require.config({
    paths: {
        'sdk': uiBuilderSDKPath + '/sdk',
    }
});

define(['sdk'], BackendlessUI => BackendlessUI.startApp());

define('./functions/03e9e4e2797693e9f375c3dfa7d7abc8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'] = async function fn_03e9e4e2797693e9f375c3dfa7d7abc8(data, activeId) {
var result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  result = (await Promise.all(data.map(async item => {  if (activeId == (getObjectProperty(item, 'objectId'))) {
      item['active'] = true;
    } else {
      item['active'] = false;
    }
  ; return item;})));

return result
}

})
define('./functions/10ec5a56ee543c1efe719ed5ba61441a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'] = async function fn_10ec5a56ee543c1efe719ed5ba61441a(data) {
var response, userLikedActivities, blockList, location2, gender, pageOffset, ageMin, ageMax, religion, drink, smoke, sexOrientation, political, maritalStatus, hairColor, ethnicity, education, bodyType, dateEnd, dateStart, category, searchInput, dateFrom, dateTo, dietaryPreference, searchInputText, delimeter, argname, item, proplist;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function get_text_from_list(argname, delimeter) {
  if ((getObjectProperty(data, argname)) && (getObjectProperty(data, argname)).length > 0) {
    return ((getObjectProperty(data, argname)).join(delimeter));
  }
}

/**
 * Describe this function...
 */
async function filter(proplist) {
  if (proplist) {
    if (!!proplist.length) {
      return ([' and',' (',(await Promise.all(proplist.map(async item => {; return (['( jsoncontains(author.userProfile.dietaryPreferenceJson, \'',item,'\' ) = ',1,') '].join(''));}))).join(' or '),')',' '].join(''));
    } else {
      return ;
    }
  }
}


  if ((getObjectProperty(data, 'searchInputText')) && getValueLength((getObjectProperty(data, 'searchInputText'))) > 0) {
    searchInputText = (getObjectProperty(data, 'searchInputText')).toLowerCase().trim();
    searchInput = [' and (name like \'%',searchInputText,'%\' or description like \'%',searchInputText,'%\' or activityTitle like \'%',searchInputText,'%\')'].join('');
  } else {
    searchInput = '';
  }
  if ((getObjectProperty(data, 'category')) && (getObjectProperty(data, 'category')) != 'All categories') {
    category = [' and (category.objectId in (\'',(getObjectProperty(data, 'category')),'\') )'].join('');
  } else {
    category = '';
  }
  if (getObjectProperty(data, 'dateStart')) {
    dateStart = (getObjectProperty(data, 'dateStart'));
  }
  if (getObjectProperty(data, 'dateEnd')) {
    dateEnd = (getObjectProperty(data, 'dateEnd'));
  }
  if (getObjectProperty(data, 'countOffset')) {
    pageOffset = (getObjectProperty(data, 'countOffset')) * (getObjectProperty(data, 'pageSize')) + 1;
  } else {
    pageOffset = 1;
  }
  gender = await get_text_from_list('currentUser.searchFilter.gender', '\',\'');
  if ((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'likedActivities')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'likedActivities')).length) {
    userLikedActivities = (JSON.stringify(((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'likedActivities')).map(item => item['objectId']))));
  } else {
    userLikedActivities = null;
  }
  if ((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'blockListJson')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'blockListJson')).length) {
    blockList = ({ [`blockListJson`]: (getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'blockListJson')) });
  } else {
    blockList = null;
  }
  if ((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'locationGeoPoint')) && (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'locationGeoPoint')), 'coordinates'))) {
    location2 = (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'locationGeoPoint')), 'coordinates')).join(' ');
  } else if ((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'locationGeoPointNew')) && !(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'locationGeoPoint')), 'coordinates'))) {
    location2 = [(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'locationGeoPointNew')), 'coordinates')).slice(-1)[0], (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'locationGeoPointNew')), 'coordinates'))[0]].join(' ');
  }
  if (getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'searchFilter')), 'ageMax')) {
    dateFrom = (new Date());
    dateTo = (new Date());
    dateFrom.setFullYear((((new Date((new Date())).getFullYear()) - (getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'searchFilter')), 'ageMax'))) - 1));
    dateTo.setFullYear(((new Date((new Date())).getFullYear()) - (getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'searchFilter')), 'ageMin'))));
    ageMin = [' and (author.birthDate <= \'',(dateTo.toISOString()),'\')'].join('');
    ageMax = [' and (author.birthDate >= \'',(dateFrom.toISOString()),'\')'].join('');
  } else {
    ageMin = '';
    ageMax = '';
  }
  response = (await Backendless.Request.get(`${Backendless.appPath}/services/activitiesSearchFilter/activitiesSearchFilterData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'searchInput': JSON.stringify(searchInput),'category': JSON.stringify(category),'pageSize': ((getObjectProperty(data, 'pageSize')) ? (getObjectProperty(data, 'pageSize')) : 100),'startDate': JSON.stringify(dateStart),'endDate': JSON.stringify(dateEnd),'radius': (getObjectProperty(data, 'radius')),'bodyType': JSON.stringify(bodyType),'education': JSON.stringify(education),'ethnicity': JSON.stringify(ethnicity),'hairColor': JSON.stringify(hairColor),'maritalStatus': JSON.stringify(maritalStatus),'political': JSON.stringify(political),'sexOrientation': JSON.stringify(sexOrientation),'smoke': JSON.stringify(smoke),'drink': JSON.stringify(drink),'religion': JSON.stringify(religion),'other': JSON.stringify(([ageMax,ageMin,(await BackendlessUI.Functions.Custom['fn_1d3e40275c733dadae5d77dbdddd49a5']((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'searchFilter')), 'heightPrefix')), (getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'searchFilter')), 'height')), ' and ', 'author.')),'',''].join(''))),'pageOffset': pageOffset,'gender': JSON.stringify(gender),'locationGeoPoint': JSON.stringify(location2),'financialRole': JSON.stringify(((getObjectProperty((getObjectProperty(data, 'currentUser')), 'searchFilter')) && (getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'searchFilter')), 'financialRole')) ? (getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'searchFilter')), 'financialRole')) : '')),'past': ((getObjectProperty(data, 'pastActivities')) ? true : false),'blockList': JSON.stringify((blockList ? (JSON.stringify(blockList)) : null)),'userLikedActivities': JSON.stringify(userLikedActivities) }).send());
  if (getObjectProperty(data, 'activityListAllNew')) {
    delete data['activityListAllNew'];
  }

return response
}

})
define('./functions/1184d4b305a59291bd9405d6fccacf26/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1184d4b305a59291bd9405d6fccacf26'] = async function fn_1184d4b305a59291bd9405d6fccacf26(data) {
var saveSubscriber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  saveSubscriber = (await Backendless.Data.of('Subscriber').save( ({ [`email`]: (getObjectProperty(data, 'email')) }) ));

return saveSubscriber
}

})
define('./functions/1198d43615bd6424f797f407cd2f1d3c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1198d43615bd6424f797f407cd2f1d3c'] = async function fn_1198d43615bd6424f797f407cd2f1d3c(stepCount, dynamicList) {
var widgetSecondRender, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  widgetSecondRender = (await Promise.all(dynamicList.map(async item => {  if ((getObjectProperty(item, 'height')) < 0) {
      item['height'] = (stepCount * (dynamicList.length - 1));
      item['opacity'] = 1;
    }
  ; return item;})));

return widgetSecondRender
}

})
define('./functions/13bb85a46897d202007c1928be45709e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_13bb85a46897d202007c1928be45709e'] = async function fn_13bb85a46897d202007c1928be45709e(date) {
    if (date) {
    return ([' and (dayofmonth(activityDate) <= ',(new Date((new Date(date))).getDate()),'',' and year(activityDate) <= ',(new Date((new Date(date))).getFullYear()),'',' and month(activityDate) <= ',(new Date((new Date(date))).getMonth()) + 1,')'].join(''));
  } else {
    return '';
  }


  return
}

})
define('./functions/15839a3dd6a9e8ce681ec977fe735279/code.js', () => { 

BackendlessUI.Functions.Custom['fn_15839a3dd6a9e8ce681ec977fe735279'] = async function fn_15839a3dd6a9e8ce681ec977fe735279(date) {
    if (date) {
    return ([' and dayofmonth(activityDate) =',(new Date((new Date(date))).getDate()),'',' and  year(activityDate) =',(new Date((new Date(date))).getFullYear()),'',' and  month(activityDate) =',(new Date((new Date(date))).getMonth()) + 1,''].join(''));
  }


  return
}

})
define('./functions/16025c2354d5da4b13ff8315c307d95f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_16025c2354d5da4b13ff8315c307d95f'] = function fn_16025c2354d5da4b13ff8315c307d95f(stylesUserLogin, stylesUserAge, isOpenFullList, userLogin) {
var fontSizeAge, fontSizeName;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (isOpenFullList) {
    stylesUserLogin['fontSize'] = '20px';
    stylesUserAge['fontSize'] = '20px';
  } else {
    if (getValueLength(userLogin) >= 7) {
      fontSizeName = Math.round(20 - 0.3 * getValueLength(userLogin));
      fontSizeAge = Math.round(20 - 0.3 * getValueLength(userLogin));
      stylesUserLogin['fontSize'] = (String(fontSizeName) + String('px'));
      stylesUserAge['fontSize'] = (String(fontSizeAge) + String('px'));
    }
  }

}

})
define('./functions/1d3e40275c733dadae5d77dbdddd49a5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_1d3e40275c733dadae5d77dbdddd49a5'] = function fn_1d3e40275c733dadae5d77dbdddd49a5(heightPrefix, object, and, isRelation) {
  if (object) {
    if (heightPrefix == 'maxHeight') {
      return ([and,'(',String(isRelation) + String('userProfile.height <= '),object,')'].join(''));
    } else if (heightPrefix == 'minHeight') {
      return ([and,'(',String(isRelation) + String('userProfile.height >= '),object,')'].join(''));
    }
  }

return 
}

})
define('./functions/2171da3dd0357b5cf3e53a779f8ad201/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2171da3dd0357b5cf3e53a779f8ad201'] = async function fn_2171da3dd0357b5cf3e53a779f8ad201() {
var savedMessages, newMessages, error, chaIdList, j, byOthersNewChat, isByOtherChatExist, byOthersSavedChat, item, byMeNewChat, byMeSavedChat, byMeSavedActivity, byMeActivities, invSentNewChat, invSentSavedChat, invReceivedNewChat, statusChangedChatId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getSavedChatIdList() {
  chaIdList = [];
  if (getObjectProperty(savedMessages, 'chats')) {
    var j_list2 = (getObjectProperty((getObjectProperty(savedMessages, 'chats')), 'byMe'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      var j_list = (getObjectProperty(j, 'chats'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        chaIdList.push((getObjectProperty(j, 'objectId')));
      }
    }
    var j_list3 = (getObjectProperty((getObjectProperty(savedMessages, 'chats')), 'byOthers'));
    for (var j_index3 in j_list3) {
      j = j_list3[j_index3];
      chaIdList.push((getObjectProperty((getObjectProperty(j, 'chat')), 'objectId')));
    }
  }
  if (getObjectProperty(savedMessages, 'invitations')) {
    var j_list4 = (getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'received'));
    for (var j_index4 in j_list4) {
      j = j_list4[j_index4];
      chaIdList.push((getObjectProperty(j, 'objectId')));
    }
    var j_list5 = (getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'sent'));
    for (var j_index5 in j_list5) {
      j = j_list5[j_index5];
      chaIdList.push((getObjectProperty(j, 'objectId')));
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function updateByOthersChats() {
  if ((getObjectProperty(newMessages, 'chatIdDeleteList')) && !!(getObjectProperty(newMessages, 'chatIdDeleteList')).length) {
    (getObjectProperty(savedMessages, 'chats'))['byOthers'] = (await asyncListFilter((getObjectProperty((getObjectProperty(savedMessages, 'chats')), 'byOthers')), async (item) => {


     return (!((getObjectProperty(newMessages, 'chatIdDeleteList')).includes((getObjectProperty((getObjectProperty(item, 'chat')), 'objectId')))));
    }));
  }
  if (!!(getObjectProperty((getObjectProperty((getObjectProperty(newMessages, 'messages')), 'chats')), 'byOthers')).length) {
    var byOthersNewChat_list = (getObjectProperty((getObjectProperty((getObjectProperty(newMessages, 'messages')), 'chats')), 'byOthers'));
    for (var byOthersNewChat_index in byOthersNewChat_list) {
      byOthersNewChat = byOthersNewChat_list[byOthersNewChat_index];
      isByOtherChatExist = false;
      var byOthersSavedChat_list = (getObjectProperty((getObjectProperty(savedMessages, 'chats')), 'byOthers'));
      for (var byOthersSavedChat_index in byOthersSavedChat_list) {
        byOthersSavedChat = byOthersSavedChat_list[byOthersSavedChat_index];
        if ((getObjectProperty((getObjectProperty(byOthersNewChat, 'chat')), 'objectId')) == (getObjectProperty((getObjectProperty(byOthersSavedChat, 'chat')), 'objectId'))) {
          isByOtherChatExist = true;
          if ((getObjectProperty((getObjectProperty((getObjectProperty(byOthersNewChat, 'chat')), 'recentMessage')), 'created')) > (getObjectProperty((getObjectProperty((getObjectProperty(byOthersSavedChat, 'chat')), 'recentMessage')), 'created'))) {
            (getObjectProperty(byOthersSavedChat, 'chat'))['message'] = ((getObjectProperty((getObjectProperty(byOthersNewChat, 'chat')), 'message')).concat((getObjectProperty((getObjectProperty(byOthersSavedChat, 'chat')), 'message'))));
            (getObjectProperty(byOthersSavedChat, 'chat'))['chatIsRead'] = (getObjectProperty((getObjectProperty(byOthersNewChat, 'chat')), 'chatIsRead'));
            (getObjectProperty(byOthersSavedChat, 'chat'))['recentMessage'] = (getObjectProperty((getObjectProperty(byOthersNewChat, 'chat')), 'recentMessage'));
          }
        }
      }
      if (!isByOtherChatExist) {
        if (getObjectProperty((getObjectProperty(byOthersNewChat, 'chat')), 'statusUpdated')) {
          (getObjectProperty((getObjectProperty(savedMessages, 'chats')), 'byOthers')).unshift(byOthersNewChat);
          await deleteStatusChangedChat((getObjectProperty((getObjectProperty(byOthersNewChat, 'chat')), 'objectId')));
        }
      }
    }
  }
}

/**
 * Describe this function...
 */
async function updateByMeChats() {
  if ((getObjectProperty(newMessages, 'chatIdDeleteList')) && !!(getObjectProperty(newMessages, 'chatIdDeleteList')).length) {
    (getObjectProperty(savedMessages, 'chats'))['byMe'] = (await asyncListFilter((getObjectProperty((getObjectProperty(savedMessages, 'chats')), 'byMe')), async (byMeActivities) => {
       byMeActivities['chats'] = (await asyncListFilter((getObjectProperty(byMeActivities, 'chats')), async (item) => {


       return (!((getObjectProperty(newMessages, 'chatIdDeleteList')).includes((getObjectProperty(item, 'objectId')))));
      }));


     return (!!(getObjectProperty(byMeActivities, 'chats')).length);
    }));
  }
  if (!!(getObjectProperty((getObjectProperty((getObjectProperty(newMessages, 'messages')), 'chats')), 'byMe')).length) {
    var j_list6 = (getObjectProperty((getObjectProperty((getObjectProperty(newMessages, 'messages')), 'chats')), 'byMe'));
    for (var j_index6 in j_list6) {
      j = j_list6[j_index6];
      if (!(((getObjectProperty((getObjectProperty(savedMessages, 'chats')), 'byMe')).map(item => item['objectId'])).includes((getObjectProperty(j, 'objectId'))))) {
        (getObjectProperty((getObjectProperty(savedMessages, 'chats')), 'byMe')).unshift(j);
        var byMeNewChat_list = (getObjectProperty(j, 'chats'));
        for (var byMeNewChat_index in byMeNewChat_list) {
          byMeNewChat = byMeNewChat_list[byMeNewChat_index];
          if (getObjectProperty(byMeNewChat, 'statusUpdated')) {
            await deleteStatusChangedChat((getObjectProperty(byMeNewChat, 'objectId')));
          }
        }
      } else {
        var byMeSavedActivity_list = (getObjectProperty((getObjectProperty(savedMessages, 'chats')), 'byMe'));
        for (var byMeSavedActivity_index in byMeSavedActivity_list) {
          byMeSavedActivity = byMeSavedActivity_list[byMeSavedActivity_index];
          if ((getObjectProperty(j, 'objectId')) == (getObjectProperty(byMeSavedActivity, 'objectId'))) {
            var byMeNewChat_list2 = (getObjectProperty(j, 'chats'));
            for (var byMeNewChat_index2 in byMeNewChat_list2) {
              byMeNewChat = byMeNewChat_list2[byMeNewChat_index2];
              if (!(((getObjectProperty(byMeSavedActivity, 'chats')).map(item => item['objectId'])).includes((getObjectProperty(byMeNewChat, 'objectId'))))) {
                (getObjectProperty(byMeSavedActivity, 'chats')).unshift(byMeNewChat);
                if (getObjectProperty(byMeNewChat, 'statusUpdated')) {
                  await deleteStatusChangedChat((getObjectProperty(byMeNewChat, 'objectId')));
                }
              } else {
                var byMeSavedChat_list = (getObjectProperty(byMeSavedActivity, 'chats'));
                for (var byMeSavedChat_index in byMeSavedChat_list) {
                  byMeSavedChat = byMeSavedChat_list[byMeSavedChat_index];
                  if ((getObjectProperty(byMeSavedChat, 'objectId')) == (getObjectProperty(byMeNewChat, 'objectId'))) {
                    if ((getObjectProperty((getObjectProperty(byMeNewChat, 'recentMessage')), 'created')) > (getObjectProperty((getObjectProperty(byMeSavedChat, 'recentMessage')), 'created'))) {
                      byMeSavedChat['message'] = ((getObjectProperty(byMeNewChat, 'message')).concat((getObjectProperty(byMeSavedChat, 'message'))));
                      byMeSavedChat['chatIsRead'] = (getObjectProperty(byMeNewChat, 'chatIsRead'));
                      byMeSavedChat['recentMessage'] = (getObjectProperty(byMeNewChat, 'recentMessage'));
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function updateInvitationsChats() {
  if ((getObjectProperty(newMessages, 'chatIdDeleteList')) && !!(getObjectProperty(newMessages, 'chatIdDeleteList')).length) {
    (getObjectProperty(savedMessages, 'invitations'))['received'] = (await asyncListFilter((getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'received')), async (item) => {


     return (!((getObjectProperty(newMessages, 'chatIdDeleteList')).includes((getObjectProperty(item, 'objectId')))));
    }));
    (getObjectProperty(savedMessages, 'invitations'))['sent'] = (await asyncListFilter((getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'sent')), async (item) => {


     return (!((getObjectProperty(newMessages, 'chatIdDeleteList')).includes((getObjectProperty(item, 'objectId')))));
    }));
  }
  var invReceivedNewChat_list = (getObjectProperty((getObjectProperty((getObjectProperty(newMessages, 'messages')), 'invitations')), 'received'));
  for (var invReceivedNewChat_index in invReceivedNewChat_list) {
    invReceivedNewChat = invReceivedNewChat_list[invReceivedNewChat_index];
    if (!(((getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'received')).map(item => item['objectId'])).includes((getObjectProperty(invReceivedNewChat, 'objectId'))))) {
      (getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'received')).unshift(invReceivedNewChat);
    }
  }
  var invSentNewChat_list = (getObjectProperty((getObjectProperty((getObjectProperty(newMessages, 'messages')), 'invitations')), 'sent'));
  for (var invSentNewChat_index in invSentNewChat_list) {
    invSentNewChat = invSentNewChat_list[invSentNewChat_index];
    if (!(((getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'sent')).map(item => item['objectId'])).includes((getObjectProperty(invSentNewChat, 'objectId'))))) {
      (getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'sent')).unshift(invSentNewChat);
    } else {
      var invSentSavedChat_list = (getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'sent'));
      for (var invSentSavedChat_index in invSentSavedChat_list) {
        invSentSavedChat = invSentSavedChat_list[invSentSavedChat_index];
        if ((getObjectProperty(invSentNewChat, 'objectId')) == (getObjectProperty(invSentSavedChat, 'objectId'))) {
          invSentSavedChat['status'] = (getObjectProperty(invSentNewChat, 'status'));
          invSentSavedChat['type'] = (getObjectProperty(invSentNewChat, 'type'));
        }
      }
    }
  }
  (getObjectProperty(savedMessages, 'invitations'))['sent'] = (await asyncListSort((getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'sent')), -1, async (item) => {


   return (getObjectProperty(item, 'created'));
  }));
  (getObjectProperty(savedMessages, 'invitations'))['received'] = (await asyncListSort((getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'received')), -1, async (item) => {


   return (getObjectProperty(item, 'created'));
  }));
}

/**
 * Describe this function...
 */
async function deleteStatusChangedChat(statusChangedChatId) {
  if (!!(getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'received')).length) {
    (getObjectProperty(savedMessages, 'invitations'))['received'] = (await asyncListFilter((getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'received')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != statusChangedChatId);
    }));
  }
  if (!!(getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'sent')).length) {
    (getObjectProperty(savedMessages, 'invitations'))['sent'] = (await asyncListFilter((getObjectProperty((getObjectProperty(savedMessages, 'invitations')), 'sent')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != statusChangedChatId);
    }));
  }
}


  savedMessages = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'messages'));
  await getSavedChatIdList();
  try {
    newMessages = (await Backendless.Request.get(`${Backendless.appPath}/services/messages/getNewMessagesData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'chatIdList': JSON.stringify((JSON.stringify(chaIdList))),'updateTime': (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'lastUpdate')) }).send());

  } catch (error) {
    try {
      console.log('Retrying to download messages');
      newMessages = (await Backendless.Request.get(`${Backendless.appPath}/services/messages/getNewMessagesData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'chatIdList': JSON.stringify((JSON.stringify(chaIdList))),'updateTime': (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'lastUpdate')) }).send());

    } catch (error) {
      (function (message) { alert(message) })((getObjectProperty(error, 'message')));
      console.log(error);

    }
    console.log(error);

  }
  if (newMessages) {
    await updateByMeChats();
    await updateByOthersChats();
    await updateInvitationsChats();
  } else {
    savedMessages = (await Backendless.Request.get(`${Backendless.appPath}/services/messages/getMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  }
  localStorage.setItem('messages', JSON.stringify(({ [`messages`]: savedMessages,[`lastUpdate`]: ((new Date()).valueOf()) })));

return savedMessages
}

})
define('./functions/24392cc9c418884d6e77cf1f6c7ebbce/code.js', () => { 

BackendlessUI.Functions.Custom['fn_24392cc9c418884d6e77cf1f6c7ebbce'] = function fn_24392cc9c418884d6e77cf1f6c7ebbce(imgUrl) {
var domain, resultUrl, text;


  domain = 'https://app.findmyplus.one/';
  if ((imgUrl.indexOf('https') !== -1) || (imgUrl.indexOf('http') !== -1)) {
    return ([domain,'api/files',imgUrl.slice(((imgUrl.indexOf('/pictures/') + 1) - 1), imgUrl.length)].join(''));
  } else {
    return ([domain,'api/files',imgUrl].join(''));
  }

return 
}

})
define('./functions/24498a1473c83209b6d1428325c66861/code.js', () => { 

BackendlessUI.Functions.Custom['fn_24498a1473c83209b6d1428325c66861'] = async function fn_24498a1473c83209b6d1428325c66861(locationGeoPoint, profileId) {
var error, country, locationInfo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    locationInfo = (await Backendless.Request.get(`${Backendless.appPath}/services/ReverseGeoCodding/getReverceGeoCodding`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'lat': ((getObjectProperty(locationGeoPoint, 'coordinates')).slice(-1)[0]),'lng': ((getObjectProperty(locationGeoPoint, 'coordinates'))[0]) }).send());
    country = (getObjectProperty(((getObjectProperty(locationInfo, 'results')).slice(-1)[0]), 'formatted_address')).split(',').slice(-1)[0].trim();
    localStorage.setItem('country', JSON.stringify(country));
    await Backendless.Data.of('UserProfile').bulkUpdate( (['objectId=\'',profileId,'\''].join('')), ({ [`country`]: country }) );

  } catch (error) {
    console.log(error);

  }

}

})
define('./functions/249e4e954aab12b477526507a3c7c0f3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_249e4e954aab12b477526507a3c7c0f3'] = async function fn_249e4e954aab12b477526507a3c7c0f3(appdata, user) {
var curChat, object, newChat, newChatObject, newActivity, receiverPhoto, item, updatedChatItem, activityId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function deleteActivityListener() {
  getRTSubscriptions().remove('deleteActivityListener');

  ;(function(whereClause) {
    const callback = async object => {
        activityId = (getObjectProperty(object, 'objectId'));
    appdata['chats'] = (await asyncListFilter((getObjectProperty(appdata, 'chats')), async (item) => {


     return ((getObjectProperty(item, 'activityId')) != activityId);
    }));
    if ((getObjectProperty(appdata, 'activityMessages')) && (((getObjectProperty(appdata, 'activityMessages')).map(item => item['objectId'])).includes(activityId))) {
      removeItemInList((getObjectProperty(appdata, 'activityMessages')), ({ [`objectId`]: activityId }), 'objectId');
    }

    };

    const rtHandlers = Backendless.Data.of('Activity').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('deleteActivityListener', () => rtHandlers.removeDeleteListener(callback));

  })((['objectId IN (\'',((getObjectProperty(appdata, 'chats')).map(item => item['activityId'])).join('\',\''),'\')'].join('')));
    }


  await BackendlessUI.Functions.Custom['fn_5082808d30ee2f24c04143d4d6e4151d']();

  ;(function(whereClause) {
    const callback = async object => {
        curChat = (await (async function(list, condition) {
    	return list.find(item => condition.includes(item.objectId))
    })((getObjectProperty(appdata, 'chats')), (getObjectProperty(object, 'whereClause'))));
    if (curChat) {
      updatedChatItem = (await Backendless.Request.get(`${Backendless.appPath}/services/updatedChat/getUpdatedChat`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'whereClause': JSON.stringify((['objectId=\'',(getObjectProperty(curChat, 'objectId')),'\''].join(''))),'relations': JSON.stringify((['receiver', 'sender', 'recentMessage', 'recentMessage.sender', 'recentMessage.receiver'].join(','))),'properties': JSON.stringify((['receiver.userProfile.media as receiverPhoto', 'sender.userProfile.media as senderPhoto', 'activityId', 'deletedByReceiver', 'deletedBySender', 'objectId', 'status', 'type', 'isBlocked', 'receiver.userProfile.objectId as receiverUserProfile', 'sender.userProfile.objectId as senderUserProfile', 'recentMessage.isRead as chatIsRead'].join(','))),'pageSize': 1 }).send())[0];
      await BackendlessUI.Functions.Custom['fn_57135e2cd68ac40b08da3b12a576bccb'](updatedChatItem);
      Object.assign(curChat, updatedChatItem);
      if ((getObjectProperty(updatedChatItem, 'type')) == 'acceptedInvitation' && (getObjectProperty(updatedChatItem, 'status')) == 'accepted' || (getObjectProperty(updatedChatItem, 'type')) == 'acceptedRequest' && (getObjectProperty(updatedChatItem, 'status')) == 'accepted') {
        if (!(((getObjectProperty(appdata, 'activityMessages')).map(item => item['objectId'])).includes((getObjectProperty(updatedChatItem, 'activityId'))))) {
          newActivity = (await Backendless.Request.get(`${Backendless.appPath}/services/activityMessages/ActivityMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'whereClause': JSON.stringify((['objectId=\'',(getObjectProperty(updatedChatItem, 'activityId')),'\''].join(''))) }).send())[0];
          if (getObjectProperty(newActivity, 'authorMedia')) {
            receiverPhoto = (await asyncListFilter((getObjectProperty(newActivity, 'authorMedia')), async (item) => {


             return (getObjectProperty(item, 'isCover'));
            }))[0];
            newActivity['authorPhoto'] = (getObjectProperty(receiverPhoto, 'file'));
          }
          (getObjectProperty(appdata, 'activityMessages')).unshift(newActivity);
        }
      }
    }

    };

    const rtHandlers = Backendless.Data.of('Chat').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addBulkUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('listenChatUpdate', () => rtHandlers.removeBulkUpdateListener(callback));

  })('');

  ;(function(parentObjects) {
    const callback = async newChatObject => {
        newChat = (await Backendless.Request.get(`${Backendless.appPath}/services/updatedChat/getUpdatedChat`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'whereClause': JSON.stringify((['objectId=\'',(getObjectProperty(newChatObject, 'children'))[0],'\''].join(''))),'relations': JSON.stringify((['receiver', 'sender', 'recentMessage', 'recentMessage.sender', 'recentMessage.receiver'].join(','))),'properties': JSON.stringify((['receiver.userProfile.media as receiverPhoto', 'sender.userProfile.media as senderPhoto', 'activityId', 'deletedByReceiver', 'deletedBySender', 'objectId', 'status', 'type', 'isBlocked', 'receiver.userProfile.objectId as receiverUserProfile', 'sender.userProfile.objectId as senderUserProfile', 'deletedByReceiver', 'deletedBySender', 'recentMessage.isRead as chatIsRead'].join(','))),'pageSize': 1 }).send())[0];
    await BackendlessUI.Functions.Custom['fn_57135e2cd68ac40b08da3b12a576bccb'](newChat);
    addItemToList((getObjectProperty(appdata, 'chats')), newChat);
    await deleteActivityListener();

    };

    const rtHandlers = Backendless.Data.of('Users').rt();

    const options = ['chat'];

    if (parentObjects) {
       options.push(parentObjects);
    }

    options.push(callback)

    rtHandlers.addAddRelationListener.apply(rtHandlers, options);

    getRTSubscriptions().add('listenChatCreate', () => rtHandlers.removeAddRelationListener(callback));

  })([user]);

  ;(function(parentObjects) {
    const callback = async object => {
        curChat = (await (async function(list, condition) {
    	return list.find(item => item.objectId === condition)
    })((getObjectProperty(appdata, 'chats')), (getObjectProperty(object, 'parentObjectId'))));
    curChat['chatIsRead'] = false;
    curChat['recentMessage'] = ((await Backendless.Request.get(`${Backendless.appPath}/services/getMessages/getMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'whereClause': JSON.stringify((['objectId = \'',(getObjectProperty(object, 'children'))[0],'\''].join(''))),'pageSize': 1 }).send())[0]);

    };

    const rtHandlers = Backendless.Data.of('Chat').rt();

    const options = ['recentMessage'];

    if (parentObjects) {
       options.push(parentObjects);
    }

    options.push(callback)

    rtHandlers.addSetRelationListener.apply(rtHandlers, options);

    getRTSubscriptions().add('listenRecentMessage', () => rtHandlers.removeSetRelationListener(callback));

  })((getObjectProperty(appdata, 'chats')));

  ;(function(whereClause) {
    const callback = async object => {
        curChat = (await (async function(list, condition) {
    	return list.find(item => condition.includes(item.objectId))
    })((getObjectProperty(appdata, 'chats')), (getObjectProperty(object, 'whereClause'))));
    if (curChat) {
      removeItemInList((getObjectProperty(appdata, 'chats')), curChat, 'objectId');
    }

    };

    const rtHandlers = Backendless.Data.of('Chat').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addBulkDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('dlistenChatDelete', () => rtHandlers.removeBulkDeleteListener(callback));

  })('');
    await deleteActivityListener();

}

})
define('./functions/25e577c7a55ec13aac55c1b782dc57ca/code.js', () => { 

BackendlessUI.Functions.Custom['fn_25e577c7a55ec13aac55c1b782dc57ca'] = async function fn_25e577c7a55ec13aac55c1b782dc57ca(appData) {
  appData['messagesNumber'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getCount/getCount`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());

}

})
define('./functions/2b16a5796a23a5f31854b91671393ba8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2b16a5796a23a5f31854b91671393ba8'] = async function fn_2b16a5796a23a5f31854b91671393ba8(pageData, appData) {
var currentUser, message, item, curChat;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  getRTSubscriptions().remove('newMessages');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('default');
  await new Promise(r => setTimeout(r, 500 || 0));
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    getRTSubscriptions().remove('newMessages');
    await new Promise(r => setTimeout(r, 100 || 0));
    if (!(getObjectProperty(appData, 'currentUser')) && !((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'))) {
      await BackendlessUI.Functions.Custom['fn_b60329368f595ebe51d195537c8a4735'](pageData, appData);
    }
    currentUser = (getObjectProperty(appData, 'currentUser')) ? (getObjectProperty(appData, 'currentUser')) : (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) ? ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) : (await Backendless.UserService.getCurrentUser(false)));
    appData['currentUser'] = currentUser;
    pageData['currentUser'] = currentUser;

    ;(function(selector) {
      const callback = async message => {
          if (!(getObjectProperty(appData, (getObjectProperty(message, 'messageId'))))) {
        appData[(getObjectProperty(message, 'messageId'))] = true;
        if ((getObjectProperty((getObjectProperty((getObjectProperty(message, 'message')), 'receiver')), 'objectId')) == (getObjectProperty(currentUser, 'objectId'))) {
          await BackendlessUI.Functions.Custom['fn_45329afd4d1efc64364b4b6d45c9e02a'](pageData, appData);
          if (getObjectProperty(appData, 'chats')) {
            curChat = (await (async function(list, id) {
            	return list.find(item => item.objectId === id)
            })((getObjectProperty(appData, 'chats')), (getObjectProperty((getObjectProperty(message, 'message')), 'chatId'))));
            if (curChat) {
              curChat['recentMessage'] = (getObjectProperty(message, 'message'));
              curChat['chatIsRead'] = false;
            }
          }
          if (appData && (getObjectProperty(appData, 'openMessage'))) {
            (getObjectProperty(appData, 'openMessage'))['message'] = (await asyncListSort((await Backendless.Request.get(`${Backendless.appPath}/services/getMessages/getMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'whereClause': JSON.stringify((['chatId=\'',(getObjectProperty((getObjectProperty(appData, 'openMessage')), 'objectId')),'\''].join(''))) }).send()), 1, async (item) => {


             return (getObjectProperty(item, 'created'));
            }));
            pageData['openMessage'] = (getObjectProperty(appData, 'openMessage'));
          }
        }
        delete appData['chatId'];
        delete pageData['chatId'];
      }

      };

      const channel = getChannelInstance('default');

      const options = [callback];

      if (selector) {
         options.unshift(selector);
      }

      channel.addMessageListener.apply(channel, options);

      getRTSubscriptions().add('newMessages', () => channel.removeMessageListener.apply(channel, options));
    })((['receiverId IN (\'',(getObjectProperty(currentUser, 'objectId')),'\')'].join('')));
  }

}

})
define('./functions/2e61f0a2adf4439f5332020550ba8c13/code.js', () => { 

BackendlessUI.Functions.Custom['fn_2e61f0a2adf4439f5332020550ba8c13'] = function fn_2e61f0a2adf4439f5332020550ba8c13(chats, data, scrollTo, modalClasslist) {
var error, object, message, currentUser, user, item, messageText, ids, currentActivity, activityId, j, invitedChats, invitedActivitiesNew, invitedActivity, myActivity, myChats, mapChats, receiverPhoto, receivedChats, activityItem, activity, updatedChat;

}

})
define('./functions/30743f6255d6db0f649790555183a8e3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_30743f6255d6db0f649790555183a8e3'] = async function fn_30743f6255d6db0f649790555183a8e3(data) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(data, 'openMessage')) {
    await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](data);
    if (getObjectProperty((getObjectProperty(data, 'openMessage')), 'recentMessage')) {
      (getObjectProperty((getObjectProperty(data, 'openMessage')), 'recentMessage'))['isRead'] = true;
    }
    if (((getObjectProperty((getObjectProperty(data, 'openMessage')), 'status')) == 'accepted' || (getObjectProperty((getObjectProperty(data, 'openMessage')), 'status')) == 'rejected') && (getObjectProperty((getObjectProperty(data, 'openMessage')), 'type')) == 'requestPermission' || (getObjectProperty((getObjectProperty(data, 'openMessage')), 'type')) == 'invitation' && (getObjectProperty((getObjectProperty(data, 'openMessage')), 'status')) == 'rejected') {
      await Backendless.Data.of('Message').bulkDelete( (['chatId=\'',(getObjectProperty((getObjectProperty(data, 'openMessage')), 'objectId')),'\''].join('')) );
      await Backendless.Data.of('Chat').bulkDelete( (['objectId=\'',(getObjectProperty((getObjectProperty(data, 'openMessage')), 'objectId')),'\''].join('')) );
    }
    data['currentActivity'] = null;
    data['openMessage'] = null;
  }

}

})
define('./functions/31fe36fc4e51195c809fd315fd766523/code.js', () => { 

BackendlessUI.Functions.Custom['fn_31fe36fc4e51195c809fd315fd766523'] = async function fn_31fe36fc4e51195c809fd315fd766523(height, dynamicList) {
var renderWidget, item, startTop, stepCount;


  startTop = 0 - height;
  stepCount = height;
  renderWidget = (await Promise.all(dynamicList.map(async item => {  startTop = startTop + stepCount;
    item['height'] = startTop;
    item['width'] = height;
  ; return item;})));

return renderWidget
}

})
define('./functions/33d4b09fd437e3c36dee5ef9d12d4fa1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_33d4b09fd437e3c36dee5ef9d12d4fa1'] = function fn_33d4b09fd437e3c36dee5ef9d12d4fa1(data) {
var regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  regExp = (new RegExp('[a-z0-9!#$%&\'*+/=?^_`{|}~-]+(?:\\.[a-z0-9!#$%&\'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?', ''));
  if ((regExp.test((getObjectProperty(data, 'email')))) == false) {
    return ({ [`status`]: false });
  }

return ({ [`status`]: true })
}

})
define('./functions/341a41468d22574396fc05e34d8ab549/code.js', () => { 

BackendlessUI.Functions.Custom['fn_341a41468d22574396fc05e34d8ab549'] = async function fn_341a41468d22574396fc05e34d8ab549(blockedUserId, messagesModel) {
var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  var j_list = (getObjectProperty((getObjectProperty(messagesModel, 'chats')), 'byMe'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['chats'] = (await asyncListFilter((getObjectProperty(j, 'chats')), async (item) => {


     return ((getObjectProperty((getObjectProperty(item, 'sender')), 'objectId')) != blockedUserId && (getObjectProperty((getObjectProperty(item, 'receiver')), 'objectId')) != blockedUserId);
    }));
  }
  (getObjectProperty(messagesModel, 'chats'))['byMe'] = (await asyncListFilter((getObjectProperty((getObjectProperty(messagesModel, 'chats')), 'byMe')), async (item) => {


   return (!!(getObjectProperty(item, 'chats')).length);
  }));
  (getObjectProperty(messagesModel, 'chats'))['byOthers'] = (await asyncListFilter((getObjectProperty((getObjectProperty(messagesModel, 'chats')), 'byOthers')), async (item) => {


   return ((getObjectProperty((getObjectProperty((getObjectProperty(item, 'chat')), 'sender')), 'objectId')) != blockedUserId && (getObjectProperty((getObjectProperty((getObjectProperty(item, 'chat')), 'receiver')), 'objectId')) != blockedUserId);
  }));
  (getObjectProperty(messagesModel, 'invitations'))['received'] = (await asyncListFilter((getObjectProperty((getObjectProperty(messagesModel, 'invitations')), 'received')), async (item) => {


   return ((getObjectProperty((getObjectProperty(item, 'sender')), 'objectId')) != blockedUserId && (getObjectProperty((getObjectProperty(item, 'receiver')), 'objectId')) != blockedUserId);
  }));
  (getObjectProperty(messagesModel, 'invitations'))['sent'] = (await asyncListFilter((getObjectProperty((getObjectProperty(messagesModel, 'invitations')), 'sent')), async (item) => {


   return ((getObjectProperty((getObjectProperty(item, 'sender')), 'objectId')) != blockedUserId && (getObjectProperty((getObjectProperty(item, 'receiver')), 'objectId')) != blockedUserId);
  }));

}

})
define('./functions/36de753f55e8be4c07da77eb5cf7e8b5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_36de753f55e8be4c07da77eb5cf7e8b5'] = async function fn_36de753f55e8be4c07da77eb5cf7e8b5(userId, appData) {
var error, version, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
      version = (getObjectProperty((await ( async function () { return BackendlessUI.DeviceAPI.getAppInfo() })()), 'version'));
    } else {
      version = 'web';
    }
    if (version) {
      if (getObjectProperty(appData, 'currentUser')) {
        (getObjectProperty(appData, 'currentUser'))['version'] = version;
      }
      currentUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
      if (currentUser) {
        currentUser['version'] = version;
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
      }
      await Backendless.UserService.update( new Backendless.User(({ [`objectId`]: userId,[`version`]: version })) );
    }

  } catch (error) {
    console.log('updateAppVersion function');
    console.log(error);

  }

}

})
define('./functions/3b374911e58e10b950860fc357bf0904/code.js', () => { 

BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904'] = async function fn_3b374911e58e10b950860fc357bf0904(type, targetUserId, senderUserId, chatId, activityId) {
var data;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  if (type == 'blockUser' || type == 'unBlockUser') {
    data = ({ [`targetUserId`]: targetUserId,[`senderUserId`]: senderUserId });
  }
  if (type == 'receivedInvitation') {
    data = ({ [`targetUserId`]: targetUserId,[`senderUserId`]: senderUserId,[`chatId`]: chatId });
  }
  if (type == 'rejectReceivedRequst' || type == 'acceptedInvitation' || type == 'acceptedActivityRequest' || type == 'acceptedRequestPermission' || type == 'withdrawRequest') {
    data = ({ [`targetUserId`]: targetUserId,[`chatId`]: chatId });
  }
  if (type == 'unBlockActivityLocation') {
    data = ({ [`targetUserId`]: targetUserId });
  }
  if (type == 'removeActivityChats') {
    data = ({ [`targetUserId`]: targetUserId,[`activityId`]: activityId });
  }
  await (getChannelInstance('RT_messages')).send(type, data);

}

})
define('./functions/45260bb9a9b455464117624d9bba19e6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_45260bb9a9b455464117624d9bba19e6'] = function fn_45260bb9a9b455464117624d9bba19e6(data, month) {
var allDays, dayOfWeek, dayIndex, dayData, month, i, lastDay, nextDays, prevLastDay, date, idx, firstDayIndex, lastDayIndex;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  allDays = [];
  dayIndex = 0;
  lastDay = (new Date());
  if (month == 'next') {
    if ((getObjectProperty(data, 'month')) == 12) {
      month = 1;
      data['year'] = ((getObjectProperty(data, 'year')) + 1);
    } else {
      month = (getObjectProperty(data, 'month')) + 1;
    }
  } else if (month == 'prev') {
    if ((getObjectProperty(data, 'month')) == 1) {
      month = 12;
      data['year'] = ((getObjectProperty(data, 'year')) - 1);
    } else {
      month = (getObjectProperty(data, 'month')) - 1;
    }
  } else {
    month = (getObjectProperty(data, 'month'));
  }
  lastDay.setDate('1');
  lastDay.setFullYear((getObjectProperty(data, 'year')));
  lastDay.setMonth(month);
  lastDay.setDate('0');
  prevLastDay = (new Date());
  prevLastDay.setFullYear((getObjectProperty(data, 'year')));
  prevLastDay.setDate('1');
  prevLastDay.setMonth((month - 1));
  prevLastDay.setDate('0');
  firstDayIndex = (new Date());
  firstDayIndex.setFullYear((getObjectProperty(data, 'year')));
  firstDayIndex.setDate('1');
  firstDayIndex.setMonth((month - 1));
  lastDayIndex = (new Date(lastDay).getDay());
  nextDays = 6 - lastDayIndex;
  idx = (new Date(firstDayIndex).getDay());
  if (!(getObjectProperty((getObjectProperty(data, 'calendarData')), (getObjectProperty(data, 'year'))))) {
    (getObjectProperty(data, 'calendarData'))[(getObjectProperty(data, 'year'))] = ({  });
  }
  if (getObjectProperty((getObjectProperty((getObjectProperty(data, 'calendarData')), (getObjectProperty(data, 'year')))), ((getObjectProperty(data, 'months'))[(month - 1)]))) {
  } else {
    (getObjectProperty((getObjectProperty(data, 'calendarData')), (getObjectProperty(data, 'year'))))[((getObjectProperty(data, 'months'))[(month - 1)])] = [];
    if (idx > 0) {
      var i_inc = 1;
      if (idx > 1) {
        i_inc = -i_inc;
      }
      for (i = idx; i_inc >= 0 ? i <= 1 : i >= 1; i += i_inc) {
        dayOfWeek = (new Date());
        date = ((new Date(prevLastDay).getDate()) - i) + 1;
        dayOfWeek.setDate(date);
        dayOfWeek.setMonth((new Date(prevLastDay).getMonth()));
        if (month == 1) {
          dayOfWeek.setFullYear(((new Date(lastDay).getFullYear()) - 1));
        } else {
          dayOfWeek.setFullYear((new Date(lastDay).getFullYear()));
        }
        dayData = ({ [`index`]: dayIndex,[`day`]: ((new Date(prevLastDay).getDate()) - i) + 1,[`dayOfWeek`]: (new Date(dayOfWeek).getDay()),[`month`]: (new Date(dayOfWeek).getMonth()),[`year`]: (new Date(dayOfWeek).getFullYear()),[`isToday`]: ((new Date(prevLastDay).getDate()) - i) + 1 == (new Date((new Date())).getDate()) && month == (new Date((new Date())).getMonth()) && (getObjectProperty(data, 'year')) == (new Date((new Date())).getFullYear()),[`prev`]: month <= (new Date((new Date())).getMonth()) + 1 && (getObjectProperty(data, 'year')) == (new Date((new Date())).getFullYear()) || (getObjectProperty(data, 'year')) < (new Date((new Date())).getFullYear()),[`next`]: month > (new Date((new Date())).getMonth()) + 1 && (getObjectProperty(data, 'year')) == (new Date((new Date())).getFullYear()) || (getObjectProperty(data, 'year')) > (new Date((new Date())).getFullYear()),[`prevMonth`]: true,[`nextMonth`]: false });
        addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(data, 'calendarData')), (getObjectProperty(data, 'year')))), ((getObjectProperty(data, 'months'))[(month - 1)]))), dayData);
        addItemToList(allDays, dayData);
        dayIndex = (typeof dayIndex == 'number' ? dayIndex : 0) + 1;
      }
    }
    var i_end = (new Date(lastDay).getDate());
    var i_inc2 = 1;
    if (1 > i_end) {
      i_inc2 = -i_inc2;
    }
    for (i = 1; i_inc2 >= 0 ? i <= i_end : i >= i_end; i += i_inc2) {
      dayOfWeek = (new Date());
      dayOfWeek.setDate(1);
      dayOfWeek.setMonth((month - 1));
      dayOfWeek.setFullYear((new Date(lastDay).getFullYear()));
      dayOfWeek.setDate(i);
      dayData = ({ [`index`]: dayIndex,[`day`]: i,[`dayOfWeek`]: (new Date(dayOfWeek).getDay()),[`month`]: (new Date(dayOfWeek).getMonth()),[`year`]: (new Date(dayOfWeek).getFullYear()),[`isToday`]: i == (new Date((new Date())).getDate()) && month == (new Date((new Date())).getMonth()) + 1 && (getObjectProperty(data, 'year')) == (new Date((new Date())).getFullYear()),[`prev`]: (i < (new Date((new Date())).getDate()) && month == (new Date((new Date())).getMonth()) + 1 || month < (new Date((new Date())).getMonth()) + 1) && (getObjectProperty(data, 'year')) == (new Date((new Date())).getFullYear()) || (getObjectProperty(data, 'year')) < (new Date((new Date())).getFullYear()),[`next`]: (i > (new Date((new Date())).getDate()) && month == (new Date((new Date())).getMonth()) + 1 || month > (new Date((new Date())).getMonth()) + 1) && (getObjectProperty(data, 'year')) == (new Date((new Date())).getFullYear()) || (getObjectProperty(data, 'year')) > (new Date((new Date())).getFullYear()),[`prevMonth`]: false,[`nextMonth`]: false });
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(data, 'calendarData')), (getObjectProperty(data, 'year')))), ((getObjectProperty(data, 'months'))[(month - 1)]))), dayData);
      addItemToList(allDays, dayData);
      dayIndex = (typeof dayIndex == 'number' ? dayIndex : 0) + 1;
    }
    if (nextDays != 0) {
      var i_inc3 = 1;
      if (1 > nextDays) {
        i_inc3 = -i_inc3;
      }
      for (i = 1; i_inc3 >= 0 ? i <= nextDays : i >= nextDays; i += i_inc3) {
        dayOfWeek = (new Date());
        dayOfWeek.setDate(1);
        dayOfWeek.setMonth(month);
        dayOfWeek.setDate(i);
        if (month < 12) {
          dayOfWeek.setFullYear((new Date(lastDay).getFullYear()));
        } else {
          dayOfWeek.setFullYear(((new Date((new Date())).getFullYear()) + 1));
        }
        dayData = ({ [`index`]: dayIndex,[`day`]: i,[`dayOfWeek`]: (new Date(dayOfWeek).getDay()),[`month`]: (new Date(dayOfWeek).getMonth()),[`year`]: (new Date(dayOfWeek).getFullYear()),[`prev`]: month < (new Date((new Date())).getMonth()) + 1 && (getObjectProperty(data, 'year')) == (new Date((new Date())).getFullYear()) || (getObjectProperty(data, 'year')) < (new Date((new Date())).getFullYear()),[`next`]: month >= (new Date((new Date())).getMonth()) + 1 && (getObjectProperty(data, 'year')) == (new Date((new Date())).getFullYear()) || (getObjectProperty(data, 'year')) > (new Date((new Date())).getFullYear()),[`prevMonth`]: false,[`nextMonth`]: true });
        addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(data, 'calendarData')), (getObjectProperty(data, 'year')))), ((getObjectProperty(data, 'months'))[(month - 1)]))), dayData);
        addItemToList(allDays, dayData);
        dayIndex = (typeof dayIndex == 'number' ? dayIndex : 0) + 1;
      }
    }
  }
  data['allDays'] = allDays;

}

})
define('./functions/45329afd4d1efc64364b4b6d45c9e02a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_45329afd4d1efc64364b4b6d45c9e02a'] = async function fn_45329afd4d1efc64364b4b6d45c9e02a(pageData, appData) {
  await new Promise(r => setTimeout(r, 1000 || 0));
  appData['messagesNumber'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getCount/getCount`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());

}

})
define('./functions/47bed951feaa47e346a419d69147a6a6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_47bed951feaa47e346a419d69147a6a6'] = async function fn_47bed951feaa47e346a419d69147a6a6() {
var output, userLocation, error, locationList, userAddress, currentGeo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function subsequenceFirstFromEnd(sequence, at2) {
  var start = 0;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}


  try {
    currentGeo = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
    userAddress = (await Backendless.Request.get(`${Backendless.appPath}/services/ReverseGeoCodding/getReverceGeoCodding`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'lat': (getObjectProperty(currentGeo, 'lat')),'lng': (getObjectProperty(currentGeo, 'lng')) }).send());
    locationList = (getObjectProperty((getObjectProperty(userAddress, 'plus_code')), 'compound_code')).split(' ');
    userLocation = ({ [`latitude`]: (getObjectProperty(currentGeo, 'lat')),[`longitude`]: (getObjectProperty(currentGeo, 'lng')),[`city`]: subsequenceFromStartLast((getObjectProperty((getObjectProperty(userAddress, 'plus_code')), 'compound_code')).split(',')[0].split(' '), 1).join(' ').trim(),[`country`]: locationList.slice(-1)[0],[`region_code`]: subsequenceFirstFromEnd(locationList.slice(-2)[0], 1) });

  } catch (error) {
    console.log(error);

  }
  try {
    if (!userLocation || !(getObjectProperty(userLocation, 'city'))) {
      userLocation = (await (async function() {
      	const getIp = async () => {
      	  const res = await fetch('https://ipapi.co/json/')

      	  const data = await res.json()

      	  return data
      	}

      	return await getIp()

      })());
    }

  } catch (error) {
    console.log(error);

  }
  try {
    if (!userLocation || !(getObjectProperty(userLocation, 'city'))) {
      console.log('Retrying to get location...');
      userLocation = (await (async function() {
      	const getIp = async () => {
      	  const res = await fetch('https://ipapi.co/json/')

      	  const data = await res.json()

      	  return data
      	}

      	return await getIp()

      })());
    }

  } catch (error) {
    console.log(error);

  }
  if (userLocation && (getObjectProperty(userLocation, 'city'))) {
    output = ({ [`locationGeoPoint`]: ({ [`type`]: 'Point',[`coordinates`]: [(getObjectProperty(userLocation, 'longitude')), (getObjectProperty(userLocation, 'latitude'))] }),[`location`]: [(getObjectProperty(userLocation, 'city')),', ',(getObjectProperty(userLocation, 'country')) == 'US' || (getObjectProperty(userLocation, 'country')) == 'USA' ? (getObjectProperty(userLocation, 'region_code')) : (getObjectProperty(userLocation, 'country'))].join(''),[`country`]: (getObjectProperty(userLocation, 'country')) });
  }

return output
}

})
define('./functions/498e158c8709b3f96ffb2d42938f05b8/code.js', () => { 

BackendlessUI.Functions.Custom['fn_498e158c8709b3f96ffb2d42938f05b8'] = async function fn_498e158c8709b3f96ffb2d42938f05b8(data) {
var groups, location2, category, searchInput, locationGeoPoint, groupSize;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if ((getObjectProperty(data, 'searchInput')) && getValueLength((getObjectProperty(data, 'searchInput'))) > 0) {
    searchInput = [' and (name like \'%',(getObjectProperty(data, 'searchInput')),'%\' or longDescription like \'%',(getObjectProperty(data, 'searchInput')),'%\' or shortDescription like \'%',(getObjectProperty(data, 'searchInput')),'%\')'].join('');
  }
  if (getObjectProperty(data, 'categoryChecked')) {
    category = [' and category.objectId in (\'',(getObjectProperty(data, 'categoryChecked')),'\')'].join('');
    if ((getObjectProperty(data, 'categoryChecked')) == 'All categories') {
      category = '';
    }
  } else {
    category = '';
  }
  if ((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'locationGeoPoint')) && (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'locationGeoPoint')), 'coordinates'))) {
    locationGeoPoint = ['\'POINT(',(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(data, 'currentUser')), 'userProfile')), 'locationGeoPoint')), 'coordinates')).join(' '),')\''].join('');
  } else {
    locationGeoPoint = '';
  }
  if (getObjectProperty(data, 'location')) {
    location2 = [' and distanceOnSphere(locationPiont,',locationGeoPoint,') <=',(getObjectProperty(data, 'location'))].join('');
  } else {
    location2 = [' and distanceOnSphere(locationPiont,',locationGeoPoint,') <=',16093000].join('');
  }
  if (getObjectProperty(data, 'groupSize')) {
  } else {
  }
  groups = (await Backendless.Data.of('Group').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId!=null ',searchInput,category,location2].join(''))).setProperties(['visibility', 'objectId', 'name', 'profilePictures', 'shortDescription', 'Count(members) as count']).setRelationsDepth(2).setGroupBy('objectId').setPageSize(100)));
  console.log(groups);

return groups
}

})
define('./functions/4d7f21ac6aa9dcc98952b933fa97e9e3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_4d7f21ac6aa9dcc98952b933fa97e9e3'] = function fn_4d7f21ac6aa9dcc98952b933fa97e9e3(pageData) {
var currentMonth, monthIndex, months;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  months = (getObjectProperty(pageData, 'months'));
  monthIndex = (getObjectProperty(pageData, 'month'));
  currentMonth = months[(monthIndex - 1)];

return currentMonth
}

})
define('./functions/5082808d30ee2f24c04143d4d6e4151d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5082808d30ee2f24c04143d4d6e4151d'] = function fn_5082808d30ee2f24c04143d4d6e4151d() {
function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove('listenChatUpdate');
  getRTSubscriptions().remove('listenChatCreate');
  getRTSubscriptions().remove('listenRecentMessage');
  getRTSubscriptions().remove('dlistenChatDelete');

}

})
define('./functions/51cfe3ce5dd5feda72d561df87a153ea/code.js', () => { 

BackendlessUI.Functions.Custom['fn_51cfe3ce5dd5feda72d561df87a153ea'] = async function fn_51cfe3ce5dd5feda72d561df87a153ea(currentUser) {
var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')) {
    (getObjectProperty(currentUser, 'searchFilter'))['bodyType'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'bodyTypeJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'bodyTypeList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'bodyTypeJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty(currentUser, 'searchFilter'))['drink'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'drinkJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'drinkList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'drinkJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty(currentUser, 'searchFilter'))['dietaryPreference'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'dietaryPreferenceJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'dietaryList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'dietaryPreferenceJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty(currentUser, 'searchFilter'))['education'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'educationJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'educationList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'educationJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty(currentUser, 'searchFilter'))['ethnicity'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'ethnicityJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'ethnicityList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'ethnicityJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty(currentUser, 'searchFilter'))['hairColor'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'hairColorJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'hairColorList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'hairColorJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty(currentUser, 'searchFilter'))['maritalStatus'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'maritalStatusJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'statusList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'maritalStatusJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty(currentUser, 'searchFilter'))['political'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'politicalJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'politicalList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'politicalJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty(currentUser, 'searchFilter'))['religion'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'religionJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'religionList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'religionJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty(currentUser, 'searchFilter'))['sexOrientation'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'sexOrientationJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'orientationList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'sexOrientationJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty(currentUser, 'searchFilter'))['smoke'] = ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'smokeJson')) ? (await asyncListFilter((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')), 'smokeList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(currentUser, 'searchFilter')), 'smokeJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
  }

return currentUser
}

})
define('./functions/5443ddc69ad10a1c48cca32797c3739b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_5443ddc69ad10a1c48cca32797c3739b'] = async function fn_5443ddc69ad10a1c48cca32797c3739b(pageData, appData, currentUser) {
var error, data, temp, notificationPermissionsStatus, channels;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getDeviceSubscriptions() { return getSubscriptionsManager('deviceSubscriptions');}


  channels = (await BackendlessUI.Functions.Custom['fn_60df16e39c865d63641b3eb11343e25f'](currentUser));
  if (!(getObjectProperty(appData, 'isMobileDevice'))) {
    try {
      if (!!channels.length) {
        await ( async function (channels) { return BackendlessUI.DeviceAPI.registerDevice(channels) })(channels);
        try {
          notificationPermissionsStatus = (await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('GET_NOTIFICATION_PERMISSIONS_STATUS', undefined));
          if (notificationPermissionsStatus == 'granted') {
            await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('accepted_device_registration');
          } else {
            await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('declined_device_registration');
          }

        } catch (error) {
          console.log(error);

        }
      } else {
        await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('declined_device_registration');
      }
      appData['isMobileDevice'] = true;

    } catch (error) {
      console.log(error);

    }
  }
  try {
    getDeviceSubscriptions().remove('onTapPushAction');

    await (async function() {
      const callback = async (data) => {
          temp = (getObjectProperty(data, 'data'));
      try {
        if (getObjectProperty(temp, 'chatId')) {
          if (getObjectProperty(temp, 'senderId')) {
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(temp, 'senderId')) }));
          } else {
            if ((await (async function() {
            	return document.location.search.indexOf('messages') < 0
            })())) {
              (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(temp, 'page')), ({ [`chatId`]: (getObjectProperty(temp, 'chatId')) }));
            } else {
              appData['chatId'] = (getObjectProperty(temp, 'chatId'));
            }
          }
        } else if (getObjectProperty(temp, 'activeTab')) {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(temp, 'activeTab')) }));
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(temp, 'page')), undefined);
        }

      } catch (error) {
        console.log(error);

      }

      };

      const eventName = 'onTapPushAction'

      if(!getDeviceSubscriptions().has('onTapPushAction')) {
        await BackendlessUI.DeviceAPI.addEventListener(eventName, callback)
      }

      getDeviceSubscriptions().add('onTapPushAction', () => BackendlessUI.DeviceAPI.removeEventListener(eventName, callback));
    })();

  } catch (error) {
    console.log(error);

  }
  try {
    getDeviceSubscriptions().remove('handleInactiveState');

    await (async function() {
      const callback = async (data) => {
          console.log('_________________HANDLE_INACTIVE_STATE');
      if ((await (async function() {
      	return document.location.search.indexOf('messages') > 0
      })())) {
        await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty(currentUser, 'objectId'))).delete();
      }

      };

      const eventName = 'HANDLE_INACTIVE_STATE'

      if(!getDeviceSubscriptions().has('handleInactiveState')) {
        await BackendlessUI.DeviceAPI.addEventListener(eventName, callback)
      }

      getDeviceSubscriptions().add('handleInactiveState', () => BackendlessUI.DeviceAPI.removeEventListener(eventName, callback));
    })();

  } catch (error) {
    console.log(error);

  }
  try {
    getDeviceSubscriptions().remove('handleResumeState');

    await (async function() {
      const callback = async (data) => {
          console.log('----------------HANDLE_RESUME_STATE');
      if ((await (async function() {
      	return document.location.search.indexOf('messages') < 0
      })())) {
        if (!(((function () { return window.location.href })()).indexOf('quiz') !== -1) && !(((function () { return window.location.href })()).indexOf('signup') !== -1)) {
          console.log('----------------HANDLE_RESUME_STATE for all pages');
          await BackendlessUI.Functions.Custom['fn_2b16a5796a23a5f31854b91671393ba8'](pageData, appData);
          await BackendlessUI.Functions.Custom['fn_7e2293213ea45d13055f12e9567b649a'](appData, pageData);
        }
      } else {
        if (getObjectProperty(appData, 'openMessage')) {
          await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty(currentUser, 'objectId'))).set((getObjectProperty((getObjectProperty(appData, 'openMessage')), 'objectId')));
          appData['chatId'] = (getObjectProperty((getObjectProperty(appData, 'openMessage')), 'objectId'));
        } else {
          appData['chatId'] = 'update';
        }
      }

      };

      const eventName = 'HANDLE_RESUME_STATE'

      if(!getDeviceSubscriptions().has('handleResumeState')) {
        await BackendlessUI.DeviceAPI.addEventListener(eventName, callback)
      }

      getDeviceSubscriptions().add('handleResumeState', () => BackendlessUI.DeviceAPI.removeEventListener(eventName, callback));
    })();

  } catch (error) {
    console.log(error);

  }
  await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('ON_TAP_EVENT_INITIALIZED', undefined);

}

})
define('./functions/54d97075d3360c01afb2f96e65abc56e/code.js', () => { 

BackendlessUI.Functions.Custom['fn_54d97075d3360c01afb2f96e65abc56e'] = async function fn_54d97075d3360c01afb2f96e65abc56e(usersList, currentUser, date, role) {
var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (usersList) {
    console.log('getActivities');
    return (await asyncListFilter((await Backendless.Data.of('Activity').find(Backendless.DataQueryBuilder.create().setWhereClause((await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41'](usersList, 'ownerId=\'', ' or ', '', 'objectId', '\''))).setHavingClause((['activityDate!= null',(await BackendlessUI.Functions.Custom['fn_15839a3dd6a9e8ce681ec977fe735279'](date)),(await BackendlessUI.Functions.Custom['fn_f8564041e56be4dc88360dd95c938941'](role, 'financialRole=\'', ' and ', '\''))].join(''))).setRelated('category').setPageSize(20))), async (item) => {


     return ((getObjectProperty(item, 'ownerId')) != (getObjectProperty(currentUser, 'objectId')));
    }));
  }

return 
}

})
define('./functions/567c7a0e174f799a045d74a8011a4f9b/code.js', () => { 

BackendlessUI.Functions.Custom['fn_567c7a0e174f799a045d74a8011a4f9b'] = function fn_567c7a0e174f799a045d74a8011a4f9b(date) {
  if (date) {
    return ([' and (dayofmonth(activityDate) >= ',(new Date((new Date(date))).getDate()),'',' and year(activityDate) >= ',(new Date((new Date(date))).getFullYear()),'',' and month(activityDate) >= ',(new Date((new Date(date))).getMonth()) + 1,') '].join(''));
  } else {
    return '';
  }

return 
}

})
define('./functions/570c5ed578a4125bf0d767a52b1a63fc/code.js', () => { 

BackendlessUI.Functions.Custom['fn_570c5ed578a4125bf0d767a52b1a63fc'] = async function fn_570c5ed578a4125bf0d767a52b1a63fc(appData, pageData) {
var error, currentChatType, activeChat, j, activeActivity, item, interlocutorId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function setInterlocutorCoverPhoto() {
  pageData['interlocutorImgUrl'] = null;
  interlocutorId = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'openMessage')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'openMessage')), 'sender')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'openMessage')), 'receiver')), 'objectId'));
  pageData['interlocutorImgUrl'] = (await Backendless.Request.get(`${Backendless.appPath}/services/userProfileImg/UserProfileImg`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'userId': JSON.stringify(interlocutorId) }).send());
}


  if (getObjectProperty(pageData, 'messages')) {
    var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'messages')), 'chats')), 'byMe'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      activeChat = (await asyncListFilter((getObjectProperty(j, 'chats')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(pageData, 'getChat')));
      }));
      if (!!activeChat.length) {
        currentChatType = 'byMe';
        activeChat = activeChat[0];
        activeActivity = j;
        break;
      }
    }
    if (!currentChatType) {
      var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'messages')), 'chats')), 'byOthers'));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        if ((getObjectProperty((getObjectProperty(j, 'chat')), 'objectId')) == (getObjectProperty(pageData, 'getChat'))) {
          currentChatType = 'byOthers';
          activeChat = (getObjectProperty(j, 'chat'));
          activeActivity = j;
          break;
        }
      }
    }
    if (!currentChatType) {
      var j_list3 = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'messages')), 'invitations')), 'received'));
      for (var j_index3 in j_list3) {
        j = j_list3[j_index3];
        if ((getObjectProperty(j, 'objectId')) == (getObjectProperty(pageData, 'getChat'))) {
          currentChatType = 'received';
          activeChat = j;
          activeActivity = (getObjectProperty(j, 'currentActivity'));
          break;
        }
      }
    }
    if (!currentChatType) {
      var j_list4 = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'messages')), 'invitations')), 'sent'));
      for (var j_index4 in j_list4) {
        j = j_list4[j_index4];
        if ((getObjectProperty(j, 'objectId')) == (getObjectProperty(pageData, 'getChat'))) {
          currentChatType = 'sent';
          activeChat = j;
          activeActivity = (getObjectProperty(j, 'currentActivity'));
          break;
        }
      }
    }
    if (!currentChatType) {
      return ;
    }
    if (currentChatType == 'byMe' || currentChatType == 'byOthers') {
      activeChat['message'] = (await asyncListSort((getObjectProperty(activeChat, 'message')), 1, async (item) => {


       return (getObjectProperty(item, 'created'));
      }));
    } else {
      activeChat['message'] = [(getObjectProperty(activeChat, 'recentMessage'))];
    }
    pageData['currentActivity'] = activeActivity;
    pageData['openMessage'] = activeChat;
    appData['openMessage'] = (getObjectProperty(pageData, 'openMessage'));
    if (!(getObjectProperty(activeChat, 'chatIsRead'))) {
      activeChat['chatIsRead'] = true;
      if (getObjectProperty(activeChat, 'message')) {
        var j_list5 = (getObjectProperty(activeChat, 'message'));
        for (var j_index5 in j_list5) {
          j = j_list5[j_index5];
          if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId'))) {
            j['isRead'] = true;
          }
        }
      }
      if ((getObjectProperty((getObjectProperty((getObjectProperty(activeChat, 'recentMessage')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId'))) {
        (getObjectProperty(activeChat, 'recentMessage'))['isRead'] = true;
      }
      ;(async () => {
          await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](pageData);

      })();
    }
    if (currentChatType == 'byMe') {
      pageData['currentTab'] = 'chats';
      pageData['activeSpoiler'] = 'myAct';
      pageData['selectedAct'] = (getObjectProperty((getObjectProperty(pageData, 'currentActivity')), 'objectId'));
      (getObjectProperty(pageData, 'openMessage'))['currentChatType'] = 'byMe';
    }
    if (currentChatType == 'byOthers') {
      pageData['currentTab'] = 'chats';
      pageData['activeSpoiler'] = 'otherAct';
      (getObjectProperty(pageData, 'openMessage'))['currentChatType'] = 'byOthers';
    }
    if (currentChatType == 'received') {
      pageData['currentTab'] = 'invitations';
      pageData['activeSpoiler'] = 'receivedInv';
      (getObjectProperty(pageData, 'openMessage'))['currentChatType'] = 'received';
    }
    if (currentChatType == 'sent') {
      pageData['currentTab'] = 'invitations';
      pageData['activeSpoiler'] = 'sentInv';
      (getObjectProperty(pageData, 'openMessage'))['currentChatType'] = 'sent';
    }
    appData['openMessage'] = (getObjectProperty(pageData, 'openMessage'));
    try {
      ;(async () => {
          await setInterlocutorCoverPhoto();

      })();

    } catch (error) {
      console.log(error);

    }
    await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId'))).set((getObjectProperty(pageData, 'getChat')));
    localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
  }

}

})
define('./functions/57135e2cd68ac40b08da3b12a576bccb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_57135e2cd68ac40b08da3b12a576bccb'] = async function fn_57135e2cd68ac40b08da3b12a576bccb(chat) {
var senderPhoto, item, receiverPhoto;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(chat, 'receiverPhoto')) {
    receiverPhoto = (await asyncListFilter((getObjectProperty(chat, 'receiverPhoto')), async (item) => {


     return (getObjectProperty(item, 'isCover'));
    }))[0];
    if (receiverPhoto) {
      (getObjectProperty(chat, 'receiver'))['photo'] = (getObjectProperty(receiverPhoto, 'file'));
    }
  }
  if (getObjectProperty(chat, 'senderPhoto')) {
    senderPhoto = (await asyncListFilter((getObjectProperty(chat, 'senderPhoto')), async (item) => {


     return (getObjectProperty(item, 'isCover'));
    }))[0];
    if (senderPhoto) {
      (getObjectProperty(chat, 'sender'))['photo'] = (getObjectProperty(senderPhoto, 'file'));
    }
  }

}

})
define('./functions/60df16e39c865d63641b3eb11343e25f/code.js', () => { 

BackendlessUI.Functions.Custom['fn_60df16e39c865d63641b3eb11343e25f'] = function fn_60df16e39c865d63641b3eb11343e25f(currentUser) {
var channelList, notifications;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  channelList = [];
  if ((getObjectProperty(currentUser, 'userProfile')) && (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'settings'))) {
    notifications = (getObjectProperty((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'settings')), 'notifications'));
    if (notifications.includes('likes')) {
      channelList.push('likes');
    }
    if (notifications.includes('replies')) {
      channelList.push('replies');
    }
    if (notifications.includes('message')) {
      channelList.push('push_background');
    }
    if (notifications.includes('invites')) {
      channelList.push('invites');
    }
  } else {
    channelList = ['likes', 'replies', 'push_background', 'invites'];
  }

return channelList
}

})
define('./functions/6bf75c3392372ebb595566f4a75ca2b3/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'] = async function fn_6bf75c3392372ebb595566f4a75ca2b3(pageData, classListNewMessage, appData) {
var message, currentUser, newCount, activityId, item, object, activitiesId, error, command, updatedChatItem, curChat, receiverName, activityName, newChat, senderName, userJson, userResponce, userSeenBy, seenByList, newUserLikes, getLikedBy, likedBy, likedByList, userProfileObjectId, profileId, areLikesEnabled;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

/**
 * Describe this function...
 */
async function messages() {
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    getRTSubscriptions().remove('newMessages');
    await BackendlessUI.Functions.Custom['fn_2b16a5796a23a5f31854b91671393ba8'](pageData, appData);
  } else {
    getRTSubscriptions().remove('messages');
    getRTSubscriptions().remove('newMessages');

    ;(function(selector) {
      const callback = async message => {
          if (!((getObjectProperty(((function () { return window.location })()), 'search')).indexOf('messages') !== -1) && !(getObjectProperty(appData, (getObjectProperty(message, 'messageId'))))) {
        appData[(getObjectProperty(message, 'messageId'))] = true;
        if ((getObjectProperty((getObjectProperty((getObjectProperty(message, 'message')), 'receiver')), 'objectId')) == (getObjectProperty(currentUser, 'objectId'))) {
          await BackendlessUI.Functions.Custom['fn_45329afd4d1efc64364b4b6d45c9e02a'](pageData, appData);
          newCount = (getObjectProperty(appData, 'messagesNumber'));
          if (!(getObjectProperty(pageData, 'openMessage')) || (getObjectProperty((getObjectProperty(message, 'message')), 'chatId')) != (getObjectProperty((getObjectProperty(pageData, 'openMessage')), 'objectId')) && (getObjectProperty((getObjectProperty((getObjectProperty(message, 'message')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId'))) {
            if (newCount) {
              if (!(getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'settings')) || !(getObjectProperty((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'settings')), 'notifications')) || ((getObjectProperty((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'settings')), 'notifications')).includes('replies')) || ((getObjectProperty((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'settings')), 'notifications')).includes('message'))) {
                appData['newMessageText'] = (String('You have a new message from ') + String(getObjectProperty((getObjectProperty(message, 'message')), 'senderName')));
                appData['showPopup'] = true;
                if (getObjectProperty(appData, 'showPopup')) {
                  appData['getChat'] = (getObjectProperty((getObjectProperty(message, 'message')), 'chatId'));
                  await new Promise(r => setTimeout(r, 7000 || 0));
                  delete appData['getChat'];
                  delete appData['newMessageText'];
                  delete appData['showPopup'];
                }
                delete appData['newCounts'];
                delete appData['newCounts'];
              }
            }
          }
        }
      }

      };

      const channel = getChannelInstance('default');

      const options = [callback];

      if (selector) {
         options.unshift(selector);
      }

      channel.addMessageListener.apply(channel, options);

      getRTSubscriptions().add('newMessages', () => channel.removeMessageListener.apply(channel, options));
    })((['receiverId IN (\'',(getObjectProperty((getObjectProperty(appData, 'currentUser')), 'objectId')),'\')'].join('')));
  }
}

/**
 * Describe this function...
 */
async function deleteActivityListener() {
  getRTSubscriptions().remove('deleteActivityListener');
  if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')) && (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'messages')) && (getObjectProperty((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'messages')), 'chats'))) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'messages')), 'chats')), 'byOthers')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'messages')), 'chats')), 'byOthers')).length) {
      activitiesId = ((getObjectProperty((getObjectProperty((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'messages')), 'chats')), 'byOthers')).map(item => item['objectId'])).join(',');
    }
  }
  if (activitiesId) {

    ;(function(whereClause) {
      const callback = async object => {
          await BackendlessUI.Functions.Custom['fn_45329afd4d1efc64364b4b6d45c9e02a'](pageData, appData);

      };

      const rtHandlers = Backendless.Data.of('Activity').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addDeleteListener.apply(rtHandlers, options);

      getRTSubscriptions().add('deleteActivityListener', () => rtHandlers.removeDeleteListener(callback));

    })((['objectId IN (\'',activitiesId,'\')'].join('')));
      }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  getRTSubscriptions().remove('blockedUser');
  getRTSubscriptions().remove('unBlockUser');
  getRTSubscriptions().remove('blockListDelete');
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  if (!(getObjectProperty(appData, 'currentUser'))) {
    appData['currentUser'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
    pageData['currentUser'] = (getObjectProperty(appData, 'currentUser'));
  }
  currentUser = (getObjectProperty(appData, 'currentUser'));
  try {
    getRTSubscriptions().remove('blockListAdd');

    ;(function() {
      const callback = async object => {
          if (((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))) || (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'objectId'))) {
        if (((function () { return window.location.href })()).indexOf('activities-search') !== -1) {
          pageData['countOffset'] = 0;
          pageData['pastActivities'] = false;
          appData['activityList'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](pageData));
          pageData['activityListAll'] = (getObjectProperty(appData, 'activityList'));
          pageData['activityList'] = (getObjectProperty(appData, 'activityList'));
          pageData['noMoreActivities'] = false;
        } else {
          delete appData['activityList'];
        }
        if (getObjectProperty(appData, 'users')) {
          appData['users'] = (await asyncListFilter((getObjectProperty(appData, 'users')), async (item) => {


           return ((getObjectProperty(item, 'userProfileId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')));
          }));
          pageData['users'] = (getObjectProperty(appData, 'users'));
          appData['needUpdateUsersRtBlock'] = true;
        } else if (getObjectProperty(pageData, 'users')) {
          pageData['users'] = (await asyncListFilter((getObjectProperty(pageData, 'users')), async (item) => {


           return ((getObjectProperty(item, 'userProfileId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')));
          }));
          appData['users'] = (getObjectProperty(pageData, 'users'));
          appData['needUpdateUsersRtBlock'] = true;
        }
        if (getObjectProperty(appData, 'seenBy')) {
          appData['seenBy'] = (await asyncListFilter((getObjectProperty(appData, 'seenBy')), async (item) => {


           return ((getObjectProperty(item, 'userProfileObjectId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) && !((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))));
          }));
          if (getObjectProperty(pageData, 'seenBy')) {
            pageData['seenBy'] = (getObjectProperty(appData, 'seenBy'));
          }
        }
        if (getObjectProperty(appData, 'myLikes')) {
          appData['myLikes'] = (await asyncListFilter((getObjectProperty(appData, 'myLikes')), async (item) => {


           return ((getObjectProperty(item, 'userProfileObjectId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) && !((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))));
          }));
          if (getObjectProperty(pageData, 'myLikes')) {
            pageData['myLikes'] = (getObjectProperty(appData, 'myLikes'));
          }
        }
        if (getObjectProperty(pageData, 'likedBy')) {
          pageData['likedBy'] = (await asyncListFilter((getObjectProperty(pageData, 'likedBy')), async (item) => {


           return ((getObjectProperty(item, 'userProfileObjectId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) && !((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))));
          }));
        }
        if (getObjectProperty(pageData, 'likesActivities')) {
          pageData['likesActivities'] = (await asyncListFilter((getObjectProperty(pageData, 'likesActivities')), async (item) => {


           return ((getObjectProperty(item, 'userProfileObjectId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) && !((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))));
          }));
        }
        delete pageData['chats'];
        delete appData['chats'];
        delete pageData['receivedChats'];
        delete pageData['activityMessages'];
        delete appData['activityMessages'];
        if ((getObjectProperty(object, 'userId')) != (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId'))) {
          if (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'seenBy')) {
            (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile'))['seenBy'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'seenBy')), async (item) => {


             return ((getObjectProperty(object, 'userId')) != (getObjectProperty(item, 'objectId')));
            }));
            (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'userProfile'))['seenBy'] = (getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'userProfile')), 'seenBy'));
            localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(appData, 'currentUser'))));
          }
        }
        if (((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))) && ((((function () { return window.location.href })()).indexOf('profile-page') !== -1) && !(((function () { return window.location.href })()).indexOf((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId'))) !== -1) || (((function () { return window.location.href })()).indexOf('activity') !== -1) && (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentActivityOwner')), 'userProfile')), 'objectId')) == (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')))) {
          if ((getObjectProperty(appData, 'previousPage')) && (getObjectProperty(appData, 'previousPage')) == 'profile-page' && (getObjectProperty(appData, 'previousPage')) == 'activity') {
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(appData, 'previousPage')), undefined);
          } else {
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
          }
        }
      }

      };

      const channel = getChannelInstance('blockUserForever');

      channel.addCommandListener(callback);

      getRTSubscriptions().add('blockListAdd', () => channel.removeCommandListener(callback));
    })();

  } catch (error) {
    console.log(error);

  }
  try {
    getRTSubscriptions().remove('blockListDelete');

    ;(function() {
      const callback = async object => {
          await new Promise(r => setTimeout(r, 1000 || 0));
      if (((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))) || (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'objectId'))) {
        if (((function () { return window.location.href })()).indexOf('activities-search') !== -1) {
          pageData['countOffset'] = 0;
          pageData['pastActivities'] = false;
          pageData['noMoreActivities'] = true;
          pageData['activityListAllNew'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](pageData));
          pageData['newActivities'] = false;
        }
        if (((function () { return window.location.href })()).indexOf('page=profiles') !== -1) {
          if (getObjectProperty(pageData, 'countOffset')) {
            delete pageData['countOffset'];
          }
        }
        appData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(pageData, 'currentUser')), (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'searchFilter')), ((getObjectProperty(pageData, 'pageSize')) ? (getObjectProperty(pageData, 'pageSize')) : 10), pageData));
        if (((function () { return window.location.href })()).indexOf('page=profiles') !== -1) {
          if ((getObjectProperty(object, 'userId')) != (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId'))) {
            pageData['usersNew'] = (getObjectProperty(appData, 'users'));
            pageData['btnNewProfileVisible'] = true;
          }
        } else {
          pageData['users'] = (getObjectProperty(appData, 'users'));
        }
        pageData['seenBy'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'seenBy')).map(item => item['objectId'])).slice(0, 21).join('\',\''))) }).send());
        if (getObjectProperty(pageData, 'seenBy')) {
          var userResponce_list = (getObjectProperty(pageData, 'seenBy'));
          for (var userResponce_index in userResponce_list) {
            userResponce = userResponce_list[userResponce_index];
            var userJson_list = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'seenBy'));
            for (var userJson_index in userJson_list) {
              userJson = userJson_list[userJson_index];
              if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
              }
            }
          }
          pageData['seenBy'] = (await asyncListSort((getObjectProperty(pageData, 'seenBy')), -1, async (item) => {


           return (getObjectProperty(item, 'ts'));
          }));
        }
        appData['seenBy'] = (getObjectProperty(pageData, 'seenBy'));
        pageData['myLikes'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'myLikes')).map(item => item['objectId'])).slice(0, 21).join('\',\''))) }).send());
        if (getObjectProperty(pageData, 'myLikes')) {
          var userResponce_list2 = (getObjectProperty(pageData, 'myLikes'));
          for (var userResponce_index2 in userResponce_list2) {
            userResponce = userResponce_list2[userResponce_index2];
            var userJson_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'myLikes'));
            for (var userJson_index2 in userJson_list2) {
              userJson = userJson_list2[userJson_index2];
              if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
              }
            }
          }
          pageData['myLikes'] = (await asyncListSort((getObjectProperty(pageData, 'myLikes')), -1, async (item) => {


           return (getObjectProperty(item, 'ts'));
          }));
        }
        appData['myLikes'] = (getObjectProperty(pageData, 'myLikes'));
        if (getObjectProperty(pageData, 'likedBy')) {
          pageData['likedBy'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likedBy')).map(item => item['objectId'])).slice(0, 21).join('\',\''))) }).send());
          var userResponce_list3 = (getObjectProperty(pageData, 'likedBy'));
          for (var userResponce_index3 in userResponce_list3) {
            userResponce = userResponce_list3[userResponce_index3];
            var userJson_list3 = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likedBy'));
            for (var userJson_index3 in userJson_list3) {
              userJson = userJson_list3[userJson_index3];
              if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
              }
            }
          }
          pageData['likedBy'] = (await asyncListSort((getObjectProperty(pageData, 'likedBy')), -1, async (item) => {


           return (getObjectProperty(item, 'ts'));
          }));
        }
        if ((getObjectProperty(pageData, 'likesActivities')) && (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile'))) {
          pageData['likesActivities'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivity/getActivities`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'pageSize': 100,'relation': JSON.stringify((['category', 'author', 'author.userProfile.settings'].join(','))),'sort': JSON.stringify('activityDate DESC, ongoingTiming'),'whereClause': JSON.stringify((['visibility!=3 and activityStatus=true ',' and objectId in (\'',((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likedActivities')).map(item => item['objectId'])).join('\',\''),'\') '].join(''))) }).send());
          var userResponce_list4 = (getObjectProperty(pageData, 'likesActivities'));
          for (var userResponce_index4 in userResponce_list4) {
            userResponce = userResponce_list4[userResponce_index4];
            var userJson_list4 = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likesActivities'));
            for (var userJson_index4 in userJson_list4) {
              userJson = userJson_list4[userJson_index4];
              if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
              }
            }
          }
          pageData['likesActivities'] = (await asyncListSort((getObjectProperty(pageData, 'likesActivities')), -1, async (item) => {


           return (getObjectProperty(item, 'ts'));
          }));
        }
        delete pageData['chats'];
        delete appData['chats'];
        delete pageData['receivedChats'];
        delete pageData['activityMessages'];
        delete appData['activityMessages'];
      }

      };

      const channel = getChannelInstance('unblockUserChannel');

      channel.addCommandListener(callback);

      getRTSubscriptions().add('blockListDelete', () => channel.removeCommandListener(callback));
    })();

  } catch (error) {
    console.log(error);

  }
  try {
    getRTSubscriptions().remove('likes');
    areLikesEnabled = true;
    if (getObjectProperty(currentUser, 'userProfile')) {
      areLikesEnabled = !(getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'settings')) || (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'settings')) && ((getObjectProperty((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'settings')), 'notifications')).includes('likes'));
    }
    if (areLikesEnabled) {

      ;(function() {
        const callback = async command => {
            if ((getObjectProperty(currentUser, 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'receiver'))) {
          pageData['likedByOld'] = (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'likedBy'));
          await new Promise(r => setTimeout(r, 1000 || 0));
          userProfileObjectId = (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'objectId'));
          if (!userProfileObjectId) {
            userProfileObjectId = (getObjectProperty((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'userProfile')), 'objectId'));
            if (!userProfileObjectId) {
              profileId = (getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/userProfile/userProfile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), 'objectId'));
              (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'userProfile'))['objectId'] = profileId;
              localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(appData, 'currentUser'))));
              userProfileObjectId = (getObjectProperty((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'userProfile')), 'objectId'));
            }
          }
          newUserLikes = (await Backendless.Request.get(`${Backendless.appPath}/services/userProfileLikes/getUserLikes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'objectId': JSON.stringify(userProfileObjectId) }).send());
          (getObjectProperty(currentUser, 'userProfile'))['likedBy'] = (getObjectProperty(newUserLikes, 'likedBy'));
          (getObjectProperty(currentUser, 'userProfile'))['myLikes'] = (getObjectProperty(newUserLikes, 'myLikes'));
          (getObjectProperty(currentUser, 'userProfile'))['seenBy'] = (getObjectProperty(newUserLikes, 'seenBy'));
          (getObjectProperty(currentUser, 'userProfile'))['likedActivities'] = (getObjectProperty(newUserLikes, 'likedActivities'));
          if (!(await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
            appData['showPopup'] = true;
            if ((getObjectProperty(appData, 'showPopup')) && (getObjectProperty((getObjectProperty(command, 'data')), 'message'))) {
              appData['newMessageText'] = (getObjectProperty((getObjectProperty(command, 'data')), 'message'));
              appData['newMessageBtn'] = (['View ',(getObjectProperty((getObjectProperty(command, 'data')), 'senderName')),'\'s profile'].join(''));
              appData['senderId'] = (getObjectProperty((getObjectProperty(command, 'data')), 'senderId'));
              await new Promise(r => setTimeout(r, 7000 || 0));
              delete appData['senderId'];
              delete appData['newMessageText'];
              delete appData['newMessageBtn'];
              delete appData['showPopup'];
            }
          }
          delete pageData['likedByOld'];
          delete appData['pushMessage'];
          if (currentUser && (getObjectProperty(currentUser, 'userProfile'))) {
            (getObjectProperty(currentUser, 'userProfile'))['likedBy'] = (getObjectProperty(newUserLikes, 'likedBy'));
            (getObjectProperty(currentUser, 'userProfile'))['myLikes'] = (getObjectProperty(newUserLikes, 'myLikes'));
            (getObjectProperty(currentUser, 'userProfile'))['seenBy'] = (getObjectProperty(newUserLikes, 'seenBy'));
            (getObjectProperty(currentUser, 'userProfile'))['likedActivities'] = (getObjectProperty(newUserLikes, 'likedActivities'));
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
            if ((getObjectProperty(newUserLikes, 'likedBy')) && (getObjectProperty(newUserLikes, 'likedBy')).length > 0) {
              likedByList = (await asyncListFilter((getObjectProperty(newUserLikes, 'likedBy')), async (item) => {


               return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(currentUser, 'ownerId')));
              }));
              pageData['likedByList'] = (likedByList.map(item => item['objectId']));
              if ((getObjectProperty(newUserLikes, 'likedBy')).length > 21) {
                likedBy = (getObjectProperty(pageData, 'likedByList')).slice(0, 21);
                pageData['likedByList'] = (subsequenceFromStartLast((getObjectProperty(pageData, 'likedByList')), 21));
              } else {
                likedBy = (getObjectProperty(pageData, 'likedByList'));
                pageData['likedByList'] = [];
              }
              getLikedBy = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((likedBy.join('\',\''))) }).send());
              if (getLikedBy) {
                for (var userResponce_index5 in getLikedBy) {
                  userResponce = getLikedBy[userResponce_index5];
                  var userJson_list5 = (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'likedBy'));
                  for (var userJson_index5 in userJson_list5) {
                    userJson = userJson_list5[userJson_index5];
                    if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                      userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
                    }
                  }
                }
                pageData['likedBy'] = (await asyncListSort(getLikedBy, -1, async (item) => {


                 return (getObjectProperty(item, 'ts'));
                }));
              }
            }
            if ((getObjectProperty(newUserLikes, 'seenBy')) || (getObjectProperty(newUserLikes, 'seenBy')).length > 0) {
              seenByList = (await asyncListFilter((getObjectProperty(newUserLikes, 'seenBy')), async (item) => {


               return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(currentUser, 'ownerId')));
              }));
              pageData['seenByList'] = (seenByList.map(item => item['objectId']));
              if ((getObjectProperty(pageData, 'seenByList')).length > 21) {
                userSeenBy = (getObjectProperty(pageData, 'seenByList')).slice(0, 21);
                pageData['seenByList'] = (subsequenceFromStartLast((getObjectProperty(pageData, 'seenByList')), 20));
              } else {
                userSeenBy = (getObjectProperty(pageData, 'seenByList'));
                pageData['seenByList'] = [];
              }
              pageData['seenByNew'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((userSeenBy.join('\',\''))) }).send());
              await new Promise(r => setTimeout(r, 200 || 0));
              if ((getObjectProperty(pageData, 'seenByNew')) && !!(getObjectProperty(pageData, 'seenByNew')).length) {
                if (getObjectProperty(pageData, 'seenByNew')) {
                  var userResponce_list5 = (getObjectProperty(pageData, 'seenByNew'));
                  for (var userResponce_index6 in userResponce_list5) {
                    userResponce = userResponce_list5[userResponce_index6];
                    var userJson_list6 = (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'seenBy'));
                    for (var userJson_index6 in userJson_list6) {
                      userJson = userJson_list6[userJson_index6];
                      if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                        userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
                      }
                    }
                  }
                  pageData['seenBy'] = (await asyncListSort((getObjectProperty(pageData, 'seenByNew')), -1, async (item) => {


                   return (getObjectProperty(item, 'ts'));
                  }));
                }
              }
            }
          }
        }

        };

        const channel = getChannelInstance('likes');

        channel.addCommandListener(callback);

        getRTSubscriptions().add('likes', () => channel.removeCommandListener(callback));
      })();
    }

  } catch (error) {
    console.log(error);

  }
  try {
    getRTSubscriptions().remove('chats');

    ;(function(parentObjects) {
      const callback = async object => {
          console.log('chats');
      console.log(object);
      await new Promise(r => setTimeout(r, 1000 || 0));
      newChat = (await Backendless.Request.get(`${Backendless.appPath}/services/updatedChat/getUpdatedChat`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'whereClause': JSON.stringify((['objectId=\'',(getObjectProperty(object, 'children'))[0],'\''].join(''))),'relations': JSON.stringify((['receiver', 'sender', 'recentMessage', 'recentMessage.sender', 'recentMessage.receiver'].join(','))),'properties': JSON.stringify((['receiver.userProfile.media as receiverPhoto', 'sender.userProfile.media as senderPhoto', 'created', 'activityId', 'deletedByReceiver', 'deletedBySender', 'objectId', 'status', 'type', 'isBlocked', 'receiver.userProfile.objectId as receiverUserProfile', 'sender.userProfile.objectId as senderUserProfile', 'deletedByReceiver', 'deletedBySender', 'recentMessage.isRead as chatIsRead', 'sender.name as senderName', 'sender.login as login', 'sender.objectId as senderObjectId', 'Activity[chat].name as activityName'].join(','))),'pageSize': 1 }).send())[0];
      if (newChat && (getObjectProperty(newChat, 'senderObjectId')) != (getObjectProperty(currentUser, 'objectId'))) {
        await BackendlessUI.Functions.Custom['fn_45329afd4d1efc64364b4b6d45c9e02a'](pageData, appData);
        await new Promise(r => setTimeout(r, 500 || 0));
        if (!(await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
          senderName = (getObjectProperty(newChat, 'senderName')) ? (getObjectProperty(newChat, 'senderName')).split(' ')[0] : (getObjectProperty(newChat, 'login'));
          if ((getObjectProperty(newChat, 'status')) == 'new') {
            if ((getObjectProperty(newChat, 'type')) == 'requestPermission') {
              appData['newMessageText'] = (String('You have a new request to photo from ') + String(senderName));
            } else if ((getObjectProperty(newChat, 'type')) == 'activityRequest') {
              appData['newMessageText'] = ([senderName,' asks to join your activity "',(getObjectProperty(newChat, 'activityName')),'"'].join(''));
            } else {
              appData['newMessageText'] = ([senderName,' invites you to be their +1 for "',(getObjectProperty(newChat, 'activityName')),'"'].join(''));
            }
            appData['showPopup'] = true;
            if (getObjectProperty(appData, 'showPopup')) {
              appData['getChat'] = (getObjectProperty(newChat, 'objectId'));
              await new Promise(r => setTimeout(r, 7000 || 0));
              delete appData['getChat'];
              delete appData['newMessageText'];
              delete appData['showPopup'];
            }
          }
        }
      }
      await deleteActivityListener();

      };

      const rtHandlers = Backendless.Data.of('Users').rt();

      const options = ['chat'];

      if (parentObjects) {
         options.push(parentObjects);
      }

      options.push(callback)

      rtHandlers.addAddRelationListener.apply(rtHandlers, options);

      getRTSubscriptions().add('chats', () => rtHandlers.removeAddRelationListener(callback));

    })([currentUser]);

  } catch (error) {
    console.log(error);

  }
  try {
    getRTSubscriptions().remove('chatsAccepted');

    ;(function(whereClause) {
      const callback = async object => {
          appData['newChatId'] = ((getObjectProperty(object, 'whereClause')).slice(10, 46));
      if (!(getObjectProperty(appData, 'chats'))) {
        appData['chats'] = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      }
      curChat = (await (async function(list, condition) {
      	return list.find(item => condition.includes(item.objectId))
      })((getObjectProperty(appData, 'chats')), (getObjectProperty(object, 'whereClause'))));
      try {
        if ((getObjectProperty(object, 'whereClause')).slice(0, 8) == 'objectId') {
          appData['newAcceptedChat'] = ((await Backendless.Request.get(`${Backendless.appPath}/services/updatedChat/getUpdatedChat`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'whereClause': JSON.stringify((['objectId=\'',(getObjectProperty(appData, 'newChatId')),'\''].join(''))),'relations': JSON.stringify(''),'properties': JSON.stringify((['receiver.login as login', 'ownerId', 'type', 'objectId', 'status', 'activityId', 'receiver.name as receiverName', 'deletedByReceiver', 'deletedBySender', 'receiver.gender as receiverGender'].join(','))) }).send())[0]);
          updatedChatItem = (getObjectProperty(appData, 'newAcceptedChat'));
          if (!(getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'deletedByReceiver')) && !(getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'deletedBySender'))) {
            await BackendlessUI.Functions.Custom['fn_45329afd4d1efc64364b4b6d45c9e02a'](pageData, appData);
            if (getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'activityId')) {
              appData['activityName'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivityName/getActivityName`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'activityId': JSON.stringify((getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'activityId'))) }).send());
            }
            if ((getObjectProperty(appData, 'newAcceptedChat')) && (getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'ownerId')) == (getObjectProperty(currentUser, 'objectId'))) {
              await new Promise(r => setTimeout(r, 500 || 0));
              if (!(await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
                receiverName = (getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'receiverName')) ? (getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'receiverName')).split(' ')[0] : (getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'login'));
                if (((getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'type')) == 'acceptedInvitation' || (getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'type')) == 'activityRequest') && (getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'status')) != 'rejected') {
                  activityName = (getObjectProperty(appData, 'activityName')) ? ['"',(getObjectProperty((getObjectProperty(appData, 'activityName')), 'name')),'"'].join('') : '';
                  appData['newMessageText'] = ([activityName,' - ',receiverName,' has accepted your request to join this activity.'].join(''));
                } else if ((getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'type')) == 'requestPermission' && (getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'status')) != 'rejected') {
                  appData['newMessageText'] = (String(receiverName) + String(' has approved your photo request!'));
                }
                appData['showPopup'] = true;
                if ((getObjectProperty(appData, 'showPopup')) && (getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'status')) != 'rejected') {
                  appData['getChat'] = (getObjectProperty((getObjectProperty(appData, 'newAcceptedChat')), 'objectId'));
                  ;(async () => {
                      await new Promise(r => setTimeout(r, 10000 || 0));
                    delete appData['getChat'];
                    delete appData['newMessageText'];
                    delete appData['showPopup'];

                  })();
                }
              }
            }
            Object.assign(curChat, updatedChatItem);
          }
        }
        delete appData['newAcceptedChat'];

      } catch (error) {
        console.log(error);

      }
      appData['newMessagesRt'] = true;

      };

      const rtHandlers = Backendless.Data.of('Chat').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addBulkUpdateListener.apply(rtHandlers, options);

      getRTSubscriptions().add('chatsAccepted', () => rtHandlers.removeBulkUpdateListener(callback));

    })('');

  } catch (error) {
    console.log(error);

  }
  await messages();
  await deleteActivityListener();
  try {
    getRTSubscriptions().remove('delete');

    ;(function(whereClause) {
      const callback = async object => {
          try {
        if ((getObjectProperty(object, 'whereClause')).slice(0, 6) == 'chatId') {
          await BackendlessUI.Functions.Custom['fn_45329afd4d1efc64364b4b6d45c9e02a'](pageData, appData);
        }

      } catch (error) {
        console.log(error);

      }

      };

      const rtHandlers = Backendless.Data.of('Message').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addBulkDeleteListener.apply(rtHandlers, options);

      getRTSubscriptions().add('delete', () => rtHandlers.removeBulkDeleteListener(callback));

    })('');

  } catch (error) {
    console.log(error);

  }
  try {
    getRTSubscriptions().remove('RT_messages_listener');

    ;(function() {
      const callback = async command => {
          if ((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'targetUserId'))) {
        if ((getObjectProperty(command, 'type')) == 'unBlockActivityLocation') {
          if (getObjectProperty(appData, 'activityList')) {
            delete appData['activityList'];
          }
        }
      }
      if (Array.isArray((getObjectProperty((getObjectProperty(command, 'data')), 'targetUserId')))) {
        if ((getObjectProperty((getObjectProperty(command, 'data')), 'targetUserId')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))) {
          if ((getObjectProperty(command, 'type')) == 'blockUser' || (getObjectProperty(command, 'type')) == 'unBlockUser') {
            await BackendlessUI.Functions.Custom['fn_45329afd4d1efc64364b4b6d45c9e02a'](pageData, appData);
          }
        }
      }

      };

      const channel = getChannelInstance('RT_messages');

      channel.addCommandListener(callback);

      getRTSubscriptions().add('RT_messages_listener', () => channel.removeCommandListener(callback));
    })();

  } catch (error) {
    console.log(error);

  }
  try {
    if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
      await BackendlessUI.Functions.Custom['fn_5443ddc69ad10a1c48cca32797c3739b'](pageData, appData, currentUser);
    }

  } catch (error) {
    console.log(error);

  }

}

})
define('./functions/6d640b539fc5e0f7d9c267729e9a3a04/code.js', () => { 

BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04'] = async function fn_6d640b539fc5e0f7d9c267729e9a3a04() {
  await (async function() {
  	if (Array.isArray(swiper)) {
  	  for (const swiperItem of swiper) {
  	    swiperItem.destroy(true, false);
  	  }
  	} else {
  	  swiper.destroy(true, false);
  	}

  	setTimeout(() => {

  	  swiper = new Swiper('.swiper', {

  	    pagination: {
  	      el: '.swiper-pagination',
  	      clickable: true
  	    }

  	  });

  	}, 100);
  })();

}

})
define('./functions/703d699284abb6c5284f7341533b3fd7/code.js', () => { 

BackendlessUI.Functions.Custom['fn_703d699284abb6c5284f7341533b3fd7'] = async function fn_703d699284abb6c5284f7341533b3fd7(stepCount, dynamicList) {
var firstWidgetRender, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  firstWidgetRender = (await Promise.all(dynamicList.map(async item => {  item['height'] = ((getObjectProperty(item, 'height')) - stepCount);
    if ((getObjectProperty(item, 'height')) < 0) {
      item['opacity'] = 0;
    }
  ; return item;})));

return firstWidgetRender
}

})
define('./functions/70a9085df5e89a247121f93b27feaf9c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_70a9085df5e89a247121f93b27feaf9c'] = function fn_70a9085df5e89a247121f93b27feaf9c(pageData, activity, chat) {
function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  chat['chatIsRead'] = true;
  (getObjectProperty(chat, 'recentMessage'))['isRead'] = true;
  pageData['countMessages'] = ((getObjectProperty(pageData, 'countMessages')) - 1);
  activity['newMessage'] = false;
  pageData['unreadInvChatsCount'] = ((getObjectProperty(pageData, 'unreadInvChatsCount')) - 1);

}

})
define('./functions/77f5988a8ef8a2995bf9591883927c65/code.js', () => { 

BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65'] = function fn_77f5988a8ef8a2995bf9591883927c65(date) {
var time, day, date, month, minutes, hours, created, dayList, monthList;


  monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  date = (new Date(date));
  month = monthList[(((new Date(date).getMonth()) + 1) - 1)];
  day = dayList[(((new Date(date).getDay()) + 1) - 1)];
  if (date) {
    created = (new Date(date));
    if ((new Date(created).getHours()) < 10) {
      hours = String(0) + String(new Date(created).getHours());
    } else {
      hours = (new Date(created).getHours());
    }
    if ((new Date(created).getMinutes()) < 10) {
      minutes = String(0) + String(new Date(created).getMinutes());
    } else {
      minutes = (new Date(created).getMinutes());
    }
    if (hours <= 12) {
      time = [hours,':',minutes,' am'].join('');
    } else {
      time = [hours - 12,':',minutes,' pm'].join('');
    }
  }

return ([month,' ',(new Date(date).getDate()),', ',(new Date(date).getFullYear()),', ',day,', ',time].join(''))
}

})
define('./functions/7933881c975cf68554fd4556990234b5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5'] = async function fn_7933881c975cf68554fd4556990234b5(tableName) {
return (await Backendless.Data.of(tableName).find(Backendless.DataQueryBuilder.create().setPageSize(50)))
}

})
define('./functions/7e2293213ea45d13055f12e9567b649a/code.js', () => { 

BackendlessUI.Functions.Custom['fn_7e2293213ea45d13055f12e9567b649a'] = async function fn_7e2293213ea45d13055f12e9567b649a(appData, pageData) {
var error, item, receivedChats, likedActivities, userJson, userResponce, likedBy, query, userSeenBy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getMessages() {
  try {
    appData['chats'] = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    receivedChats = (await asyncListFilter((getObjectProperty(appData, 'chats')), async (item) => {


     return ((getObjectProperty(item, 'type')) == 'acceptedRequest' || (getObjectProperty(item, 'type')) == 'acceptedInvitation');
    }));
    appData['receivedChats'] = (await asyncListFilter(receivedChats, async (item) => {
       if ((getObjectProperty(item, 'deletedBySender')) || (getObjectProperty(item, 'deletedByReceiver'))) {
        if ((getObjectProperty((getObjectProperty(item, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'objectId'))) {
          return ((getObjectProperty(item, 'deletedBySender')) < (getObjectProperty((getObjectProperty(item, 'recentMessage')), 'created')));
        } else {
          return ((getObjectProperty(item, 'deletedByReceiver')) < (getObjectProperty((getObjectProperty(item, 'recentMessage')), 'created')));
        }
      } else {
        return item;
      }


     return ;
    }));
    if (!!(getObjectProperty(appData, 'receivedChats')).length) {
      appData['activityMessages'] = (await Backendless.Request.get(`${Backendless.appPath}/services/activityMessages/ActivityMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'whereClause': JSON.stringify((['objectId in (\'',((getObjectProperty(appData, 'receivedChats')).map(item => item['activityId'])).join('\',\''),'\')'].join(''))) }).send());
    } else {
      appData['activityMessages'] = [];
    }
    pageData['chats'] = (getObjectProperty(appData, 'chats'));
    pageData['receivedChats'] = (getObjectProperty(appData, 'receivedChats'));
    pageData['activityMessages'] = (getObjectProperty(appData, 'activityMessages'));
    appData['updateChatsOnResume'] = true;

  } catch (error) {
    console.log(error);

  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function likes() {
  if (!(getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'seenBy'))) {
    (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile'))['seenBy'] = [];
  }
  if ((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'seenBy')) || (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'seenBy')).length > 0) {
    pageData['seenByList'] = ((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'seenBy')).map(item => item['objectId']));
    if ((getObjectProperty(pageData, 'seenByList')).length > 21) {
      userSeenBy = (getObjectProperty(pageData, 'seenByList')).slice(0, 21);
      pageData['seenByList'] = (subsequenceFromStartLast((getObjectProperty(pageData, 'seenByList')), 20));
    } else {
      userSeenBy = (getObjectProperty(pageData, 'seenByList'));
      pageData['seenByList'] = [];
    }
    pageData['seenBy'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((userSeenBy.join('\',\''))) }).send());
    pageData['tab'] = 'seenBy';
    if ((getObjectProperty(pageData, 'seenBy')) && !!(getObjectProperty(pageData, 'seenBy')).length) {
      if (getObjectProperty(pageData, 'seenBy')) {
        var userResponce_list = (getObjectProperty(pageData, 'seenBy'));
        for (var userResponce_index in userResponce_list) {
          userResponce = userResponce_list[userResponce_index];
          var userJson_list = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'seenBy'));
          for (var userJson_index in userJson_list) {
            userJson = userJson_list[userJson_index];
            if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
              userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
            }
          }
        }
        pageData['seenBy'] = (await asyncListSort((getObjectProperty(pageData, 'seenBy')), -1, async (item) => {


         return (getObjectProperty(item, 'ts'));
        }));
      }
    }
  }
  if (!(getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'myLikes'))) {
    (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile'))['myLikes'] = [];
  }
  if ((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'myLikes')) && (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'myLikes')).length > 0) {
    query = ((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'myLikes')).map(item => item['objectId']));
    pageData['myLikes'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((query.join('\',\''))) }).send());
    if (getObjectProperty(pageData, 'myLikes')) {
      var userResponce_list2 = (getObjectProperty(pageData, 'myLikes'));
      for (var userResponce_index2 in userResponce_list2) {
        userResponce = userResponce_list2[userResponce_index2];
        var userJson_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'myLikes'));
        for (var userJson_index2 in userJson_list2) {
          userJson = userJson_list2[userJson_index2];
          if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
            userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
          }
        }
      }
      pageData['myLikes'] = (await asyncListSort((getObjectProperty(pageData, 'myLikes')), -1, async (item) => {


       return (getObjectProperty(item, 'ts'));
      }));
    }
  }
  if ((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likedBy')) && (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likedBy')).length > 0) {
    pageData['likedByList'] = ((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likedBy')).map(item => item['objectId']));
    if ((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likedBy')).length > 21) {
      likedBy = (getObjectProperty(pageData, 'likedByList')).slice(0, 21);
      pageData['likedByList'] = (subsequenceFromStartLast((getObjectProperty(pageData, 'likedByList')), 21));
    } else {
      likedBy = (getObjectProperty(pageData, 'likedByList'));
      pageData['likedByList'] = [];
    }
    pageData['likedBy'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((likedBy.join('\',\''))) }).send());
    if (getObjectProperty(pageData, 'likedBy')) {
      var userResponce_list3 = (getObjectProperty(pageData, 'likedBy'));
      for (var userResponce_index3 in userResponce_list3) {
        userResponce = userResponce_list3[userResponce_index3];
        var userJson_list3 = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likedBy'));
        for (var userJson_index3 in userJson_list3) {
          userJson = userJson_list3[userJson_index3];
          if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
            userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
          }
        }
      }
      pageData['likedBy'] = (await asyncListSort((getObjectProperty(pageData, 'likedBy')), -1, async (item) => {


       return (getObjectProperty(item, 'ts'));
      }));
    }
  }
  if (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likedActivities')) {
    likedActivities = ((getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), 'likedActivities')).map(item => item['objectId']));
    pageData['likesActivities'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivity/getActivities`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'objectId': JSON.stringify((likedActivities.join('\',\''))),'pageSize': 100,'relation': JSON.stringify((['category', 'author', 'author.userProfile.settings'].join(','))),'sort': JSON.stringify('activityDate DESC, ongoingTiming'),'whereClause': JSON.stringify((['visibility!=3 and activityStatus=true ',' and objectId in (\'',likedActivities.join('\',\''),'\') '].join(''))) }).send());
    if (!(getObjectProperty(pageData, 'likesActivities'))) {
      pageData['likesActivities'] = [];
    }
    if (!(getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'likesActivities'))) {
      (getObjectProperty(pageData, 'currentUser'))['likesActivities'] = [];
    }
  }
  appData['seenBy'] = (getObjectProperty(pageData, 'seenBy'));
  appData['myLikes'] = (getObjectProperty(pageData, 'myLikes'));
  appData['likedBy'] = (getObjectProperty(pageData, 'likedBy'));
  appData['likesActivities'] = (getObjectProperty(pageData, 'likesActivities'));
  await BackendlessUI.Functions.Custom['fn_45329afd4d1efc64364b4b6d45c9e02a'](pageData, appData);
}


  ;(async () => {
      console.log('_______updateDataOnResumeState');
    if (!(getObjectProperty(appData, 'currentUser')) && !(getObjectProperty(pageData, 'currentUser')) && !((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'))) {
      await BackendlessUI.Functions.Custom['fn_b60329368f595ebe51d195537c8a4735'](appData, pageData);
    } else if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
      if (!(getObjectProperty(appData, 'currentUser'))) {
        appData['currentUser'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
      }
      if (!(getObjectProperty(pageData, 'currentUser'))) {
        pageData['currentUser'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
      }
    }
    try {
      await getMessages();

    } catch (error) {
      console.log(error);

    }
    pageData['countOffset'] = 0;
    appData['activityListAllNew'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](pageData));
    appData['usersNew'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(pageData, 'currentUser')), (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'userProfile')), (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'searchFilter')), (getObjectProperty(pageData, 'pageSize')), pageData));
    try {
      await likes();

    } catch (error) {
      console.log(error);

    }
    console.log('________');

  })();

}

})
define('./functions/8102bf6f3d2ae8538ba8eb4128ef3e87/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87'] = async function fn_8102bf6f3d2ae8538ba8eb4128ef3e87(templateName, message, page, chatId, userId, activeTab, senderId, ownerId) {
var data;


  if (templateName == 'likes') {
    data = ({ [`message`]: message,[`userId`]: userId,[`activeTab`]: activeTab,[`senderId`]: senderId,[`ownerId`]: senderId });
  } else if (templateName == 'replies') {
    data = ({ [`message`]: message,[`page`]: page,[`chatId`]: chatId,[`userId`]: userId,[`senderId`]: senderId });
  } else {
    data = ({ [`message`]: message,[`page`]: page,[`chatId`]: chatId,[`userId`]: userId });
  }
  await Backendless.Messaging.pushWithTemplate(templateName, data);

}

})
define('./functions/84c67ace74fc2eddd48975c1e2e48199/code.js', () => { 

BackendlessUI.Functions.Custom['fn_84c67ace74fc2eddd48975c1e2e48199'] = async function fn_84c67ace74fc2eddd48975c1e2e48199(pageData, appData, object) {
var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(appData, 'activityList')) || (getObjectProperty(appData, 'activityListAll'))) {
    appData['activityList'] = (await asyncListFilter((getObjectProperty(appData, 'activityList')), async (item) => {


     return ((getObjectProperty(item, 'userProfileObjectId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) && !((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty(appData, 'authorObjectId')))));
    }));
    pageData['activityList'] = (getObjectProperty(appData, 'activityList'));
    appData['activityListAll'] = (getObjectProperty(appData, 'activityList'));
  } else {
    appData['activityList'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](pageData));
    pageData['activityList'] = (getObjectProperty(appData, 'activityList'));
    pageData['activityListAll'] = (getObjectProperty(appData, 'activityList'));
    appData['activityListAll'] = (getObjectProperty(appData, 'activityList'));
  }
  if (getObjectProperty(appData, 'users')) {
    appData['users'] = (await asyncListFilter((getObjectProperty(appData, 'users')), async (item) => {


     return ((getObjectProperty(item, 'userProfileId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')));
    }));
    pageData['users'] = (getObjectProperty(appData, 'users'));
  } else if (getObjectProperty(pageData, 'users')) {
    pageData['users'] = (await asyncListFilter((getObjectProperty(pageData, 'users')), async (item) => {


     return ((getObjectProperty(item, 'userProfileId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')));
    }));
    appData['users'] = (getObjectProperty(pageData, 'users'));
  }
  if (getObjectProperty(appData, 'seenBy')) {
    appData['seenBy'] = (await asyncListFilter((getObjectProperty(appData, 'seenBy')), async (item) => {


     return ((getObjectProperty(item, 'userProfileObjectId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) && !((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))));
    }));
    if (getObjectProperty(pageData, 'seenBy')) {
      pageData['seenBy'] = (getObjectProperty(appData, 'seenBy'));
    }
  }
  if (getObjectProperty(appData, 'myLikes')) {
    appData['myLikes'] = (await asyncListFilter((getObjectProperty(appData, 'myLikes')), async (item) => {


     return ((getObjectProperty(item, 'userProfileObjectId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) && !((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))));
    }));
    if (getObjectProperty(pageData, 'myLikes')) {
      pageData['myLikes'] = (getObjectProperty(appData, 'myLikes'));
    }
  }
  if (getObjectProperty(pageData, 'likedBy')) {
    pageData['likedBy'] = (await asyncListFilter((getObjectProperty(pageData, 'likedBy')), async (item) => {


     return ((getObjectProperty(item, 'userProfileObjectId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) && !((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))));
    }));
  }
  if (getObjectProperty(pageData, 'likesActivities')) {
    pageData['likesActivities'] = (await asyncListFilter((getObjectProperty(pageData, 'likesActivities')), async (item) => {


     return ((getObjectProperty(item, 'userProfileObjectId')) != (getObjectProperty((getObjectProperty(object, 'data')), 'parentObjectId')) && !((getObjectProperty((getObjectProperty(object, 'data')), 'children')).includes((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'objectId')))));
    }));
  }

}

})
define('./functions/8c410f7c55d946be06c4e40322722e41/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41'] = async function fn_8c410f7c55d946be06c4e40322722e41(propertyList, propertyName, determiner, and, id, x) {
var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (propertyList) {
    if (!!propertyList.length) {
      return ([' ',and,' (',(await Promise.all(propertyList.map(async item => {; return ([propertyName,(getObjectProperty(item, id)),x].join(''));}))).join(determiner),')',' '].join(''));
    } else {
      return ;
    }
  }

return 
}

})
define('./functions/8e282241fdc37b3b4d15125f65e24656/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8e282241fdc37b3b4d15125f65e24656'] = function fn_8e282241fdc37b3b4d15125f65e24656(inner, size) {
var widthElem;


  widthElem = size;

return widthElem
}

})
define('./functions/8ee7c112c28a73c6a512f0080e38e44d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_8ee7c112c28a73c6a512f0080e38e44d'] = async function fn_8ee7c112c28a73c6a512f0080e38e44d(appData) {
var error, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if (!((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'))) {
      localStorage.setItem('profilesData', JSON.stringify((await Backendless.Request.get(`${Backendless.appPath}/services/ProfilesTableData/profilesTableData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send())));
    }
    if (!(getObjectProperty(appData, 'profilesData'))) {
      appData['profilesData'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'));
      var j_list = (Object.keys((getObjectProperty(appData, 'profilesData'))));
      for (var j_index in j_list) {
        j = j_list[j_index];
        appData[j] = (getObjectProperty((getObjectProperty(appData, 'profilesData')), j));
      }
    }

  } catch (error) {
    console.log('Error from  getProfilesTableData func');
    console.log(error);

  }

}

})
define('./functions/90729fb61be96ffcf74a9622259d0dc4/code.js', () => { 

BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4'] = async function fn_90729fb61be96ffcf74a9622259d0dc4(eventName) {
var dataForMobileApp, hasPhotos, gender, age, currentUser, userAge;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  if (currentUser) {
    userAge = (await (async function(year, month, day) {
    	let now = new Date();
    	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    	let dob = new Date(year, month, day);

    	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

    	let age;

    	age = today.getFullYear() - dob.getFullYear();

    	if (today < dobnow) {
    	  age = age-1;
    	} else {
    	  age = age
    	}

    	return age

    })((new Date((getObjectProperty(currentUser, 'birthDate'))).getFullYear()), (new Date((getObjectProperty(currentUser, 'birthDate'))).getMonth()), (new Date((getObjectProperty(currentUser, 'birthDate'))).getDate())));
    if (userAge >= 18 && userAge <= 19) {
      age = '18–19';
    } else if (userAge >= 20 && userAge <= 24) {
      age = '20–24';
    } else if (userAge >= 25 && userAge <= 34) {
      age = '25–34';
    } else if (userAge >= 35 && userAge <= 44) {
      age = '35–44';
    } else if (userAge >= 45 && userAge <= 54) {
      age = '45–54';
    } else if (userAge >= 55 && userAge <= 64) {
      age = '55–64';
    } else if (userAge >= 65 && userAge <= 74) {
      age = '65–74';
    } else if (userAge >= 75 && userAge <= 84) {
      age = '75–84';
    } else if (userAge >= 85) {
      age = '85+';
    }
    gender = (getObjectProperty(currentUser, 'gender'));
    if ((getObjectProperty(currentUser, 'userProfile')) && (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'media'))) {
      hasPhotos = !!(getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'media')).length ? 'yes' : 'no';
    } else {
      hasPhotos = 'no';
    }
    if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
      dataForMobileApp = ({ [`name`]: eventName,[`parameters`]: ({ [`age`]: age,[`gender`]: gender,[`hasPhoto`]: hasPhotos }) });
      await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('LOG_FIREBASE_ANALYTICS_EVENT', dataForMobileApp);
    } else {
      await (async function(event, age, gender, hasPhotos) {
      	gtag('event', event, {
      	  'age': age,
      	  'gender': gender,
      	  'hasPhotos': hasPhotos,
      	  'platform': 'web'
      	});
      })(eventName, age, gender, hasPhotos);
    }
  } else {
    if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
      dataForMobileApp = ({ [`name`]: eventName,[`parameters`]: ({  }) });
      await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('LOG_FIREBASE_ANALYTICS_EVENT', dataForMobileApp);
    } else {
      await (async function(event) {
      	gtag('event', event, {
      	  'platform': 'web'
      	});
      })(eventName);
    }
  }

}

})
define('./functions/9ac46285dc248a0bb09c5664daf2c6f6/code.js', () => { 

BackendlessUI.Functions.Custom['fn_9ac46285dc248a0bb09c5664daf2c6f6'] = function fn_9ac46285dc248a0bb09c5664daf2c6f6(testInput) {
return 'ok'
}

})
define('./functions/a54cd48df219fcf28293b9e3e089975d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a54cd48df219fcf28293b9e3e089975d'] = async function fn_a54cd48df219fcf28293b9e3e089975d(AppData, pageData, chatId, popupText) {
  pageData['getChat'] = chatId;
  AppData['showPopup'] = true;
  AppData['newMessageText'] = popupText;
  await new Promise(r => setTimeout(r, 7000 || 0));
  delete AppData['showPopup'];

}

})
define('./functions/a6239c5e9d268c5cd33796f8bd05f661/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a6239c5e9d268c5cd33796f8bd05f661'] = async function fn_a6239c5e9d268c5cd33796f8bd05f661(x) {
var item, distance;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  distance = (await (async function(pointLat, pointLng, centerLat, centerLng) {
  	  const earthRadiusM = 3958.8;

  	  const dLat = (centerLat-pointLat) * Math.PI / 180;
  	  const dLon = (centerLng-pointLng) * Math.PI / 180;

  	  pointLat = pointLat * Math.PI / 180;
  	  centerLat = centerLat * Math.PI / 180;

  	  const a = Math.sin(dLat/2) * Math.sin(dLat/2) + Math.sin(dLon/2) * Math.sin(dLon/2) * Math.cos(pointLat) * Math.cos(centerLat);
  	  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1-a));
  	  return earthRadiusM * c;


  })((getObjectProperty((getObjectProperty(x, 'userLocation')), 'latitude')), (getObjectProperty((getObjectProperty(x, 'userLocation')), 'longitude')), (getObjectProperty((getObjectProperty(item, 'center')), 'lat')), (getObjectProperty((getObjectProperty(item, 'center')), 'lng'))));
  if ((await (async function(radius, newRadius) {
  	if (newRadius <= radius ) {
  	    //point is inside the circle
  	    return true;
  	}
  	else if (newRadius > radius) {
  	    //point is outside the circle
  	    return false;
  	}
  })((getObjectProperty(x, 'radius')), distance))) {
    return item;
  }

return 
}

})
define('./functions/a75f6a563aabaeda5a92d8c6a6055093/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a75f6a563aabaeda5a92d8c6a6055093'] = async function fn_a75f6a563aabaeda5a92d8c6a6055093(userId) {
var isServiceAvailable;


  if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((userId.split('-').slice(-1)[0]))) == 'enabled') {
    isServiceAvailable = true;
  } else {
    if ((await Backendless.Request.get(`${Backendless.appPath}/services/serviceAvailability/checkServiceAvailability`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send())) {
      localStorage.setItem((userId.split('-').slice(-1)[0]), JSON.stringify('enabled'));
      isServiceAvailable = true;
    } else {
      isServiceAvailable = false;
    }
  }

return isServiceAvailable
}

})
define('./functions/a981d7d7f97db90c49ec67e3b7d11474/code.js', () => { 

BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474'] = async function fn_a981d7d7f97db90c49ec67e3b7d11474(userProfile, context) {
var logMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getProfileId() {
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
    if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'userProfile')), 'objectId'))) {
      userProfile['objectId'] = (getObjectProperty((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'userProfile')), 'objectId'));
      logMessage = 'Profile id was taken from LS';
    } else {
      userProfile['objectId'] = (getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/userProfile/userProfile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), 'objectId'));
      logMessage = 'Profile id was taken from API service';
    }
  } else {
    userProfile['objectId'] = (getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/userProfile/userProfile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), 'objectId'));
    logMessage = 'Profile id was taken from API service';
  }
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function logBug() {
  console.log('***************************************************');
  console.log('**********   Trying update profile without ID     *********');
  console.log('***************************************************');
  await Backendless.Files.saveFile(encodePath('/testLogSaveProfile'), ([(new Date((new Date())).getHours()),'_',(new Date((new Date())).getMinutes()),'_',(new Date((new Date())).getDate()),'.txt'].join('')), ([((new Date()).toDateString()),' ',((new Date()).toLocaleTimeString()),'\r\n',logMessage,'\r\n','Profile:  ',(JSON.stringify(userProfile)),'\r\n','Page:  ',context,'\r\n','UserId:   ',(await Backendless.UserService.getCurrentUser(false)) != null ? (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')) : 'No user'].join('')), true);
}


  if (userProfile) {
    if (!(getObjectProperty(userProfile, 'objectId'))) {
      await getProfileId();
      await logBug();
    }
    await Backendless.Data.of('UserProfile').save( userProfile );
  } else {
    logMessage = 'No profile';
    await logBug();
  }

}

})
define('./functions/ad89afb73ebab1c1c7a57aa8e307f1d5/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ad89afb73ebab1c1c7a57aa8e307f1d5'] = function fn_ad89afb73ebab1c1c7a57aa8e307f1d5(stylesUserLogin, stylesUserAge, isOpenFullList, userLogin) {
var fontSizeName, fontSizeAge;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (isOpenFullList) {
    stylesUserLogin['fontSize'] = '20px';
    stylesUserAge['fontSize'] = '20px';
  } else {
    if (getValueLength(userLogin) >= 7) {
      fontSizeName = Math.round(20 - 0.3 * getValueLength(userLogin));
      fontSizeAge = Math.round(20 - 0.3 * getValueLength(userLogin));
      stylesUserLogin['fontSize'] = (String(fontSizeName / 16) + String('em'));
      stylesUserAge['fontSize'] = (String(fontSizeName / 16) + String('em'));
    }
  }

}

})
define('./functions/b60329368f595ebe51d195537c8a4735/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b60329368f595ebe51d195537c8a4735'] = async function fn_b60329368f595ebe51d195537c8a4735(pageData, appData) {
var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function setSearchFilters() {
  if (!(getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'bodyType')) || !(Array.isArray((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'bodyType'))))) {
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['bodyType'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'bodyTypeJson')) ? (await asyncListFilter((getObjectProperty(appData, 'bodyTypeList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'bodyTypeJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['drink'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'drinkJson')) ? (await asyncListFilter((getObjectProperty(appData, 'drinkList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'drinkJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['dietaryPreference'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'dietaryPreferenceJson')) ? (await asyncListFilter((getObjectProperty(appData, 'dietaryList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'dietaryPreferenceJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['education'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'educationJson')) ? (await asyncListFilter((getObjectProperty(appData, 'educationList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'educationJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['ethnicity'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'ethnicityJson')) ? (await asyncListFilter((getObjectProperty(appData, 'ethnicityList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'ethnicityJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['hairColor'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'hairColorJson')) ? (await asyncListFilter((getObjectProperty(appData, 'hairColorList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'hairColorJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['maritalStatus'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'maritalStatusJson')) ? (await asyncListFilter((getObjectProperty(appData, 'statusList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'maritalStatusJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['political'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'politicalJson')) ? (await asyncListFilter((getObjectProperty(appData, 'politicalList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'politicalJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['religion'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'religionJson')) ? (await asyncListFilter((getObjectProperty(appData, 'religionList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'religionJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['sexOrientation'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'sexOrientationJson')) ? (await asyncListFilter((getObjectProperty(appData, 'orientationList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'sexOrientationJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))['smoke'] = ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'smokeJson')) ? (await asyncListFilter((getObjectProperty(appData, 'smokeList')), async (item) => {


     return ((getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter')), 'smokeJson')).includes((getObjectProperty(item, 'id'))));
    })) : []);
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(appData, 'currentUser'))));
  }
}


  appData['currentUser'] = (await Backendless.UserService.getCurrentUser(true));
  (getObjectProperty(appData, 'currentUser'))['searchFilter'] = (await Backendless.Request.get(`${Backendless.appPath}/services/searchFilter/searchFilter`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  if (!(getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))) {
    (getObjectProperty(appData, 'currentUser'))['searchFilter'] = (await Backendless.Data.of('UserSearchFilter').save( ({ [`bodyTypeJson`]: [],[`drinkJson`]: [],[`educationJson`]: [],[`ethnicityJson`]: [],[`hairColorJson`]: [],[`maritalStatusJson`]: [],[`politicalJson`]: [],[`religionJson`]: [],[`sexOrientationJson`]: [],[`smokeJson`]: [],[`dietaryPreferenceJson`]: [] }) ));
    await Backendless.Data.of('Users').setRelation((getObjectProperty(appData, 'currentUser')), 'searchFilter', [(getObjectProperty((getObjectProperty(appData, 'currentUser')), 'searchFilter'))]);
  }
  (getObjectProperty(appData, 'currentUser'))['userProfile'] = (await Backendless.Request.get(`${Backendless.appPath}/services/userProfile/userProfile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  if (!(getObjectProperty((getObjectProperty(appData, 'currentUser')), 'userProfile'))) {
    (getObjectProperty(appData, 'currentUser'))['userProfile'] = (await Backendless.Data.of('UserProfile').save( ({ [`likedActivities`]: [],[`myLikes`]: [],[`likedBy`]: [],[`seenBy`]: [],[`media`]: [],[`blockListJson`]: [],[`hasPermissionJson`]: [],[`myInterestsJson`]: [],[`searchedInterestsJson`]: [] }) ));
    await Backendless.Data.of('Users').setRelation((getObjectProperty(appData, 'currentUser')), 'userProfile', [(getObjectProperty((getObjectProperty(appData, 'currentUser')), 'userProfile'))]);
  }
  (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'userProfile'))['lastUsedServiceArea'] = ({ [`center`]: (getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'userProfile')), 'center')),[`lastUsedServiceAreaName`]: (getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'userProfile')), 'lastUsedServiceAreaName')),[`lastUsedServiceObjectId`]: (getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'userProfile')), 'lastUsedServiceObjectId')),[`radius`]: (getObjectProperty((getObjectProperty((getObjectProperty(appData, 'currentUser')), 'userProfile')), 'radius')) });
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(appData, 'currentUser'))));
  appData['login'] = (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'login'));
  appData['name'] = (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'name'));
  appData['photo'] = (getObjectProperty((getObjectProperty(appData, 'currentUser')), 'photoThumbnail'));
  await setSearchFilters();

}

})
define('./functions/b7bed1b964e9034a97b47d4f7ba72369/code.js', () => { 

BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369'] = function fn_b7bed1b964e9034a97b47d4f7ba72369(messages, currentUserId) {
var counter, chat, activity;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  counter = 0;
  var activity_list = (getObjectProperty((getObjectProperty(messages, 'chats')), 'byMe'));
  for (var activity_index in activity_list) {
    activity = activity_list[activity_index];
    var chat_list = (getObjectProperty(activity, 'chats'));
    for (var chat_index in chat_list) {
      chat = chat_list[chat_index];
      if (currentUserId == (getObjectProperty((getObjectProperty((getObjectProperty(chat, 'recentMessage')), 'receiver')), 'objectId')) && !(getObjectProperty(chat, 'chatIsRead'))) {
        counter = (typeof counter == 'number' ? counter : 0) + 1;
      }
    }
  }
  var activity_list2 = (getObjectProperty((getObjectProperty(messages, 'chats')), 'byOthers'));
  for (var activity_index2 in activity_list2) {
    activity = activity_list2[activity_index2];
    if (currentUserId == (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(activity, 'chat')), 'recentMessage')), 'receiver')), 'objectId')) && !(getObjectProperty((getObjectProperty(activity, 'chat')), 'chatIsRead'))) {
      counter = (typeof counter == 'number' ? counter : 0) + 1;
    }
  }
  var chat_list2 = (getObjectProperty((getObjectProperty(messages, 'invitations')), 'received'));
  for (var chat_index2 in chat_list2) {
    chat = chat_list2[chat_index2];
    if (!(getObjectProperty(chat, 'chatIsRead'))) {
      counter = (typeof counter == 'number' ? counter : 0) + 1;
    }
  }

return counter
}

})
define('./functions/bab1f0b5ad1751b1ff61bf156822e044/code.js', () => { 

BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'] = async function fn_bab1f0b5ad1751b1ff61bf156822e044(data, appData) {
var drink, smoke, hairColor, politicalView, bodyTypes, education, sexualOrientation, religion, ethnicity, children, maritalStatus, height, gender, age;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 500 || 0));
  if ((getObjectProperty(data, 'ageFrom')) || (getObjectProperty(data, 'ageTo'))) {
    if ((getObjectProperty(data, 'ageFrom')) == 18 && (getObjectProperty(data, 'ageTo')) == 100) {
      age = '';
    } else {
      age = [' and year(birthDate) >= ',(new Date((new Date())).getFullYear()) - (getObjectProperty(data, 'ageTo')),' and ','year(birthDate) <= ',(new Date((new Date())).getFullYear()) - (getObjectProperty(data, 'ageFrom'))].join('');
    }
  } else {
    age = '';
  }
  if (!(getObjectProperty(data, 'genderCheckbox'))) {
    if ((getObjectProperty(data, 'gender')) && (getObjectProperty(data, 'gender')).length > 0) {
      gender = [' and gender in (\'',(getObjectProperty(data, 'gender')).join('\',\''),'\') '].join('');
    } else {
      gender = '';
    }
  } else {
    gender = '';
  }
  if (!(getObjectProperty(data, 'heightCheckbox'))) {
    if (getObjectProperty(data, 'heightDataTaller')) {
      height = [' and ','userProfile.height >= ',(getObjectProperty(data, 'height'))].join('');
    } else if (getObjectProperty(data, 'heightDataSmaller')) {
      height = [' and ','userProfile.height <= ',(getObjectProperty(data, 'height'))].join('');
    } else if (!(getObjectProperty(data, 'heightData'))) {
      height = '';
    }
  } else {
    height = '';
  }
  if (!(getObjectProperty(data, 'maritalStatusCheckbox'))) {
    if ((getObjectProperty(data, 'maritalStatusId')) && (getObjectProperty(data, 'maritalStatusId')).length > 0) {
      maritalStatus = [' and ','userProfile.maritalStatus in (',(getObjectProperty(data, 'maritalStatusId')).join(','),') '].join('');
    } else {
      maritalStatus = ' ';
    }
  } else {
    maritalStatus = ' ';
  }
  if (!(getObjectProperty(data, 'childrenCheckbox'))) {
    if (getObjectProperty(data, 'children')) {
      children = [' and ','userProfile.children in (',(getObjectProperty(data, 'children')),') '].join('');
    } else {
      children = '';
    }
  } else {
    children = '';
  }
  if (!(getObjectProperty(data, 'ethnicityCheckbox'))) {
    if ((getObjectProperty(data, 'ethnicityId')) && (getObjectProperty(data, 'ethnicityId')).length > 0) {
      ethnicity = [' and ','userProfile.ethnicity in (',(getObjectProperty(data, 'ethnicityId')).join(','),') '].join('');
      if ((getObjectProperty(data, 'ethnicityId')).length == (getObjectProperty(appData, 'ethnicityList')).length) {
        ethnicity = '';
      }
    } else {
      ethnicity = '';
    }
  } else {
    ethnicity = '';
  }
  if (!(getObjectProperty(data, 'religionCheckbox'))) {
    if ((getObjectProperty(data, 'religionId')) && (getObjectProperty(data, 'religionId')).length > 0) {
      religion = [' and ','userProfile.religion in (',(getObjectProperty(data, 'religionId')).join(','),') '].join('');
      if ((getObjectProperty(data, 'religionId')).length == (getObjectProperty(appData, 'religionList')).length) {
        religion = '';
      }
    } else {
      religion = '';
    }
  } else {
    religion = '';
  }
  if (!(getObjectProperty(data, 'sexualidentityCheckbox'))) {
    if ((getObjectProperty(data, 'sexualidentityId')) && (getObjectProperty(data, 'sexualidentityId')).length > 0) {
      sexualOrientation = [' and ','userProfile.sexOrientation in (',(getObjectProperty(data, 'sexualidentityId')).join(','),') '].join('');
      if ((getObjectProperty(data, 'sexualidentityId')).length == (getObjectProperty(appData, 'orientationList')).length) {
        sexualOrientation = '';
      }
    } else {
      sexualOrientation = '';
    }
  } else {
    sexualOrientation = '';
  }
  if (!(getObjectProperty(data, 'educationCheckbox'))) {
    if ((getObjectProperty(data, 'educationId')) && (getObjectProperty(data, 'educationId')).length > 0) {
      education = [' and ','userProfile.educationLevel in (',(getObjectProperty(data, 'educationId')).join(','),') '].join('');
      if ((getObjectProperty(data, 'educationId')).length == (getObjectProperty(appData, 'educationList')).length) {
        education = '';
      }
    } else {
      education = '';
    }
  } else {
    education = '';
  }
  if (!(getObjectProperty(data, 'bodyTypeCheckbox'))) {
    if ((getObjectProperty(data, 'bodyTypeObjects')) && (getObjectProperty(data, 'bodyTypeObjects')).length > 0) {
      bodyTypes = [' and ','userProfile.bodyType in (',(getObjectProperty(data, 'bodyTypeObjects')).join(','),') '].join('');
      if ((getObjectProperty(data, 'bodyTypeObjects')).length == (getObjectProperty(appData, 'bodyTypeList')).length) {
        bodyTypes = '';
      }
    } else {
      bodyTypes = '';
    }
  } else {
    bodyTypes = '';
  }
  if (!(getObjectProperty(data, 'politicalViewCheckbox'))) {
    if ((getObjectProperty(data, 'politicalViewId')) && (getObjectProperty(data, 'politicalViewId')).length > 0) {
      politicalView = [' and ','userProfile.politicalView in (',(getObjectProperty(data, 'politicalViewId')).join(','),') '].join('');
      if ((getObjectProperty(data, 'politicalViewId')).length == (getObjectProperty(appData, 'politicalList')).length) {
        politicalView = '';
      }
    } else {
      politicalView = '';
    }
  } else {
    politicalView = '';
  }
  if (!(getObjectProperty(data, 'hairColorCheckbox'))) {
    if ((getObjectProperty(data, 'hairColorId')) && (getObjectProperty(data, 'hairColorId')).length > 0) {
      hairColor = [' and ','userProfile.hairColor in (',(getObjectProperty(data, 'hairColorId')).join(','),') '].join('');
      if ((getObjectProperty(data, 'hairColorId')).length == (getObjectProperty(appData, 'hairColorList')).length) {
        hairColor = '';
      }
    } else {
      hairColor = '';
    }
  } else {
    hairColor = '';
  }
  if (!(getObjectProperty(data, 'smokeCheckbox'))) {
    if ((getObjectProperty(data, 'smokeId')) && (getObjectProperty(data, 'smokeId')).length > 0) {
      smoke = [' and ','userProfile.smoke in (',(getObjectProperty(data, 'smokeId')).join(','),') '].join('');
      if ((getObjectProperty(data, 'smokeId')).length == (getObjectProperty(appData, 'smokeList')).length) {
        smoke = '';
      }
    } else {
      smoke = '';
    }
  } else {
    smoke = '';
  }
  if (!(getObjectProperty(data, 'drinkCheckbox'))) {
    if ((getObjectProperty(data, 'drinkId')) && (getObjectProperty(data, 'drinkId')).length > 0) {
      drink = [' and ','userProfile.drink in (',(getObjectProperty(data, 'drinkId')).join(','),') '].join('');
      if ((getObjectProperty(data, 'drinkId')).length == (getObjectProperty(appData, 'drinkList')).length) {
        drink = '';
      }
    } else {
      drink = '';
    }
  } else {
    drink = '';
  }
  data['count'] = (await Backendless.Request.get(`${Backendless.appPath}/services/potentialMatches/getUsersCount`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'whereClause': JSON.stringify((['objectId != null',age,gender,height,maritalStatus,children,ethnicity,religion,sexualOrientation,education,bodyTypes,politicalView,hairColor,smoke,drink].join(''))) }).send());
  await new Promise(r => setTimeout(r, 500 || 0));

}

})
define('./functions/bf1fe4681c7578f8420691da33164325/code.js', () => { 

BackendlessUI.Functions.Custom['fn_bf1fe4681c7578f8420691da33164325'] = function fn_bf1fe4681c7578f8420691da33164325(data) {
var currentYear, currentMonthIndex, months, currentMonth;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentYear = (new Date((new Date())).getFullYear());
  currentMonthIndex = (new Date((new Date())).getMonth()) + 1;
  months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
  currentMonth = months[(currentMonthIndex - 1)];
  data['basicMonth'] = currentMonthIndex;
  data['calendarData'] = ({  });
  (getObjectProperty(data, 'calendarData'))[currentYear] = ({  });
  data['months'] = months;
  data['month'] = currentMonthIndex;
  data['year'] = currentYear;

}

})
define('./functions/c335db4194025bb2dd974bfd09c53ebb/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'] = async function fn_c335db4194025bb2dd974bfd09c53ebb(classList) {
function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ;(async () => {
      if (!(classList.includes('alert-block'))) {
      addItemToList(classList, 'alert-block');
    }
    await new Promise(r => setTimeout(r, 2000 || 0));
    if (classList.slice(-1)[0] == 'alert-block') {
      classList.pop();
    }

  })();

}

})
define('./functions/c3e522be76839721882205a107595563/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'] = async function fn_c3e522be76839721882205a107595563(context) {
var user, profileId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  user = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  if (user && (getObjectProperty(user, 'userProfile'))) {
    if (getObjectProperty((getObjectProperty(user, 'userProfile')), 'objectId')) {
      return user;
    } else {
      console.log('***************************************************');
      console.log('**********   User profile without ID     *********');
      console.log('***************************************************');
      profileId = (getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/userProfile/userProfile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send()), 'objectId'));
      (getObjectProperty(user, 'userProfile'))['objectId'] = profileId;
      localStorage.setItem('currentUser', JSON.stringify(user));
      await Backendless.Files.saveFile(encodePath('/testLog'), ([(new Date((new Date())).getHours()),'_',(new Date((new Date())).getMinutes()),'_',(new Date((new Date())).getDate()),'.txt'].join('')), ([((new Date()).toDateString()),' ',((new Date()).toLocaleTimeString()),'\r\n',context,'\r\n','userId: ',(getObjectProperty(user, 'objectId')),'\r\n','profileId: ',profileId].join('')), false);
      return user;
    }
  }

return user
}

})
define('./functions/c52974435ae439961137e54a2d451282/code.js', () => { 

BackendlessUI.Functions.Custom['fn_c52974435ae439961137e54a2d451282'] = async function fn_c52974435ae439961137e54a2d451282(userId) {
var shortUserId, activitiesCount;


  shortUserId = userId.split('-').slice(-1)[0];
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String(shortUserId) + String('_viewEnabled')))) {
    return true;
  }
  localStorage.setItem((String(shortUserId) + String('_viewCounter')), JSON.stringify(((((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String(shortUserId) + String('_viewCounter')))) ? ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String(shortUserId) + String('_viewCounter')))) : 0) + 1)));
  if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String(shortUserId) + String('_viewCounter')))) > 5) {
    activitiesCount = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivities/CurrentUserActivitiesCount`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    if (activitiesCount > 0) {
      localStorage.removeItem((String(shortUserId) + String('_viewCounter')));
      localStorage.setItem((String(shortUserId) + String('_viewEnabled')), JSON.stringify(true));
      return true;
    } else {
      return false;
    }
  } else {
    return true;
  }

return 
}

})
define('./functions/cafad29ad5fef5a558c351332414f639/code.js', () => { 

BackendlessUI.Functions.Custom['fn_cafad29ad5fef5a558c351332414f639'] = async function fn_cafad29ad5fef5a558c351332414f639(pageData, appData, filterDataContainer, genderRepeater) {
var updatedSearchFilter, newGenderList, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  newGenderList = (await Promise.all((await asyncListFilter(genderRepeater, async (item) => {


   return (getObjectProperty(item, 'isChecked'));
  })).map(async item => {; return (getObjectProperty(item, 'label'));})));
  (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'searchFilter'))['gender'] = newGenderList;
  filterDataContainer['gender'] = newGenderList;
  (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'searchFilter'))['financialRole'] = (getObjectProperty(filterDataContainer, 'financialRole'));
  appData['currentUser'] = (getObjectProperty(pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(appData, 'currentUser'))));
  delete appData['users'];
  delete appData['activityList'];
  if (getObjectProperty(pageData, 'resetFilters')) {
    delete appData['filtersActivitiesAdded'];
    delete appData['filtersProfilesAdded'];
    delete pageData['resetFilters'];
  }
  ;(async () => {
      if (getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'searchFilter')) {
      updatedSearchFilter = (getObjectProperty((getObjectProperty((getObjectProperty(pageData, 'currentUser')), 'searchFilter')), 'objectId'));
      await Backendless.Data.of('UserSearchFilter').bulkUpdate( (['objectId=\'',updatedSearchFilter,'\''].join('')), filterDataContainer );
    }

  })();

}

})
define('./functions/d412eac4160659791c47d3aec2497977/code.js', () => { 

BackendlessUI.Functions.Custom['fn_d412eac4160659791c47d3aec2497977'] = function fn_d412eac4160659791c47d3aec2497977(object, option, and, math) {
  if (object) {
    return (['',and,option,math,''].join(''));
  }

return 
}

})
define('./functions/e28b55c91a3fb8f8238d5da2a4f7515c/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e28b55c91a3fb8f8238d5da2a4f7515c'] = function fn_e28b55c91a3fb8f8238d5da2a4f7515c(pageData, activity, chat) {
var activitiesHaveNewMessage, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(chat, 'recentMessage'))['isRead'] = true;
  pageData['countMessages'] = ((getObjectProperty(pageData, 'countMessages')) - 1);
  activity['newMessageCount'] = ((getObjectProperty(activity, 'newMessageCount')) - 1);
  chat['chatIsRead'] = true;
  var j_list = (getObjectProperty(pageData, 'myActivities'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    activitiesHaveNewMessage = false;
    if (getObjectProperty(j, 'newMessageCount')) {
      activitiesHaveNewMessage = true;
      break;
    }
  }
  pageData['newMessagesMyActivities'] = activitiesHaveNewMessage;

}

})
define('./functions/e6838df71af3b86c75934ac7bf79c8b1/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'] = async function fn_e6838df71af3b86c75934ac7bf79c8b1(data) {
var countRead;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(data, 'openMessage')) && !!(getObjectProperty((getObjectProperty(data, 'openMessage')), 'message')).length) {
    countRead = (await Backendless.Request.put(`${Backendless.appPath}/services/updateMessageStatus/updateMessageStatus`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['chatId=\'',(getObjectProperty((getObjectProperty(data, 'openMessage')), 'objectId')),'\' and receiver=\'',(getObjectProperty(data, 'currentUser')) ? (getObjectProperty((getObjectProperty(data, 'currentUser')), 'objectId')) : (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')),'\' and isRead=false'].join('')),'changes': ({ [`isRead`]: true }) }));
  }

}

})
define('./functions/e97140c64a3efafdbfb71077439f3811/code.js', () => { 

BackendlessUI.Functions.Custom['fn_e97140c64a3efafdbfb71077439f3811'] = async function fn_e97140c64a3efafdbfb71077439f3811() {
var error;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getDeviceSubscriptions() { return getSubscriptionsManager('deviceSubscriptions');}


  try {
    if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
      getDeviceSubscriptions().remove('onTapPushAction');
      getDeviceSubscriptions().remove('handleInactiveState');
      getDeviceSubscriptions().remove('handleResumeState');
      await ( async function () { return BackendlessUI.DeviceAPI.unregisterDevice() })();
    }

  } catch (error) {
    console.log(error);

  }
  await Backendless.UserService.logout();
  Backendless.setCurrentUserToken(null);
  localStorage.removeItem('messages');
  localStorage.removeItem('currentUser');
  localStorage.removeItem('tooltipInfo');
  localStorage.removeItem('userLocationInfo');
  localStorage.removeItem('country');
  localStorage.removeItem('lastChatInfoUpdate');
  localStorage.removeItem('tempFilters');
  localStorage.removeItem('Backendless');

}

})
define('./functions/ead80f47f298b9a953c7346e7d3a663d/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ead80f47f298b9a953c7346e7d3a663d'] = async function fn_ead80f47f298b9a953c7346e7d3a663d(tableName) {
return (await Backendless.Request.get(`${Backendless.appPath}/services/profilesData/ProfilesData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify(tableName) }).send())
}

})
define('./functions/f19ee1336b67ca26c4d92a38762420fa/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f19ee1336b67ca26c4d92a38762420fa'] = function fn_f19ee1336b67ca26c4d92a38762420fa(message) {
var time, minutes, hours, created;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (message) {
    created = (new Date((getObjectProperty(message, 'created'))));
    if ((new Date(created).getHours()) < 10) {
      hours = String(0) + String(new Date(created).getHours());
    } else {
      hours = (new Date(created).getHours());
    }
    if ((new Date(created).getMinutes()) < 10) {
      minutes = String(0) + String(new Date(created).getMinutes());
    } else {
      minutes = (new Date(created).getMinutes());
    }
    if (hours <= 12) {
      time = [hours,':',minutes,' am'].join('');
    } else {
      time = [hours - 12,':',minutes,' pm'].join('');
    }
  }

return time
}

})
define('./functions/f8564041e56be4dc88360dd95c938941/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f8564041e56be4dc88360dd95c938941'] = function fn_f8564041e56be4dc88360dd95c938941(object, propertyName, and, isString) {
  if (object) {
    return ([' ',and,' (',propertyName,object,isString,')',' '].join(''));
  }

return 
}

})
define('./functions/f918007d700c69eceb3445db5ba65eec/code.js', () => { 

BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec'] = async function fn_f918007d700c69eceb3445db5ba65eec(currentUser, userProfile, dataContainer, pageSize, data) {
var ageMax, ageMin, argname, blockList, bodyType, dateFrom, dateTo, delimeter, dietaryPreference, drink, education, ethnicity, gender, hairColor, item, j, like, location2, maritalStatus, pageOffset, political, proplist, religion, responce, searchInput, sexOrientation, smoke, userLikedProfiles;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function get_text_from_list(argname, delimeter) {
  if ((getObjectProperty(data, argname)) && (getObjectProperty(data, argname)).length > 0) {
    return ((getObjectProperty(data, argname)).join(delimeter));
  }
}

/**
 * Describe this function...
 */
async function filter(proplist) {
  if (proplist) {
    if (!!proplist.length) {
      return ([' and',' (',(await Promise.all(proplist.map(async item => {; return (['( jsoncontains(userProfile.dietaryPreferenceJson, \'',item,'\' ) = ',1,') '].join(''));}))).join(' or '),')',' '].join(''));
    } else {
      return ;
    }
  }
}


  if ((getObjectProperty(data, 'searchInput')) && getValueLength((getObjectProperty(data, 'searchInput'))) > 0) {
    searchInput = [' and (nameLogin like \'%',(getObjectProperty(data, 'searchInput')).trim(),'%\' or userProfile.aboutShort like \'%',(getObjectProperty(data, 'searchInput')).trim(),'%\')'].join('');
  }
  if (getObjectProperty(data, 'countOffset')) {
    pageOffset = (getObjectProperty(data, 'countOffset')) * pageSize + 1;
  } else {
    pageOffset = 1;
  }
  gender = await get_text_from_list('currentUser.searchFilter.gender', '\',\'');
  if ((getObjectProperty(userProfile, 'blockListJson')) && !!(getObjectProperty(userProfile, 'blockListJson')).length) {
    blockList = ({ [`blockListJson`]: (getObjectProperty(userProfile, 'blockListJson')) });
  } else {
    blockList = null;
  }
  if ((getObjectProperty(userProfile, 'myLikes')) && !!(getObjectProperty(userProfile, 'myLikes')).length) {
    userLikedProfiles = (JSON.stringify(((getObjectProperty(userProfile, 'myLikes')).map(item => item['objectId']))));
  } else {
    userLikedProfiles = null;
  }
  if ((getObjectProperty(userProfile, 'locationGeoPoint')) && (getObjectProperty((getObjectProperty(userProfile, 'locationGeoPoint')), 'coordinates'))) {
    location2 = (getObjectProperty((getObjectProperty(userProfile, 'locationGeoPoint')), 'coordinates')).join(' ');
  } else if ((getObjectProperty(userProfile, 'locationGeoPointNew')) && !(getObjectProperty((getObjectProperty(userProfile, 'locationGeoPoint')), 'coordinates'))) {
    location2 = [(getObjectProperty((getObjectProperty(userProfile, 'locationGeoPointNew')), 'coordinates')).slice(-1)[0], (getObjectProperty((getObjectProperty(userProfile, 'locationGeoPointNew')), 'coordinates'))[0]].join(' ');
  }
  if (getObjectProperty(dataContainer, 'ageMax')) {
    dateFrom = (new Date());
    dateTo = (new Date());
    dateFrom.setFullYear((((new Date((new Date())).getFullYear()) - (getObjectProperty(dataContainer, 'ageMax'))) - 1));
    dateTo.setFullYear(((new Date((new Date())).getFullYear()) - (getObjectProperty(dataContainer, 'ageMin'))));
    ageMin = [' and (birthDate <= \'',(dateTo.toISOString()),'\')'].join('');
    ageMax = [' and (birthDate >= \'',(dateFrom.toISOString()),'\')'].join('');
  }
  responce = (await Backendless.Request.get(`${Backendless.appPath}/services/profilesFilter/profilesFilterData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'search': JSON.stringify(searchInput),'pageSize': pageSize,'pageOffset': pageOffset,'other': JSON.stringify(([ageMax,ageMin,(await BackendlessUI.Functions.Custom['fn_1d3e40275c733dadae5d77dbdddd49a5']((getObjectProperty(dataContainer, 'heightPrefix')), (getObjectProperty(dataContainer, 'height')), ' and ', '')),'',''].join(''))),'location': JSON.stringify(location2),'bodyType': JSON.stringify(bodyType),'education': JSON.stringify(education),'ethnicity': JSON.stringify(ethnicity),'hairColor': JSON.stringify(hairColor),'maritalStatus': JSON.stringify(maritalStatus),'political': JSON.stringify(political),'sexOrientation': JSON.stringify(sexOrientation),'smoke': JSON.stringify(smoke),'drink': JSON.stringify(drink),'religion': JSON.stringify(religion),'gender': JSON.stringify(gender),'radius': (getObjectProperty(data, 'radius')),'blockList': JSON.stringify((blockList ? (JSON.stringify(blockList)) : null)),'userLikedProfiles': JSON.stringify(userLikedProfiles) }).send());
  if (!(((function () { return window.location.href })()).indexOf('page=profiles') !== -1)) {
    if (getObjectProperty(data, 'usersNew')) {
      delete data['usersNew'];
    }
  }
  var like_list = (getObjectProperty(userProfile, 'myLikes'));
  for (var like_index in like_list) {
    like = like_list[like_index];
    for (var j_index in responce) {
      j = responce[j_index];
      if ((getObjectProperty(like, 'objectId')) == (getObjectProperty(j, 'objectId'))) {
        j['likedIcon'] = true;
      }
    }
  }

return responce
}

})
define('./functions/ff776ab87025e31a9a7f4d5fcf8fe516/code.js', () => { 

BackendlessUI.Functions.Custom['fn_ff776ab87025e31a9a7f4d5fcf8fe516'] = function fn_ff776ab87025e31a9a7f4d5fcf8fe516(data) {
var setActive, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  setActive = false;
  for (var item_index in data) {
    item = data[item_index];
    if (setActive) {
      setActive = false;
      return (getObjectProperty(item, 'objectId'));
    }
    if (getObjectProperty(item, 'active')) {
      setActive = true;
    }
  }

return (getObjectProperty((data[0]), 'objectId'))
}

})
define('./pages/404/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var count, j, height, allUsers;

  },
  /* handler:onEnter */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return '404'

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/404/components/902c9641de4ec9e73427e7192a118d14/bundle.js', [], () => ({
  /* content */

  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('', undefined);

  },
  /* handler:onClick *//* content */
}));

define('./pages/activities-search/components/916764cf81f7f4dd39add13dbd65fa7a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['height'] = (___arguments.value * 1);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix'))) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefHeightCheckbox'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var height;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'heightList'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/activities-search/components/5979df7d1ea76def79124244409e64d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8884db3fe34a7ff9b455175b1a54afe8')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8884db3fe34a7ff9b455175b1a54afe8'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/78c320323da7ed26c9b8f5f4aa2e5761/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('415fe643768d137f21f9ce82b5b5cae6')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('415fe643768d137f21f9ce82b5b5cae6'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list', 'activity-page__quality-list', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__quality-list', 'activity-page__text-wrapper', 'activity-page__quality-list']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/70f2547404293aab0e6c72e76781a2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62f9240b00f7d5aadc8e6e1327237515')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62f9240b00f7d5aadc8e6e1327237515'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/454b2d213f9de7b9e88940a982e58aff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4538ba12e85afc390656197d5d426ed')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4538ba12e85afc390656197d5d426ed'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/f14a23fbebc8d1bd3e02f02e6cc20b23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2f7fbbd0b97d8eca1faa76de851f4fa')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2f7fbbd0b97d8eca1faa76de851f4fa'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/3322eed45a44439b5e0818f8b3d7fec5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5e48256646d768090d4ec8bbda7a3188')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5e48256646d768090d4ec8bbda7a3188'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/54aa67d779df4b443aee7eeab00bc6d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('54aa67d779df4b443aee7eeab00bc6d3'))['opacity'] = 1;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'children'))) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-padding', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'no-padding']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/95c2e8cf2a39b1f3ec3b278902dd3273/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b5686909fc32d7055a59aaef72e057')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b5686909fc32d7055a59aaef72e057')), 'no-prefs-content');
    }
    ___arguments.context.pageData['isVisible'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatus'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatusJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['maritalStatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['maritalStatusJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatusJson'));
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['noMoreActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      delete ___arguments.context.pageData['pastActivities'];
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['maritalStatusChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b5686909fc32d7055a59aaef72e057')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b5686909fc32d7055a59aaef72e057')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/65b5686909fc32d7055a59aaef72e057/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-padding', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'no-padding']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/0f28f89e2a6536cfb0eebe16d0559bda/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54aa67d779df4b443aee7eeab00bc6d3')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54aa67d779df4b443aee7eeab00bc6d3')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['children'] = null;
    ___arguments.context.pageData['isVisible'] = true;
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['children'] = null;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['noMoreActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      delete ___arguments.context.pageData['pastActivities'];
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54aa67d779df4b443aee7eeab00bc6d3')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54aa67d779df4b443aee7eeab00bc6d3')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'children'))) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/01815e1e73fa255454e22ba1a802afcb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('719557ecdc25ddc33fb93fbd57862026')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('719557ecdc25ddc33fb93fbd57862026')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicity'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicityJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ethnicity'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ethnicityJson'] = [];
    ___arguments.context.pageData['isVisible'] = true;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['noMoreActivities'];
      delete ___arguments.context.pageData['pastActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['ethnicityChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('719557ecdc25ddc33fb93fbd57862026')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('719557ecdc25ddc33fb93fbd57862026')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/719557ecdc25ddc33fb93fbd57862026/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-padding', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'no-padding']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/a8db42ffbba6fb0120a63c65e89baedd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatus'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatusJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a8db42ffbba6fb0120a63c65e89baedd')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a8db42ffbba6fb0120a63c65e89baedd')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatusJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a8db42ffbba6fb0120a63c65e89baedd')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatus'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatusJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatusJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['maritalStatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['maritalStatusJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatusJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['noMoreActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    delete ___arguments.context.pageData['pastActivities'];
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['maritalStatusChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/291b763c95f5d6bbafa48f05487f8bed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isVisible'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('291b763c95f5d6bbafa48f05487f8bed')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('291b763c95f5d6bbafa48f05487f8bed')), 'activity-page__quality-item-active');
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['children'] = (getObjectProperty(___arguments.context.dataModel, 'value'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('291b763c95f5d6bbafa48f05487f8bed')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['children'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = true;
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['children'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'children'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['noMoreActivities'];
    delete ___arguments.context.pageData['pastActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'children')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'children')) == (getObjectProperty(___arguments.context.dataModel, 'value'))) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/54064f0e3191651d6a12169de924785a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicity'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicityJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54064f0e3191651d6a12169de924785a')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54064f0e3191651d6a12169de924785a')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicityJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54064f0e3191651d6a12169de924785a')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicity'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicityJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicityJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['ethnicity'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['ethnicityJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicityJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['noMoreActivities'];
    delete ___arguments.context.pageData['pastActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['ethnicityChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/5c17afcc57bb0b1abd42323dae8683e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religion'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religionJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religionJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religion'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religionJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religionJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religionJson')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8884db3fe34a7ff9b455175b1a54afe8'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religion'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religionJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religionJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['noMoreActivities'];
    delete ___arguments.context.pageData['pastActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['religionChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion'))) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
      }));
    }
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/8e75f309995d41a7d5dd49872bdf2a58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['education'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['educationJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'educationJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['education'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['educationJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'educationJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62f9240b00f7d5aadc8e6e1327237515'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['education'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['educationJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'educationJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['noMoreActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    delete ___arguments.context.pageData['pastActivities'];
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['educationChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education'))) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
      }));
    }
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/e332d82dbc4c5d099d3919faf62be734/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['political'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['politicalJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'politicalJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['political'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['politicalJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'politicalJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2f7fbbd0b97d8eca1faa76de851f4fa'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['political'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['politicalJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'politicalJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['pastActivities'];
    delete ___arguments.context.pageData['noMoreActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['politicalChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political'))) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
      }));
    }
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/982656bea75328da811cc844403d3e19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientation'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientationJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('982656bea75328da811cc844403d3e19')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('982656bea75328da811cc844403d3e19')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientationJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('982656bea75328da811cc844403d3e19')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientation'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientationJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientationJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('415fe643768d137f21f9ce82b5b5cae6'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['sexOrientation'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['sexOrientationJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientationJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['noMoreActivities'];
    delete ___arguments.context.pageData['pastActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['sexOrientationChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/ca6ecb0f5df69667b0b79f9fe86d845f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyType'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyTypeJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ca6ecb0f5df69667b0b79f9fe86d845f')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ca6ecb0f5df69667b0b79f9fe86d845f')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyTypeJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ca6ecb0f5df69667b0b79f9fe86d845f')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyType'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyTypeJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyTypeJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4538ba12e85afc390656197d5d426ed'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['bodyType'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['bodyTypeJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyTypeJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    ___arguments.context.pageData['countOffset'] = 0;
    delete ___arguments.context.pageData['pastActivities'];
    delete ___arguments.context.pageData['noMoreActivities'];
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['bodyTypeChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/34a95071417e8828fbb385946e9c01d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColor'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColorJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34a95071417e8828fbb385946e9c01d3')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34a95071417e8828fbb385946e9c01d3')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColorJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34a95071417e8828fbb385946e9c01d3')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColor'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColorJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColorJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5e48256646d768090d4ec8bbda7a3188'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['hairColor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilterActivities'))['hairColorJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColorJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['pastActivities'];
    delete ___arguments.context.pageData['noMoreActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['hairColorChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/020b49a8ac82256cbc7b4f8d8d678804/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['heightPrefix'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix'))) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefHeightCheckbox'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/activities-search/components/8378734b92fa3c99354c7421f3ad9f23/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('enterData');

  ;(function() {
    const callback = async () => {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    if (___arguments.value) {
      ___arguments.context.pageData['searchInput'] = (___arguments.value.toLowerCase().split(','));
    }
    delete ___arguments.context.pageData['noMoreActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    delete ___arguments.context.pageData['pastActivities'];
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.appData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.appData['searchActivity'] = (getObjectProperty(___arguments.context.pageData, 'searchInputText'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();

    };

    const timerId = 'enterData';
    const timerDelay = 650;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.keyCode == 13) {
    ___arguments.context.pageData['search'] = true;
    await new Promise(r => setTimeout(r, 500 || 0));
    if (getObjectProperty(___arguments.context.pageData, 'search')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      if (getObjectProperty(___arguments.context.pageData, 'searchInputText')) {
        ___arguments.context.pageData['searchInput'] = ((getObjectProperty(___arguments.context.pageData, 'searchInputText')).split(','));
      }
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
      delete ___arguments.context.pageData['search'];
    }
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/activities-search/components/de44aacee84aa13176226579f74f4892/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1e5a5a3e590f0aa61df668717d4cc172')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    var messagesNumber;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'messagesNumber')) > 0) {
    return (['(',(getObjectProperty(___arguments.context.appData, 'messagesNumber')),') Activities'].join(''));
  }

  return 'Activities'

  },
  /* handler:onTitleAssignment */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) != null) {
    getRTSubscriptions().remove('messages');
    getRTSubscriptions().remove('chats');
    getRTSubscriptions().remove('chatsAccepted');
    getRTSubscriptions().remove('delete');
    getRTSubscriptions().remove('push');
    getRTSubscriptions().remove('likes');
    getRTSubscriptions().remove('blockListAdd');
    getRTSubscriptions().remove('blockListDelete');
    ___arguments.context.appData['activitiesCountOffset'] = (getObjectProperty(___arguments.context.pageData, 'countOffset'));
    ___arguments.context.appData['previousPage'] = 'activities-search';
    ___arguments.context.appData['pastActivities'] = (getObjectProperty(___arguments.context.pageData, 'pastActivities'));
    ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    ___arguments.context.appData['scrollTopActivities'] = (await (async function() {
    	return scrollTopActivities
    })());
    await (async function() {
    	if (swiper) {

    	  if (Array.isArray(swiper)) {
    	    for (const swiperItem of swiper) {
    	      swiperItem.destroy(true, true);
    	    }
    	  } else {
    	    swiper.destroy(true, true)
    	  }

    	}
    })();
    await (async function() {
    	delete window.scrollTopActivities;
    	delete window.onScrollActivities;
    })();
  }

  },
  /* handler:onLeave */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', true);
  }

  },
  /* handler:onResize */
  /* handler:onScroll */
  async ['onScroll'](___arguments) {
    var newActivities, sceduledActivities, activitiesWithDate, item, activityItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  await (async function(value) {
  	scrollTopActivities = value;
  })(___arguments.scrollTop);
  if (___arguments.scrollTop >= 30) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('de44aacee84aa13176226579f74f4892', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('de44aacee84aa13176226579f74f4892', false);
  }
  if (!(await (async function() {
  	return onScrollActivities
  })()) && (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    if (___arguments.scrollBottom <= 30 && ((getObjectProperty(___arguments.context.pageData, 'activityList')) ? (getObjectProperty(___arguments.context.pageData, 'activityList')).length : null) > 0 && !(getObjectProperty(___arguments.context.pageData, 'noMoreActivities'))) {
      await (async function() {
      	onScrollActivities = true;
      })();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ff2cf98ab181faf101752041ce59278', true);
      ___arguments.context.pageData['countOffset'] = ((getObjectProperty(___arguments.context.pageData, 'countOffset')) + 1);
      newActivities = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      if (!!newActivities.length) {
        ___arguments.context.pageData['activityListAll'] = ((getObjectProperty(___arguments.context.pageData, 'activityListAll')).concat(newActivities));
        activitiesWithDate = (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityListAll')), async (activityItem) => {


         return ((getObjectProperty(activityItem, 'order')) == 1);
        })), 1, async (item) => {


         return (getObjectProperty(item, 'activityDate'));
        }));
        sceduledActivities = (await asyncListSort((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityListAll')), async (activityItem) => {


         return ((getObjectProperty(activityItem, 'order')) != 1);
        })), 1, async (item) => {


         return (getObjectProperty(item, 'order'));
        }));
        ___arguments.context.pageData['activityListAll'] = (activitiesWithDate.concat(sceduledActivities));
        ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
        ___arguments.context.appData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityList'));
        if (newActivities.length < (getObjectProperty(___arguments.context.pageData, 'pageSize')) && (getObjectProperty(___arguments.context.pageData, 'pastActivities'))) {
          ___arguments.context.pageData['noMoreActivities'] = true;
        } else if (newActivities.length < (getObjectProperty(___arguments.context.pageData, 'pageSize')) && !(getObjectProperty(___arguments.context.pageData, 'pastActivities'))) {
          ___arguments.context.pageData['pastActivities'] = true;
          ___arguments.context.pageData['countOffset'] = -1;
        }
        await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();
      } else if (!newActivities.length && !(getObjectProperty(___arguments.context.pageData, 'pastActivities'))) {
        ___arguments.context.pageData['pastActivities'] = true;
        ___arguments.context.pageData['countOffset'] = 0;
        newActivities = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
        ___arguments.context.pageData['activityListAll'] = ((getObjectProperty(___arguments.context.pageData, 'activityListAll')).concat(newActivities));
        ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
        ___arguments.context.appData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityList'));
        if (newActivities.length < (getObjectProperty(___arguments.context.pageData, 'pageSize'))) {
          ___arguments.context.pageData['noMoreActivities'] = true;
        }
        await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();
      } else {
        ___arguments.context.pageData['noMoreActivities'] = true;
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3ff2cf98ab181faf101752041ce59278', false);
      await (async function() {
      	onScrollActivities = null;
      })();
    }
  }

  },
  /* handler:onScroll */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var error, tempFiltersRadius, tempFilters, countriesThatUseMiles, item, isNewActivity, j, activityListAllId, receivedChats, userJson, userResponce, query, userSeenBy, filterArrs, filterItems, filterArrsList, filterItemsList, searchFiltersLS, tempFiltersLS;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

/**
 * Describe this function...
 */
async function removeListeners() {
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('newMessages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
}

/**
 * Describe this function...
 */
async function getHeightList() {
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) {
    if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'US' || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'LR' || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'MM') {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″' }), ({ [`value`]: '124',[`label`]: '4′1″' }), ({ [`value`]: '127',[`label`]: '4′2″' }), ({ [`value`]: '130',[`label`]: '4′3″' }), ({ [`value`]: '132',[`label`]: '4′4″' }), ({ [`value`]: '135',[`label`]: '4′5″' }), ({ [`value`]: '137',[`label`]: '4′6″' }), ({ [`value`]: '140',[`label`]: '4′7″' }), ({ [`value`]: '142',[`label`]: '4′8″' }), ({ [`value`]: '145',[`label`]: '4′9″' }), ({ [`value`]: '152',[`label`]: '5′0″' }), ({ [`value`]: '155',[`label`]: '5′1″' }), ({ [`value`]: '157',[`label`]: '5′2″' }), ({ [`value`]: '160',[`label`]: '5′3″' }), ({ [`value`]: '163',[`label`]: '5′4″' }), ({ [`value`]: '165',[`label`]: '5′5″' }), ({ [`value`]: '168',[`label`]: '5′6″' }), ({ [`value`]: '170',[`label`]: '5′7″' }), ({ [`value`]: '173',[`label`]: '5′8″' }), ({ [`value`]: '176',[`label`]: '5′9″' }), ({ [`value`]: '178',[`label`]: '5′10″' }), ({ [`value`]: '180',[`label`]: '5′11″' }), ({ [`value`]: '183',[`label`]: '6′0″' }), ({ [`value`]: '185',[`label`]: '6′1″' }), ({ [`value`]: '188',[`label`]: '6′2″' }), ({ [`value`]: '191',[`label`]: '6′3″' }), ({ [`value`]: '193',[`label`]: '6′4″' }), ({ [`value`]: '195',[`label`]: '6′5″' }), ({ [`value`]: '198',[`label`]: '6′6″' }), ({ [`value`]: '201',[`label`]: '6′7″' }), ({ [`value`]: '203',[`label`]: '6′8″' }), ({ [`value`]: '206',[`label`]: '6′9″' }), ({ [`value`]: '208',[`label`]: '6′10″' }), ({ [`value`]: '211',[`label`]: '6′11″' }), ({ [`value`]: '213',[`label`]: '7′0″' })];
    } else {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '122 cm' }), ({ [`value`]: '124',[`label`]: '124 cm' }), ({ [`value`]: '127',[`label`]: '127 cm' }), ({ [`value`]: '130',[`label`]: '130 cm' }), ({ [`value`]: '132',[`label`]: '132 cm' }), ({ [`value`]: '135',[`label`]: '135 cm' }), ({ [`value`]: '137',[`label`]: '137 cm' }), ({ [`value`]: '140',[`label`]: '140 cm' }), ({ [`value`]: '142',[`label`]: '142 cm' }), ({ [`value`]: '145',[`label`]: '145 cm' }), ({ [`value`]: '152',[`label`]: '152 cm' }), ({ [`value`]: '155',[`label`]: '155 cm' }), ({ [`value`]: '157',[`label`]: '157 cm' }), ({ [`value`]: '160',[`label`]: '160 cm' }), ({ [`value`]: '163',[`label`]: '163 cm' }), ({ [`value`]: '165',[`label`]: '165 cm' }), ({ [`value`]: '168',[`label`]: '168 cm' }), ({ [`value`]: '170',[`label`]: '170 cm' }), ({ [`value`]: '173',[`label`]: '173 cm' }), ({ [`value`]: '176',[`label`]: '176 cm' }), ({ [`value`]: '178',[`label`]: '178 cm' }), ({ [`value`]: '180',[`label`]: '180 cm' }), ({ [`value`]: '183',[`label`]: '183 cm' }), ({ [`value`]: '185',[`label`]: '185 cm' }), ({ [`value`]: '188',[`label`]: '188 cm' }), ({ [`value`]: '191',[`label`]: '191 cm' }), ({ [`value`]: '193',[`label`]: '193 cm' }), ({ [`value`]: '195',[`label`]: '195 cm' }), ({ [`value`]: '198',[`label`]: '198 cm' }), ({ [`value`]: '201',[`label`]: '201 cm' }), ({ [`value`]: '203',[`label`]: '203 cm' }), ({ [`value`]: '206',[`label`]: '206 cm' }), ({ [`value`]: '208',[`label`]: '208 cm' }), ({ [`value`]: '211',[`label`]: '211 cm' }), ({ [`value`]: '213',[`label`]: '213 cm' })];
    }
  } else {
    ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″ (122 cm)' }), ({ [`value`]: '124',[`label`]: '4′1″ (124 cm)' }), ({ [`value`]: '127',[`label`]: '4′2″ (127 cm)' }), ({ [`value`]: '130',[`label`]: '4′3″ (130 cm)' }), ({ [`value`]: '132',[`label`]: '4′4″ (132 cm)' }), ({ [`value`]: '135',[`label`]: '4′5″ (135 cm)' }), ({ [`value`]: '137',[`label`]: '4′6″ (137 cm)' }), ({ [`value`]: '140',[`label`]: '4′7″ (140 cm)' }), ({ [`value`]: '142',[`label`]: '4′8″ (142 cm)' }), ({ [`value`]: '145',[`label`]: '4′9″ (145 cm)' }), ({ [`value`]: '152',[`label`]: '5′0″ (152 cm)' }), ({ [`value`]: '155',[`label`]: '5′1″ (155 cm)' }), ({ [`value`]: '157',[`label`]: '5′2″ (157 cm)' }), ({ [`value`]: '160',[`label`]: '5′3″ (160 cm)' }), ({ [`value`]: '163',[`label`]: '5′4″ (163 cm)' }), ({ [`value`]: '165',[`label`]: '5′5″ (165 cm)' }), ({ [`value`]: '168',[`label`]: '5′6″ (168 cm)' }), ({ [`value`]: '170',[`label`]: '5′7″ (170 cm)' }), ({ [`value`]: '173',[`label`]: '5′8″ (173 cm)' }), ({ [`value`]: '176',[`label`]: '5′9″ (176 cm)' }), ({ [`value`]: '178',[`label`]: '5′10″ (178 cm)' }), ({ [`value`]: '180',[`label`]: '5′11″ (180 cm)' }), ({ [`value`]: '183',[`label`]: '6′0″ (183 cm)' }), ({ [`value`]: '185',[`label`]: '6′1″ (185 cm)' }), ({ [`value`]: '188',[`label`]: '6′2″ (188 cm)' }), ({ [`value`]: '191',[`label`]: '6′3″ (191 cm)' }), ({ [`value`]: '193',[`label`]: '6′4″ (193 cm)' }), ({ [`value`]: '195',[`label`]: '6′5″ (195 cm)' }), ({ [`value`]: '198',[`label`]: '6′6″ (198 cm)' }), ({ [`value`]: '201',[`label`]: '6′7″ (201 cm)' }), ({ [`value`]: '203',[`label`]: '6′8″ (203 cm)' }), ({ [`value`]: '206',[`label`]: '6′9″ (206 cm)' }), ({ [`value`]: '208',[`label`]: '6′10″ (208 cm)' }), ({ [`value`]: '211',[`label`]: '6′11″ (211 cm)' }), ({ [`value`]: '213',[`label`]: '7′0″ (213 cm)' })];
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function setTempFilters() {
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'category')) && getValueLength((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'category'))) >= 36) {
      ___arguments.context.pageData['category'] = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'category'));
      if ((getObjectProperty(___arguments.context.pageData, 'category')) && (getObjectProperty(___arguments.context.pageData, 'category')) != 'All categories') {
        if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4236b579d2c7e60dbe1dc23cc4a4232b')) {
          (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('4236b579d2c7e60dbe1dc23cc4a4232b', (getObjectProperty(___arguments.context.pageData, 'category')));
        }
      }
    } else {
      tempFilters = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
      tempFilters['category'] = null;
      localStorage.setItem('tempFilters', JSON.stringify(tempFilters));
    }
    ___arguments.context.pageData['dateStart'] = ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'dateStart')) ? (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'dateStart')) : null);
    ___arguments.context.pageData['dateEnd'] = ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'dateEnd')) ? (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'dateEnd')) : null);
    if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')) && (((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')).indexOf('mi') !== -1) || ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')).indexOf('km') !== -1))) {
      tempFiltersRadius = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
      tempFiltersRadius['radius'] = null;
      localStorage.setItem('tempFilters', JSON.stringify(tempFiltersRadius));
    }
    if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')) && (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')) != 'All') {
      ___arguments.context.pageData['radius'] = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius'));
    }
  }
}

/**
 * Describe this function...
 */
async function setDataToRadiusSelect() {
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) {
    countriesThatUseMiles = ['united states', 'usa', 'us', 'myanmar', 'myanmar (burma)', 'burma', 'mm', 'liberia', 'lr'];
    if (countriesThatUseMiles.includes((((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')).toLowerCase()))) {
      ___arguments.context.pageData['distanseUnit'] = [({ [`value`]: 'All',[`label`]: 'Radius not selected' }), ({ [`value`]: '16093',[`label`]: '10 mi' }), ({ [`value`]: '40234',[`label`]: '25 mi' }), ({ [`value`]: '80467',[`label`]: '50 mi' }), ({ [`value`]: '120701',[`label`]: '75 mi' }), ({ [`value`]: '160934',[`label`]: '100 mi' })];
    } else {
      ___arguments.context.pageData['distanseUnit'] = [({ [`value`]: 'All',[`label`]: 'Radius not selected' }), ({ [`value`]: '16000',[`label`]: '16 km' }), ({ [`value`]: '40000',[`label`]: '40 km' }), ({ [`value`]: '80000',[`label`]: '80 km' }), ({ [`value`]: '120000',[`label`]: '120 km' }), ({ [`value`]: '160000',[`label`]: '160 km' })];
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'radius')) && (getObjectProperty(___arguments.context.pageData, 'radius')) != 'All') {
    if (((getObjectProperty(___arguments.context.pageData, 'distanseUnit')).map(item => item['value'])).includes((getObjectProperty(___arguments.context.pageData, 'radius')))) {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('be6599fe600b582619c8cd6cd5026c81', (getObjectProperty(___arguments.context.pageData, 'radius')));
    }
  }
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getActivityList() {
  if (!(getObjectProperty(___arguments.context.appData, 'activityList'))) {
    ___arguments.context.pageData['activityList'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.appData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityList'));
    ___arguments.context.pageData['activities'] = true;
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'activityList')).length > 100 && !(getObjectProperty(___arguments.context.pageData, 'notUpdate'))) {
      ___arguments.context.appData['activityList'] = ((getObjectProperty(___arguments.context.appData, 'activityList')).slice(0, 100));
    }
    ___arguments.context.appData['activityList'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'activityList')), async (item) => {


     return ((getObjectProperty(item, 'order')) != 4);
    }));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.appData, 'activityList'));
  }
  ___arguments.context.pageData['activityListAll'] = (getObjectProperty(___arguments.context.appData, 'activityList'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6a8f403c019b4a02b177d5034d14607d', true);
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('18bb7492395ea009014c87d41ba811fa')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if ((getObjectProperty(___arguments.context.appData, 'scrollTop')) && (await (async function() {
  	const pageEl = document.getElementById('page');
  	if (pageEl) {
  	  return pageEl;
  	} else {
  	  return null;
  	}
  })()) && (getObjectProperty(___arguments.context.pageData, 'notUpdate'))) {
    await (async function(scrollTop) {
    	const pageEl = document.getElementById('page');
    	if (pageEl) {
    	  pageEl.scroll({
    	    top: scrollTop,
    	    left: 0,
    	    behavior: "smooth",
    	  });
    	}
    })((getObjectProperty(___arguments.context.appData, 'scrollTop')));
  }
}

/**
 * Describe this function...
 */
async function getActivityListAllNew() {
  if ((getObjectProperty(___arguments.context.appData, 'activityList')) && !(getObjectProperty(___arguments.context.pageData, 'activities')) && !(getObjectProperty(___arguments.context.pageData, 'notUpdate'))) {
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['activityListAllNew'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    if ((getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) && !!(getObjectProperty(___arguments.context.pageData, 'activityListAllNew')).length) {
      isNewActivity = false;
      activityListAllId = ((getObjectProperty(___arguments.context.pageData, 'activityListAll')).map(item => item['objectId']));
      var j_list = (getObjectProperty(___arguments.context.pageData, 'activityListAllNew'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!(activityListAllId.includes((getObjectProperty(j, 'objectId'))))) {
          isNewActivity = true;
          break;
        }
      }
      if (isNewActivity) {
        ___arguments.context.pageData['isNewActivityBtnVisible'] = true;
        ___arguments.context.pageData['noMoreActivities'] = true;
      } else {
        ___arguments.context.pageData['activityListAll'] = (getObjectProperty(___arguments.context.pageData, 'activityListAllNew'));
        ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAllNew'));
        ___arguments.context.appData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAllNew'));
      }
    } else {
      ___arguments.context.pageData['activityListAll'] = [];
      ___arguments.context.pageData['activityList'] = [];
      ___arguments.context.appData['activityList'] = [];
    }
  }
}

/**
 * Describe this function...
 */
async function createFilterItemList() {
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    tempFiltersLS = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
  }
  if (searchFiltersLS && tempFiltersLS) {
    filterItemsList = [(getObjectProperty(searchFiltersLS, 'ageMax')), (getObjectProperty(searchFiltersLS, 'ageMin')), (getObjectProperty(searchFiltersLS, 'height')), (getObjectProperty(searchFiltersLS, 'financialRole')), (getObjectProperty(tempFiltersLS, 'category')), (getObjectProperty(tempFiltersLS, 'date')), (getObjectProperty(tempFiltersLS, 'dateEnd')), (getObjectProperty(tempFiltersLS, 'dateStart')), (getObjectProperty(tempFiltersLS, 'radius'))];
    filterArrsList = [(getObjectProperty(searchFiltersLS, 'gender'))];
    filterItems = (await asyncListFilter(filterItemsList, async (item) => {


     return (item != null);
    }));
    filterArrs = (await asyncListFilter(filterArrsList, async (item) => {


     return (item.length > 0);
    }));
    if (filterItems.length > 0 || filterArrs.length > 0) {
      ___arguments.context.appData['filtersProfilesAdded'] = true;
      ___arguments.context.appData['filtersActivitiesAdded'] = true;
    } else {
      ___arguments.context.appData['filtersProfilesAdded'] = false;
      ___arguments.context.appData['filtersActivitiesAdded'] = false;
    }
  }
}

/**
 * Describe this function...
 */
async function setFilters() {
  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))) {
    Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')));
    delete ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['created'];
    delete ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['updated'];
    delete ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['objectId'];
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) && !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['age'] = [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')), 100];
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['ageMax'] = 100;
    } else if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['age'] = [18, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))];
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['ageMin'] = 18;
    } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['age'] = [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))];
      if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) == 18 && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax')) == 100) {
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefAgeCheckbox'] = true;
      }
    } else if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) && !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['age'] = [18, 100];
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefAgeCheckbox'] = true;
    }
    if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'gender'))) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['gender'] = [];
    }
    if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'gender')).length) {
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefGenderCheckbox'] = true;
    }
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefHeightCheckbox'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'height')) ? false : true);
    ___arguments.context.pageData['checked'] = true;
  }
}

/**
 * Describe this function...
 */
async function getCategories() {
  if (!((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories'))) {
    ___arguments.context.appData['categoryList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/profilesData/ProfilesData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Category') }).send());
    localStorage.setItem('categories', JSON.stringify((getObjectProperty(___arguments.context.appData, 'categoryList'))));
  } else if (!(getObjectProperty(___arguments.context.appData, 'categoryList'))) {
    ___arguments.context.appData['categoryList'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories'));
  }
  ___arguments.context.pageData['categoryList'] = (getObjectProperty(___arguments.context.appData, 'categoryList'));
  ___arguments.context.pageData['categories'] = ([({ [`value`]: 'All categories',[`label`]: 'All categories' })].concat((await Promise.all((getObjectProperty(___arguments.context.pageData, 'categoryList')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'name')) });})))));
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
    if (!(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus'))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', ({ [`accountPaused`]: true }));
      return ;
    }
  }
  if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) && !(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
    ___arguments.context.appData['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'photoThumbnail'));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if (!((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login')) && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'birthDate')) && !((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
  await (async function() {
  	scrollTopActivities = 0;
  	onScrollActivities = null;
  })();
  await getHeightList();
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('18bb7492395ea009014c87d41ba811fa')) && !(getObjectProperty(___arguments.context.pageData, 'activityList'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
  }
  await setTempFilters();
  ___arguments.context.pageData['pageSize'] = 100;
  if ((getObjectProperty(___arguments.context.pageData, 'notUpdate')) && (typeof (getObjectProperty(___arguments.context.appData, 'activitiesCountOffset')) === 'number' && !isNaN((getObjectProperty(___arguments.context.appData, 'activitiesCountOffset'))))) {
    if (getObjectProperty(___arguments.context.appData, 'pastActivities')) {
      ___arguments.context.pageData['pastActivities'] = (getObjectProperty(___arguments.context.appData, 'pastActivities'));
      ___arguments.context.pageData['countOffset'] = -1;
    } else {
      ___arguments.context.pageData['countOffset'] = (getObjectProperty(___arguments.context.appData, 'activitiesCountOffset'));
    }
  } else {
    ___arguments.context.pageData['countOffset'] = 0;
  }
  await getActivityList();
  await getActivityListAllNew();
  await (async function() {
  	swiper = new Swiper('.swiper', {

  	  pagination: {
  	    el: '.swiper-pagination',
  	    clickable: true
  	  }

  	});
  })();
  if ((getObjectProperty(___arguments.context.appData, 'scrollTopActivities')) && (await (async function() {
  	const pageEl = document.getElementById('page');
  	if (pageEl) {
  	  return pageEl;
  	} else {
  	  return null;
  	}
  })()) && (getObjectProperty(___arguments.context.pageData, 'notUpdate'))) {
    await (async function(scrollTop) {
    	const pageEl = document.getElementById('page');
    	if (pageEl) {
    	  pageEl.scroll({
    	    top: scrollTop,
    	    left: 0,
    	    behavior: "smooth",
    	  });
    	}
    })((getObjectProperty(___arguments.context.appData, 'scrollTopActivities')));
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4236b579d2c7e60dbe1dc23cc4a4232b')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4236b579d2c7e60dbe1dc23cc4a4232b')), 'display'))) {
    await setDataToRadiusSelect();
  }
  if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson'))) {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['blockListJson'] = [];
    ___arguments.context.pageData['save'] = true;
  }
  if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myInterestsJson'))) {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['myInterestsJson'] = [];
    ___arguments.context.pageData['save'] = true;
  }
  if (getObjectProperty(___arguments.context.pageData, 'save')) {
    ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
      localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    }
    delete ___arguments.context.pageData['save'];
    await Backendless.Data.of('userProfile').save( (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) );
  }
  await getCategories();
  await createFilterItemList();
  if (getObjectProperty(___arguments.context.pageData, 'notUpdate')) {
    await (async function() {
    	const url = new URL(document.location);
    	const searchParams = url.searchParams;
    	searchParams.delete("data");
    	window.history.pushState({}, '', url.toString());

    })();
  }
  await setFilters();
  await removeListeners();
  try {
    await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);

  } catch (error) {
    console.log(error);

  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_activities_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/activities-search/components/4236b579d2c7e60dbe1dc23cc4a4232b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var tempFilter;


  ___arguments.context.pageData['category'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'categories'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/activities-search/components/3442a6fca43ec5439354598b3d368001/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var category, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.pageData['category']) {
    category = (await asyncListFilter((___arguments.context.pageData['categoryList']), async (item) => {
       if ((item['objectId']) == (___arguments.context.pageData['category'])) {
        return item;
      }


     return ;
    }))[0];
    return (String(category['name']));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activities-search/components/dc03aac371cc6039146f057933075608/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var category, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'category')) {
    category = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryList')), async (item) => {
       if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'category'))) {
        return item;
      }


     return ;
    }))[0];
    return (getObjectProperty(category, 'icon'));
  }
  await (async function() {
  	window.location.href.split('#')[0]
  })();

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activities-search/components/d3ee65a8eb53f5b48e95183969773dd9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    localStorage.setItem('isShowModal', JSON.stringify(true));
  } else {
    localStorage.removeItem('isShowModal');
  }

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/activities-search/components/28757196addbe43775c3081d8474f94a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] == 'open') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).slice(-1)[0] == 'content-blur') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).pop();
  }
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d168aace99e6f9c71adfc78f96a9193')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/1df183bf91b6ebff13e18b02db328bf8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ___arguments.context.pageData['reset'] = true;
  ___arguments.context.pageData['isVisible'] = true;
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] == 'open') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).pop();
  }
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).slice(-1)[0] == 'content-blur') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).pop();
  }
  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6af5b28122f6620ddf627244b427de1f'))['value'] = null;
  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('b5290d9ea6b473110b64985978f1a6fe'))['value'] = null;
  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('c244bad2104450974af94f2aacdb8f0e'))['value'] = 18;
  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('60b9689f45a34ddd6a6414927bd34fdf'))['value'] = 100;
  (___arguments.context.pageData['contentData'])['gender'] = null;
  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('020b49a8ac82256cbc7b4f8d8d678804'))['value'] = null;
  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('916764cf81f7f4dd39add13dbd65fa7a'))['value'] = null;
  (___arguments.context.pageData['contentData'])['maritalStatus'] = [];
  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked'] = true;
  (___arguments.context.pageData['contentData'])['children'] = null;
  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = true;
  ___arguments.context.pageData['financialRole'] = null;
  (___arguments.context.pageData['contentData'])['financialRole'] = null;
  (___arguments.context.pageData['contentData'])['ethnicity'] = [];
  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked'] = true;
  (___arguments.context.pageData['contentData'])['religion'] = [];
  (___arguments.context.pageData['contentData'])['sexOrientation'] = [];
  (___arguments.context.pageData['contentData'])['education'] = [];
  (___arguments.context.pageData['contentData'])['bodyType'] = [];
  (___arguments.context.pageData['contentData'])['hairColor'] = [];
  ___arguments.context.pageData['activityListAll'] = (await Backendless.Data.of('Activity').find(Backendless.DataQueryBuilder.create().setWhereClause(([String('author != ') + String(null),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['bodyType']), 'author.userProfile.bodyType=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['education']), 'author.userProfile.educationLevel=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['ethnicity']), 'author.userProfile.ethnicity=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['hairColor']), 'author.userProfile.hairColor=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['maritalStatus']), 'author.userProfile.maritalStatus=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['political']), 'author.userProfile.politicalView=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['religion']), 'author.userProfile.religion=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['sexOrientation']), 'author.userProfile.sexOrientation=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_d412eac4160659791c47d3aec2497977']((___arguments.context.dataModel['ageMax']), 'year(author.birthDate) >= ', ' and ', ((new Date((new Date())).getFullYear()) - (___arguments.context.dataModel['ageMax'])))),(await BackendlessUI.Functions.Custom['fn_d412eac4160659791c47d3aec2497977']((___arguments.context.dataModel['ageMin']), 'YEAR(author.birthDate) <= ', ' and ', ((new Date((new Date())).getFullYear()) - (___arguments.context.dataModel['ageMin'])))),(await BackendlessUI.Functions.Custom['fn_1d3e40275c733dadae5d77dbdddd49a5']((___arguments.context.dataModel['heightPrefix']), (___arguments.context.dataModel['height']), ' and ', 'author.')),(await BackendlessUI.Functions.Custom['fn_f8564041e56be4dc88360dd95c938941']((___arguments.context.dataModel['children']), 'author.userProfile.children=', ' and ', '')),(await BackendlessUI.Functions.Custom['fn_f8564041e56be4dc88360dd95c938941']((___arguments.context.dataModel['gender']), 'author.gender=\'', ' and ', '\''))].join(''))).setHavingClause((['keepLocationPrivate = false',(await BackendlessUI.Functions.Custom['fn_f8564041e56be4dc88360dd95c938941'](((___arguments.context.pageData['currentUser'])['location']), 'location=\'', ' and ', '\'')),(await BackendlessUI.Functions.Custom['fn_15839a3dd6a9e8ce681ec977fe735279']((___arguments.context.pageData['date']))),(await BackendlessUI.Functions.Custom['fn_f8564041e56be4dc88360dd95c938941']((___arguments.context.pageData['financialRole']), 'financialRole=\'', ' and ', '\''))].join(''))).setRelated(['author', 'category', 'author.userProfile', 'author.interests']).setGroupBy('objectId').setPageSize((___arguments.context.pageData['pageSize']))));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/b36463a64aa1693964de49bfa9ca3ece/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] == 'open') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).pop();
  }
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).slice(-1)[0] == 'content-blur') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).pop();
  }
  ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('8d168aace99e6f9c71adfc78f96a9193')));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
  ___arguments.context.pageData['activityListAll'] = (await Backendless.Data.of('Activity').find(Backendless.DataQueryBuilder.create().setWhereClause(([String('author != ') + String(null),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['bodyType']), 'author.userProfile.bodyType=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['education']), 'author.userProfile.educationLevel=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['ethnicity']), 'author.userProfile.ethnicity=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['hairColor']), 'author.userProfile.hairColor=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['maritalStatus']), 'author.userProfile.maritalStatus=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['political']), 'author.userProfile.politicalView=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['religion']), 'author.userProfile.religion=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_8c410f7c55d946be06c4e40322722e41']((___arguments.context.dataModel['sexOrientation']), 'author.userProfile.sexOrientation=', ' or ', ' and ', 'id', '')),(await BackendlessUI.Functions.Custom['fn_d412eac4160659791c47d3aec2497977']((___arguments.context.dataModel['ageMax']), 'year(author.birthDate) >= ', ' and ', ((new Date((new Date())).getFullYear()) - (___arguments.context.dataModel['ageMax'])))),(await BackendlessUI.Functions.Custom['fn_d412eac4160659791c47d3aec2497977']((___arguments.context.dataModel['ageMin']), 'year(author.birthDate) <= ', ' and ', ((new Date((new Date())).getFullYear()) - (___arguments.context.dataModel['ageMin'])))),(await BackendlessUI.Functions.Custom['fn_1d3e40275c733dadae5d77dbdddd49a5']((___arguments.context.dataModel['heightPrefix']), (___arguments.context.dataModel['height']), ' and ', 'author.')),(await BackendlessUI.Functions.Custom['fn_f8564041e56be4dc88360dd95c938941']((___arguments.context.dataModel['children']), 'author.userProfile.children=', ' and ', '')),(await BackendlessUI.Functions.Custom['fn_f8564041e56be4dc88360dd95c938941']((___arguments.context.dataModel['gender']), 'author.gender=\'', ' and ', '\''))].join(''))).setHavingClause((['keepLocationPrivate = false',(await BackendlessUI.Functions.Custom['fn_f8564041e56be4dc88360dd95c938941'](((___arguments.context.pageData['currentUser'])['location']), 'location=\'', ' and ', '\'')),(await BackendlessUI.Functions.Custom['fn_15839a3dd6a9e8ce681ec977fe735279']((___arguments.context.pageData['date']))),(await BackendlessUI.Functions.Custom['fn_f8564041e56be4dc88360dd95c938941']((___arguments.context.pageData['financialRole']), 'financialRole=\'', ' and ', '\''))].join(''))).setRelated(['author', 'category', 'author.userProfile', 'author.interests']).setGroupBy('objectId').setPageSize((___arguments.context.pageData['pageSize']))));
  ___arguments.context.pageData['activityList'] = (___arguments.context.pageData['activityListAll']);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/8884db3fe34a7ff9b455175b1a54afe8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8884db3fe34a7ff9b455175b1a54afe8'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5979df7d1ea76def79124244409e64d4')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5979df7d1ea76def79124244409e64d4')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religion'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religionJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religion'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religionJson'] = [];
    ___arguments.context.pageData['isVisible'] = true;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['noMoreActivities'];
      delete ___arguments.context.pageData['pastActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['religionChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5979df7d1ea76def79124244409e64d4')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5979df7d1ea76def79124244409e64d4')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/415fe643768d137f21f9ce82b5b5cae6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('415fe643768d137f21f9ce82b5b5cae6'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('78c320323da7ed26c9b8f5f4aa2e5761')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('78c320323da7ed26c9b8f5f4aa2e5761')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientation'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientationJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['sexOrientation'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['sexOrientationJson'] = [];
    ___arguments.context.pageData['isVisible'] = true;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['noMoreActivities'];
      delete ___arguments.context.pageData['pastActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['sexOrientationChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('78c320323da7ed26c9b8f5f4aa2e5761')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('78c320323da7ed26c9b8f5f4aa2e5761')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/62f9240b00f7d5aadc8e6e1327237515/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('62f9240b00f7d5aadc8e6e1327237515'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('70f2547404293aab0e6c72e76781a2cd')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('70f2547404293aab0e6c72e76781a2cd')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['education'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['educationJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['education'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['educationJson'] = [];
    ___arguments.context.pageData['isVisible'] = true;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['noMoreActivities'];
      delete ___arguments.context.pageData['pastActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['educationChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('70f2547404293aab0e6c72e76781a2cd')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('70f2547404293aab0e6c72e76781a2cd')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/e4538ba12e85afc390656197d5d426ed/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4538ba12e85afc390656197d5d426ed'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('454b2d213f9de7b9e88940a982e58aff')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('454b2d213f9de7b9e88940a982e58aff')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyType'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyTypeJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['bodyType'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['bodyTypeJson'] = [];
    ___arguments.context.pageData['isVisible'] = true;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['pastActivities'];
      delete ___arguments.context.pageData['noMoreActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['bodyTypeChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('454b2d213f9de7b9e88940a982e58aff')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('454b2d213f9de7b9e88940a982e58aff')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/b2f7fbbd0b97d8eca1faa76de851f4fa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2f7fbbd0b97d8eca1faa76de851f4fa'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f14a23fbebc8d1bd3e02f02e6cc20b23')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f14a23fbebc8d1bd3e02f02e6cc20b23')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['political'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['politicalJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['political'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['politicalJson'] = [];
    ___arguments.context.pageData['isVisible'] = true;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['pastActivities'];
      delete ___arguments.context.pageData['noMoreActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['politicalChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f14a23fbebc8d1bd3e02f02e6cc20b23')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f14a23fbebc8d1bd3e02f02e6cc20b23')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/5e48256646d768090d4ec8bbda7a3188/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5e48256646d768090d4ec8bbda7a3188'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3322eed45a44439b5e0818f8b3d7fec5')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3322eed45a44439b5e0818f8b3d7fec5')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColor'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColorJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColor'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColorJson'] = [];
    ___arguments.context.pageData['isVisible'] = true;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['noMoreActivities'];
      delete ___arguments.context.pageData['pastActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['hairColorChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3322eed45a44439b5e0818f8b3d7fec5')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3322eed45a44439b5e0818f8b3d7fec5')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/94acb35bc3bef88ed4b8435a08ed6b57/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f00bb80ee757c7664b85bcd3842ec8a4')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f00bb80ee757c7664b85bcd3842ec8a4'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/48818f28b69279fa3a0c9826849219ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c76e7109a1e6a94956d6c444a3eb1d1d')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c76e7109a1e6a94956d6c444a3eb1d1d'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/2391bb174fd98bff778f7fa9748262d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smoke'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smokeJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smokeJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smoke'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smokeJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smokeJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f00bb80ee757c7664b85bcd3842ec8a4'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smoke'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smokeJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smokeJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['pastActivities'];
    delete ___arguments.context.pageData['noMoreActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['smokeChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke'))) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
      }));
    }
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/6c22d08e7ef7767286973b17663d77f7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drink'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drinkJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drinkJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drink'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drinkJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drinkJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c76e7109a1e6a94956d6c444a3eb1d1d'))['checked'] = true;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drinkJson')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c76e7109a1e6a94956d6c444a3eb1d1d'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drink'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drinkJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drinkJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['pastActivities'];
    delete ___arguments.context.pageData['noMoreActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['drinkChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink'))) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/f00bb80ee757c7664b85bcd3842ec8a4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f00bb80ee757c7664b85bcd3842ec8a4'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('94acb35bc3bef88ed4b8435a08ed6b57')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('94acb35bc3bef88ed4b8435a08ed6b57')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smoke'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smokeJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smoke'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smokeJson'] = [];
    ___arguments.context.pageData['isVisible'] = true;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['pastActivities'];
      delete ___arguments.context.pageData['noMoreActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['smokeChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('94acb35bc3bef88ed4b8435a08ed6b57')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('94acb35bc3bef88ed4b8435a08ed6b57')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/c76e7109a1e6a94956d6c444a3eb1d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c76e7109a1e6a94956d6c444a3eb1d1d'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('48818f28b69279fa3a0c9826849219ca')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('48818f28b69279fa3a0c9826849219ca')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drink'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drinkJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drink'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drinkJson'] = [];
    ___arguments.context.pageData['isVisible'] = true;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['pastActivities'];
      delete ___arguments.context.pageData['noMoreActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['drinkChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('48818f28b69279fa3a0c9826849219ca')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('48818f28b69279fa3a0c9826849219ca')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')).length) {
    return false;
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drinkJson'))) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drinkJson'] = [];
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/be6599fe600b582619c8cd6cd5026c81/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var tempFilter, selectedRadiusItem, item;


  if (___arguments.value == 'All') {
    ___arguments.context.pageData['radius'] = null;
  } else {
    ___arguments.context.pageData['radius'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'distanseUnit'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/activities-search/components/e10c498e064201675563d6995c1a3a91/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'searchActivity')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8378734b92fa3c99354c7421f3ad9f23'))['value'] = (getObjectProperty(___arguments.context.appData, 'searchActivity'));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/activities-search/components/c3b8b8eb80d9306e5fa511a321eeeb2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activityList')) && (getObjectProperty(___arguments.context.pageData, 'activityList')).length == 0) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activities-search/components/a72c6e683193ef4d737d28d6f58220e3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value[0] == 18 && ___arguments.value.slice(-1)[0] == 100) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefAgeCheckbox'] = true;
  } else {
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'noPrefAgeCheckbox')) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefAgeCheckbox'] = false;
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/activities-search/components/aadf593950383e1b5bd5a057038f6cd6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/activities-search/components/f3bb039ced4875e3b557d80781bce5ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/activities-search/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/2489ec87cf38b8480636aa88561be8b1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['height'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['heightPrefix'] = null;
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['heightPrefix'] = 'minHeight';
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['height'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'heightList'))[0]), 'value')) * 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/activities-search/components/fae551458351890ba5924f9dc7ff0423/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['genderList'] = [({ [`label`]: 'Male' }), ({ [`label`]: 'Female' }), ({ [`label`]: 'Non-Binary' })];

  },
  /* handler:onMounted */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'noPrefGenderCheckbox')) ? ({ [`opacity`]: 0.3 }) : ({ [`opacity`]: 1 }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/activities-search/components/026672db3627604592f883da4f93afa4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'] = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')).map(async item => {; return item;})));
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')), (getObjectProperty(___arguments.context.dataModel, 'label')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'label')));
    }));
  }
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefGenderCheckbox'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')).length ? true : false);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')).length) {
    return (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')).join(',')).indexOf((getObjectProperty(___arguments.context.dataModel, 'label'))) !== -1);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/69acb25ab4c64cfca01dd196a63c9e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var list1, j, list2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isNewActivityBtnVisible'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.appData['activitiesCountOffset'] = (getObjectProperty(___arguments.context.pageData, 'countOffset'));
    delete ___arguments.context.pageData['pastActivities'];
    delete ___arguments.context.pageData['noMoreActivities'];
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAllNew'));
    ___arguments.context.appData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityList'));
    ___arguments.context.pageData['activityListAll'] = (getObjectProperty(___arguments.context.pageData, 'activityListAllNew'));
    delete ___arguments.context.pageData['activityListAllNew'];
  }
  ___arguments.context.pageData['isNewActivityBtnVisible'] = false;
  await new Promise(r => setTimeout(r, 100 || 0));
  await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/c4d360f9584d8828b116ff1ee133ba51/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item, error;

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var error, isNewActivity, j, activityListAllId, item, tempFiltersRadius, tempFilters, receivedChats, userJson, userResponce, query, userSeenBy, countriesThatUseMiles;


  ___arguments.context.pageData['contentData'] = ___arguments.context.dataModel;
  delete ___arguments.context.dataModel['isVisible'];

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/activities-search/components/4fed3de52427c19e8ad407bcf1ee9e37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('560fccd5edead76a07cc90c3a04de2de')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('560fccd5edead76a07cc90c3a04de2de'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')).length) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/560fccd5edead76a07cc90c3a04de2de/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')).length) {
    return false;
  }
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson'))) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreferenceJson'] = [];
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('560fccd5edead76a07cc90c3a04de2de'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4fed3de52427c19e8ad407bcf1ee9e37')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4fed3de52427c19e8ad407bcf1ee9e37')), 'no-prefs-content');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreferenceJson'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreference'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreference'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreferenceJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson'));
    ___arguments.context.pageData['isVisible'] = true;
    if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
      ___arguments.context.pageData['checkedCategory'] = [];
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
      delete ___arguments.context.pageData['noMoreActivities'];
      delete ___arguments.context.pageData['pastActivities'];
      ___arguments.context.pageData['countOffset'] = 0;
      ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
      ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
      ___arguments.context.pageData['dietaryChanged'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4fed3de52427c19e8ad407bcf1ee9e37')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4fed3de52427c19e8ad407bcf1ee9e37')).pop();
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/activities-search/components/ca736eec63cb8ac5d8ffc09d4a2251be/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['isVisible'] = true;
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreference'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreferenceJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreference'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreferenceJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('560fccd5edead76a07cc90c3a04de2de'))['checked'] = true;
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('560fccd5edead76a07cc90c3a04de2de'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreference'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreferenceJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson'));
  if (!(getObjectProperty(___arguments.context.pageData, 'checkedCategory'))) {
    ___arguments.context.pageData['checkedCategory'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('02f77e44dbb49453d3be5df96ed5fe1a')).slice(-1)[0] != 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
    delete ___arguments.context.pageData['pastActivities'];
    delete ___arguments.context.pageData['noMoreActivities'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
    ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
    ___arguments.context.pageData['dietaryChanged'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference'))) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activities-search/components/0339be6a6249ffc1a38d159b6e4e4252/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('23e9db8f324d6c9c77a611cf7e162196')).includes('aside__open'))) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('23e9db8f324d6c9c77a611cf7e162196')).push('aside__open');
    try {
      await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('activities_filter_opened');

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'filtersProfilesAdded')) || (getObjectProperty(___arguments.context.appData, 'filtersActivitiesAdded'))) {
    return ['searchPrefButton', 'filterHeading__btn', 'active'];
  }

  return ['searchPrefButton', 'filterHeading__btn']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/89928fadfbd3ba1e8f4aa999f944015f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'name'))

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/85a2f9f4f2b64edb307ad4eb232a8f0a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85a2f9f4f2b64edb307ad4eb232a8f0a'))['pointer-events'] = 'none';
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) {
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'likedIcon')) {
      ___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91')['likedIcon'] = false;
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['likedActivities'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')), async (item) => {


       return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'objectId')) != (getObjectProperty(item, 'objectId')));
      }));
      await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'objectId')),'parameter': 'likedActivities','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
    } else {
      if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities'))) {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['likedActivities'] = [];
      }
      ___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91')['likedIcon'] = true;
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')), ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'objectId')),[`ts`]: ((new Date()).valueOf()) }));
      try {
        await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),' just liked your activity "',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'name')),'"'].join('')), null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'ownerId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'ownerId')));
        await (getChannelInstance('likes')).send('', ({ [`message`]: [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),' just liked your activity "',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'name')),'"'].join(''),[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'ownerId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

      } catch (error) {
        console.log(error);

      }
      await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'objectId')),'parameter': 'likedActivities','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
    }
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('85a2f9f4f2b64edb307ad4eb232a8f0a'))['pointer-events'] = 'auto';
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'likedIcon')) ? ['card__favoriteBtn', 'btnRound', 'clicked'] : ['card__favoriteBtn', 'btnRound'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/212de6a2ce2667f5ef6a627b16847ff4/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var item;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/activities-search/components/7ee6aba11caee1f3733ab81bdc26541f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'location'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activities-search/components/c1ccfe665955e8f167764d64c56d8877/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'icon'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activities-search/components/a652bf14409cb58a2b8d4a2a4c9399cb/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'mediaList'))

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/0958d038375ff9af740a6996320c2db7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'categoryName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activities-search/components/6a8f403c019b4a02b177d5034d14607d/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'activityList'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/activities-search/components/9317ae4f03d5048ddf7b4b2fae3a7168/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['countOffset'];
  delete ___arguments.context.appData['activitiesSearch'];
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/b66b1549a84bc8061272a27bb51e0bdd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(closeBtn) {
  	closeBtn.click();
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('855976328d35534a392cb565eed20a65')), 'el')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/855976328d35534a392cb565eed20a65/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('23e9db8f324d6c9c77a611cf7e162196')), 'aside__open', '');
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('4236b579d2c7e60dbe1dc23cc4a4232b', (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'category')));
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('be6599fe600b582619c8cd6cd5026c81', (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')));
    ___arguments.context.pageData['dateStart'] = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'dateStart'));
    ___arguments.context.pageData['dateEnd'] = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'dateEnd'));
  } else {
    ___arguments.context.pageData['dateStart'] = null;
    ___arguments.context.pageData['dateEnd'] = null;
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('4236b579d2c7e60dbe1dc23cc4a4232b', null);
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('be6599fe600b582619c8cd6cd5026c81', null);
  }
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['age'] = [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))];
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) == 18 && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax')) == 100) {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefAgeCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefAgeCheckbox'] = false;
  }
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['gender'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'gender')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'gender')) : []);
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'gender')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'gender')).length) {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefGenderCheckbox'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefGenderCheckbox'] = true;
  }
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['heightPrefix'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'heightPrefix'));
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['height'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'height'));
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'heightPrefix')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'height'))) {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefHeightCheckbox'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefHeightCheckbox'] = true;
  }
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['financialRole'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'financialRole'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc0e9037c748bf5872366949cc92f977', false);
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('550d4154da03160a1f63404613b3572f')).includes('filterItem__dateRange--active')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('550d4154da03160a1f63404613b3572f'))['pointer-events'] = 'auto';
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('550d4154da03160a1f63404613b3572f')), 'filterItem__dateRange--active', '');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['asideBtnApplyDisabled'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/d4786bef2412b775952ed4230f56864a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age')) ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age'))[0],'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age')).slice(-1)[0]].join('') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activities-search/components/5e164f3c39339deb0cfe15be97c48091/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['financialRole'] = 'passenger';

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'financialRole')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'financialRole')) == 'passenger' ? ['filterItem__finRoleBtn', 'filterItem__finRoleBtn--active'] : ['filterItem__finRoleBtn'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/c24e96aeb99f6a8aea4c0477c89635c1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['financialRole'] = 'driver';

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'financialRole')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'financialRole')) == 'driver' ? ['filterItem__finRoleBtn', 'filterItem__finRoleBtn--active'] : ['filterItem__finRoleBtn'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/7874fdf66e457b59d5254509882a1419/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['financialRole'] = '50/50';

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'financialRole')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'financialRole')) != 'driver' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'financialRole')) != 'passenger' ? ['filterItem__finRoleBtn', 'filterItem__finRoleBtn--active'] : ['filterItem__finRoleBtn'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activities-search/components/364cf97b89ec966181539d0f34dd4e5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getFilteredData() {
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['pastActivities'];
  delete ___arguments.context.pageData['noMoreActivities'];
  ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
  ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
  ___arguments.context.appData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
}

/**
 * Describe this function...
 */
async function saveFilterData() {
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
  if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'objectId')) {
    await Backendless.Data.of('UserSearchFilter').save( (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')) );
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ageMin'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age'))[0]);
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ageMax'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age')).slice(-1)[0]);
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ageMin'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age'))[0]);
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ageMax'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age')).slice(-1)[0]);
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['gender'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'gender'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix'))) {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['heightPrefix'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['height'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height'));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['financialRole'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'financialRole'));
  localStorage.setItem('tempFilters', JSON.stringify(({ [`category`]: (getObjectProperty(___arguments.context.pageData, 'category')) ? (getObjectProperty(___arguments.context.pageData, 'category')) : null,[`radius`]: (getObjectProperty(___arguments.context.pageData, 'radius')) ? (getObjectProperty(___arguments.context.pageData, 'radius')) : null,[`dateStart`]: (getObjectProperty(___arguments.context.pageData, 'dateStart')) ? (getObjectProperty(___arguments.context.pageData, 'dateStart')) : null,[`dateEnd`]: (getObjectProperty(___arguments.context.pageData, 'dateEnd')) ? (getObjectProperty(___arguments.context.pageData, 'dateEnd')) : null })));
  await (async function(closeBtn) {
  	closeBtn.click();
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('855976328d35534a392cb565eed20a65')), 'el')));
  await getFilteredData();
  await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  await saveFilterData();
  if (getObjectProperty(___arguments.context.pageData, 'activityListAllNew')) {
    delete ___arguments.context.pageData['activityListAllNew'];
  }
  if (getObjectProperty(___arguments.context.appData, 'users')) {
    delete ___arguments.context.appData['users'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/194c46f6d2882bc10e4574c2c7d7dffd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['age'] = [18, 100];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/activities-search/components/70ab3d050f1568f61e75b6df361c099e/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'noPrefAgeCheckbox')) ? ({ [`opacity`]: 0.3 }) : ({ [`opacity`]: 1 }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/activities-search/components/c7e341cf0d7788d17fe7872ac3ccf299/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'] = [];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/activities-search/components/52935a85c38bf4d237a9a84af764629c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'noPrefHeightCheckbox')) ? ({ [`opacity`]: 0.4 }) : ({ [`opacity`]: 1 }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/activities-search/components/24afeeb984013f0b5d7bb52301ffb20b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['financialRole'] = null;
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['financialRole'] = 'passenger';
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'financialRole')) == null)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/activities-search/components/894f9fad07ec6cbbf8d489e858bfb49c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['category'] = 'All categories';
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('4236b579d2c7e60dbe1dc23cc4a4232b', (getObjectProperty(___arguments.context.pageData, 'category')));
  ___arguments.context.pageData['radius'] = null;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('be6599fe600b582619c8cd6cd5026c81', (getObjectProperty(___arguments.context.pageData, 'radius')));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['age'] = [18, 100];
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefAgeCheckbox'] = true;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'] = [];
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefGenderCheckbox'] = true;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['height'] = null;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['heightPrefix'] = null;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefHeightCheckbox'] = true;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['financialRole'] = null;
  ___arguments.context.pageData['dateStart'] = null;
  ___arguments.context.pageData['dateEnd'] = null;
  ___arguments.context.pageData['dateStartTemp'] = null;
  ___arguments.context.pageData['dateEndTemp'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc0e9037c748bf5872366949cc92f977', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/550d4154da03160a1f63404613b3572f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('550d4154da03160a1f63404613b3572f')).includes('filterItem__dateRange--active'))) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('550d4154da03160a1f63404613b3572f')).push('filterItem__dateRange--active');
  }
  ___arguments.context.pageData['dateStartTemp'] = ((getObjectProperty(___arguments.context.pageData, 'dateStart')) ? (getObjectProperty(___arguments.context.pageData, 'dateStart')) : null);
  ___arguments.context.pageData['dateEndTemp'] = ((getObjectProperty(___arguments.context.pageData, 'dateEnd')) ? (getObjectProperty(___arguments.context.pageData, 'dateEnd')) : null);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('550d4154da03160a1f63404613b3572f'))['pointer-events'] = 'none';
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['asideBtnApplyDisabled'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/5fe274941ef3e6ddc3784a33c56dae9e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('550d4154da03160a1f63404613b3572f')), 'filterItem__dateRange--active', '');
  ___arguments.context.pageData['dateStart'] = (getObjectProperty(___arguments.context.pageData, 'dateStartTemp'));
  ___arguments.context.pageData['dateEnd'] = (getObjectProperty(___arguments.context.pageData, 'dateEndTemp'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('550d4154da03160a1f63404613b3572f'))['pointer-events'] = 'auto';
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['asideBtnApplyDisabled'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc0e9037c748bf5872366949cc92f977', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/75aaf0cb778f300f05b10a9195e84374/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var dateContent;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dateStart')) && !(getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    dateContent = ['From - ',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getFullYear())].join('');
  } else if (!(getObjectProperty(___arguments.context.pageData, 'dateStart')) && (getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    dateContent = ['To - ',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getFullYear())].join('');
  } else if ((getObjectProperty(___arguments.context.pageData, 'dateStart')) && (getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    dateContent = [[(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getFullYear())].join(''),' - ',[(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getFullYear())].join('')].join('');
  } else if (!(getObjectProperty(___arguments.context.pageData, 'dateStart')) && !(getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    dateContent = 'Select date';
  }

  return dateContent

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activities-search/components/3dcdf747b98e1c92289244a7a389a05d/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dateStart'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var selectedDate;


  if (___arguments.value) {
    selectedDate = (new Date(___arguments.value));
    selectedDate.setHours(0);
    selectedDate.setMinutes(0);
    ___arguments.context.pageData['dateStart'] = (selectedDate.valueOf());
  } else {
    ___arguments.context.pageData['dateStart'] = null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc0e9037c748bf5872366949cc92f977', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/activities-search/components/17fbb43ef86f24fb9e8f8519999e4d99/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dateEnd'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var selectedDate;


  if (___arguments.value) {
    selectedDate = (new Date(___arguments.value));
    selectedDate.setHours(23);
    selectedDate.setMinutes(59);
    selectedDate.setSeconds(59);
    ___arguments.context.pageData['dateEnd'] = (selectedDate.valueOf());
  } else {
    ___arguments.context.pageData['dateEnd'] = null;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc0e9037c748bf5872366949cc92f977', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/activities-search/components/52926e5ac578fb325dd4891b5fb124f7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'dateStart')) && (getObjectProperty(___arguments.context.pageData, 'dateEnd')) && (getObjectProperty(___arguments.context.pageData, 'dateStart')) > (getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bc0e9037c748bf5872366949cc92f977', true);
  } else {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('550d4154da03160a1f63404613b3572f')), 'filterItem__dateRange--active', '');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('550d4154da03160a1f63404613b3572f'))['pointer-events'] = 'auto';
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['asideBtnApplyDisabled'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/b614823302a147d95f5d6f3103ea78dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/d01fe677c1c47d7bb4b4cbd86879041a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activities-search/components/55668d3604fe1aacab92c0a8e3070653/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['searchInputText'] = '';
  ___arguments.context.pageData['searchInput'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', true);
  delete ___arguments.context.pageData['noMoreActivities'];
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['pastActivities'];
  ___arguments.context.pageData['activityListAll'] = (await BackendlessUI.Functions.Custom['fn_10ec5a56ee543c1efe719ed5ba61441a'](___arguments.context.pageData));
  ___arguments.context.appData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
  ___arguments.context.pageData['activityList'] = (getObjectProperty(___arguments.context.pageData, 'activityListAll'));
  ___arguments.context.appData['searchActivity'] = (getObjectProperty(___arguments.context.pageData, 'searchInputText'));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18bb7492395ea009014c87d41ba811fa', false);
  await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/0dff861bd668ff041345b8aecf64aa9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'ownerId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activities-search/components/f42eb96b04c85f9f2ba36c5beb78cecd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab111dfdfa2395d6f9d6333832e2b91'), 'order')) == 4)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/4656e7b669fd310c5462125d02b29333/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/27292276b8a4ecdff87d30d618b5bf59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('personal-data-quiz', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/44052603e929851ad9234dfd84e81683/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var owner, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'allUsers')) {
    ___arguments.context.pageData['activityOwnerList'] = [];
    owner = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'allUsers')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'ownerId')));
    }));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'activityOwnerList')), (owner[0]));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/activity/components/b6c2bb4d94fda823c8cf82cebc8e7fde/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'categoryName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/69b9a7435b6e5a774f967f27f307dc8b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  if ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile'))) {
    getRTSubscriptions().remove((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'objectId')));
  }

  },
  /* handler:onBeforeUnmount */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var currentUser, item, error, object, isChat, userCover, activityId;

  },
  /* handler:onBeforeMount */
  /* content */
}))
// /
//   
define('./pages/activity/components/660ba6897508db5549c885bf9ea46e73/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/65415c18b0fca6c5e061237867995b25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/4187b1854e4c566789a60b465d7b6675/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    return (String((await (async function(year, month, day) {
    	let now = new Date();
    	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    	let dob = new Date(year, month, day);

    	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

    	let age;

    	age = today.getFullYear() - dob.getFullYear();

    	if (today < dobnow) {
    	  age = age-1;
    	} else {
    	  age = age
    	}

    	return age

    })((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'birthDate'))).getFullYear()), (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'birthDate'))).getMonth()), (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'birthDate'))).getDate())))) + String(' Years Old'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/814ee84b0f6d53815959599fe22b6916/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var height, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    height = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'heightList')), async (item) => {


     return ((getObjectProperty(item, 'value')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'height')));
    }))[0];
    if (height) {
      return ((getObjectProperty(height, 'label')).slice(0, (getObjectProperty(height, 'label')).indexOf(' ') + 1));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/8a236ed593cfad09a4265969bb345b53/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate')) {
      return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate'))));
    } else if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming'));
    }
  }

  return 'To be scheduled'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/7bd41a9de118c67951b68e6fd0d80685/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async onSourceUrlAssignment(___arguments) {
    var item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'media')) {
      try {
        return (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'media')), async (item) => {


         return ((getObjectProperty(item, 'isCover')) == true);
        }))[0]), 'file'));

      } catch (error) {
        console.log(error);
        return 'styles/img/placeholder_photo.png';

      }
    } else {
      return 'styles/img/placeholder_photo.png';
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/4a28da2d7a952f27113e6f62e3cf5de5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    
  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/cf1b5cda2f499162fb74553332da9372/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) {
      return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) + String('\'s '));
    } else {
      return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login')) + String('\'s '));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/e937903899af201ec38d2a2adc096398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'outOfService')) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/b77fdf2637d5ad66504c7f9e52f3f4f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-activities', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/6465e80a2358bd62c423aaba884644d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (pageName, pageData) { BackendlessUI.goToPage(pageName, pageData) })('edit-activity', ({ 'activityId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')) }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) == (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming'))) {
        return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate')) > ((new Date()).valueOf()) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming')) ? true : false);
      } else if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming'))) {
        return true;
      }
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/6e695a29c0a923fdd02eed655d4c67ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'description'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/3a152476ea7500c5d9175d541dec93ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'zodiac'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/e4fd2a420218c704fab7639853f40f8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole'));
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/d7fe2313a28319cac025d3c956dcf78b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/5271f505f2f435b3c51fd2f22f33fd99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['backBtnIsClicked'] = true;
  if (getObjectProperty(___arguments.context.pageData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ [`getChat`]: (getObjectProperty(___arguments.context.pageData, 'getChat')) }));
    return ;
  }
  if (getObjectProperty(___arguments.context.appData, 'previousPage')) {
    if ((getObjectProperty(___arguments.context.appData, 'previousPage')) == 'activities-search' || (getObjectProperty(___arguments.context.appData, 'previousPage')) == 'profiles') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), ({ [`notUpdate`]: true }));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), undefined);
    }
  } else {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/87e119f4e0e9b12abc1fb58d0acfd4af/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'zodiac'))) {
    return (['styles/media/zodiac/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'zodiac')).toLowerCase(),'.svg'].join(''));
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity/components/7acf273cdc154e7c1f0ff85b33388e65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
    return false;
  } else if (getObjectProperty(___arguments.context.pageData, 'alertMessage')) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, isActivityInServiceArea, userLocation, recentMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  console.log('click');
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')).includes('disabled')) {
    return ;
  }
  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');
    } else {
      if (getObjectProperty(___arguments.context.pageData, 'isInvitation')) {
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'deletedBySender')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'sender')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'deletedByReceiver')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'receiver'))) {
          recentMessage = (await Backendless.Request.get(`${Backendless.appPath}/services/messages/getRecentChatMessage`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'chatId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'objectId'))) }).send());
          if (recentMessage) {
            if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'deletedBySender')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'deletedBySender')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'deletedByReceiver'))) > (getObjectProperty(recentMessage, 'created'))) {
              ___arguments.context.pageData['resumeDeletedChat'] = true;
              addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')), 'open');
            } else {
              (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ [`getChat`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'objectId')) }));
            }
          } else {
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ [`getChat`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'objectId')) }));
          }
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ [`getChat`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'objectId')) }));
        }
      } else {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')), 'open');
      }
    }
  } else {
    ___arguments.context.pageData['disableBePlusOneBtn'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2b153aaf767526a6c4458b9b1ba4abeb', true);
    userLocation = (await BackendlessUI.Functions.Custom['fn_47bed951feaa47e346a419d69147a6a6']());
    if (!userLocation) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
      return ;
    }
    try {
      isActivityInServiceArea = (await Backendless.Request.get(`${Backendless.appPath}/services/isActivityInServiceArea/isActivityInServiceArea`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'activityId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'activityId'))),'userLat': ((getObjectProperty((getObjectProperty(userLocation, 'locationGeoPoint')), 'coordinates')).slice(-1)[0]),'userLng': ((getObjectProperty((getObjectProperty(userLocation, 'locationGeoPoint')), 'coordinates'))[0]) }).send());
      ___arguments.context.pageData['disableBePlusOneBtn'] = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2b153aaf767526a6c4458b9b1ba4abeb', false);
      if (isActivityInServiceArea) {
        localStorage.setItem('userRequestActivity', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'activityId'))));
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity-far', ({ [`authorLogin`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorLogin')) }));
      }

    } catch (error) {
      console.log(error);
      console.log('error');
      ___arguments.context.pageData['disableBePlusOneBtn'] = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2b153aaf767526a6c4458b9b1ba4abeb', false);

    }
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorName')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorName')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorLogin'));
    if ((getObjectProperty(___arguments.context.pageData, 'isInvitation')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'accepted') {
      if (name2) {
        return (String('Continue chatting with ') + String(name2));
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'isInvitation')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'new') {
      return 'View invitation';
    } else if ((getObjectProperty(___arguments.context.pageData, 'isInvitation')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'rejected') {
      return 'Request already sent';
    }
  }

  return (['Be ',name2,'\'s '].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      return ['btn btn--primary']

  },
  /* handler:onClassListAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'disableBePlusOneBtn')) {
    return true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'activityDate')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'activityDate')) < ((new Date()).valueOf())) {
    if ((getObjectProperty(___arguments.context.pageData, 'isInvitation')) && ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'new' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'accepted')) {
      return false;
    } else {
      return true;
    }
  }

  return false

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/activity/components/ba91f952324802d404d8d70cb77f917b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    return ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) == (getObjectProperty(___arguments.context.pageData, 'currentUser')));
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/3f3c1a21a2015662b12119510f954def/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    return ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) != (getObjectProperty(___arguments.context.pageData, 'currentUser')));
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/677e08cf3be6aebbcfe8e665a28d0b3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/aea919c8e7c3c40e13e84e0a8beb98d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/7c0b817d980e31a3741e77c373f2619f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['counter'] = (String(getValueLength(___arguments.value)) + String('/500 symbols'));
  if (!___arguments.value.trim().length) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')), 'alert-border');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00ec1a41a6f822d91a8e12ee551870bf', true);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')).includes('alert-border')) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')), 'alert-border', '');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00ec1a41a6f822d91a8e12ee551870bf', false);
    }
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login'));
  }
  if (name2) {
    if (getObjectProperty(___arguments.context.pageData, 'resumeDeletedChat')) {
      return (String('You previously deleted this chat. To resume the chat, send a message to ') + String(name2));
    } else {
      return (['Let ',name2,' know why you would be the perfect +1!'].join(''));
    }
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onPlaceholderAssignment */
  ['onPlaceholderAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'resumeDeletedChat')) ? '' : 'Be fun and creative. Let them know why you are a perfect +1')

  },
  /* handler:onPlaceholderAssignment */
  /* content */
}))

define('./pages/activity/components/c09c346410c1934301c759efb5a960ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login'));
  }
  if (name2) {
    if (getObjectProperty(___arguments.context.pageData, 'resumeDeletedChat')) {
      return (String('Send a message to ') + String(name2));
    } else {
      return (['Become ',name2,'\'s  '].join(''));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/dbe14ec582a2b1dbe503b87c85bc55da/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['counter'] = '0/500 symbols';

  },
  /* handler:onBeforeMount */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f19d3a052602b0645fa17be5e95cdb68'))['margin-bottom'] = '50vh';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0241c30d9a4ce56459ce2e79ea546a0d')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/0763d153c58a9f88badfb46b4eeaf004/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var isNotificationsEnabled, newMessage, currentSenderChatId, newChat, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function resumeChat() {
  newMessage = ({ [`chatId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'objectId')),[`message`]: (getObjectProperty(___arguments.context.pageData, 'requestMessage')),[`sender`]: ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) }),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),[`receiver`]: ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')) }),[`type`]: 'text',[`created`]: ((new Date()).valueOf()),[`isRead`]: false });
  await Backendless.Messaging.publish('default', newMessage, new Backendless.PublishOptions({ subtopic: '', headers: ({ [`chatId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'objectId')),[`receiverId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')) }) }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
  if (isNotificationsEnabled) {
    currentSenderChatId = (await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId'))).get());
    if (currentSenderChatId == null || currentSenderChatId != (getObjectProperty(newMessage, 'chatId'))) {
      await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('message', (String('New message from ') + String(getObjectProperty(newMessage, 'senderName'))), 'messages', (getObjectProperty(newMessage, 'chatId')), (getObjectProperty((getObjectProperty(newMessage, 'receiver')), 'objectId')), null, null, null);
    }
  }
  delete ___arguments.context.pageData['resumeDeletedChat'];
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ [`getChat`]: (getObjectProperty(newMessage, 'chatId')) }));
}

/**
 * Describe this function...
 */
async function createChat() {
  try {
    newChat = (await Backendless.Request.post(`${Backendless.appPath}/services/createChat/createChatFromActivity`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'activityType': 'activityRequest','activityId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')),'plusOneId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')),'message': (getObjectProperty(___arguments.context.pageData, 'requestMessage')) }));
    if (isNotificationsEnabled) {
      try {
        await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('invites', ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),' asks to join your activity "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name')),'"'].join('')), 'messages', newChat, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')), null, null, null);

      } catch (error) {
        console.log(error);

      }
    }

  } catch (error) {
    console.log(error);

  }
  ;(async () => {
      await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('receivedInvitation', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), newChat, null);

  })();
}


  if ((getObjectProperty(___arguments.context.pageData, 'requestMessage')) && !!(getObjectProperty(___arguments.context.pageData, 'requestMessage')).trim().length) {
    ___arguments.context.pageData['disableBtn'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92977129da7d0947cef23122ed31ae44', true);
    isNotificationsEnabled = !(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'settings')) || (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'settings')) && (((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'settings')), 'notifications')).includes('message')) || ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'settings')), 'notifications')).includes('invites')));
    if (getObjectProperty(___arguments.context.pageData, 'resumeDeletedChat')) {
      await resumeChat();
      return ;
    } else {
      await createChat();
    }
    delete ___arguments.context.pageData['disableBtn'];
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('92977129da7d0947cef23122ed31ae44', false);
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')).pop();
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a6ce736b6a4d989d764c4412413fd541')), 'open');
  } else {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')), 'alert-border');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00ec1a41a6f822d91a8e12ee551870bf', true);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/4512d4e953f1972f90db0004a17fc9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')).pop();
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')).includes('alert-border')) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')), 'alert-border', '');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('00ec1a41a6f822d91a8e12ee551870bf', false);
  }
  ___arguments.context.pageData['requestMessage'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/3b52dbaf320f544c6c4880153a0cd98e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a6ce736b6a4d989d764c4412413fd541')).pop();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/f6c57a120f6ee6cfc8238488f30caf82/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    return ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) != (getObjectProperty(___arguments.context.pageData, 'currentUser')));
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/dfa10baffe6da20dc6a7851c3eeae838/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'photoThumbnail'));
  }

  return 'styles/media/icons/user-black.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity/components/dfeb464bec4359fb436190f36259f96a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var currentUserName, error, item, repeaterDataVar;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dfeb464bec4359fb436190f36259f96a'))['pointer-events'] = 'none';
  if ((getObjectProperty(___arguments.context.pageData, 'activity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'ownerId'))) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfeb464bec4359fb436190f36259f96a')).slice(-1)[0] != 'clicked') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfeb464bec4359fb436190f36259f96a')), 'clicked');
      if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities'))) {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['likedActivities'] = [];
      }
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')), ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'objectId')),[`ts`]: ((new Date()).valueOf()) }));
      currentUserName = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
      try {
        await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', ([currentUserName,' just liked your activity "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'name')),'"'].join('')), null, null, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'ownerId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'ownerId')));
        await (getChannelInstance('likes')).send('', ({ [`message`]: [currentUserName,' just liked your activity "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'name')),'"'].join(''),[`receiver`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'ownerId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: currentUserName }));

      } catch (error) {
        console.log(error);

      }
      await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'objectId')),'parameter': 'likedActivities','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfeb464bec4359fb436190f36259f96a')).pop();
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['likedActivities'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')), async (item) => {


       return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'objectId')) != (getObjectProperty(item, 'objectId')));
      }));
      await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'objectId')),'parameter': 'likedActivities','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
    }
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dfeb464bec4359fb436190f36259f96a'))['pointer-events'] = 'auto';
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentUser'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/4109238cffa15ea1f87ca90b4284aef7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'height'));
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/d483bde8f4eb22e82b9e463ce0344774/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'locationPoint')) {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login'));
    if ((getObjectProperty(___arguments.context.appData, 'messagesNumber')) > 0) {
      return (['(',(getObjectProperty(___arguments.context.appData, 'messagesNumber')),') ',name2,'\'s activity'].join(''));
    } else {
      return (String(name2) + String('\'s activity'));
    }
  }

  return 'Activity'

  },
  /* handler:onTitleAssignment */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	if (swiper) {

  	  if (Array.isArray(swiper)) {
  	    for (const swiperItem of swiper) {
  	      swiperItem.destroy(true, true);
  	    }
  	  } else {
  	    swiper.destroy(true, true)
  	  }

  	}
  })();
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  getRTSubscriptions().remove('push');
  ___arguments.context.appData['chatList'] = (getObjectProperty(___arguments.context.pageData, 'chatList'));

  },
  /* handler:onLeave */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('90ac21f893b35b0e53bb7126aadd83e1')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e82d5ff2512cc9df6c7f920494b40d88'))) {
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e82d5ff2512cc9df6c7f920494b40d88', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('90ac21f893b35b0e53bb7126aadd83e1', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e82d5ff2512cc9df6c7f920494b40d88', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('90ac21f893b35b0e53bb7126aadd83e1', true);
    }
  }

  },
  /* handler:onResize */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var currentUser, item, error, object, isChat, userCover, activityId;

/**
 * Describe this function...
 */
async function setHeightList() {
  ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″ (122 cm)' }), ({ [`value`]: '124',[`label`]: '4′1″ (124 cm)' }), ({ [`value`]: '127',[`label`]: '4′2″ (127 cm)' }), ({ [`value`]: '130',[`label`]: '4′3″ (130 cm)' }), ({ [`value`]: '132',[`label`]: '4′4″ (132 cm)' }), ({ [`value`]: '135',[`label`]: '4′5″ (135 cm)' }), ({ [`value`]: '137',[`label`]: '4′6″ (137 cm)' }), ({ [`value`]: '140',[`label`]: '4′7″ (140 cm)' }), ({ [`value`]: '142',[`label`]: '4′8″ (142 cm)' }), ({ [`value`]: '145',[`label`]: '4′9″ (145 cm)' }), ({ [`value`]: '152',[`label`]: '5′0″ (152 cm)' }), ({ [`value`]: '155',[`label`]: '5′1″ (155 cm)' }), ({ [`value`]: '157',[`label`]: '5′2″ (157 cm)' }), ({ [`value`]: '160',[`label`]: '5′3″ (160 cm)' }), ({ [`value`]: '163',[`label`]: '5′4″ (163 cm)' }), ({ [`value`]: '165',[`label`]: '5′5″ (165 cm)' }), ({ [`value`]: '168',[`label`]: '5′6″ (168 cm)' }), ({ [`value`]: '170',[`label`]: '5′7″ (170 cm)' }), ({ [`value`]: '173',[`label`]: '5′8″ (173 cm)' }), ({ [`value`]: '176',[`label`]: '5′9″ (176 cm)' }), ({ [`value`]: '178',[`label`]: '5′10″ (178 cm)' }), ({ [`value`]: '180',[`label`]: '5′11″ (180 cm)' }), ({ [`value`]: '183',[`label`]: '6′0″ (183 cm)' }), ({ [`value`]: '185',[`label`]: '6′1″ (185 cm)' }), ({ [`value`]: '188',[`label`]: '6′2″ (188 cm)' }), ({ [`value`]: '191',[`label`]: '6′3″ (191 cm)' }), ({ [`value`]: '193',[`label`]: '6′4″ (193 cm)' }), ({ [`value`]: '195',[`label`]: '6′5″ (195 cm)' }), ({ [`value`]: '198',[`label`]: '6′6″ (198 cm)' }), ({ [`value`]: '201',[`label`]: '6′7″ (201 cm)' }), ({ [`value`]: '203',[`label`]: '6′8″ (203 cm)' }), ({ [`value`]: '206',[`label`]: '6′9″ (206 cm)' }), ({ [`value`]: '208',[`label`]: '6′10″ (208 cm)' }), ({ [`value`]: '211',[`label`]: '6′11″ (211 cm)' }), ({ [`value`]: '213',[`label`]: '7′0″ (213 cm)' })];
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
    ___arguments.context.pageData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
  } else if (getObjectProperty(___arguments.context.appData, 'currentUser')) {
    currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser'));
    ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  } else {
    ___arguments.context.pageData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
  }
  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
      return ;
    }
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name'));
    ___arguments.context.appData['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
    currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    try {
      await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);

    } catch (error) {
      console.log(error);

    }
    if (!(await BackendlessUI.Functions.Custom['fn_c52974435ae439961137e54a2d451282']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c42ef89fbae40460e970d0c1b05188d', true);
      return ;
    }
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c872f5d052e97d671d3b064b9a502e1')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c872f5d052e97d671d3b064b9a502e1', true);
  }
  await setHeightList();
  activityId = (getObjectProperty(___arguments.context.pageData, 'activityId')) ? (getObjectProperty(___arguments.context.pageData, 'activityId')) : (getObjectProperty(___arguments.context.pageData, 'activityCode'));
  try {
    ___arguments.context.pageData['activity'] = (await Backendless.Request.get(`${Backendless.appPath}/services/activity/getActivityDetails`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'activityId': JSON.stringify(activityId) }).send());
    if (getObjectProperty(___arguments.context.pageData, 'activity')) {
      ___arguments.context.pageData['profileStatus'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorProfileStatus'));
    }

  } catch (error) {
    console.log(error);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('441188383fc30858b9d286b2c0de9654')), 'open');
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c872f5d052e97d671d3b064b9a502e1')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c872f5d052e97d671d3b064b9a502e1', false);
    }

  }
  if (!(getObjectProperty(___arguments.context.pageData, 'activity'))) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('441188383fc30858b9d286b2c0de9654')), 'open');
  }
  if (getObjectProperty(___arguments.context.pageData, 'activity')) {
    await (async function(url, title, description, img) {
    	const meta = document.createElement('meta')
    	const meta1 = document.createElement('meta')
    	const meta2 = document.createElement('meta')
    	const meta3 = document.createElement('meta')
    	const meta4 = document.createElement('meta')
    	const meta5 = document.createElement('meta')

    	meta.setAttribute('property', 'og:type')
    	meta.setAttribute('content', 'website')
    	document.querySelector("head").prepend(meta)
    	meta1.setAttribute('property', 'og:url')
    	meta1.setAttribute('content', url)
    	document.querySelector("head").prepend(meta1)
    	meta2.setAttribute('property', 'og:title')
    	meta2.setAttribute('content', title)
    	document.querySelector("head").prepend(meta2)
    	meta3.setAttribute('property', 'og:description')
    	meta3.setAttribute('content', description)
    	document.querySelector("head").prepend(meta3)
    	// meta4.setAttribute('property', 'og:image')
    	// meta4.setAttribute('content', img)
    	// document.querySelector("head").prepend(meta4)
    	meta5.setAttribute('property', 'og:site_name')
    	meta5.setAttribute('content', 'Find my +1')
    	document.querySelector("head").prepend(meta5)

    })('https://app.findmyplus.one/', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'name')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'description')), (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'media'))[0]), 'file')));
    if (!(getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'visibility')) != 1) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('registration', undefined);
      return ;
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'currentUser')) || (getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'ownerId'))) {
      ___arguments.context.pageData['allUsers'] = [({ [`name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorName')),[`login`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorLogin')),[`birthDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorBirthDate')),[`zodiac`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorZodiac')),[`authorShortDescr`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorShortDescr')),[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'ownerId')),[`isBlocked`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'isBlocked')),[`userProfile`]: ({ [`likesCount`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorlikesCount')),[`media`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorMedia')),[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), ' authorProfileId')),[`height`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorHeight')) }) })];
    } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'ownerId'))) {
      ___arguments.context.pageData['allUsers'] = [(getObjectProperty(___arguments.context.pageData, 'currentUser'))];
    } else {
    }
    if (getObjectProperty(___arguments.context.pageData, 'allUsers')) {
      ___arguments.context.pageData['currentActivityOwner'] = ((getObjectProperty(___arguments.context.pageData, 'allUsers'))[0]);
    }
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'isBlocked')) {
      delete ___arguments.context.appData['users'];
      delete ___arguments.context.appData['searchActivity'];
      delete ___arguments.context.appData['searchProfiles'];
      (function () { window.history.back(); })();
    }
    (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner'))['activity'] = (getObjectProperty(___arguments.context.pageData, 'activity'));
    ___arguments.context.pageData['currentActivity'] = (getObjectProperty(___arguments.context.pageData, 'activity'));
    if ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'activity'))) {
      ___arguments.context.pageData['currentActivity'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'activity'));
      if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
        if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media')) {
          ___arguments.context.pageData['imageList'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media'));
        }
        ___arguments.context.pageData['location'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'location'));
      }
    }
    if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'locationPoint')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'locationPoint')), 'coordinates'))) {
      (getObjectProperty(___arguments.context.pageData, 'currentActivity'))['locationPoint'] = ({ [`lat`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'locationPoint')), 'coordinates')).slice(-1)[0],[`lng`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'locationPoint')), 'coordinates'))[0] });
    }
    if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
      try {
        userCover = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


         return ((getObjectProperty(item, 'isCover')) == true);
        }))[0];
        if (userCover) {
          (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty(userCover, 'file'));
        }

      } catch (error) {
        console.log(error);

      }
    }
    await new Promise(r => setTimeout(r, 10 || 0));
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c872f5d052e97d671d3b064b9a502e1')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c872f5d052e97d671d3b064b9a502e1', false);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('234b2175dd78fb65a874d61666a2f0fe', true);
    ;(async () => {
        if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'ownerId'))) {
        ___arguments.context.pageData['userActivityList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivity/getActivitiesActivityPage`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'userId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId'))),'excludeActivityId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId'))) }).send());
      }
      if ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
          (getObjectProperty(___arguments.context.pageData, 'currentActivity'))['keepLocationPrivate'] = false;
        }
      }
      if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'chat')) && !!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'chat')).length && (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
        isChat = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'chat')), async (item) => {


         return ((getObjectProperty(item, 'sender')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')));
        }));
        ___arguments.context.pageData['isInvitation'] = ((await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'chat')), async (item) => {


         return ((getObjectProperty(item, 'receiver')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) || (getObjectProperty(item, 'sender')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')));
        }))[0]);
        if ((getObjectProperty(___arguments.context.pageData, 'isInvitation')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'accepted') {
          (getObjectProperty(___arguments.context.pageData, 'currentActivity'))['keepLocationPrivate'] = false;
        }
        if (!!isChat.length) {
          if ((getObjectProperty((isChat[0]), 'status')) == 'accepted') {
            (getObjectProperty(___arguments.context.pageData, 'currentActivity'))['keepLocationPrivate'] = false;
          }
        }
      }
      await (async function() {
      	let counter = 0;

      	const checkRender = setInterval (swiperInit, 100);

      	function swiperInit() {
      	  const activityImgId = document.querySelector('.activityImgId');

      	  if (activityImgId || (counter >= 10000)) {
      	    swiper = new Swiper('.swiper', {
      	      pagination: {
      	        el: '.swiper-pagination',
      	        clickable: true
      	      }
      	    });

      	    clearInterval(checkRender);
      	  }

      	  counter += 100;
      	}
      })();
      if ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile'))) {
        getRTSubscriptions().remove((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'objectId')));
        try {

          ;(function(whereClause) {
            const callback = async object => {
                if (object && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'objectId')) == (getObjectProperty(object, 'objectId'))) {
              if (getObjectProperty(object, 'likesCount')) {
                (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile'))['likesCount'] = (getObjectProperty(object, 'likesCount'));
              }
            }

            };

            const rtHandlers = Backendless.Data.of('UserProfile').rt();

            const options = [callback];

            if (whereClause) {
               options.unshift(whereClause);
            }

            rtHandlers.addUpdateListener.apply(rtHandlers, options);

            getRTSubscriptions().add((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'objectId')), () => rtHandlers.removeUpdateListener(callback));

          })((['objectId=\'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'objectId')),'\''].join('')));

        } catch (error) {
          console.log(error);

        }
      }
      if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
        if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')) && (((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')).map(item => item['objectId'])).includes((getObjectProperty(___arguments.context.pageData, 'activityId'))))) {
          addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfeb464bec4359fb436190f36259f96a')), 'clicked');
        }
        ___arguments.context.pageData['user'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'allUsers')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(currentUser, 'objectId')));
        }))[0]);
        if (getObjectProperty(___arguments.context.pageData, 'user')) {
          if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
            await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'parameter': 'seenBy','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'objectId')) });
          }
        }
      }
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'likedBy')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'likesCount')) != (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'likedBy')).length) {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile'))['likesCount'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'likedBy')).length);
        await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'objectId')),'likesCount': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'likesCount')) });
      }
      if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
        ___arguments.context.pageData['alertMessage'] = (['Describe why ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')),' need to pick you'].join(''));
      }

    })();
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_activity_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/activity/components/ddf3159b707971be8f264be6a9215538/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var media;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 2000 || 0));
  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    media = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media'));
  }
  if (media) {
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
      return (media.slice(0, 5));
    } else {
      return (media.slice(0, 4));
    }
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/activity/components/4649f693e2b6c007d36fc4a3db37a897/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['imageList'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'imageList')).map(async item => {  if ((getObjectProperty(item, 'file')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('e42cc18da21dca017acbd27a779936ba'), 'file'))) {
      item['current'] = true;
    } else {
      item['current'] = false;
    }
  ; return item;})));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/a07a6fe9044d29badd1975a4b62b9d8a/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'media'))) {
    return 'styles/img/placeholder_photo.png';
  }

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('616ca1ebe566008a7436a6f40a2dab71'), 'file'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity/components/aa82dc320913998c74f7dd0279acca8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login'));
  }
  if (name2) {
    if (getObjectProperty(___arguments.context.pageData, 'resumeDeletedChat')) {
      return (String('Send a message to ') + String(name2));
    } else {
      return (['Become ',name2,'\'s  '].join(''));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/2da745ca8bf99428385b90effba145e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/6861b8874438bf787d62aab89a7fe55f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/2a4a45bcf78b084c76790d5f36e3ce63/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var photo, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'media')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'media')).length) {
      photo = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'media')), async (item) => {


       return (getObjectProperty(item, 'isCover'));
      }))[0];
      return (photo ? (getObjectProperty(photo, 'file')) : 'styles/img/placeholder_photo.png');
    } else {
      return 'styles/img/placeholder_photo.png';
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity/components/5947a301eddf63d6c1ba1c4dcdd9f04d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'category')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/071efbfb2f64f64e57f8c1c2cab7e179/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'driver') {
      return ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login')),' is ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')),' & Me - passenger'].join(''));
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'passenger') {
      return ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login')),' is ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')),' & Me - driver'].join(''));
    } else {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/d42e0cedf513b33208bf741405343282/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name'));
    } else {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/70dd7ce2a419cd450acd72d5c35be7a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    return ((new Date((new Date())).getFullYear()) - (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'birthDate'))).getFullYear()));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/d5d28709124ec837f2e93e889f6bb588/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityTitle')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityTitle')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'description')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/d3baa37bfccf1eae26cdb6f39aed4b51/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate')) {
      return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate'))));
    } else if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming'));
    } else {
      return 'To be scheduled';
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/de43a3b3ea282d3c41628b5f7d4781c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/b79b9e05550a180601fecb01e49b0027/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login'));
    return (['We have successfully notified ',name2,' about your interest to be their',' <img src="styles/img/icons/logoIcon.svg" style=" width: 25 px ;" /> ','. You will be able to chat with ',name2,' when they accept your request.'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/75d6245fadea90971148463162e6686e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, currentUser, isChat;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c872f5d052e97d671d3b064b9a502e1', true);
  await new Promise(r => setTimeout(r, 200 || 0));
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (false) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8d168aace99e6f9c71adfc78f96a9193')));
    }
  } else {
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c1812ddb4bc95131d286fa14b052785c')) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c1812ddb4bc95131d286fa14b052785c')));
    }
  }
  ___arguments.context.pageData['activity'] = (await Backendless.Request.get(`${Backendless.appPath}/services/activity/getActivity`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'activityId': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId'))) }).send());
  ___arguments.context.pageData['currentActivity'] = (getObjectProperty(___arguments.context.pageData, 'activity'));
  currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  ___arguments.context.pageData['activityList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivity/getActivities`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'user': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId'))),'objectId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId'))),'pageSize': 3,'relation': JSON.stringify('category'),'sort': JSON.stringify('activityDate'),'whereClause': JSON.stringify((['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')),'\'',['and objectId!= \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')),'\''].join(''),['and visibility!=3 and (activityDate is null or activityDate >=',((new Date()).valueOf()),')'].join('')].join(''))) }).send());
  ___arguments.context.pageData['alertMessage'] = (['Describe why ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')),' need to pick you'].join(''));
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media')) {
    ___arguments.context.pageData['imageList'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ddf3159b707971be8f264be6a9215538', true);
  }
  ___arguments.context.pageData['location'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'location'));
  if (!!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')));
  })).length) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfeb464bec4359fb436190f36259f96a')), 'clicked');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c872f5d052e97d671d3b064b9a502e1', false);
  if (!!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'chat')).length) {
    if (!!(await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'chat')), async (item) => {


     return ((getObjectProperty((getObjectProperty(item, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')));
    })).length) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')), 'disabled');
    } else {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')).includes('disabled')) {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')).pop();
      }
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')).includes('disabled')) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')).pop();
    }
  }
  ___arguments.context.pageData['isInvitation'] = ((await Backendless.Request.get(`${Backendless.appPath}/services/chatInvitation/isInvitation`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'activityId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId'))) }).send())[0]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/99fb8321d874baaaa3479c770d83658f/bundle.js', [], () => ({
  /* content */
  /* handler:onMapCenterAssignment */
  onMapCenterAssignment(___arguments) {
      if (___arguments.context.pageData['currentActivity']) {
    if ((___arguments.context.pageData['currentActivity'])['locationPoint']) {
      return ({ 'lat': (((___arguments.context.pageData['currentActivity'])['locationPoint'])['lat']),'lng': (((___arguments.context.pageData['currentActivity'])['locationPoint'])['lng']) });
    }
  }

  },
  /* handler:onMapCenterAssignment */
  /* handler:onPointsAssignment */
  onPointsAssignment(___arguments) {
      if (___arguments.context.pageData['currentActivity']) {
    if (!((___arguments.context.pageData['currentActivity'])['keepLocationPrivate'])) {
      if ((___arguments.context.pageData['currentActivity'])['locationPoint']) {
        return [((___arguments.context.pageData['currentActivity'])['locationPoint'])];
      }
    } else {
      return [];
    }
  }

  },
  /* handler:onPointsAssignment */
  /* handler:onMapZoomAssignment */
  onMapZoomAssignment(___arguments) {
      if (___arguments.context.pageData['currentActivity']) {
    if ((___arguments.context.pageData['currentActivity'])['keepLocationPrivate']) {
      return 11;
    } else {
      return 15;
    }
  }

  },
  /* handler:onMapZoomAssignment */
  /* content */
}))

define('./pages/activity/components/54772498579e340d7db84e1176ea92ad/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) == (getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate'))) {
      return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate')) < ((new Date()).valueOf()) ? true : false);
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/a41a2bea9573e3612c35eec6b9198657/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await ( async function (pageName, pageData) { BackendlessUI.goToPage(pageName, pageData) })('edit-activity', ({ 'activityId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/a9b21d669606a6e2381aab79027289e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/activity/components/06e664a27aede264a82ad1ff622829ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/89afbaf2e0bff3b74d330dac26ed88e6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'driver') {
      if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'photoThumbnail'));
      } else {
        return 'styles/img/icons/pic_profile.svg';
      }
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'passenger' && (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
      if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
      } else {
        return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photo'));
      }
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'))) {
        return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
      } else {
        return 'styles/img/icons/pic_profile.svg';
      }
    }
  }

  return 'styles/img/icons/pic_profile.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity/components/d8f54c89c5855c33971cda566df3b90f/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async onSourceUrlAssignment(___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if (!(getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'driver') {
        return 'styles/img/icons/user-black.svg';
      } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'passenger') {
        if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'photoThumbnail')) {
          return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'photoThumbnail'));
        } else {
        }
        return 'styles/img/icons/user-black.svg';
      } else {
        return false;
      }
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'driver') {
      if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
        if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
          return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
        } else {
          return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photo'));
        }
      } else {
        if (getObjectProperty(___arguments.context.appData, 'photoThumbnail')) {
          return (getObjectProperty(___arguments.context.appData, 'photoThumbnail'));
        }
      }
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'passenger') {
      if ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'media'))) {
        return (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'userProfile')), 'media')), async (item) => {


         return ((getObjectProperty(item, 'isCover')) == true);
        }))[0]), 'file'));
      } else {
        return 'styles/img/icons/user-black.svg';
      }
    } else {
      return false;
    }
  }

  return 'styles/img/icons/user-black.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity/components/88b876ee690aafb42eef32e3b3f88f4e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) && ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'driver' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'passenger')) {
    return 'Covers the expenses ';
  }

  return 'Share Expense '

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/5401dde30bc50f0669c60dac03676f9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) && ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'driver' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'passenger')) {
    return 'Activity expenses are paid by:';
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole'))) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/b919d699659904c4fc0a58fb44ed0362/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/cbda281385187d7f12bf606cd1b1b029/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        return false;
      } else {
        if (getObjectProperty(___arguments.context.pageData, 'userActivityList')) {
          if (!!(getObjectProperty(___arguments.context.pageData, 'userActivityList')).length) {
            return true;
          }
        }
      }
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/7674a69db26cc8e70b6a9bcfe2dc8c95/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    return true;
  } else if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')));
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/38e23a8922483b87fd280082470f6853/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) == (getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming'))) {
      return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityStatus')) == false ? true : false);
    } else if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) == (getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate'))) {
      return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityStatus')) == false && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate')) > ((new Date()).valueOf()) ? true : false);
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/8c41598b21885609f9b6f31ddecd707d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await Backendless.Data.of('Activity').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')),'\''].join('')), ({ 'activityStatus': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityStatus')) }) );
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b72197114108bd9b758333f2602b7e4e')), 'open');
  (getObjectProperty(___arguments.context.pageData, 'currentActivity'))['activityStatus'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/2ad7e82844ad952af42b36170f697485/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9322d6650c54405a094b1953f31da09a')), 'open');
  ___arguments.context.pageData['clickPause'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/9a26ec1e4909553181ee5d6797448456/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9322d6650c54405a094b1953f31da09a')), 'open');
  ___arguments.context.pageData['clickDelete'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/e9fdfbe91c0d29a9c37f2e4c96365d28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, mediaItem, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if (getObjectProperty(___arguments.context.pageData, 'clickPause')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9322d6650c54405a094b1953f31da09a')).pop();
    await new Promise(r => setTimeout(r, 300 || 0));
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityStatus')) == true) {
      (getObjectProperty(___arguments.context.pageData, 'currentActivity'))['activityStatus'] = false;
    } else {
      (getObjectProperty(___arguments.context.pageData, 'currentActivity'))['activityStatus'] = true;
    }
    await Backendless.Data.of('Activity').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')),'\''].join('')), ({ [`activityStatus`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityStatus')) }) );
    delete ___arguments.context.pageData['clickPause'];
  } else if (getObjectProperty(___arguments.context.pageData, 'clickDelete')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0659399e0984fc65fe1de38fbd2ed5e4', true);
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'preferences')) {
      await Backendless.Data.of('ActivityPreferences').remove( (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'preferences')), 'objectId')) );
    }
    await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['activityId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')),'\''].join('')),'tableName': 'Chat' });
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'chat')) {
      await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['chatId in (\'',((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'chat')).map(item => item['objectId'])).join('\',\''),'\')'].join('')),'tableName': 'Message' });
    }
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media')) {
      var mediaItem_list = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media')).map(async item => {; return (getObjectProperty(item, 'file'));})));
      for (var mediaItem_index in mediaItem_list) {
        mediaItem = mediaItem_list[mediaItem_index];
        try {
          ;(async () => {
              await Backendless.Files.remove(encodePath(mediaItem));

          })();

        } catch (error) {
          console.log(error);

        }
      }
    }
    await Backendless.Data.of('Activity').remove( (getObjectProperty(___arguments.context.pageData, 'currentActivity')) );
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9322d6650c54405a094b1953f31da09a')).pop();
    await new Promise(r => setTimeout(r, 500 || 0));
    delete ___arguments.context.pageData['clickDelete'];
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-activities', undefined);
  }
  delete ___arguments.context.appData['userActivitiesForInvitation'];

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'clickPause')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityStatus')) {
      return 'Pause';
    } else {
      return 'Reactivate';
    }
  } else if (getObjectProperty(___arguments.context.pageData, 'clickDelete')) {
    return 'Delete';
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (___arguments.context.pageData['clickPause']) {
    return ;
  } else if (___arguments.context.pageData['clickDelete']) {
    return ['btn-red'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activity/components/3ffcac541d919fab2828e0d69b246642/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'clickPause')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityStatus')) {
      return 'Do you want to pause your activity? ';
    } else {
      return 'Do you want to reactivate your activity?';
    }
  } else if (getObjectProperty(___arguments.context.pageData, 'clickDelete')) {
    return 'Delete activity?';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/53e2cbb5b2d19ae1d8fc4b9b954ccf97/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    
  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/f574e74eb6036fa876e87a5f84fb6c5c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9322d6650c54405a094b1953f31da09a')).pop();
  await new Promise(r => setTimeout(r, 500 || 0));
  if (getObjectProperty(___arguments.context.pageData, 'clickPause')) {
    delete ___arguments.context.pageData['clickPause'];
  } else if (getObjectProperty(___arguments.context.pageData, 'clickDelete')) {
    delete ___arguments.context.pageData['clickDelete'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/37d45f3e26919201539a44cac6aa7d37/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9322d6650c54405a094b1953f31da09a')).pop();
  await new Promise(r => setTimeout(r, 500 || 0));
  if (getObjectProperty(___arguments.context.pageData, 'clickPause')) {
    delete ___arguments.context.pageData['clickPause'];
  } else if (getObjectProperty(___arguments.context.pageData, 'clickDelete')) {
    delete ___arguments.context.pageData['clickDelete'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/1ca523935546ca69e60a9875ff8903cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b72197114108bd9b758333f2602b7e4e')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/8e48a7efd27e7d186a6d9b16ad2e3827/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b72197114108bd9b758333f2602b7e4e')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/9e4e2344d819137e0cc9783af2de19b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityStatus')) == true) {
      return ['maskIcon', 'pause'];
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityStatus')) == false) {
      return ['maskIcon', 'play'];
    }
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activity/components/674a5945ed3bb6afe5479f5271b7b58e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['currentActivity']) {
    if (((___arguments.context.pageData['currentActivity'])['activityStatus']) == true) {
      return 'Pause my activity';
    } else if (((___arguments.context.pageData['currentActivity'])['activityStatus']) == false) {
      return 'Resume my activity';
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/a433bd8292b302dcaab21bd3b82490c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['currentActivityOwner']) {
    return ((___arguments.context.pageData['currentActivityOwner']) == (___arguments.context.pageData['currentUser']));
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/3a9b7759d24d263f51e4c12a683ac1cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/3cea117c1c25f5eb2056883a489d5c3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/83dfb0d214335931332362717bf9d983/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a6ce736b6a4d989d764c4412413fd541')).pop();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/5571dcae486cf4b632aec49119d3e50d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'driver') {
      if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorName')) {
        return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorName'));
      } else {
        return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorLogin'));
      }
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'passenger') {
      if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
        if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) {
          return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name'));
        } else {
          return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
        }
      }
    } else {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole'));
    }
  }

  return ''

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/c9a76b81f522b7fc815a5031722e9b29/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login'));
    return (String('We successfully notified ') + String(name2));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/6253bbeec94b38e13ee4da2546ccdaf3/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) != 'driver' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) != 'passenger') {
      if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'photoThumbnail'));
      } else {
        return 'styles/img/icons/pic_profile.svg';
      }
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity/components/0d18f5273f93388d342e08e8b54650c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activity/components/3fa80b4f23d3ca16503bf262a18f8631/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/ecd114d3c79b9144c56c5a1963f2bb05/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/94bc8b1d9d4c27b8da08d3c40507345b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/f778921bf00e8c4b739c584e53adedc8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((typeof (getObjectProperty(___arguments.context.pageData, 'profileStatus')) === 'undefined') ? false : !(getObjectProperty(___arguments.context.pageData, 'profileStatus')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/a1941703ae689491a4ae56973c413542/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/61259662d4e7e092aceed815beb9b3c1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'resumeDeletedChat')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/6e43d75857f4a8e175495b05d5d919b9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'resumeDeletedChat')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/0b67ee517b6fdb84e14aece5b4d1803d/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var media;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 2000 || 0));
  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    media = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media'));
  }
  if (media) {
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
      return (media.slice(0, 5));
    } else {
      return (media.slice(0, 4));
    }
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/activity/components/48da08e32e0118d85e0e0ae61df49fc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'keepLocationPrivate')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'location'))) {
      return true;
    } else if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'keepLocationPrivate')) {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/515a54418dbb52e873f2f63727c858c7/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'media'))

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c872f5d052e97d671d3b064b9a502e1', true);
  await new Promise(r => setTimeout(r, 200 || 0));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cc1ab1f4995632132447de58a4b68718')));
  ___arguments.context.pageData['activity'] = (await Backendless.Request.get(`${Backendless.appPath}/services/activity/getActivity`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'activityId': JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId'))) }).send());
  ___arguments.context.pageData['currentActivity'] = (getObjectProperty(___arguments.context.pageData, 'activity'));
  currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  ___arguments.context.pageData['userActivityList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivity/getActivities`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'user': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId'))),'objectId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId'))),'pageSize': 10,'relation': JSON.stringify('category'),'sort': JSON.stringify('activityDate'),'whereClause': JSON.stringify((['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')),'\'',['and objectId!= \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')),'\''].join(''),['and visibility!=3 and (activityDate is null or activityDate >=',((new Date()).valueOf()),')'].join('')].join(''))) }).send());
  ___arguments.context.pageData['alertMessage'] = (['Describe why ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')),' need to pick you'].join(''));
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media')) {
    ___arguments.context.pageData['imageList'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ddf3159b707971be8f264be6a9215538', true);
  }
  ___arguments.context.pageData['location'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'location'));
  if (!!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')));
  })).length) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfeb464bec4359fb436190f36259f96a')), 'clicked');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c872f5d052e97d671d3b064b9a502e1', false);
  if (!!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'chat')).length) {
    if (!!(await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'chat')), async (item) => {


     return ((getObjectProperty((getObjectProperty(item, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')));
    })).length) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')), 'disabled');
    } else {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')).includes('disabled')) {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')).pop();
      }
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')).includes('disabled')) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')).pop();
    }
  }
  ___arguments.context.pageData['isInvitation'] = ((await Backendless.Request.get(`${Backendless.appPath}/services/chatInvitation/isInvitation`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'activityId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId'))) }).send())[0]);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/064363085101dfb6fb98393a87ec5ee3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'authorShortDescr')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'authorShortDescr')) : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/bf57f664a90bcaa8e11395cf09e7e27c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'locationPoint')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/746579fff9badb55c88baa77f0466122/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'userActivityList')) || (getObjectProperty(___arguments.context.pageData, 'userActivityList')) <= 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/e4ca0fe4b81c35528b9577f20f97e9b4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) {
      return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) + String(' '));
    } else {
      return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login')) + String(' '));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/c63d5ca5da337b0a03b9e88a42d6e3c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['backBtnIsClicked'] = true;
  if (getObjectProperty(___arguments.context.pageData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ [`getChat`]: (getObjectProperty(___arguments.context.pageData, 'getChat')) }));
    return ;
  }
  if (!(getObjectProperty(___arguments.context.appData, 'previousPage'))) {
    (function () { window.history.back(); })();
  } else if (getObjectProperty(___arguments.context.appData, 'previousPage')) {
    if ((getObjectProperty(___arguments.context.appData, 'previousPage')) == 'activities-search' || (getObjectProperty(___arguments.context.appData, 'previousPage')) == 'profiles') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), ({ [`notUpdate`]: true }));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), undefined);
    }
    delete ___arguments.context.appData['previousPage'];
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentUser'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/1efda3ec5bf5265425f64b13e74cf793/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name'));
    } else {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/ad42631b59757e927cf4deabf8ebb115/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ad42631b59757e927cf4deabf8ebb115'))['pointer-events'] = 'none';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ad42631b59757e927cf4deabf8ebb115')).slice(-1)[0] != 'clicked') {
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities'))) {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['likedActivities'] = [];
    }
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ad42631b59757e927cf4deabf8ebb115')), 'clicked');
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')), ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')),[`ts`]: ((new Date()).valueOf()) }));
    try {
      await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', (String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your activity')), null, null, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')));
      await (getChannelInstance('likes')).send('', ({ [`message`]: [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),' just liked your activity "',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'name')),'"'].join(''),[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'ownerId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

    } catch (error) {
      console.log(error);

    }
    getRTSubscriptions().remove('push');
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')),'parameter': 'likedActivities','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ad42631b59757e927cf4deabf8ebb115')).pop();
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['likedActivities'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')) != (getObjectProperty(item, 'objectId')));
    }));
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')),'parameter': 'likedActivities','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ad42631b59757e927cf4deabf8ebb115'))['pointer-events'] = 'auto';
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'objectId')))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')) {
    if (!!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')));
    })).length && !(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ad42631b59757e927cf4deabf8ebb115')).includes('clicked'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ad42631b59757e927cf4deabf8ebb115')), 'clicked');
    }
  }

  return ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ad42631b59757e927cf4deabf8ebb115'))

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/activity/components/d8b505ebedc1d98c1904e7e230625e6e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var link, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  link = String('https://app.findmyplus.one/index.html?page=activity&activityId=') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId'));
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    await ( async function (link, message, resourceName) { return BackendlessUI.DeviceAPI.shareSheetRequest({ link, message, resourceName }) })(link, 'Check out the activity in the in the "FindMyPlusOne" app', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name')));
  } else {
    ___arguments.context.pageData['modalShareOpen'] = true;
    ___arguments.context.pageData['shareLink'] = link;
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('share_activity');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/c7a66fc998022fa97a0c6e63dbf6cc33/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'category')), 'icon'));
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity/components/6572714bf9297d396757ff7cac850a5a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'category')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/c2cf83d430111b93194de485b5fa4d93/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'previousPage')) == 'activities-search') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), ({ [`notUpdate`]: true }));
  } else if (getObjectProperty(___arguments.context.appData, 'previousPage')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), undefined);
  } else {
    (function () { window.history.back(); })();
  }
  delete ___arguments.context.appData['previousPage'];

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentUser'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/536198f15b53773f11eea26268e1ca21/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'alertMessage')) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, isActivityInServiceArea, userLocation, recentMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')).includes('disabled')) {
    return ;
  }
  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');
    } else {
      if (getObjectProperty(___arguments.context.pageData, 'isInvitation')) {
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'deletedBySender')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'sender')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'deletedByReceiver')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'receiver'))) {
          recentMessage = (await Backendless.Request.get(`${Backendless.appPath}/services/messages/getRecentChatMessage`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'chatId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'objectId'))) }).send());
          if (recentMessage) {
            if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'deletedBySender')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'deletedBySender')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'deletedByReceiver'))) > (getObjectProperty(recentMessage, 'created'))) {
              ___arguments.context.pageData['resumeDeletedChat'] = true;
              addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')), 'open');
            } else {
              (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ [`getChat`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'objectId')) }));
            }
          } else {
            (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ [`getChat`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'objectId')) }));
          }
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ [`getChat`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'objectId')) }));
        }
      } else {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')), 'open');
      }
    }
  } else {
    ___arguments.context.pageData['disableBePlusOneBtn'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2b153aaf767526a6c4458b9b1ba4abeb', true);
    userLocation = (await BackendlessUI.Functions.Custom['fn_47bed951feaa47e346a419d69147a6a6']());
    if (!userLocation) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
      return ;
    }
    try {
      isActivityInServiceArea = (await Backendless.Request.get(`${Backendless.appPath}/services/isActivityInServiceArea/isActivityInServiceArea`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'activityId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'activityId'))),'userLat': ((getObjectProperty((getObjectProperty(userLocation, 'locationGeoPoint')), 'coordinates')).slice(-1)[0]),'userLng': ((getObjectProperty((getObjectProperty(userLocation, 'locationGeoPoint')), 'coordinates'))[0]) }).send());
      ___arguments.context.pageData['disableBePlusOneBtn'] = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2b153aaf767526a6c4458b9b1ba4abeb', false);
      if (isActivityInServiceArea) {
        localStorage.setItem('userRequestActivity', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'activityId'))));
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity-far', ({ [`authorLogin`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorLogin')) }));
      }

    } catch (error) {
      console.log(error);
      console.log('error');
      ___arguments.context.pageData['disableBePlusOneBtn'] = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2b153aaf767526a6c4458b9b1ba4abeb', false);

    }
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorName')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorName')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'authorLogin'));
    if ((getObjectProperty(___arguments.context.pageData, 'isInvitation')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'accepted') {
      if (name2) {
        return (String('Continue chatting with ') + String(name2));
      }
    } else if ((getObjectProperty(___arguments.context.pageData, 'isInvitation')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'new') {
      return 'View invitation';
    } else if ((getObjectProperty(___arguments.context.pageData, 'isInvitation')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'rejected') {
      return 'Request already sent';
    }
  }

  return (['Be ',name2,'\'s '].join(''))

  },
  /* handler:onLabelAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'disableBePlusOneBtn')) {
    return true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'activityDate')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'activityDate')) < ((new Date()).valueOf())) {
    if ((getObjectProperty(___arguments.context.pageData, 'isInvitation')) && ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'new' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'isInvitation')), 'status')) == 'accepted')) {
      return false;
    } else {
      return true;
    }
  }

  return false

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/activity/components/6e84b613d48efb2f391ee9dc13186e4d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'location'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/cfe99d94480b1be92be7b84cbafa7131/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/567a7a7ab56f55a45db9772716826ee3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalShareOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity/components/cee5cd9a05a24fc2719426eed49f423d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('edit-activity', ({ [`activityId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity/components/60038933514e20ceb3ffb5fe2d5d7496/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activity')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'activityDate')) {
      return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'activityDate'))));
    } else if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'ongoingTiming')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activity')), 'ongoingTiming'));
    }
  }

  return 'To be scheduled'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity/components/63825f8785a8dc081e51bd5a6bfde43f/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return './styles/media/icons/Calendar.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity/components/9bc451850a420371268dacc5a542be3e/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return './styles/media/icons/Ruler.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity/components/170d777b40c662c4961e9482223887bf/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return './styles/media/Map.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/activity-far/components/eb12e5dc7373502a78063e5e7aa5c957/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity-far/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (['','© ',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed worldwide. All rights reserved'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/activity-far/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
      return 'Activity too far'

  },
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;


  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_far_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/activity-far/components/651d896d8a76094ce0c504b694d694cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity-presentation/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  localStorage.setItem('isInitialActivity', JSON.stringify(true));

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/activity-presentation/components/0c6661db445dd8fb03c1b386c67163a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity-presentation/components/2f1ae4fe3e7e0746a3ba3e2111027532/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return ((await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) || (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('VIEWER')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity-presentation/components/4837e558c7b23ae5cbd9bc055681dbee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('BROWSER'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity-presentation/components/b7646367917126ce4685079c487b50c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/activity-presentation/components/72d847259a442005789750ae4e61f464/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('BROWSER'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/activity-presentation/components/a83f437ee049ae72cca4545f492f37a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      return ((await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('VIEWER')) || (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var error, currentUser, userData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getUser() {
  currentUser = (await Backendless.UserService.getCurrentUser(false));
  userData = (await Backendless.Request.get(`${Backendless.appPath}/services/getCurrentUserData/getCurrentUserData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  currentUser['searchFilter'] = (getObjectProperty(userData, 'searchFilter'));
  currentUser['userProfile'] = (getObjectProperty(userData, 'userProfile'));
  if (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')) {
    ___arguments.context.appData['userLocationInfo'] = ({ [`locationGeoPoint`]: (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')),[`location`]: (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'location')) });
    localStorage.setItem('userLocationInfo', JSON.stringify((getObjectProperty(___arguments.context.appData, 'userLocationInfo'))));
    if (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'country')) {
      localStorage.setItem('country', JSON.stringify((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'country'))));
    } else {
      await BackendlessUI.Functions.Custom['fn_24498a1473c83209b6d1428325c66861']((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')), (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'objectId')));
      (getObjectProperty(currentUser, 'userProfile'))['country'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country'));
    }
  }
  ___arguments.context.appData['currentUser'] = currentUser;
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
}


  if (!(getObjectProperty(___arguments.context.appData, 'userRoles'))) {
    ___arguments.context.appData['userRoles'] = (await Backendless.UserService.getUserRoles());
  }
  if (!((getObjectProperty(___arguments.context.appData, 'userRoles')).includes('admin'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  Object.assign(___arguments.context.pageData, ({ [`isMainVisible`]: true,[`currentTab`]: 'complaints',[`pageSize`]: 20,[`isLoaderVisible`]: true }));
  if (!((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'))) {
    await getUser();
  }
  if (getObjectProperty(___arguments.context.appData, 'pageOffsetComplaints')) {
    ___arguments.context.pageData['pageOffsetComplaints'] = (getObjectProperty(___arguments.context.appData, 'pageOffsetComplaints'));
  } else {
    ___arguments.context.pageData['pageOffsetComplaints'] = 0;
  }
  try {
    ___arguments.context.pageData['complaints'] = (await Backendless.Request.get(`${Backendless.appPath}/services/complaints/getComplaints`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'pageSize': (getObjectProperty(___arguments.context.pageData, 'pageSize')),'pageOffset': (getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints')) }).send());
    console.log(getObjectProperty(___arguments.context.pageData, 'complaints'));

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  } finally {
    ___arguments.context.pageData['isLoaderVisible'] = false;

  }
  if (getObjectProperty(___arguments.context.appData, 'scrollTopComplaints')) {
    await (async function(scrollTop) {
    	const pageEl = document.getElementById('page');
    	if (pageEl) {
    	  pageEl.scroll({
    	    top: scrollTop,
    	    left: 0
    	  });
    	}


    })((getObjectProperty(___arguments.context.appData, 'scrollTopComplaints')));
  }

  },
  /* handler:onBeforeEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['pageOffsetComplaints'] = (getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints'));
  ___arguments.context.appData['previousPage'] = 'admin-dashboard';

  },
  /* handler:onLeave */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
      ___arguments.context.appData['scrollTopComplaints'] = ___arguments.scrollTop;

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/admin-dashboard/components/24c4bf32d6de53e8087eda716e84327f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'complaints' ? ['dashboardTabs__item', 'active'] : ['dashboardTabs__item'])

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['currentTab'] = 'complaints';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin-dashboard/components/60a26e4987f5e6e497549174d276832f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'tabItem1' ? ['dashboardTabs__item', 'active'] : ['dashboardTabs__item'])

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['currentTab'] = 'tabItem1';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin-dashboard/components/4b1c0a48e0bedea1c49453e4b7a249de/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'tabItem2' ? ['dashboardTabs__item', 'active'] : ['dashboardTabs__item'])

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['currentTab'] = 'tabItem2';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin-dashboard/components/efb8723ce634e306281bde434b32c51b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'complaints')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/6d3c6dac9464919b7f2b48d4b674a9a1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'tabItem1')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/c3f6d05512fa91ccb2a5e0b5c612dca8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'tabItem2')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/3c65f0f8c9c380d4a8042ba88b138c42/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'complaints')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'complaints')), 'items')) : [])

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/3ee32fe6a266bd9f32fd8b3fa2cdd7c3/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a05a68585844c7581e1a08c76fb970fa'), 'violator')), 'violatorName'))

  },
  /* handler:onTextAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a05a68585844c7581e1a08c76fb970fa'), 'violator')), 'violatorObjectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin-dashboard/components/3a85518cdbba10a897aa7be2cd676a07/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a05a68585844c7581e1a08c76fb970fa'), 'violator')), 'violatorEmail'))

  },
  /* handler:onTextAssignment */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('mailto:') + String(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a05a68585844c7581e1a08c76fb970fa'), 'violator')), 'violatorEmail')))

  },
  /* handler:onTargetPathAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/534af7c95b9a5a0be076736d8fef8827/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('093aaf8c2736139c670f6d1d212294a2'), 'sourceProfileObjectId')) ? 'Profile' : 'Chat')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/ee0c752d61142b3e5c07dbc41e914556/bundle.js', [], () => ({
  /* content */
  /* handler:onTargetPathAssignment */
  ['onTargetPathAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('mailto:') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('093aaf8c2736139c670f6d1d212294a2'), 'reporterEmail')))

  },
  /* handler:onTargetPathAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/51f773dc670731799a14ee32024ecdd1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('093aaf8c2736139c670f6d1d212294a2'), 'reporterName')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/a32358ee469de85d64f150e97f6bf537/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('093aaf8c2736139c670f6d1d212294a2'), 'reporterObjectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin-dashboard/components/cff3d03359034d08a324c173d69c2bf9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints')) / (getObjectProperty(___arguments.context.pageData, 'pageSize')) + 1)

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/cfa73f8118b29c97b0b7659b0f4bbd1a/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints')) == 0 ? ['dashboardComplaints__paginationIcon', 'inactive'] : ['dashboardComplaints__paginationIcon'])

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints')) != 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c5bb349cfdec2651c08e2246c0cd173', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2d7df51174e84d649325965ca1b7819')));
    ___arguments.context.pageData['pageOffsetComplaints'] = ((getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints')) - (getObjectProperty(___arguments.context.pageData, 'pageSize')));
    try {
      console.log('pageSize');
      console.log(getObjectProperty(___arguments.context.pageData, 'pageSize'));
      console.log('pageOffset');
      console.log(getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints'));
      ___arguments.context.pageData['complaints'] = (await Backendless.Request.get(`${Backendless.appPath}/services/complaints/getComplaints`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'pageSize': (getObjectProperty(___arguments.context.pageData, 'pageSize')),'pageOffset': (getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints')) }).send());

    } catch (error) {
      (function (message) { alert(message) })((getObjectProperty(___arguments.context.pageData, 'message')));

    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c5bb349cfdec2651c08e2246c0cd173', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin-dashboard/components/4f8a750b831b8f929ce844de22bcde49/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'complaints')) && !!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'complaints')), 'items')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/f317c14f3df2349e8278d9a7ce0be565/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'complaints')), 'hasNextPage')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c5bb349cfdec2651c08e2246c0cd173', true);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b2d7df51174e84d649325965ca1b7819')));
    ___arguments.context.pageData['pageOffsetComplaints'] = ((getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints')) + (getObjectProperty(___arguments.context.pageData, 'pageSize')));
    try {
      console.log('pageSize');
      console.log(getObjectProperty(___arguments.context.pageData, 'pageSize'));
      console.log('pageOffset');
      console.log(getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints'));
      ___arguments.context.pageData['complaints'] = (await Backendless.Request.get(`${Backendless.appPath}/services/complaints/getComplaints`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'pageSize': (getObjectProperty(___arguments.context.pageData, 'pageSize')),'pageOffset': (getObjectProperty(___arguments.context.pageData, 'pageOffsetComplaints')) }).send());

    } catch (error) {
      (function (message) { alert(message) })((getObjectProperty(___arguments.context.pageData, 'message')));

    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c5bb349cfdec2651c08e2246c0cd173', false);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'complaints')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'complaints')), 'hasNextPage')) ? ['dashboardComplaints__paginationIcon'] : ['dashboardComplaints__paginationIcon', 'inactive'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/0619cf2dae37468e18ed09af494feeb2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'previousPage')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'activities-search')), undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin-dashboard/components/2d9bb8b744eabb2b631c7df6ddf7d924/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2ce1922687ef915f2b1578d3956cc989')).includes('open'))) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2ce1922687ef915f2b1578d3956cc989')).push('open');
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2ce1922687ef915f2b1578d3956cc989'))['violatorName'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a05a68585844c7581e1a08c76fb970fa'), 'violator')), 'violatorName'));
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('2ce1922687ef915f2b1578d3956cc989'))['violatorObjectId'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a05a68585844c7581e1a08c76fb970fa'), 'violator')), 'violatorObjectId'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin-dashboard/components/69b80283ee97384f5d66aab503e66051/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2ce1922687ef915f2b1578d3956cc989')), 'open', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin-dashboard/components/6e994b7513af2ba40abdd33b672c5703/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2ce1922687ef915f2b1578d3956cc989')), 'open', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/admin-dashboard/components/5b091baa8f96d532e9ba6a78bf45c292/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('2ce1922687ef915f2b1578d3956cc989'), 'violatorName')) ? ['Are you sure you want to delete the account of user "',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2ce1922687ef915f2b1578d3956cc989'), 'violatorName')),'"?'].join('') : 'Are you sure you want to delete this account?')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/admin-dashboard/components/20fa734a46e877cb3b73847f31a4f159/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var usersForUpdateChat, j, chats, error, userObjectId, likesCount, getProfile, item, mapLikedUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updateChatsOnMessagePage() {
  if (getObjectProperty(___arguments.context.appData, 'chats')) {
    chats = (getObjectProperty(___arguments.context.appData, 'chats'));
  } else {
    chats = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  }
  usersForUpdateChat = [];
  for (var j_index in chats) {
    j = chats[j_index];
    if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId'))))) {
        usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')));
      }
    }
    if ((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId'))))) {
        usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')));
      }
    }
  }
  await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('blockUser', usersForUpdateChat, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), null, null);
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function deleteUser() {
  if (true) {
    return ;
  }
  await updateChatsOnMessagePage();
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Media...';
  ;(async () => {
      try {
      await Backendless.Files.removeDirectory(encodePath((['/pictures/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),'/'].join(''))));

    } catch (error) {
      console.log(error);

    }

  })();
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User folders...';
  ;(async () => {
      try {
      await Backendless.Files.removeDirectory(encodePath((['/pictures/activities/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),'/'].join(''))));

    } catch (error) {
      console.log(error);

    }

  })();
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Activities...';
  await Backendless.Data.of('Activity').bulkDelete( (['author.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the ActivityPreferences...';
  await Backendless.Data.of('ActivityPreferences').bulkDelete( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Messagess...';
  await Backendless.Data.of('Message').bulkDelete( (['sender.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\'',' or receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Chats...';
  await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChatNoClause`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes'))) {
    mapLikedUsers = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')).map(async item => {  try {
        getProfile = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfile/getProfile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'id': JSON.stringify((getObjectProperty(item, 'objectId'))) }).send());
        if (getProfile && (getObjectProperty(getProfile, 'userProfile'))) {
          userObjectId = (getObjectProperty((getObjectProperty(getProfile, 'userProfile')), 'objectId'));
          likesCount = (getObjectProperty((getObjectProperty(getProfile, 'userProfile')), 'likesCount'));
          await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': userObjectId,'likesCount': (likesCount > 0 ? likesCount - 1 : 0) });
          await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'parameter': 'likedBy','currentUser': userObjectId });
        }

      } catch (error) {
        console.log(error);

      }
    ; return ;})));
  }
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User profile...';
  await Backendless.Data.of('UserProfile').bulkDelete( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User search filter...';
  await Backendless.Data.of('UserSearchFilter').bulkDelete( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User folders...';
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    await ( async function () { return BackendlessUI.DeviceAPI.unregisterDevice() })();
  }
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User record...';
  await Backendless.Data.of(Backendless.User).remove({ objectId: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) });
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2ce1922687ef915f2b1578d3956cc989'), 'violatorObjectId'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/919d55a2a72afa2bb1cb03f880960808/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength(___arguments.value) == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', false);
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'el'))['maxLength'] = 60;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '50vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6039d74cf061de58a8f122f42ae1561c')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/create-activity/components/10476337a1fe6ff828cd2ade6062f95f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['activityTimingAlertText'] = '';
  } else {
    ___arguments.context.pageData['activityTimingAlertText'] = 'Please choose date';
  }

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/create-activity/components/7eb9af336d564ab949398bda49392324/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (!___arguments.value.trim().length) {
    ___arguments.context.pageData['activityTimingAlertText'] = 'Please, enter timing';
  } else {
    ___arguments.context.pageData['activityTimingAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7eb9af336d564ab949398bda49392324')), 'el'))['maxLength'] = 60;

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    
  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/create-activity/components/7556db4d9898976a79a4198c85eedd97/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength(___arguments.value.trim()) == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d2cadcf117eb39a308f75f27f5e52d4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d2cadcf117eb39a308f75f27f5e52d4', false);
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')), 'el'))['maxLength'] = 60;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '50vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe427f09815f6441a9eed7e76a471f81')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financialRole')) != 'passenger' && (getObjectProperty(___arguments.context.pageData, 'financialRole')) != 'driver')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/c84bc82bb6f109fba3db9f11e6e837ff/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['visibility'] = 1;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibility'))

  },
  /* handler:onValueAssignment */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
      return 1

  },
  /* handler:onCheckedValueAssignment */
  /* content */
}))

define('./pages/create-activity/components/5dbf8d9cc9320811ee851d74bca83589/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['visibility'] = 2;

  },
  /* handler:onChange */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
      return 2

  },
  /* handler:onCheckedValueAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibility'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/create-activity/components/c7bf475e7a59cd8e1fed2b9bd222b185/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['visibility'] = 3;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibility'))

  },
  /* handler:onValueAssignment */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
      return 3

  },
  /* handler:onCheckedValueAssignment */
  /* content */
}))

define('./pages/create-activity/components/916764cf81f7f4dd39add13dbd65fa7a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var heightInch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['height'] = ___arguments.value;
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 1 || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == '1') {
    heightInch = String('-') + String(getObjectProperty(___arguments.context.pageData, 'height'));
    ___arguments.context.pageData['heightData'] = (heightInch * 1);
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 2 || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == '2') {
    ___arguments.context.pageData['heightData'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var height;


  height = [({ 'value': '122','label': '4′0″ (122 cm)' }), ({ 'value': '124','label': '4′1″ (124 cm)' }), ({ 'value': '127','label': '4′2″ (127 cm)' }), ({ 'value': '130','label': '4′3″ (130 cm)' }), ({ 'value': '132','label': '4′4″ (132 cm)' }), ({ 'value': '135','label': '4′5″ (135 cm)' }), ({ 'value': '137','label': '4′6″ (137 cm)' }), ({ 'value': '140','label': '4′7″ (140 cm)' }), ({ 'value': '142','label': '4′8″ (142 cm)' }), ({ 'value': '145','label': '4′9″ (145 cm)' }), ({ 'value': '152','label': '5′0″ (152 cm)' }), ({ 'value': '155','label': '5′1″ (155 cm)' }), ({ 'value': '157','label': '5′2″ (157 cm)' }), ({ 'value': '160','label': '5′3″ (160 cm)' }), ({ 'value': '163','label': '5′4″ (163 cm)' }), ({ 'value': '165','label': '5′5″ (165 cm)' }), ({ 'value': '168','label': '5′6″ (168 cm)' }), ({ 'value': '170','label': '5′7″ (170 cm)' }), ({ 'value': '173','label': '5′8″ (173 cm)' }), ({ 'value': '176','label': '5′9″ (176 cm)' }), ({ 'value': '178','label': '5′10″ (178 cm)' }), ({ 'value': '180','label': '5′11″ (180 cm)' }), ({ 'value': '183','label': '6′0″ (183 cm)' }), ({ 'value': '185','label': '6′1″ (185 cm)' }), ({ 'value': '188','label': '6′2″ (188 cm)' }), ({ 'value': '191','label': '6′3″ (191 cm)' }), ({ 'value': '193','label': '6′4″ (193 cm)' }), ({ 'value': '195','label': '6′5″ (195 cm)' }), ({ 'value': '198','label': '6′6″ (198 cm)' }), ({ 'value': '201','label': '6′7″ (201 cm)' }), ({ 'value': '203','label': '6′8″ (203 cm)' }), ({ 'value': '206','label': '6′9″ (206 cm)' }), ({ 'value': '208','label': '6′10″ (208 cm)' }), ({ 'value': '211','label': '6′11″ (211 cm)' }), ({ 'value': '213','label': '7′0″ (213 cm)' })];

  return height

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/create-activity/components/a7993934459154523e34663fcee9224a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ___arguments.context.pageData['age'] = [18, 100];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-activity/components/2a6cc267ff1834d4e052611c72f1f1d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['gender'] = [];
  } else {
    ___arguments.context.pageData['gender'] = ['Female', 'Male', 'Non-Binary'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'gender')) || !(getObjectProperty(___arguments.context.pageData, 'gender')).length)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/create-activity/components/3555fd47b081b0a63af89443d6e87df1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3968029d13271427744c4ff2c65259ce'))['opacity'] = 0.35;
    ___arguments.context.pageData['heightCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3968029d13271427744c4ff2c65259ce'))['opacity'] = 1;
    delete ___arguments.context.pageData['heightCheckbox'];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-activity/components/3968029d13271427744c4ff2c65259ce/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″ (122 cm)' }), ({ [`value`]: '124',[`label`]: '4′1″ (124 cm)' }), ({ [`value`]: '127',[`label`]: '4′2″ (127 cm)' }), ({ [`value`]: '130',[`label`]: '4′3″ (130 cm)' }), ({ [`value`]: '132',[`label`]: '4′4″ (132 cm)' }), ({ [`value`]: '135',[`label`]: '4′5″ (135 cm)' }), ({ [`value`]: '137',[`label`]: '4′6″ (137 cm)' }), ({ [`value`]: '140',[`label`]: '4′7″ (140 cm)' }), ({ [`value`]: '142',[`label`]: '4′8″ (142 cm)' }), ({ [`value`]: '145',[`label`]: '4′9″ (145 cm)' }), ({ [`value`]: '152',[`label`]: '5′0″ (152 cm)' }), ({ [`value`]: '155',[`label`]: '5′1″ (155 cm)' }), ({ [`value`]: '157',[`label`]: '5′2″ (157 cm)' }), ({ [`value`]: '160',[`label`]: '5′3″ (160 cm)' }), ({ [`value`]: '163',[`label`]: '5′4″ (163 cm)' }), ({ [`value`]: '165',[`label`]: '5′5″ (165 cm)' }), ({ [`value`]: '168',[`label`]: '5′6″ (168 cm)' }), ({ [`value`]: '170',[`label`]: '5′7″ (170 cm)' }), ({ [`value`]: '173',[`label`]: '5′8″ (173 cm)' }), ({ [`value`]: '176',[`label`]: '5′9″ (176 cm)' }), ({ [`value`]: '178',[`label`]: '5′10″ (178 cm)' }), ({ [`value`]: '180',[`label`]: '5′11″ (180 cm)' }), ({ [`value`]: '183',[`label`]: '6′0″ (183 cm)' }), ({ [`value`]: '185',[`label`]: '6′1″ (185 cm)' }), ({ [`value`]: '188',[`label`]: '6′2″ (188 cm)' }), ({ [`value`]: '191',[`label`]: '6′3″ (191 cm)' }), ({ [`value`]: '193',[`label`]: '6′4″ (193 cm)' }), ({ [`value`]: '195',[`label`]: '6′5″ (195 cm)' }), ({ [`value`]: '198',[`label`]: '6′6″ (198 cm)' }), ({ [`value`]: '201',[`label`]: '6′7″ (201 cm)' }), ({ [`value`]: '203',[`label`]: '6′8″ (203 cm)' }), ({ [`value`]: '206',[`label`]: '6′9″ (206 cm)' }), ({ [`value`]: '208',[`label`]: '6′10″ (208 cm)' }), ({ [`value`]: '211',[`label`]: '6′11″ (211 cm)' }), ({ [`value`]: '213',[`label`]: '7′0″ (213 cm)' })];
  ___arguments.context.pageData['heightValue'] = (subsequenceFromStartLast(String(getObjectProperty(___arguments.context.pageData, 'height')), 1));
  if (getObjectProperty(___arguments.context.pageData, 'height')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3968029d13271427744c4ff2c65259ce'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3555fd47b081b0a63af89443d6e87df1'))['checked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'height')) < 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee'))['value'] = 1;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('916764cf81f7f4dd39add13dbd65fa7a'))['label'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'heightList')), async (item) => {
         if ((getObjectProperty(___arguments.context.pageData, 'heightValue')) == (getObjectProperty(item, 'value'))) {
          return item;
        }


       return ;
      }))[0]), 'label'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee'))['value'] = 2;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('916764cf81f7f4dd39add13dbd65fa7a'))['value'] = (getObjectProperty(___arguments.context.pageData, 'height'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('916764cf81f7f4dd39add13dbd65fa7a'))['label'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'heightList')), async (item) => {
         if (String(getObjectProperty(___arguments.context.pageData, 'height')) == (getObjectProperty(item, 'value'))) {
          return item;
        }


       return ;
      }))[0]), 'label'));
    }
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3968029d13271427744c4ff2c65259ce'))['opacity'] = 0.35;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3555fd47b081b0a63af89443d6e87df1'))['checked'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee'))['value'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('916764cf81f7f4dd39add13dbd65fa7a'))['label'] = '5’10”';
  }

  },
  /* handler:onMounted */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var inch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3555fd47b081b0a63af89443d6e87df1'))['checked'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3968029d13271427744c4ff2c65259ce'))['opacity'] = 1;
  if (!(getObjectProperty(___arguments.context.pageData, 'height'))) {
    ___arguments.context.pageData['height'] = 178;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 1) {
    inch = String('-') + String(getObjectProperty(___arguments.context.pageData, 'height'));
    ___arguments.context.pageData['heightData'] = (inch * 1);
    delete ___arguments.context.pageData['heightDataTaller'];
    ___arguments.context.pageData['heightDataSmaller'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 2) {
    ___arguments.context.pageData['heightData'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
    delete ___arguments.context.pageData['heightDataSmaller'];
    ___arguments.context.pageData['heightDataTaller'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
      return 'Create activity'

  },
  /* handler:onTitleAssignment */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927')) {
    if (___arguments.screenWidth <= 992) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927'))['buttonLabel'] = 'Upload media';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927'))['buttonLabel'] = 'Drag and Drop or click to upload';
    }
  }

  },
  /* handler:onResize */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('isInitialActivity')) {
    localStorage.removeItem('isInitialActivity');
    ___arguments.context.pageData['isInitialActivity'] = true;
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var error;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  getRTSubscriptions().remove('likes');
  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
  ___arguments.context.pageData['financialRole'] = 'driver';
  ___arguments.context.pageData['timing'] = 'scheduled';
  ___arguments.context.pageData['visibility'] = 1;
  ___arguments.context.pageData['gender'] = [];
  ___arguments.context.pageData['age'] = [18, 100];
  if (!((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories')) || !((((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories')).map(item => item['name'])).includes('Professional Services'))) {
    ___arguments.context.appData['categoryList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/profilesData/ProfilesData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Category') }).send());
    localStorage.setItem('categories', JSON.stringify((getObjectProperty(___arguments.context.appData, 'categoryList'))));
  } else if (!(getObjectProperty(___arguments.context.appData, 'categoryList'))) {
    ___arguments.context.appData['categoryList'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories'));
  }
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);
  ___arguments.context.pageData['categoryListTableData'] = (getObjectProperty(___arguments.context.appData, 'categoryList'));
  ___arguments.context.pageData['userNameMedia'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).replace((new RegExp('[^\\w\\s]', 'g')), ''));
  ___arguments.context.pageData['media'] = [];
  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_createActivity_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeEnter */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
      await (async function() {
  	try {

  	  if (swiper) {

  	    if (Array.isArray(swiper)) {
  	      for (const swiperItem of swiper) {
  	        swiperItem.destroy(true, true);
  	      }
  	    } else {
  	      swiper.destroy(true, true)
  	    }

  	  }

  	} catch {}
  })();

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/create-activity/components/5d34836c20df0ed3e3654affc6b67d38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'showServiceDisabledScreen')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('out-of-service', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showServiceDisabledScreen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/594b9e3753547161e26e31b916d68155/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var result, mappingCategory, item, error, categoryName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getCategyFromGoogleType() {
  if (___arguments.value && !(getObjectProperty(___arguments.context.pageData, 'isManualEdit'))) {
    if ((getObjectProperty(___arguments.value, 'types')) && !!(getObjectProperty(___arguments.value, 'types')).length) {
      try {
        categoryName = (await Backendless.Request.get(`${Backendless.appPath}/services/categories/getCategoryFromType`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'type': JSON.stringify(((getObjectProperty(___arguments.value, 'types'))[0])) }).send());
        mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


         return ((getObjectProperty(item, 'name')) == categoryName);
        }))[0];
        if (!mappingCategory) {
          mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


           return ((getObjectProperty(item, 'name')) == 'Other');
          }))[0];
        }

      } catch (error) {
        console.log(error);
        mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


         return ((getObjectProperty(item, 'name')) == 'Other');
        }))[0];

      }
    } else {
      mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


       return ((getObjectProperty(item, 'name')) == 'Other');
      }))[0];
    }
    ___arguments.context.pageData['categorySelectValue'] = (getObjectProperty(mappingCategory, 'objectId'));
    ___arguments.context.pageData['category'] = (getObjectProperty(mappingCategory, 'name'));
    ___arguments.context.pageData['activityCategory'] = mappingCategory;
    ___arguments.context.pageData['iconCategory'] = (getObjectProperty(mappingCategory, 'icon'));
    if (!(getObjectProperty(mappingCategory, 'financialRoleRequired'))) {
      ___arguments.context.pageData['financialRoleRequired'] = false;
    } else {
      ___arguments.context.pageData['financialRoleRequired'] = true;
    }
  }
}


  if (!___arguments.value) {
    ___arguments.context.pageData['isLocationSelected'] = false;
    return ;
  } else {
    ___arguments.context.pageData['isLocationSelected'] = true;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07745225406d90ae80ac1f2748957c7f', false);
  await getCategyFromGoogleType();
  try {
    result = (getObjectProperty((getObjectProperty(((getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/getGeoCode/inputAddress`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'inputAddress': JSON.stringify((getObjectProperty(___arguments.value, 'description'))) }).send()), 'results'))[0]), 'geometry')), 'location'));
    ___arguments.context.pageData['locationPointResult'] = result;
    ___arguments.context.pageData['location'] = (getObjectProperty(___arguments.value, 'description'));
    if (result) {
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', (getObjectProperty(result, 'lat')), (getObjectProperty(result, 'lng')));
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('4df590d6dc3a54537dcf708f8de2676b', [result]);
      ___arguments.context.pageData['locationPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(result, 'lng'))).setY((getObjectProperty(result, 'lat'))));
    }

  } catch (error) {
    await new Promise(r => setTimeout(r, 1000 || 0));

  }

  },
  /* handler:onChange */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var lng, lat, currentUser, error, userLocation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  if (currentUser && (getObjectProperty(currentUser, 'userProfile')) && (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint'))) {
    lng = (getObjectProperty((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')), 'coordinates'))[0];
    lat = (getObjectProperty((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')), 'coordinates')).slice(-1)[0];
    (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('594b9e3753547161e26e31b916d68155', undefined, undefined, undefined, undefined, undefined, undefined, undefined, ['establishment'], undefined, undefined, ((function (center, radius) { return { type: 'CircleLiteral', value: { center, radius } } })(((function (lat, lng) { return { type: 'LatLngLiteral', value: { lat, lng } } })(lat, lng)), 250000)), undefined);
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', lat, lng);
  } else {
    (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('594b9e3753547161e26e31b916d68155', undefined, undefined, undefined, undefined, undefined, undefined, undefined, ['establishment'], undefined, undefined, undefined, undefined);
  }

  },
  /* handler:onMounted */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '50vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('98bc33836a311ae9faf179c83b8df5c7')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/create-activity/components/d4a9c3e2f54970e2ab7669a3d7597dc8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item, categoryListTableData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  if (getObjectProperty(___arguments.context.pageData, 'categoryListTableData')) {
    categoryListTableData = (getObjectProperty(___arguments.context.pageData, 'categoryListTableData'));
    return (await Promise.all(categoryListTableData.map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'name')),'icon': (getObjectProperty(item, 'icon')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var category, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['activityCategory'] = ___arguments.value;
  category = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


   return ((getObjectProperty(___arguments.context.pageData, 'activityCategory')) == (getObjectProperty(item, 'objectId')));
  }))[0];
  ___arguments.context.pageData['category'] = (getObjectProperty(category, 'name'));
  ___arguments.context.pageData['iconCategory'] = (getObjectProperty(category, 'icon'));
  if (!(getObjectProperty(category, 'financialRoleRequired'))) {
    ___arguments.context.pageData['financialRoleRequired'] = false;
  } else {
    ___arguments.context.pageData['financialRoleRequired'] = true;
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'category')) {
    return (getObjectProperty(___arguments.context.pageData, 'category'));
  }

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/create-activity/components/741f6a07142fb5b99adb9223834cb927/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var item, error, j, deleteFiles, moderateResult;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function dragAndDrop() {
  await (async function(path, mediaList, media2, data) {

  	async function resizeFiles(files, width, percent) {
  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index]

  	    const fileName = file.name

  	    const content = await readFileAsDataURL(file)

  	    const img = await getNewImage(content)

  	    const elem = document.createElement('canvas')

  	    const widthImage = !width ? img.width : width
  	    const scaleFactor = width && width / img.width
  	    const heightImage = width ? img.height * scaleFactor : img.height

  	    elem.width = widthImage
  	    elem.height = heightImage

  	    const ctx = elem.getContext('2d')

  	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	    const blob = await getCanvasBlob(ctx.canvas, percent)

  	    const newFile = new File([blob], fileName, {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })

  	    files[index] = newFile
  	  }

  	  async function readFileAsDataURL(file) {
  	    const result = await new Promise((resolve) => {
  	      const fileReader = new FileReader()

  	      fileReader.onload = (e) => resolve(e.target.result)

  	      fileReader.readAsDataURL(file)
  	    })

  	    return result;
  	  }

  	  async function getNewImage(content) {
  	    const result = await new Promise((resolve) => {
  	      const img = new Image()

  	      img.src = content

  	      img.onload = () => resolve(img)
  	    })

  	    return result
  	  }

  	  async function getCanvasBlob(canvas, percent) {
  	    const result = await new Promise((resolve) => {
  	      canvas.toBlob((blob) => {
  	        resolve(blob)
  	      }, 'image/jpeg', percent)
  	    })

  	    return result
  	  }

  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.upload__btn');

  	  dropArea.addEventListener("dragover", (event) => {
  	    event.preventDefault();
  	    dropArea.classList.add('active');
  	  });

  	  dropArea.addEventListener("dragleave", () => {
  	    dropArea.classList.remove('active');
  	  });


  	  function uploadFile(files) {
  	    files.forEach((file) => {
  	      if (file.type.includes('image')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	       .then(async function(fileURL) {
  	          let media = {
  	            file: fileURL.fileURL,
  	            isCover: false
  	          };
  	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', true);
  	          let moderationResult =  await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileURL.fileURL) }).send();
  	         if (moderationResult == 'OK') {
  	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
  	          data.media.push(media);
  	          data.media[0].isCover = true;
  	          data.media2 = data.media;
  	          data.imageList = data.media;
  	          data.activityImageAlertText = '';
  	         } else {
  	           Backendless.Files.remove(fileURL.fileURL);
  	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
  	          data.showRejectMsg = true;
  	          (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('9bcfbdf2ffd2fff69d7b5f4670f55712', ({ 'showRejectMsg': true }));
  	         }
  	        })
  	       .catch( function( error ) {
  	        console.log(error)
  	        })
  	      }
  	    })

  	    return mediaList;
  	  }

  	  dropArea.addEventListener("drop", (event) => {
  	    event.preventDefault();
  	    let files = event.dataTransfer.files;
  	    resizeFiles([...files], 700, 80);
  	    dropArea.classList.remove('active');
  	  });


  })((['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('')), (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')), ___arguments.context.pageData);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', true);
  try {
    var j_list = ___arguments.uploadedFiles;
    for (var j_index in j_list) {
      j = j_list[j_index];
      moderateResult = (await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(j) }).send());
      if (moderateResult == 'KO') {
        ___arguments.context.pageData['showRejectMsg'] = true;
        (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('9bcfbdf2ffd2fff69d7b5f4670f55712', ({ [`showRejectMsg`]: true }));
        deleteFiles = true;
        break;
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
    if (deleteFiles) {
      ;(async () => {
          var j_list2 = ___arguments.uploadedFiles;
        for (var j_index2 in j_list2) {
          j = j_list2[j_index2];
          await Backendless.Files.remove(encodePath(j));
        }

      })();
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');
      await dragAndDrop();
      return ;
    }

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');
    return ;

  } finally {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c38f74a5d54a3bbcffc2b3d4396e2524', false);

  }
  addItemToList((getObjectProperty(___arguments.context.pageData, 'media')), (await Promise.all(___arguments.uploadedFiles.map(async item => {; return ({ [`file`]: item,[`isCover`]: false });}))));
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 4) {
    ___arguments.context.pageData['media'] = ((getObjectProperty(___arguments.context.pageData, 'media')).slice(0, 4));
  }
  ((getObjectProperty(___arguments.context.pageData, 'media'))[0])['isCover'] = true;
  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  ___arguments.context.pageData['imageList'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c38f74a5d54a3bbcffc2b3d4396e2524', false);
  await dragAndDrop();
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 0) {
    ___arguments.context.pageData['activityImageAlertText'] = '';
  }

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var name2, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    name2 = (await asyncListFilter(((getObjectProperty(___arguments.context.pageData, 'name')).split('')), async (item) => {


     return (item != '\'' && item != '.');
    }));
    ___arguments.context.pageData['newName'] = (name2.join(''));
    return (['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/',(getObjectProperty(___arguments.context.pageData, 'newName')),'/'].join(''));
  } else {
    return (['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join(''));
  }

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([((new Date()).valueOf()),'_',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c38f74a5d54a3bbcffc2b3d4396e2524', true);
  if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')).includes('.')) {
    ___arguments.context.pageData['userNameMedia'] = ((await asyncListFilter(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')), async (item) => {


     return (item != '.');
    })).join(''));
  } else {
    ___arguments.context.pageData['userNameMedia'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
  }

  return (await (async function(files, width, percent) {
	for (let index = 0; index < files.length; index++) {
	  const file = files[index]

	  const fileName = file.name

	  const content = await readFileAsDataURL(file)

	  const img = await getNewImage(content)

	  const elem = document.createElement('canvas')

	  const widthImage = !width ? img.width : width
	  const scaleFactor = width && width / img.width
	  const heightImage = width ? img.height * scaleFactor : img.height

	  elem.width = widthImage
	  elem.height = heightImage

	  const ctx = elem.getContext('2d')

	  ctx.drawImage(img, 0, 0, widthImage, heightImage)

	  const blob = await getCanvasBlob(ctx.canvas, percent)

	  const newFile = new File([blob], fileName, {
	    type: 'image/jpeg',
	    lastModified: Date.now()
	  })

	  files[index] = newFile
	}

	async function readFileAsDataURL(file) {
	  const result = await new Promise((resolve) => {
	    const fileReader = new FileReader()

	    fileReader.onload = (e) => resolve(e.target.result)

	    fileReader.readAsDataURL(file)
	  })

	  return result
	}

	async function getNewImage(content) {
	  const result = await new Promise((resolve) => {
	    const img = new Image()

	    img.src = content

	    img.onload = () => resolve(img)
	  })

	  return result
	}

	async function getCanvasBlob(canvas, percent) {
	  const result = await new Promise((resolve) => {
	    canvas.toBlob((blob) => {
	      resolve(blob)
	    }, 'image/jpeg', percent)
	  })

	  return result
	}

	return files;
})(___arguments.files, 700, 80))

  },
  /* handler:onBeforeUpload */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 4) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onButtonLabelAssignment */
  ['onButtonLabelAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992) {
    return 'Upload media';
  } else {
    return 'Drag and drop or click to upload';
  }

  },
  /* handler:onButtonLabelAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/create-activity/components/16072df84cd60c7c36b223120beab8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'media'))) {
    ___arguments.context.pageData['media'] = [];
    ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  }

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var path;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'isDrag')) {
    path = ['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('');
    await (async function(path, mediaList, media2, data) {
    	async function resizeFiles(files, width, percent) {
    	  for (let index = 0; index < files.length; index++) {
    	    const file = files[index]

    	    const fileName = file.name

    	    const content = await readFileAsDataURL(file)

    	    const img = await getNewImage(content)

    	    const elem = document.createElement('canvas')

    	    const widthImage = !width ? img.width : width
    	    const scaleFactor = width && width / img.width
    	    const heightImage = width ? img.height * scaleFactor : img.height

    	    elem.width = widthImage
    	    elem.height = heightImage

    	    const ctx = elem.getContext('2d')

    	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

    	    const blob = await getCanvasBlob(ctx.canvas, percent)

    	    const newFile = new File([blob], fileName, {
    	      type: 'image/jpeg',
    	      lastModified: Date.now()
    	    })

    	    files[index] = newFile
    	  }

    	  async function readFileAsDataURL(file) {
    	    const result = await new Promise((resolve) => {
    	      const fileReader = new FileReader()

    	      fileReader.onload = (e) => resolve(e.target.result)

    	      fileReader.readAsDataURL(file)
    	    })

    	    return result;
    	  }

    	  async function getNewImage(content) {
    	    const result = await new Promise((resolve) => {
    	      const img = new Image()

    	      img.src = content

    	      img.onload = () => resolve(img)
    	    })

    	    return result
    	  }

    	  async function getCanvasBlob(canvas, percent) {
    	    const result = await new Promise((resolve) => {
    	      canvas.toBlob((blob) => {
    	        resolve(blob)
    	      }, 'image/jpeg', percent)
    	    })

    	    return result
    	  }

    	  uploadFile(files);
    	}

    	const dropArea = document.querySelector('.upload__btn');

    	  dropArea.addEventListener("dragover", (event) => {
    	    event.preventDefault();
    	    dropArea.classList.add('active');
    	  });

    	  dropArea.addEventListener("dragleave", () => {
    	    dropArea.classList.remove('active');
    	  });


    	  function uploadFile(files) {
    	    files.forEach((file) => {
    	      if (file.type.includes('image')) {
    	        Backendless.Files.upload(file, path, overwrite = true)
    	      .then(function(fileURL) {
    	          let media = {
    	            file: fileURL.fileURL,
    	            isCover: false
    	          }

    	          data.media.push(media);
    	          data.media[0].isCover = true;
    	          data.media2 = data.media;
    	          data.imageList = data.media;
    	          data.activityImageAlertText = '';
    	          data.isDrag = true;

    	        })
    	      .catch( function( error ) {
    	        console.log(error)
    	        })
    	      }
    	    })

    	    return data.media;
    	  }

    	  dropArea.addEventListener("drop", (event) => {
    	    event.preventDefault();
    	    let files = event.dataTransfer.files;
    	    resizeFiles([...files], 700, 80);
    	    dropArea.classList.remove('active');
    	  });







    })(path, (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')), ___arguments.context.pageData);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-activity/components/3cc9bed4da442af39e98af38a236af17/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'media2'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/create-activity/components/91eee0065a64be6576e8fd8397d35029/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('3cc9bed4da442af39e98af38a236af17'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['isCover'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946')['isCover'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'media')) && (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[0]), 'isCover')) != true) {
    ___arguments.context.pageData['media'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'media')), -1, async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/099f6d62c7fa590a6c84794cfedbedee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var inch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 1) {
    inch = String('-') + String(getObjectProperty(___arguments.context.pageData, 'height'));
    ___arguments.context.pageData['heightData'] = (inch * 1);
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 2) {
    ___arguments.context.pageData['heightData'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-activity/components/3f2f1461d4b8879860f88a47d893f946/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));

  },
  /* handler:onMounted */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  console.log('');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/5687f9da010bc23ce0c9884db1c61259/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, getGeoLocation, clientAddress, geoInfo, types, mappingCategory, item, categoryName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getCategyFromGoogleTupe() {
  if (!(getObjectProperty(___arguments.context.pageData, 'isManualEdit'))) {
    if (types && !!types.length) {
      try {
        categoryName = (await Backendless.Request.get(`${Backendless.appPath}/services/categories/getCategoryFromType`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'type': JSON.stringify((types[0])) }).send());
        mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


         return ((getObjectProperty(item, 'name')) == categoryName);
        }))[0];
        if (!mappingCategory) {
          mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


           return ((getObjectProperty(item, 'name')) == 'Other');
          }))[0];
        }

      } catch (error) {
        console.log(error);
        mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


         return ((getObjectProperty(item, 'name')) == 'Other');
        }))[0];

      }
    } else {
      mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


       return ((getObjectProperty(item, 'name')) == 'Other');
      }))[0];
    }
    ___arguments.context.pageData['categorySelectValue'] = (getObjectProperty(mappingCategory, 'objectId'));
    ___arguments.context.pageData['category'] = (getObjectProperty(mappingCategory, 'name'));
    ___arguments.context.pageData['activityCategory'] = mappingCategory;
    ___arguments.context.pageData['iconCategory'] = (getObjectProperty(mappingCategory, 'icon'));
    if (!(getObjectProperty(mappingCategory, 'financialRoleRequired'))) {
      ___arguments.context.pageData['financialRoleRequired'] = false;
    } else {
      ___arguments.context.pageData['financialRoleRequired'] = true;
    }
  }
}


  ___arguments.context.pageData['errorLocation'] = '';
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a0f22ef2bcf47a388e9f473555a6754', true);
    getGeoLocation = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
    geoInfo = (getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/ReverseGeoCodding/getReverceGeoCodding`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'lat': (getObjectProperty(getGeoLocation, 'lat')),'lng': (getObjectProperty(getGeoLocation, 'lng')) }).send()), 'results'))[0];
    clientAddress = (getObjectProperty(geoInfo, 'formatted_address'));
    types = (getObjectProperty(geoInfo, 'types'));
    ;(async () => {
        await getCategyFromGoogleTupe();

    })();
    ___arguments.context.pageData['locationGeoPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(getGeoLocation, 'lat'))).setY((getObjectProperty(getGeoLocation, 'lng'))));
    ___arguments.context.pageData['locationPointResult'] = getGeoLocation;
    ___arguments.context.pageData['location'] = clientAddress;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('594b9e3753547161e26e31b916d68155'))['value'] = (getObjectProperty(___arguments.context.pageData, 'location'));
    if (getGeoLocation) {
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', (getObjectProperty(getGeoLocation, 'lat')), (getObjectProperty(getGeoLocation, 'lng')));
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('4df590d6dc3a54537dcf708f8de2676b', [getGeoLocation]);
      ___arguments.context.pageData['locationPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(getGeoLocation, 'lng'))).setY((getObjectProperty(getGeoLocation, 'lat'))));
    }
    ___arguments.context.pageData['isLocationSelected'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a0f22ef2bcf47a388e9f473555a6754', false);

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a0f22ef2bcf47a388e9f473555a6754', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('594b9e3753547161e26e31b916d68155'))['value'] = '';
    ___arguments.context.pageData['isLocationSelected'] = false;
    if ((getObjectProperty(error, 'code')) == 1) {
      ___arguments.context.pageData['errorLocation'] = 'Geolocation has been disabled for this website. Please allow this site to use geolocation or enter your address in the input';
    } else {
      ___arguments.context.pageData['errorLocation'] = 'Something went wrong. Please try again.';
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a0f22ef2bcf47a388e9f473555a6754', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/8b63ad7f65f16f827c5d2f5a810bab67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['checkboxAgeState'] = ((getObjectProperty(___arguments.context.pageData, 'age'))[0] == 18 && (getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0] == 100 ? true : false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-activity/components/e783989234853c03d2aaeed14fa50fba/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 2000 || 0));
  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'el'))['maxLength'] = 60;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-activity/components/d79f2bb365d14a49a78c9799b2dffb13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/c55e74920b7e1da8f6f433b99a8c1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Male');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Male', '');
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gender')) && ((getObjectProperty(___arguments.context.pageData, 'gender')).includes('Male')))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/create-activity/components/09154419473a835108f2c13cb295ae13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    try {
      await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('REQUEST_CAMERA_PERMISSIONS', undefined);
      await (async function() {
      	const btn = document.querySelector('.upload__btn')

      	btn.click()
      })();
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09154419473a835108f2c13cb295ae13')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('09154419473a835108f2c13cb295ae13')), 'hidden');
      }

    } catch (error) {
      console.log(error);
      await (async function() {
      	const btn = document.querySelector('.upload__btn')

      	btn.click()
      })();
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09154419473a835108f2c13cb295ae13')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('09154419473a835108f2c13cb295ae13')), 'hidden');
      }

    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992 && (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(path, mediaList, media2, data) {
  	async function resizeFiles(files, width, percent) {
  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index]

  	    const fileName = file.name

  	    const content = await readFileAsDataURL(file)

  	    const img = await getNewImage(content)

  	    const elem = document.createElement('canvas')

  	    const widthImage = !width ? img.width : width
  	    const scaleFactor = width && width / img.width
  	    const heightImage = width ? img.height * scaleFactor : img.height

  	    elem.width = widthImage
  	    elem.height = heightImage

  	    const ctx = elem.getContext('2d')

  	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	    const blob = await getCanvasBlob(ctx.canvas, percent)

  	    const newFile = new File([blob], fileName, {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })

  	    files[index] = newFile
  	  }

  	  async function readFileAsDataURL(file) {
  	    const result = await new Promise((resolve) => {
  	      const fileReader = new FileReader()

  	      fileReader.onload = (e) => resolve(e.target.result)

  	      fileReader.readAsDataURL(file)
  	    })

  	    return result;
  	  }

  	  async function getNewImage(content) {
  	    const result = await new Promise((resolve) => {
  	      const img = new Image()

  	      img.src = content

  	      img.onload = () => resolve(img)
  	    })

  	    return result
  	  }

  	  async function getCanvasBlob(canvas, percent) {
  	    const result = await new Promise((resolve) => {
  	      canvas.toBlob((blob) => {
  	        resolve(blob)
  	      }, 'image/jpeg', percent)
  	    })

  	    return result
  	  }

  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.upload__btn');

  	  dropArea.addEventListener("dragover", (event) => {
  	    event.preventDefault();
  	    dropArea.classList.add('active');
  	  });

  	  dropArea.addEventListener("dragleave", () => {
  	    dropArea.classList.remove('active');
  	  });


  	  function uploadFile(files) {
  	    files.forEach((file) => {
  	      if (file.type.includes('image')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	      .then(async function(fileURL) {
  	          let media = {
  	            file: fileURL.fileURL,
  	            isCover: false
  	          };
  	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', true);
  	          let moderationResult =  await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileURL.fileURL) }).send();
  	         if (moderationResult == 'OK') {
  	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
  	          data.media.push(media);
  	          data.media[0].isCover = true;
  	          data.media2 = data.media;
  	          data.imageList = data.media;
  	          data.activityImageAlertText = '';
  	          data.isDrag = true;
  	         } else {
  	           Backendless.Files.remove(fileURL.fileURL);
  	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
  	          data.showRejectMsg = true;
  	          (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('9bcfbdf2ffd2fff69d7b5f4670f55712', ({ 'showRejectMsg': true }));
  	         }
  	        })
  	      .catch( function( error ) {
  	        console.log(error)
  	        })
  	      }
  	    })

  	    return data.media;
  	  }

  	  dropArea.addEventListener("drop", (event) => {
  	    event.preventDefault();
  	    let files = event.dataTransfer.files;
  	    resizeFiles([...files], 700, 80);
  	    dropArea.classList.remove('active');
  	  });


  })((['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('')), (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')), ___arguments.context.pageData);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-activity/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/create-activity/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-activity/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/38ad17735a64da8b29854fffcc74146e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showServiceDisabledScreen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/e6d492f35c06dfc7926dd46b703497fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showServiceDisabledScreen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/da0f9556baabb8c15d0d9f7be4c4deb9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768 ? String('<p data-display="">You are currently outside an active service area. Please share your activity by clicking the icons above.</p> ') + String('<p data-display="">As soon as we have enough members in your area, we will notify you so you can fully enjoy FindMy+1&nbsp;</p>') : String('<p data-display="">You are currently outside an active service area. Please share your activity by clicking the icons below.</p> ') + String('<p data-display="">As soon as we have enough members in your area, we will notify you so you can fully enjoy FindMy+1&nbsp;</p>'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-activity/components/a43437c1bf5465c1745e69efb0c1fa05/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
      return [({ [`value`]: 'Friendly & Engaging',[`label`]: 'Friendly & Engaging' }), ({ [`value`]: 'Intellectual & Thought-Provoking',[`label`]: 'Intellectual & Thought-Provoking' }), ({ [`value`]: 'Active & Energetic',[`label`]: 'Active & Energetic' }), ({ [`value`]: ' Creative & Artistic',[`label`]: ' Creative & Artistic' }), ({ [`value`]: 'Laid-back & Easygoing',[`label`]: 'Laid-back & Easygoing' }), ({ [`value`]: 'Curious & Explorative',[`label`]: 'Curious & Explorative' })]

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8472eccd0a13acd64c794089cc2a5d7c', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-activity/components/ac2e22f879ba7953ae53a6e57e7ba815/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var personalQualitiesAndInterests, request, photoUri, descriptionStatus, financialStatus, locationStatus, activityMoodStatus, nameStatus, regExp, inputName, interestsStatus, qualitiesStatus, placePhoto, error, resourceName, places, activityDescription;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function validateActivityName() {
  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    inputName = (getObjectProperty(___arguments.context.pageData, 'name')).trim();
    regExp = ((new RegExp('\\.{4,}', 'g')).test(inputName));
    if (regExp == true) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', false);
      nameStatus = true;
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', true);
  }
}

/**
 * Describe this function...
 */
async function validateFeelAndMood() {
  if (getObjectProperty(___arguments.context.pageData, 'activityMood')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8472eccd0a13acd64c794089cc2a5d7c', false);
    activityMoodStatus = true;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8472eccd0a13acd64c794089cc2a5d7c', true);
  }
}

/**
 * Describe this function...
 */
async function validateLocation() {
  if (!(getObjectProperty(___arguments.context.pageData, 'location')) || !(getObjectProperty(___arguments.context.pageData, 'isLocationSelected'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07745225406d90ae80ac1f2748957c7f', true);
    locationStatus = false;
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07745225406d90ae80ac1f2748957c7f', false);
    locationStatus = true;
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function validatePaying() {
  if ((getObjectProperty(___arguments.context.pageData, 'financialRole')) && getValueLength((getObjectProperty(___arguments.context.pageData, 'financialRole')).trim()) != 0) {
    financialStatus = true;
  } else {
    financialStatus = false;
  }
}

/**
 * Describe this function...
 */
async function validateDescription() {
  if (getObjectProperty(___arguments.context.pageData, 'qualities')) {
    if (getValueLength((getObjectProperty(___arguments.context.pageData, 'qualities')).trim()) == 0) {
      qualitiesStatus = false;
      ___arguments.context.pageData['activityQualitiesAlertText'] = 'Enter your qualities';
    } else {
      qualitiesStatus = true;
    }
  } else {
    qualitiesStatus = false;
    ___arguments.context.pageData['activityQualitiesAlertText'] = 'Enter your qualities';
  }
  if (getObjectProperty(___arguments.context.pageData, 'interests')) {
    if (getValueLength((getObjectProperty(___arguments.context.pageData, 'interests')).trim()) == 0) {
      interestsStatus = false;
      ___arguments.context.pageData['activityInterestsAlertText'] = 'Enter your interests';
    } else {
      interestsStatus = true;
    }
  } else {
    interestsStatus = false;
    ___arguments.context.pageData['activityInterestsAlertText'] = 'Enter your interests';
  }
  descriptionStatus = qualitiesStatus && interestsStatus;
}

/**
 * Describe this function...
 */
async function getPhoto() {
  try {
    places = (await Backendless.Request.post(`${Backendless.appPath}/services/GoogleMapsPlaces/text-search`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(({ [`textQuery`]: (getObjectProperty(___arguments.context.pageData, 'location')),[`fields`]: 'places.photos' }))));
    if (places && !!(getObjectProperty(places, 'places')).length) {
      if (getObjectProperty(((getObjectProperty(places, 'places'))[0]), 'photos')) {
        resourceName = (getObjectProperty(((getObjectProperty(((getObjectProperty(places, 'places'))[0]), 'photos'))[0]), 'name'));
      }
    }
    if (resourceName) {
      placePhoto = (getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/GoogleMapsPlaces/place-photo`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'resourceName': JSON.stringify(resourceName),'maxHeightPx': 700,'maxWidthPx': 700 }).send()), 'photoUri'));
    } else {
      placePhoto = 'https://settledcellar.backendless.app/api/files/images/default_activity.png';
    }

  } catch (error) {
    placePhoto = 'https://settledcellar.backendless.app/api/files/images/default_activity.png';
    console.log(error);

  }
  return placePhoto
}

/**
 * Describe this function...
 */
async function getQualitiesAndInterests() {
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9c05791493b110f303d38615d2f4f1b4')), 'display')) {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['qualitiesForAI'] = (getObjectProperty(___arguments.context.pageData, 'qualities'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['interestsForAI'] = (getObjectProperty(___arguments.context.pageData, 'interests'));
    ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    ;(async () => {
        await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ((function () { return window.location.href })()));

    })();
  }
  return { [`interests`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'interestsForAI')),[`qualities`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'qualitiesForAI')) }
}

/**
 * Describe this function...
 */
async function createActivityDescription() {
  try {
    activityDescription = (JSON.parse((await Backendless.Request.get(`${Backendless.appPath}/services/chatGPT/getDescriptions`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'Message': JSON.stringify(request) }).send())));
    if (getValueLength((getObjectProperty(activityDescription, 'description'))) > 500 || getValueLength((getObjectProperty(activityDescription, 'description'))) < 220) {
      activityDescription = (JSON.parse((await Backendless.Request.get(`${Backendless.appPath}/services/chatGPT/getDescriptions`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'Message': JSON.stringify(request) }).send())));
    }

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['description'] = (activityDescription && (getObjectProperty(activityDescription, 'description')) ? (getValueLength((getObjectProperty(activityDescription, 'description'))) > 500 ? String((getObjectProperty(activityDescription, 'description')).slice(0, 496)) + String('...') : (getObjectProperty(activityDescription, 'description'))) : '');
  ___arguments.context.pageData['activityTitle'] = (activityDescription && (getObjectProperty(activityDescription, 'title')) ? (getObjectProperty(activityDescription, 'title')) : '');
  if (!(activityDescription && (getObjectProperty(activityDescription, 'title')))) {
    ___arguments.context.pageData['needManualTitle'] = true;
  }
  if (!(activityDescription && (getObjectProperty(activityDescription, 'description')))) {
    ___arguments.context.pageData['needManualDescription'] = true;
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def280c3910a89236b494a68e205f0d8', true);
  ___arguments.context.pageData['disabledBtnNextPreview'] = true;
  while (!(getObjectProperty(___arguments.context.pageData, 'location')) && (getObjectProperty(___arguments.context.pageData, 'isLocationSelected'))) {
    await new Promise(r => setTimeout(r, 100 || 0));
  }
  await validateActivityName();
  await validateFeelAndMood();
  await validateLocation();
  await validatePaying();
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9c05791493b110f303d38615d2f4f1b4')), 'display')) {
    await validateDescription();
  } else {
    descriptionStatus = true;
  }
  if (nameStatus && activityMoodStatus && locationStatus && financialStatus && descriptionStatus) {
    photoUri = await getPhoto();
    (getObjectProperty(___arguments.context.pageData, 'media')).push(({ [`file`]: photoUri,[`isCover`]: true,[`isGooglePhoto`]: true }));
    ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
    ___arguments.context.pageData['imageList'] = (getObjectProperty(___arguments.context.pageData, 'media'));
    personalQualitiesAndInterests = await getQualitiesAndInterests();
    request = ['Generate a title and a description for an activity posted in an app designed for meeting other people based on mutual interests. The title must be at least 80 characters and no more than 100 characters. The description must be at least 290 characters and no more than 320 characters.The response should be in the following JSON format: {"title":"", "description":""}. Do not mention the person\'s age explicitly, but allude to it.  Write it from a single person\'s perspective meeting another person. Make it sound so others would want to meet the person posting the generated text. The tone and mood of the text you generate must be ',(getObjectProperty(___arguments.context.pageData, 'activityMood')),'. Make sure to use emojis where appropriate. Below are the data points to consider. Make sure to assess personal qualities and interests only as they relate to the actual activity, do not reference them directly if they do not apply.','\n','Activity name - ',(getObjectProperty(___arguments.context.pageData, 'name')),'\n','Category - ',(getObjectProperty(___arguments.context.pageData, 'category')),'\n','Location - ',(getObjectProperty(___arguments.context.pageData, 'location')),'\n','Person creating  the activity - ',(await (async function(dob) {
    	let now = new Date(); 
    	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); 
    	
    	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate()); 
    	
    	let age; 
    	
    	age = today.getFullYear() - dob.getFullYear();
    	
    	if (today < dobnow) {
    	  age = age-1;
    	} else {
    	  age = age
    	}
    	
    	return age
    })((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'birthDate')))))),' year old ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'gender')),'\n','Who pays - ',(getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'driver' || (getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'passenger' ? ((getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'driver' ? 'All expenses will be at my expense' : 'All expenses will be at your expense') : String('Expenses will be shared: ') + String(getObjectProperty(___arguments.context.pageData, 'financialRole')),'\n','Personal qualities of the person creating the activity  -  ',(getObjectProperty(personalQualitiesAndInterests, 'qualities')),'\n','Personal interests  of the person creating the activity - ',(getObjectProperty(personalQualitiesAndInterests, 'interests'))].join('');
    await createActivityDescription();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def280c3910a89236b494a68e205f0d8', false);
    ___arguments.context.pageData['disabledBtnNextPreview'] = false;
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')), 'currentStepDescription', '');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')).push('currentStepPreview');
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c4bda5b072b41136df47dded8b2cb79')), 'open', '');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4bb2456d78bcd6adfdad642bd569fe4b')).push('open');
    await (async function() {
    	swiper = new Swiper('.swiper', {

    	  pagination: {
    	    el: '.swiper-pagination',
    	    clickable: true
    	  }

    	});

    })();
  } else {
    ___arguments.context.pageData['disabledBtnNextPreview'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('def280c3910a89236b494a68e205f0d8', false);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6039d74cf061de58a8f122f42ae1561c')));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isManualEdit')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/041e25dc93e93f8d50a855dba48d00aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var nameStatus, regExp, inputName, validateList, imageStatus, descriptionStatus, titleStatus, locationStatus, financialStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function validateActivityName() {
  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    inputName = (getObjectProperty(___arguments.context.pageData, 'name')).trim();
    regExp = ((new RegExp('\\.{4,}', 'g')).test(inputName));
    if (regExp == true) {
      ___arguments.context.pageData['activityAlertText'] = 'Enter activity name';
      nameStatus = false;
      if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')).includes('alert-border'))) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'alert-border');
      }
      await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')));
    } else {
      ___arguments.context.pageData['activityAlertText'] = '';
      nameStatus = true;
    }
  } else {
    ___arguments.context.pageData['activityAlertText'] = 'Enter activity name';
    nameStatus = false;
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'alert-border');
    }
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')));
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function validatePaying() {
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')), 'display'))) {
    financialStatus = true;
    return ;
  }
  if (getObjectProperty(___arguments.context.pageData, 'paySelectValue')) {
    if ((getObjectProperty(___arguments.context.pageData, 'paySelectValue')) != 'payYourOwnWay') {
      ___arguments.context.pageData['finansialRoles'] = (getObjectProperty(___arguments.context.pageData, 'paySelectValue'));
      financialStatus = true;
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) && !(getValueLength((getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')).trim()) == 0)) {
        ___arguments.context.pageData['finansialRoles'] = (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput'));
        financialStatus = true;
      } else {
        ___arguments.context.pageData['activityRolesAlertText'] = 'Please select a Financial Role for your activity';
        financialStatus = false;
        await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')));
        if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')).slice(-1)[0] != 'alert-border') {
          addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')), 'alert-border');
        }
      }
    }
  } else {
    ___arguments.context.pageData['activityRolesAlertText'] = 'Please select a Financial Role for your activity';
    financialStatus = false;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6f9fde3dea4c108932acec8953e6316a')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6f9fde3dea4c108932acec8953e6316a')), 'alert-border');
    }
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')));
  }
}

/**
 * Describe this function...
 */
async function validateLocation() {
  if (!(getObjectProperty(___arguments.context.pageData, 'location'))) {
    ___arguments.context.pageData['errorLocation'] = 'Please, enter your location';
    locationStatus = false;
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('594b9e3753547161e26e31b916d68155')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('594b9e3753547161e26e31b916d68155')), 'alert-border');
    }
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')));
  } else {
    ___arguments.context.pageData['errorLocation'] = '';
    locationStatus = true;
  }
}

/**
 * Describe this function...
 */
async function validateActivityTitle() {
  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'activityTitle')).trim()) == 0) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7a1184326c08f3d325fdeb6446548fe4')));
    titleStatus = false;
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f346419c73ff1eb8a5acad1230938847')));
  } else {
    titleStatus = true;
    ___arguments.context.pageData['needManualTitle'] = false;
  }
}

/**
 * Describe this function...
 */
async function validateActivityDescription() {
  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'description')).trim()) == 0) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e844c167d5aed83169b3a90317481348')));
    descriptionStatus = false;
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('da3d01ca26dd308f91ef0fdaaed903a6')));
  } else {
    descriptionStatus = true;
    ___arguments.context.pageData['needManualDescription'] = false;
  }
}

/**
 * Describe this function...
 */
async function validateActivityImage() {
  if (!(getObjectProperty(___arguments.context.pageData, 'media')) || !(getObjectProperty(___arguments.context.pageData, 'media')).length) {
    imageStatus = false;
    ___arguments.context.pageData['activityImageAlertText'] = 'Please add an image';
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13')));
  } else {
    imageStatus = true;
  }
}


  await validateActivityName();
  await validatePaying();
  await validateLocation();
  await validateActivityDescription();
  await validateActivityTitle();
  await validateActivityImage();
  validateList = [nameStatus, financialStatus, locationStatus, titleStatus, descriptionStatus, imageStatus];
  if (!(validateList.includes(false))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd455704370e2363b70b946c6f7fbb64', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/ac3d8fbe288619e5224249344c0a193f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.pageData['counterQualities'] = (String(getValueLength(___arguments.value)) + String('/150 symbols'));
  if (getValueLength(___arguments.value.trim()) == 0) {
    ___arguments.context.pageData['activityQualitiesAlertText'] = 'Enter your qualities';
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ac3d8fbe288619e5224249344c0a193f')).includes('alert-border')) {
      ___arguments.context.pageData['activityQualitiesAlertText'] = '';
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '75vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('876396e94ad5350d2702af2f96268eed')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/create-activity/components/32d4ed7d7c6644c3e5f7e51adf4caf84/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.pageData['interestsCounter'] = (String(getValueLength(___arguments.value)) + String('/150 symbols'));
  if (getValueLength(___arguments.value.trim()) == 0) {
    ___arguments.context.pageData['activityInterestsAlertText'] = 'Enter your interests';
  } else {
    ___arguments.context.pageData['activityInterestsAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    
  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    
  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/create-activity/components/9c05791493b110f303d38615d2f4f1b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'qualitiesForAI')) || !(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'interestsForAI'))) {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/2102213f837a2aa84e15511b0c2eab01/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return (await (async function(dob) {
    	let now = new Date(); 
    	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); 
    	
    	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate()); 
    	
    	let age; 
    	
    	age = today.getFullYear() - dob.getFullYear();
    	
    	if (today < dobnow) {
    	  age = age-1;
    	} else {
    	  age = age
    	}
    	
    	return age + ' Years Old'
    })((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'birthDate'))))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-activity/components/26d946f52005c6b7e3a179876dff2957/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var height, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
    height = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'heightList')), async (item) => {


     return ((getObjectProperty(item, 'value')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'height')));
    }))[0];
    if (height) {
      return ((getObjectProperty(height, 'label')).slice(0, (getObjectProperty(height, 'label')).indexOf(' ') + 1));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-activity/components/5cce0902bebfecb47041cc65fadf7182/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'height')) {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/0f0d6be10c6faa756752692880429644/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″ (122 cm)' }), ({ [`value`]: '124',[`label`]: '4′1″ (124 cm)' }), ({ [`value`]: '127',[`label`]: '4′2″ (127 cm)' }), ({ [`value`]: '130',[`label`]: '4′3″ (130 cm)' }), ({ [`value`]: '132',[`label`]: '4′4″ (132 cm)' }), ({ [`value`]: '135',[`label`]: '4′5″ (135 cm)' }), ({ [`value`]: '137',[`label`]: '4′6″ (137 cm)' }), ({ [`value`]: '140',[`label`]: '4′7″ (140 cm)' }), ({ [`value`]: '142',[`label`]: '4′8″ (142 cm)' }), ({ [`value`]: '145',[`label`]: '4′9″ (145 cm)' }), ({ [`value`]: '152',[`label`]: '5′0″ (152 cm)' }), ({ [`value`]: '155',[`label`]: '5′1″ (155 cm)' }), ({ [`value`]: '157',[`label`]: '5′2″ (157 cm)' }), ({ [`value`]: '160',[`label`]: '5′3″ (160 cm)' }), ({ [`value`]: '163',[`label`]: '5′4″ (163 cm)' }), ({ [`value`]: '165',[`label`]: '5′5″ (165 cm)' }), ({ [`value`]: '168',[`label`]: '5′6″ (168 cm)' }), ({ [`value`]: '170',[`label`]: '5′7″ (170 cm)' }), ({ [`value`]: '173',[`label`]: '5′8″ (173 cm)' }), ({ [`value`]: '176',[`label`]: '5′9″ (176 cm)' }), ({ [`value`]: '178',[`label`]: '5′10″ (178 cm)' }), ({ [`value`]: '180',[`label`]: '5′11″ (180 cm)' }), ({ [`value`]: '183',[`label`]: '6′0″ (183 cm)' }), ({ [`value`]: '185',[`label`]: '6′1″ (185 cm)' }), ({ [`value`]: '188',[`label`]: '6′2″ (188 cm)' }), ({ [`value`]: '191',[`label`]: '6′3″ (191 cm)' }), ({ [`value`]: '193',[`label`]: '6′4″ (193 cm)' }), ({ [`value`]: '195',[`label`]: '6′5″ (195 cm)' }), ({ [`value`]: '198',[`label`]: '6′6″ (198 cm)' }), ({ [`value`]: '201',[`label`]: '6′7″ (201 cm)' }), ({ [`value`]: '203',[`label`]: '6′8″ (203 cm)' }), ({ [`value`]: '206',[`label`]: '6′9″ (206 cm)' }), ({ [`value`]: '208',[`label`]: '6′10″ (208 cm)' }), ({ [`value`]: '211',[`label`]: '6′11″ (211 cm)' }), ({ [`value`]: '213',[`label`]: '7′0″ (213 cm)' })];

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-activity/components/d10d309232938bd1f2b99988d16b86f3/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'zodiac'))) {
    return (['styles/img/zodiac/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'zodiac')).toLowerCase(),'.svg'].join(''));
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/create-activity/components/501d39850841c5fa976bada75d11c3f3/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var photoObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
    photoObj = (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


     return (getObjectProperty(item, 'isCover'));
    }));
    if (photoObj) {
      return (getObjectProperty(photoObj, 'file'));
    }
  }

  return ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) : null)

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/create-activity/components/252c1244020f9e1ece04b8ccda3505ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'driver' || (getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'passenger') {
    if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
      if ((getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'driver') {
        return (String('Covers Expense ') + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))));
      } else {
        return 'Covers Expens your +1';
      }
    }
  } else {
    return (String('Share Expense ') + String(getObjectProperty(___arguments.context.pageData, 'financialRole')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-activity/components/e844c167d5aed83169b3a90317481348/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.pageData['descriptionCounter'] = (String(getValueLength(___arguments.value)) + String('/500 symbols'));
  if (!___arguments.value.trim().length) {
    ___arguments.context.pageData['activityDescriptionAlertText'] = 'Please, describe your activity';
  } else {
    ___arguments.context.pageData['activityDescriptionAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '75vh';
    await new Promise(r => setTimeout(r, 300 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('655a686c7c4e565176fdf37d1048d1a9')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/create-activity/components/28210676aee14d32616ba0e9d10bf724/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'needManualTitle')) {
    ___arguments.context.pageData['activityTitleAlertText'] = 'Please, describe your activity';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-activity/components/7908532832056d930fec97b4e823a397/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'needManualDescription')) {
    ___arguments.context.pageData['activityDescriptionAlertText'] = 'Please, describe your activity';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-activity/components/1d72ecdcaad6d368c5edb028ff5ec054/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.pageData['descriptionTitleCounter'] = (String(getValueLength(___arguments.value)) + String('/100 symbols'));
  if (!___arguments.value.trim().length) {
    ___arguments.context.pageData['activityTitleAlertText'] = 'Please, describe your activity';
  } else {
    ___arguments.context.pageData['activityTitleAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '75vh';
    await new Promise(r => setTimeout(r, 300 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7a1184326c08f3d325fdeb6446548fe4')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('10fbf08b9712ec246ca2021b9e1436e5'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/create-activity/components/5e6f2d5c13ac8168aab61c32bd4de448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var link, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  link = String('https://app.findmyplus.one/index.html?page=activity&activityId=') + String(getObjectProperty(___arguments.context.pageData, 'activityId'));
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    await ( async function (link, message, resourceName) { return BackendlessUI.DeviceAPI.shareSheetRequest({ link, message, resourceName }) })(link, 'Check out my new activity on the FindMyPlusOne app.', (getObjectProperty(___arguments.context.pageData, 'name')));
  } else {
    ___arguments.context.pageData['modalShareOpen'] = true;
    ___arguments.context.pageData['shareLink'] = link;
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('share_activity');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'visibility')) {
    return ((getObjectProperty(___arguments.context.pageData, 'visibility')) == 1);
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/9e0a190957ba3c15ae97995ed5087ad7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/3f56ef0d5407dda61a92369cbf87cc5c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'previousPage')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), undefined);
  } else {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/7a4f484cb503d2954858f3d5146539ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'previousPage')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), undefined);
  } else {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/e84a48bb2617c8eac39dab62a0182765/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'previousPage')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), undefined);
  } else {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/d0a6ee9e208cbf0b1d966935ea641f68/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')), 'currentStepPreview', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')).push('currentStepDescription');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4bb2456d78bcd6adfdad642bd569fe4b')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c4bda5b072b41136df47dded8b2cb79')).push('open');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4756c7ca664952725d2a42e261b227ed', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1bebea2881612e3b8917aee54dca676c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f346419c73ff1eb8a5acad1230938847', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da3d01ca26dd308f91ef0fdaaed903a6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d79f2bb365d14a49a78c9799b2dffb13', true);
  ___arguments.context.pageData['isManualEdit'] = true;
  await (async function() {
  	if (swiper) {

  	  if (Array.isArray(swiper)) {
  	    for (const swiperItem of swiper) {
  	      swiperItem.destroy(true, true);
  	    }
  	  } else {
  	    swiper.destroy(true, true)
  	  }

  	}
  })();
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd8ea1bbcc54f0af968ecd067e0a4656')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/3a6e5b5a79428bfc2dd9f41de219b392/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function returnToFirstScreen() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1bebea2881612e3b8917aee54dca676c', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f346419c73ff1eb8a5acad1230938847', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('da3d01ca26dd308f91ef0fdaaed903a6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d79f2bb365d14a49a78c9799b2dffb13', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4756c7ca664952725d2a42e261b227ed', true);
}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')), 'currentStepPreview', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')).push('currentStepDescription');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4bb2456d78bcd6adfdad642bd569fe4b')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c4bda5b072b41136df47dded8b2cb79')).push('open');
  ___arguments.context.pageData['media'] = [];
  ___arguments.context.pageData['media2'] = [];
  ___arguments.context.pageData['imageList'] = [];
  ___arguments.context.pageData['isManualEdit'] = false;
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')), 'display')) {
    await returnToFirstScreen();
  }
  await (async function() {
  	if (swiper) {

  	  if (Array.isArray(swiper)) {
  	    for (const swiperItem of swiper) {
  	      swiperItem.destroy(true, true);
  	    }
  	  } else {
  	    swiper.destroy(true, true)
  	  }

  	}
  })();
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd8ea1bbcc54f0af968ecd067e0a4656')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/f6eb99d5727be25db65534f56aa113ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')), 'currentStepPreview', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')).push('currentStepSettings');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4bb2456d78bcd6adfdad642bd569fe4b')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8ec143146a6b86e602ddff4cc2f38801')).push('open');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd8ea1bbcc54f0af968ecd067e0a4656')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/42458567a8d8a8133456222fb253c557/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')), 'currentStepSettings', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')).push('currentStepPreview');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8ec143146a6b86e602ddff4cc2f38801')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4bb2456d78bcd6adfdad642bd569fe4b')).push('open');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd8ea1bbcc54f0af968ecd067e0a4656')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/64fb38a4853923226314a85644f2f753/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['financialRole'] = 'driver';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d2cadcf117eb39a308f75f27f5e52d4', false);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'driver' ? ['selectionButtons__btn', 'active'] : ['selectionButtons__btn'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/create-activity/components/51443ab664d55a2a68483fccecabeaf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['financialRole'] = 'passenger';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d2cadcf117eb39a308f75f27f5e52d4', false);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'passenger' ? ['selectionButtons__btn', 'active'] : ['selectionButtons__btn'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/create-activity/components/fcf68a05599c067cb2dbde9d089a5652/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d2cadcf117eb39a308f75f27f5e52d4', false);
  ___arguments.context.pageData['financialRole'] = '50/50';

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financialRole')) != 'passenger' && (getObjectProperty(___arguments.context.pageData, 'financialRole')) != 'driver' ? ['selectionButtons__btn', 'active'] : ['selectionButtons__btn'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/create-activity/components/52b260437796121bb9eb3ea58a16a0c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return (String('About ') + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-activity/components/966ae081f9be4fc2e11bc7218d033823/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('966ae081f9be4fc2e11bc7218d033823'))['pointer-events'] = 'none';
  var j_list = (getObjectProperty(___arguments.context.pageData, 'media'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['isCover'] = false;
  }
  ___arguments.context.pageData['media'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'media')), async (item) => {


   return ((getObjectProperty(item, 'file')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file')));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 1) {
    ((getObjectProperty(___arguments.context.pageData, 'media'))[0])['isCover'] = true;
  }
  try {
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'isGooglePhoto'))) {
      ;(async () => {
          await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file'))));

      })();
    }

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['imageList'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('966ae081f9be4fc2e11bc7218d033823'))['pointer-events'] = 'auto';
  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/02fa45cb955cdac4f7ad79283e31349a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isManualEdit')) ? 'Edit Activity' : 'Description')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-activity/components/8cdccce4c6d7f6630ba2dcdcfe783e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var isFormValid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  isFormValid = true;
  if ((getObjectProperty(___arguments.context.pageData, 'name')) && !!(getObjectProperty(___arguments.context.pageData, 'name')).trim().length) {
    if ((new RegExp('\\.{4,}', 'g')).test((getObjectProperty(___arguments.context.pageData, 'name')))) {
      isFormValid = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', false);
    }
  } else {
    isFormValid = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', true);
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'activityTitle')) || !(getObjectProperty(___arguments.context.pageData, 'activityTitle')).trim().length) {
    isFormValid = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'description')) || !(getObjectProperty(___arguments.context.pageData, 'description')).trim().length) {
    isFormValid = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'media')).length) {
    isFormValid = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'location')) || !(getObjectProperty(___arguments.context.pageData, 'isLocationSelected'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07745225406d90ae80ac1f2748957c7f', true);
    isFormValid = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'financialRole')) || !(getObjectProperty(___arguments.context.pageData, 'financialRole')).trim().length) {
    isFormValid = false;
  }
  if (isFormValid) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')), 'currentStepDescription', '');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')).push('currentStepPreview');
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c4bda5b072b41136df47dded8b2cb79')), 'open', '');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4bb2456d78bcd6adfdad642bd569fe4b')).push('open');
    await (async function() {
    	swiper = new Swiper('.swiper', {

    	  pagination: {
    	    el: '.swiper-pagination',
    	    clickable: true
    	  }

    	});

    })();
  } else {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd8ea1bbcc54f0af968ecd067e0a4656')));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isManualEdit'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/7edf59e890b84a2915ba9e8a774f7561/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['activityTimingAlertText'] = '';
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7eb9af336d564ab949398bda49392324')));
  ___arguments.context.pageData['ongoing'] = 'ongoing';
  ___arguments.context.pageData['scheduled'] = false;
  if (getObjectProperty(___arguments.context.pageData, 'specific')) {
    ___arguments.context.pageData['specific'] = false;
  }
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'value')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f'))['value'] = '';
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).pop();
    ___arguments.context.pageData['activityTimingAlertText'] = '';
  }
}


  ___arguments.context.pageData['activityTimingAlertText'] = '';
  ___arguments.context.pageData['ongoingInput'] = null;
  ___arguments.context.pageData['specificInput'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-activity/components/04de84164142354208d3f1ba77fa0ca7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'specific')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/8b556d982c47d359874a11981f6d5194/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'ongoing')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/f7a1c3a66b84459116bf739ec15fdd61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, isAgeSet, order, pathIndex, j, name2, item, timingStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function validateTiming() {
  if ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'scheduled') {
    timingStatus = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'specific') {
    if (getObjectProperty(___arguments.context.pageData, 'specificInput')) {
      timingStatus = true;
    } else {
      timingStatus = false;
      ___arguments.context.pageData['activityTimingAlertText'] = 'Please choose date';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6039d74cf061de58a8f122f42ae1561c')));
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'ongoingInput')) && !!(getObjectProperty(___arguments.context.pageData, 'ongoingInput')).trim().length) {
      timingStatus = true;
    } else {
      timingStatus = false;
      ___arguments.context.pageData['activityTimingAlertText'] = 'Please, enter timing';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6039d74cf061de58a8f122f42ae1561c')));
    }
  }
}


  await validateTiming();
  if (!timingStatus) {
    return ;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f53de2620f4d733b0e7582de365227b', true);
  ___arguments.context.pageData['publishBtnDisable'] = true;
  try {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'media'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (getObjectProperty(j, 'isGooglePhoto')) {
        if (!(getObjectProperty(___arguments.context.pageData, 'newName'))) {
          name2 = (await asyncListFilter(((getObjectProperty(___arguments.context.pageData, 'name')).split('')), async (item) => {


           return (item != '\'' && item != '.');
          }));
          ___arguments.context.pageData['newName'] = (name2.join(''));
        }
        j['file'] = (await Backendless.Files.upload(
            (getObjectProperty(j, 'file')),
            encodePath((['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/',(getObjectProperty(___arguments.context.pageData, 'newName')),'/',[((new Date()).valueOf()),'_','googleimg.jpg'].join('')].join(''))),
            true
          ).then(result => result.fileURL));
        delete j['isGooglePhoto'];
      }
      pathIndex = (getObjectProperty(j, 'file')).indexOf('/pictures') + 1;
      j['file'] = (subsequenceFromStartLast((getObjectProperty(j, 'file')), (pathIndex - 1)));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'specific') {
      order = 1;
    } else if ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'ongoing') {
      order = 2;
    } else {
      order = 3;
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'financialRoleRequired'))) {
      ___arguments.context.pageData['financialRole'] = null;
    }
    ___arguments.context.pageData['activityId'] = (await Backendless.Request.post(`${Backendless.appPath}/services/saveActivity/saveActivity`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'name': (getObjectProperty(___arguments.context.pageData, 'name')),'location': (getObjectProperty(___arguments.context.pageData, 'location')),'keepLocationPrivate': (getObjectProperty(___arguments.context.pageData, 'keepLocationPrivate')),'media': (getObjectProperty(___arguments.context.pageData, 'media')),'locationPoint': (getObjectProperty(___arguments.context.pageData, 'locationPoint')),'description': (getObjectProperty(___arguments.context.pageData, 'description')),'activityDate': (getObjectProperty(___arguments.context.pageData, 'specificInput')),'ongoingTiming': (getObjectProperty(___arguments.context.pageData, 'ongoingInput')),'finansialRole': (getObjectProperty(___arguments.context.pageData, 'financialRole')),'visability': (getObjectProperty(___arguments.context.pageData, 'visibility')),'code': null,'order': order,'activityTitle': (getObjectProperty(___arguments.context.pageData, 'activityTitle')) }));
    if (getObjectProperty(___arguments.context.pageData, 'activityCategory')) {
      await Backendless.Data.of('Activity').addRelation((getObjectProperty(___arguments.context.pageData, 'activityId')), 'category', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityCategory')), 'objectId')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityCategory')), 'objectId')) : (getObjectProperty(___arguments.context.pageData, 'activityCategory'))]);
    }
    await Backendless.Data.of('Activity').addRelation((getObjectProperty(___arguments.context.pageData, 'activityId')), 'author', [({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) })]);
    await Backendless.Data.of('Users').addRelation((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'activity', [({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'activityId')) })]);
    delete ___arguments.context.appData['userActivitiesForInvitation'];
    isAgeSet = !((getObjectProperty(___arguments.context.pageData, 'age'))[0] == 18 && (getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0] == 100);
    if (!(getObjectProperty(___arguments.context.pageData, 'heightCheckbox')) && !(getObjectProperty(___arguments.context.pageData, 'height'))) {
      ___arguments.context.pageData['heightDataTable'] = null;
    } else {
      if (getObjectProperty(___arguments.context.pageData, 'heightCheckbox')) {
        ___arguments.context.pageData['heightDataTable'] = null;
      } else {
        ___arguments.context.pageData['heightDataTable'] = ((getObjectProperty(___arguments.context.pageData, 'heightData')) * 1);
      }
    }
    if (isAgeSet || !!(getObjectProperty(___arguments.context.pageData, 'gender')).length || (getObjectProperty(___arguments.context.pageData, 'heightDataTable'))) {
      ___arguments.context.pageData['objectIdActivityPreferences'] = (await Backendless.Request.post(`${Backendless.appPath}/services/saveActivityPreferences/saveoActivityPreferences`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'ageFrom': ((getObjectProperty(___arguments.context.pageData, 'age'))[0]),'ageTo': ((getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0]),'gender': (getObjectProperty(___arguments.context.pageData, 'gender')),'height': (getObjectProperty(___arguments.context.pageData, 'heightDataTable')),'children': null }));
      await Backendless.Data.of('Activity').addRelation((getObjectProperty(___arguments.context.pageData, 'activityId')), 'preferences', [({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'objectIdActivityPreferences')) })]);
    }
    if (!(await BackendlessUI.Functions.Custom['fn_a75f6a563aabaeda5a92d8c6a6055093']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
      ___arguments.context.pageData['showServiceDisabledScreen'] = true;
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35dfbd4b7152263312277c4547c1bb5e', true);

  } catch (error) {
    console.log(error);
    (function (message) { alert(message) })('Failed to save activity, please try again later');

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f53de2620f4d733b0e7582de365227b', false);
  ___arguments.context.pageData['publishBtnDisable'] = true;
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('activity_created');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-activity/components/aa92f4f670c73ab7d98160c587d36926/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'checkboxAgeState')) ? ({ [`opacity`]: '0.35' }) : ({ [`opacity`]: '1' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/create-activity/components/21921cf9d8475ad207ec9154d81ef267/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'age')) {
    return ([(getObjectProperty(___arguments.context.pageData, 'age'))[0],'-',(getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0]].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-activity/components/6df6d4b13bfff5e7a111d08f751d6af4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Female');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Female', '');
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gender')) && ((getObjectProperty(___arguments.context.pageData, 'gender')).includes('Female')))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/create-activity/components/67a308e77eca91cda901ae6a12c8ceb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Non-Binary');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Non-Binary', '');
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gender')) && ((getObjectProperty(___arguments.context.pageData, 'gender')).includes('Non-Binary')))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/create-activity/components/73b54014edf4489da74203a6490cfee8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'gender')) || !(getObjectProperty(___arguments.context.pageData, 'gender')).length ? ({ [`opacity`]: '0.35' }) : ({ [`opacity`]: '1' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/create-activity/components/dd1a437bcd15baf26cdce5a87fb44a96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'media')) && !(getObjectProperty(___arguments.context.pageData, 'media')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-activity/components/5e298f72048deb2fccd1962d63d45593/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'specificInput')) {
    return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty(___arguments.context.pageData, 'specificInput'))));
  } else if (getObjectProperty(___arguments.context.pageData, 'ongoingInput')) {
    return (getObjectProperty(___arguments.context.pageData, 'ongoingInput'));
  }

  return 'To be scheduled'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-group/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/c8c1f31e123dc7cba0f700c139228274/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var categoryStatus, descriptionLongStatus, descriptionStatus, error, inputDescription, inputName, item, j, mediaStatus, nameStatus, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    inputName = (getObjectProperty(___arguments.context.pageData, 'name')).trim();
    regExp = ((new RegExp('\\.{4,}', 'g')).test(inputName));
    if (regExp == true) {
      ___arguments.context.pageData['activityAlertText'] = 'Enter group name';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'alert-border');
    } else {
      ___arguments.context.pageData['activityAlertText'] = '';
      nameStatus = true;
    }
  } else {
    ___arguments.context.pageData['activityAlertText'] = 'Enter group name';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'alert-border');
  }
  if (getObjectProperty(___arguments.context.pageData, 'description')) {
    inputDescription = (getObjectProperty(___arguments.context.pageData, 'description')).trim();
    regExp = ((new RegExp('\\.{4,}', 'g')).test(inputDescription));
    if (inputDescription && !regExp) {
      ___arguments.context.pageData['activityDescriptionShortAlertText'] = '';
      descriptionStatus = true;
    } else {
      ___arguments.context.pageData['activityDescriptionShortAlertText'] = 'Please, describe your group';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')), 'alert-border');
    }
  } else {
    ___arguments.context.pageData['activityDescriptionShortAlertText'] = 'Please describe your group';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')), 'alert-border');
  }
  if (getObjectProperty(___arguments.context.pageData, 'descriptionShort')) {
    inputDescription = (getObjectProperty(___arguments.context.pageData, 'descriptionShort')).trim();
    regExp = ((new RegExp('\\.{4,}', 'g')).test(inputDescription));
    if (inputDescription && regExp == false) {
      ___arguments.context.pageData['activityDescriptionAlertText'] = '';
      descriptionLongStatus = true;
    } else {
      ___arguments.context.pageData['activityDescriptionAlertText'] = 'Please describe your group';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cfbc6815a7d748879309d3f13276ffdd')), 'alert-border');
    }
  } else {
    ___arguments.context.pageData['activityDescriptionAlertText'] = 'Please describe your group';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cfbc6815a7d748879309d3f13276ffdd')), 'alert-border');
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'category'))) {
    ___arguments.context.pageData['categoryAlertText'] = 'Please, select a category';
    categoryStatus = false;
  } else {
    ___arguments.context.pageData['categoryAlertText'] = '';
    categoryStatus = true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 0 || (getObjectProperty(___arguments.context.pageData, 'media2')).length == 0) {
    ___arguments.context.pageData['activityImageAlertText'] = 'Please, add a photo';
    mediaStatus = false;
  } else {
    ___arguments.context.pageData['activityImageAlertText'] = '';
    mediaStatus = true;
  }
  if (nameStatus && descriptionStatus && descriptionLongStatus && categoryStatus && mediaStatus) {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'media'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(j, 'file')).split('/')[0] == 'https:' && subsequenceFromEndLast((getObjectProperty(j, 'file')).split('/'), 4).join('/') != 'api') {
        j['file'] = (String('/') + String(subsequenceFromEndLast((getObjectProperty(j, 'file')).split('/'), 4).join('/')));
        if ((getObjectProperty(j, 'file')).split('/')[1] == 'files') {
          j['file'] = (String('/') + String(subsequenceFromStartLast((getObjectProperty(j, 'file')).split('/'), 2).join('/')));
        }
      }
    }
    try {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8c1f31e123dc7cba0f700c139228274'))['disabled'] = true;
      ___arguments.context.pageData['groupId'] = (getObjectProperty((await Backendless.Data.of('Group').save( ({ 'name': (getObjectProperty(___arguments.context.pageData, 'name')),'shortDescription': (getObjectProperty(___arguments.context.pageData, 'descriptionShort')),'profilePictures': (getObjectProperty(___arguments.context.pageData, 'media')),'longDescription': (getObjectProperty(___arguments.context.pageData, 'description')),'visibility': (getObjectProperty(___arguments.context.pageData, 'visibility')),'membershipType': (getObjectProperty(___arguments.context.pageData, 'membershipType')),'location': (getObjectProperty(___arguments.context.pageData, 'location')),'locationPiont': (getObjectProperty(___arguments.context.pageData, 'locationPoint')) }) )), 'objectId'));
      await Backendless.Data.of('Group').addRelation((getObjectProperty(___arguments.context.pageData, 'groupId')), 'category', [({ 'objectId': (getObjectProperty(___arguments.context.pageData, 'category')) })]);

    } catch (error) {
      console.log(error);
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8c1f31e123dc7cba0f700c139228274'))['disabled'] = false;

    }
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a915ac93423faf18518809839f0bf768')));
    await Backendless.Data.of('Group').addRelation((getObjectProperty(___arguments.context.pageData, 'groupId')), 'organizers', (await Promise.all((addItemToList(((getObjectProperty(___arguments.context.pageData, 'admin')).map(item => item['userProfileObjectId'])), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')))).map(async item => {; return ({ 'objectId': item });}))));
    await Backendless.Data.of('Group').addRelation((getObjectProperty(___arguments.context.pageData, 'groupId')), 'members', (await Promise.all((addItemToList(((getObjectProperty(___arguments.context.pageData, 'members')).map(item => item['userProfileObjectId'])), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')))).map(async item => {; return ({ 'objectId': item });}))));
    (function () { window.history.back(); })();
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'visibility'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/3f1ca6cacabbc6ba65f71d21d8092c88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['counterShort'] = (String(___arguments.value.length) + String('/50 symbols'));
  if (___arguments.value.length == 0) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')), 'alert-border');
    ___arguments.context.pageData['activityDescriptionShortAlertText'] = 'Please, describe your group';
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')).slice(-1)[0] == 'alert-border') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')).pop();
      ___arguments.context.pageData['activityDescriptionShortAlertText'] = '';
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-group/components/ababb6766daebdb5b1894c9eecaba311/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.pageData['counterShort'] = '0/50 symbols';
  ___arguments.context.pageData['counter'] = '0/500 symbols';

  },
  /* handler:onMounted */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = '50vh';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('94533b850a9c5007aa3e17b5de920086')));
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/919d55a2a72afa2bb1cb03f880960808/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['activityAlertText'] = '';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')).pop();
  }
  if (___arguments.value.length == 0) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'alert-border');
    ___arguments.context.pageData['activityAlertText'] = 'Enter group name';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async onFocus(___arguments) {
      (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808'))['el'])['maxLength'] = 60;
  if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = '50vh';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/create-group/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'Create activity'

  },  
  /* handler:onTitleAssignment */
  /* handler:onResize */
  onResize(___arguments) {
      if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927')) {
    if (___arguments.screenWidth <= 992) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927'))['buttonLabel'] = 'Upload media';
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927'))['buttonLabel'] = 'Drag and Drop or click to upload';
    }
  }

  },  
  /* handler:onResize */
  /* content */
}))

define('./pages/create-group/components/eb0cea7d2f89ede366b9b8124b0d45b6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-group/components/dba15726d2fb76435cde99bc82444243/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
    var item, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if (!currentUser) {
  } else if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  ___arguments.context.pageData['currentUser'] = currentUser;
  ___arguments.context.pageData['currentUser'] = ((await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(currentUser, 'objectId')),'\''].join(''))).setRelated(['userProfile']).setRelationsDepth(2).setPageSize(1)))[0]);
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == false) {
    ___arguments.context.appData['profileStatus'] = false;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  ___arguments.context.pageData['categoryListTableData'] = (await Backendless.Data.of('Category').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')).includes('.')) {
    ___arguments.context.pageData['userNameMedia'] = ((await asyncListFilter(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')), async (item) => {


     return (item != '.');
    })).join(''));
  } else {
    ___arguments.context.pageData['userNameMedia'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
  }
  ___arguments.context.pageData['members'] = [];
  ___arguments.context.pageData['admin'] = [];

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-group/components/5b71f085d15f357c3db17237257f88b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5b71f085d15f357c3db17237257f88b4')).slice(-1)[0] == 'fa-chevron-left') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')), 'activity-page__create--active');
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')), 'activity-page__create--active');
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')), 'activity-page__create--active');
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('f346419c73ff1eb8a5acad1230938847')), 'activity-page__create--active');
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')), 'activity-page__create--active');
    if (!(___arguments.context.pageData['financialRoleTrue'])) {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a')).pop();
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')).pop();
    }
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a')).pop();
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2894dfb56f3475328becafc550390aa5')).pop();
    ___arguments.context.pageData['stepCount'] = '1/2';
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('761e572bb31e21c623b378f58f7b8ae2')).pop();
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4ca8f14e97a4f468a5ad4c4e99a6ae46')).pop();
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6aa3cd22564163e3c5484769b996f1e1')).pop();
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('d03692cf3f4acb7dfe4e8215d5c8263d')).pop();
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5b71f085d15f357c3db17237257f88b4')).pop();
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5b71f085d15f357c3db17237257f88b4')), 'fa-times');
  } else if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5b71f085d15f357c3db17237257f88b4')).slice(-1)[0] == 'fa-times') {
    ;await ( async function (){ window.history.back(); })();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/426bbf2730836624297d6346508e4a0f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    return (getObjectProperty(___arguments.context.pageData, 'name'));
  }

  return 'Group name'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-group/components/abf6da177e88207f43980703aabc7d29/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'descriptionShort')) {
    return (getObjectProperty(___arguments.context.pageData, 'descriptionShort'));
  }

  return 'Group short description.'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-group/components/cf930c9a35b4b0e3122514e4cc2f4194/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/create-group/components/23bdc643dbd5b1578451528b83788579/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return true;
  } else {
    return false;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-group/components/741f6a07142fb5b99adb9223834cb927/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async onUploadSuccess(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList((getObjectProperty(___arguments.context.pageData, 'media')), (await Promise.all(___arguments.uploadedFiles.map(async item => {; return ({ 'file': item,'isCover': false });}))));
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 4) {
    ___arguments.context.pageData['media'] = ((getObjectProperty(___arguments.context.pageData, 'media')).slice(0, 4));
  }
  ((getObjectProperty(___arguments.context.pageData, 'media'))[0])['isCover'] = true;
  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');
  await (async function(path, mediaList, media2) {
  	async function resizeFiles(files, width, percent) {
  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index]

  	    const fileName = file.name

  	    const content = await readFileAsDataURL(file)

  	    const img = await getNewImage(content)

  	    const elem = document.createElement('canvas')

  	    const widthImage = !width ? img.width : width
  	    const scaleFactor = width && width / img.width
  	    const heightImage = width ? img.height * scaleFactor : img.height

  	    elem.width = widthImage
  	    elem.height = heightImage

  	    const ctx = elem.getContext('2d')

  	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	    const blob = await getCanvasBlob(ctx.canvas, percent)

  	    const newFile = new File([blob], fileName, {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })

  	    files[index] = newFile
  	  }

  	  async function readFileAsDataURL(file) {
  	    const result = await new Promise((resolve) => {
  	      const fileReader = new FileReader()

  	      fileReader.onload = (e) => resolve(e.target.result)

  	      fileReader.readAsDataURL(file)
  	    })

  	    return result;
  	  }

  	  async function getNewImage(content) {
  	    const result = await new Promise((resolve) => {
  	      const img = new Image()

  	      img.src = content

  	      img.onload = () => resolve(img)
  	    })

  	    return result
  	  }

  	  async function getCanvasBlob(canvas, percent) {
  	    const result = await new Promise((resolve) => {
  	      canvas.toBlob((blob) => {
  	        resolve(blob)
  	      }, 'image/jpeg', percent)
  	    })

  	    return result
  	  }

  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.content__upload-button');

  	  dropArea.addEventListener("dragover", (event) => {
  	    event.preventDefault();
  	    dropArea.classList.add('active');
  	  });

  	  dropArea.addEventListener("dragleave", () => {
  	    dropArea.classList.remove('active');
  	  });


  	  function uploadFile(files) {
  	    files.forEach((file) => {
  	      if (file.type.includes('image')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	       .then(function(fileURL) {
  	          let media = {
  	            file: fileURL.fileURL,
  	            isCover: false
  	          }
  	          mediaList.push(media);
  	          mediaList[0].isCover = true;
  	          // media2.push(media);
  	          media2 = mediaList;
  	          //console.log(media2);
  	          //console.log(mediaList);

  	        })
  	       .catch( function( error ) {
  	         console.log(error)
  	        })
  	      }
  	    })

  	    return mediaList;
  	  }

  	  dropArea.addEventListener("drop", (event) => {
  	    event.preventDefault();
  	    let files = event.dataTransfer.files;
  	    resizeFiles([...files], 700, 80);
  	    dropArea.classList.remove('active');
  	  });

  })((['/pictures/groups/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('')), (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')));
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', false);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', false);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', true);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 0) {
    ___arguments.context.pageData['activityImageAlertText'] = '';
  }

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async onDirectoryAssignment(___arguments) {
    var name2, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    name2 = (await asyncListFilter(((getObjectProperty(___arguments.context.pageData, 'name')).split('')), async (item) => {


     return (item != '\'' && item != '.');
    }));
    ___arguments.context.pageData['newName'] = (name2.join(''));
    return (['/pictures/groups/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/',(getObjectProperty(___arguments.context.pageData, 'newName')),'/'].join(''));
  } else {
    return (['/pictures/groups/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join(''));
  }

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([((new Date()).valueOf()),'_',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 4) {
    ___arguments.context.pageData['media'] = ((getObjectProperty(___arguments.context.pageData, 'media')).slice(0, 4));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', false);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', false);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', true);
  }

  return ['content__upload-button activity-page__upload-button']

  },
  /* handler:onClassListAssignment */
  /* handler:onBeforeUpload */
  async onBeforeUpload(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')).includes('.')) {
    ___arguments.context.pageData['userNameMedia'] = ((await asyncListFilter(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')), async (item) => {


     return (item != '.');
    })).join(''));
  } else {
    ___arguments.context.pageData['userNameMedia'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
  }

  return (await (async function(files, width, percent) {
	for (let index = 0; index < files.length; index++) {
	  const file = files[index]

	  const fileName = file.name

	  const content = await readFileAsDataURL(file)

	  const img = await getNewImage(content)

	  const elem = document.createElement('canvas')

	  const widthImage = !width ? img.width : width
	  const scaleFactor = width && width / img.width
	  const heightImage = width ? img.height * scaleFactor : img.height

	  elem.width = widthImage
	  elem.height = heightImage

	  const ctx = elem.getContext('2d')

	  ctx.drawImage(img, 0, 0, widthImage, heightImage)

	  const blob = await getCanvasBlob(ctx.canvas, percent)

	  const newFile = new File([blob], fileName, {
	    type: 'image/jpeg',
	    lastModified: Date.now()
	  })

	  files[index] = newFile
	}

	async function readFileAsDataURL(file) {
	  const result = await new Promise((resolve) => {
	    const fileReader = new FileReader()

	    fileReader.onload = (e) => resolve(e.target.result)

	    fileReader.readAsDataURL(file)
	  })

	  return result
	}

	async function getNewImage(content) {
	  const result = await new Promise((resolve) => {
	    const img = new Image()

	    img.src = content

	    img.onload = () => resolve(img)
	  })

	  return result
	}

	async function getCanvasBlob(canvas, percent) {
	  const result = await new Promise((resolve) => {
	    canvas.toBlob((blob) => {
	      resolve(blob)
	    }, 'image/jpeg', percent)
	  })

	  return result
	}

	return files;
})(___arguments.files, 700, 80))

  },
  /* handler:onBeforeUpload */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 4) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/create-group/components/16072df84cd60c7c36b223120beab8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'media'))) {
    ___arguments.context.pageData['media'] = [];
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'media2'))) {
    ___arguments.context.pageData['media2'] = [];
  }

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var media2, mediaList, path;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  if (getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'login')) {
    path = ['/pictures/activities/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'login')),'/'].join('');
  }
  if (getObjectProperty(___arguments.context.pageData, 'media')) {
    mediaList = (getObjectProperty(___arguments.context.pageData, 'media'));
    media2 = (getObjectProperty(___arguments.context.pageData, 'media2'));
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927'))['buttonLabel'] = 'Upload media';
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927'))['buttonLabel'] = 'Drag and Drop or click to upload';
  }
  await (async function(path, mediaList, media2) {
  	async function resizeFiles(files, width, percent) {
  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index]

  	    const fileName = file.name

  	    const content = await readFileAsDataURL(file)

  	    const img = await getNewImage(content)

  	    const elem = document.createElement('canvas')

  	    const widthImage = !width ? img.width : width
  	    const scaleFactor = width && width / img.width
  	    const heightImage = width ? img.height * scaleFactor : img.height

  	    elem.width = widthImage
  	    elem.height = heightImage

  	    const ctx = elem.getContext('2d')

  	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	    const blob = await getCanvasBlob(ctx.canvas, percent)

  	    const newFile = new File([blob], fileName, {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })

  	    files[index] = newFile
  	  }

  	  async function readFileAsDataURL(file) {
  	    const result = await new Promise((resolve) => {
  	      const fileReader = new FileReader()

  	      fileReader.onload = (e) => resolve(e.target.result)

  	      fileReader.readAsDataURL(file)
  	    })

  	    return result;
  	  }

  	  async function getNewImage(content) {
  	    const result = await new Promise((resolve) => {
  	      const img = new Image()

  	      img.src = content

  	      img.onload = () => resolve(img)
  	    })

  	    return result
  	  }

  	  async function getCanvasBlob(canvas, percent) {
  	    const result = await new Promise((resolve) => {
  	      canvas.toBlob((blob) => {
  	        resolve(blob)
  	      }, 'image/jpeg', percent)
  	    })

  	    return result
  	  }

  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.content__upload-button');

  	  dropArea.addEventListener("dragover", (event) => {
  	    event.preventDefault();
  	    dropArea.classList.add('active');
  	  });

  	  dropArea.addEventListener("dragleave", () => {
  	    dropArea.classList.remove('active');
  	  });


  	  function uploadFile(files) {
  	    files.forEach((file) => {
  	      if (file.type.includes('image')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	       .then(function(fileURL) {
  	          let media = {
  	            file: fileURL.fileURL,
  	            isCover: false
  	          }
  	          mediaList.push(media);
  	          mediaList[0].isCover = true;
  	          media2.push(media);
  	          media2[0].isCover = true;
  	          //console.log(media2);
  	          //console.log(mediaList);

  	        })
  	       .catch( function( error ) {
  	         console.log(error)
  	        })
  	      }
  	    })

  	    return mediaList;
  	  }

  	  dropArea.addEventListener("drop", (event) => {
  	    event.preventDefault();
  	    let files = event.dataTransfer.files;
  	    resizeFiles([...files], 700, 80);
  	    dropArea.classList.remove('active');
  	  });

  })(path, mediaList, media2);
  await (async function() {
  	let input = document.querySelector('.activity-page__upload-field input')
  	input.setAttribute('capture', 'camera')

  })();

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-group/components/3cc9bed4da442af39e98af38a236af17/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'media2'))

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.pageData['check'] = true;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-group/components/91eee0065a64be6576e8fd8397d35029/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      return ['content__media-image', 'activity-page__image']

  },  
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var j, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  var j_list = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('3cc9bed4da442af39e98af38a236af17'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['isCover'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946')['isCover'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'media')) && (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[0]), 'isCover')) != true) {
    ___arguments.context.pageData['media'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'media')), -1, async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/3d7a0b7f949d689404495eea6aad8b5a/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'media')) {
    if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 1 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a'))) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')).slice(-1)[0] != 'activity-page__prewiev-img-big') {
        addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')), 'activity-page__prewiev-img-big');
      }
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')).slice(-1)[0] != 'activity-page__prewiev-wrapper') {
        addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')), 'activity-page__prewiev-wrapper');
      }
      return (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[0]), 'file'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 1 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a'))) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')).slice(-1)[0] == 'activity-page__prewiev-img-big') {
        ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')).pop();
      }
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')).slice(-1)[0] == 'activity-page__prewiev-wrapper') {
        ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')).pop();
      }
      return '/images/prewiev.svg';
    }
  }

  return '/images/prewiev.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 1 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'media')) && (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[0]), 'isCover')) != true) {
      ___arguments.context.pageData['media'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'media')), -1, async (item) => {


       return ((getObjectProperty(item, 'isCover')) == true);
      }));
    }
    return ['activity-page__prewiev-img-big'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 0 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a'))) {
    return [''];
  }

  return ['']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/create-group/components/33e7df29c9acc1c267dd4bdafe9882bf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  ___arguments.context.pageData['media'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'media')), async (item) => {


   return ((getObjectProperty(item, 'file')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file')));
  }));
  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  await (async function(path, mediaList, media2) {
  	async function resizeFiles(files, width, percent) {
  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index]

  	    const fileName = file.name

  	    const content = await readFileAsDataURL(file)

  	    const img = await getNewImage(content)

  	    const elem = document.createElement('canvas')

  	    const widthImage = !width ? img.width : width
  	    const scaleFactor = width && width / img.width
  	    const heightImage = width ? img.height * scaleFactor : img.height

  	    elem.width = widthImage
  	    elem.height = heightImage

  	    const ctx = elem.getContext('2d')

  	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	    const blob = await getCanvasBlob(ctx.canvas, percent)

  	    const newFile = new File([blob], fileName, {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })

  	    files[index] = newFile
  	  }

  	  async function readFileAsDataURL(file) {
  	    const result = await new Promise((resolve) => {
  	      const fileReader = new FileReader()

  	      fileReader.onload = (e) => resolve(e.target.result)

  	      fileReader.readAsDataURL(file)
  	    })

  	    return result;
  	  }

  	  async function getNewImage(content) {
  	    const result = await new Promise((resolve) => {
  	      const img = new Image()

  	      img.src = content

  	      img.onload = () => resolve(img)
  	    })

  	    return result
  	  }

  	  async function getCanvasBlob(canvas, percent) {
  	    const result = await new Promise((resolve) => {
  	      canvas.toBlob((blob) => {
  	        resolve(blob)
  	      }, 'image/jpeg', percent)
  	    })

  	    return result
  	  }

  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.content__upload-button');

  	  dropArea.addEventListener("dragover", (event) => {
  	    event.preventDefault();
  	    dropArea.classList.add('active');
  	  });

  	  dropArea.addEventListener("dragleave", () => {
  	    dropArea.classList.remove('active');
  	  });


  	  function uploadFile(files) {
  	    files.forEach((file) => {
  	      if (file.type.includes('image')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	       .then(function(fileURL) {
  	          let media = {
  	            file: fileURL.fileURL,
  	            isCover: false
  	          }
  	          mediaList.push(media);
  	          mediaList[0].isCover = true;
  	         // media2.push(media);
  	         // media2[0].isCover = true;
  	          media2 = mediaList;
  	          //console.log(media2);
  	          //console.log(mediaList);

  	        })
  	       .catch( function( error ) {
  	         console.log(error)
  	        })
  	      }
  	    })

  	    return mediaList;
  	  }

  	  dropArea.addEventListener("drop", (event) => {
  	    event.preventDefault();
  	    let files = event.dataTransfer.files;
  	    resizeFiles([...files], 700, 80);
  	    dropArea.classList.remove('active');
  	  });

  })((['/pictures/activities/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'login')),'/'].join('')), (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')));
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 0 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a'))) {
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')).slice(-1)[0] == 'activity-page__prewiev-img-big') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')).slice(-1)[0] == 'activity-page__prewiev-wrapper') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')).pop();
    }
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', true);
  }
  await Backendless.Files.remove(encodePath((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/097f14a721d403bb07dec75720da4b86/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.context.pageData['media']) {
    if ((___arguments.context.pageData['media']).length == 2 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('097f14a721d403bb07dec75720da4b86'))) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')).slice(-1)[0] != 'activity-page__prewiev-img-big') {
        addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')), 'activity-page__prewiev-img-big');
      }
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')).slice(-1)[0] != 'activity-page__prewiev-wrapper') {
        addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')), 'activity-page__prewiev-wrapper');
      }
      return (((___arguments.context.pageData['media'])[1])['file']);
    } else if ((___arguments.context.pageData['media']).length > 2 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('097f14a721d403bb07dec75720da4b86'))) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')).slice(-1)[0] != 'activity-page__prewiev-img-small') {
        addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')), 'activity-page__prewiev-img-small');
      }
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')).slice(-1)[0] != 'activity-page__prewiev-wrapper') {
        addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')), 'activity-page__prewiev-wrapper');
      }
      return (((___arguments.context.pageData['media'])[1])['file']);
    } else if ((___arguments.context.pageData['media']).length == 1 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('097f14a721d403bb07dec75720da4b86'))) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')).slice(-1)[0] == 'activity-page__prewiev-img-small') {
        ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')).pop();
      }
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')).slice(-1)[0] == 'activity-page__prewiev-wrapper') {
        ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')).pop();
      }
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', false);
      return '/images/prewiev1.svg';
    }
  }

  return '/images/prewiev1.svg'

  },  
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.pageData['media']).length == 2 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('097f14a721d403bb07dec75720da4b86'))) {
    return ['activity-page__prewiev-img-big'];
  } else if ((___arguments.context.pageData['media']).length > 2 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('097f14a721d403bb07dec75720da4b86'))) {
    return ['activity-page__prewiev-img-small'];
  }

  return ['']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/create-group/components/73691c0d14b72c74621c701beda525ce/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.context.pageData['media']) {
    if ((___arguments.context.pageData['media']).length > 2 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('73691c0d14b72c74621c701beda525ce'))) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('73691c0d14b72c74621c701beda525ce')).slice(-1)[0] != 'activity-page__prewiev-img-small') {
        addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('73691c0d14b72c74621c701beda525ce')), 'activity-page__prewiev-img-small');
      }
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('612d149413a9d0a5d215aea239ffffec')).slice(-1)[0] != 'activity-page__prewiev-wrapper') {
        addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('612d149413a9d0a5d215aea239ffffec')), 'activity-page__prewiev-wrapper');
      }
      return (((___arguments.context.pageData['media'])[2])['file']);
    } else if ((___arguments.context.pageData['media']).length == 2 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('73691c0d14b72c74621c701beda525ce'))) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('73691c0d14b72c74621c701beda525ce')).slice(-1)[0] == 'activity-page__prewiev-img-small') {
        ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('73691c0d14b72c74621c701beda525ce')).pop();
      }
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('612d149413a9d0a5d215aea239ffffec')).slice(-1)[0] == 'activity-page__prewiev-wrapper') {
        ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('612d149413a9d0a5d215aea239ffffec')).pop();
      }
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', false);
      return '/images/prewiev2.svg';
    }
  }

  return '/images/prewiev2.svg'

  },  
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.pageData['media']).length > 2 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('73691c0d14b72c74621c701beda525ce'))) {
    return ['activity-page__prewiev-img-small'];
  } else if ((___arguments.context.pageData['media']).length == 2 && ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('73691c0d14b72c74621c701beda525ce'))) {
    return [''];
  }

  return ['']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/create-group/components/097a232d4e93ae359babf4de13fa5884/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['media']) {
    if ((___arguments.context.pageData['media']).length > 3) {
      ___arguments.context.pageData['photoCount'] = (['+',(___arguments.context.pageData['media']).length - 3,' more'].join(''));
      ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('097a232d4e93ae359babf4de13fa5884'))['width'] = '100%';
      return true;
    } else {
      return false;
    }
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-group/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['© ',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-group/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/3f2f1461d4b8879860f88a47d893f946/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  await (async function(data) {
  	if (data.check) {
  	  const draggables = document.querySelectorAll('.draggable')
  	  const containers = document.querySelectorAll('.container')
  	  draggables.forEach(draggable => {
  	    draggable.addEventListener('dragstart', () => {
  	      draggable.classList.add('dragging')
  	    })

  	    draggable.addEventListener('dragend', () => {
  	      draggable.classList.remove('dragging')
  	      const images = [...document.querySelectorAll('.draggable .content__media-image')]
  	      const list = [...document.querySelectorAll('.draggable')]

  	      const cover = list.filter(item => item.classList.contains("cover"));
  	      try {
  	        let coverImage = cover[0].firstChild.children[3].src
  	        const media = images.map((image, index) => ({ file:image.src, isCover: image.src === coverImage}))
  	        data.media = media
  	        data.media2 = media.sort((a, b) => (a.isCover > b.isCover) ? 1 : -1)
  	      } catch {

  	      }

  	    })

  	    draggable.addEventListener('touchstart', () => {
  	      draggable.classList.add('dragging')
  	    })

  	    draggable.addEventListener('touchend', () => {
  	      draggable.classList.remove('dragging')
  	      const images = [...document.querySelectorAll('.draggable .content__media-image')]

  	      const list = [...document.querySelectorAll('.draggable')]

  	      try {
  	      const cover = list.filter(item => item.classList.contains("cover"));
  	      let coverImage = cover[0].firstChild.children[3].src

  	      const media = images.map((image, index) => ({ file:image.src, isCover: image.src === coverImage }))

  	      data.media = media
  	      data.media2 = media.sort((a, b) => (a.isCover > b.isCover) ? 1 : -1)
  	      } catch {

  	      }


  	    })
  	  })

  	  containers.forEach(container => {
  	    container.addEventListener('dragover', e => {
  	      e.preventDefault()
  	      const afterElement = getDragAfterElement(container, e.clientY)
  	      const draggable = document.querySelector('.dragging')
  	      if (draggable) {
  	        if (afterElement == null) {
  	          container.appendChild(draggable)
  	        } else {
  	          container.insertBefore(draggable, afterElement)
  	        }
  	      }
  	    })

  	    container.addEventListener('touchmove', event => {
  	      event.preventDefault()
  	      const afterElement = getDragAfterElementMobile(container, event.targetTouches[0].clientY)
  	      const draggable = document.querySelector('.dragging')
  	      if (draggable) {
  	        if (afterElement == null) {
  	          container.appendChild(draggable)
  	        } else {
  	          container.insertBefore(draggable, afterElement)
  	        }
  	      }
  	    })
  	  })

  	  function getDragAfterElement(container, y) {
  	    const draggableElements = [...container.querySelectorAll('.draggable:not(.dragging)')]

  	    return draggableElements.reduce((closest, child) => {
  	      const box = child.getBoundingClientRect()
  	      const offset = y - box.top - box.height / 1.25
  	    if (offset < 0 && offset > closest.offset) {
  	        return { offset: offset, element: child }
  	      } else {
  	        return closest
  	      }
  	    }, { offset: Number.NEGATIVE_INFINITY }).element
  	  }
  	}

  	  function getDragAfterElementMobile(container, y) {
  	    const draggableElements = [...container.querySelectorAll('.draggable:not(.dragging)')]

  	    return draggableElements.reduce((closest, child) => {
  	      const box = child.getBoundingClientRect()
  	      const offset = y - box.top - box.height / 1.5
  	    if (offset < 0 && offset > closest.offset) {
  	        return { offset: offset, element: child }
  	      } else {
  	        return closest
  	      }
  	    }, { offset: Number.NEGATIVE_INFINITY }).element
  	  }


  	data.check = false
  })(___arguments.context.pageData);

  },
  /* handler:onMounted */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  console.log('');

  },  
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return true

  },  
  /* handler:onDisplayAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'isCover')) {
    return ['content__media-item', 'activity-page__media-item', 'draggable', 'cover'];
  } else {
    return ['content__media-item', 'activity-page__media-item', 'draggable'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/create-group/components/1bac70e39cddb3b1e7f4a039f32f0449/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    
  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/create-group/components/39b75428660ee33d13e98659711f5964/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 768) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-group/components/94533b850a9c5007aa3e17b5de920086/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-group/components/e783989234853c03d2aaeed14fa50fba/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await new Promise(r => setTimeout(r, 2000 || 0));
  (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808'))['el'])['maxLength'] = 60;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/create-group/components/d79f2bb365d14a49a78c9799b2dffb13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/739f4499265d8a9896ac97b341affe06/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'description')) {
    return (getObjectProperty(___arguments.context.pageData, 'description'));
  }

  return 'Group long description.'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/create-group/components/cfbc6815a7d748879309d3f13276ffdd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['counter'] = (String(___arguments.value.length) + String('/500 symbols'));
  if (___arguments.value.length == 0) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cfbc6815a7d748879309d3f13276ffdd')), 'alert-border');
    ___arguments.context.pageData['activityDescriptionAlertText'] = 'Please, describe your group';
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cfbc6815a7d748879309d3f13276ffdd')).slice(-1)[0] == 'alert-border') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cfbc6815a7d748879309d3f13276ffdd')).pop();
    }
    ___arguments.context.pageData['activityDescriptionAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-group/components/36329874cc0463331368e03857ce6aa3/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'categoryListTableData')) {
    return (await Promise.all((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'name')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['category'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-group/components/a386dd4fbdb9a1c1e4dc4d689ddb94ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var clientAddress, error, getGeoLocation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['errorLocation'] = '';
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9952fd95bbdc862dc06d65f19281c3bf', true);
    getGeoLocation = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
    clientAddress = (getObjectProperty(((await Backendless.Request.get(`${Backendless.appPath}/services/ReverseGeoCodding/getReverceGeoCodding`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'lat': (getObjectProperty(getGeoLocation, 'lat')),'lng': (getObjectProperty(getGeoLocation, 'lng')) }).send())[0]), 'formatted_address'));
    ___arguments.context.pageData['locationPointResult'] = (new Backendless.Data.Point().setX((getObjectProperty(getGeoLocation, 'lng'))).setY((getObjectProperty(getGeoLocation, 'lat'))));
    ___arguments.context.pageData['location'] = clientAddress;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03f7951ecac13398da1074b275894d8'))['value'] = (getObjectProperty(___arguments.context.pageData, 'location'));
    if (getGeoLocation) {
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('1c7d0ab214bd954f5e7cc82e0ce43059', (getObjectProperty(getGeoLocation, 'lng')), (getObjectProperty(getGeoLocation, 'lat')));
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('1c7d0ab214bd954f5e7cc82e0ce43059', [getGeoLocation]);
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('3d1d8fac94bcd3b8cc0b908e6dda3ff1', (getObjectProperty(getGeoLocation, 'lng')), (getObjectProperty(getGeoLocation, 'lat')));
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('3d1d8fac94bcd3b8cc0b908e6dda3ff1', [getGeoLocation]);
      ___arguments.context.pageData['locationPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(getGeoLocation, 'lng'))).setY((getObjectProperty(getGeoLocation, 'lat'))));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9952fd95bbdc862dc06d65f19281c3bf', false);

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9952fd95bbdc862dc06d65f19281c3bf', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    if ((getObjectProperty(error, 'code')) == 1) {
      ___arguments.context.pageData['errorLocation'] = 'Geolocation has been disabled for this website. Please allow this site to use geolocation or enter your address in the input';
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9952fd95bbdc862dc06d65f19281c3bf', false);
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/6fc91486f467d07e84c15a89d1b50314/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'location')) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'location')) {
    ___arguments.context.pageData['location'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03f7951ecac13398da1074b275894d8'))['value'] = '';
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a03f7951ecac13398da1074b275894d8')), 'el'))['value'] = '';
    ___arguments.context.pageData['locationPointResult'] = null;
    ___arguments.context.pageData['locationPoint'] = null;
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('1c7d0ab214bd954f5e7cc82e0ce43059', 0, 0);
    (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('1c7d0ab214bd954f5e7cc82e0ce43059', []);
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('3d1d8fac94bcd3b8cc0b908e6dda3ff1', 0, 0);
    (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('3d1d8fac94bcd3b8cc0b908e6dda3ff1', []);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/a03f7951ecac13398da1074b275894d8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var error, result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9952fd95bbdc862dc06d65f19281c3bf', true);
  await new Promise(r => setTimeout(r, 1000 || 0));
  if (getObjectProperty(___arguments.context.pageData, 'errorLocation')) {
    ___arguments.context.pageData['errorLocation'] = '';
  }
  try {
    result = (getObjectProperty((getObjectProperty(((getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/getGeoCode/inputAddress`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'inputAddress': JSON.stringify((getObjectProperty(___arguments.value, 'description'))) }).send()), 'results'))[0]), 'geometry')), 'location'));
    ___arguments.context.pageData['locationPointResult'] = result;
    ___arguments.context.pageData['location'] = (getObjectProperty(___arguments.value, 'description'));
    if (result) {
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('1c7d0ab214bd954f5e7cc82e0ce43059', (getObjectProperty(result, 'lat')), (getObjectProperty(result, 'lng')));
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('1c7d0ab214bd954f5e7cc82e0ce43059', [result]);
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('3d1d8fac94bcd3b8cc0b908e6dda3ff1', (getObjectProperty(result, 'lat')), (getObjectProperty(result, 'lng')));
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('3d1d8fac94bcd3b8cc0b908e6dda3ff1', [result]);
      ___arguments.context.pageData['locationPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(result, 'lng'))).setY((getObjectProperty(result, 'lat'))));
    }

  } catch (error) {
    console.log(error);

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9952fd95bbdc862dc06d65f19281c3bf', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-group/components/d67df9ec6136a6fcbd7c9a3674ec2be6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  if (___arguments.value) {
    ___arguments.context.pageData['users'] = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId !=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\' and ( ','(login like \'%',___arguments.value,'%\')',' or (name like \'%',___arguments.value,'%\'))'].join(''))).setProperties(['objectId', 'photoThumbnail', 'login', 'userProfile.objectId as userProfileObjectId']).excludeProperties(['email']).setPageSize(100)));
  } else {
    ___arguments.context.pageData['users'] = [];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/create-group/components/0d9e08b5e5995cbb1be443875d1af5ac/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a28498ec005bd80fdaba2bb9455de85a'), 'photoThumbnail')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a28498ec005bd80fdaba2bb9455de85a'), 'photoThumbnail'));
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/create-group/components/a28498ec005bd80fdaba2bb9455de85a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'members')) && (getObjectProperty(___arguments.context.pageData, 'members')).length > 0) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'members')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      ___arguments.context.pageData['members'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'members')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
      }));
      addItemToList((getObjectProperty(___arguments.context.pageData, 'users')), ___arguments.context.dataModel);
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'members')), ___arguments.context.dataModel);
      ___arguments.context.pageData['users'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'users')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
      }));
    }
  } else {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'members')), ___arguments.context.dataModel);
    ___arguments.context.pageData['users'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'users')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/5a4e9a1f49a730fc7c09b54dee5c984a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'members')) && (getObjectProperty(___arguments.context.pageData, 'members')).length > 0 && (getObjectProperty(___arguments.context.pageData, 'users')) && (getObjectProperty(___arguments.context.pageData, 'users')).length > 0) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-group/components/2ffff5a61cf4d7ef3b22fe3289dca673/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'), 'photoThumbnail')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'), 'photoThumbnail'));
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/create-group/components/ebfc7dff8d99d00ac81bd478c4cfddc4/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'users')) {
    return (getObjectProperty(___arguments.context.pageData, 'users'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/create-group/components/020f691b368672651742837ca792c453/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'members')) && (getObjectProperty(___arguments.context.pageData, 'members')).length > 0 ? true : false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/create-group/components/feee829f2e0bd7b9ee62ba64c319bc98/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'members')) && (getObjectProperty(___arguments.context.pageData, 'members')).length > 0) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'members')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'), 'objectId')));
    })).length) {
      ___arguments.context.pageData['members'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'members')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'), 'objectId')));
      }));
      addItemToList((getObjectProperty(___arguments.context.pageData, 'users')), ___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'));
    } else {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'members')), ___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'));
      ___arguments.context.pageData['users'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'users')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'), 'objectId')));
      }));
    }
  } else {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'members')), ___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'));
    ___arguments.context.pageData['users'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'users')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'), 'objectId')));
    }));
  }
  ___arguments.context.pageData['admin'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'admin')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'), 'objectId')));
  }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/create-group/components/d781f00c94498bab4187aaab9d8554b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var item, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'admin')), ___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'));
  } else {
    ___arguments.context.pageData['admin'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'admin')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'), 'objectId')));
    }));
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'admin'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async onCheckedStateAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}



  return ((getObjectProperty(___arguments.context.pageData, 'admin')) && !!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'admin')), async (item) => {


 return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d0ba79459aa31e7f1ee962a548f4e96c'), 'objectId')));
})).length ? true : false)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity/components/919d55a2a72afa2bb1cb03f880960808/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength(___arguments.value) == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', false);
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'el'))['maxLength'] = 60;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a35334d5d128c9bd1d554cdcad43b3ef'))['height'] = '50vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('02fa45cb955cdac4f7ad79283e31349a')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a35334d5d128c9bd1d554cdcad43b3ef'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/edit-activity/components/10476337a1fe6ff828cd2ade6062f95f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['activityTimingAlertText'] = '';
  } else {
    ___arguments.context.pageData['activityTimingAlertText'] = 'Please choose date';
  }

  },
  /* handler:onChange */
  /* handler:onMinDateAssignment */
  ['onMinDateAssignment'](___arguments) {
      return (new Date())

  },
  /* handler:onMinDateAssignment */
  /* content */
}))

define('./pages/edit-activity/components/7eb9af336d564ab949398bda49392324/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (!___arguments.value.trim().length) {
    ___arguments.context.pageData['activityTimingAlertText'] = 'Please, enter timing';
  } else {
    ___arguments.context.pageData['activityTimingAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7eb9af336d564ab949398bda49392324')), 'el'))['maxLength'] = 60;

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    
  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/edit-activity/components/7556db4d9898976a79a4198c85eedd97/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getValueLength(___arguments.value.trim()) == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d2cadcf117eb39a308f75f27f5e52d4', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d2cadcf117eb39a308f75f27f5e52d4', false);
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')), 'el'))['maxLength'] = 60;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a35334d5d128c9bd1d554cdcad43b3ef'))['height'] = '50vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('803e5ecb918452392b42287274a8b9ea')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a35334d5d128c9bd1d554cdcad43b3ef'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financialRole')) != 'passenger' && (getObjectProperty(___arguments.context.pageData, 'financialRole')) != 'driver')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/c84bc82bb6f109fba3db9f11e6e837ff/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['visibility'] = 1;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibility'))

  },
  /* handler:onValueAssignment */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
      return 1

  },
  /* handler:onCheckedValueAssignment */
  /* content */
}))

define('./pages/edit-activity/components/5dbf8d9cc9320811ee851d74bca83589/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['visibility'] = 2;

  },
  /* handler:onChange */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
      return 2

  },
  /* handler:onCheckedValueAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibility'))

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/edit-activity/components/c7bf475e7a59cd8e1fed2b9bd222b185/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['visibility'] = 3;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'visibility'))

  },
  /* handler:onValueAssignment */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
      return 3

  },
  /* handler:onCheckedValueAssignment */
  /* content */
}))

define('./pages/edit-activity/components/916764cf81f7f4dd39add13dbd65fa7a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var heightInch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isHeightBlockActive'] = true;
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 1 || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == '1') {
    heightInch = String('-') + String(___arguments.value);
    ___arguments.context.pageData['heightData'] = (heightInch * 1);
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 2 || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == '2') {
    ___arguments.context.pageData['heightData'] = (___arguments.value * 1);
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var height;


  height = [({ 'value': '122','label': '4′0″ (122 cm)' }), ({ 'value': '124','label': '4′1″ (124 cm)' }), ({ 'value': '127','label': '4′2″ (127 cm)' }), ({ 'value': '130','label': '4′3″ (130 cm)' }), ({ 'value': '132','label': '4′4″ (132 cm)' }), ({ 'value': '135','label': '4′5″ (135 cm)' }), ({ 'value': '137','label': '4′6″ (137 cm)' }), ({ 'value': '140','label': '4′7″ (140 cm)' }), ({ 'value': '142','label': '4′8″ (142 cm)' }), ({ 'value': '145','label': '4′9″ (145 cm)' }), ({ 'value': '152','label': '5′0″ (152 cm)' }), ({ 'value': '155','label': '5′1″ (155 cm)' }), ({ 'value': '157','label': '5′2″ (157 cm)' }), ({ 'value': '160','label': '5′3″ (160 cm)' }), ({ 'value': '163','label': '5′4″ (163 cm)' }), ({ 'value': '165','label': '5′5″ (165 cm)' }), ({ 'value': '168','label': '5′6″ (168 cm)' }), ({ 'value': '170','label': '5′7″ (170 cm)' }), ({ 'value': '173','label': '5′8″ (173 cm)' }), ({ 'value': '176','label': '5′9″ (176 cm)' }), ({ 'value': '178','label': '5′10″ (178 cm)' }), ({ 'value': '180','label': '5′11″ (180 cm)' }), ({ 'value': '183','label': '6′0″ (183 cm)' }), ({ 'value': '185','label': '6′1″ (185 cm)' }), ({ 'value': '188','label': '6′2″ (188 cm)' }), ({ 'value': '191','label': '6′3″ (191 cm)' }), ({ 'value': '193','label': '6′4″ (193 cm)' }), ({ 'value': '195','label': '6′5″ (195 cm)' }), ({ 'value': '198','label': '6′6″ (198 cm)' }), ({ 'value': '201','label': '6′7″ (201 cm)' }), ({ 'value': '203','label': '6′8″ (203 cm)' }), ({ 'value': '206','label': '6′9″ (206 cm)' }), ({ 'value': '208','label': '6′10″ (208 cm)' }), ({ 'value': '211','label': '6′11″ (211 cm)' }), ({ 'value': '213','label': '7′0″ (213 cm)' })];

  return height

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/edit-activity/components/a7993934459154523e34663fcee9224a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ___arguments.context.pageData['age'] = [18, 100];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity/components/2a6cc267ff1834d4e052611c72f1f1d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.pageData['gender'] = [];
  } else {
    ___arguments.context.pageData['gender'] = ['Female', 'Male', 'Non-Binary'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'gender')) || !(getObjectProperty(___arguments.context.pageData, 'gender')).length)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity/components/3555fd47b081b0a63af89443d6e87df1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ___arguments.context.pageData['isHeightBlockActive'] = false;
    ___arguments.context.pageData['heightData'] = null;
    ___arguments.context.pageData['haightPrefixValue'] = 1;
    ___arguments.context.pageData['height'] = '178';
  } else {
    ___arguments.context.pageData['isHeightBlockActive'] = true;
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isHeightBlockActive')))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
      return 'Edit activity'

  },
  /* handler:onTitleAssignment */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927')) {
    if (___arguments.screenWidth <= 992) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927'))['buttonLabel'] = 'Upload media';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927'))['buttonLabel'] = 'Drag and Drop or click to upload';
    }
  }

  },
  /* handler:onResize */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('isInitialActivity')) {
    localStorage.removeItem('isInitialActivity');
    ___arguments.context.pageData['isInitialActivity'] = true;
  }

  },
  /* handler:onEnter */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var activity, lat, lng, loginWithoutDots, item, currentCategory, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function getActivityData() {
  activity = (await Backendless.Request.get(`${Backendless.appPath}/services/getMyActivity/getMyActivityData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'activityId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'activityId'))) }).send());
  ___arguments.context.pageData['isPreloaderVisible'] = false;
  ___arguments.context.pageData['activityData'] = (JSON.parse((JSON.stringify(activity))));
  ___arguments.context.pageData['name'] = (getObjectProperty(activity, 'name'));
  ___arguments.context.pageData['activityTitle'] = (getObjectProperty(activity, 'activityTitle'));
  if (!((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories')) || !((((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories')).map(item => item['name'])).includes('Professional Services'))) {
    ___arguments.context.appData['categoryList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/profilesData/ProfilesData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Category') }).send());
    localStorage.setItem('categories', JSON.stringify((getObjectProperty(___arguments.context.appData, 'categoryList'))));
  } else if (!(getObjectProperty(___arguments.context.appData, 'categoryList'))) {
    ___arguments.context.appData['categoryList'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories'));
  }
  ___arguments.context.pageData['categoryListTableData'] = (getObjectProperty(___arguments.context.appData, 'categoryList'));
  if (!(getObjectProperty(activity, 'categoryId'))) {
    currentCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


     return ((getObjectProperty(item, 'name')) == 'Other');
    }))[0];
  } else {
    currentCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(activity, 'categoryId')));
    }))[0];
  }
  ___arguments.context.pageData['activityCategory'] = (getObjectProperty(currentCategory, 'objectId'));
  ___arguments.context.pageData['category'] = (getObjectProperty(currentCategory, 'name'));
  ___arguments.context.pageData['iconCategory'] = (getObjectProperty(currentCategory, 'icon'));
  if (!(getObjectProperty(currentCategory, 'financialRoleRequired'))) {
    ___arguments.context.pageData['financialRoleRequired'] = false;
  } else {
    ___arguments.context.pageData['financialRoleRequired'] = true;
  }
  if (getObjectProperty(activity, 'description')) {
    ___arguments.context.pageData['description'] = (getObjectProperty(activity, 'description'));
    ___arguments.context.pageData['counter'] = (String(getValueLength((getObjectProperty(___arguments.context.pageData, 'description')))) + String('/500 symbols'));
  }
  if (getObjectProperty(activity, 'media')) {
    ___arguments.context.pageData['media'] = (getObjectProperty(activity, 'media'));
    ___arguments.context.pageData['media2'] = (getObjectProperty(activity, 'media'));
  } else {
    ___arguments.context.pageData['media'] = [];
    ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  }
  if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')).includes('.')) {
    loginWithoutDots = (await asyncListFilter(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')), async (item) => {


     return (item != '.');
    })).join('');
  }
  ___arguments.context.pageData['userNameMedia'] = ((loginWithoutDots ? loginWithoutDots : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))).replace((new RegExp('[^\\w\\s]', 'g')), ''));
  if (getObjectProperty(activity, 'location')) {
    ___arguments.context.pageData['location'] = (getObjectProperty(activity, 'location'));
    ___arguments.context.pageData['locationInputValue'] = (getObjectProperty(activity, 'location'));
  }
  if (getObjectProperty(activity, 'locationPoint')) {
    ___arguments.context.pageData['locationPoint'] = (getObjectProperty(activity, 'locationPoint'));
    lat = (getObjectProperty((getObjectProperty(activity, 'locationPoint')), 'coordinates')).slice(-1)[0];
    lng = (getObjectProperty((getObjectProperty(activity, 'locationPoint')), 'coordinates'))[0];
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', lat, lng);
    (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('4df590d6dc3a54537dcf708f8de2676b', [({ [`lng`]: lng,[`lat`]: lat })]);
  }
  ___arguments.context.pageData['keepLocationPrivate'] = (getObjectProperty(activity, 'keepLocationPrivate'));
  if (getObjectProperty(activity, 'activityDate')) {
    ___arguments.context.pageData['timing'] = 'specific';
    ___arguments.context.pageData['specificInput'] = (getObjectProperty(activity, 'activityDate'));
  } else if (getObjectProperty(activity, 'ongoingTiming')) {
    ___arguments.context.pageData['timing'] = 'ongoing';
    ___arguments.context.pageData['ongoingInput'] = (getObjectProperty(activity, 'ongoingTiming'));
  } else {
    ___arguments.context.pageData['timing'] = 'scheduled';
  }
  if (getObjectProperty(activity, 'financialRole')) {
    ___arguments.context.pageData['financialRole'] = (getObjectProperty(activity, 'financialRole'));
  } else {
    ___arguments.context.pageData['financialRole'] = 'driver';
  }
  if (getObjectProperty(activity, 'visibility')) {
    ___arguments.context.pageData['visibility'] = (getObjectProperty(activity, 'visibility'));
  } else {
    ___arguments.context.pageData['visibility'] = 1;
  }
  if (getObjectProperty(activity, 'preferences')) {
    if ((getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageFrom')) && (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageTo'))) {
      ___arguments.context.pageData['age'] = [(getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageFrom')), (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageTo'))];
      ___arguments.context.pageData['checkboxAgeState'] = ((getObjectProperty(___arguments.context.pageData, 'age'))[0] == 18 && (getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0] == 100 ? true : false);
    } else {
      ___arguments.context.pageData['age'] = [18, 100];
    }
    if ((getObjectProperty((getObjectProperty(activity, 'preferences')), 'gender')) && (getObjectProperty((getObjectProperty(activity, 'preferences')), 'gender')).length > 0) {
      ___arguments.context.pageData['gender'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'gender'));
    } else {
      ___arguments.context.pageData['gender'] = [];
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'height')) {
      ___arguments.context.pageData['heightData'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'height'));
      ___arguments.context.pageData['height'] = (Math.abs(getObjectProperty((getObjectProperty(activity, 'preferences')), 'height')));
      ___arguments.context.pageData['haightPrefixValue'] = ((getObjectProperty((getObjectProperty(activity, 'preferences')), 'height')) < 0 ? 1 : 2);
      ___arguments.context.pageData['isHeightBlockActive'] = true;
    } else {
      ___arguments.context.pageData['isHeightBlockActive'] = false;
      ___arguments.context.pageData['haightPrefixValue'] = 1;
      ___arguments.context.pageData['height'] = '178';
    }
  } else {
    ___arguments.context.pageData['gender'] = [];
    ___arguments.context.pageData['age'] = [18, 100];
    ___arguments.context.pageData['isHeightBlockActive'] = false;
    ___arguments.context.pageData['haightPrefixValue'] = 1;
    ___arguments.context.pageData['height'] = '178';
  }
}


  ___arguments.context.pageData['isPreloaderVisible'] = true;
  if (!(getObjectProperty(___arguments.context.pageData, 'activityId'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
    return ;
  }
  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
  getRTSubscriptions().remove('likes');
  await getActivityData();
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_editActivity_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeEnter */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activityId')) {
    await (async function() {
    	try {
    	  if (swiper) {

    	    if (Array.isArray(swiper)) {
    	      for (const swiperItem of swiper) {
    	        swiperItem.destroy(true, true);
    	      }
    	    } else {
    	      swiper.destroy(true, true);
    	    }
    	  }
    	} catch {}
    })();
  }

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/edit-activity/components/5d34836c20df0ed3e3654affc6b67d38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'showServiceDisabledScreen')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('out-of-service', undefined);
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showServiceDisabledScreen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/594b9e3753547161e26e31b916d68155/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07745225406d90ae80ac1f2748957c7f', false);
  try {
    result = (getObjectProperty((getObjectProperty(((getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/getGeoCode/inputAddress`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'inputAddress': JSON.stringify((getObjectProperty(___arguments.value, 'description'))) }).send()), 'results'))[0]), 'geometry')), 'location'));
    ___arguments.context.pageData['locationPointResult'] = result;
    ___arguments.context.pageData['location'] = (getObjectProperty(___arguments.value, 'description'));
    if (result) {
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', (getObjectProperty(result, 'lat')), (getObjectProperty(result, 'lng')));
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('4df590d6dc3a54537dcf708f8de2676b', [result]);
      ___arguments.context.pageData['locationPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(result, 'lng'))).setY((getObjectProperty(result, 'lat'))));
    }

  } catch (error) {
    await new Promise(r => setTimeout(r, 1000 || 0));

  }

  },
  /* handler:onChange */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var userLocation, lng, lat, error, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activityId')) {
    currentUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
    if (currentUser && (getObjectProperty(currentUser, 'userProfile')) && (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint'))) {
      lng = (getObjectProperty((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')), 'coordinates'))[0];
      lat = (getObjectProperty((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')), 'coordinates')).slice(-1)[0];
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('594b9e3753547161e26e31b916d68155', undefined, undefined, undefined, undefined, undefined, undefined, undefined, ['establishment'], undefined, undefined, ((function (center, radius) { return { type: 'CircleLiteral', value: { center, radius } } })(((function (lat, lng) { return { type: 'LatLngLiteral', value: { lat, lng } } })(lat, lng)), 250000)), undefined);
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', lat, lng);
    } else {
      (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('594b9e3753547161e26e31b916d68155', undefined, undefined, undefined, undefined, undefined, undefined, undefined, ['establishment'], undefined, undefined, undefined, undefined);
    }
  }

  },
  /* handler:onMounted */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a35334d5d128c9bd1d554cdcad43b3ef'))['height'] = '50vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('98bc33836a311ae9faf179c83b8df5c7')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a35334d5d128c9bd1d554cdcad43b3ef'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/edit-activity/components/d4a9c3e2f54970e2ab7669a3d7597dc8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item, categoryListTableData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  if (getObjectProperty(___arguments.context.pageData, 'categoryListTableData')) {
    categoryListTableData = (getObjectProperty(___arguments.context.pageData, 'categoryListTableData'));
    return (await Promise.all(categoryListTableData.map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'name')),'icon': (getObjectProperty(item, 'icon')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var category, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['activityCategory'] = ___arguments.value;
  category = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


   return ((getObjectProperty(___arguments.context.pageData, 'activityCategory')) == (getObjectProperty(item, 'objectId')));
  }))[0];
  ___arguments.context.pageData['category'] = (getObjectProperty(category, 'name'));
  ___arguments.context.pageData['iconCategory'] = (getObjectProperty(category, 'icon'));
  if (!(getObjectProperty(category, 'financialRoleRequired'))) {
    ___arguments.context.pageData['financialRoleRequired'] = false;
  } else {
    ___arguments.context.pageData['financialRoleRequired'] = true;
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'category')) {
    return (getObjectProperty(___arguments.context.pageData, 'category'));
  }

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/edit-activity/components/741f6a07142fb5b99adb9223834cb927/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var item, error, j, deleteFiles, moderateResult;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function dragAndDrop() {
  await (async function(path, mediaList, media2, data) {

  	async function resizeFiles(files, width, percent) {
  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index]

  	    const fileName = file.name

  	    const content = await readFileAsDataURL(file)

  	    const img = await getNewImage(content)

  	    const elem = document.createElement('canvas')

  	    const widthImage = !width ? img.width : width
  	    const scaleFactor = width && width / img.width
  	    const heightImage = width ? img.height * scaleFactor : img.height

  	    elem.width = widthImage
  	    elem.height = heightImage

  	    const ctx = elem.getContext('2d')

  	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	    const blob = await getCanvasBlob(ctx.canvas, percent)

  	    const newFile = new File([blob], fileName, {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })

  	    files[index] = newFile
  	  }

  	  async function readFileAsDataURL(file) {
  	    const result = await new Promise((resolve) => {
  	      const fileReader = new FileReader()

  	      fileReader.onload = (e) => resolve(e.target.result)

  	      fileReader.readAsDataURL(file)
  	    })

  	    return result;
  	  }

  	  async function getNewImage(content) {
  	    const result = await new Promise((resolve) => {
  	      const img = new Image()

  	      img.src = content

  	      img.onload = () => resolve(img)
  	    })

  	    return result
  	  }

  	  async function getCanvasBlob(canvas, percent) {
  	    const result = await new Promise((resolve) => {
  	      canvas.toBlob((blob) => {
  	        resolve(blob)
  	      }, 'image/jpeg', percent)
  	    })

  	    return result
  	  }

  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.upload__btn');

  	  dropArea.addEventListener("dragover", (event) => {
  	    event.preventDefault();
  	    dropArea.classList.add('active');
  	  });

  	  dropArea.addEventListener("dragleave", () => {
  	    dropArea.classList.remove('active');
  	  });


  	  function uploadFile(files) {
  	    files.forEach((file) => {
  	      if (file.type.includes('image')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	       .then(async function(fileURL) {
  	          let media = {
  	            file: fileURL.fileURL,
  	            isCover: false
  	          };
  	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', true);
  	          let moderationResult =  await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileURL.fileURL) }).send();
  	         if (moderationResult == 'OK') {
  	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
  	          data.media.push(media);
  	          data.media[0].isCover = true;
  	          data.media2 = data.media;
  	          data.imageList = data.media;
  	          data.activityImageAlertText = '';
  	         } else {
  	           Backendless.Files.remove(fileURL.fileURL);
  	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
  	          data.showRejectMsg = true;
  	          (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('9bcfbdf2ffd2fff69d7b5f4670f55712', ({ 'showRejectMsg': true }));
  	         }
  	        })
  	       .catch( function( error ) {
  	        console.log(error)
  	        })
  	      }
  	    })

  	    return mediaList;
  	  }

  	  dropArea.addEventListener("drop", (event) => {
  	    event.preventDefault();
  	    let files = event.dataTransfer.files;
  	    resizeFiles([...files], 700, 80);
  	    dropArea.classList.remove('active');
  	  });


  })((['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('')), (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')), ___arguments.context.pageData);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', true);
  try {
    var j_list = ___arguments.uploadedFiles;
    for (var j_index in j_list) {
      j = j_list[j_index];
      moderateResult = (await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(j) }).send());
      if (moderateResult == 'KO') {
        ___arguments.context.pageData['showRejectMsg'] = true;
        (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('9bcfbdf2ffd2fff69d7b5f4670f55712', ({ [`showRejectMsg`]: true }));
        deleteFiles = true;
        break;
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
    if (deleteFiles) {
      ;(async () => {
          var j_list2 = ___arguments.uploadedFiles;
        for (var j_index2 in j_list2) {
          j = j_list2[j_index2];
          await Backendless.Files.remove(encodePath(j));
        }

      })();
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');
      await dragAndDrop();
      return ;
    }

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');
    return ;

  } finally {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c38f74a5d54a3bbcffc2b3d4396e2524', false);

  }
  addItemToList((getObjectProperty(___arguments.context.pageData, 'media')), (await Promise.all(___arguments.uploadedFiles.map(async item => {; return ({ [`file`]: item,[`isCover`]: false });}))));
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 4) {
    ___arguments.context.pageData['media'] = ((getObjectProperty(___arguments.context.pageData, 'media')).slice(0, 4));
  }
  ((getObjectProperty(___arguments.context.pageData, 'media'))[0])['isCover'] = true;
  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  ___arguments.context.pageData['imageList'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c38f74a5d54a3bbcffc2b3d4396e2524', false);
  await dragAndDrop();
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 0) {
    ___arguments.context.pageData['activityImageAlertText'] = '';
  }

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var name2, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    name2 = (await asyncListFilter(((getObjectProperty(___arguments.context.pageData, 'name')).split('')), async (item) => {


     return (item != '\'' && item != '.');
    }));
    ___arguments.context.pageData['newName'] = (name2.join(''));
    return (['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/',(getObjectProperty(___arguments.context.pageData, 'newName')),'/'].join(''));
  } else {
    return (['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join(''));
  }

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([((new Date()).valueOf()),'_',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c38f74a5d54a3bbcffc2b3d4396e2524', true);
  if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')).includes('.')) {
    ___arguments.context.pageData['userNameMedia'] = ((await asyncListFilter(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')), async (item) => {


     return (item != '.');
    })).join(''));
  } else {
    ___arguments.context.pageData['userNameMedia'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
  }

  return (await (async function(files, width, percent) {
	for (let index = 0; index < files.length; index++) {
	  const file = files[index]

	  const fileName = file.name

	  const content = await readFileAsDataURL(file)

	  const img = await getNewImage(content)

	  const elem = document.createElement('canvas')

	  const widthImage = !width ? img.width : width
	  const scaleFactor = width && width / img.width
	  const heightImage = width ? img.height * scaleFactor : img.height

	  elem.width = widthImage
	  elem.height = heightImage

	  const ctx = elem.getContext('2d')

	  ctx.drawImage(img, 0, 0, widthImage, heightImage)

	  const blob = await getCanvasBlob(ctx.canvas, percent)

	  const newFile = new File([blob], fileName, {
	    type: 'image/jpeg',
	    lastModified: Date.now()
	  })

	  files[index] = newFile
	}

	async function readFileAsDataURL(file) {
	  const result = await new Promise((resolve) => {
	    const fileReader = new FileReader()

	    fileReader.onload = (e) => resolve(e.target.result)

	    fileReader.readAsDataURL(file)
	  })

	  return result
	}

	async function getNewImage(content) {
	  const result = await new Promise((resolve) => {
	    const img = new Image()

	    img.src = content

	    img.onload = () => resolve(img)
	  })

	  return result
	}

	async function getCanvasBlob(canvas, percent) {
	  const result = await new Promise((resolve) => {
	    canvas.toBlob((blob) => {
	      resolve(blob)
	    }, 'image/jpeg', percent)
	  })

	  return result
	}

	return files;
})(___arguments.files, 700, 80))

  },
  /* handler:onBeforeUpload */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 4) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onButtonLabelAssignment */
  ['onButtonLabelAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992) {
    return 'Upload media';
  } else {
    return 'Drag and drop or click to upload';
  }

  },
  /* handler:onButtonLabelAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/edit-activity/components/16072df84cd60c7c36b223120beab8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'media'))) {
    ___arguments.context.pageData['media'] = [];
    ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  }

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var path;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'isDrag')) {
    path = ['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('');
    await (async function(path, mediaList, media2, data) {
    	async function resizeFiles(files, width, percent) {
    	  for (let index = 0; index < files.length; index++) {
    	    const file = files[index]

    	    const fileName = file.name

    	    const content = await readFileAsDataURL(file)

    	    const img = await getNewImage(content)

    	    const elem = document.createElement('canvas')

    	    const widthImage = !width ? img.width : width
    	    const scaleFactor = width && width / img.width
    	    const heightImage = width ? img.height * scaleFactor : img.height

    	    elem.width = widthImage
    	    elem.height = heightImage

    	    const ctx = elem.getContext('2d')

    	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

    	    const blob = await getCanvasBlob(ctx.canvas, percent)

    	    const newFile = new File([blob], fileName, {
    	      type: 'image/jpeg',
    	      lastModified: Date.now()
    	    })

    	    files[index] = newFile
    	  }

    	  async function readFileAsDataURL(file) {
    	    const result = await new Promise((resolve) => {
    	      const fileReader = new FileReader()

    	      fileReader.onload = (e) => resolve(e.target.result)

    	      fileReader.readAsDataURL(file)
    	    })

    	    return result;
    	  }

    	  async function getNewImage(content) {
    	    const result = await new Promise((resolve) => {
    	      const img = new Image()

    	      img.src = content

    	      img.onload = () => resolve(img)
    	    })

    	    return result
    	  }

    	  async function getCanvasBlob(canvas, percent) {
    	    const result = await new Promise((resolve) => {
    	      canvas.toBlob((blob) => {
    	        resolve(blob)
    	      }, 'image/jpeg', percent)
    	    })

    	    return result
    	  }

    	  uploadFile(files);
    	}

    	const dropArea = document.querySelector('.upload__btn');

    	  dropArea.addEventListener("dragover", (event) => {
    	    event.preventDefault();
    	    dropArea.classList.add('active');
    	  });

    	  dropArea.addEventListener("dragleave", () => {
    	    dropArea.classList.remove('active');
    	  });


    	  function uploadFile(files) {
    	    files.forEach((file) => {
    	      if (file.type.includes('image')) {
    	        Backendless.Files.upload(file, path, overwrite = true)
    	      .then(function(fileURL) {
    	          let media = {
    	            file: fileURL.fileURL,
    	            isCover: false
    	          }

    	          data.media.push(media);
    	          data.media[0].isCover = true;
    	          data.media2 = data.media;
    	          data.imageList = data.media;
    	          data.activityImageAlertText = '';
    	          data.isDrag = true;

    	        })
    	      .catch( function( error ) {
    	        console.log(error)
    	        })
    	      }
    	    })

    	    return data.media;
    	  }

    	  dropArea.addEventListener("drop", (event) => {
    	    event.preventDefault();
    	    let files = event.dataTransfer.files;
    	    resizeFiles([...files], 700, 80);
    	    dropArea.classList.remove('active');
    	  });







    })(path, (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')), ___arguments.context.pageData);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity/components/3cc9bed4da442af39e98af38a236af17/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'media2'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/edit-activity/components/91eee0065a64be6576e8fd8397d35029/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('3cc9bed4da442af39e98af38a236af17'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['isCover'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946')['isCover'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'media')) && (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[0]), 'isCover')) != true) {
    ___arguments.context.pageData['media'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'media')), -1, async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/099f6d62c7fa590a6c84794cfedbedee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var inch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isHeightBlockActive'] = true;
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 1) {
    inch = String('-') + String(getObjectProperty(___arguments.context.pageData, 'height'));
    ___arguments.context.pageData['heightData'] = (inch * 1);
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 2) {
    ___arguments.context.pageData['heightData'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity/components/3f2f1461d4b8879860f88a47d893f946/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));

  },
  /* handler:onMounted */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  console.log('');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/5687f9da010bc23ce0c9884db1c61259/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, getGeoLocation, clientAddress, geoInfo, types, mappingCategory, item, categoryName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getCategyFromGoogleTupe() {
  if (!(getObjectProperty(___arguments.context.pageData, 'isManualEdit'))) {
    if (types && !!types.length) {
      try {
        categoryName = (await Backendless.Request.get(`${Backendless.appPath}/services/categories/getCategoryFromType`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'type': JSON.stringify((types[0])) }).send());
        mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


         return ((getObjectProperty(item, 'name')) == categoryName);
        }))[0];
        if (!mappingCategory) {
          mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


           return ((getObjectProperty(item, 'name')) == 'Other');
          }))[0];
        }

      } catch (error) {
        console.log(error);
        mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


         return ((getObjectProperty(item, 'name')) == 'Other');
        }))[0];

      }
    } else {
      mappingCategory = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


       return ((getObjectProperty(item, 'name')) == 'Other');
      }))[0];
    }
    ___arguments.context.pageData['categorySelectValue'] = (getObjectProperty(mappingCategory, 'objectId'));
    ___arguments.context.pageData['category'] = (getObjectProperty(mappingCategory, 'name'));
    ___arguments.context.pageData['activityCategory'] = mappingCategory;
    ___arguments.context.pageData['iconCategory'] = (getObjectProperty(mappingCategory, 'icon'));
    if (!(getObjectProperty(mappingCategory, 'financialRoleRequired'))) {
      ___arguments.context.pageData['financialRoleRequired'] = false;
    } else {
      ___arguments.context.pageData['financialRoleRequired'] = true;
    }
  }
}


  ___arguments.context.pageData['errorLocation'] = '';
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a0f22ef2bcf47a388e9f473555a6754', true);
    getGeoLocation = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
    geoInfo = (getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/ReverseGeoCodding/getReverceGeoCodding`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'lat': (getObjectProperty(getGeoLocation, 'lat')),'lng': (getObjectProperty(getGeoLocation, 'lng')) }).send()), 'results'))[0];
    clientAddress = (getObjectProperty(geoInfo, 'formatted_address'));
    types = (getObjectProperty(geoInfo, 'types'));
    ;(async () => {
        await getCategyFromGoogleTupe();

    })();
    ___arguments.context.pageData['locationGeoPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(getGeoLocation, 'lat'))).setY((getObjectProperty(getGeoLocation, 'lng'))));
    ___arguments.context.pageData['locationPointResult'] = getGeoLocation;
    ___arguments.context.pageData['location'] = clientAddress;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('594b9e3753547161e26e31b916d68155'))['value'] = (getObjectProperty(___arguments.context.pageData, 'location'));
    if (getGeoLocation) {
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', (getObjectProperty(getGeoLocation, 'lat')), (getObjectProperty(getGeoLocation, 'lng')));
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('4df590d6dc3a54537dcf708f8de2676b', [getGeoLocation]);
      ___arguments.context.pageData['locationPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(getGeoLocation, 'lng'))).setY((getObjectProperty(getGeoLocation, 'lat'))));
    }
    ___arguments.context.pageData['isLocationSelected'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a0f22ef2bcf47a388e9f473555a6754', false);

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a0f22ef2bcf47a388e9f473555a6754', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('594b9e3753547161e26e31b916d68155'))['value'] = '';
    ___arguments.context.pageData['isLocationSelected'] = false;
    if ((getObjectProperty(error, 'code')) == 1) {
      ___arguments.context.pageData['errorLocation'] = 'Geolocation has been disabled for this website. Please allow this site to use geolocation or enter your address in the input';
    } else {
      ___arguments.context.pageData['errorLocation'] = 'Something went wrong. Please try again.';
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2a0f22ef2bcf47a388e9f473555a6754', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/8b63ad7f65f16f827c5d2f5a810bab67/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['checkboxAgeState'] = ((getObjectProperty(___arguments.context.pageData, 'age'))[0] == 18 && (getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0] == 100 ? true : false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity/components/e783989234853c03d2aaeed14fa50fba/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activityId')) {
    await new Promise(r => setTimeout(r, 2000 || 0));
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'el'))['maxLength'] = 60;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity/components/d79f2bb365d14a49a78c9799b2dffb13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/c55e74920b7e1da8f6f433b99a8c1c48/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Male');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Male', '');
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gender')) && ((getObjectProperty(___arguments.context.pageData, 'gender')).includes('Male')))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity/components/5c62850a112889b1ba7df2b6fb5f2a6e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('BROWSER')) && (getObjectProperty(___arguments.context.pageData, 'visibility'))) {
    return ((getObjectProperty(___arguments.context.pageData, 'visibility')) == 1);
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/b362d72b9d23f7d320d987192264ef93/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58aa413781c5240ae5f369a710acdc0a', true);
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('BROWSER')) {
    await (async function(url) {
    	navigator.clipboard.writeText(url)
    })((['https://app.findmyplus.one/?page=activity&data=%7B%22activityId%22%3A%22',(getObjectProperty(___arguments.context.pageData, 'activityId')),'%22%7D'].join('')));
  } else {
    await (async function(url) {
    	const copyTextarea = document.createElement("textarea");
    	      copyTextarea.style.position = "fixed";
    	      copyTextarea.style.opacity = "0";
    	      copyTextarea.textContent = url;
    	      document.body.appendChild(copyTextarea);
    	      copyTextarea.select();
    	      document.execCommand("copy");
    	      document.body.removeChild(copyTextarea);
    })((['https://app.findmyplus.one/?page=activity&data=%7B%22activityId%22%3A%22',(getObjectProperty(___arguments.context.pageData, 'activityId')),'%22%7D'].join('')));
  }
  await new Promise(r => setTimeout(r, 1500 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('58aa413781c5240ae5f369a710acdc0a', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/5c9337910a8d88ed58e6a0dba8587bdc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://facebook.com/sharer/sharer.php', true, ({ [`s`]: 100,[`p[title]`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name')),[`p[url]`]: ((function () { return window.location.href })()),[`p[summary]`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'description')),[`p[images][0]`]: (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media'))[0]), 'file')) }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/b33ddc53c6e3ba7476aaf91a0f49e831/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://twitter.com/intent/tweet', true, ({ 'text': String('https://app.findmyplus.one/index.html?page=activity&activityId=') + String(getObjectProperty(___arguments.context.pageData, 'activityId')) }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/0b4646cff515270952a8c8d5e8744a14/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.linkedin.com/shareArticle', true, ({ [`url`]: ['https://app.findmyplus.one/index.html?page=activity&data=%7B%22activityId"%3A"',(getObjectProperty(___arguments.context.pageData, 'activityId')),'"%7D'].join(''),[`title`]: 'findmyplusone' }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/09154419473a835108f2c13cb295ae13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    try {
      await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('REQUEST_CAMERA_PERMISSIONS', undefined);
      await (async function() {
      	const btn = document.querySelector('.upload__btn')

      	btn.click()
      })();
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09154419473a835108f2c13cb295ae13')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('09154419473a835108f2c13cb295ae13')), 'hidden');
      }

    } catch (error) {
      console.log(error);
      await (async function() {
      	const btn = document.querySelector('.upload__btn')

      	btn.click()
      })();
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('09154419473a835108f2c13cb295ae13')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('09154419473a835108f2c13cb295ae13')), 'hidden');
      }

    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992 && (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(path, mediaList, media2, data) {
  	async function resizeFiles(files, width, percent) {
  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index]

  	    const fileName = file.name

  	    const content = await readFileAsDataURL(file)

  	    const img = await getNewImage(content)

  	    const elem = document.createElement('canvas')

  	    const widthImage = !width ? img.width : width
  	    const scaleFactor = width && width / img.width
  	    const heightImage = width ? img.height * scaleFactor : img.height

  	    elem.width = widthImage
  	    elem.height = heightImage

  	    const ctx = elem.getContext('2d')

  	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	    const blob = await getCanvasBlob(ctx.canvas, percent)

  	    const newFile = new File([blob], fileName, {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })

  	    files[index] = newFile
  	  }

  	  async function readFileAsDataURL(file) {
  	    const result = await new Promise((resolve) => {
  	      const fileReader = new FileReader()

  	      fileReader.onload = (e) => resolve(e.target.result)

  	      fileReader.readAsDataURL(file)
  	    })

  	    return result;
  	  }

  	  async function getNewImage(content) {
  	    const result = await new Promise((resolve) => {
  	      const img = new Image()

  	      img.src = content

  	      img.onload = () => resolve(img)
  	    })

  	    return result
  	  }

  	  async function getCanvasBlob(canvas, percent) {
  	    const result = await new Promise((resolve) => {
  	      canvas.toBlob((blob) => {
  	        resolve(blob)
  	      }, 'image/jpeg', percent)
  	    })

  	    return result
  	  }

  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.upload__btn');

  	  dropArea.addEventListener("dragover", (event) => {
  	    event.preventDefault();
  	    dropArea.classList.add('active');
  	  });

  	  dropArea.addEventListener("dragleave", () => {
  	    dropArea.classList.remove('active');
  	  });


  	  function uploadFile(files) {
  	    files.forEach((file) => {
  	      if (file.type.includes('image')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	      .then(async function(fileURL) {
  	          let media = {
  	            file: fileURL.fileURL,
  	            isCover: false
  	          };
  	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', true);
  	          let moderationResult =  await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileURL.fileURL) }).send();
  	         if (moderationResult == 'OK') {
  	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
  	          data.media.push(media);
  	          data.media[0].isCover = true;
  	          data.media2 = data.media;
  	          data.imageList = data.media;
  	          data.activityImageAlertText = '';
  	          data.isDrag = true;
  	         } else {
  	           Backendless.Files.remove(fileURL.fileURL);
  	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c35bc5e501edc94c8a23365fd9c69463', false);
  	          data.showRejectMsg = true;
  	          (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('9bcfbdf2ffd2fff69d7b5f4670f55712', ({ 'showRejectMsg': true }));
  	         }
  	        })
  	      .catch( function( error ) {
  	        console.log(error)
  	        })
  	      }
  	    })

  	    return data.media;
  	  }

  	  dropArea.addEventListener("drop", (event) => {
  	    event.preventDefault();
  	    let files = event.dataTransfer.files;
  	    resizeFiles([...files], 700, 80);
  	    dropArea.classList.remove('active');
  	  });


  })((['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('')), (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')), ___arguments.context.pageData);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/38ad17735a64da8b29854fffcc74146e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showServiceDisabledScreen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/e6d492f35c06dfc7926dd46b703497fe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'showServiceDisabledScreen')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/da0f9556baabb8c15d0d9f7be4c4deb9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768 ? String('<p data-display="">You are currently outside an active service area. Please share your activity by clicking the icons above.</p> ') + String('<p data-display="">As soon as we have enough members in your area, we will notify you so you can fully enjoy FindMy+1&nbsp;</p>') : String('<p data-display="">You are currently outside an active service area. Please share your activity by clicking the icons below.</p> ') + String('<p data-display="">As soon as we have enough members in your area, we will notify you so you can fully enjoy FindMy+1&nbsp;</p>'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity/components/041e25dc93e93f8d50a855dba48d00aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var nameStatus, regExp, inputName, validateList, imageStatus, descriptionStatus, titleStatus, locationStatus, financialStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function validateActivityName() {
  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    inputName = (getObjectProperty(___arguments.context.pageData, 'name')).trim();
    regExp = ((new RegExp('\\.{4,}', 'g')).test(inputName));
    if (regExp == true) {
      ___arguments.context.pageData['activityAlertText'] = 'Enter activity name';
      nameStatus = false;
      if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')).includes('alert-border'))) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'alert-border');
      }
      await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')));
    } else {
      ___arguments.context.pageData['activityAlertText'] = '';
      nameStatus = true;
    }
  } else {
    ___arguments.context.pageData['activityAlertText'] = 'Enter activity name';
    nameStatus = false;
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'alert-border');
    }
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')));
  }
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function validatePaying() {
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')), 'display'))) {
    financialStatus = true;
    return ;
  }
  if (getObjectProperty(___arguments.context.pageData, 'paySelectValue')) {
    if ((getObjectProperty(___arguments.context.pageData, 'paySelectValue')) != 'payYourOwnWay') {
      ___arguments.context.pageData['finansialRoles'] = (getObjectProperty(___arguments.context.pageData, 'paySelectValue'));
      financialStatus = true;
    } else {
      if ((getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) && !(getValueLength((getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')).trim()) == 0)) {
        ___arguments.context.pageData['finansialRoles'] = (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput'));
        financialStatus = true;
      } else {
        ___arguments.context.pageData['activityRolesAlertText'] = 'Please select a Financial Role for your activity';
        financialStatus = false;
        await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')));
        if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')).slice(-1)[0] != 'alert-border') {
          addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')), 'alert-border');
        }
      }
    }
  } else {
    ___arguments.context.pageData['activityRolesAlertText'] = 'Please select a Financial Role for your activity';
    financialStatus = false;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6f9fde3dea4c108932acec8953e6316a')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6f9fde3dea4c108932acec8953e6316a')), 'alert-border');
    }
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')));
  }
}

/**
 * Describe this function...
 */
async function validateLocation() {
  if (!(getObjectProperty(___arguments.context.pageData, 'location'))) {
    ___arguments.context.pageData['errorLocation'] = 'Please, enter your location';
    locationStatus = false;
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('594b9e3753547161e26e31b916d68155')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('594b9e3753547161e26e31b916d68155')), 'alert-border');
    }
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')));
  } else {
    ___arguments.context.pageData['errorLocation'] = '';
    locationStatus = true;
  }
}

/**
 * Describe this function...
 */
async function validateActivityTitle() {
  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'activityTitle')).trim()) == 0) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7a1184326c08f3d325fdeb6446548fe4')));
    titleStatus = false;
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f346419c73ff1eb8a5acad1230938847')));
  } else {
    titleStatus = true;
    ___arguments.context.pageData['needManualTitle'] = false;
  }
}

/**
 * Describe this function...
 */
async function validateActivityDescription() {
  if (getValueLength((getObjectProperty(___arguments.context.pageData, 'description')).trim()) == 0) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e844c167d5aed83169b3a90317481348')));
    descriptionStatus = false;
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('da3d01ca26dd308f91ef0fdaaed903a6')));
  } else {
    descriptionStatus = true;
    ___arguments.context.pageData['needManualDescription'] = false;
  }
}

/**
 * Describe this function...
 */
async function validateActivityImage() {
  if (!(getObjectProperty(___arguments.context.pageData, 'media')) || !(getObjectProperty(___arguments.context.pageData, 'media')).length) {
    imageStatus = false;
    ___arguments.context.pageData['activityImageAlertText'] = 'Please add an image';
    await BackendlessUI.Functions.Custom['fn_c335db4194025bb2dd974bfd09c53ebb'](((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13')));
  } else {
    imageStatus = true;
  }
}


  await validateActivityName();
  await validatePaying();
  await validateLocation();
  await validateActivityDescription();
  await validateActivityTitle();
  await validateActivityImage();
  validateList = [nameStatus, financialStatus, locationStatus, titleStatus, descriptionStatus, imageStatus];
  if (!(validateList.includes(false))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd455704370e2363b70b946c6f7fbb64', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/2102213f837a2aa84e15511b0c2eab01/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return (await (async function(dob) {
    	let now = new Date(); 
    	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); 
    	
    	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate()); 
    	
    	let age; 
    	
    	age = today.getFullYear() - dob.getFullYear();
    	
    	if (today < dobnow) {
    	  age = age-1;
    	} else {
    	  age = age
    	}
    	
    	return age + ' Years Old'
    })((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'birthDate'))))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity/components/26d946f52005c6b7e3a179876dff2957/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var height, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
    height = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'heightList')), async (item) => {


     return ((getObjectProperty(item, 'value')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'height')));
    }))[0];
    if (height) {
      return ((getObjectProperty(height, 'label')).slice(0, (getObjectProperty(height, 'label')).indexOf(' ') + 1));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity/components/5cce0902bebfecb47041cc65fadf7182/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'height')) {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/0f0d6be10c6faa756752692880429644/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″ (122 cm)' }), ({ [`value`]: '124',[`label`]: '4′1″ (124 cm)' }), ({ [`value`]: '127',[`label`]: '4′2″ (127 cm)' }), ({ [`value`]: '130',[`label`]: '4′3″ (130 cm)' }), ({ [`value`]: '132',[`label`]: '4′4″ (132 cm)' }), ({ [`value`]: '135',[`label`]: '4′5″ (135 cm)' }), ({ [`value`]: '137',[`label`]: '4′6″ (137 cm)' }), ({ [`value`]: '140',[`label`]: '4′7″ (140 cm)' }), ({ [`value`]: '142',[`label`]: '4′8″ (142 cm)' }), ({ [`value`]: '145',[`label`]: '4′9″ (145 cm)' }), ({ [`value`]: '152',[`label`]: '5′0″ (152 cm)' }), ({ [`value`]: '155',[`label`]: '5′1″ (155 cm)' }), ({ [`value`]: '157',[`label`]: '5′2″ (157 cm)' }), ({ [`value`]: '160',[`label`]: '5′3″ (160 cm)' }), ({ [`value`]: '163',[`label`]: '5′4″ (163 cm)' }), ({ [`value`]: '165',[`label`]: '5′5″ (165 cm)' }), ({ [`value`]: '168',[`label`]: '5′6″ (168 cm)' }), ({ [`value`]: '170',[`label`]: '5′7″ (170 cm)' }), ({ [`value`]: '173',[`label`]: '5′8″ (173 cm)' }), ({ [`value`]: '176',[`label`]: '5′9″ (176 cm)' }), ({ [`value`]: '178',[`label`]: '5′10″ (178 cm)' }), ({ [`value`]: '180',[`label`]: '5′11″ (180 cm)' }), ({ [`value`]: '183',[`label`]: '6′0″ (183 cm)' }), ({ [`value`]: '185',[`label`]: '6′1″ (185 cm)' }), ({ [`value`]: '188',[`label`]: '6′2″ (188 cm)' }), ({ [`value`]: '191',[`label`]: '6′3″ (191 cm)' }), ({ [`value`]: '193',[`label`]: '6′4″ (193 cm)' }), ({ [`value`]: '195',[`label`]: '6′5″ (195 cm)' }), ({ [`value`]: '198',[`label`]: '6′6″ (198 cm)' }), ({ [`value`]: '201',[`label`]: '6′7″ (201 cm)' }), ({ [`value`]: '203',[`label`]: '6′8″ (203 cm)' }), ({ [`value`]: '206',[`label`]: '6′9″ (206 cm)' }), ({ [`value`]: '208',[`label`]: '6′10″ (208 cm)' }), ({ [`value`]: '211',[`label`]: '6′11″ (211 cm)' }), ({ [`value`]: '213',[`label`]: '7′0″ (213 cm)' })];

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity/components/d10d309232938bd1f2b99988d16b86f3/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'zodiac'))) {
    return (['styles/img/zodiac/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'zodiac')).toLowerCase(),'.svg'].join(''));
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/edit-activity/components/501d39850841c5fa976bada75d11c3f3/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var photoObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
    photoObj = (await asyncListFind((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


     return (getObjectProperty(item, 'isCover'));
    }));
    if (photoObj) {
      return (getObjectProperty(photoObj, 'file'));
    }
  }

  return ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) : null)

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/edit-activity/components/252c1244020f9e1ece04b8ccda3505ab/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'driver' || (getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'passenger') {
    if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
      if ((getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'driver') {
        return (String('Covers Expense ') + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))));
      } else {
        return 'Covers Expens your +1';
      }
    }
  } else {
    return (String('Share Expense ') + String(getObjectProperty(___arguments.context.pageData, 'financialRole')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity/components/47585314fbcfd74eab9902afb41b297c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d3b889cba0198234c0c23a7108f9e396', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/e495af5c39698f0c29e4cb16cd5d8368/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var currentItem, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  currentItem = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'imageList')), async (item) => {


   return ((getObjectProperty(item, 'current')) == true);
  }))[0];

  return ([(getObjectProperty(___arguments.context.pageData, 'imageList')).indexOf(currentItem) + 1,'/',(getObjectProperty(___arguments.context.pageData, 'imageList')).length].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity/components/c3f45837b46af12caf1ff73187ff169e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var itemsList, previousItem, currentItemIndex, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  itemsList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('efca64e7671330a55dbf7463e514ead9'));
  currentItemIndex = 0;
  for (var j_index in itemsList) {
    j = itemsList[j_index];
    if (getObjectProperty(j, 'current')) {
      currentItemIndex = itemsList.indexOf(j) + 1;
      j['current'] = false;
    }
  }
  previousItem = itemsList[((currentItemIndex - 1) - 1)];
  if (previousItem) {
    previousItem['current'] = true;
  } else {
    (itemsList.slice(-1)[0])['current'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/5a11b4e88b93b76b4415c6b55456794c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var itemsList, nextItem, currentItemsIndex, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  itemsList = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('efca64e7671330a55dbf7463e514ead9'));
  currentItemsIndex = 0;
  for (var j_index in itemsList) {
    j = itemsList[j_index];
    if (getObjectProperty(j, 'current')) {
      currentItemsIndex = itemsList.indexOf(j) + 1;
      j['current'] = false;
    }
  }
  nextItem = itemsList[((currentItemsIndex + 1) - 1)];
  if (nextItem) {
    nextItem['current'] = true;
  } else {
    (itemsList[0])['current'] = true;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/5078408ab2d5ee3197f9765c4ff5d5a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'current')) {
    return ['gallery__slider-image', 'image', 'visible'];
  }

  return ['gallery__slider-image', 'image']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity/components/e844c167d5aed83169b3a90317481348/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.pageData['descriptionCounter'] = (String(getValueLength(___arguments.value)) + String('/500 symbols'));
  if (getValueLength(___arguments.value) == 0) {
    ___arguments.context.pageData['activityDescriptionAlertText'] = 'Please, describe your activity';
  } else {
    ___arguments.context.pageData['activityDescriptionAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a35334d5d128c9bd1d554cdcad43b3ef'))['height'] = '75vh';
    await new Promise(r => setTimeout(r, 300 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('655a686c7c4e565176fdf37d1048d1a9')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a35334d5d128c9bd1d554cdcad43b3ef'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/edit-activity/components/28210676aee14d32616ba0e9d10bf724/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'needManualTitle')) {
    ___arguments.context.pageData['activityTitleAlertText'] = 'Please, describe your activity';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity/components/7908532832056d930fec97b4e823a397/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'needManualDescription')) {
    ___arguments.context.pageData['activityDescriptionAlertText'] = 'Please, describe your activity';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity/components/1d72ecdcaad6d368c5edb028ff5ec054/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.pageData['descriptionTitleCounter'] = (String(getValueLength(___arguments.value)) + String('/100 symbols'));
  if (getValueLength(___arguments.value) == 0) {
    ___arguments.context.pageData['activityTitleAlertText'] = 'Please, describe your activity';
  } else {
    ___arguments.context.pageData['activityTitleAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a35334d5d128c9bd1d554cdcad43b3ef'))['height'] = '75vh';
    await new Promise(r => setTimeout(r, 300 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7a1184326c08f3d325fdeb6446548fe4')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a35334d5d128c9bd1d554cdcad43b3ef'))['height'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/edit-activity/components/5e6f2d5c13ac8168aab61c32bd4de448/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var link;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  link = String('https://app.findmyplus.one/index.html?page=activity&activityId=') + String(getObjectProperty(___arguments.context.pageData, 'activityId'));
  await ( async function (link, message, resourceName) { return BackendlessUI.DeviceAPI.shareSheetRequest({ link, message, resourceName }) })(link, 'Check out my new activity on the FindMyPlusOne app.', (getObjectProperty(___arguments.context.pageData, 'name')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) && (getObjectProperty(___arguments.context.pageData, 'visibility'))) {
    return ((getObjectProperty(___arguments.context.pageData, 'visibility')) == 1);
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/9e0a190957ba3c15ae97995ed5087ad7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/3f56ef0d5407dda61a92369cbf87cc5c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'previousPage')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'previousPage')), undefined);
  } else {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/7a4f484cb503d2954858f3d5146539ff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'previousPage')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'previousPage')), undefined);
  } else {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/e84a48bb2617c8eac39dab62a0182765/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'previousPage')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.pageData, 'previousPage')), undefined);
  } else {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/3a6e5b5a79428bfc2dd9f41de219b392/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')), 'currentStepPreview', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')).push('currentStepDescription');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4bb2456d78bcd6adfdad642bd569fe4b')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c4bda5b072b41136df47dded8b2cb79')).push('open');
  await (async function() {
  	if (swiper) {

  	  if (Array.isArray(swiper)) {
  	    for (const swiperItem of swiper) {
  	      swiperItem.destroy(true, true);
  	    }
  	  } else {
  	    swiper.destroy(true, true)
  	  }

  	}
  })();
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd8ea1bbcc54f0af968ecd067e0a4656')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/f6eb99d5727be25db65534f56aa113ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')), 'currentStepPreview', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')).push('currentStepSettings');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4bb2456d78bcd6adfdad642bd569fe4b')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8ec143146a6b86e602ddff4cc2f38801')).push('open');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd8ea1bbcc54f0af968ecd067e0a4656')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/42458567a8d8a8133456222fb253c557/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')), 'currentStepSettings', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')).push('currentStepPreview');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8ec143146a6b86e602ddff4cc2f38801')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4bb2456d78bcd6adfdad642bd569fe4b')).push('open');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd8ea1bbcc54f0af968ecd067e0a4656')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/64fb38a4853923226314a85644f2f753/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['financialRole'] = 'driver';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d2cadcf117eb39a308f75f27f5e52d4', false);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'driver' ? ['selectionButtons__btn', 'active'] : ['selectionButtons__btn'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity/components/51443ab664d55a2a68483fccecabeaf7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['financialRole'] = 'passenger';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d2cadcf117eb39a308f75f27f5e52d4', false);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financialRole')) == 'passenger' ? ['selectionButtons__btn', 'active'] : ['selectionButtons__btn'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity/components/fcf68a05599c067cb2dbde9d089a5652/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d2cadcf117eb39a308f75f27f5e52d4', false);
  ___arguments.context.pageData['financialRole'] = '50/50';

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'financialRole')) != 'passenger' && (getObjectProperty(___arguments.context.pageData, 'financialRole')) != 'driver' ? ['selectionButtons__btn', 'active'] : ['selectionButtons__btn'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity/components/52b260437796121bb9eb3ea58a16a0c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return (String('About ') + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity/components/966ae081f9be4fc2e11bc7218d033823/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, j, list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('966ae081f9be4fc2e11bc7218d033823'))['pointer-events'] = 'none';
  var j_list = (getObjectProperty(___arguments.context.pageData, 'media'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['isCover'] = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'imagesToDelete'))) {
    ___arguments.context.pageData['imagesToDelete'] = [];
  }
  (getObjectProperty(___arguments.context.pageData, 'imagesToDelete')).push((getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file')));
  ___arguments.context.pageData['media'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'media')), async (item) => {


   return ((getObjectProperty(item, 'file')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file')));
  }));
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 1) {
    ((getObjectProperty(___arguments.context.pageData, 'media'))[0])['isCover'] = true;
  }
  ___arguments.context.pageData['imageList'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('966ae081f9be4fc2e11bc7218d033823'))['pointer-events'] = 'auto';
  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/02fa45cb955cdac4f7ad79283e31349a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isManualEdit')) ? 'Edit Activity' : 'Description')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity/components/8cdccce4c6d7f6630ba2dcdcfe783e1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, j, isFormValid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  isFormValid = true;
  if ((getObjectProperty(___arguments.context.pageData, 'name')) && !!(getObjectProperty(___arguments.context.pageData, 'name')).trim().length) {
    if ((new RegExp('\\.{4,}', 'g')).test((getObjectProperty(___arguments.context.pageData, 'name')))) {
      isFormValid = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', true);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', false);
    }
  } else {
    isFormValid = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2ccc31de6851d682d52564cadc968e98', true);
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'activityTitle')) || !(getObjectProperty(___arguments.context.pageData, 'activityTitle')).trim().length) {
    isFormValid = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'description')) || !(getObjectProperty(___arguments.context.pageData, 'description')).trim().length) {
    isFormValid = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'media')).length) {
    isFormValid = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'location')) || !(getObjectProperty(___arguments.context.pageData, 'locationPoint'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07745225406d90ae80ac1f2748957c7f', true);
    isFormValid = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'financialRole')) || !(getObjectProperty(___arguments.context.pageData, 'financialRole')).trim().length) {
    isFormValid = false;
  }
  if (isFormValid) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')), 'currentStepDescription', '');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f86658b83762d41b7b5e7888bc82f02a')).push('currentStepPreview');
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c4bda5b072b41136df47dded8b2cb79')), 'open', '');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4bb2456d78bcd6adfdad642bd569fe4b')).push('open');
    await (async function() {
    	swiper = new Swiper('.swiper', {

    	  pagination: {
    	    el: '.swiper-pagination',
    	    clickable: true
    	  }

    	});

    })();
  } else {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('cd8ea1bbcc54f0af968ecd067e0a4656')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/7edf59e890b84a2915ba9e8a774f7561/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function do_something() {
  ___arguments.context.pageData['activityTimingAlertText'] = '';
  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7eb9af336d564ab949398bda49392324')));
  ___arguments.context.pageData['ongoing'] = 'ongoing';
  ___arguments.context.pageData['scheduled'] = false;
  if (getObjectProperty(___arguments.context.pageData, 'specific')) {
    ___arguments.context.pageData['specific'] = false;
  }
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'value')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f'))['value'] = '';
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).pop();
    ___arguments.context.pageData['activityTimingAlertText'] = '';
  }
}


  ___arguments.context.pageData['activityTimingAlertText'] = '';
  ___arguments.context.pageData['ongoingInput'] = null;
  ___arguments.context.pageData['specificInput'] = null;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity/components/04de84164142354208d3f1ba77fa0ca7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'specific')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/8b556d982c47d359874a11981f6d5194/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'ongoing')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/f7a1c3a66b84459116bf739ec15fdd61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, preferences, isHeightChange, isGenderChange, isAgeChange, j, activity, order, pathIndex, timingStatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function validateTiming() {
  if ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'scheduled') {
    timingStatus = true;
  } else if ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'specific') {
    if (getObjectProperty(___arguments.context.pageData, 'specificInput')) {
      timingStatus = true;
    } else {
      timingStatus = false;
      ___arguments.context.pageData['activityTimingAlertText'] = 'Please choose date';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6039d74cf061de58a8f122f42ae1561c')));
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'ongoingInput')) && !!(getObjectProperty(___arguments.context.pageData, 'ongoingInput')).trim().length) {
      timingStatus = true;
    } else {
      timingStatus = false;
      ___arguments.context.pageData['activityTimingAlertText'] = 'Please, enter timing';
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6039d74cf061de58a8f122f42ae1561c')));
    }
  }
}


  await validateTiming();
  if (!timingStatus) {
    return ;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f53de2620f4d733b0e7582de365227b', true);
  ___arguments.context.pageData['publishBtnDisable'] = true;
  try {
    var j_list = (getObjectProperty(___arguments.context.pageData, 'media'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      pathIndex = (getObjectProperty(j, 'file')).indexOf('/pictures') + 1;
      j['file'] = (subsequenceFromStartLast((getObjectProperty(j, 'file')), (pathIndex - 1)));
    }
    if ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'specific') {
      order = 1;
    } else if ((getObjectProperty(___arguments.context.pageData, 'timing')) == 'ongoing') {
      order = 2;
    } else {
      order = 3;
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'financialRoleRequired'))) {
      ___arguments.context.pageData['financialRole'] = null;
    }
    activity = ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'name')),[`location`]: (getObjectProperty(___arguments.context.pageData, 'location')),[`keepLocationPrivate`]: (getObjectProperty(___arguments.context.pageData, 'keepLocationPrivate')),[`media`]: (getObjectProperty(___arguments.context.pageData, 'media')),[`locationPoint`]: (getObjectProperty(___arguments.context.pageData, 'locationPoint')),[`description`]: (getObjectProperty(___arguments.context.pageData, 'description')),[`activityDate`]: (getObjectProperty(___arguments.context.pageData, 'specificInput')),[`ongoingTiming`]: (getObjectProperty(___arguments.context.pageData, 'ongoingInput')),[`financialRole`]: (getObjectProperty(___arguments.context.pageData, 'financialRole')),[`visibility`]: (getObjectProperty(___arguments.context.pageData, 'visibility')),[`order`]: order,[`activityTitle`]: (getObjectProperty(___arguments.context.pageData, 'activityTitle')) });
    await Backendless.Data.of('Activity').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'activityId')),'\''].join('')), activity );
    await Backendless.Data.of('Activity').setRelation((getObjectProperty(___arguments.context.pageData, 'activityId')), 'category', [(getObjectProperty(___arguments.context.pageData, 'activityCategory'))]);
    delete ___arguments.context.appData['userActivitiesForInvitation'];
    if ((getObjectProperty(___arguments.context.pageData, 'imagesToDelete')) && !!(getObjectProperty(___arguments.context.pageData, 'imagesToDelete')).length) {
      try {
        ;(async () => {
            var j_list2 = (getObjectProperty(___arguments.context.pageData, 'imagesToDelete'));
          for (var j_index2 in j_list2) {
            j = j_list2[j_index2];
            await Backendless.Files.remove(encodePath(j));
          }

        })();

      } catch (error) {
        console.log(error);

      }
    }
    preferences = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'preferences'));
    if (preferences) {
      if (!(getObjectProperty(preferences, 'ageFrom'))) {
        preferences['ageFrom'] = 18;
      }
      if (!(getObjectProperty(preferences, 'ageTo'))) {
        preferences['ageTo'] = 100;
      }
      isAgeChange = (getObjectProperty(___arguments.context.pageData, 'age'))[0] != (getObjectProperty(preferences, 'ageFrom')) || (getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0] != (getObjectProperty(preferences, 'ageTo'));
      if (getObjectProperty(preferences, 'gender')) {
        if ((getObjectProperty(___arguments.context.pageData, 'gender')).length != (getObjectProperty(preferences, 'gender')).length) {
          isGenderChange = true;
        } else {
          isGenderChange = false;
          var j_list3 = (getObjectProperty(___arguments.context.pageData, 'gender'));
          for (var j_index3 in j_list3) {
            j = j_list3[j_index3];
            if (!((getObjectProperty(preferences, 'gender')).includes(j))) {
              isGenderChange = true;
              break;
            }
          }
        }
      } else {
        if (!!(getObjectProperty(___arguments.context.pageData, 'gender')).length) {
          isGenderChange = true;
        }
      }
      isHeightChange = (getObjectProperty(___arguments.context.pageData, 'heightData')) != (getObjectProperty(preferences, 'height'));
    } else {
      isAgeChange = (getObjectProperty(___arguments.context.pageData, 'age'))[0] != 18 || (getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0] != 100;
      isGenderChange = !!(getObjectProperty(___arguments.context.pageData, 'gender')).length;
      isHeightChange = (getObjectProperty(___arguments.context.pageData, 'heightData')) ? true : false;
    }
    if (isAgeChange || isGenderChange || isHeightChange) {
      if (!(getObjectProperty(___arguments.context.pageData, 'heightData'))) {
        ___arguments.context.pageData['heightData'] = null;
      }
      if (preferences) {
        await Backendless.Data.of('ActivityPreferences').bulkUpdate( (['objectId=\'',(getObjectProperty(preferences, 'objectId')),'\''].join('')), ({ [`ageFrom`]: (getObjectProperty(___arguments.context.pageData, 'age'))[0],[`ageTo`]: (getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0],[`gender`]: (getObjectProperty(___arguments.context.pageData, 'gender')),[`height`]: (getObjectProperty(___arguments.context.pageData, 'heightData')) }) );
      } else {
        ___arguments.context.pageData['objectIdActivityPreferences'] = (await Backendless.Request.post(`${Backendless.appPath}/services/saveActivityPreferences/saveoActivityPreferences`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'ageFrom': ((getObjectProperty(___arguments.context.pageData, 'age'))[0]),'ageTo': ((getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0]),'gender': (getObjectProperty(___arguments.context.pageData, 'gender')),'height': (getObjectProperty(___arguments.context.pageData, 'heightData')),'children': null }));
        await Backendless.Data.of('Activity').setRelation((getObjectProperty(___arguments.context.pageData, 'activityId')), 'preferences', [({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'objectIdActivityPreferences')) })]);
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f53de2620f4d733b0e7582de365227b', false);
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.pageData, 'activityId')) }));

  } catch (error) {
    console.log(error);
    ___arguments.context.pageData['publishBtnDisable'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f53de2620f4d733b0e7582de365227b', false);
    (function (message) { alert(message) })('Failed to update activity, please try again later');

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity/components/aa92f4f670c73ab7d98160c587d36926/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'checkboxAgeState')) ? ({ [`opacity`]: '0.35' }) : ({ [`opacity`]: '1' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/edit-activity/components/21921cf9d8475ad207ec9154d81ef267/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'age')) {
    return ([(getObjectProperty(___arguments.context.pageData, 'age'))[0],'-',(getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0]].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity/components/6df6d4b13bfff5e7a111d08f751d6af4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Female');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Female', '');
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gender')) && ((getObjectProperty(___arguments.context.pageData, 'gender')).includes('Female')))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity/components/67a308e77eca91cda901ae6a12c8ceb9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Non-Binary');
  } else {
    removeItemInList((getObjectProperty(___arguments.context.pageData, 'gender')), 'Non-Binary', '');
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'gender')) && ((getObjectProperty(___arguments.context.pageData, 'gender')).includes('Non-Binary')))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity/components/73b54014edf4489da74203a6490cfee8/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'gender')) || !(getObjectProperty(___arguments.context.pageData, 'gender')).length ? ({ [`opacity`]: '0.35' }) : ({ [`opacity`]: '1' }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/edit-activity/components/3968029d13271427744c4ff2c65259ce/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ({ [`opacity`]: (getObjectProperty(___arguments.context.pageData, 'isHeightBlockActive')) ? 1 : 0.35 })

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/edit-activity/components/dd1a437bcd15baf26cdce5a87fb44a96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'media')) && !(getObjectProperty(___arguments.context.pageData, 'media')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/0641ed5e933719244b6ecc9eef4f3178/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isPreloaderVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity/components/db79b952c227aedb27b37c7e573eb3fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'specificInput')) {
    return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty(___arguments.context.pageData, 'specificInput'))));
  } else if (getObjectProperty(___arguments.context.pageData, 'ongoingInput')) {
    return (getObjectProperty(___arguments.context.pageData, 'ongoingInput'));
  }

  return 'To be scheduled'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/7108b0a7713aaea77e6908612246f0c9/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var categoryListTableData;


  categoryListTableData = (await Backendless.Data.of('Category').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7108b0a7713aaea77e6908612246f0c9', categoryListTableData);
  ___arguments.context.pageData['categoryListTableData'] = categoryListTableData;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/65294bd93cda6445bee91fc33d64bdd1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, categoryListTableData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activityCategory'] = (getObjectProperty(___arguments.context.dataModel, 'objectId'));
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 992) {
    categoryListTableData = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')).map(async item => {  if ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'activityCategory'))) {
        if ((getObjectProperty(item, 'financialRoleRequired')) == true) {
          ___arguments.context.pageData['financialRoleTrue'] = true;
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f77bc408eed2f32a47f271160008c9eb', true);
        } else {
          ___arguments.context.pageData['financialRoleTrue'] = false;
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f77bc408eed2f32a47f271160008c9eb', false);
        }
      }
    ; return item;})));
  }
  ___arguments.context.pageData['category'] = (getObjectProperty(___arguments.context.dataModel, 'name'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'activityCategory')) == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
    return ['activity-page__category-item activity-page__category-item-active'];
  }

  return ['activity-page__category-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/c8c1f31e123dc7cba0f700c139228274/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var activityTitleStatus, mediaStatus, categoryStatus, descriptionStatus, nameStatus, regExp, inputDescription, inputName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    inputName = (getObjectProperty(___arguments.context.pageData, 'name')).trim();
    regExp = ((new RegExp('\\.{4,}', 'g')).test(inputName));
    if (regExp == true) {
      ___arguments.context.pageData['activityAlertText'] = 'Enter activity name';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'alert-border');
    } else {
      ___arguments.context.pageData['activityAlertText'] = '';
      nameStatus = true;
    }
  } else {
    ___arguments.context.pageData['activityAlertText'] = 'Enter activity name';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'alert-border');
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'activityTitle')) || !(getObjectProperty(___arguments.context.pageData, 'activityTitle')).trim().length) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ec53c04cdfab00ea1fae18bcda084964')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ec53c04cdfab00ea1fae18bcda084964')), 'alert-border');
      ___arguments.context.pageData['activityTitleAlertText'] = 'Please describe your activity';
    }
  } else {
    activityTitleStatus = true;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'description')) || !(getObjectProperty(___arguments.context.pageData, 'description')).trim().length) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')), 'alert-border');
      ___arguments.context.pageData['activityDescriptionAlertText'] = 'Please describe your activity';
    }
  } else {
    descriptionStatus = true;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'activityCategory'))) {
    ___arguments.context.pageData['activityCategoryAlertText'] = 'Please select a category';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d4a9c3e2f54970e2ab7669a3d7597dc8')), 'alert-border');
  } else {
    categoryStatus = true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 0 || (getObjectProperty(___arguments.context.pageData, 'media2')).length == 0) {
    ___arguments.context.pageData['activityImageAlertText'] = 'Please, add a photo';
    mediaStatus = false;
  } else {
    ___arguments.context.pageData['activityImageAlertText'] = '';
    mediaStatus = true;
  }
  if (nameStatus && descriptionStatus && categoryStatus && mediaStatus && activityTitleStatus) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('17f1266dfb5c067766544ac91f23c797')), 'activity-page__step--active');
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9b42149ee70bbfd53cbaedd3ee257b97'))['icon'] = 'keyboard_arrow_left';
    ___arguments.context.pageData['stepCount'] = 'Step 2/3';
    ___arguments.context.pageData['subtitle'] = '2. A few additional details...';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a915ac93423faf18518809839f0bf768')));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb0cea7d2f89ede366b9b8124b0d45b6', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1bebea2881612e3b8917aee54dca676c', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('660b51459628682615d7c73f825c273e', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f346419c73ff1eb8a5acad1230938847', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d79f2bb365d14a49a78c9799b2dffb13', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8969145a18dfd7cf6982d3287c9abc94', true);
    if (getObjectProperty(___arguments.context.pageData, 'financialRoleRequired')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b45a85cc462475129ac5857f1d051f3c', true);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4cc43d921412e62604ce8121f83518c7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e561a1da3fd68df7a55b9c48ebdce91a', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/4df590d6dc3a54537dcf708f8de2676b/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var activity;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'locationPoint')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'locationPoint')), 'lat'))) {
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'locationPoint')), 'lat')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'locationPoint')), 'lng')));
    (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('4df590d6dc3a54537dcf708f8de2676b', [(getObjectProperty(___arguments.context.pageData, 'locationPoint'))]);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/3f1ca6cacabbc6ba65f71d21d8092c88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['counter'] = (String(getValueLength(___arguments.value)) + String('/500 symbols'));
  if (!___arguments.value.trim().length) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')), 'alert-border');
      ___arguments.context.pageData['activityDescriptionAlertText'] = 'Please, describe your activity';
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')).slice(-1)[0] == 'alert-border') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')).pop();
      ___arguments.context.pageData['activityDescriptionAlertText'] = '';
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 350 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = '50vh';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7a1184326c08f3d325fdeb6446548fe4')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/edit-activity-old/components/919d55a2a72afa2bb1cb03f880960808/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['activityAlertText'] = '';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')).pop();
  }
  if (___arguments.value.length == 0) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'alert-border');
    ___arguments.context.pageData['activityAlertText'] = 'Enter activity name';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('919d55a2a72afa2bb1cb03f880960808')), 'el'))['maxLength'] = 60;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 350 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = '50vh';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('803e5ecb918452392b42287274a8b9ea')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/edit-activity-old/components/2efbbcb9400276de9473a2a949698db8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var preferenseObjectId, error, j, activity, vizibility, regExp, payYourOwnWayInput, pathIndex;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'media'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    pathIndex = (getObjectProperty(j, 'file')).indexOf('/pictures') + 1;
    j['file'] = (subsequenceFromStartLast((getObjectProperty(j, 'file')), (pathIndex - 1)));
  }
  ___arguments.context.pageData['religion'] = (getObjectProperty(___arguments.context.pageData, 'religionList'));
  if (getObjectProperty(___arguments.context.pageData, 'driver')) {
    ___arguments.context.pageData['finansialRoles'] = (getObjectProperty(___arguments.context.pageData, 'driver'));
  } else if (getObjectProperty(___arguments.context.pageData, 'passenger')) {
    ___arguments.context.pageData['finansialRoles'] = (getObjectProperty(___arguments.context.pageData, 'passenger'));
  } else if (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) {
    ___arguments.context.pageData['finansialRoles'] = (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput'));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'payYourOwnWay')) && (!(getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) || getValueLength((getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput'))) == 0)) {
    ___arguments.context.pageData['activityRolesAlertText'] = 'Please, enter your roles';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')), 'alert-border');
  } else if (!(getObjectProperty(___arguments.context.pageData, 'driver')) && !(getObjectProperty(___arguments.context.pageData, 'passenger')) && !(getObjectProperty(___arguments.context.pageData, 'payYourOwnWay'))) {
    ___arguments.context.pageData['activityRolesAlertText'] = 'Please, enter your roles';
  } else if (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) {
    if (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) {
      payYourOwnWayInput = (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')).trim();
      regExp = ((new RegExp('\\.{4,}', 'g')).test(payYourOwnWayInput));
      if (regExp == true) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7eb9af336d564ab949398bda49392324')), 'alert-border');
        ___arguments.context.pageData['activityRolesAlertText'] = 'Please, enter your roles';
      } else if (payYourOwnWayInput && regExp == false) {
        ___arguments.context.pageData['activityRolesAlertText'] = '';
      } else {
        ___arguments.context.pageData['activityRolesAlertText'] = 'Please, enter your roles';
      }
    }
  } else {
    ___arguments.context.pageData['activityRolesAlertText'] = '';
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'location'))) {
    ___arguments.context.pageData['location'] = null;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'locationPoint'))) {
    ___arguments.context.pageData['locationPoint'] = null;
  }
  if (getObjectProperty(___arguments.context.pageData, '1')) {
    ___arguments.context.pageData['vizibility'] = (getObjectProperty(___arguments.context.pageData, '1'));
  } else if (getObjectProperty(___arguments.context.pageData, '2')) {
    ___arguments.context.pageData['vizibility'] = (getObjectProperty(___arguments.context.pageData, '2'));
  } else if (getObjectProperty(___arguments.context.pageData, '3')) {
    ___arguments.context.pageData['vizibility'] = (getObjectProperty(___arguments.context.pageData, '3'));
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'financialRoleRequired'))) {
    ___arguments.context.pageData['finansialRoles'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'activityStatus')) != false) {
    ___arguments.context.pageData['activityStatus'] = true;
  }
  if (getObjectProperty(___arguments.context.pageData, 'specificDataPicker')) {
    ___arguments.context.pageData['order'] = 1;
  } else if (getObjectProperty(___arguments.context.pageData, 'ongoingInput')) {
    ___arguments.context.pageData['order'] = 2;
  } else {
    ___arguments.context.pageData['order'] = 3;
  }
  vizibility = (getObjectProperty(___arguments.context.pageData, 'vizibility')) * 1;
  if (!(getObjectProperty(___arguments.context.pageData, 'vizibility'))) {
    ___arguments.context.pageData['activityVizibilityAlertText'] = 'Please select visibility';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')), 'alert-border');
  } else {
    try {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2efbbcb9400276de9473a2a949698db8'))['disabled'] = true;
      if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'locationPoint')), 'lat')) {
        ___arguments.context.pageData['locationPoint'] = (new Backendless.Data.Point().setX((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'locationPoint')), 'lng'))).setY((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'locationPoint')), 'lat'))));
      }
      activity = ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'name')),[`location`]: (getObjectProperty(___arguments.context.pageData, 'location')),[`keepLocationPrivate`]: (getObjectProperty(___arguments.context.pageData, 'keepLocationPrivate')),[`media`]: (getObjectProperty(___arguments.context.pageData, 'media')),[`locationPoint`]: (getObjectProperty(___arguments.context.pageData, 'locationPoint')),[`description`]: (getObjectProperty(___arguments.context.pageData, 'description')),[`activityDate`]: (getObjectProperty(___arguments.context.pageData, 'specificDataPicker')),[`ongoingTiming`]: (getObjectProperty(___arguments.context.pageData, 'ongoingInput')),[`financialRole`]: (getObjectProperty(___arguments.context.pageData, 'finansialRoles')),[`visibility`]: vizibility,[`activityStatus`]: (getObjectProperty(___arguments.context.pageData, 'activityStatus')),[`order`]: (getObjectProperty(___arguments.context.pageData, 'order')),[`activityTitle`]: (getObjectProperty(___arguments.context.pageData, 'activityTitle')) });
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a915ac93423faf18518809839f0bf768')));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9f53de2620f4d733b0e7582de365227b', true);
      await Backendless.Data.of('Activity').bulkUpdate( (['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'activityId')),'\''].join('')), activity );
      if (!!(getObjectProperty(___arguments.context.pageData, 'toDelete')).length) {
        var j_list2 = (getObjectProperty(___arguments.context.pageData, 'toDelete'));
        for (var j_index2 in j_list2) {
          j = j_list2[j_index2];
          ;(async () => {
              await Backendless.Files.remove(encodePath(j));

          })();
        }
      }
      await Backendless.Data.of('Activity').setRelation((getObjectProperty(___arguments.context.pageData, 'activityId')), 'category', [({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'activityCategory')) })]);

    } catch (error) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2efbbcb9400276de9473a2a949698db8'))['disabled'] = false;
      console.log(error);

    }
    if (!(getObjectProperty(___arguments.context.pageData, 'ageFrom'))) {
      ___arguments.context.pageData['ageFrom'] = null;
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'ageTo'))) {
      ___arguments.context.pageData['ageTo'] = null;
    }
    if ((getObjectProperty(___arguments.context.pageData, 'genderCheckbox')) || !((getObjectProperty(___arguments.context.pageData, 'gender')) || (getObjectProperty(___arguments.context.pageData, 'gender')).length == 0)) {
      ___arguments.context.pageData['genderData'] = null;
    } else {
      if (getObjectProperty(___arguments.context.pageData, 'genderCheckbox')) {
        ___arguments.context.pageData['genderData'] = null;
      } else {
        ___arguments.context.pageData['genderData'] = (getObjectProperty(___arguments.context.pageData, 'gender'));
      }
    }
    if ((getObjectProperty(___arguments.context.pageData, 'heightCheckbox')) || !(getObjectProperty(___arguments.context.pageData, 'heightData'))) {
      ___arguments.context.pageData['heightDataTable'] = null;
    } else {
      if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 1) {
        ___arguments.context.pageData['heightData'] = (String('-') + String((getObjectProperty(___arguments.context.pageData, 'height')) * 1));
      } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 2) {
        ___arguments.context.pageData['heightData'] = (getObjectProperty(___arguments.context.pageData, 'height'));
      }
      if (getObjectProperty(___arguments.context.pageData, 'heightCheckbox')) {
        ___arguments.context.pageData['heightDataTable'] = null;
      } else {
        ___arguments.context.pageData['heightDataTable'] = ((getObjectProperty(___arguments.context.pageData, 'heightData')) * 1);
      }
    }
    if (getObjectProperty(___arguments.context.pageData, 'childrenCheckbox')) {
      ___arguments.context.pageData['childrenData'] = null;
    } else if ((getObjectProperty(___arguments.context.pageData, 'childrenCheckbox')) == 'undefined' || (getObjectProperty(___arguments.context.pageData, 'children')) == 'undefined') {
      ___arguments.context.pageData['childrenData'] = null;
    } else if (getObjectProperty(___arguments.context.pageData, 'children')) {
      ___arguments.context.pageData['childrenData'] = ((getObjectProperty(___arguments.context.pageData, 'children')) * 1);
    }
    if ((getObjectProperty(___arguments.context.pageData, 'ageFrom')) || (getObjectProperty(___arguments.context.pageData, 'ageTo')) || (getObjectProperty(___arguments.context.pageData, 'genderData')) || (getObjectProperty(___arguments.context.pageData, 'heightDataTable')) || (getObjectProperty(___arguments.context.pageData, 'childrenData')) || (getObjectProperty(___arguments.context.pageData, 'maritalStatusCheckbox')) || (getObjectProperty(___arguments.context.pageData, 'maritalStatus')) || (getObjectProperty(___arguments.context.pageData, 'ethnicityCheckbox')) || (getObjectProperty(___arguments.context.pageData, 'ethnicity')) || (getObjectProperty(___arguments.context.pageData, 'religionCheckbox')) || (getObjectProperty(___arguments.context.pageData, 'religion')) || (getObjectProperty(___arguments.context.pageData, 'sexualidentityCheckbox')) || (getObjectProperty(___arguments.context.pageData, 'sexualidentity')) || (getObjectProperty(___arguments.context.pageData, 'educationCheckbox')) || (getObjectProperty(___arguments.context.pageData, 'education')) || (getObjectProperty(___arguments.context.pageData, 'bodyTypeCheckbox')) || (getObjectProperty(___arguments.context.pageData, 'bodyType')) || (getObjectProperty(___arguments.context.pageData, 'politicalViewCheckbox')) || (getObjectProperty(___arguments.context.pageData, 'politicalView')) || (getObjectProperty(___arguments.context.pageData, 'hairColorCheckbox')) || (getObjectProperty(___arguments.context.pageData, 'hairColor')) || (getObjectProperty(___arguments.context.pageData, 'smokeCheckbox')) || (getObjectProperty(___arguments.context.pageData, 'smoke')) || (getObjectProperty(___arguments.context.pageData, 'drinkCheckbox')) || (getObjectProperty(___arguments.context.pageData, 'drink')) && (getObjectProperty(___arguments.context.pageData, 'dietaryPreferenceCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'dietaryPreference'))) {
      if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'preferences')) {
        await Backendless.Data.of('ActivityPreferences').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'preferences')), 'objectId')),'\''].join('')), ({ [`ageFrom`]: (getObjectProperty(___arguments.context.pageData, 'ageFrom')),[`ageTo`]: (getObjectProperty(___arguments.context.pageData, 'ageTo')),[`gender`]: (getObjectProperty(___arguments.context.pageData, 'genderData')),[`height`]: (getObjectProperty(___arguments.context.pageData, 'heightDataTable')),[`children`]: (getObjectProperty(___arguments.context.pageData, 'childrenData')) }) );
        await Backendless.Data.of('Activity').setRelation((getObjectProperty(___arguments.context.pageData, 'activityId')), 'preferences', [({ [`objectId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'preferences')), 'objectId')) })]);
        preferenseObjectId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'preferences')), 'objectId'));
      } else {
        ___arguments.context.pageData['objectIdActivityPreferences'] = (await Backendless.Request.post(`${Backendless.appPath}/services/saveActivityPreferences/saveoActivityPreferences`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'ageFrom': (getObjectProperty(___arguments.context.pageData, 'ageFrom')),'ageTo': (getObjectProperty(___arguments.context.pageData, 'ageTo')),'gender': (getObjectProperty(___arguments.context.pageData, 'genderData')),'height': (getObjectProperty(___arguments.context.pageData, 'heightDataTable')),'children': (getObjectProperty(___arguments.context.pageData, 'childrenData')) }));
        await Backendless.Data.of('Activity').setRelation((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'objectId')), 'preferences', [({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'objectIdActivityPreferences')) })]);
        preferenseObjectId = (getObjectProperty(___arguments.context.pageData, 'objectIdActivityPreferences'));
      }
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'maritalStatusCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'maritalStatus'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'maritalStatus', (getObjectProperty(___arguments.context.pageData, 'maritalStatus')));
    } else if (getObjectProperty(___arguments.context.pageData, 'maritalStatusCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'maritalStatus', []);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'ethnicityCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'ethnicity'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'ethnicity', (getObjectProperty(___arguments.context.pageData, 'ethnicity')));
    } else if (getObjectProperty(___arguments.context.pageData, 'ethnicityCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'ethnicity', []);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'religionCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'religion'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'religion', (getObjectProperty(___arguments.context.pageData, 'religion')));
    } else if (getObjectProperty(___arguments.context.pageData, 'religionCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'religion', []);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'sexualidentityCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'sexualidentity'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'sexualIdentity', (getObjectProperty(___arguments.context.pageData, 'sexualidentity')));
    } else if (getObjectProperty(___arguments.context.pageData, 'sexualidentityCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'sexualIdentity', []);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'educationCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'education'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'education', (getObjectProperty(___arguments.context.pageData, 'education')));
    } else if (getObjectProperty(___arguments.context.pageData, 'educationCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'education', []);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'bodyTypeCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'bodyType'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'bodyType', (getObjectProperty(___arguments.context.pageData, 'bodyType')));
    } else if (getObjectProperty(___arguments.context.pageData, 'bodyTypeCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'bodyType', []);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'politicalViewCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'politicalView'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'politicalViews', (getObjectProperty(___arguments.context.pageData, 'politicalView')));
    } else if (getObjectProperty(___arguments.context.pageData, 'politicalViewCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'politicalViews', []);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'hairColorCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'hairColor'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'hairColor', (getObjectProperty(___arguments.context.pageData, 'hairColor')));
    } else if (getObjectProperty(___arguments.context.pageData, 'hairColorCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'hairColor', []);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'smokeCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'smoke'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'smoke', (getObjectProperty(___arguments.context.pageData, 'smoke')));
    } else if (getObjectProperty(___arguments.context.pageData, 'smokeCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'smoke', []);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'drinkCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'drink'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'drink', (getObjectProperty(___arguments.context.pageData, 'drink')));
    } else if (getObjectProperty(___arguments.context.pageData, 'drinkCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'drink', []);
    }
    if (!(getObjectProperty(___arguments.context.pageData, 'dietaryPreferenceCheckbox')) && (getObjectProperty(___arguments.context.pageData, 'dietaryPreference'))) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'dietaryPreference', (getObjectProperty(___arguments.context.pageData, 'dietaryPreference')));
    } else if (getObjectProperty(___arguments.context.pageData, 'dietaryPreferenceCheckbox')) {
      await Backendless.Data.of('ActivityPreferences').setRelation(preferenseObjectId, 'dietaryPreference', []);
    }
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/967841ebfbb49d6f45fab82c6fa6ce79/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activityTimingAlertText'] = '';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).pop();
  }
  if (getObjectProperty(___arguments.context.pageData, 'ongoing')) {
    ___arguments.context.pageData['ongoing'] = false;
  }
  if (getObjectProperty(___arguments.context.pageData, 'ongoingInput')) {
    ___arguments.context.pageData['ongoingInput'] = '';
  }
  if (getObjectProperty(___arguments.context.pageData, 'scheduled')) {
    ___arguments.context.pageData['scheduled'] = null;
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7eb9af336d564ab949398bda49392324')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7eb9af336d564ab949398bda49392324')).pop();
    ___arguments.context.pageData['activityTimingAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return false

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/3f0d1a61d452fa0f617aeeb81fe29ec4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activityTimingAlertText'] = '';
  if (getObjectProperty(___arguments.context.pageData, 'specific')) {
    ___arguments.context.pageData['specific'] = false;
  }
  ___arguments.context.pageData['ongoing'] = 'ongoing';
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'value')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f'))['value'] = '';
  }
  if (getObjectProperty(___arguments.context.pageData, 'scheduled')) {
    ___arguments.context.pageData['scheduled'] = null;
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).pop();
    ___arguments.context.pageData['activityTimingAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  onDisabledStateAssignment(___arguments) {
      return false

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/10476337a1fe6ff828cd2ade6062f95f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activityTimingAlertText'] = '';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).pop();
  }
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('967841ebfbb49d6f45fab82c6fa6ce79'))['checkedValue'] = 'specificDate';
  ___arguments.context.pageData['ongoing'] = false;
  if (getObjectProperty(___arguments.context.pageData, 'specific')) {
    ___arguments.context.pageData['specificInput'] = ___arguments.value;
    ___arguments.context.pageData['minDateNotification'] = false;
  }
  if (getObjectProperty(___arguments.context.pageData, 'ongoingInput')) {
    ___arguments.context.pageData['ongoingInput'] = '';
  }
  if (!___arguments.value) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('967841ebfbb49d6f45fab82c6fa6ce79'))['checkedValue'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/7eb9af336d564ab949398bda49392324/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'ongoing')) {
    ___arguments.context.pageData['ongoingInput'] = ___arguments.value;
    ___arguments.context.pageData['specificInput'] = null;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'ongoingInput')).length == 0) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7eb9af336d564ab949398bda49392324')), 'alert-border');
    ___arguments.context.pageData['activityTimingAlertText'] = 'Please, enter timing';
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7eb9af336d564ab949398bda49392324')).slice(-1)[0] == 'alert-border') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7eb9af336d564ab949398bda49392324')).pop();
    }
    ___arguments.context.pageData['activityTimingAlertText'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f0d1a61d452fa0f617aeeb81fe29ec4'))['checkedValue'] = 'ongoing';
  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7eb9af336d564ab949398bda49392324')), 'el'))['maxLength'] = 60;
  ___arguments.context.pageData['specific'] = false;
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'value')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f'))['value'] = '';
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a'))['margin-bottom'] = '50vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f0d1a61d452fa0f617aeeb81fe29ec4')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/edit-activity-old/components/5487b84eaff8f5492361d74b940898e7/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activityRolesAlertText'] = '';
  if ((getObjectProperty(___arguments.context.pageData, 'passenger')) || (getObjectProperty(___arguments.context.pageData, 'payYourOwnWay'))) {
    ___arguments.context.pageData['passenger'] = false;
    ___arguments.context.pageData['payYourOwnWay'] = false;
  }
  if (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) {
    ___arguments.context.pageData['payYourOwnWayInput'] = '';
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')).pop();
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/fd718acdb4e4a516e0114fa8ad98a5e4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activityRolesAlertText'] = '';
  if ((getObjectProperty(___arguments.context.pageData, 'driver')) || (getObjectProperty(___arguments.context.pageData, 'payYourOwnWay'))) {
    ___arguments.context.pageData['driver'] = false;
    ___arguments.context.pageData['payYourOwnWay'] = false;
  }
  if (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) {
    ___arguments.context.pageData['payYourOwnWayInput'] = '';
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')).pop();
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/00edfc8b597a776af07221de0f2e1506/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')));
  ___arguments.context.pageData['activityRolesAlertText'] = '';
  if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')), 'value'))) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97'))['value'] = '50/50';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'driver')) || (getObjectProperty(___arguments.context.pageData, 'passenger'))) {
    ___arguments.context.pageData['driver'] = false;
    ___arguments.context.pageData['passenger'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/7556db4d9898976a79a4198c85eedd97/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['activityRolesAlertText'] = '';
  if ((getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) == true) {
    ___arguments.context.pageData['payYourOwnWayInput'] = ___arguments.value;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')).length == 0) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')), 'alert-border');
    ___arguments.context.pageData['activityRolesAlertText'] = 'Please select a Financial Role for your activity';
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')).slice(-1)[0] == 'alert-border') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')).pop();
      ___arguments.context.pageData['activityRolesAlertText'] = '';
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('00edfc8b597a776af07221de0f2e1506'))['checkedValue'] = 'pay your own way';
  ___arguments.context.pageData['driver'] = false;
  ___arguments.context.pageData['passenger'] = false;
  ___arguments.context.pageData['payYourOwnWay'] = 'payYourOwnWay';
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97'))['value'] = '50/50';
  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')), 'el'))['maxLength'] = 60;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd0276dd5249369f1c2c628f0e2b268c', true);
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd0276dd5249369f1c2c628f0e2b268c'))['padding-bottom'] = '50vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fd0276dd5249369f1c2c628f0e2b268c')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fd0276dd5249369f1c2c628f0e2b268c'))['padding-bottom'] = 'unset';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fd0276dd5249369f1c2c628f0e2b268c', false);
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/edit-activity-old/components/868ca14116b7664ae49e7a7508b6d056/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('868ca14116b7664ae49e7a7508b6d056', (getObjectProperty(___arguments.context.pageData, 'categoryRelation')));
  if (!(getObjectProperty(___arguments.context.pageData, 'qualityList'))) {
    ___arguments.context.pageData['qualityList'] = [];
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/1d61c9a7286f9baf3e5194abd727caf9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1d61c9a7286f9baf3e5194abd727caf9')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1d61c9a7286f9baf3e5194abd727caf9')), 'activity-page__quality-item-active');
    ___arguments.context.pageData['activityQualityAlertText'] = '';
    addItemToList((getObjectProperty(___arguments.context.pageData, 'qualityList')), (getObjectProperty(___arguments.context.dataModel, 'objectId')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1d61c9a7286f9baf3e5194abd727caf9')).pop();
    ___arguments.context.pageData['qualityList'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'qualityList')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'qualityList')), async (item) => {


   return (item == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
  })).length) {
    return ['activity-page__quality-item', 'activity-page__quality-item-active'];
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/3d491f34ce52a7eb00bb2c44ba7927ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var financialStatus, quialitiesStatus, timingStatus, locationStatus, regExp, payYourOwnWayInput, ongoingInput;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  ___arguments.context.pageData['specificDataPicker'] = (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'value'));
  if (!(getObjectProperty(___arguments.context.pageData, 'location'))) {
    ___arguments.context.pageData['errorLocation'] = 'Please, enter your location';
    locationStatus = false;
  } else {
    ___arguments.context.pageData['errorLocation'] = '';
    locationStatus = true;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'specific')) && (getObjectProperty(___arguments.context.pageData, 'specific')) != false && !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'value'))) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'alert-border');
    ___arguments.context.pageData['activityTimingAlertText'] = 'Please, enter timing';
    timingStatus = false;
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).slice(-1)[0] == 'alert-border') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).pop();
      ___arguments.context.pageData['activityTimingAlertText'] = '';
      timingStatus = true;
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'ongoing')) != false && (getObjectProperty(___arguments.context.pageData, 'ongoing')) && !(getObjectProperty(___arguments.context.pageData, 'ongoingInput'))) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7eb9af336d564ab949398bda49392324')), 'alert-border');
    ___arguments.context.pageData['activityTimingAlertText'] = 'Please, enter timing';
    timingStatus = false;
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7eb9af336d564ab949398bda49392324')).slice(-1)[0] == 'alert-border') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7eb9af336d564ab949398bda49392324')).pop();
      ___arguments.context.pageData['activityTimingAlertText'] = '';
      timingStatus = true;
    }
  }
  if ((!(getObjectProperty(___arguments.context.pageData, 'specific')) || !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'value'))) && (!(getObjectProperty(___arguments.context.pageData, 'ongoing')) || !(getObjectProperty(___arguments.context.pageData, 'ongoingInput'))) && !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a059d45ebf8a77f9cbecf1a5f9a16547')), 'checkedValue'))) {
    ___arguments.context.pageData['activityTimingAlertText'] = 'Please, enter timing';
    timingStatus = false;
  } else if (getObjectProperty(___arguments.context.pageData, 'specific')) {
    if ((new Date((new Date()).getTime() - (60 * 1000))) <= (new Date((getObjectProperty(___arguments.context.pageData, 'specificInput'))))) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).slice(-1)[0] == 'alert-border') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).pop();
      }
      ___arguments.context.pageData['activityTimingAlertText'] = '';
      timingStatus = true;
    } else {
      ___arguments.context.pageData['activityTimingAlertText'] = '';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'alert-border');
      timingStatus = false;
    }
  } else if (getObjectProperty(___arguments.context.pageData, 'ongoingInput')) {
    if (getObjectProperty(___arguments.context.pageData, 'ongoingInput')) {
      ongoingInput = (getObjectProperty(___arguments.context.pageData, 'ongoingInput')).trim();
      regExp = ((new RegExp('\\.{4,}', 'g')).test(ongoingInput));
      if (regExp == true) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7eb9af336d564ab949398bda49392324')), 'alert-border');
        ___arguments.context.pageData['activityTimingAlertText'] = 'Please, enter timing';
        timingStatus = false;
      } else if (ongoingInput && regExp == false) {
        ___arguments.context.pageData['activityTimingAlertText'] = '';
        timingStatus = true;
      } else {
        ___arguments.context.pageData['activityTimingAlertText'] = 'Please, enter timing';
        timingStatus = false;
      }
    }
  }
  if (getObjectProperty(___arguments.context.pageData, 'scheduled')) {
    ___arguments.context.pageData['activityTimingAlertText'] = '';
    timingStatus = true;
  }
  if (getObjectProperty(___arguments.context.pageData, 'driver')) {
    ___arguments.context.pageData['finansialRoles'] = (getObjectProperty(___arguments.context.pageData, 'driver'));
    financialStatus = true;
  } else if (getObjectProperty(___arguments.context.pageData, 'passenger')) {
    ___arguments.context.pageData['finansialRoles'] = (getObjectProperty(___arguments.context.pageData, 'passenger'));
    financialStatus = true;
  } else if (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) {
    ___arguments.context.pageData['finansialRoles'] = (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput'));
    financialStatus = true;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'payYourOwnWay')) && (!(getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) || getValueLength((getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput'))) == 0)) {
      ___arguments.context.pageData['activityRolesAlertText'] = 'Enter below how the payment will take place';
      financialStatus = false;
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')).slice(-1)[0] != 'alert-border') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')), 'alert-border');
      }
    } else if (!(getObjectProperty(___arguments.context.pageData, 'driver')) && !(getObjectProperty(___arguments.context.pageData, 'passenger')) && !(getObjectProperty(___arguments.context.pageData, 'payYourOwnWay'))) {
      ___arguments.context.pageData['activityRolesAlertText'] = 'Please select a Financial Role for your activity';
      financialStatus = false;
    } else if (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) {
      if (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) {
        payYourOwnWayInput = (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')).trim();
        regExp = ((new RegExp('\\.{4,}', 'g')).test(payYourOwnWayInput));
        if (regExp == true) {
          if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')).slice(-1)[0] != 'alert-border') {
            addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7556db4d9898976a79a4198c85eedd97')), 'alert-border');
          }
          ___arguments.context.pageData['activityRolesAlertText'] = 'Please select a Financial Role for your activity';
          financialStatus = false;
        } else if (payYourOwnWayInput && regExp == false) {
          ___arguments.context.pageData['activityRolesAlertText'] = '';
          financialStatus = true;
        } else {
          ___arguments.context.pageData['activityRolesAlertText'] = 'Please select a Financial Role for your activity';
          financialStatus = false;
        }
      }
    } else {
      ___arguments.context.pageData['activityRolesAlertText'] = '';
      financialStatus = true;
    }
  }
  quialitiesStatus = true;
  if (!(getObjectProperty(___arguments.context.pageData, 'financialRoleRequired'))) {
    financialStatus = true;
  }
  if (locationStatus && quialitiesStatus && timingStatus) {
    if (getObjectProperty(___arguments.context.pageData, 'financialRoleRequired')) {
      if (financialStatus) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b45a85cc462475129ac5857f1d051f3c', false);
        ___arguments.context.pageData['stepCount'] = 'Step 3/3';
        ___arguments.context.pageData['subtitle'] = '3. Settings';
        if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d74362cb5191d50acf435d28d2685ecd')).slice(-1)[0] != 'activity-page__step--active') {
          addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d74362cb5191d50acf435d28d2685ecd')), 'activity-page__step--active');
        }
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8969145a18dfd7cf6982d3287c9abc94', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4cc43d921412e62604ce8121f83518c7', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e561a1da3fd68df7a55b9c48ebdce91a', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2894dfb56f3475328becafc550390aa5', true);
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a915ac93423faf18518809839f0bf768')));
      } else {
        ___arguments.context.pageData['activityRolesAlertText'] = 'Please select a Financial Role for your activity';
      }
    } else {
      ___arguments.context.pageData['stepCount'] = '3/3 step';
      ___arguments.context.pageData['subtitle'] = '3. Settings';
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d74362cb5191d50acf435d28d2685ecd')).slice(-1)[0] != 'activity-page__step--active') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d74362cb5191d50acf435d28d2685ecd')), 'activity-page__step--active');
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8969145a18dfd7cf6982d3287c9abc94', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4cc43d921412e62604ce8121f83518c7', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e561a1da3fd68df7a55b9c48ebdce91a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2894dfb56f3475328becafc550390aa5', true);
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a915ac93423faf18518809839f0bf768')));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/c84bc82bb6f109fba3db9f11e6e837ff/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activityVizibilityAlertText'] = '';
  if ((getObjectProperty(___arguments.context.pageData, '2')) || (getObjectProperty(___arguments.context.pageData, '3'))) {
    ___arguments.context.pageData['2'] = false;
    ___arguments.context.pageData['3'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/5dbf8d9cc9320811ee851d74bca83589/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activityVizibilityAlertText'] = '';
  if ((getObjectProperty(___arguments.context.pageData, '1')) || (getObjectProperty(___arguments.context.pageData, '3'))) {
    ___arguments.context.pageData['1'] = false;
    ___arguments.context.pageData['3'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/c7bf475e7a59cd8e1fed2b9bd222b185/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activityVizibilityAlertText'] = '';
  if ((getObjectProperty(___arguments.context.pageData, '1')) || (getObjectProperty(___arguments.context.pageData, '2'))) {
    ___arguments.context.pageData['1'] = false;
    ___arguments.context.pageData['2'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/b3e614a80d460e6d53dff501d99a944c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b3e614a80d460e6d53dff501d99a944c')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b3e614a80d460e6d53dff501d99a944c')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2739255c3294cbcd736ad4e93cc34e37')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b3e614a80d460e6d53dff501d99a944c')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b3e614a80d460e6d53dff501d99a944c')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2739255c3294cbcd736ad4e93cc34e37')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/154c2d9cecf2f3329ede16c380b4b25c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('154c2d9cecf2f3329ede16c380b4b25c')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('154c2d9cecf2f3329ede16c380b4b25c')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('32ea180c6a5ae4a779c8ab7f61dcc468')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('154c2d9cecf2f3329ede16c380b4b25c')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('154c2d9cecf2f3329ede16c380b4b25c')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('32ea180c6a5ae4a779c8ab7f61dcc468')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/7a42c80c904bf6ac90af7395f36a13bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7a42c80c904bf6ac90af7395f36a13bd')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7a42c80c904bf6ac90af7395f36a13bd')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3b247f9d2a7fc2fd9c8b60bdd2ed4f78')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7a42c80c904bf6ac90af7395f36a13bd')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7a42c80c904bf6ac90af7395f36a13bd')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3b247f9d2a7fc2fd9c8b60bdd2ed4f78')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/01ff5d27eecb1b6bd8ae2d75c1f6b533/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('01ff5d27eecb1b6bd8ae2d75c1f6b533')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('01ff5d27eecb1b6bd8ae2d75c1f6b533')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2fb2638ea9dd85c58f2ff656099d8bbd')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('01ff5d27eecb1b6bd8ae2d75c1f6b533')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('01ff5d27eecb1b6bd8ae2d75c1f6b533')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2fb2638ea9dd85c58f2ff656099d8bbd')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/3363d9e89ccde0cafb233fc25b51522a/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3363d9e89ccde0cafb233fc25b51522a', (getObjectProperty(___arguments.context.appData, 'statusList')));
  if ((getObjectProperty(___arguments.context.pageData, 'maritalStatus')) && (getObjectProperty(___arguments.context.pageData, 'maritalStatus')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f492f6e3dfe643d43a13e59e5a25dca'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47b894b24b98dc6e183e0797adf8ac32'))['checked'] = false;
  } else {
    ___arguments.context.pageData['maritalStatusId'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f492f6e3dfe643d43a13e59e5a25dca'))['opacity'] = 0.35;
    ___arguments.context.pageData['maritalStatus'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47b894b24b98dc6e183e0797adf8ac32'))['checked'] = true;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/634b3fb81b37b47f92a218a258e1ffaf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('47b894b24b98dc6e183e0797adf8ac32'))['checked'] = false;
  delete ___arguments.context.pageData['maritalStatusCheckbox'];
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f492f6e3dfe643d43a13e59e5a25dca'))['opacity'] = 1;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('634b3fb81b37b47f92a218a258e1ffaf')).slice(-1)[0] != 'activity-page__marital-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('634b3fb81b37b47f92a218a258e1ffaf')), 'activity-page__marital-item-active');
    addItemToList((getObjectProperty(___arguments.context.pageData, 'maritalStatus')), (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'maritalStatusId')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('634b3fb81b37b47f92a218a258e1ffaf')).pop();
    (getObjectProperty(___arguments.context.pageData, 'maritalStatus')).splice((((getObjectProperty(___arguments.context.pageData, 'maritalStatus')).indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'maritalStatusId')).splice((((getObjectProperty(___arguments.context.pageData, 'maritalStatusId')).indexOf(getObjectProperty(___arguments.context.dataModel, 'id')) + 1) - 1), 1);
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'maritalStatus')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'maritalStatus')), async (item) => {


     return (item == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__marital-item', 'activity-page__marital-item-active'];
    }
  }

  return ['activity-page__marital-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/47b894b24b98dc6e183e0797adf8ac32/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f492f6e3dfe643d43a13e59e5a25dca'))['opacity'] = 0.35;
    ___arguments.context.pageData['maritalStatusCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3f492f6e3dfe643d43a13e59e5a25dca'))['opacity'] = 1;
    delete ___arguments.context.pageData['maritalStatusCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/a0a4ac7cfa3115af9b7ffac3f949a63e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2a6cc267ff1834d4e052611c72f1f1d9'))['checked'] = false;
  ___arguments.context.pageData['gender'] = ___arguments.checkedValue;
  if (___arguments.checkedValue == 1) {
    ___arguments.context.pageData['genderChecked'] = '\'Male\'';
  } else if (___arguments.checkedValue == 2) {
    ___arguments.context.pageData['genderChecked'] = '\'Female\'';
  } else if (___arguments.checkedValue == 3) {
    ___arguments.context.pageData['genderChecked'] = '\'Male\', \'Female\', \'\'';
  }
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('ebcfb68a5f1d7b02d84221d4a0c839c3'))['opacity'] = 1;
  ___arguments.context.pageData['countStart'] = true;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/916764cf81f7f4dd39add13dbd65fa7a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['height'] = ___arguments.value;
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 1 || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == '1') {
    ___arguments.context.pageData['heightData'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * -1);
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 2 || (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == '2') {
    ___arguments.context.pageData['heightData'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var height;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'heightList'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/a7993934459154523e34663fcee9224a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa92f4f670c73ab7d98160c587d36926'))['opacity'] = 0.35;
    ___arguments.context.pageData['ageFrom'] = 18;
    ___arguments.context.pageData['ageTo'] = 100;
    ___arguments.context.pageData['age'] = [18, 100];
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa92f4f670c73ab7d98160c587d36926'))['opacity'] = 1;
    ___arguments.context.pageData['ageFrom'] = 18;
    ___arguments.context.pageData['ageTo'] = 100;
    ___arguments.context.pageData['age'] = [18, 100];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/aa92f4f670c73ab7d98160c587d36926/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'ageFrom')) || (getObjectProperty(___arguments.context.pageData, 'ageTo'))) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7993934459154523e34663fcee9224a'))['checked'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa92f4f670c73ab7d98160c587d36926'))['opacity'] = 1;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa92f4f670c73ab7d98160c587d36926'))['opacity'] = 0.35;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7993934459154523e34663fcee9224a'))['checked'] = true;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/2a6cc267ff1834d4e052611c72f1f1d9/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7bedbfcd637446769de998b874a864df'))['opacity'] = 0.35;
    ___arguments.context.pageData['genderCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7bedbfcd637446769de998b874a864df'))['opacity'] = 1;
    delete ___arguments.context.pageData['genderCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/ebcfb68a5f1d7b02d84221d4a0c839c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a6cc267ff1834d4e052611c72f1f1d9'))['checked'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ebcfb68a5f1d7b02d84221d4a0c839c3'))['opacity'] = 1;
  if (!(getObjectProperty(___arguments.context.pageData, 'gender'))) {
    ___arguments.context.pageData['gender'] = (getObjectProperty(___arguments.context.pageData, 'genderList'));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/3555fd47b081b0a63af89443d6e87df1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3968029d13271427744c4ff2c65259ce'))['opacity'] = 0.35;
    ___arguments.context.pageData['heightCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3968029d13271427744c4ff2c65259ce'))['opacity'] = 1;
    delete ___arguments.context.pageData['heightCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/3968029d13271427744c4ff2c65259ce/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) {
    if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'US' || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'LR' || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'MM') {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″' }), ({ [`value`]: '124',[`label`]: '4′1″' }), ({ [`value`]: '127',[`label`]: '4′2″' }), ({ [`value`]: '130',[`label`]: '4′3″' }), ({ [`value`]: '132',[`label`]: '4′4″' }), ({ [`value`]: '135',[`label`]: '4′5″' }), ({ [`value`]: '137',[`label`]: '4′6″' }), ({ [`value`]: '140',[`label`]: '4′7″' }), ({ [`value`]: '142',[`label`]: '4′8″' }), ({ [`value`]: '145',[`label`]: '4′9″' }), ({ [`value`]: '152',[`label`]: '5′0″' }), ({ [`value`]: '155',[`label`]: '5′1″' }), ({ [`value`]: '157',[`label`]: '5′2″' }), ({ [`value`]: '160',[`label`]: '5′3″' }), ({ [`value`]: '163',[`label`]: '5′4″' }), ({ [`value`]: '165',[`label`]: '5′5″' }), ({ [`value`]: '168',[`label`]: '5′6″' }), ({ [`value`]: '170',[`label`]: '5′7″' }), ({ [`value`]: '173',[`label`]: '5′8″' }), ({ [`value`]: '176',[`label`]: '5′9″' }), ({ [`value`]: '178',[`label`]: '5′10″' }), ({ [`value`]: '180',[`label`]: '5′11″' }), ({ [`value`]: '183',[`label`]: '6′0″' }), ({ [`value`]: '185',[`label`]: '6′1″' }), ({ [`value`]: '188',[`label`]: '6′2″' }), ({ [`value`]: '191',[`label`]: '6′3″' }), ({ [`value`]: '193',[`label`]: '6′4″' }), ({ [`value`]: '195',[`label`]: '6′5″' }), ({ [`value`]: '198',[`label`]: '6′6″' }), ({ [`value`]: '201',[`label`]: '6′7″' }), ({ [`value`]: '203',[`label`]: '6′8″' }), ({ [`value`]: '206',[`label`]: '6′9″' }), ({ [`value`]: '208',[`label`]: '6′10″' }), ({ [`value`]: '211',[`label`]: '6′11″' }), ({ [`value`]: '213',[`label`]: '7′0″' })];
    } else {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '122 cm' }), ({ [`value`]: '124',[`label`]: '124 cm' }), ({ [`value`]: '127',[`label`]: '127 cm' }), ({ [`value`]: '130',[`label`]: '130 cm' }), ({ [`value`]: '132',[`label`]: '132 cm' }), ({ [`value`]: '135',[`label`]: '135 cm' }), ({ [`value`]: '137',[`label`]: '137 cm' }), ({ [`value`]: '140',[`label`]: '140 cm' }), ({ [`value`]: '142',[`label`]: '142 cm' }), ({ [`value`]: '145',[`label`]: '145 cm' }), ({ [`value`]: '152',[`label`]: '152 cm' }), ({ [`value`]: '155',[`label`]: '155 cm' }), ({ [`value`]: '157',[`label`]: '157 cm' }), ({ [`value`]: '160',[`label`]: '160 cm' }), ({ [`value`]: '163',[`label`]: '163 cm' }), ({ [`value`]: '165',[`label`]: '165 cm' }), ({ [`value`]: '168',[`label`]: '168 cm' }), ({ [`value`]: '170',[`label`]: '170 cm' }), ({ [`value`]: '173',[`label`]: '173 cm' }), ({ [`value`]: '176',[`label`]: '176 cm' }), ({ [`value`]: '178',[`label`]: '178 cm' }), ({ [`value`]: '180',[`label`]: '180 cm' }), ({ [`value`]: '183',[`label`]: '183 cm' }), ({ [`value`]: '185',[`label`]: '185 cm' }), ({ [`value`]: '188',[`label`]: '188 cm' }), ({ [`value`]: '191',[`label`]: '191 cm' }), ({ [`value`]: '193',[`label`]: '193 cm' }), ({ [`value`]: '195',[`label`]: '195 cm' }), ({ [`value`]: '198',[`label`]: '198 cm' }), ({ [`value`]: '201',[`label`]: '201 cm' }), ({ [`value`]: '203',[`label`]: '203 cm' }), ({ [`value`]: '206',[`label`]: '206 cm' }), ({ [`value`]: '208',[`label`]: '208 cm' }), ({ [`value`]: '211',[`label`]: '211 cm' }), ({ [`value`]: '213',[`label`]: '213 cm' })];
    }
  } else {
    ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″ (122 cm)' }), ({ [`value`]: '124',[`label`]: '4′1″ (124 cm)' }), ({ [`value`]: '127',[`label`]: '4′2″ (127 cm)' }), ({ [`value`]: '130',[`label`]: '4′3″ (130 cm)' }), ({ [`value`]: '132',[`label`]: '4′4″ (132 cm)' }), ({ [`value`]: '135',[`label`]: '4′5″ (135 cm)' }), ({ [`value`]: '137',[`label`]: '4′6″ (137 cm)' }), ({ [`value`]: '140',[`label`]: '4′7″ (140 cm)' }), ({ [`value`]: '142',[`label`]: '4′8″ (142 cm)' }), ({ [`value`]: '145',[`label`]: '4′9″ (145 cm)' }), ({ [`value`]: '152',[`label`]: '5′0″ (152 cm)' }), ({ [`value`]: '155',[`label`]: '5′1″ (155 cm)' }), ({ [`value`]: '157',[`label`]: '5′2″ (157 cm)' }), ({ [`value`]: '160',[`label`]: '5′3″ (160 cm)' }), ({ [`value`]: '163',[`label`]: '5′4″ (163 cm)' }), ({ [`value`]: '165',[`label`]: '5′5″ (165 cm)' }), ({ [`value`]: '168',[`label`]: '5′6″ (168 cm)' }), ({ [`value`]: '170',[`label`]: '5′7″ (170 cm)' }), ({ [`value`]: '173',[`label`]: '5′8″ (173 cm)' }), ({ [`value`]: '176',[`label`]: '5′9″ (176 cm)' }), ({ [`value`]: '178',[`label`]: '5′10″ (178 cm)' }), ({ [`value`]: '180',[`label`]: '5′11″ (180 cm)' }), ({ [`value`]: '183',[`label`]: '6′0″ (183 cm)' }), ({ [`value`]: '185',[`label`]: '6′1″ (185 cm)' }), ({ [`value`]: '188',[`label`]: '6′2″ (188 cm)' }), ({ [`value`]: '191',[`label`]: '6′3″ (191 cm)' }), ({ [`value`]: '193',[`label`]: '6′4″ (193 cm)' }), ({ [`value`]: '195',[`label`]: '6′5″ (195 cm)' }), ({ [`value`]: '198',[`label`]: '6′6″ (198 cm)' }), ({ [`value`]: '201',[`label`]: '6′7″ (201 cm)' }), ({ [`value`]: '203',[`label`]: '6′8″ (203 cm)' }), ({ [`value`]: '206',[`label`]: '6′9″ (206 cm)' }), ({ [`value`]: '208',[`label`]: '6′10″ (208 cm)' }), ({ [`value`]: '211',[`label`]: '6′11″ (211 cm)' }), ({ [`value`]: '213',[`label`]: '7′0″ (213 cm)' })];
  }
  ___arguments.context.pageData['heightValue'] = (subsequenceFromStartLast(String(getObjectProperty(___arguments.context.pageData, 'height')), 1));
  if (getObjectProperty(___arguments.context.pageData, 'height')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3968029d13271427744c4ff2c65259ce'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3555fd47b081b0a63af89443d6e87df1'))['checked'] = false;
    if ((getObjectProperty(___arguments.context.pageData, 'height')) < 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee'))['value'] = 1;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('916764cf81f7f4dd39add13dbd65fa7a'))['label'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'heightList')), async (item) => {
         if ((getObjectProperty(___arguments.context.pageData, 'heightValue')) == (getObjectProperty(item, 'value'))) {
          return item;
        }


       return ;
      }))[0]), 'label'));
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee'))['value'] = 2;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('916764cf81f7f4dd39add13dbd65fa7a'))['value'] = (getObjectProperty(___arguments.context.pageData, 'height'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('916764cf81f7f4dd39add13dbd65fa7a'))['label'] = (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'heightList')), async (item) => {
         if (String(getObjectProperty(___arguments.context.pageData, 'height')) == (getObjectProperty(item, 'value'))) {
          return item;
        }


       return ;
      }))[0]), 'label'));
    }
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3968029d13271427744c4ff2c65259ce'))['opacity'] = 0.35;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3555fd47b081b0a63af89443d6e87df1'))['checked'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee'))['value'] = 1;
  }

  },
  /* handler:onMounted */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var heightInch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3555fd47b081b0a63af89443d6e87df1'))['checked'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3968029d13271427744c4ff2c65259ce'))['opacity'] = 1;
  if (!(getObjectProperty(___arguments.context.pageData, 'height'))) {
    ___arguments.context.pageData['height'] = 178;
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 1) {
    heightInch = String('-') + String(getObjectProperty(___arguments.context.pageData, 'height'));
    ___arguments.context.pageData['heightData'] = (heightInch * 1);
    delete ___arguments.context.pageData['heightDataTaller'];
    ___arguments.context.pageData['heightDataSmaller'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
  } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('099f6d62c7fa590a6c84794cfedbedee')), 'value')) == 2) {
    ___arguments.context.pageData['heightData'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
    delete ___arguments.context.pageData['heightDataSmaller'];
    ___arguments.context.pageData['heightDataTaller'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/2739255c3294cbcd736ad4e93cc34e37/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b3e614a80d460e6d53dff501d99a944c')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/32ea180c6a5ae4a779c8ab7f61dcc468/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('154c2d9cecf2f3329ede16c380b4b25c')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* handler:onMounted */
  onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'gender')) && (getObjectProperty(___arguments.context.pageData, 'gender')).length > 0) {
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2a6cc267ff1834d4e052611c72f1f1d9'))['checked'] = false;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7bedbfcd637446769de998b874a864df'))['opacity'] = 1;
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('2a6cc267ff1834d4e052611c72f1f1d9'))['checked'] = true;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('7bedbfcd637446769de998b874a864df'))['opacity'] = 0.35;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/3b247f9d2a7fc2fd9c8b60bdd2ed4f78/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7a42c80c904bf6ac90af7395f36a13bd')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/2fb2638ea9dd85c58f2ff656099d8bbd/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('01ff5d27eecb1b6bd8ae2d75c1f6b533')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/08ae6616b3fbc2c2fa1e55e68bf87d1d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('1b2da0410ad31cde372b34bf8a79cd34'))['checked'] = false;
  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('aaf75cf59e3d3946f266b87128b96f79'))['opacity'] = 1;
  if ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('08ae6616b3fbc2c2fa1e55e68bf87d1d')) {
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('08ae6616b3fbc2c2fa1e55e68bf87d1d')).slice(-1)[0] != 'activity-page__children-item-active') {
      addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('08ae6616b3fbc2c2fa1e55e68bf87d1d')), 'activity-page__children-item-active');
      ___arguments.context.pageData['children'] = (getObjectProperty(___arguments.context.dataModel, 'value'));
      ___arguments.context.pageData['childrenCheckbox'] = false;
    } else {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('08ae6616b3fbc2c2fa1e55e68bf87d1d')).pop();
      ___arguments.context.pageData['children'] = null;
      ___arguments.context.pageData['childrenCheckbox'] = true;
    }
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'children')) {
    if ((getObjectProperty(___arguments.context.pageData, 'children')) == (getObjectProperty(___arguments.context.dataModel, 'value'))) {
      return ['activity-page__children-item-active', 'activity-page__children-item'];
    }
  }

  return ['activity-page__children-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/1b2da0410ad31cde372b34bf8a79cd34/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aaf75cf59e3d3946f266b87128b96f79'))['opacity'] = 0.35;
    ___arguments.context.pageData['childrenCheckbox'] = true;
    delete ___arguments.context.pageData['children'];
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aaf75cf59e3d3946f266b87128b96f79'))['opacity'] = 1;
    delete ___arguments.context.pageData['childrenCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/257f10ba826c753a3298a6bbc581e34e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('257f10ba826c753a3298a6bbc581e34e')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('257f10ba826c753a3298a6bbc581e34e')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('63128916ea5fc73ffbda973a6a2c06de')), 'activity-page__preference-block--open');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('257f10ba826c753a3298a6bbc581e34e')).pop();
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('63128916ea5fc73ffbda973a6a2c06de')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/63128916ea5fc73ffbda973a6a2c06de/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('257f10ba826c753a3298a6bbc581e34e')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/aaf75cf59e3d3946f266b87128b96f79/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['childrenList'] = [({ 'name': 'None','icon': '/images/speaker-low-volume.svg','value': -1 }), ({ 'name': '1','icon': '/images/performing-arts.svg','value': 1 }), ({ 'name': '2','icon': '/images/light-bulb.svg','value': 2 }), ({ 'name': 'More than 2','icon': '/images/person-standing.svg','value': 3 })];
  if (getObjectProperty(___arguments.context.pageData, 'children')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aaf75cf59e3d3946f266b87128b96f79'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b2da0410ad31cde372b34bf8a79cd34'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aaf75cf59e3d3946f266b87128b96f79'))['opacity'] = 0.35;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b2da0410ad31cde372b34bf8a79cd34'))['checked'] = true;
  }

  },
  /* handler:onMounted */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b2da0410ad31cde372b34bf8a79cd34')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b2da0410ad31cde372b34bf8a79cd34'))['checked'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aaf75cf59e3d3946f266b87128b96f79'))['opacity'] = 1;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1b2da0410ad31cde372b34bf8a79cd34')), 'checked')) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content', 'no-padding'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'no-padding']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/c8b8daaaf171e9487593ed89d3a659a5/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('c8b8daaaf171e9487593ed89d3a659a5', (getObjectProperty(___arguments.context.appData, 'ethnicityList')));
  if ((getObjectProperty(___arguments.context.pageData, 'ethnicity')) && (getObjectProperty(___arguments.context.pageData, 'ethnicity')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0ff23ad657c7645890228e55d595e6ac'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('77184e2e4c110404ae687b2df0d64a11'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('77184e2e4c110404ae687b2df0d64a11'))['checked'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0ff23ad657c7645890228e55d595e6ac'))['opacity'] = 0.35;
    ___arguments.context.pageData['ethnicityId'] = [];
    ___arguments.context.pageData['ethnicity'] = [];
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/9cc5c80e40789217ded4f8cf9d04bbf1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('77184e2e4c110404ae687b2df0d64a11'))['checked'] = false;
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0ff23ad657c7645890228e55d595e6ac'))['opacity'] = 1;
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('9cc5c80e40789217ded4f8cf9d04bbf1')).slice(-1)[0] != 'activity-page__ethnicity-item-active') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('9cc5c80e40789217ded4f8cf9d04bbf1')), 'activity-page__ethnicity-item-active');
    addItemToList((getObjectProperty(___arguments.context.pageData, 'ethnicity')), (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'ethnicityId')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('9cc5c80e40789217ded4f8cf9d04bbf1')).pop();
    (getObjectProperty(___arguments.context.pageData, 'ethnicity')).splice((((getObjectProperty(___arguments.context.pageData, 'ethnicity')).indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'ethnicityId')).splice((((getObjectProperty(___arguments.context.pageData, 'ethnicityId')).indexOf(getObjectProperty(___arguments.context.dataModel, 'id')) + 1) - 1), 1);
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'ethnicity')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ethnicity')), async (item) => {


     return (item == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__ethnicity-item', 'activity-page__ethnicity-item-active'];
    }
  }

  return ['activity-page__ethnicity-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/44cf228830ac169a64ca709b2f8dfb2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('44cf228830ac169a64ca709b2f8dfb2a')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('44cf228830ac169a64ca709b2f8dfb2a')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1702912c68e65a2d189e7054b57fab4d')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('44cf228830ac169a64ca709b2f8dfb2a')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('44cf228830ac169a64ca709b2f8dfb2a')).pop();
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1702912c68e65a2d189e7054b57fab4d')).pop();
    }
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/1702912c68e65a2d189e7054b57fab4d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('44cf228830ac169a64ca709b2f8dfb2a')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/77184e2e4c110404ae687b2df0d64a11/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0ff23ad657c7645890228e55d595e6ac'))['opacity'] = 0.35;
    ___arguments.context.pageData['ethnicityCheckbox'] = true;
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0ff23ad657c7645890228e55d595e6ac'))['opacity'] = 1;
    delete ___arguments.context.pageData['ethnicityCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/0ff23ad657c7645890228e55d595e6ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0ff23ad657c7645890228e55d595e6ac'))['opacity'] = 1;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/056562276a6ba641b7d9d93b26f636e2/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('056562276a6ba641b7d9d93b26f636e2', (___arguments.context.appData['religionList']));
  if ((___arguments.context.pageData['religionList']) && (___arguments.context.pageData['religionList']).length > 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('ad13146e886e6991937f9bc6457215a4'))['opacity'] = 1;
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5569bcccad7e98e6a303efafec272639'))['checked'] = false;
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5569bcccad7e98e6a303efafec272639'))['checked'] = true;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('ad13146e886e6991937f9bc6457215a4'))['opacity'] = 0.35;
    ___arguments.context.pageData['religionId'] = [];
    ___arguments.context.pageData['religionList'] = [];
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/4edf578e1a8429bd0d2303718a765383/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4edf578e1a8429bd0d2303718a765383')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4edf578e1a8429bd0d2303718a765383')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3226938924b750a16b662aae01760714')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4edf578e1a8429bd0d2303718a765383')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4edf578e1a8429bd0d2303718a765383')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3226938924b750a16b662aae01760714')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/3226938924b750a16b662aae01760714/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4edf578e1a8429bd0d2303718a765383')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/5569bcccad7e98e6a303efafec272639/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('ad13146e886e6991937f9bc6457215a4'))['opacity'] = 0.35;
    ___arguments.context.pageData['religionCheckbox'] = true;
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('ad13146e886e6991937f9bc6457215a4'))['opacity'] = 1;
    delete ___arguments.context.pageData['religionCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/9381cb3b05f5d0f23ffa05ff8ff13b1d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var religionList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('5569bcccad7e98e6a303efafec272639'))['checked'] = false;
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('ad13146e886e6991937f9bc6457215a4'))['opacity'] = 1;
  religionList = (getObjectProperty(___arguments.context.pageData, 'religionList'));
  if (___arguments.value == true) {
    addItemToList(religionList, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bace9fd87deec01982ef9c1a5d9b4f27'), 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'religionId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bace9fd87deec01982ef9c1a5d9b4f27'), 'id')));
  } else {
    religionList.splice(((religionList.indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bace9fd87deec01982ef9c1a5d9b4f27'), 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'religionId')).splice((((getObjectProperty(___arguments.context.pageData, 'religionId')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('bace9fd87deec01982ef9c1a5d9b4f27'), 'id')) + 1) - 1), 1);
  }
  ___arguments.context.pageData['religion'] = religionList;
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'religionList'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (j == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('bace9fd87deec01982ef9c1a5d9b4f27'), 'objectId'))) {
      return true;
    }
  }

  return false

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/91acd28a95fd2a45097e9be678328d64/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('91acd28a95fd2a45097e9be678328d64', (___arguments.context.appData['orientationList']));
  if ((___arguments.context.pageData['sexualidentity']) && (___arguments.context.pageData['sexualidentity']).length > 0) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b0afb904e96fdc0b663f1b29d27be277'))['opacity'] = 1;
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('48ecf171f40c1a08d693bf55ea08e5b2'))['checked'] = false;
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('48ecf171f40c1a08d693bf55ea08e5b2'))['checked'] = true;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b0afb904e96fdc0b663f1b29d27be277'))['opacity'] = 0.35;
    ___arguments.context.pageData['sexualidentityId'] = [];
    ___arguments.context.pageData['sexualidentity'] = [];
  }

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/2e8fb54cea7223b5a866a1bf3a0331ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('48ecf171f40c1a08d693bf55ea08e5b2'))['checked'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b0afb904e96fdc0b663f1b29d27be277'))['opacity'] = 1;
  delete ___arguments.context.pageData['sexualidentityCheckbox'];
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e8fb54cea7223b5a866a1bf3a0331ee')).slice(-1)[0] != 'activity-page__sexualidentify-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e8fb54cea7223b5a866a1bf3a0331ee')), 'activity-page__sexualidentify-item-active');
    addItemToList((getObjectProperty(___arguments.context.pageData, 'sexualidentity')), (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'sexualidentityId')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e8fb54cea7223b5a866a1bf3a0331ee')).pop();
    (getObjectProperty(___arguments.context.pageData, 'sexualidentity')).splice((((getObjectProperty(___arguments.context.pageData, 'sexualidentity')).indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'sexualidentityId')).splice((((getObjectProperty(___arguments.context.pageData, 'sexualidentityId')).indexOf(getObjectProperty(___arguments.context.dataModel, 'id')) + 1) - 1), 1);
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'sexualidentity')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'sexualidentity')), async (item) => {


     return (item == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__sexualidentify-item', 'activity-page__sexualidentify-item-active'];
    }
  }

  return ['activity-page__sexualidentify-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/48ecf171f40c1a08d693bf55ea08e5b2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b0afb904e96fdc0b663f1b29d27be277'))['opacity'] = 0.35;
    ___arguments.context.pageData['sexualidentityCheckbox'] = true;
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('b0afb904e96fdc0b663f1b29d27be277'))['opacity'] = 1;
    delete ___arguments.context.pageData['sexualidentityCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/cec8d79b4a7b7cc610ee323ae56b0b79/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('cec8d79b4a7b7cc610ee323ae56b0b79', (getObjectProperty(___arguments.context.appData, 'educationList')));
  if ((getObjectProperty(___arguments.context.pageData, 'educationList')) && (getObjectProperty(___arguments.context.pageData, 'educationList')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2fdfd188b13739bf0b4f69bfc7c7215a'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3b3a367edfd7fade1f71589f45d38faa'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3b3a367edfd7fade1f71589f45d38faa'))['checked'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('2fdfd188b13739bf0b4f69bfc7c7215a'))['opacity'] = 0.35;
    ___arguments.context.pageData['educationId'] = [];
    ___arguments.context.pageData['educationList'] = [];
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/f5241da2206cfd49064bf2a68ff2bde1/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var educationList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3b3a367edfd7fade1f71589f45d38faa'))['checked'] = false;
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2fdfd188b13739bf0b4f69bfc7c7215a'))['opacity'] = 1;
  educationList = (getObjectProperty(___arguments.context.pageData, 'educationList'));
  if (___arguments.value == true) {
    addItemToList(educationList, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab463bd119e6791af3e9acf782d9018'), 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'educationId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab463bd119e6791af3e9acf782d9018'), 'id')));
  } else {
    educationList.splice(((educationList.indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab463bd119e6791af3e9acf782d9018'), 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'educationId')).splice((((getObjectProperty(___arguments.context.pageData, 'educationId')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab463bd119e6791af3e9acf782d9018'), 'id')) + 1) - 1), 1);
  }
  ___arguments.context.pageData['education'] = educationList;
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'educationList'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (j == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('9ab463bd119e6791af3e9acf782d9018'), 'objectId'))) {
      return true;
    }
  }

  return false

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/3b3a367edfd7fade1f71589f45d38faa/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2fdfd188b13739bf0b4f69bfc7c7215a'))['opacity'] = 0.35;
    ___arguments.context.pageData['educationCheckbox'] = true;
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('2fdfd188b13739bf0b4f69bfc7c7215a'))['opacity'] = 1;
    delete ___arguments.context.pageData['educationCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/101cf71e4f732ba34722c242a247c11c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('101cf71e4f732ba34722c242a247c11c')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('101cf71e4f732ba34722c242a247c11c')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('dbaa0cdc43d8770617cb3d9dd6860848')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('101cf71e4f732ba34722c242a247c11c')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('101cf71e4f732ba34722c242a247c11c')).pop();
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('dbaa0cdc43d8770617cb3d9dd6860848')).pop();
    }
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/ccf5a51a38310b0eac6e3f69f6c38a9b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('ccf5a51a38310b0eac6e3f69f6c38a9b')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('ccf5a51a38310b0eac6e3f69f6c38a9b')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('01c86276bea9962206e93fd5362be709')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('ccf5a51a38310b0eac6e3f69f6c38a9b')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('ccf5a51a38310b0eac6e3f69f6c38a9b')).pop();
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('01c86276bea9962206e93fd5362be709')).pop();
    }
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/dbaa0cdc43d8770617cb3d9dd6860848/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('101cf71e4f732ba34722c242a247c11c')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/01c86276bea9962206e93fd5362be709/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ccf5a51a38310b0eac6e3f69f6c38a9b')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/fea3344714ac538206cae19bad14436f/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('fea3344714ac538206cae19bad14436f', (getObjectProperty(___arguments.context.appData, 'bodyTypeList')));
  if ((getObjectProperty(___arguments.context.pageData, 'bodyType')) && (getObjectProperty(___arguments.context.pageData, 'bodyType')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fc37a0d71fb3b86c3e272103af14983c'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a2848326d7acff1c13e344447f347ee'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a2848326d7acff1c13e344447f347ee'))['checked'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fc37a0d71fb3b86c3e272103af14983c'))['opacity'] = 0.35;
    ___arguments.context.pageData['bodyType'] = [];
    ___arguments.context.pageData['bodyTypeObjects'] = [];
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/dce830ca3a88303e19dfa586e4daf24f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a2848326d7acff1c13e344447f347ee'))['checked'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fc37a0d71fb3b86c3e272103af14983c'))['opacity'] = 1;
  delete ___arguments.context.pageData['bodyTypeCheckbox'];
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dce830ca3a88303e19dfa586e4daf24f')).slice(-1)[0] != 'activity-page__sexualidentify-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dce830ca3a88303e19dfa586e4daf24f')), 'activity-page__sexualidentify-item-active');
    addItemToList((getObjectProperty(___arguments.context.pageData, 'bodyType')), (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'bodyTypeObjects')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dce830ca3a88303e19dfa586e4daf24f')).pop();
    (getObjectProperty(___arguments.context.pageData, 'bodyType')).splice((((getObjectProperty(___arguments.context.pageData, 'bodyType')).indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'bodyTypeObjects')).splice((((getObjectProperty(___arguments.context.pageData, 'bodyTypeObjects')).indexOf(getObjectProperty(___arguments.context.dataModel, 'id')) + 1) - 1), 1);
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'bodyType')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'bodyType')), async (item) => {


     return (item == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__sexualidentify-item', 'activity-page__sexualidentify-item-active'];
    }
  }

  return ['activity-page__sexualidentify-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/5a2848326d7acff1c13e344447f347ee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fc37a0d71fb3b86c3e272103af14983c'))['opacity'] = 0.35;
    ___arguments.context.pageData['bodyTypeCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('fc37a0d71fb3b86c3e272103af14983c'))['opacity'] = 1;
    delete ___arguments.context.pageData['bodyTypeCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/f65a554984b932dda54c80e2bf5930d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a185ddfe58ba99afb024fb78342f7c66')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/a185ddfe58ba99afb024fb78342f7c66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a185ddfe58ba99afb024fb78342f7c66')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a185ddfe58ba99afb024fb78342f7c66')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f65a554984b932dda54c80e2bf5930d8')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a185ddfe58ba99afb024fb78342f7c66')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a185ddfe58ba99afb024fb78342f7c66')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f65a554984b932dda54c80e2bf5930d8')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/ff6f3bae11f928310d2a7c03f696e7f7/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('ff6f3bae11f928310d2a7c03f696e7f7', (getObjectProperty(___arguments.context.appData, 'politicalList')));
  if ((getObjectProperty(___arguments.context.pageData, 'politicalViewList')) && (getObjectProperty(___arguments.context.pageData, 'politicalViewList')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0327e7eb880b69e2ac1201dea2f9144e'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8a4fe32b992a68dd7f7cbc17dd9e8caf'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8a4fe32b992a68dd7f7cbc17dd9e8caf'))['checked'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0327e7eb880b69e2ac1201dea2f9144e'))['opacity'] = 0.35;
    ___arguments.context.pageData['politicalViewId'] = [];
    ___arguments.context.pageData['politicalViewList'] = [];
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/063983d2c32f34a2cb5351b36db4112e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var politicalViewList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('8a4fe32b992a68dd7f7cbc17dd9e8caf'))['checked'] = false;
  ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('0327e7eb880b69e2ac1201dea2f9144e'))['opacity'] = 1;
  politicalViewList = (getObjectProperty(___arguments.context.pageData, 'politicalViewList'));
  if (___arguments.value == true) {
    addItemToList(politicalViewList, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a44bd829956e50d59eec6f553ef6cc98'), 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'politicalViewId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a44bd829956e50d59eec6f553ef6cc98'), 'id')));
  } else {
    (getObjectProperty(___arguments.context.pageData, 'politicalViewList')).splice(((politicalViewList.indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a44bd829956e50d59eec6f553ef6cc98'), 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'politicalViewId')).splice((((getObjectProperty(___arguments.context.pageData, 'politicalViewId')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a44bd829956e50d59eec6f553ef6cc98'), 'id')) + 1) - 1), 1);
  }
  ___arguments.context.pageData['politicalView'] = politicalViewList;
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'politicalViewList'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (j == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a44bd829956e50d59eec6f553ef6cc98'), 'objectId'))) {
      return true;
    }
  }

  return false

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/7e0cc411f6e853a5d87d5501f9f2ce48/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('7e0cc411f6e853a5d87d5501f9f2ce48', (getObjectProperty(___arguments.context.appData, 'hairColorList')));
  if ((getObjectProperty(___arguments.context.pageData, 'hairColor')) && (getObjectProperty(___arguments.context.pageData, 'hairColor')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa277a56a46c2dd6d58ee444a323f6d3'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5796d43ad80dcd779bc99e483357a9b6'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa277a56a46c2dd6d58ee444a323f6d3'))['opacity'] = 0.35;
    ___arguments.context.pageData['hairColor'] = [];
    ___arguments.context.pageData['hairColorId'] = [];
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/be04f0299fa4ce5a9daa9e8ea503169c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5796d43ad80dcd779bc99e483357a9b6'))['checked'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa277a56a46c2dd6d58ee444a323f6d3'))['opacity'] = 1;
  delete ___arguments.context.pageData['hairColorCheckbox'];
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('be04f0299fa4ce5a9daa9e8ea503169c')).slice(-1)[0] != 'activity-page__sexualidentify-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('be04f0299fa4ce5a9daa9e8ea503169c')), 'activity-page__sexualidentify-item-active');
    addItemToList((getObjectProperty(___arguments.context.pageData, 'hairColor')), (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'hairColorId')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('be04f0299fa4ce5a9daa9e8ea503169c')).pop();
    (getObjectProperty(___arguments.context.pageData, 'hairColor')).splice((((getObjectProperty(___arguments.context.pageData, 'hairColor')).indexOf(getObjectProperty(___arguments.context.dataModel, 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'hairColorId')).splice((((getObjectProperty(___arguments.context.pageData, 'hairColorId')).indexOf(getObjectProperty(___arguments.context.dataModel, 'id')) + 1) - 1), 1);
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'hairColor')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'hairColor')), async (item) => {


     return (item == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__sexualidentify-item', 'activity-page__sexualidentify-item-active'];
    }
  }

  return ['activity-page__sexualidentify-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/8a4fe32b992a68dd7f7cbc17dd9e8caf/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0327e7eb880b69e2ac1201dea2f9144e'))['opacity'] = 0.35;
    ___arguments.context.pageData['politicalViewCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0327e7eb880b69e2ac1201dea2f9144e'))['opacity'] = 1;
    delete ___arguments.context.pageData['politicalViewCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/5796d43ad80dcd779bc99e483357a9b6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa277a56a46c2dd6d58ee444a323f6d3'))['opacity'] = 0.35;
    ___arguments.context.pageData['hairColorCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa277a56a46c2dd6d58ee444a323f6d3'))['opacity'] = 1;
    delete ___arguments.context.pageData['hairColorCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/dfcca17532f9cfc9f3b899752147fd33/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfcca17532f9cfc9f3b899752147fd33')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfcca17532f9cfc9f3b899752147fd33')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d735be07330276b84889336e89faf28b')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfcca17532f9cfc9f3b899752147fd33')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfcca17532f9cfc9f3b899752147fd33')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d735be07330276b84889336e89faf28b')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/7b9659617ba87e4f9a61858643a9067a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b9659617ba87e4f9a61858643a9067a')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b9659617ba87e4f9a61858643a9067a')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2531586347e27164a36de624a70d19f4')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b9659617ba87e4f9a61858643a9067a')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b9659617ba87e4f9a61858643a9067a')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2531586347e27164a36de624a70d19f4')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/d735be07330276b84889336e89faf28b/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dfcca17532f9cfc9f3b899752147fd33')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/2531586347e27164a36de624a70d19f4/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b9659617ba87e4f9a61858643a9067a')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/c575e2a322d64426385b47345c1e54c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 992) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e696f82bb6654778927bf94873775fae')).slice(-1)[0] == 'activity-page__create--active') {
      (function () { window.history.back(); })();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')).slice(-1)[0] == 'activity-page__create--active') {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1a6b799dbdce136509f443e500f2a2dd')).slice(-1)[0] != 'activity-page__sidebar-bg') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1a6b799dbdce136509f443e500f2a2dd')), 'activity-page__sidebar-bg');
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2bf7b5487267cff2e39f7f5615ea2403', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('cf930c9a35b4b0e3122514e4cc2f4194', false);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')).pop();
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e696f82bb6654778927bf94873775fae')), 'activity-page__create--active');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('01bd024ca25a52e99fa6ae27faadccf3', false);
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')).pop();
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')), 'activity-page__create--active');
      ___arguments.context.pageData['stepCount'] = '1/8';
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c8c205db2edad4464b2b0d38d3eb3ef9')).slice(-1)[0] == 'activity-page__step--active') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c8c205db2edad4464b2b0d38d3eb3ef9')).pop();
      }
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')).pop();
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')), 'activity-page__create--active');
      ___arguments.context.pageData['stepCount'] = '2/8';
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e5e87712460b037c97c88efa80af4c15')).slice(-1)[0] == 'activity-page__step--active') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e5e87712460b037c97c88efa80af4c15')).pop();
      }
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f346419c73ff1eb8a5acad1230938847')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f346419c73ff1eb8a5acad1230938847')).pop();
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')), 'activity-page__create--active');
      ___arguments.context.pageData['stepCount'] = '3/8';
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b764867e67e2be968a2d1b17859f4f52')).slice(-1)[0] == 'activity-page__step--active') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b764867e67e2be968a2d1b17859f4f52')).pop();
      }
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')).pop();
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f346419c73ff1eb8a5acad1230938847')), 'activity-page__create--active');
      ___arguments.context.pageData['stepCount'] = '4/8';
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8d79d9720bd8381b992fa31f951af657')).slice(-1)[0] == 'activity-page__step--active') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8d79d9720bd8381b992fa31f951af657')).pop();
      }
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')).pop();
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')), 'activity-page__create--active');
      ___arguments.context.pageData['stepCount'] = '5/8';
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28adb8a27246f4833b4724f298c46c1f')).slice(-1)[0] == 'activity-page__step--active') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28adb8a27246f4833b4724f298c46c1f')).pop();
      }
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a')).pop();
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')), 'activity-page__create--active');
      ___arguments.context.pageData['stepCount'] = '6/8';
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('17f1266dfb5c067766544ac91f23c797')).slice(-1)[0] == 'activity-page__step--active') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('17f1266dfb5c067766544ac91f23c797')).pop();
      }
      if (!(getObjectProperty(___arguments.context.pageData, 'financialRoleTrue'))) {
        if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a')).slice(-1)[0] == 'activity-page__create--active') {
          ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a')).pop();
        }
        if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')).slice(-1)[0] == 'activity-page__create--active') {
          ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')).pop();
        }
        if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')).slice(-1)[0] == 'activity-page__create--active') {
          addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')), 'activity-page__create--active');
        }
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')), 'activity-page__create--active');
        ___arguments.context.pageData['stepCount'] = '5/8';
        if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('17f1266dfb5c067766544ac91f23c797')).slice(-1)[0] == 'activity-page__step--active') {
          ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('17f1266dfb5c067766544ac91f23c797')).pop();
        }
        if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28adb8a27246f4833b4724f298c46c1f')).slice(-1)[0] == 'activity-page__step--active') {
          ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28adb8a27246f4833b4724f298c46c1f')).pop();
        }
      } else {
        if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')).slice(-1)[0] != 'activity-page__create--active') {
          addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')), 'activity-page__create--active');
        }
        ___arguments.context.pageData['stepCount'] = '6/8';
        if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('17f1266dfb5c067766544ac91f23c797')).slice(-1)[0] == 'activity-page__step--active') {
          ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('17f1266dfb5c067766544ac91f23c797')).pop();
        }
      }
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2894dfb56f3475328becafc550390aa5')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2894dfb56f3475328becafc550390aa5')).pop();
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a')), 'activity-page__create--active');
      ___arguments.context.pageData['stepCount'] = '7/8';
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d74362cb5191d50acf435d28d2685ecd')).slice(-1)[0] == 'activity-page__step--active') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d74362cb5191d50acf435d28d2685ecd')).pop();
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927')) {
    if (___arguments.screenWidth <= 992) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927'))['buttonLabel'] = 'Upload media';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('741f6a07142fb5b99adb9223834cb927'))['buttonLabel'] = 'Drag and Drop or click to upload';
    }
  }

  },
  /* handler:onResize */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'Edit activity'

  },  
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
      ___arguments.context.pageData['toDelete'] = [];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/edit-activity-old/components/eb0cea7d2f89ede366b9b8124b0d45b6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')), 'activity-page__create--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')), 'activity-page__create--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')), 'activity-page__create--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f346419c73ff1eb8a5acad1230938847')), 'activity-page__create--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')), 'activity-page__create--active');
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dba15726d2fb76435cde99bc82444243')), 'activity-page__create--active');
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f346419c73ff1eb8a5acad1230938847')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f346419c73ff1eb8a5acad1230938847')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')).slice(-1)[0] == 'activity-page__create--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')).pop();
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/06318719601b71ddfcb1b2e4d514bb91/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['stepCount'] = 'Step 1/3';
  ___arguments.context.pageData['title'] = 'Edit Activity';
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b2e338bd032d96d9e1dc9235d43491eb')), 'activity-page__step--active');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9f84d2db9129d34b937b64065d386fb9')), 'activity-page__step--active');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5f7712198ecf36c821ac52d2ba657e6c')), 'activity-page__step--active');

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/5b71f085d15f357c3db17237257f88b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b71f085d15f357c3db17237257f88b4')).slice(-1)[0] == 'fa-chevron-left') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')), 'activity-page__create--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1bebea2881612e3b8917aee54dca676c')), 'activity-page__create--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')), 'activity-page__create--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f346419c73ff1eb8a5acad1230938847')), 'activity-page__create--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8969145a18dfd7cf6982d3287c9abc94')), 'activity-page__create--active');
    if (!(getObjectProperty(___arguments.context.pageData, 'financialRoleTrue'))) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a')).pop();
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b45a85cc462475129ac5857f1d051f3c')).pop();
    }
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e561a1da3fd68df7a55b9c48ebdce91a')).pop();
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2894dfb56f3475328becafc550390aa5')).pop();
    ___arguments.context.pageData['stepCount'] = '1/2';
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('761e572bb31e21c623b378f58f7b8ae2')).pop();
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4ca8f14e97a4f468a5ad4c4e99a6ae46')).pop();
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6aa3cd22564163e3c5484769b996f1e1')).pop();
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d03692cf3f4acb7dfe4e8215d5c8263d')).pop();
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b71f085d15f357c3db17237257f88b4')).pop();
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b71f085d15f357c3db17237257f88b4')), 'fa-times');
  } else if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b71f085d15f357c3db17237257f88b4')).slice(-1)[0] == 'fa-times') {
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/1d23abcb5cdd67d72ba37a3a2e284a68/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f'))['minDate'] = (new Date());
  if ((new Date((getObjectProperty(___arguments.context.pageData, 'specificInput')))) <= (new Date((new Date()).getTime() - (120 * 1000)))) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'alert-border');
    }
    ___arguments.context.pageData['minDateNotification'] = true;
  } else {
    ___arguments.context.pageData['minDateNotification'] = false;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).slice(-1)[0] == 'alert-border') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')).pop();
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/5d34836c20df0ed3e3654affc6b67d38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/d654959aaca58d61cb57e0c48b93b46b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activityId')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.pageData, 'activityId')) }));
  }
  if (getObjectProperty(___arguments.context.pageData, 'objectIdActivity')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.pageData, 'objectIdActivity')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/96458f2e443a813daae42bd7d2cce777/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/426bbf2730836624297d6346508e4a0f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    return (getObjectProperty(___arguments.context.pageData, 'name'));
  }

  return 'Activity name'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/c8b76238931c9f120f4f1dbd500b2505/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'category')) {
    return (getObjectProperty(___arguments.context.pageData, 'category'));
  }

  return 'Activity Category'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/abf6da177e88207f43980703aabc7d29/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'description')) {
    return (getObjectProperty(___arguments.context.pageData, 'description'));
  }

  return 'Activity description. Tell us about the details of your activity. Describe how you see the event happening.'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/9f6c3d91c7be48164bee02027ef1c534/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var date, day, month;



  return 'Date & Time'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/cf930c9a35b4b0e3122514e4cc2f4194/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['monthList'] = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  ___arguments.context.pageData['daysList'] = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/edit-activity-old/components/72abe4575c8d95624672d035e3d18d2a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'driver')) || (getObjectProperty(___arguments.context.pageData, 'passenger'))) {
    return 'Covers the expenses';
  } else if (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput')) {
    return 'Share the expenses';
  }

  return 'Financial “Roles”'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/594b9e3753547161e26e31b916d68155/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var result;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  try {
    result = (getObjectProperty((getObjectProperty(((getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/getGeoCode/inputAddress`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'inputAddress': JSON.stringify((getObjectProperty(___arguments.value, 'description'))) }).send()), 'results'))[0]), 'geometry')), 'location'));
    ___arguments.context.pageData['location'] = (getObjectProperty(___arguments.value, 'description'));
    if (result) {
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', (getObjectProperty(result, 'lat')), (getObjectProperty(result, 'lng')));
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('60e48ff23dac5a6752f5a3e7d7031b6e', (getObjectProperty(result, 'lat')), (getObjectProperty(result, 'lng')));
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('4df590d6dc3a54537dcf708f8de2676b', [result]);
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('60e48ff23dac5a6752f5a3e7d7031b6e', [result]);
      ___arguments.context.pageData['locationPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(result, 'lng'))).setY((getObjectProperty(result, 'lat'))));
    }

  } catch (error) {
    await new Promise(r => setTimeout(r, 1000 || 0));

  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('594b9e3753547161e26e31b916d68155')), 'el'))['maxLength'] = 60;

  },
  /* handler:onFocus */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var userLocation, lng, lat, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    userLocation = (await Backendless.Request.get(`${Backendless.appPath}/services/location/getUserLocationForActivity`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());

  } catch (error) {
    console.log(error);

  }
  if (userLocation && (getObjectProperty(userLocation, 'geopoint'))) {
    lng = (getObjectProperty((getObjectProperty(userLocation, 'geopoint')), 'coordinates'))[0];
    lat = (getObjectProperty((getObjectProperty(userLocation, 'geopoint')), 'coordinates')).slice(-1)[0];
    (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('594b9e3753547161e26e31b916d68155', undefined, undefined, undefined, undefined, undefined, undefined, undefined, ['establishment'], undefined, undefined, ((function (center, radius) { return { type: 'CircleLiteral', value: { center, radius } } })(((function (lat, lng) { return { type: 'LatLngLiteral', value: { lat, lng } } })(lat, lng)), (getObjectProperty(userLocation, 'radius')))), undefined);
  } else {
    (function (componentUid, bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region) { ___arguments.context.getComponentByUid(componentUid).placesPredictionsSettings = { bounds, componentRestrictions, location, offset, origin, radius, sessionToken, types, language, locationBias, locationRestriction, region } })('594b9e3753547161e26e31b916d68155', undefined, undefined, undefined, undefined, undefined, undefined, undefined, ['establishment'], undefined, undefined, undefined, undefined);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/d4a9c3e2f54970e2ab7669a3d7597dc8/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item, categoryListTableData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  if (getObjectProperty(___arguments.context.pageData, 'categoryListTableData')) {
    categoryListTableData = (getObjectProperty(___arguments.context.pageData, 'categoryListTableData'));
    return (await Promise.all(categoryListTableData.map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'name')),[`icon`]: (getObjectProperty(item, 'icon')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
    var category, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['activityCategory'] = ___arguments.value;
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('d4a9c3e2f54970e2ab7669a3d7597dc8')).slice(-1)[0] == 'alert-border') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('d4a9c3e2f54970e2ab7669a3d7597dc8')).pop();
  }
  ___arguments.context.pageData['activityCategoryAlertText'] = '';
  category = (await asyncListFilter((___arguments.context.pageData['categoryListTableData']), async (item) => {


   return ((___arguments.context.pageData['activityCategory']) == (item['objectId']));
  }))[0];
  ___arguments.context.pageData['filterCategory'] = category;
  ___arguments.context.pageData['category'] = (category['name']);
  ___arguments.context.pageData['iconCategory'] = (category['icon']);
  if (!(category['financialRoleRequired'])) {
    ___arguments.context.pageData['financialRoleRequired'] = false;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f77bc408eed2f32a47f271160008c9eb', false);
  } else {
    ___arguments.context.pageData['financialRoleRequired'] = true;
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f77bc408eed2f32a47f271160008c9eb', true);
  }

  },  
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activityCategory')) {
    return (getObjectProperty(___arguments.context.pageData, 'activityCategory'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/23bdc643dbd5b1578451528b83788579/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 768) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/de3a9a7b7ef73ad818d4f4c610a267e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('17f1266dfb5c067766544ac91f23c797')).pop();
  ___arguments.context.pageData['stepCount'] = 'Step 1/3';
  ___arguments.context.pageData['subtitle'] = 'Description';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb0cea7d2f89ede366b9b8124b0d45b6', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1bebea2881612e3b8917aee54dca676c', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('660b51459628682615d7c73f825c273e', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f346419c73ff1eb8a5acad1230938847', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d79f2bb365d14a49a78c9799b2dffb13', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8969145a18dfd7cf6982d3287c9abc94', false);
  if (getObjectProperty(___arguments.context.pageData, 'financialRoleRequired')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b45a85cc462475129ac5857f1d051f3c', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4cc43d921412e62604ce8121f83518c7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e561a1da3fd68df7a55b9c48ebdce91a', false);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a915ac93423faf18518809839f0bf768')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 768) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/741f6a07142fb5b99adb9223834cb927/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var item, error, j, deleteFiles, moderateResult;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function dragAndDrop() {
  await (async function(path, mediaList, media2) {
  	async function resizeFiles(files, width, percent) {
  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index]

  	    const fileName = file.name

  	    const content = await readFileAsDataURL(file)

  	    const img = await getNewImage(content)

  	    const elem = document.createElement('canvas')

  	    const widthImage = !width ? img.width : width
  	    const scaleFactor = width && width / img.width
  	    const heightImage = width ? img.height * scaleFactor : img.height

  	    elem.width = widthImage
  	    elem.height = heightImage

  	    const ctx = elem.getContext('2d')

  	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	    const blob = await getCanvasBlob(ctx.canvas, percent)

  	    const newFile = new File([blob], fileName, {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })

  	    files[index] = newFile
  	  }

  	  async function readFileAsDataURL(file) {
  	    const result = await new Promise((resolve) => {
  	      const fileReader = new FileReader()

  	      fileReader.onload = (e) => resolve(e.target.result)

  	      fileReader.readAsDataURL(file)
  	    })

  	    return result;
  	  }

  	  async function getNewImage(content) {
  	    const result = await new Promise((resolve) => {
  	      const img = new Image()

  	      img.src = content

  	      img.onload = () => resolve(img)
  	    })

  	    return result
  	  }

  	  async function getCanvasBlob(canvas, percent) {
  	    const result = await new Promise((resolve) => {
  	      canvas.toBlob((blob) => {
  	        resolve(blob)
  	      }, 'image/jpeg', percent)
  	    })

  	    return result
  	  }

  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.content__upload-button');
  	dropArea.removeEventListener('drop', dragAndDropFunc);

  	  dropArea.addEventListener("dragover", (event) => {
  	    event.preventDefault();
  	    dropArea.classList.add('active');
  	  });

  	  dropArea.addEventListener("dragleave", () => {
  	    dropArea.classList.remove('active');
  	  });


  	  function uploadFile(files) {
  	    files.forEach((file) => {
  	      if (file.type.includes('image')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	       .then(async function(fileURL) {
  	          let media = {
  	            file: fileURL.fileURL,
  	            isCover: false
  	          };
  	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', true);
  	          let moderationResult =  await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileURL.fileURL) }).send();
  	          if (moderationResult == 'OK') {
  	              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', false);
  	              mediaList.push(media);
  	              mediaList[0].isCover = true;
  	              media2 = mediaList;
  	           } else {
  	              Backendless.Files.remove(fileURL.fileURL);
  	              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', false);
  	              (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('66520f11f7bdb87eae4bab4675453905', ({ 'showRejectMsg': true }));
  	           };
  	        })
  	       .catch( function( error ) {
  	         console.log(error)
  	        })
  	      }
  	    })

  	    return mediaList;
  	  }

  	  dragAndDropFunc = function(event) {
  	    event.preventDefault();
  	    let files = event.dataTransfer.files;
  	    resizeFiles([...files], 700, 80);
  	    dropArea.classList.remove('active');
  	  }

  	  dropArea.addEventListener("drop", dragAndDropFunc);

  })((['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('')), (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')));
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', true);
  try {
    var j_list = ___arguments.uploadedFiles;
    for (var j_index in j_list) {
      j = j_list[j_index];
      moderateResult = (await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(j) }).send());
      if (moderateResult == 'KO') {
        (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('66520f11f7bdb87eae4bab4675453905', ({ [`showRejectMsg`]: true }));
        deleteFiles = true;
        break;
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', false);
    if (deleteFiles) {
      ;(async () => {
          var j_list2 = ___arguments.uploadedFiles;
        for (var j_index2 in j_list2) {
          j = j_list2[j_index2];
          await Backendless.Files.remove(encodePath(j));
        }

      })();
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');
      await dragAndDrop();
      return ;
    }

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', false);
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');
    return ;

  }
  addItemToList((getObjectProperty(___arguments.context.pageData, 'media')), (await Promise.all(___arguments.uploadedFiles.map(async item => {; return ({ [`file`]: item,[`isCover`]: false });}))));
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 4) {
    ___arguments.context.pageData['media'] = ((getObjectProperty(___arguments.context.pageData, 'media')).slice(0, 4));
  }
  ((getObjectProperty(___arguments.context.pageData, 'media'))[0])['isCover'] = true;
  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');
  await dragAndDrop();
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', false);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', false);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', true);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'media2')).length > 0) {
    ___arguments.context.pageData['activityImageAlertText'] = '';
  }

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  async ['onDirectoryAssignment'](___arguments) {
    var name2, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'name')) {
    name2 = (await asyncListFilter(((getObjectProperty(___arguments.context.pageData, 'name')).split('')), async (item) => {


     return (item != '\'' && item != '.');
    }));
    ___arguments.context.pageData['newName'] = (name2.join(''));
    return (['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/',(getObjectProperty(___arguments.context.pageData, 'newName')),'/'].join(''));
  } else {
    return (['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join(''));
  }

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([((new Date()).valueOf()),'_',(getObjectProperty(___arguments.file, 'name'))].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 4) {
    ___arguments.context.pageData['media'] = ((getObjectProperty(___arguments.context.pageData, 'media')).slice(0, 4));
  }
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 0) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', true);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 1) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', false);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 2) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', false);
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 3) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', true);
  }

  return ['content__upload-button activity-page__upload-button']

  },
  /* handler:onClassListAssignment */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
      return (await (async function(files, width, percent) {
	for (let index = 0; index < files.length; index++) {
	  const file = files[index]

	  const fileName = file.name

	  const content = await readFileAsDataURL(file)

	  const img = await getNewImage(content)

	  const elem = document.createElement('canvas')

	  const widthImage = !width ? img.width : width
	  const scaleFactor = width && width / img.width
	  const heightImage = width ? img.height * scaleFactor : img.height

	  elem.width = widthImage
	  elem.height = heightImage

	  const ctx = elem.getContext('2d')

	  ctx.drawImage(img, 0, 0, widthImage, heightImage)

	  const blob = await getCanvasBlob(ctx.canvas, percent)

	  const newFile = new File([blob], fileName, {
	    type: 'image/jpeg',
	    lastModified: Date.now()
	  })

	  files[index] = newFile
	}

	async function readFileAsDataURL(file) {
	  const result = await new Promise((resolve) => {
	    const fileReader = new FileReader()

	    fileReader.onload = (e) => resolve(e.target.result)

	    fileReader.readAsDataURL(file)
	  })

	  return result
	}

	async function getNewImage(content) {
	  const result = await new Promise((resolve) => {
	    const img = new Image()

	    img.src = content

	    img.onload = () => resolve(img)
	  })

	  return result
	}

	async function getCanvasBlob(canvas, percent) {
	  const result = await new Promise((resolve) => {
	    canvas.toBlob((blob) => {
	      resolve(blob)
	    }, 'image/jpeg', percent)
	  })

	  return result
	}

	return files;
})(___arguments.files, 700, 80))

  },
  /* handler:onBeforeUpload */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 4) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onButtonLabelAssignment */
  ['onButtonLabelAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992) {
    return 'Upload media';
  } else {
    return 'Drag and Drop or click to upload';
  }

  },
  /* handler:onButtonLabelAssignment */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('741f6a07142fb5b99adb9223834cb927');

  },
  /* handler:onUploadFail */
  /* content */
}))

define('./pages/edit-activity-old/components/3cc9bed4da442af39e98af38a236af17/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.pageData['check'] = true;

  },
  /* handler:onMounted */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'media2')) {
    return (getObjectProperty(___arguments.context.pageData, 'media2'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/91eee0065a64be6576e8fd8397d35029/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file'))

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      return ['content__media-image', 'activity-page__image']

  },  
  /* handler:onClassListAssignment */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    
  },
  /* handler:onMouseOut */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('3cc9bed4da442af39e98af38a236af17'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['isCover'] = false;
  }
  ___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946')['isCover'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'media')) && (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[0]), 'isCover')) != true) {
    ___arguments.context.pageData['media'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'media')), -1, async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/3d7a0b7f949d689404495eea6aad8b5a/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'media')) {
    if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 1 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a'))) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')).slice(-1)[0] != 'activity-page__prewiev-img-big') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')), 'activity-page__prewiev-img-big');
      }
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')).slice(-1)[0] != 'activity-page__prewiev-wrapper') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')), 'activity-page__prewiev-wrapper');
      }
      return (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[0]), 'file'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 1 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a'))) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')).slice(-1)[0] == 'activity-page__prewiev-img-big') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')).pop();
      }
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')).slice(-1)[0] == 'activity-page__prewiev-wrapper') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')).pop();
      }
      return '/images/prewiev.svg';
    }
  }

  return '/images/prewiev.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'media')).length >= 1 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'media')) && (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[0]), 'isCover')) != true) {
      ___arguments.context.pageData['media'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'media')), -1, async (item) => {


       return ((getObjectProperty(item, 'isCover')) == true);
      }));
    }
    return ['activity-page__prewiev-img-big'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 0 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a'))) {
    return [''];
  }

  return ['']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/33e7df29c9acc1c267dd4bdafe9882bf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  addItemToList((getObjectProperty(___arguments.context.pageData, 'toDelete')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file')));
  ___arguments.context.pageData['media'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'media')), async (item) => {


   return ((getObjectProperty(item, 'file')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946'), 'file')));
  }));
  if (!!(getObjectProperty(___arguments.context.pageData, 'media')).length) {
    ((getObjectProperty(___arguments.context.pageData, 'media'))[0])['isCover'] = true;
  }
  ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  await (async function(path, mediaList, media2) {
  	async function resizeFiles(files, width, percent) {
  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index]

  	    const fileName = file.name

  	    const content = await readFileAsDataURL(file)

  	    const img = await getNewImage(content)

  	    const elem = document.createElement('canvas')

  	    const widthImage = !width ? img.width : width
  	    const scaleFactor = width && width / img.width
  	    const heightImage = width ? img.height * scaleFactor : img.height

  	    elem.width = widthImage
  	    elem.height = heightImage

  	    const ctx = elem.getContext('2d')

  	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	    const blob = await getCanvasBlob(ctx.canvas, percent)

  	    const newFile = new File([blob], fileName, {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })

  	    files[index] = newFile
  	  }

  	  async function readFileAsDataURL(file) {
  	    const result = await new Promise((resolve) => {
  	      const fileReader = new FileReader()

  	      fileReader.onload = (e) => resolve(e.target.result)

  	      fileReader.readAsDataURL(file)
  	    })

  	    return result;
  	  }

  	  async function getNewImage(content) {
  	    const result = await new Promise((resolve) => {
  	      const img = new Image()

  	      img.src = content

  	      img.onload = () => resolve(img)
  	    })

  	    return result
  	  }

  	  async function getCanvasBlob(canvas, percent) {
  	    const result = await new Promise((resolve) => {
  	      canvas.toBlob((blob) => {
  	        resolve(blob)
  	      }, 'image/jpeg', percent)
  	    })

  	    return result
  	  }

  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.content__upload-button');
  	dropArea.removeEventListener('drop', dragAndDropFunc);

  	  dropArea.addEventListener("dragover", (event) => {
  	    event.preventDefault();
  	    dropArea.classList.add('active');
  	  });

  	  dropArea.addEventListener("dragleave", () => {
  	    dropArea.classList.remove('active');
  	  });


  	  function uploadFile(files) {
  	    files.forEach((file) => {
  	      if (file.type.includes('image')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	       .then(async function(fileURL) {
  	          let media = {
  	            file: fileURL.fileURL,
  	            isCover: false
  	          };
  	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', true);
  	           let moderationResult =  await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileURL.fileURL) }).send();
  	           if (moderationResult == 'OK') {
  	              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', false);
  	              mediaList.push(media);
  	              mediaList[0].isCover = true;
  	              media2 = mediaList;
  	           } else {
  	              await Backendless.Files.remove(fileURL.fileURL);
  	              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', false);
  	              (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('66520f11f7bdb87eae4bab4675453905', ({ 'showRejectMsg': true }));
  	           };
  	        })
  	       .catch( function( error ) {
  	         console.log(error)
  	        })
  	      }
  	    })

  	    return mediaList;
  	  }


  	  dragAndDropFunc = function(event){
  	    event.preventDefault();
  	    let files = event.dataTransfer.files;
  	    resizeFiles([...files], 700, 80);
  	    dropArea.classList.remove('active');
  	  }

  	  dropArea.addEventListener("drop", dragAndDropFunc);

  })((['/pictures/activities/',(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'login')),'/'].join('')), (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')));
  if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 0 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a'))) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')).slice(-1)[0] == 'activity-page__prewiev-img-big') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3d7a0b7f949d689404495eea6aad8b5a')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')).slice(-1)[0] == 'activity-page__prewiev-wrapper') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8c97621301fab18d7859a7212773e5de')).pop();
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/097f14a721d403bb07dec75720da4b86/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'media')) {
    if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 2 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('097f14a721d403bb07dec75720da4b86'))) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')).slice(-1)[0] != 'activity-page__prewiev-img-big') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')), 'activity-page__prewiev-img-big');
      }
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')).slice(-1)[0] != 'activity-page__prewiev-wrapper') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')), 'activity-page__prewiev-wrapper');
      }
      return (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[1]), 'file'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 2 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('097f14a721d403bb07dec75720da4b86'))) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')).slice(-1)[0] != 'activity-page__prewiev-img-small') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')), 'activity-page__prewiev-img-small');
      }
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')).slice(-1)[0] != 'activity-page__prewiev-wrapper') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')), 'activity-page__prewiev-wrapper');
      }
      return (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[1]), 'file'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 1 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('097f14a721d403bb07dec75720da4b86'))) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')).slice(-1)[0] == 'activity-page__prewiev-img-small') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('097f14a721d403bb07dec75720da4b86')).pop();
      }
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')).slice(-1)[0] == 'activity-page__prewiev-wrapper') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6d8bfc57af24be67a374bdb42e47b8ac')).pop();
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d8bfc57af24be67a374bdb42e47b8ac', false);
      return '/images/prewiev1.svg';
    }
  }

  return '/images/prewiev1.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 2 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('097f14a721d403bb07dec75720da4b86'))) {
    return ['activity-page__prewiev-img-big'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 2 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('097f14a721d403bb07dec75720da4b86'))) {
    return ['activity-page__prewiev-img-small'];
  }

  return ['']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/73691c0d14b72c74621c701beda525ce/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'media')) {
    if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 2 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73691c0d14b72c74621c701beda525ce'))) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('73691c0d14b72c74621c701beda525ce')).slice(-1)[0] != 'activity-page__prewiev-img-small') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('73691c0d14b72c74621c701beda525ce')), 'activity-page__prewiev-img-small');
      }
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('612d149413a9d0a5d215aea239ffffec')).slice(-1)[0] != 'activity-page__prewiev-wrapper') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('612d149413a9d0a5d215aea239ffffec')), 'activity-page__prewiev-wrapper');
      }
      return (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'media'))[2]), 'file'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 2 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73691c0d14b72c74621c701beda525ce'))) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('73691c0d14b72c74621c701beda525ce')).slice(-1)[0] == 'activity-page__prewiev-img-small') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('73691c0d14b72c74621c701beda525ce')).pop();
      }
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('612d149413a9d0a5d215aea239ffffec')).slice(-1)[0] == 'activity-page__prewiev-wrapper') {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('612d149413a9d0a5d215aea239ffffec')).pop();
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('612d149413a9d0a5d215aea239ffffec', false);
      return '/images/prewiev2.svg';
    }
  }

  return '/images/prewiev2.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 2 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73691c0d14b72c74621c701beda525ce'))) {
    return ['activity-page__prewiev-img-small'];
  } else if ((getObjectProperty(___arguments.context.pageData, 'media')).length == 2 && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73691c0d14b72c74621c701beda525ce'))) {
    return [''];
  }

  return ['']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/097a232d4e93ae359babf4de13fa5884/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'media')) {
    if ((getObjectProperty(___arguments.context.pageData, 'media')).length > 3) {
      ___arguments.context.pageData['photoCount'] = (['+',(getObjectProperty(___arguments.context.pageData, 'media')).length - 3,' more'].join(''));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('097a232d4e93ae359babf4de13fa5884'))['width'] = '100%';
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/c0de6fd8d1d5748b8f4610318f6df83e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('39cd1631cfd442115832d2b73b68fa8b', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c0de6fd8d1d5748b8f4610318f6df83e', false);

  },
  /* handler:onClick */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c0de6fd8d1d5748b8f4610318f6df83e'))['cursor'] = 'pointer';

  },
  /* handler:onMouseOver */
  /* content */
}))

define('./pages/edit-activity-old/components/155b51cc99a4a922ef468182e526dfda/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'category')) {
    return (getObjectProperty(___arguments.context.pageData, 'iconCategory'));
  }

  return '/images/category.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/538e6e37fc9fd4e3efac48864b15b806/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['stepCount'] = 'Step 2/3';
  ___arguments.context.pageData['subtitle'] = '2. A few additional details...';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d74362cb5191d50acf435d28d2685ecd')).slice(-1)[0] == 'activity-page__step--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d74362cb5191d50acf435d28d2685ecd')).pop();
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8969145a18dfd7cf6982d3287c9abc94', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4cc43d921412e62604ce8121f83518c7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e561a1da3fd68df7a55b9c48ebdce91a', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2894dfb56f3475328becafc550390aa5', false);
  if (getObjectProperty(___arguments.context.pageData, 'financialRoleRequired')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b45a85cc462475129ac5857f1d051f3c', true);
  }
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a915ac93423faf18518809839f0bf768')));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 768) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/e6385e2a40e409f9633fd31b11414274/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if (getObjectProperty(___arguments.context.pageData, 'countStart')) {
    await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);
  }
  if (getObjectProperty(___arguments.context.pageData, 'count')) {
    if ((getObjectProperty(___arguments.context.pageData, 'count')) > 999) {
      return ([String(getObjectProperty(___arguments.context.pageData, 'count')).slice(0, String(getObjectProperty(___arguments.context.pageData, 'count')).length - 3),',',subsequenceFromEndLast(String(getObjectProperty(___arguments.context.pageData, 'count')), 2),''].join(''));
    } else {
      return (getObjectProperty(___arguments.context.pageData, 'count'));
    }
  } else {
    return 0;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/40d2a4ec1205c90fa63b1a7a92f268a1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var newUsersList, allUsers, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function mathRandomInt(a, b) {
  if (a > b) {
    // Swap a and b to ensure a is smaller.
    var c = a;
    a = b;
    b = c;
  }
  return Math.floor(Math.random() * (b - a + 1) + a);
}


  ___arguments.context.pageData['users'] = (await Backendless.Request.get(`${Backendless.appPath}/services/potentialMatches/getUsersPhoto`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  newUsersList = [];
  allUsers = (getObjectProperty(___arguments.context.pageData, 'users'));
  ___arguments.context.pageData['bodyTypesList'] = [];
  var j_list = (getObjectProperty(___arguments.context.pageData, 'users'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'photo')) {
      addItemToList(allUsers, j);
    }
  }
  for (var count = 0; count < 3; count++) {
    addItemToList(newUsersList, (allUsers[(mathRandomInt(1, allUsers.length) - 1)]));
  }
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3101f401c6a85881b68fc1659166736b', newUsersList);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/099f6d62c7fa590a6c84794cfedbedee/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var heightInch;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value == '1') {
    heightInch = String('-') + String(getObjectProperty(___arguments.context.pageData, 'height'));
    ___arguments.context.pageData['heightData'] = (heightInch * 1);
    delete ___arguments.context.pageData['heightDataTaller'];
    ___arguments.context.pageData['heightDataSmaller'] = true;
  } else if (___arguments.value == '2') {
    ___arguments.context.pageData['heightData'] = ((getObjectProperty(___arguments.context.pageData, 'height')) * 1);
    delete ___arguments.context.pageData['heightDataSmaller'];
    ___arguments.context.pageData['heightDataTaller'] = true;
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/b7ee7bfb4339b3b8faf2899921170f1f/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'childrenList'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['© ',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/c98697816d2e1b96e86cec2c14dbacad/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var j, activity, item, media2, mediaList, path, category;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  getRTSubscriptions().remove('likes');
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
  ___arguments.context.pageData['stepCount'] = 'Step 1/3';
  ___arguments.context.pageData['subtitle'] = '1. Description';
  activity = (await Backendless.Request.get(`${Backendless.appPath}/services/getMyActivity/getMyActivity`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'id': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'activityId'))) }).send())[0];
  if (!((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories')) || !((((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories')).map(item => item['name'])).includes('Professional Services'))) {
    ___arguments.context.appData['categoryList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/profilesData/ProfilesData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'tableName': JSON.stringify('Category') }).send());
    localStorage.setItem('categories', JSON.stringify((getObjectProperty(___arguments.context.appData, 'categoryList'))));
  } else if (!(getObjectProperty(___arguments.context.appData, 'categoryList'))) {
    ___arguments.context.appData['categoryList'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('categories'));
  }
  ___arguments.context.pageData['categoryListTableData'] = (getObjectProperty(___arguments.context.appData, 'categoryList'));
  ___arguments.context.pageData['activityData'] = activity;
  if (getObjectProperty(activity, 'name')) {
    ___arguments.context.pageData['name'] = (getObjectProperty(activity, 'name'));
  }
  if (getObjectProperty(activity, 'activityTitle')) {
    ___arguments.context.pageData['activityTitle'] = (getObjectProperty(activity, 'activityTitle'));
  }
  if (getObjectProperty(activity, 'category')) {
    ___arguments.context.pageData['activityCategory'] = (getObjectProperty((getObjectProperty(activity, 'category')), 'objectId'));
    category = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'categoryListTableData')), async (item) => {


     return ((getObjectProperty(___arguments.context.pageData, 'activityCategory')) == (getObjectProperty(item, 'objectId')));
    }))[0];
    ___arguments.context.pageData['category'] = (getObjectProperty(category, 'name'));
    ___arguments.context.pageData['iconCategory'] = (getObjectProperty(category, 'icon'));
    if (!(getObjectProperty(category, 'financialRoleRequired'))) {
      ___arguments.context.pageData['financialRoleRequired'] = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f77bc408eed2f32a47f271160008c9eb', false);
    } else {
      ___arguments.context.pageData['financialRoleRequired'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f77bc408eed2f32a47f271160008c9eb', true);
    }
  }
  if (getObjectProperty(activity, 'description')) {
    ___arguments.context.pageData['description'] = (getObjectProperty(activity, 'description'));
    ___arguments.context.pageData['counter'] = (String(getValueLength((getObjectProperty(___arguments.context.pageData, 'description')))) + String('/500 symbols'));
  }
  if (getObjectProperty(activity, 'media')) {
    ___arguments.context.pageData['media'] = (getObjectProperty(activity, 'media'));
    ___arguments.context.pageData['media2'] = (getObjectProperty(activity, 'media'));
    ___arguments.context.pageData['userNameMedia'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).replace((new RegExp('[^\\w\\s]', 'g')), ''));
    path = ['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('');
    mediaList = (getObjectProperty(___arguments.context.pageData, 'media'));
    media2 = (getObjectProperty(___arguments.context.pageData, 'media2'));
    await (async function(path, mediaList, media2, data) {
    	async function resizeFiles(files, width, percent) {
    	  for (let index = 0; index < files.length; index++) {
    	    const file = files[index]

    	    const fileName = file.name

    	    const content = await readFileAsDataURL(file)

    	    const img = await getNewImage(content)

    	    const elem = document.createElement('canvas')

    	    const widthImage = !width ? img.width : width
    	    const scaleFactor = width && width / img.width
    	    const heightImage = width ? img.height * scaleFactor : img.height

    	    elem.width = widthImage
    	    elem.height = heightImage

    	    const ctx = elem.getContext('2d')

    	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

    	    const blob = await getCanvasBlob(ctx.canvas, percent)

    	    const newFile = new File([blob], fileName, {
    	      type: 'image/jpeg',
    	      lastModified: Date.now()
    	    })

    	    files[index] = newFile
    	  }

    	  async function readFileAsDataURL(file) {
    	    const result = await new Promise((resolve) => {
    	      const fileReader = new FileReader()

    	      fileReader.onload = (e) => resolve(e.target.result)

    	      fileReader.readAsDataURL(file)
    	    })

    	    return result;
    	  }

    	  async function getNewImage(content) {
    	    const result = await new Promise((resolve) => {
    	      const img = new Image()

    	      img.src = content

    	      img.onload = () => resolve(img)
    	    })

    	    return result
    	  }

    	  async function getCanvasBlob(canvas, percent) {
    	    const result = await new Promise((resolve) => {
    	      canvas.toBlob((blob) => {
    	        resolve(blob)
    	      }, 'image/jpeg', percent)
    	    })

    	    return result
    	  }

    	  uploadFile(files);
    	}

    	const dropArea = document.querySelector('.content__upload-button');

    	  dropArea.addEventListener("dragover", (event) => {
    	    event.preventDefault();
    	    dropArea.classList.add('active');
    	  });

    	  dropArea.addEventListener("dragleave", () => {
    	    dropArea.classList.remove('active');
    	  });


    	  function uploadFile(files) {
    	    files.forEach((file) => {
    	      if (file.type.includes('image')) {
    	        Backendless.Files.upload(file, path, overwrite = true)
    	       .then(async function(fileURL) {
    	          let media = {
    	            file: fileURL.fileURL,
    	            isCover: false
    	          };
    	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', true);
    	          let moderationResult =  await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileURL.fileURL) }).send();
    	          if (moderationResult == 'OK') {
    	            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', false);
    	            data.media.push(media);
    	            data.media[0].isCover = true;
    	            data.media2 = data.media;
    	            data.isDrag = true;
    	          } else {
    	            Backendless.Files.remove(fileURL.fileURL);
    	            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3a890338e19f50fdf5be54b187466438', false);
    	            (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('66520f11f7bdb87eae4bab4675453905', ({ 'showRejectMsg': true }));
    	          }
    	        })
    	       .catch( function( error ) {
    	         console.log(error)
    	        })
    	      }
    	    })

    	    return data.media;
    	  }

    	  dragAndDropFunc = function (event) {
    	    event.preventDefault();
    	    let files = event.dataTransfer.files;
    	    resizeFiles([...files], 700, 80);
    	    dropArea.classList.remove('active');
    	  }

    	  dropArea.addEventListener("drop", dragAndDropFunc);

    })(path, mediaList, media2, ___arguments.context.pageData);
    ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  }
  if (getObjectProperty(___arguments.context.appData, 'countMessage')) {
    ___arguments.context.pageData['countMessage'] = (getObjectProperty(___arguments.context.appData, 'countMessage'));
    ___arguments.context.pageData['messagesNumber'] = (getObjectProperty(___arguments.context.pageData, 'countMessage'));
  }
  if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')).includes('.')) {
    ___arguments.context.pageData['userNameMedia'] = ((await asyncListFilter(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')), async (item) => {


     return (item != '.');
    })).join(''));
  } else {
    ___arguments.context.pageData['userNameMedia'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
  }
  if (!(getObjectProperty(___arguments.context.appData, 'statusList'))) {
    ___arguments.context.appData['profilesData'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'));
    ___arguments.context.appData['statusList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'statusList'));
    ___arguments.context.appData['ethnicityList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'ethnicityList'));
    ___arguments.context.appData['bodyTypeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'bodyTypeList'));
    ___arguments.context.appData['orientationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'orientationList'));
    ___arguments.context.appData['educationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'educationList'));
    ___arguments.context.appData['politicalList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'politicalList'));
    ___arguments.context.appData['religionList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList'));
    ___arguments.context.appData['hairColorList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'hairColorList'));
    ___arguments.context.appData['smokeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'smokeList'));
    ___arguments.context.appData['drinkList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'drinkList'));
    ___arguments.context.appData['dietaryList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList')), 1, async (item) => {


     return (getObjectProperty(item, 'id'));
    }));
  }
  if (getObjectProperty(activity, 'location')) {
    ___arguments.context.pageData['location'] = (getObjectProperty(activity, 'location'));
  }
  if (getObjectProperty(activity, 'locationPoint')) {
    if (getObjectProperty((getObjectProperty(activity, 'locationPoint')), 'lat')) {
      ___arguments.context.pageData['locationPoint'] = (getObjectProperty(activity, 'locationPoint'));
    } else if (getObjectProperty((getObjectProperty(activity, 'locationPoint')), 'coordinates')) {
      ___arguments.context.pageData['locationPoint'] = ({  });
      (getObjectProperty(___arguments.context.pageData, 'locationPoint'))['lng'] = ((getObjectProperty((getObjectProperty(activity, 'locationPoint')), 'coordinates'))[0]);
      (getObjectProperty(___arguments.context.pageData, 'locationPoint'))['lat'] = ((getObjectProperty((getObjectProperty(activity, 'locationPoint')), 'coordinates')).slice(-1)[0]);
      activity['locationPoint'] = (getObjectProperty(___arguments.context.pageData, 'locationPoint'));
    }
  }
  await new Promise(r => setTimeout(r, 1000 || 0));
  if (getObjectProperty(activity, 'locationPoint')) {
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('60e48ff23dac5a6752f5a3e7d7031b6e', (getObjectProperty((getObjectProperty(activity, 'locationPoint')), 'lat')), (getObjectProperty((getObjectProperty(activity, 'locationPoint')), 'lng')));
    (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('60e48ff23dac5a6752f5a3e7d7031b6e', [(getObjectProperty(activity, 'locationPoint'))]);
  }
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);
  if (getObjectProperty(activity, 'keepLocationPrivate')) {
    ___arguments.context.pageData['keepLocationPrivate'] = (getObjectProperty(activity, 'keepLocationPrivate'));
  }
  if (getObjectProperty(activity, 'activityDate')) {
    ___arguments.context.pageData['specificInput'] = (getObjectProperty(activity, 'activityDate'));
    ___arguments.context.pageData['specific'] = 'specificDate';
  } else if (getObjectProperty(activity, 'ongoingTiming')) {
    ___arguments.context.pageData['ongoingInput'] = (getObjectProperty(activity, 'ongoingTiming'));
    ___arguments.context.pageData['ongoing'] = 'ongoing';
  } else {
    ___arguments.context.pageData['scheduled'] = 'scheduled';
  }
  if (getObjectProperty(activity, 'financialRole')) {
    if ((getObjectProperty(activity, 'financialRole')) == 'passenger') {
      ___arguments.context.pageData['passenger'] = 'passenger';
    }
    if ((getObjectProperty(activity, 'financialRole')) == 'driver') {
      ___arguments.context.pageData['driver'] = 'driver';
    }
    if ((getObjectProperty(activity, 'financialRole')) != 'driver' && (getObjectProperty(activity, 'financialRole')) != 'passenger' && getValueLength((getObjectProperty(activity, 'financialRole'))) > 0) {
      ___arguments.context.pageData['payYourOwnWay'] = 'payYourOwnWay';
      ___arguments.context.pageData['payYourOwnWayInput'] = (getObjectProperty(activity, 'financialRole'));
    }
  }
  if (getObjectProperty(activity, 'visibility')) {
    ___arguments.context.pageData['visibility'] = (getObjectProperty(activity, 'visibility'));
    if ((getObjectProperty(activity, 'visibility')) == '1') {
      ___arguments.context.pageData['1'] = '1';
    }
    if ((getObjectProperty(activity, 'visibility')) == '2') {
      ___arguments.context.pageData['2'] = '2';
    }
    if ((getObjectProperty(activity, 'visibility')) == '3') {
      ___arguments.context.pageData['3'] = '3';
    }
  }
  if (getObjectProperty(activity, 'preferences')) {
    if ((getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageFrom')) && !(getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageTo'))) {
      ___arguments.context.pageData['ageFrom'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageFrom'));
      ___arguments.context.pageData['age'] = [(getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageFrom')), 100];
      ___arguments.context.pageData['ageTo'] = 100;
    } else if (!(getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageFrom')) && (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageTo'))) {
      ___arguments.context.pageData['ageTo'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageTo'));
      ___arguments.context.pageData['age'] = [18, (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageTo'))];
      ___arguments.context.pageData['ageFrom'] = 18;
    } else if ((getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageFrom')) && (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageTo'))) {
      ___arguments.context.pageData['ageFrom'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageFrom'));
      ___arguments.context.pageData['ageTo'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageTo'));
      ___arguments.context.pageData['age'] = [(getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageFrom')), (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageTo'))];
    } else if (!(getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageFrom')) && !(getObjectProperty((getObjectProperty(activity, 'preferences')), 'ageTo'))) {
      ___arguments.context.pageData['age'] = [18, 100];
    }
    if ((getObjectProperty((getObjectProperty(activity, 'preferences')), 'gender')) && (getObjectProperty((getObjectProperty(activity, 'preferences')), 'gender')).length > 0) {
      ___arguments.context.pageData['gender'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'gender'));
    } else {
      ___arguments.context.pageData['gender'] = [];
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'height')) {
      ___arguments.context.pageData['height'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'height'));
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'maritalStatus')) {
      ___arguments.context.pageData['maritalStatus'] = [];
      ___arguments.context.pageData['maritalStatusObjects'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'maritalStatus'));
      ___arguments.context.pageData['maritalStatusId'] = [];
      var j_list = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'maritalStatus'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'maritalStatus')), (getObjectProperty(j, 'objectId')));
      }
      var j_list2 = (getObjectProperty(___arguments.context.pageData, 'maritalStatusObjects'));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'maritalStatusId')), (getObjectProperty(j, 'id')));
      }
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'children')) {
      ___arguments.context.pageData['children'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'children'));
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ethnicity')) {
      ___arguments.context.pageData['ethnicityObjects'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ethnicity'));
      ___arguments.context.pageData['ethnicity'] = [];
      ___arguments.context.pageData['ethnicityId'] = [];
      var j_list3 = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'ethnicity'));
      for (var j_index3 in j_list3) {
        j = j_list3[j_index3];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'ethnicity')), (getObjectProperty(j, 'objectId')));
      }
      var j_list4 = (getObjectProperty(___arguments.context.pageData, 'ethnicityObjects'));
      for (var j_index4 in j_list4) {
        j = j_list4[j_index4];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'ethnicityId')), (getObjectProperty(j, 'id')));
      }
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'religion')) {
      ___arguments.context.pageData['religionObjects'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'religion'));
      ___arguments.context.pageData['religionList'] = [];
      ___arguments.context.pageData['religionId'] = [];
      var j_list5 = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'religion'));
      for (var j_index5 in j_list5) {
        j = j_list5[j_index5];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'religionList')), (getObjectProperty(j, 'objectId')));
      }
      var j_list6 = (getObjectProperty(___arguments.context.pageData, 'religionObjects'));
      for (var j_index6 in j_list6) {
        j = j_list6[j_index6];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'religionId')), (getObjectProperty(j, 'id')));
      }
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'sexualIdentity')) {
      ___arguments.context.pageData['sexualidentityObjects'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'sexualIdentity'));
      ___arguments.context.pageData['sexualidentity'] = [];
      ___arguments.context.pageData['sexualidentityId'] = [];
      var j_list7 = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'sexualIdentity'));
      for (var j_index7 in j_list7) {
        j = j_list7[j_index7];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'sexualidentity')), (getObjectProperty(j, 'objectId')));
      }
      var j_list8 = (getObjectProperty(___arguments.context.pageData, 'sexualidentityObjects'));
      for (var j_index8 in j_list8) {
        j = j_list8[j_index8];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'sexualidentityId')), (getObjectProperty(j, 'id')));
      }
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'education')) {
      ___arguments.context.pageData['educationObjects'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'education'));
      ___arguments.context.pageData['educationList'] = [];
      ___arguments.context.pageData['educationId'] = [];
      var j_list9 = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'education'));
      for (var j_index9 in j_list9) {
        j = j_list9[j_index9];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'educationList')), (getObjectProperty(j, 'objectId')));
      }
      var j_list10 = (getObjectProperty(___arguments.context.pageData, 'educationObjects'));
      for (var j_index10 in j_list10) {
        j = j_list10[j_index10];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'educationId')), (getObjectProperty(j, 'id')));
      }
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'bodyType')) {
      ___arguments.context.pageData['bodyTypesAll'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'bodyType'));
      ___arguments.context.pageData['bodyType'] = [];
      ___arguments.context.pageData['bodyTypeObjects'] = [];
      var j_list11 = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'bodyType'));
      for (var j_index11 in j_list11) {
        j = j_list11[j_index11];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'bodyType')), (getObjectProperty(j, 'objectId')));
      }
      var j_list12 = (getObjectProperty(___arguments.context.pageData, 'bodyTypesAll'));
      for (var j_index12 in j_list12) {
        j = j_list12[j_index12];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'bodyTypeObjects')), (getObjectProperty(j, 'id')));
      }
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'politicalViews')) {
      ___arguments.context.pageData['politicalViewsObjects'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'bodyType'));
      ___arguments.context.pageData['politicalViewList'] = [];
      ___arguments.context.pageData['politicalViewId'] = [];
      var j_list13 = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'politicalViews'));
      for (var j_index13 in j_list13) {
        j = j_list13[j_index13];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'politicalViewList')), (getObjectProperty(j, 'objectId')));
      }
      var j_list14 = (getObjectProperty(___arguments.context.pageData, 'politicalViewsObjects'));
      for (var j_index14 in j_list14) {
        j = j_list14[j_index14];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'politicalViewId')), (getObjectProperty(j, 'id')));
      }
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'hairColor')) {
      ___arguments.context.pageData['hairColorObjects'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'hairColor'));
      ___arguments.context.pageData['hairColor'] = [];
      ___arguments.context.pageData['hairColorId'] = [];
      var j_list15 = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'hairColor'));
      for (var j_index15 in j_list15) {
        j = j_list15[j_index15];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'hairColor')), (getObjectProperty(j, 'objectId')));
      }
      var j_list16 = (getObjectProperty(___arguments.context.pageData, 'hairColorObjects'));
      for (var j_index16 in j_list16) {
        j = j_list16[j_index16];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'hairColorId')), (getObjectProperty(j, 'id')));
      }
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'smoke')) {
      ___arguments.context.pageData['smokeObjects'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'smoke'));
      ___arguments.context.pageData['smoke'] = [];
      ___arguments.context.pageData['smokeId'] = [];
      var j_list17 = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'smoke'));
      for (var j_index17 in j_list17) {
        j = j_list17[j_index17];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'smoke')), (getObjectProperty(j, 'objectId')));
      }
      var j_list18 = (getObjectProperty(___arguments.context.pageData, 'smokeObjects'));
      for (var j_index18 in j_list18) {
        j = j_list18[j_index18];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'smokeId')), (getObjectProperty(j, 'id')));
      }
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'drink')) {
      ___arguments.context.pageData['drinkObjects'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'drink'));
      ___arguments.context.pageData['drink'] = [];
      ___arguments.context.pageData['drinkId'] = [];
      var j_list19 = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'drink'));
      for (var j_index19 in j_list19) {
        j = j_list19[j_index19];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'drink')), (getObjectProperty(j, 'objectId')));
      }
      var j_list20 = (getObjectProperty(___arguments.context.pageData, 'drinkObjects'));
      for (var j_index20 in j_list20) {
        j = j_list20[j_index20];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'drinkId')), (getObjectProperty(j, 'id')));
      }
    }
    if (getObjectProperty((getObjectProperty(activity, 'preferences')), 'dietaryPreference')) {
      ___arguments.context.pageData['dietaryPreferenceObjects'] = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'dietaryPreference'));
      ___arguments.context.pageData['dietaryPreference'] = [];
      ___arguments.context.pageData['dietaryPreferenceId'] = [];
      var j_list21 = (getObjectProperty((getObjectProperty(activity, 'preferences')), 'dietaryPreference'));
      for (var j_index21 in j_list21) {
        j = j_list21[j_index21];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'dietaryPreference')), (getObjectProperty(j, 'objectId')));
      }
      var j_list22 = (getObjectProperty(___arguments.context.pageData, 'dietaryPreferenceObjects'));
      for (var j_index22 in j_list22) {
        j = j_list22[j_index22];
        addItemToList((getObjectProperty(___arguments.context.pageData, 'dietaryPreferenceId')), (getObjectProperty(j, 'id')));
      }
    }
  } else {
    ___arguments.context.pageData['age'] = [18, 100];
    ___arguments.context.pageData['gender'] = [];
  }
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/edit-activity-old/components/3f2f1461d4b8879860f88a47d893f946/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f2f1461d4b8879860f88a47d893f946'))['anchor'] = (getObjectProperty(___arguments.context.dataModel, 'id'));

  return true

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'media')) {
    ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  }
  await (async function(data) {
  	if (data.check) {
  	  const draggables = document.querySelectorAll('.draggable')
  	  const containers = document.querySelectorAll('.container')
  	  draggables.forEach(draggable => {
  	    draggable.addEventListener('dragstart', () => {
  	      draggable.classList.add('dragging')
  	    })

  	    draggable.addEventListener('dragend', () => {
  	      draggable.classList.remove('dragging')
  	      const images = [...document.querySelectorAll('.draggable .content__media-image')]
  	      const list = [...document.querySelectorAll('.draggable')]

  	      const cover = list.filter(item => item.classList.contains("cover"));
  	      let coverImage = cover[0].firstChild.children[3].src

  	      const media = images.map((image, index) => ({ file:image.src, isCover: image.src === coverImage}))
  	      data.media = media
  	      data.media2 = media.sort((a, b) => (a.isCover > b.isCover) ? 1 : -1)

  	    })

  	    draggable.addEventListener('touchstart', () => {
  	      draggable.classList.add('dragging')
  	    })

  	    draggable.addEventListener('touchend', () => {
  	      draggable.classList.remove('dragging')
  	      const images = [...document.querySelectorAll('.draggable .content__media-image')]

  	      const list = [...document.querySelectorAll('.draggable')]
  	      const cover = list.filter(item => item.classList.contains("cover"));
  	      let coverImage = cover[0].firstChild.children[3].src

  	      const media = images.map((image, index) => ({ file:image.src, isCover: image.src === coverImage }))

  	      data.media = media
  	      data.media2 = media.sort((a, b) => (a.isCover > b.isCover) ? 1 : -1)

  	    })
  	  })

  	  containers.forEach(container => {
  	    container.addEventListener('dragover', e => {
  	      e.preventDefault()
  	      const afterElement = getDragAfterElement(container, e.clientY)
  	      const draggable = document.querySelector('.dragging')
  	      if (draggable) {
  	        if (afterElement == null) {
  	          container.appendChild(draggable)
  	        } else {
  	          container.insertBefore(draggable, afterElement)
  	        }
  	      }
  	    })

  	    container.addEventListener('touchmove', event => {
  	      event.preventDefault()
  	      const afterElement = getDragAfterElementMobile(container, event.targetTouches[0].clientY)
  	      const draggable = document.querySelector('.dragging')
  	      if (draggable) {
  	        if (afterElement == null) {
  	          container.appendChild(draggable)
  	        } else {
  	          container.insertBefore(draggable, afterElement)
  	        }
  	      }
  	    })
  	  })

  	  function getDragAfterElement(container, y) {
  	    const draggableElements = [...container.querySelectorAll('.draggable:not(.dragging)')]

  	    return draggableElements.reduce((closest, child) => {
  	      const box = child.getBoundingClientRect()
  	      const offset = y - box.top - box.height / 1.25
  	    if (offset < 0 && offset > closest.offset) {
  	        return { offset: offset, element: child }
  	      } else {
  	        return closest
  	      }
  	    }, { offset: Number.NEGATIVE_INFINITY }).element
  	  }
  	}

  	  function getDragAfterElementMobile(container, y) {
  	    const draggableElements = [...container.querySelectorAll('.draggable:not(.dragging)')]

  	    return draggableElements.reduce((closest, child) => {
  	      const box = child.getBoundingClientRect()
  	      const offset = y - box.top - box.height / 1.5
  	    if (offset < 0 && offset > closest.offset) {
  	        return { offset: offset, element: child }
  	      } else {
  	        return closest
  	      }
  	    }, { offset: Number.NEGATIVE_INFINITY }).element
  	  }


  	data.check = false
  })(___arguments.context.pageData);

  },
  /* handler:onMounted */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'isCover')) {
    return ['content__media-item', 'activity-page__media-item', 'draggable', 'cover'];
  } else {
    return ['content__media-item', 'activity-page__media-item', 'draggable'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/0fc61926bac2d7d339314814e1a5c51e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'minDateNotification')) {
    return 'Date cannot be in the past';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/c938823c43ae48fa54031aed807f4124/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'location')) {
    ___arguments.context.pageData['location'] = '';
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('594b9e3753547161e26e31b916d68155'))['value'] = '';
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('594b9e3753547161e26e31b916d68155')), 'el'))['value'] = '';
    ___arguments.context.pageData['locationPointResult'] = null;
    ___arguments.context.pageData['locationPoint'] = null;
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', 0, 0);
    (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('60e48ff23dac5a6752f5a3e7d7031b6e', 0, 0);
    (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('4df590d6dc3a54537dcf708f8de2676b', []);
    (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('60e48ff23dac5a6752f5a3e7d7031b6e', []);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['location']) {
    return true;
  } else {
    return false;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/4e393a7c0eb719ec3a3b3c0c5d13e31a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, getGeoLocation, clientAddress;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['errorLocation'] = '';
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d399f05140e37bb1f047fe9152f90bf2', true);
    getGeoLocation = (await ( async function () { return BackendlessUI.Navigator.getCurrentGeolocation() })());
    clientAddress = (getObjectProperty(((getObjectProperty((await Backendless.Request.get(`${Backendless.appPath}/services/ReverseGeoCodding/getReverceGeoCodding`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'lat': (getObjectProperty(getGeoLocation, 'lat')),'lng': (getObjectProperty(getGeoLocation, 'lng')) }).send()), 'results'))[0]), 'formatted_address'));
    ___arguments.context.pageData['locationGeoPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(getGeoLocation, 'lat'))).setY((getObjectProperty(getGeoLocation, 'lng'))));
    ___arguments.context.pageData['locationPointResult'] = getGeoLocation;
    ___arguments.context.pageData['location'] = clientAddress;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('594b9e3753547161e26e31b916d68155'))['value'] = (getObjectProperty(___arguments.context.pageData, 'location'));
    if (getGeoLocation) {
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('4df590d6dc3a54537dcf708f8de2676b', (getObjectProperty(getGeoLocation, 'lat')), (getObjectProperty(getGeoLocation, 'lng')));
      (function (componentUid, lat, lng) { ___arguments.context.getComponentByUid(componentUid).center = { lat, lng } })('60e48ff23dac5a6752f5a3e7d7031b6e', (getObjectProperty(getGeoLocation, 'lat')), (getObjectProperty(getGeoLocation, 'lng')));
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('4df590d6dc3a54537dcf708f8de2676b', [getGeoLocation]);
      (function (componentUid, points) { ___arguments.context.getComponentByUid(componentUid).points = points })('60e48ff23dac5a6752f5a3e7d7031b6e', [getGeoLocation]);
      ___arguments.context.pageData['locationPoint'] = (new Backendless.Data.Point().setX((getObjectProperty(getGeoLocation, 'lng'))).setY((getObjectProperty(getGeoLocation, 'lat'))));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d399f05140e37bb1f047fe9152f90bf2', false);

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d399f05140e37bb1f047fe9152f90bf2', true);
    await new Promise(r => setTimeout(r, 1000 || 0));
    if ((getObjectProperty(error, 'code')) == 1) {
      ___arguments.context.pageData['errorLocation'] = 'Geolocation has been disabled for this website. Please allow this site to use geolocation or enter your address in the input';
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d399f05140e37bb1f047fe9152f90bf2', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/1db716faff0979144ff28816b946d89e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'age'))[0]) {
    return (String((getObjectProperty(___arguments.context.pageData, 'age'))[0]) + String(' - '));
  } else {
    return ;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/0268fca2335e793a18c20fe1af17a662/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0]) {
    return ((getObjectProperty(___arguments.context.pageData, 'age')).slice(-1)[0]);
  } else {
    return ;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/0d2ee8aee0fc7bc943eb33aaf84b8a68/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('0d2ee8aee0fc7bc943eb33aaf84b8a68', (getObjectProperty(___arguments.context.appData, 'smokeList')));
  if ((getObjectProperty(___arguments.context.pageData, 'smoke')) && (getObjectProperty(___arguments.context.pageData, 'smoke')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d557437421c805133f8e0b24ca4c8bf1'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('abcf0c67d41d22794e9dba2ab0ec5884'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('abcf0c67d41d22794e9dba2ab0ec5884'))['checked'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d557437421c805133f8e0b24ca4c8bf1'))['opacity'] = 0.35;
    ___arguments.context.pageData['smoke'] = [];
    ___arguments.context.pageData['smokeId'] = [];
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/8461e288fc28e6078abf697ecb6a54ce/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8461e288fc28e6078abf697ecb6a54ce', (getObjectProperty(___arguments.context.appData, 'drinkList')));
  if ((getObjectProperty(___arguments.context.pageData, 'drink')) && (getObjectProperty(___arguments.context.pageData, 'drink')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('95d597285283ad626b8871d82691b543'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7c17ab783689bbe179482a3ccdcd8964'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('95d597285283ad626b8871d82691b543'))['opacity'] = 0.35;
    ___arguments.context.pageData['drink'] = [];
    ___arguments.context.pageData['drinkId'] = [];
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/d082499406593b8da7557369eb4aa3a9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d082499406593b8da7557369eb4aa3a9')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d082499406593b8da7557369eb4aa3a9')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dff5144bbe69d5220fba7ceba7717f5c')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d082499406593b8da7557369eb4aa3a9')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d082499406593b8da7557369eb4aa3a9')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('dff5144bbe69d5220fba7ceba7717f5c')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/e7ddbc82ac66d3fe688470834e996f8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e7ddbc82ac66d3fe688470834e996f8d')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e7ddbc82ac66d3fe688470834e996f8d')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b64a62372d6907fab854e2958d3106e')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e7ddbc82ac66d3fe688470834e996f8d')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e7ddbc82ac66d3fe688470834e996f8d')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b64a62372d6907fab854e2958d3106e')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/dff5144bbe69d5220fba7ceba7717f5c/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d082499406593b8da7557369eb4aa3a9')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/5b64a62372d6907fab854e2958d3106e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e7ddbc82ac66d3fe688470834e996f8d')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/abcf0c67d41d22794e9dba2ab0ec5884/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d557437421c805133f8e0b24ca4c8bf1'))['opacity'] = 0.35;
    ___arguments.context.pageData['smokeCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d557437421c805133f8e0b24ca4c8bf1'))['opacity'] = 1;
    delete ___arguments.context.pageData['smokeCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/7c17ab783689bbe179482a3ccdcd8964/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('95d597285283ad626b8871d82691b543'))['opacity'] = 0.35;
    ___arguments.context.pageData['drinkCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('95d597285283ad626b8871d82691b543'))['opacity'] = 1;
    delete ___arguments.context.pageData['drinkCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/1ee4a8ad86dd4914b72b4531bb928187/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var smoke;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('abcf0c67d41d22794e9dba2ab0ec5884'))['checked'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d557437421c805133f8e0b24ca4c8bf1'))['opacity'] = 1;
  smoke = (getObjectProperty(___arguments.context.pageData, 'smoke'));
  if (___arguments.value == true) {
    addItemToList(smoke, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5f7268567e37baf6416daf889311699c'), 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'smokeId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5f7268567e37baf6416daf889311699c'), 'id')));
  } else {
    (getObjectProperty(___arguments.context.pageData, 'smoke')).splice(((smoke.indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5f7268567e37baf6416daf889311699c'), 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'smokeId')).splice((((getObjectProperty(___arguments.context.pageData, 'smokeId')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('5f7268567e37baf6416daf889311699c'), 'id')) + 1) - 1), 1);
  }
  ___arguments.context.pageData['smoke'] = smoke;
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'smoke'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (j == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5f7268567e37baf6416daf889311699c'), 'objectId'))) {
      return true;
    }
  }

  return false

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/a0cd581501bc4163895239c641bcb089/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var drink;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7c17ab783689bbe179482a3ccdcd8964'))['checked'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('95d597285283ad626b8871d82691b543'))['opacity'] = 1;
  drink = (getObjectProperty(___arguments.context.pageData, 'drink'));
  if (___arguments.value == true) {
    addItemToList(drink, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3cb31b536fe5c8920fd1724fcd43f268'), 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'drinkId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3cb31b536fe5c8920fd1724fcd43f268'), 'id')));
  } else {
    (getObjectProperty(___arguments.context.pageData, 'drink')).splice(((drink.indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3cb31b536fe5c8920fd1724fcd43f268'), 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'drinkId')).splice((((getObjectProperty(___arguments.context.pageData, 'drinkId')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('3cb31b536fe5c8920fd1724fcd43f268'), 'id')) + 1) - 1), 1);
  }
  ___arguments.context.pageData['drink'] = drink;
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'drink'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (j == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('3cb31b536fe5c8920fd1724fcd43f268'), 'objectId'))) {
      return true;
    }
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/905564fd6ac642ebbd3993d3c749272c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('aa92f4f670c73ab7d98160c587d36926'))['opacity'] = 1;
  ___arguments.context.pageData['ageFrom'] = (___arguments.value[0]);
  ___arguments.context.pageData['ageTo'] = (___arguments.value.slice(-1)[0]);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a7993934459154523e34663fcee9224a'))['checked'] = false;
  if (!(getObjectProperty(___arguments.context.pageData, 'ageFrom'))) {
    ___arguments.context.pageData['ageFrom'] = 100;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'ageTo'))) {
    ___arguments.context.pageData['ageTo'] = 100;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/9b42149ee70bbfd53cbaedd3ee257b97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb0cea7d2f89ede366b9b8124b0d45b6')), 'display')) {
    (function () { window.history.back(); })();
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9b42149ee70bbfd53cbaedd3ee257b97'))['icon'] = 'close';
  } else if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4cc43d921412e62604ce8121f83518c7')), 'display')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('17f1266dfb5c067766544ac91f23c797')).pop();
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9b42149ee70bbfd53cbaedd3ee257b97'))['icon'] = 'close';
    ___arguments.context.pageData['stepCount'] = 'Step 1/3';
    ___arguments.context.pageData['subtitle'] = 'Description';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb0cea7d2f89ede366b9b8124b0d45b6', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1bebea2881612e3b8917aee54dca676c', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('660b51459628682615d7c73f825c273e', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f346419c73ff1eb8a5acad1230938847', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d79f2bb365d14a49a78c9799b2dffb13', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8969145a18dfd7cf6982d3287c9abc94', false);
    if (getObjectProperty(___arguments.context.pageData, 'financialRoleRequired')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b45a85cc462475129ac5857f1d051f3c', false);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4cc43d921412e62604ce8121f83518c7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e561a1da3fd68df7a55b9c48ebdce91a', false);
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a915ac93423faf18518809839f0bf768')));
  } else if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2894dfb56f3475328becafc550390aa5')), 'display')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9b42149ee70bbfd53cbaedd3ee257b97'))['icon'] = 'keyboard_arrow_left';
    ___arguments.context.pageData['stepCount'] = 'Step 2/3';
    ___arguments.context.pageData['subtitle'] = '2. A few additional details...';
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d74362cb5191d50acf435d28d2685ecd')).slice(-1)[0] == 'activity-page__step--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d74362cb5191d50acf435d28d2685ecd')).pop();
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8969145a18dfd7cf6982d3287c9abc94', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4cc43d921412e62604ce8121f83518c7', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e561a1da3fd68df7a55b9c48ebdce91a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('2894dfb56f3475328becafc550390aa5', false);
    if (getObjectProperty(___arguments.context.pageData, 'financialRoleRequired')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b45a85cc462475129ac5857f1d051f3c', true);
    }
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a915ac93423faf18518809839f0bf768')));
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 768) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/5c1c426d869da14e67a74c4794cc5497/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['clicked'] = 'activate';
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55fc651734015d54208a191fb8d6e712')), 'open');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'activityStatus')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/551ecc5a1f06adf31ce7bfb35692cba1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'clicked')) == 'pause') {
    return 'Pause activity?';
  } else if ((getObjectProperty(___arguments.context.pageData, 'clicked')) == 'activate') {
    return 'Reactivate activity?';
  } else if ((getObjectProperty(___arguments.context.pageData, 'clicked')) == 'delete') {
    return 'Delete activity?';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/533883c9b1caa6389b2614327199d5c3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'clicked')) == 'pause') {
    return 'Do you want to pause your activity? You can resume it any time.';
  } else if ((getObjectProperty(___arguments.context.pageData, 'clicked')) == 'activate') {
    return 'Do you want to reactivate your activity? ';
  } else if ((getObjectProperty(___arguments.context.pageData, 'clicked')) == 'delete') {
    return 'Do you want to delete your activity forewer?';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/251b06d10e5166398fe10bf97c3436c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55fc651734015d54208a191fb8d6e712')), 'open');
  ___arguments.context.pageData['clicked'] = 'delete';
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('25eef25a872a7fc22ee56697dc47bead')), 'btn-delete');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/d2880cb689cdfb1663074bfb040eacc5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('25eef25a872a7fc22ee56697dc47bead')).slice(-1)[0] == 'btn-delete') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('25eef25a872a7fc22ee56697dc47bead')).pop();
  }
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55fc651734015d54208a191fb8d6e712')).pop();
  delete ___arguments.context.pageData['clicked'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/c80531f3848493df2ba13bc6e5f8e30a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55fc651734015d54208a191fb8d6e712')).pop();
  delete ___arguments.context.pageData['clicked'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/25eef25a872a7fc22ee56697dc47bead/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      if ((___arguments.context.pageData['clicked']) == 'pause') {
    return 'Pause';
  } else if ((___arguments.context.pageData['clicked']) == 'activate') {
    return 'Activate';
  } else if ((___arguments.context.pageData['clicked']) == 'delete') {
    return 'Delete';
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var mediaItem, item, chat;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if ((getObjectProperty(___arguments.context.pageData, 'clicked')) == 'pause') {
    ___arguments.context.pageData['activityStatus'] = false;
    (getObjectProperty(___arguments.context.pageData, 'activityData'))['activityStatus'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55fc651734015d54208a191fb8d6e712')).pop();
  } else if ((getObjectProperty(___arguments.context.pageData, 'clicked')) == 'activate') {
    ___arguments.context.pageData['activityStatus'] = true;
    (getObjectProperty(___arguments.context.pageData, 'activityData'))['activityStatus'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55fc651734015d54208a191fb8d6e712')).pop();
  } else if ((getObjectProperty(___arguments.context.pageData, 'clicked')) == 'delete') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d5eee36abb4cfa9f8365814d0a614636', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('25eef25a872a7fc22ee56697dc47bead'))['disabled'] = true;
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'preferences')) {
      await Backendless.Data.of('Activity').deleteRelation((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'objectId')), 'preferences', [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'preferences')), 'objectId'))]);
      await Backendless.Data.of('ActivityPreferences').remove( (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'preferences')), 'objectId')) );
    }
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'chat')) {
      await Backendless.Data.of('Activity').deleteRelation((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'objectId')), 'chat', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'chat')));
      var chat_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'chat'));
      for (var chat_index in chat_list) {
        chat = chat_list[chat_index];
        await Backendless.Data.of('Activity').deleteRelation((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'objectId')), 'chat', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'chat')));
        await Backendless.Data.of('Chat').deleteRelation((getObjectProperty(chat, 'objectId')), 'message', (getObjectProperty(chat, 'message')));
        await Backendless.Data.of('Message').remove( ((getObjectProperty(chat, 'message'))[0]) );
        await Backendless.Data.of('Chat').remove( (getObjectProperty(chat, 'objectId')) );
      }
    }
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'media')) {
      var mediaItem_list = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'media')).map(async item => {; return (getObjectProperty(item, 'file'));})));
      for (var mediaItem_index in mediaItem_list) {
        mediaItem = mediaItem_list[mediaItem_index];
        await Backendless.Files.remove(encodePath(mediaItem));
      }
    }
    await Backendless.Data.of('Activity').remove( (getObjectProperty(___arguments.context.pageData, 'activityData')) );
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('25eef25a872a7fc22ee56697dc47bead')).pop();
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55fc651734015d54208a191fb8d6e712')).pop();
    (function () { window.history.back(); })();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/f1ee55cfbe4234e286b67af213d2aab4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'activityData')), 'activityStatus')) == false) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['clicked'] = 'pause';
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55fc651734015d54208a191fb8d6e712')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/bca2a2861ef8e9c83419c4a9fd18a693/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/6c99d4f137c2caa70a14d8befac60b2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('3f2f1461d4b8879860f88a47d893f946')) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c99d4f137c2caa70a14d8befac60b2a')).slice(-1)[0] == 'active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6c99d4f137c2caa70a14d8befac60b2a')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/439580fc858a943a8d9ff8baba5c87e2/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('905564fd6ac642ebbd3993d3c749272c')) {
    await (async function(range, data) {
    	range.addEventListener('mouseup', function() {
    	  data.countStart = true
    	});
    })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('905564fd6ac642ebbd3993d3c749272c')), 'el')), ___arguments.context.pageData);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/94533b850a9c5007aa3e17b5de920086/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/ababb6766daebdb5b1894c9eecaba311/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = '50vh';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fbc96caa52f832692ef7e37b5029c8a5')));
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3f1ca6cacabbc6ba65f71d21d8092c88')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/d79f2bb365d14a49a78c9799b2dffb13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/49c1c1acb996dcd6ae2401c195a34227/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['genderList'] = [({ 'label': 'Female' }), ({ 'label': 'Male' }), ({ 'label': 'Non-Binary' })];
  if ((getObjectProperty(___arguments.context.pageData, 'gender')) && (getObjectProperty(___arguments.context.pageData, 'gender')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a6cc267ff1834d4e052611c72f1f1d9'))['checked'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7bedbfcd637446769de998b874a864df'))['opacity'] = 1;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7bedbfcd637446769de998b874a864df'))['opacity'] = 0.35;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a6cc267ff1834d4e052611c72f1f1d9'))['checked'] = true;
  }

  },
  /* handler:onMounted */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
      return (___arguments.context.pageData['genderList'])

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/1968b677b4c8e4f45d48bc9abba22923/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a6cc267ff1834d4e052611c72f1f1d9'))['checked'] = false;
    addItemToList((getObjectProperty(___arguments.context.pageData, 'gender')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6731709f84dd0a3cecc16e77ac81105'), 'label')));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7bedbfcd637446769de998b874a864df'))['opacity'] = 1;
  } else {
    ___arguments.context.pageData['gender'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'gender')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6731709f84dd0a3cecc16e77ac81105'), 'label')));
    }));
    if ((getObjectProperty(___arguments.context.pageData, 'gender')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2a6cc267ff1834d4e052611c72f1f1d9'))['checked'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7bedbfcd637446769de998b874a864df'))['opacity'] = 0.35;
    }
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'gender')) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'gender')), async (item) => {


     return (item == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('d6731709f84dd0a3cecc16e77ac81105'), 'label')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/a059d45ebf8a77f9cbecf1a5f9a16547/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'ongoing')) {
    ___arguments.context.pageData['ongoing'] = false;
  }
  if (getObjectProperty(___arguments.context.pageData, 'ongoingInput')) {
    ___arguments.context.pageData['ongoingInput'] = '';
  }
  if (getObjectProperty(___arguments.context.pageData, 'specific')) {
    ___arguments.context.pageData['specific'] = false;
    ___arguments.context.pageData['ongoing'] = true;
  }
  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f')), 'value')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10476337a1fe6ff828cd2ade6062f95f'))['value'] = '';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/751ca91f986ded6e6d9292580c28b073/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    try {
      await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('REQUEST_CAMERA_PERMISSIONS', undefined);
      await (async function() {
      	const btn = document.querySelector('.activity-page__upload-button')

      	btn.click()
      })();
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('751ca91f986ded6e6d9292580c28b073')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('751ca91f986ded6e6d9292580c28b073')), 'hidden');
      }

    } catch (error) {
      console.log(error);
      await (async function() {
      	const btn = document.querySelector('.activity-page__upload-button')

      	btn.click()
      })();
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('751ca91f986ded6e6d9292580c28b073')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('751ca91f986ded6e6d9292580c28b073')), 'hidden');
      }

    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992 && (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/16072df84cd60c7c36b223120beab8fb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'media'))) {
    ___arguments.context.pageData['media'] = [];
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'media2'))) {
    ___arguments.context.pageData['media2'] = (getObjectProperty(___arguments.context.pageData, 'media'));
  }

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var path;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'isDrag')) {
    path = ['/pictures/activities/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('');
    await (async function(path, mediaList, media2, data) {
    	async function resizeFiles(files, width, percent) {
    	  for (let index = 0; index < files.length; index++) {
    	    const file = files[index]

    	    const fileName = file.name

    	    const content = await readFileAsDataURL(file)

    	    const img = await getNewImage(content)

    	    const elem = document.createElement('canvas')

    	    const widthImage = !width ? img.width : width
    	    const scaleFactor = width && width / img.width
    	    const heightImage = width ? img.height * scaleFactor : img.height

    	    elem.width = widthImage
    	    elem.height = heightImage

    	    const ctx = elem.getContext('2d')

    	    ctx.drawImage(img, 0, 0, widthImage, heightImage)

    	    const blob = await getCanvasBlob(ctx.canvas, percent)

    	    const newFile = new File([blob], fileName, {
    	      type: 'image/jpeg',
    	      lastModified: Date.now()
    	    })

    	    files[index] = newFile
    	  }

    	  async function readFileAsDataURL(file) {
    	    const result = await new Promise((resolve) => {
    	      const fileReader = new FileReader()

    	      fileReader.onload = (e) => resolve(e.target.result)

    	      fileReader.readAsDataURL(file)
    	    })

    	    return result;
    	  }

    	  async function getNewImage(content) {
    	    const result = await new Promise((resolve) => {
    	      const img = new Image()

    	      img.src = content

    	      img.onload = () => resolve(img)
    	    })

    	    return result
    	  }

    	  async function getCanvasBlob(canvas, percent) {
    	    const result = await new Promise((resolve) => {
    	      canvas.toBlob((blob) => {
    	        resolve(blob)
    	      }, 'image/jpeg', percent)
    	    })

    	    return result
    	  }

    	  uploadFile(files);
    	}

    	const dropArea = document.querySelector('.content__upload-button');

    	  dropArea.addEventListener("dragover", (event) => {
    	    event.preventDefault();
    	    dropArea.classList.add('active');
    	  });

    	  dropArea.addEventListener("dragleave", () => {
    	    dropArea.classList.remove('active');
    	  });


    	  function uploadFile(files) {
    	    files.forEach((file) => {
    	      if (file.type.includes('image')) {
    	        Backendless.Files.upload(file, path, overwrite = true)
    	      .then(function(fileURL) {
    	          let media = {
    	            file: fileURL.fileURL,
    	            isCover: false
    	          }
    	          // console.log('новый айтем', media)
    	          data.media.push(media);
    	          data.media[0].isCover = true;

    	          data.media2 = data.media
    	          data.isDrag = true

    	        })
    	      .catch( function( error ) {
    	        console.log(error)
    	        })
    	      }
    	    })

    	    return data.media;
    	  }

    	  dropArea.addEventListener("drop", (event) => {
    	    event.preventDefault();
    	    let files = event.dataTransfer.files;
    	    resizeFiles([...files], 700, 80);
    	    dropArea.classList.remove('active');
    	  });







    })(path, (getObjectProperty(___arguments.context.pageData, 'media')), (getObjectProperty(___arguments.context.pageData, 'media2')), ___arguments.context.pageData);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/d971d2c6243db0de0cf9b0db820b6154/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'media'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(j, 'file')).split('/')[0] == 'https:' && subsequenceFromEndLast((getObjectProperty(j, 'file')).split('/'), 4).join('/') != 'api') {
      j['file'] = (String('/') + String(subsequenceFromEndLast((getObjectProperty(j, 'file')).split('/'), 4).join('/')));
      if ((getObjectProperty(j, 'file')).split('/')[1] == 'files') {
        j['file'] = (String('/') + String(subsequenceFromStartLast((getObjectProperty(j, 'file')).split('/'), 2).join('/')));
      }
    }
  }
  console.log(getObjectProperty(___arguments.context.pageData, 'media'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/929cd1810fdb400ae93cb10ecb017656/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'driver')) || (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput'))) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/868da6ce3d9a1f7a7a2d2065c3632ab7/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'passenger')) || (getObjectProperty(___arguments.context.pageData, 'payYourOwnWayInput'))) {
    return 'styles/img/icons/pic_profile.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/d50ac93627f30aaf95a14606d4b52cc4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d50ac93627f30aaf95a14606d4b52cc4')).slice(-1)[0] != 'activity-page__preference-item--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d50ac93627f30aaf95a14606d4b52cc4')), 'activity-page__preference-item--active');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('be95e2d537ab9da36dd758fc41d51e16')), 'activity-page__preference-block--open');
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d50ac93627f30aaf95a14606d4b52cc4')).slice(-1)[0] == 'activity-page__preference-item--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d50ac93627f30aaf95a14606d4b52cc4')).pop();
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('be95e2d537ab9da36dd758fc41d51e16')).pop();
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/edit-activity-old/components/be95e2d537ab9da36dd758fc41d51e16/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d50ac93627f30aaf95a14606d4b52cc4')).slice(-1)[0] == 'activity-page__preference-item--active') {
    return ['activity-page__preference-block', 'activity-page__preference-block--open'];
  }

  return ['activity-page__preference-block']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/8e97394d6dec608352fd718b71063337/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
      if (___arguments.value == true) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c35b21d7912ea5dd1203fc3d1b9d94'))['opacity'] = 0.35;
    ___arguments.context.pageData['dietaryPreferenceCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c35b21d7912ea5dd1203fc3d1b9d94'))['opacity'] = 1;
    delete ___arguments.context.pageData['dietaryPreferenceCheckbox'];
  }
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/edit-activity-old/components/6a2c7638efd790897fee6c335904c697/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('6a2c7638efd790897fee6c335904c697', (getObjectProperty(___arguments.context.appData, 'dietaryList')));
  if ((getObjectProperty(___arguments.context.pageData, 'dietaryPreference')) && (getObjectProperty(___arguments.context.pageData, 'dietaryPreference')).length > 0) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c35b21d7912ea5dd1203fc3d1b9d94'))['opacity'] = 1;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e97394d6dec608352fd718b71063337'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c35b21d7912ea5dd1203fc3d1b9d94'))['opacity'] = 0.35;
    ___arguments.context.pageData['dietaryPreference'] = [];
    ___arguments.context.pageData['dietaryPreferenceId'] = [];
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/edit-activity-old/components/7e4f636d15fdbe89f507a5df549ad46c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var dietary;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8e97394d6dec608352fd718b71063337'))['checked'] = false;
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('a7c35b21d7912ea5dd1203fc3d1b9d94'))['opacity'] = 1;
  dietary = (getObjectProperty(___arguments.context.pageData, 'dietaryPreference'));
  if (___arguments.value == true) {
    addItemToList(dietary, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54c9886ca791c3b7c2ed333dbe5949cd'), 'objectId')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'dietaryPreferenceId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54c9886ca791c3b7c2ed333dbe5949cd'), 'id')));
  } else {
    (getObjectProperty(___arguments.context.pageData, 'dietaryPreference')).splice(((dietary.indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('54c9886ca791c3b7c2ed333dbe5949cd'), 'objectId')) + 1) - 1), 1);
    (getObjectProperty(___arguments.context.pageData, 'dietaryPreferenceId')).splice((((getObjectProperty(___arguments.context.pageData, 'dietaryPreferenceId')).indexOf(getObjectProperty(___arguments.context.getComponentDataStoreByUid('54c9886ca791c3b7c2ed333dbe5949cd'), 'id')) + 1) - 1), 1);
  }
  ___arguments.context.pageData['dietaryPreference'] = dietary;
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_bab1f0b5ad1751b1ff61bf156822e044'](___arguments.context.pageData, ___arguments.context.appData);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = (getObjectProperty(___arguments.context.pageData, 'dietaryPreference'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (j == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('54c9886ca791c3b7c2ed333dbe5949cd'), 'objectId'))) {
      return true;
    }
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/edit-activity-old/components/ec53c04cdfab00ea1fae18bcda084964/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['briefDescriptionCounter'] = (String(getValueLength(___arguments.value)) + String('/500 symbols'));
  if (!___arguments.value.trim().length) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ec53c04cdfab00ea1fae18bcda084964')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ec53c04cdfab00ea1fae18bcda084964')), 'alert-border');
      ___arguments.context.pageData['activityTitleAlertText'] = 'Please, describe your activity';
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ec53c04cdfab00ea1fae18bcda084964')).includes('alert-border')) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ec53c04cdfab00ea1fae18bcda084964')), 'alert-border', '');
      ___arguments.context.pageData['activityTitleAlertText'] = '';
    }
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 350 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = '50vh';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5af3c5ecbbddcae97bb7c376821842a9')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d79f2bb365d14a49a78c9799b2dffb13'))['margin-bottom'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/group-page/components/baecc013db89a295072fa3537a3ae97b/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791')['current']) {
    return ['gallery__slider-image', 'messages-gallery', 'image', 'visible'];
  }

  return ['gallery__slider-image', 'messages-gallery', 'image']

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791'), 'type')) == 'image')

  },
  /* handler:onDisplayAssignment */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791')['type']) == 'image') {
    return (___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791')['message']);
  }

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/1cbf6c166b68abae4248a1bf6cda9777/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var itemList, nextItem, currentItemIndex, j;


  itemList = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('998fdfebf2b3a7afe31c706a04e836f1'));
  currentItemIndex = 0;
  for (var j_index in itemList) {
    j = itemList[j_index];
    if (j['current']) {
      currentItemIndex = itemList.indexOf(j) + 1;
      j['current'] = false;
    }
  }
  nextItem = itemList[((currentItemIndex + 1) - 1)];
  if (nextItem) {
    nextItem['current'] = true;
  } else {
    (itemList[0])['current'] = true;
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/0285c0180af9eeb9e84dfbf86fa90a81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var itemList, previousItem, currentItemIndex, j;


  itemList = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('998fdfebf2b3a7afe31c706a04e836f1'));
  currentItemIndex = 0;
  for (var j_index in itemList) {
    j = itemList[j_index];
    if (j['current']) {
      currentItemIndex = itemList.indexOf(j) + 1;
      j['current'] = false;
    }
  }
  previousItem = itemList[((currentItemIndex - 1) - 1)];
  if (previousItem) {
    previousItem['current'] = true;
  } else {
    (itemList.slice(-1)[0])['current'] = true;
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/5741032c5bc8e709d218926d5fc6ca07/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentItem, item;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'mediaMessages')) {
    currentItem = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'mediaMessages')), async (item) => {


     return ((getObjectProperty(item, 'current')) == true);
    }))[0];
    return ([(getObjectProperty(___arguments.context.pageData, 'mediaMessages')).indexOf(currentItem) + 1,'/',(getObjectProperty(___arguments.context.pageData, 'mediaMessages')).length].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/20caf2e5080a4bdca666ecc304961efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8968a8769b41fc3e6ad822d8ff0d0c75', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/209f76aea5a1596a808900fda74b4dd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
    }
  } else {
    if ((getObjectProperty(___arguments.context.appData, 'photoThumbnail')) && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
      return (getObjectProperty(___arguments.context.appData, 'photoThumbnail'));
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/b396680db47c2819f51d8bb87e2a2c45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (___arguments.context.pageData['currentUser']) {
      return (!((___arguments.context.pageData['currentUser'])['photoThumbnail']));
    } else {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/eb12e5dc7373502a78063e5e7aa5c957/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/e6ef7d041ac13c14d411af83c3f8bd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('profiles', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/061e6307bb3fb9b624d268225542836e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('interests', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/318563325306ad2e6d432468a69beb08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-profile', null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] != 'open') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')), 'open');
  }

  },  
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] == 'open') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).pop();
  }

  },  
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/group-page/components/b3372f6ac9172b9f4ac43c9eaf8cf874/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('create-activity', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/1403f1347411c92ad1ac3f85633ed0b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
      return (((___arguments.context.pageData['openMessage'])['sender'])['name']);
    } else {
      return (((___arguments.context.pageData['openMessage'])['receiver'])['name']);
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/33fa9bfc9a64afa2cb8db4a6580b59fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/0e1d900704dd8c2c3d319fe85b9e8bef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item, senderMessageIds;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('0e1d900704dd8c2c3d319fe85b9e8bef')).includes('current')) {
    return ;
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('0e1d900704dd8c2c3d319fe85b9e8bef')), 'current');
    if (!(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active'))) {
      addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')), 'active');
    }
    ___arguments.context.pageData['currentTab'] = 'invitations';
    await BackendlessUI.Functions.Custom['fn_30743f6255d6db0f649790555183a8e3'](___arguments.context.pageData)
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active')) {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).pop();
    }
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.pageData['currentTab']) == 'invitations') {
    return ['MessagesTabs__item', 'current'];
  }

  return ['MessagesTabs__item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/group-page/components/6553c1191ba9a6e56e9f5f3cbc7922af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item, senderMessageIds;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6553c1191ba9a6e56e9f5f3cbc7922af')).includes('current')) {
    return ;
  } else {
    if (!(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active'))) {
      addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')), 'active');
    }
    ___arguments.context.pageData['currentTab'] = 'chats';
    await BackendlessUI.Functions.Custom['fn_30743f6255d6db0f649790555183a8e3'](___arguments.context.pageData)
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active')) {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).pop();
    }
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6553c1191ba9a6e56e9f5f3cbc7922af')), 'current');
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.pageData['currentTab']) == 'chats') {
    return ['MessagesTabs__item', 'current'];
  }

  return ['MessagesTabs__item']

  },  
  /* handler:onClassListAssignment */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.pageData['newMessages'] = 0;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/group-page/components/0549422597933f442a3e2f6b8c6e9098/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['myActivities']) {
    return (['My Activities (',(___arguments.context.pageData['myActivities']).length,')'].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/13b79621ceddcdf61857572a170777b1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'invitedActivities')) {
    return (['Activities I was invited to (',(getObjectProperty(___arguments.context.pageData, 'invitedActivities')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/e75e3884c062478d9694aee9d6bff1b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('57d9567f707fa45310b99cff3512d022')['name'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/8aae1e7c39eb9d74fb97bd5d387e98bc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('57d9567f707fa45310b99cff3512d022'), 'activityDate')) {
    return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('57d9567f707fa45310b99cff3512d022'), 'activityDate'))));
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('57d9567f707fa45310b99cff3512d022'), 'ongoingTiming')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('57d9567f707fa45310b99cff3512d022'), 'ongoingTiming'));
  } else {
    return 'To be scheduled';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/cbfcde3c766b258466388e811a4cbdbc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793')['name'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/c5aaaa040a869217fd7441db4f4a98e3/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if (((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['receiver'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
    if ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['sender'])['photo']) {
      return ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['sender'])['photo']);
    }
  } else {
    if ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['receiver'])['photo']) {
      return ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['receiver'])['photo']);
    }
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/22ce372babbdf6181cea0b917286f81c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['receiver'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
    return ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['sender'])['name']);
  } else {
    return ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['receiver'])['name']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/9d9b199c3b423c0820da700fba020d2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2b2979e1c33b6e361a2e22985a7bf6bc')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2b2979e1c33b6e361a2e22985a7bf6bc')).pop();
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('b0fa8d0f8b749fcb518a565aa305b8ee')), 'closed');
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('2b2979e1c33b6e361a2e22985a7bf6bc')), 'open');
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('b0fa8d0f8b749fcb518a565aa305b8ee')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/a573a11147e8e9530d276b5eab67de36/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e96d02d68b080cf24fd310f54ae74813')).includes('open')) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ffbfc9034975dd5bb256f0278a1f4bd8', false);
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e96d02d68b080cf24fd310f54ae74813')).pop();
  } else {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ffbfc9034975dd5bb256f0278a1f4bd8', true);
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e96d02d68b080cf24fd310f54ae74813')), 'open');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/9f67c86996d18b6d7ddec78df78c4fb3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var item;



  return (await BackendlessUI.Functions.Custom['fn_f19ee1336b67ca26c4d92a38762420fa']((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['recentMessage'])))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/6702a3f8c207b336ecd19d6d51a6dd76/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var chat;


  if (((___arguments.context.pageData['currentUser'])['objectId']) == (((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['recentMessage'])['receiver'])['objectId']) && ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['recentMessage'])['isRead']) == false) {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/1ec90f8535c92c3f1cced26a5017da3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('cd753f78175390294544bc17bc05c793')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('cd753f78175390294544bc17bc05c793')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/e96d02d68b080cf24fd310f54ae74813/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['invitedActivities']) {
    return ((___arguments.context.pageData['invitedActivities']).length);
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/2b2979e1c33b6e361a2e22985a7bf6bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['myActivities']) {
    return ((___arguments.context.pageData['myActivities']).length);
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/23e9db8f324d6c9c77a611cf7e162196/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
    var updatedUser, user, newChat, item, newActivity, newChatObject, currentUser, mapChats, receiverPhoto, j, object, senderUserProfilesId, receiverUserProfilesId, updatedChatItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getReceivedMessages() {
  if ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')), 'active');
    }
  }
  ___arguments.context.pageData['chats'] = (await Backendless.Data.of('Chat').find(Backendless.DataQueryBuilder.create().setWhereClause(([['isBlocked=0 and (receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\' or '].join(''),['sender.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\')'].join(''),String([' and (receiver.userProfile.blockList.objectId not in (\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\') or receiver.userProfile.blockList.objectId is null) and '].join('')) + String(['(sender.userProfile.blockList.objectId not in (\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\') or sender.userProfile.blockList.objectId is null)'].join(''))].join(''))).setProperties(['receiver.userProfile.media as receiverPhoto', 'sender.userProfile.media as senderPhoto', 'activityId', 'deletedByReceiver', 'deletedBySender', 'objectId', 'status', 'type', 'isBlocked', 'receiver.userProfile.objectId as receiverUserProfile', 'sender.userProfile.objectId as senderUserProfile']).setRelated(['receiver', 'sender', 'recentMessage', 'recentMessage.sender', 'recentMessage.receiver']).setSortBy('created desc').setGroupBy('objectId').setPageSize(100)));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'chats'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    await BackendlessUI.Functions.Custom['fn_57135e2cd68ac40b08da3b12a576bccb'](j);
  }
  ___arguments.context.pageData['receivedChats'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'chats')), async (item) => {
     if ((getObjectProperty(item, 'type')) == 'activityRequest' && (getObjectProperty(item, 'status')) == 'accepted' || (getObjectProperty(item, 'type')) == 'acceptedInvitation') {
      return item;
    }


   return ;
  }));
  ___arguments.context.pageData['receivedChats'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'receivedChats')), async (item) => {
     if ((getObjectProperty(item, 'deletedBySender')) || (getObjectProperty(item, 'deletedByReceiver'))) {
      if ((getObjectProperty((getObjectProperty(item, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        return ((getObjectProperty(item, 'deletedBySender')) < (getObjectProperty((getObjectProperty(item, 'recentMessage')), 'created')));
      } else {
        return ((getObjectProperty(item, 'deletedByReceiver')) < (getObjectProperty((getObjectProperty(item, 'recentMessage')), 'created')));
      }
    } else {
      return item;
    }


   return ;
  }));
  ___arguments.context.pageData['activityMessages'] = (await Backendless.Data.of('Activity').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId IN (\'',((getObjectProperty(___arguments.context.pageData, 'receivedChats')).map(item => item['activityId'])).join('\',\''),'\')'].join(''))).setProperties(['objectId', 'author.name as authorName', 'author.birthDate as authorBirthDate', 'author.userProfile.media as authorMedia', 'author.objectId as authorObjectId', 'name', 'activityDate', 'author.online as onlineAuthor', 'description', 'financialRole', 'ongoingTiming', 'chat', 'chat.type', 'chat.status', 'visibility']).setPageSize(100)));
  var j_list2 = (getObjectProperty(___arguments.context.pageData, 'activityMessages'));
  for (var j_index2 in j_list2) {
    j = j_list2[j_index2];
    if (getObjectProperty(j, 'authorMedia')) {
      receiverPhoto = (await asyncListFilter((getObjectProperty(j, 'authorMedia')), async (item) => {


       return (getObjectProperty(item, 'isCover'));
      }))[0];
      j['authorPhoto'] = (getObjectProperty(receiverPhoto, 'file'));
    }
  }
  ___arguments.context.pageData['myActivities'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityMessages')), async (item) => {


   return ((getObjectProperty(item, 'authorObjectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')));
  }));
  ___arguments.context.pageData['invitedActivities'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityMessages')), async (item) => {


   return ((getObjectProperty(item, 'authorObjectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')));
  }));
  ___arguments.context.pageData['receivedSystemMessages'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'chats')), async (item) => {
     if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(item, 'receiver')), 'objectId')) && (getObjectProperty(item, 'status')) == 'new') {
      return item;
    }


   return ;
  }));
  ___arguments.context.pageData['sentSystemMessages'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'chats')), async (item) => {
     if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(item, 'sender')), 'objectId')) && ((getObjectProperty(item, 'status')) != 'accepted' && (getObjectProperty(item, 'type')) != 'requestPermission' || (getObjectProperty(item, 'type')) == 'requestPermission')) {
      return item;
    }


   return ;
  }));
  ___arguments.context.pageData['usersOnPage'] = [];
  mapChats = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'chats')).map(async item => {  addItemToList((getObjectProperty(___arguments.context.pageData, 'usersOnPage')), (getObjectProperty(item, 'sender')));
    addItemToList((getObjectProperty(___arguments.context.pageData, 'usersOnPage')), (getObjectProperty(item, 'receiver')));
  ; return ;})));
  getRTSubscriptions().remove('blockedUser');
  await getBlockedUser();
  if ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active')) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).pop();
    }
  }
}

/**
 * Describe this function...
 */
async function getBlockedUser() {
  receiverUserProfilesId = ((getObjectProperty(___arguments.context.pageData, 'chats')).map(item => item['receiverUserProfile']));
  senderUserProfilesId = ((getObjectProperty(___arguments.context.pageData, 'chats')).map(item => item['senderUserProfile']));

  ;(function(parentObjects) {
    const callback = async object => {
        if ((getObjectProperty(object, 'children'))[0] == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) || (getObjectProperty(object, 'parentObjectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId'))) {
      await getReceivedMessages();
      ___arguments.context.pageData['currentActivity'] = null;
      ___arguments.context.pageData['openMessage'] = null;
      getRTSubscriptions().remove('newMessages');
      await BackendlessUI.Functions.Custom['fn_2e61f0a2adf4439f5332020550ba8c13']((getObjectProperty(___arguments.context.pageData, 'chats')), ___arguments.context.pageData, (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) ? ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) : null));
    }

    };

    const rtHandlers = Backendless.Data.of('UserProfile').rt();

    const options = ['blockList'];

    if (parentObjects) {
       options.push(parentObjects);
    }

    options.push(callback)

    rtHandlers.addAddRelationListener.apply(rtHandlers, options);

    getRTSubscriptions().add('blockedUser', () => rtHandlers.removeAddRelationListener(callback));

  })((receiverUserProfilesId.concat(senderUserProfilesId)));
    }

function subsequenceFromStartFromEnd(sequence, at1, at2) {
  var start = at1;
  var end = sequence.length - 1 - at2 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function updatedChatListener() {

  ;(function(whereClause) {
    const callback = async object => {
        updatedChatItem = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'chats')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == subsequenceFromStartFromEnd((getObjectProperty(object, 'whereClause')), 10, 1));
    }))[0];
    if (updatedChatItem) {
      updatedChatItem = (await Backendless.Data.of('Chat').findById((getObjectProperty(updatedChatItem, 'objectId')), Backendless.DataQueryBuilder.create().setProperties(['receiver.userProfile.media as receiverPhoto', 'sender.userProfile.media as senderPhoto', 'activityId', 'deletedByReceiver', 'deletedBySender', 'objectId', 'status', 'type', 'isBlocked', 'receiver.userProfile.objectId as receiverUserProfile', 'sender.userProfile.objectId as senderUserProfile']).setRelated(['receiver', 'sender', 'recentMessage', 'recentMessage.sender', 'recentMessage.receiver'])));
      await BackendlessUI.Functions.Custom['fn_57135e2cd68ac40b08da3b12a576bccb'](updatedChatItem);
      if ((getObjectProperty(updatedChatItem, 'type')) == 'acceptedInvitation' && (getObjectProperty(updatedChatItem, 'status')) == 'accepted' || (getObjectProperty(updatedChatItem, 'type')) == 'activityRequest' && (getObjectProperty(updatedChatItem, 'status')) == 'accepted') {
        if ((getObjectProperty(updatedChatItem, 'deletedByReceiver')) || (getObjectProperty(updatedChatItem, 'deletedBySender'))) {
          if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(updatedChatItem, 'receiver')), 'objectId'))) {
            if (getObjectProperty(updatedChatItem, 'deletedByReceiver')) {
              if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
                if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(updatedChatItem, 'objectId'))) {
                  ___arguments.context.pageData['currentActivity'] = null;
                  ___arguments.context.pageData['openMessage'] = null;
                }
              }
              await getReceivedMessages();
              getRTSubscriptions().remove('newMessages');
              await BackendlessUI.Functions.Custom['fn_2e61f0a2adf4439f5332020550ba8c13']((getObjectProperty(___arguments.context.pageData, 'chats')), ___arguments.context.pageData, (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) ? ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) : null));
            }
          } else {
            if (getObjectProperty(updatedChatItem, 'deletedBySender')) {
              if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
                if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(updatedChatItem, 'objectId'))) {
                  ___arguments.context.pageData['currentActivity'] = null;
                  ___arguments.context.pageData['openMessage'] = null;
                }
              }
              await getReceivedMessages();
              getRTSubscriptions().remove('newMessages');
              await BackendlessUI.Functions.Custom['fn_2e61f0a2adf4439f5332020550ba8c13']((getObjectProperty(___arguments.context.pageData, 'chats')), ___arguments.context.pageData, (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) ? ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) : null));
            }
          }
        } else {
          if (((getObjectProperty(___arguments.context.pageData, 'receivedSystemMessages')).map(item => item['objectId'])).includes((getObjectProperty(updatedChatItem, 'objectId')))) {
            (getObjectProperty(___arguments.context.pageData, 'receivedSystemMessages')).splice(((((getObjectProperty(___arguments.context.pageData, 'receivedSystemMessages')).map(item => item['objectId'])).indexOf(getObjectProperty(updatedChatItem, 'objectId')) + 1) - 1), 1);
          } else if (((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')).map(item => item['objectId'])).includes((getObjectProperty(updatedChatItem, 'objectId')))) {
            (getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')).splice(((((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')).map(item => item['objectId'])).indexOf(getObjectProperty(updatedChatItem, 'objectId')) + 1) - 1), 1);
          }
          if (((getObjectProperty(___arguments.context.pageData, 'chats')).map(item => item['objectId'])).includes((getObjectProperty(updatedChatItem, 'objectId')))) {
            ((getObjectProperty(___arguments.context.pageData, 'chats'))[((((getObjectProperty(___arguments.context.pageData, 'chats')).map(item => item['objectId'])).indexOf(getObjectProperty(updatedChatItem, 'objectId')) + 1) - 1)])['status'] = 'accepted';
            ((getObjectProperty(___arguments.context.pageData, 'chats'))[((((getObjectProperty(___arguments.context.pageData, 'chats')).map(item => item['objectId'])).indexOf(getObjectProperty(updatedChatItem, 'objectId')) + 1) - 1)])['type'] = (getObjectProperty(updatedChatItem, 'type'));
            updatedChatItem = (getObjectProperty(___arguments.context.pageData, 'chats'))[((((getObjectProperty(___arguments.context.pageData, 'chats')).map(item => item['objectId'])).indexOf(getObjectProperty(updatedChatItem, 'objectId')) + 1) - 1)];
          } else {
            addItemToList((getObjectProperty(___arguments.context.pageData, 'chats')), updatedChatItem);
          }
          if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
            if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(updatedChatItem, 'objectId'))) {
              ___arguments.context.pageData['openMessage'] = updatedChatItem;
            }
          }
          ___arguments.context.pageData['receivedChats'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'chats')), async (item) => {
             if ((getObjectProperty(item, 'type')) == 'activityRequest' && (getObjectProperty(item, 'status')) == 'accepted' || (getObjectProperty(item, 'type')) == 'acceptedInvitation') {
              return item;
            }


           return ;
          }));
          ___arguments.context.pageData['chats'] = (((getObjectProperty(___arguments.context.pageData, 'receivedSystemMessages')).concat((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')))).concat((getObjectProperty(___arguments.context.pageData, 'receivedChats'))));
          getRTSubscriptions().remove('newMessages');
          await BackendlessUI.Functions.Custom['fn_2e61f0a2adf4439f5332020550ba8c13']((getObjectProperty(___arguments.context.pageData, 'chats')), ___arguments.context.pageData, (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) ? ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) : null));
          if (!(((getObjectProperty(___arguments.context.pageData, 'activityMessages')).map(item => item['objectId'])).includes((getObjectProperty(updatedChatItem, 'activityId'))))) {
            newActivity = (await Backendless.Data.of('Activity').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(updatedChatItem, 'activityId')),'\' '].join(''))).setProperties(['objectId', 'author.name as authorName', 'author.birthDate as authorBirthDate', 'author.userProfile.media as authorMedia', 'author.objectId as authorObjectId', 'name', 'activityDate', 'author.online as onlineAuthor', 'description', 'financialRole', 'ongoingTiming', 'chat', 'chat.type', 'chat.status', 'visibility']).setPageSize(1)))[0];
            if (getObjectProperty(newActivity, 'authorMedia')) {
              receiverPhoto = (await asyncListFilter((getObjectProperty(newActivity, 'authorMedia')), async (item) => {


               return (getObjectProperty(item, 'isCover'));
              }))[0];
              newActivity['authorPhoto'] = (getObjectProperty(receiverPhoto, 'file'));
            }
            (getObjectProperty(___arguments.context.pageData, 'activityMessages'))[0] = newActivity;
            ___arguments.context.pageData['myActivities'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityMessages')), async (item) => {


             return ((getObjectProperty(item, 'authorObjectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')));
            }));
            ___arguments.context.pageData['invitedActivities'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityMessages')), async (item) => {


             return ((getObjectProperty(item, 'authorObjectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')));
            }));
          }
        }
      } else if ((getObjectProperty(updatedChatItem, 'type')) == 'requestPermission' && (getObjectProperty(updatedChatItem, 'status')) == 'accepted') {
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(updatedChatItem, 'receiver')), 'objectId'))) {
          if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
            if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(updatedChatItem, 'objectId'))) {
              ___arguments.context.pageData['currentActivity'] = null;
              ___arguments.context.pageData['openMessage'] = null;
            }
          }
          await getReceivedMessages();
        } else {
          ((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages'))[((((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')).map(item => item['objectId'])).indexOf(getObjectProperty(updatedChatItem, 'objectId')) + 1) - 1)])['status'] = 'accepted';
        }
      } else if ((getObjectProperty(updatedChatItem, 'status')) == 'rejected') {
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(updatedChatItem, 'receiver')), 'objectId'))) {
          if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
            if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(updatedChatItem, 'objectId'))) {
              ___arguments.context.pageData['currentActivity'] = null;
              ___arguments.context.pageData['openMessage'] = null;
            }
          }
          await getReceivedMessages();
        } else {
          ((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages'))[((((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')).map(item => item['objectId'])).indexOf(getObjectProperty(updatedChatItem, 'objectId')) + 1) - 1)])['status'] = 'rejected';
        }
      }
    }

    };

    const rtHandlers = Backendless.Data.of('Chat').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addBulkUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('updatedChat', () => rtHandlers.removeBulkUpdateListener(callback));

  })('');
    }

/**
 * Describe this function...
 */
async function deleteChatListener() {

  ;(function(whereClause) {
    const callback = async object => {
        updatedChatItem = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'chats')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == subsequenceFromStartFromEnd((getObjectProperty(object, 'whereClause')), 10, 1));
    }))[0];
    console.log(updatedChatItem);
    if (updatedChatItem) {
      if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(updatedChatItem, 'objectId'))) {
          ___arguments.context.pageData['currentActivity'] = null;
          ___arguments.context.pageData['openMessage'] = null;
        }
      }
      await getReceivedMessages();
      getRTSubscriptions().remove('newMessages');
      await BackendlessUI.Functions.Custom['fn_2e61f0a2adf4439f5332020550ba8c13']((getObjectProperty(___arguments.context.pageData, 'chats')), ___arguments.context.pageData, (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) ? ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) : null));
    }

    };

    const rtHandlers = Backendless.Data.of('Chat').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addBulkDeleteListener.apply(rtHandlers, options);

    getRTSubscriptions().add('deleteChat', () => rtHandlers.removeBulkDeleteListener(callback));

  })('');
    }


  if (!(getObjectProperty(___arguments.context.appData, 'userRoles'))) {
    ___arguments.context.appData['userRoles'] = (await Backendless.UserService.getUserRoles());
  }
  if (!((getObjectProperty(___arguments.context.appData, 'userRoles')).includes('dev'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('out-of-service', undefined);
  }
  ___arguments.context.pageData['currentTab'] = 'chats';
  ___arguments.context.pageData['currentUser'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getCurrentUser/getUser`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'properties': JSON.stringify('userProfile'),'page': JSON.stringify('messages') }).send());
  ___arguments.context.pageData['countMessages'] = (await Backendless.Data.of('Message').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['(receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\')  and isRead=false'].join('')))));
  await getReceivedMessages();

  ;(function(parentObjects) {
    const callback = async newChatObject => {
        newChat = (await Backendless.Data.of('Chat').findById(((getObjectProperty(newChatObject, 'children'))[0]), Backendless.DataQueryBuilder.create().setProperties(['receiver.userProfile.media as receiverPhoto', 'sender.userProfile.media as senderPhoto', 'activityId', 'deletedByReceiver', 'deletedBySender', 'objectId', 'status', 'type', 'isBlocked', 'receiver.userProfile.objectId as receiverUserProfile', 'sender.userProfile.objectId as senderUserProfile']).setRelated(['receiver', 'sender', 'recentMessage', 'recentMessage.sender', 'recentMessage.receiver'])));
    await BackendlessUI.Functions.Custom['fn_57135e2cd68ac40b08da3b12a576bccb'](newChat);
    if ((getObjectProperty((getObjectProperty(newChat, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if ((getObjectProperty(newChat, 'status')) == 'new') {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'receivedSystemMessages')), newChat);
      } else {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'receivedChats')), newChat);
      }
      ___arguments.context.pageData['chats'] = (((getObjectProperty(___arguments.context.pageData, 'receivedSystemMessages')).concat((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')))).concat((getObjectProperty(___arguments.context.pageData, 'receivedChats'))));
      getRTSubscriptions().remove('updatedChat');
      getRTSubscriptions().remove('newMessages');
      await updatedChatListener();
      await BackendlessUI.Functions.Custom['fn_2e61f0a2adf4439f5332020550ba8c13']((getObjectProperty(___arguments.context.pageData, 'chats')), ___arguments.context.pageData, (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) ? ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) : null));
    } else {
      if ((getObjectProperty(newChat, 'status')) == 'new') {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')), newChat);
      } else {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'chats')), newChat);
      }
      ___arguments.context.pageData['chats'] = (((getObjectProperty(___arguments.context.pageData, 'receivedSystemMessages')).concat((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')))).concat((getObjectProperty(___arguments.context.pageData, 'receivedChats'))));
      getRTSubscriptions().remove('updatedChat');
      getRTSubscriptions().remove('newMessages');
      await updatedChatListener();
      await BackendlessUI.Functions.Custom['fn_2e61f0a2adf4439f5332020550ba8c13']((getObjectProperty(___arguments.context.pageData, 'chats')), ___arguments.context.pageData, (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) ? ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) : null));
    }

    };

    const rtHandlers = Backendless.Data.of('Users').rt();

    const options = ['chat'];

    if (parentObjects) {
       options.push(parentObjects);
    }

    options.push(callback)

    rtHandlers.addAddRelationListener.apply(rtHandlers, options);

    getRTSubscriptions().add('newChat', () => rtHandlers.removeAddRelationListener(callback));

  })([(getObjectProperty(___arguments.context.pageData, 'currentUser'))]);
    await updatedChatListener();
  await BackendlessUI.Functions.Custom['fn_2e61f0a2adf4439f5332020550ba8c13']((getObjectProperty(___arguments.context.pageData, 'chats')), ___arguments.context.pageData, (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) ? ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) : null));
  await deleteChatListener();

  ;(function(whereClause) {
    const callback = async updatedUser => {
        var user_list = (getObjectProperty(___arguments.context.pageData, 'usersOnPage'));
    for (var user_index in user_list) {
      user = user_list[user_index];
      if ((getObjectProperty(user, 'objectId')) == (getObjectProperty(updatedUser, 'objectId'))) {
        user['online'] = (getObjectProperty(updatedUser, 'online'));
      }
    }

    };

    const rtHandlers = Backendless.Data.of('Users').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('onlineStatus', () => rtHandlers.removeUpdateListener(callback));

  })('');

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  onBeforeUnmount(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}


  getRTSubscriptions().remove('onlineStatus');;
  getRTSubscriptions().remove('newChat');;
  getRTSubscriptions().remove('newMessages');;
  getRTSubscriptions().remove('updatedChat');;
  getRTSubscriptions().remove('blockedUser');;
  getRTSubscriptions().remove('deleteChat');;
  getRTSubscriptions().remove('newMessegesCount');;

  },  
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/group-page/components/6b3b183f5582e9f2aa59b0f789cb97b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var lastMessage, item;


  lastMessage = (___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['recentMessage']);
  if (((lastMessage['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId']) && (lastMessage['isRead']) == true) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/b1a20e2be7bf73b17008b99d62aaf7cb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('0816f5b16b0636ee36c33fc1a5a991e7')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('0816f5b16b0636ee36c33fc1a5a991e7')).pop();
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('0816f5b16b0636ee36c33fc1a5a991e7')), 'open');
  }

  },  
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'accepted') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/62cc0c5ea2b37ae83d1766c3c24d0d94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item, messageCreated;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['noMoreMessages'] = false;
  (getObjectProperty(___arguments.context.dataModel, 'recentMessage'))['isRead'] = true;
  ___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793')['newMessages'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793'), 'newMessages')) - 1);
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', false);
  } else {
    await BackendlessUI.Functions.Custom['fn_30743f6255d6db0f649790555183a8e3'](___arguments.context.pageData);
  }
  messageCreated = '';
  if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
    if (getObjectProperty(___arguments.context.dataModel, 'deletedBySender')) {
      messageCreated = String(' and created>') + String(getObjectProperty(___arguments.context.dataModel, 'deletedBySender'));
    }
  } else {
    if (getObjectProperty(___arguments.context.dataModel, 'deletedByReceiver')) {
      messageCreated = String(' and created>') + String(getObjectProperty(___arguments.context.dataModel, 'deletedByReceiver'));
    }
  }
  ___arguments.context.dataModel['message'] = (await asyncListSort((await Backendless.Data.of('Message').find(Backendless.DataQueryBuilder.create().setWhereClause((['chatId=\'',(getObjectProperty(___arguments.context.dataModel, 'objectId')),'\'',messageCreated].join(''))).setRelated(['sender', 'receiver']).setSortBy('created desc').setPageSize(10))), 1, async (item) => {


   return (getObjectProperty(item, 'created'));
  }));
  ___arguments.context.pageData['currentActivity'] = ___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793');
  ___arguments.context.pageData['openMessage'] = ___arguments.context.dataModel;
  await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](___arguments.context.pageData);
  await new Promise(r => setTimeout(r, 500 || 0));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (___arguments.context.pageData['openMessage']) {
      if (((___arguments.context.pageData['openMessage'])['objectId']) == (___arguments.context.dataModel['objectId'])) {
        return ['MessagesActivities__item', 'open'];
      }
    }
  }

  return ['MessagesActivities__item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/group-page/components/d89fbd152bf80db4533bc69dc39f0c7f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var j, senderMessageIds, item;


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).pop();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', true);
    await BackendlessUI.Functions.Custom['fn_30743f6255d6db0f649790555183a8e3'](___arguments.context.pageData)
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/42081544a91ea4ac81e463d9a50b7d8c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['currentActivity']) {
    return ((___arguments.context.pageData['currentActivity'])['name']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/a09b7b1159dea90c26a414ca31012b66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId']) && ((___arguments.context.pageData['openMessage'])['type']) == 'activityRequest' && ((___arguments.context.pageData['openMessage'])['status']) == 'new') {
      return true;
    } else {
      return false;
    }
  }

  return false

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/07234a032eb54ca893edce0bb582b2b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['type']) == 'acceptedInvitation' || ((___arguments.context.pageData['openMessage'])['type']) == 'activityRequest') && ((___arguments.context.pageData['openMessage'])['status']) == 'accepted') {
      return true;
    } else {
      return false;
    }
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/90592f5df83b1f3ab9f8231e8051c5a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name'));
      } else {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login'));
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name'));
      } else {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login'));
      }
    }
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var profileId;


  if (___arguments.context.pageData['openMessage']) {
    profileId = '';
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
      profileId = (((___arguments.context.pageData['openMessage'])['receiver'])['objectId']);
    } else {
      profileId = (((___arguments.context.pageData['openMessage'])['sender'])['objectId']);
    }
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': profileId }));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/6a54e67ba6c395f96aeca202cd937041/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
      return (String('@') + String(((___arguments.context.pageData['openMessage'])['sender'])['login']));
    } else {
      return (String('@') + String(((___arguments.context.pageData['openMessage'])['receiver'])['login']));
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/33530c8fefcce30a39377cafc7f2280c/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photo')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photo'));
      } else {
        return 'styles/img/placeholder_photo.png';
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photo')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photo'));
      } else {
        return 'styles/img/placeholder_photo.png';
      }
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var profileId;


  if (___arguments.context.pageData['openMessage']) {
    profileId = '';
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
      profileId = (((___arguments.context.pageData['openMessage'])['receiver'])['objectId']);
    } else {
      profileId = (((___arguments.context.pageData['openMessage'])['sender'])['objectId']);
    }
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': profileId }));
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/47e94bfaf83f69abb74b614c803f42f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if (((___arguments.context.pageData['openMessage'])['sender'])['name']) {
      return (['Accept ',(((___arguments.context.pageData['openMessage'])['sender'])['name']),'\'s request?'].join(''));
    } else {
      return (['Accept ',(((___arguments.context.pageData['openMessage'])['sender'])['login']),'\'s request?'].join(''));
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/4eafc1632aefdbcc00cff33e24737eb1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'acceptedInvitation' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/8b19686a030ea4f4c6642a2277b2fc25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'accepted' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'acceptedInvitation') {
      await new Promise(r => setTimeout(r, 300 || 0));
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if (___arguments.context.pageData['openMessage']) {
    return (subsequenceFromStartLast(((___arguments.context.pageData['openMessage'])['message']), 1));
  }

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/group-page/components/9dc7f6325fbe9578e0cf90372163b835/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_f19ee1336b67ca26c4d92a38762420fa'](___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/28ca6fea12d79a96f87476064a748d86/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((___arguments.context.dataModel['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId']) && ((___arguments.context.dataModel['type']) == 'image' || (___arguments.context.dataModel['type']) == 'video')) {
    return ['messages__item', 'media', 'sent'];
  } else if (((___arguments.context.dataModel['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId']) && (___arguments.context.dataModel['type']) == 'text') {
    return ['messages__item', 'sent'];
  } else if (((___arguments.context.dataModel['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId']) && ((___arguments.context.dataModel['type']) == 'image' || (___arguments.context.dataModel['type']) == 'video')) {
    return ['messages__item', 'media'];
  }

  return ['messages__item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/group-page/components/9f22ff7521482d1a706d50d4c4aa05ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'requestPermission') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/7906afbf3a91793fc71b83edea43edf6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
      if (((___arguments.context.pageData['openMessage'])['sender'])['name']) {
        return (String(((___arguments.context.pageData['openMessage'])['sender'])['name']) + String(' requested permissions to view your photos.'));
      } else {
        return (String(((___arguments.context.pageData['openMessage'])['sender'])['login']) + String(' requested permissions to view your photos.'));
      }
    } else {
      if (((___arguments.context.pageData['openMessage'])['receiver'])['name']) {
        return (['You requested permissions to view ',(((___arguments.context.pageData['openMessage'])['receiver'])['name']),'’s photos'].join(''));
      } else {
        return (['You requested permissions to view ',(((___arguments.context.pageData['openMessage'])['receiver'])['login']),'’s photos'].join(''));
      }
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/02b7580d726ed03f19c367f48c9e6c89/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
      return (['Until you accept or reject the request, ',(((___arguments.context.pageData['openMessage'])['sender'])['name']),' will not know that you read the message.'].join(''));
    } else {
      return (['You requested permissions to view ',(((___arguments.context.pageData['openMessage'])['receiver'])['name']),' photos'].join(''));
    }
  }

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'received') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/00859164152b0d33d2168ec6ad5e4753/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
      if (((___arguments.context.pageData['openMessage'])['sender'])['photo']) {
        return (((___arguments.context.pageData['openMessage'])['sender'])['photo']);
      }
    } else {
      if (((___arguments.context.pageData['openMessage'])['receiver'])['photo']) {
        return (((___arguments.context.pageData['openMessage'])['receiver'])['photo']);
      }
    }
  }

  return 'styles/img/placeholder_photo.png'

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/e2bf4d2997ff18c43bb96da68e96d0fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
      if (((___arguments.context.pageData['openMessage'])['sender'])['name']) {
        return ([(((___arguments.context.pageData['openMessage'])['sender'])['name']),' invited you to ',(((___arguments.context.pageData['openMessage'])['sender'])['gender']) == 'Female' ? 'her' : 'his',' activity.'].join(''));
      } else {
        return ([(((___arguments.context.pageData['openMessage'])['sender'])['login']),' invited you to ',(((___arguments.context.pageData['openMessage'])['sender'])['gender']) == 'Female' ? 'her' : 'his',' activity.'].join(''));
      }
    } else {
      if (((___arguments.context.pageData['openMessage'])['receiver'])['name']) {
        return (['You invited ',(((___arguments.context.pageData['openMessage'])['receiver'])['name']),' to your activity '].join(''));
      } else {
        return (['You invited ',(((___arguments.context.pageData['openMessage'])['receiver'])['login']),' to your activity '].join(''));
      }
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/b5416f8f64cbdae8349ae85b4ea974f5/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photo')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photo'));
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photo')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photo'));
      }
    }
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/161a56ae44884b8a47fdf5890a4d34be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      if (___arguments.context.pageData['currentActivity']) {
    if ((___arguments.context.pageData['currentActivity'])['activityDate']) {
      return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65'](((___arguments.context.pageData['currentActivity'])['activityDate'])));
    } else {
      return ((___arguments.context.pageData['currentActivity'])['ongoingTiming']);
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/e8e420fbbba1693895acf6e419a8e4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['currentActivity']) {
    return ((___arguments.context.pageData['currentActivity'])['name']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/d2cabcf4d25c2b2991443bcac0de3346/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['currentActivity']) {
    return ((___arguments.context.pageData['currentActivity'])['description']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/a628079f4903c3f7cb8a2353908c87ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activity', ({ 'activityId': ((___arguments.context.pageData['currentActivity'])['objectId']) }));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/e5434c8ec9ad41f9868672f8c728f465/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/935326e4d434667d09165a29982b94c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'accepted') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/4b865ee52c736a086b77e98148ed8175/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/f4d21145deeeb3ec57456db1c9576f65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId']) && ((___arguments.context.pageData['openMessage'])['status']) == 'rejected') {
      return true;
    } else {
      return false;
    }
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/9ae807e7f72312198c187b88d59d6b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/28616305d7db58dd8e0fc35f9f976ffe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'accepted') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/edb83ad88c9f08666989165dd8b85665/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/bc8337d766064b25aae73e46f5d138f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'rejected') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/39eb72467532541258257d61de6435dd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.pageData['openMessage']) && (___arguments.context.pageData['currentActivity'])) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
      if (((___arguments.context.pageData['currentActivity'])['financialRole']) == 'driver') {
        return (['I am driver, ',(((___arguments.context.pageData['openMessage'])['receiver'])['login']),' is a Passenger'].join(''));
      } else if (((___arguments.context.pageData['currentActivity'])['financialRole']) == 'passenger') {
        return (String(((___arguments.context.pageData['openMessage'])['receiver'])['login']) + String(' is driver, me is a Passenger'));
      } else {
        return ((___arguments.context.pageData['currentActivity'])['financialRole']);
      }
    } else {
      if (((___arguments.context.pageData['currentActivity'])['financialRole']) == 'driver') {
        return (String(((___arguments.context.pageData['openMessage'])['receiver'])['login']) + String(' is driver, me is a Passenger'));
      } else if (((___arguments.context.pageData['currentActivity'])['financialRole']) == 'passenger') {
        return (['I am driver, ',(((___arguments.context.pageData['openMessage'])['receiver'])['login']),' is a Passenger'].join(''));
      } else {
        return ((___arguments.context.pageData['currentActivity'])['financialRole']);
      }
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/aa6c11c95a25f1e23c01881f66e9ffd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole'));
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/2d6a40f376d4bc234d63a8861aad7289/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var user;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  user = ({  });
  if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
    user = ((___arguments.context.pageData['openMessage'])['receiver']);
  } else {
    user = ((___arguments.context.pageData['openMessage'])['sender']);
  }
  ___arguments.context.pageData['modalContent'] = ({ 'type': 'block ','title': ['Block ',(user['login']),'?'].join(''),'text': String(user['login']) + String(' will not be able to see your activities anymore.'),'button': 'Block','doneText': ['You can find ',(user['login']),' in the Block list if you change your mind.'].join(''),'doneButton': 'Got it' });
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/a8f8b43809b53664008fb18d1d0a625c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'modalContent')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalContent')), 'text'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/27292276b8a4ecdff87d30d618b5bf59/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      if (___arguments.context.pageData['modalContent']) {
    return ((___arguments.context.pageData['modalContent'])['button']);
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e83ffe6576b27e37d494101b3bbe9ed8')).includes('no-display')) {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'no-display');
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e83ffe6576b27e37d494101b3bbe9ed8')).pop();
    if (___arguments.context.pageData['modalContent']) {
      if (((___arguments.context.pageData['modalContent'])['type']) == 'reject') {
        if (((___arguments.context.pageData['openMessage'])['status']) == 'new') {
          await Backendless.Data.of('Chat').bulkUpdate( (['objectId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join('')), ({ 'status': 'rejected' }) );
        } else {
          await Backendless.Data.of('Message').bulkDelete( (['chatId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join('')) );
          await Backendless.Data.of('Chat').bulkDelete( (['objectId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join('')) );
        }
      } else if (((___arguments.context.pageData['modalContent'])['type']) == 'withdraw') {
        await Backendless.Data.of('Message').bulkDelete( (['chatId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join('')) );
        await Backendless.Data.of('Chat').bulkDelete( (['objectId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join('')) );
      } else if (((___arguments.context.pageData['modalContent'])['type']) == 'delete') {
        if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
          await Backendless.Data.of('Chat').bulkUpdate( (['objectId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join('')), ({ 'deletedBySender': (new Date()) }) );
        } else {
          await Backendless.Data.of('Chat').bulkUpdate( (['objectId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join('')), ({ 'deletedByReceiver': (new Date()) }) );
        }
      } else {
        if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
          await Backendless.Data.of('Chat').bulkUpdate( ([String(['(ownerId=\'',(((___arguments.context.pageData['openMessage'])['sender'])['objectId']),'\''].join('')) + String([' and receiver.objectId=\'',((___arguments.context.pageData['currentUser'])['objectId']),'\')'].join('')),' or ',String(['(ownerId=\'',((___arguments.context.pageData['currentUser'])['objectId']),'\''].join('')) + String([' and receiver.objectId=\'',(((___arguments.context.pageData['openMessage'])['sender'])['objectId']),'\')'].join(''))].join('')), ({ 'isBlocked': true }) );
          await Backendless.Data.of('UserProfile').addRelation(((___arguments.context.pageData['currentUser'])['userProfile']), 'blockList', [((___arguments.context.pageData['openMessage'])['sender'])]);
        } else {
          await Backendless.Data.of('Chat').bulkUpdate( (String(['ownerId=\'',((___arguments.context.pageData['currentUser'])['objectId']),'\''].join('')) + String([' and receiver.objectId=\'',(((___arguments.context.pageData['openMessage'])['receiver'])['objectId']),'\''].join(''))), ({ 'isBlocked': true }) );
          await Backendless.Data.of('UserProfile').addRelation(((___arguments.context.pageData['currentUser'])['userProfile']), 'blockList', [((___arguments.context.pageData['openMessage'])['receiver'])]);
        }
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/baac8017300799683fc68d18ebb398a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var user;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  user = ({  });
  if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
    user = ((___arguments.context.pageData['openMessage'])['receiver']);
  } else {
    user = ((___arguments.context.pageData['openMessage'])['sender']);
  }
  ___arguments.context.pageData['modalContent'] = ({ 'type': 'reject','title': ['Reject ',(user['login']),' from Activity?'].join(''),'text': ['Do you want to reject ',(user['login']),' from activity and delete chat forever?'].join(''),'button': 'Reject','doneText': ['Done! You can always invite ',(user['login']),' once again to your activity.'].join(''),'doneButton': 'Thanks' });
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var user;


  if (___arguments.context.pageData['currentActivity']) {
    if (((___arguments.context.pageData['currentActivity'])['authorObjectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/175ca55ed7c8c6a1f415cb4b9038ce38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'block','title': ['Block ',(((___arguments.context.pageData['openMessage'])['sender'])['login']),'?'].join(''),'text': String(((___arguments.context.pageData['openMessage'])['sender'])['login']) + String(' will not be able to see your activities anymore.'),'button': 'Block','doneText': ['You can find ',(((___arguments.context.pageData['openMessage'])['sender'])['login']),' in the Block list if you change your mind.'].join(''),'doneButton': 'Got it' });
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/cb5ca5c49b1354cc7467a7f20972bae8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'reject','title': 'Reject chat?','text': ['Do you want to delete chat with ',(((___arguments.context.pageData['openMessage'])['sender'])['login']),' forever?'].join(''),'button': 'Reject','doneText': ['Done! You can always invite ',(((___arguments.context.pageData['openMessage'])['sender'])['login']),' once again to your activity.'].join(''),'doneButton': 'Thanks' });
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/42e8f3bee3ce810f8eb3a6b1972850ed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'reject','title': 'Reject invitation?','text': ['If you reject invitation we will delete chat with ',(((___arguments.context.pageData['openMessage'])['sender'])['login']),' forever?'].join(''),'button': 'Reject','doneText': 'Done!','doneButton': 'Thanks' });
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/64ee9ebc59c655c7788842671414003e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'reject','title': 'Reject request?','text': 'If you reject request we will delete it from the list of requests.','button': 'Reject','doneText': 'Done!','doneButton': 'Thanks' });
  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/14f94cc9bf756a8b2fe6eed65d62644a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;


  await Backendless.Data.of('Chat').bulkUpdate( (['objectId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join('')), ({ 'status': 'accepted' }) );
  await Backendless.Data.of('Message').bulkUpdate( ((await Promise.all(((___arguments.context.pageData['openMessage'])['message']).map(async item => {; return (['objectId=\'',(item['objectId']),'\''].join(''));}))).join(' or ')), ({ 'isRead': true }) );

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/4e98bf037a763b36a00b724dfb5c574b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['receiver'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
    return ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['sender'])['online']);
  } else {
    return ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['receiver'])['online']);
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/ae720be69e43105a2519f52890c49713/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'online'));
    } else {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'online'));
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/ffcf698ae37f155b683315224795c04a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'online'));
    } else {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'online'));
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/f177bcc285f9511d21e445f7118ee249/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'online'));
    } else {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'online'));
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/6b577d392fe11a86b72cd12f2e5f934f/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'receivedChats')) {
    return (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'receivedChats')), async (item) => {


     return ((getObjectProperty(item, 'activityId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793'), 'objectId')));
    }));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/group-page/components/f8a9eda4b2ce71cb7f1f02d288da5203/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var ids, newMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    newMessage = ({ 'chatId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),'message': (getObjectProperty(___arguments.context.pageData, 'newMessage')),'sender': ({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) }),'senderName': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),'receiver': ({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) }),'type': 'text' });
    ___arguments.context.pageData['newMessage'] = '';
    await Backendless.Messaging.publish('default', newMessage, new Backendless.PublishOptions({ subtopic: '', headers: ({ 'chatId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) }) }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
    if (!(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')) || ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')).includes('replies')) || ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')).includes('message'))) {
      ___arguments.context.pageData['device'] = (await Backendless.Data.of('DeviceRegistration').find(Backendless.DataQueryBuilder.create().setWhereClause((['user.objectId=\'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(100)));
      ids = ((getObjectProperty(___arguments.context.pageData, 'device')).map(item => item['deviceId']));
      await Backendless.Messaging.publish('push', (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), new Backendless.PublishOptions({ 'headers': Object.assign({ 'android-ticker-text': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), 'android-content-title': 'FindMy+1', 'android-content-text': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), 'ios-alert': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), 'ios-badge': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) }, ({ 'ios-alert-title': 'FindMy+1' }))  }), new Backendless.DeliveryOptions({ 'pushSinglecast': ids  }));
    }
    if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
      await ( async function (component) { component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/f2eaef554bbdc4fd45cfc7738ddb1c16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      (___arguments.context.pageData['openMessage'])['status'] = 'accepted';
  await Backendless.Data.of('UserProfile').addRelation(((___arguments.context.pageData['currentUser'])['userProfile']), 'hasPermission', [((___arguments.context.pageData['openMessage'])['sender'])]);
  await Backendless.Data.of('Chat').bulkUpdate( (['objectId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join('')), ({ 'status': 'accepted' }) );

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/94bcc5b10957c93ae6ab46fcd6458ba7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      (___arguments.context.pageData['openMessage'])['status'] = 'accepted';
  (___arguments.context.pageData['openMessage'])['type'] = 'acceptedInvitation';
  await Backendless.Data.of('Chat').bulkUpdate( (['objectId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join('')), ({ 'status': 'accepted','type': 'acceptedInvitation' }) );
  await Backendless.Data.of('Message').bulkUpdate( (['objectId=\'',((((___arguments.context.pageData['openMessage'])['message'])[0])['objectId']),'\''].join('')), ({ 'isRead': true }) );

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/41171da31a5e0151cbeab5a446f31d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if (!!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')).length) {
      return (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'))[0]), 'message'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/c6d72883b395de8975cece176529f82c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (___arguments.context.pageData['openMessage']) {
    if (!!((___arguments.context.pageData['openMessage'])['message']).length) {
      return (await BackendlessUI.Functions.Custom['fn_f19ee1336b67ca26c4d92a38762420fa'](((await asyncListSort(((___arguments.context.pageData['openMessage'])['message']), 1, async (item) => {


       return (item['created']);
      }))[0])));
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/83bdec5322683a0f88e4f26aff78318e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b')['activityDate']) {
    return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b')['activityDate'])));
  } else {
    return (___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b')['ongoingTiming']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/92dec97fb6ca2e232c7bb41a2133e279/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b')['authorPhoto']) {
    return (___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b')['authorPhoto']);
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/ba42e4c2176ee5b71f9bc0d183529254/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b')['onlineAuthor'])

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/49096b92542f1bb284934ebf62a9245b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var chat, messages, item, messageCreated;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['noMoreMessages'] = false;
  ___arguments.context.dataModel['newMessages'] = false;
  if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', false);
  } else {
    await BackendlessUI.Functions.Custom['fn_30743f6255d6db0f649790555183a8e3'](___arguments.context.pageData);
  }
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9915ee5b4aff26c256e3062303d2a45', true);
  ___arguments.context.pageData['currentActivity'] = ___arguments.context.dataModel;
  chat = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'receivedChats')), async (item) => {


   return ((getObjectProperty(item, 'activityId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
  }))[0];
  (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'receivedChats'))[((((getObjectProperty(___arguments.context.pageData, 'receivedChats')).map(item => item['objectId'])).indexOf(getObjectProperty(chat, 'objectId')) + 1) - 1)]), 'recentMessage'))['isRead'] = true;
  messageCreated = '';
  if ((getObjectProperty((getObjectProperty(chat, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
    if (getObjectProperty(chat, 'deletedBySender')) {
      messageCreated = String(' and created>') + String(getObjectProperty(chat, 'deletedBySender'));
    }
  } else {
    if (getObjectProperty(chat, 'deletedByReceiver')) {
      messageCreated = String(' and created>') + String(getObjectProperty(chat, 'deletedByReceiver'));
    }
  }
  messages = (await asyncListSort((await Backendless.Data.of('Message').find(Backendless.DataQueryBuilder.create().setWhereClause((['chatId=\'',(getObjectProperty(chat, 'objectId')),'\'',messageCreated].join(''))).setRelated(['sender', 'receiver']).setSortBy('created desc').setPageSize(10))), 1, async (item) => {


   return (getObjectProperty(item, 'created'));
  }));
  chat['message'] = messages;
  ___arguments.context.pageData['openMessage'] = chat;
  await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](___arguments.context.pageData);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9915ee5b4aff26c256e3062303d2a45', false);
  await new Promise(r => setTimeout(r, 300 || 0));
  ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (___arguments.context.pageData['openMessage']) {
      if (((___arguments.context.pageData['openMessage'])['activityId']) == (___arguments.context.dataModel['objectId'])) {
        return ['MessagesActivities__item', 'open'];
      }
    }
  }

  return ['MessagesActivities__item']

  },
  /* handler:onClassListAssignment */
  /* handler:onMounted */
  async onMounted(___arguments) {
    var chat, item, list;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.dataModel['newMessages'] = false;
  if (___arguments.context.pageData['receivedChats']) {
    chat = (await asyncListFilter((___arguments.context.pageData['receivedChats']), async (item) => {


     return ((item['activityId']) == (___arguments.context.dataModel['objectId']));
    }))[0];
    if (((___arguments.context.pageData['currentUser'])['objectId']) == (((chat['recentMessage'])['receiver'])['objectId']) && ((chat['recentMessage'])['isRead']) == false) {
      ___arguments.context.dataModel['newMessages'] = true;
    }
  }
  if (___arguments.context.dataModel['newMessages']) {
    (___arguments.context.pageData['invitedActivities']).splice((((___arguments.context.pageData['invitedActivities']).indexOf(___arguments.context.dataModel) + 1) - 1), 1);
    (___arguments.context.pageData['invitedActivities']).unshift(___arguments.context.dataModel);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/group-page/components/5f3f84bab07cdf1c8c6d7df10918fec8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var lastMessage;


  if (((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['recentMessage'])['type']) == 'text') {
    return ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['recentMessage'])['message']);
  } else {
    return 'Media';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/7f5727393c21205c858416c8bf3f39d9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b')['name'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/381a94360597cb1837356c8efb3a303b/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      return ['messages__item', 'sent'];
    }
  }

  return ['messages__item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/group-page/components/3df5f22810332d6edd5d25cfc88eb897/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var previousMessage, previousMessageIdx, messageArray;


  await new Promise(r => setTimeout(r, 500 || 0));
  if (___arguments.context.pageData['openMessage']) {
    if (!!((___arguments.context.pageData['openMessage'])['message']).length) {
      messageArray = ((___arguments.context.pageData['openMessage'])['message']);
      previousMessageIdx = (messageArray.indexOf(___arguments.context.dataModel) + 1) - 1;
      previousMessage = messageArray[(previousMessageIdx - 1)];
      if (!previousMessage || ((new Date((previousMessage['created']))).toDateString()) != ((new Date((___arguments.context.dataModel['created']))).toDateString())) {
        if (((new Date()).toDateString()) == ((new Date((___arguments.context.dataModel['created']))).toDateString())) {
          return 'Today';
        } else if ((new Date((new Date())).getMonth()) == (new Date((new Date((___arguments.context.dataModel['created'])))).getMonth()) && (new Date((new Date())).getFullYear()) == (new Date((new Date((___arguments.context.dataModel['created'])))).getFullYear())) {
          if ((new Date((new Date())).getDate()) - (new Date((new Date((___arguments.context.dataModel['created'])))).getDate()) == 1) {
            return 'Yesterday';
          } else {
            return ((new Date((___arguments.context.dataModel['created']))).toDateString());
          }
        } else {
          return ((new Date((___arguments.context.dataModel['created']))).toDateString());
        }
      }
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/983cd5878ac535b43946e75f4c5a86e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var previousMessage, previousMessageIdx, messageArray;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty(___arguments.context.dataModel, 'receiver'))) {
    messageArray = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'));
    previousMessageIdx = (messageArray.indexOf(___arguments.context.dataModel) + 1) - 1;
    previousMessage = messageArray[(previousMessageIdx - 1)];
    if (!previousMessage || (getObjectProperty((getObjectProperty(previousMessage, 'receiver')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) || (getObjectProperty(previousMessage, 'isRead')) != (getObjectProperty(___arguments.context.dataModel, 'isRead'))) {
      if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty(___arguments.context.dataModel, 'isRead')) == false) {
        return true;
      } else {
        return false;
      }
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/cb31993fa61617e16d95cab8496ecde8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var message, item;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (___arguments.context.pageData['openMessage']) {
    if (!!((___arguments.context.pageData['openMessage'])['message']).length) {
      message = (await asyncListSort(((___arguments.context.pageData['openMessage'])['message']), 1, async (item) => {


       return (item['created']);
      }))[0];
      if (((new Date()).toDateString()) == ((new Date((message['created']))).toDateString())) {
        return 'Today';
      } else if ((new Date((new Date())).getMonth()) == (new Date((new Date((message['created'])))).getMonth()) && (new Date((new Date())).getFullYear()) == (new Date((new Date((message['created'])))).getFullYear())) {
        if ((new Date((new Date())).getDate()) - (new Date((new Date((message['created'])))).getDate()) == 1) {
          return 'Yesterday';
        } else {
          return ((new Date((message['created']))).toDateString());
        }
      } else {
        return ((new Date((message['created']))).toDateString());
      }
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/7979ba2576c4372adabf7e5ad59bc96e/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
      if (((___arguments.context.pageData['openMessage'])['sender'])['photo']) {
        return (((___arguments.context.pageData['openMessage'])['sender'])['photo']);
      }
    } else {
      if (((___arguments.context.pageData['openMessage'])['receiver'])['photo']) {
        return (((___arguments.context.pageData['openMessage'])['receiver'])['photo']);
      }
    }
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/eb55a2c4b313e5198adf93a87d3356f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
      if (((___arguments.context.pageData['openMessage'])['sender'])['name']) {
        return (((___arguments.context.pageData['openMessage'])['sender'])['name']);
      } else {
        return (((___arguments.context.pageData['openMessage'])['sender'])['login']);
      }
    } else {
      if (((___arguments.context.pageData['openMessage'])['receiver'])['name']) {
        return (((___arguments.context.pageData['openMessage'])['receiver'])['name']);
      } else {
        return (((___arguments.context.pageData['openMessage'])['receiver'])['login']);
      }
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/b2caadf4ee453c46401429315fff2e28/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/bfa8286f3a414eda1dd11ab25654b152/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/da1b531f95f3628bb38377b28419f33a/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async onKeyDown(___arguments) {
    var ids, newMessage;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.keyCode == 13) {
    ___arguments.context.pageData['new'] = true;
    if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
      newMessage = ({ 'chatId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),'message': (getObjectProperty(___arguments.context.pageData, 'newMessage')),'sender': ({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) }),'senderName': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),'receiver': ({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) }),'type': 'text' });
      ___arguments.context.pageData['newMessage'] = '';
      await Backendless.Messaging.publish('default', newMessage, new Backendless.PublishOptions({ subtopic: '', headers: ({ 'chatId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) }) }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
      if (!(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')) || ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')).includes('replies')) || ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')).includes('message'))) {
        ___arguments.context.pageData['device'] = (await Backendless.Data.of('DeviceRegistration').find(Backendless.DataQueryBuilder.create().setWhereClause((['user.objectId=\'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(100)));
        ids = ((getObjectProperty(___arguments.context.pageData, 'device')).map(item => item['deviceId']));
        await Backendless.Messaging.publish('push', (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), new Backendless.PublishOptions({ 'headers': Object.assign({ 'android-ticker-text': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), 'android-content-title': 'FindMy+1', 'android-content-text': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), 'ios-alert': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), 'ios-badge': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) }, ({ 'ios-alert-title': 'FindMy+1' }))  }), new Backendless.DeliveryOptions({ 'pushSinglecast': ids  }));
      }
      if ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
        await ( async function (component) { component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
      }
    }
  }

  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/group-page/components/2c1ec29922918eb39a1afdd394d88511/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceAssignment */
  onSourceAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['type']) == 'video') {
    return (___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['message']);
  }

  },  
  /* handler:onSourceAssignment */
  /* content */
}))

define('./pages/group-page/components/b289739c7f29dd4bdbec5601d315b984/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['type']) == 'image')

  },  
  /* handler:onDisplayAssignment */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['type']) == 'image') {
    return (___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['message']);
  }

  },  
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var item, mediaList;


  mediaList = (await Backendless.Data.of('Message').find(Backendless.DataQueryBuilder.create().setWhereClause((['chatId=\'',(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['chatId']),'\''].join(''))).setHavingClause('type=\'image\' or type=\'video\'').setPageSize(100)));
  ___arguments.context.pageData['mediaMessages'] = (await Promise.all(mediaList.map(async item => {  if ((item['message']) == (___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['message'])) {
      item['current'] = true;
    } else {
      item['current'] = false;
    }
  ; return item;})));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8968a8769b41fc3e6ad822d8ff0d0c75', true);
  console.log(___arguments.context.pageData['mediaMessages']);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/5f892b1e713cc90fb082fcec98789e68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['type']) == 'text')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/736c44feb60b2c27d8717949bb7172b9/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async onUploadSuccess(___arguments) {
    var newMessage, format, video;

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  video = ['.mov', '.mp4', '.mpeg4', '.wmv', '.flv', '.avi', '.mkv'];
  format = subsequenceFromStartLast(___arguments.uploadedFiles, ((___arguments.uploadedFiles.lastIndexOf('.') + 1) - 1)).trim();
  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    newMessage = ({ 'chatId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),'message': ___arguments.uploadedFiles,'sender': ({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) }),'receiver': ({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) }),'type': (video.includes(format)) ? 'video' : 'image' });
    ___arguments.context.pageData['newMessage'] = '';
    await Backendless.Messaging.publish('default', newMessage, new Backendless.PublishOptions({ subtopic: '', headers: ({ 'chatId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) }) }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
  }
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72a8e8bd3108304126e75675eed7bbc1', false);
  ;(function (componentUid){ ___arguments.context.getComponentByUid(componentUid).reset() })('736c44feb60b2c27d8717949bb7172b9');
  ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    return (String('/pictures/messages/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
  }

  },
  /* handler:onDirectoryAssignment */
  /* handler:onBeforeUpload */
  onBeforeUpload(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72a8e8bd3108304126e75675eed7bbc1', true);

  },  
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      console.log(___arguments.error);

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.file, 'name')).toLowerCase())

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/group-page/components/561cf7288d470375fb430c08dc515aac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['type']) == 'video')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/e0086643c9ea694544ce2fb9e4d3d313/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791')['current']) {
    return ['gallery__slider-image', 'messages-gallery', 'visible'];
  }

  return ['gallery__slider-image', 'messages-gallery']

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791'), 'type')) == 'video')

  },
  /* handler:onDisplayAssignment */
  /* handler:onSourceAssignment */
  onSourceAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791')['type']) == 'video') {
    return (___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791')['message']);
  }

  },  
  /* handler:onSourceAssignment */
  /* handler:onControlsAssignment */
  onControlsAssignment(___arguments) {
      return true

  },  
  /* handler:onControlsAssignment */
  /* content */
}))

define('./pages/group-page/components/48efcecab9411159f0946a0e22cc7631/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item, mediaList;


  mediaList = (await Backendless.Data.of('Message').find(Backendless.DataQueryBuilder.create().setWhereClause((['chatId=\'',(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['chatId']),'\''].join(''))).setHavingClause('type=\'image\' or type=\'video\'').setPageSize(100)));
  ___arguments.context.pageData['mediaMessages'] = (await Promise.all(mediaList.map(async item => {  if ((item['message']) == (___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')['message'])) {
      item['current'] = true;
    } else {
      item['current'] = false;
    }
  ; return item;})));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8968a8769b41fc3e6ad822d8ff0d0c75', true);
  console.log(___arguments.context.pageData['mediaMessages']);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'group page'

  },
  /* handler:onTitleAssignment */
  /* handler:onScroll */
  async onScroll(___arguments) {
    var item, sortList, moreMessages;

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (___arguments.context.pageData['openMessage']) {
    if (((___arguments.context.pageData['openMessage'])['message']).length >= 10) {
      if (___arguments.scrollTop == 0 && !(___arguments.context.pageData['noMoreMessages'])) {
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9915ee5b4aff26c256e3062303d2a45', true);
        ___arguments.context.pageData['countOffset'] = ((___arguments.context.pageData['countOffset']) + 1);
        moreMessages = (await asyncListSort((await Backendless.Data.of('Message').find(Backendless.DataQueryBuilder.create().setWhereClause((['chatId=\'',((___arguments.context.pageData['openMessage'])['objectId']),'\''].join(''))).setRelated(['sender', 'receiver']).setSortBy('created desc').setPageSize(10).setOffset(((___arguments.context.pageData['countOffset']) * 10)))), 1, async (item) => {


         return (item['created']);
        }));
        if (!!moreMessages.length) {
          sortList = (((___arguments.context.pageData['openMessage'])['message']).concat(moreMessages));
          (___arguments.context.pageData['openMessage'])['message'] = (await asyncListSort(sortList, 1, async (item) => {


           return (item['created']);
          }));
        } else {
          ___arguments.context.pageData['noMoreMessages'] = true;
        }
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9915ee5b4aff26c256e3062303d2a45', false);
      }
    }
  }

  },
  /* handler:onScroll */
  /* handler:onEnter */
  onEnter(___arguments) {
      ___arguments.context.pageData['countOffset'] = 0;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  onLeave(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}


  getRTSubscriptions().remove('updatedChat');;

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/group-page/components/be59a0977b781cff1881486bc0d72a86/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async onKeyDown(___arguments) {
    var item, message, chat;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.keyCode == 13) {
    if (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchInput']) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d89faea2b93a5846565eb7b1b7871ac', false);
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1d836629487303172d5dcbd414738c96', true);
      ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages'] = (await Backendless.Data.of('Message').find(Backendless.DataQueryBuilder.create().setWhereClause(([['(receiver.objectId=\'',((___arguments.context.pageData['currentUser'])['objectId']),'\''].join(''),[' or sender.objectId=\'',((___arguments.context.pageData['currentUser'])['objectId']),'\')'].join(''),[' and (message like \'%',(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchInput']),'%\' '].join(''),[' or sender.login like \'%',(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchInput']),'%\' '].join(''),[' or sender.name like \'%',(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchInput']),'%\' )'].join('')].join(''))).setRelationsDepth(2).setGroupBy('chatId').setPageSize(100)));
      console.log('searchResultsMessages');
      console.log(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages']);
      ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResults'] = (await Backendless.Data.of('Chat').find(Backendless.DataQueryBuilder.create().setWhereClause((String(['objectId in (\'',((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages']).map(item => item['chatId'])).join('\', \''),'\')'].join('')) + String(' and status!=\'rejected\' and status != \'blocked\''))).setRelated(['sender', 'receiver']).setGroupBy('objectId').setPageSize(100)));
      console.log(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResults']);
      ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchRequest'] = (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchInput']);
      if (!(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResults']).length) {
        ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d89faea2b93a5846565eb7b1b7871ac', true);
      }
    } else {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d89faea2b93a5846565eb7b1b7871ac', true);
      ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResults'] = [];
      ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages'] = [];
    }
    var chat_list = (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResults']);
    for (var chat_index in chat_list) {
      chat = chat_list[chat_index];
      var message_list = (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages']);
      for (var message_index in message_list) {
        message = message_list[message_index];
        if ((message['chatId']) == (chat['objectId'])) {
          chat['message'] = [message];
        }
      }
    }
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchChats'] = (await asyncListFilter((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResults']), async (item) => {
       if ((item['type']) == 'activityRequest' && (item['status']) == 'accepted' || (item['type']) == 'acceptedInvitation') {
        return item;
      }


     return ;
    }));
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchRequests'] = (await asyncListFilter((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResults']), async (item) => {
       if ((item['type']) == 'activityRequest' && (item['status']) == 'new') {
        return item;
      }


     return ;
    }));
    if (___arguments.context.pageData['activityMessages']) {
      ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchActivities'] = (await asyncListFilter((___arguments.context.pageData['activityMessages']), async (item) => {


       return ((item['type']) == 'activityRequest' && ((((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchRequests']).map(item => item['activityId'])).includes((item['objectId']))) || (((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchChats']).map(item => item['activityId'])).includes((item['objectId'])))));
      }));
    }
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchSystemMessages'] = (await asyncListFilter((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResults']), async (item) => {
       if ((item['type']) == 'invitation' && (item['status']) == 'new' || (item['type']) == 'requestPermission' && (item['status']) == 'new') {
        return item;
      }


     return ;
    }));
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1d836629487303172d5dcbd414738c96', false);
  }

  },  
  /* handler:onKeyDown */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchInput'] = (___arguments.value.toLowerCase());

  },  
  /* handler:onChange */
  /* content */
}))

define('./pages/group-page/components/e14dd997fca9980dffb7c9ed3639e698/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1d6e41f8aae1a55656110e9c7da9667b')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1d6e41f8aae1a55656110e9c7da9667b')).pop();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fec7f882dd2d3f2d1e2c8ad158cb1708', true);
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1d6e41f8aae1a55656110e9c7da9667b')), 'open');
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fec7f882dd2d3f2d1e2c8ad158cb1708', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/8d5499b934c60b27fe6ef3ecac1a2cf8/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchChats']) {
    return (await asyncListFilter((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchChats']), async (item) => {


     return ((item['activityId']) == (___arguments.context.getComponentDataStoreByUid('16dd5764241415b5429814de3ddfc0bd')['objectId']));
    }));
  }

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/group-page/components/03cdc3573ae5fa2f369896dba075d2f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchRequests']) {
    return (await asyncListFilter((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchRequests']), async (item) => {


     return ((item['activityId']) == (___arguments.context.getComponentDataStoreByUid('16dd5764241415b5429814de3ddfc0bd')['objectId']));
    }));
  }

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/group-page/components/0c517f7c39bc2733d34ede0889ba2e64/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d')['type']) == 'invitation') {
    return 'styles/img/icons/logoIcon.svg';
  } else {
    return 'styles/img/icons/lock_gray.svg';
  }

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/6473c0a1cfe2eb5c389ddeb1adb2d964/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if (((___arguments.context.pageData['currentUser'])['objectId']) == ((___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d')['sender'])['objectId'])) {
    if ((___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d')['receiver'])['photo']) {
      return ((___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d')['receiver'])['photo']);
    }
  } else {
    if ((___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d')['sender'])['photo']) {
      return ((___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d')['sender'])['photo']);
    }
  }

  return 'styles/img/placeholder_photo.png'

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/5d2b0f6691a44221e4f851fee082a07c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'sender')), 'objectId'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'type')) == 'invitation') {
      return ([(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'sender')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'sender')), 'login')),' has invited you to ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'sender')), 'gender')) == 'Female' ? 'her' : 'his',' activity '].join(''));
    } else {
      return (String((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'sender')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'sender')), 'login'))) + String(' requested permissions to view your photos'));
    }
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'type')) == 'invitation') {
      return (['You invited  ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'receiver')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'receiver')), 'login')),' to your activity '].join(''));
    } else {
      return (['You requested permissions to view ',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'receiver')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'receiver')), 'login')),' photos'].join(''));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/14d1aef6fcdab526f6ae562ccd0cd141/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed0827db658bddf3b77b94e3651592e3'), 'activityDate')) {
    return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed0827db658bddf3b77b94e3651592e3'), 'activityDate'))));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ed0827db658bddf3b77b94e3651592e3'), 'ongoingTiming'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/50c62008f70b96a7ab384e8b317c383f/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var list, message;


  if (___arguments.context.getComponentDataStoreByUid('6bf239544cdec1ead33766aeac114372')['message']) {
    message = (___arguments.context.getComponentDataStoreByUid('6bf239544cdec1ead33766aeac114372')['message'])[0];
    if ((message['sender'])['photo']) {
      return ((message['sender'])['photo']);
    } else {
      return 'styles/img/placeholder_photo.png';
    }
  }

  return 'styles/img/placeholder_photo.png'

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/615914e7057e08b765560752f9524582/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var message;


  if (___arguments.context.getComponentDataStoreByUid('796848afa46da57eda9d9b1c8067851f')['message']) {
    message = (___arguments.context.getComponentDataStoreByUid('796848afa46da57eda9d9b1c8067851f')['message'])[0];
    if ((message['sender'])['photo']) {
      return ((message['sender'])['photo']);
    } else {
      return 'styles/img/placeholder_photo.png';
    }
  }

  return 'styles/img/placeholder_photo.png'

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/25aecf0c6d72b998191547bb977d364a/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('ea839cdf0cf534111a15fb6ed7afdcdf')['sender']) {
    if ((___arguments.context.getComponentDataStoreByUid('ea839cdf0cf534111a15fb6ed7afdcdf')['sender'])['photo']) {
      return ((___arguments.context.getComponentDataStoreByUid('ea839cdf0cf534111a15fb6ed7afdcdf')['sender'])['photo']);
    }
  }

  return 'styles/img/placeholder_photo.png'

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/f80c34a8480cb7a468c9331ad31a0ac5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var message;


  message = (___arguments.context.getComponentDataStoreByUid('6bf239544cdec1ead33766aeac114372')['message'])[0];
  if ((message['sender'])['name']) {
    return ((message['sender'])['name']);
  } else {
    return ((message['sender'])['login']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/68d8c96d5dbcc33e8546889c04cb2409/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var message;


  message = (___arguments.context.getComponentDataStoreByUid('796848afa46da57eda9d9b1c8067851f')['message'])[0];
  if ((message['sender'])['name']) {
    return ((message['sender'])['name']);
  } else {
    return ((message['sender'])['login']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/f489c8611378cbbac2bff094456a9ebb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('ea839cdf0cf534111a15fb6ed7afdcdf')['sender'])['name']) {
    return ((___arguments.context.getComponentDataStoreByUid('ea839cdf0cf534111a15fb6ed7afdcdf')['sender'])['name']);
  } else {
    return ((___arguments.context.getComponentDataStoreByUid('ea839cdf0cf534111a15fb6ed7afdcdf')['sender'])['login']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/84a2fba17bdfb3cf449403bd58bf4aeb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var message;


  message = (___arguments.context.getComponentDataStoreByUid('6bf239544cdec1ead33766aeac114372')['message'])[0];
  if ((message['type']) == 'text') {
    return (message['message']);
  } else {
    return 'Media';
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/d3e6731af2c2b4810e313c5332772ba7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var message;


  message = (___arguments.context.getComponentDataStoreByUid('796848afa46da57eda9d9b1c8067851f')['message'])[0];

  return (message['message'])

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/30ac46352f86a202893db53385db8865/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('ea839cdf0cf534111a15fb6ed7afdcdf')['type']) == 'text') {
    return (___arguments.context.getComponentDataStoreByUid('ea839cdf0cf534111a15fb6ed7afdcdf')['message']);
  } else {
    return 'Media';
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/cc1f910b5a4781d8c6587239a962bb7e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_f19ee1336b67ca26c4d92a38762420fa'](___arguments.context.getComponentDataStoreByUid('ea839cdf0cf534111a15fb6ed7afdcdf')))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/e78a6405ce0be48b35e7e2461f99894a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var message;


  message = (___arguments.context.getComponentDataStoreByUid('6bf239544cdec1ead33766aeac114372')['message'])[0];

  return (await BackendlessUI.Functions.Custom['fn_f19ee1336b67ca26c4d92a38762420fa'](message))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/b93a33ef2b5f48bcc5ba1821f1319516/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('61bb7579b86a75770bcf4cbf70bfd68d'), 'sender')), 'online'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/26ac9dacb4476258454c8cea39f9a5f4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var message;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  message = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6bf239544cdec1ead33766aeac114372'), 'message'))[0];

  return (getObjectProperty((getObjectProperty(message, 'sender')), 'online'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/a0a938caec551dad219e7d6d1c1defb2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var message;


  message = (___arguments.context.getComponentDataStoreByUid('796848afa46da57eda9d9b1c8067851f')['message'])[0];

  return ((message['sender'])['online'])

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/cda721876964891eba724caeaf36e04a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('ea839cdf0cf534111a15fb6ed7afdcdf')['sender'])['online'])

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/018d7845b1679e3d5d45d7c29e628722/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchSystemMessages')) {
    return (['Found ',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchSystemMessages')).length,' requests'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/f377c9b7fc4d2643d847d80e3b5dc1e7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchRequests')) {
    return (['Found ',((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchChats')).concat((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchRequests')))).length,' chats'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/09ed9d75c4b43d1b4f874844d67a3fb1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages']) {
    return (['Found ',(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages']).length,' messages'].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return false

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/31bf0c2545560f5f988c93b5abcf9127/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchResults'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/61bb7579b86a75770bcf4cbf70bfd68d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item, senderMessageIds;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['noMoreMessages'] = false;
  if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', false);
  } else {
    if (___arguments.context.pageData['openMessage']) {
      if (!!((___arguments.context.pageData['openMessage'])['message']).length) {
        senderMessageIds = ((await asyncListFilter(((___arguments.context.pageData['openMessage'])['message']), async (item) => {
           if (((item['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
            return item;
          }


         return ;
        })).map(item => item['objectId']));
        if (!!senderMessageIds.length) {
          await Backendless.Data.of('Message').bulkUpdate( (String((await Promise.all(senderMessageIds.map(async item => {; return (['objectId=\'',item,'\''].join(''));}))).join(' or ')) + String(' and isRead=false')), ({ 'isRead': true }) );
        }
      }
      ___arguments.context.pageData['currentActivity'] = null;
      ___arguments.context.pageData['openMessage'] = null;
    }
  }
  ___arguments.context.pageData['openMessage'] = ___arguments.context.dataModel;
  if ((___arguments.context.dataModel['type']) == 'invitation') {
    ___arguments.context.pageData['currentActivity'] = ((await Backendless.Data.of('Activity').find(Backendless.DataQueryBuilder.create().setWhereClause((['chat.objectId=\'',(___arguments.context.dataModel['objectId']),'\''].join(''))).setRelated(['author', 'chat', 'category']).setPageSize(1)))[0]);
  } else {
    ___arguments.context.pageData['currentActivity'] = null;
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/6bf239544cdec1ead33766aeac114372/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var messagesArray, item, senderMessageIds;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['countOffset'] = 1;
  ___arguments.context.pageData['noMoreMessages'] = false;
  if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', false);
  } else {
    if (___arguments.context.pageData['openMessage']) {
      if (!!((___arguments.context.pageData['openMessage'])['message']).length) {
        senderMessageIds = ((await asyncListFilter(((___arguments.context.pageData['openMessage'])['message']), async (item) => {
           if (((item['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
            return item;
          }


         return ;
        })).map(item => item['objectId']));
        if (!!senderMessageIds.length) {
          await Backendless.Data.of('Message').bulkUpdate( (String((await Promise.all(senderMessageIds.map(async item => {; return (['objectId=\'',item,'\''].join(''));}))).join(' or ')) + String(' and isRead=false')), ({ 'isRead': true }) );
        }
      }
      ___arguments.context.pageData['currentActivity'] = null;
      ___arguments.context.pageData['openMessage'] = null;
    }
  }
  messagesArray = (await asyncListSort((await Backendless.Data.of('Message').find(Backendless.DataQueryBuilder.create().setWhereClause((['chatId=\'',(___arguments.context.dataModel['objectId']),'\''].join(''))).setRelated(['sender', 'receiver']).setSortBy('created desc').setPageSize(10))), 1, async (item) => {


   return (item['created']);
  }));
  ___arguments.context.pageData['currentActivity'] = ___arguments.context.getComponentDataStoreByUid('16dd5764241415b5429814de3ddfc0bd');
  ___arguments.context.pageData['openMessage'] = ___arguments.context.dataModel;
  (___arguments.context.pageData['openMessage'])['message'] = messagesArray;
  await new Promise(r => setTimeout(r, 1 || 0));
  ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/796848afa46da57eda9d9b1c8067851f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item, senderMessageIds;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['noMoreMessages'] = false;
  if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', false);
  } else {
    if (___arguments.context.pageData['openMessage']) {
      if (!!((___arguments.context.pageData['openMessage'])['message']).length) {
        senderMessageIds = ((await asyncListFilter(((___arguments.context.pageData['openMessage'])['message']), async (item) => {
           if (((item['sender'])['objectId']) != ((___arguments.context.pageData['currentUser'])['objectId'])) {
            return item;
          }


         return ;
        })).map(item => item['objectId']));
        if (!!senderMessageIds.length) {
          await Backendless.Data.of('Message').bulkUpdate( (String((await Promise.all(senderMessageIds.map(async item => {; return (['objectId=\'',item,'\''].join(''));}))).join(' or ')) + String(' and isRead=false')), ({ 'isRead': true }) );
        }
      }
      ___arguments.context.pageData['currentActivity'] = null;
      ___arguments.context.pageData['openMessage'] = null;
    }
  }
  ___arguments.context.dataModel['message'] = (await asyncListSort((await Backendless.Data.of('Message').find(Backendless.DataQueryBuilder.create().setWhereClause((['chatId=\'',(___arguments.context.dataModel['objectId']),'\''].join(''))).setRelated(['sender', 'receiver']).setSortBy('created desc').setPageSize(10))), 1, async (item) => {


   return (item['created']);
  }));
  ___arguments.context.pageData['currentActivity'] = ___arguments.context.getComponentDataStoreByUid('16dd5764241415b5429814de3ddfc0bd');
  ___arguments.context.pageData['openMessage'] = ___arguments.context.dataModel;
  await new Promise(r => setTimeout(r, 1 || 0));
  ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/d7ad7b88d2d7050d5a09b2c775d14fe5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchActivities']) {
    return (['Chats (',(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchActivities']).length,')'].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/925ebe06aff5c3f50e1c06032eb9a22c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchActivities')) {
    return (!!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchActivities')).length);
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/3867f9bd43f4e9bc47bcd75f2a93b149/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchChats']) {
    return (['Chats (',(await asyncListFilter((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchChats']), async (item) => {


     return ((item['activityId']) == (___arguments.context.getComponentDataStoreByUid('16dd5764241415b5429814de3ddfc0bd')['objectId']));
    })).length,')'].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/6d984bcaa9b38342221956235a032929/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchChats')) {
    return ((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchChats')), async (item) => {


     return ((getObjectProperty(item, 'activityId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('16dd5764241415b5429814de3ddfc0bd'), 'objectId')));
    })).length);
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/abafc493fb628fc2211c808cae63e7a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchRequests']) {
    return (['Requests (',(await asyncListFilter((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchRequests']), async (item) => {


     return ((item['activityId']) == (___arguments.context.getComponentDataStoreByUid('16dd5764241415b5429814de3ddfc0bd')['objectId']));
    })).length,')'].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/a95a0ddd25c882a81909fb6735228995/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchRequests']) {
    return ((await asyncListFilter((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchRequests']), async (item) => {


     return ((item['activityId']) == (___arguments.context.getComponentDataStoreByUid('16dd5764241415b5429814de3ddfc0bd')['objectId']));
    })).length);
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/48855f99b197ae5e647bd77c6f59c64b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchSystemMessages')) {
    return (['System messages (',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchSystemMessages')).length,')'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/9a53a9110001e3b212d5174d225a1ad6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchSystemMessages')) {
    return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b'), 'searchSystemMessages')).length);
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/ebea86d61c47973c58df5498fd6f5e66/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('16dd5764241415b5429814de3ddfc0bd')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('16dd5764241415b5429814de3ddfc0bd')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/c4b76d02d80c75d555f7912119e3c084/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('16dd5764241415b5429814de3ddfc0bd')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('16dd5764241415b5429814de3ddfc0bd')).pop();
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('16dd5764241415b5429814de3ddfc0bd')), 'open');
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/79d1884b1acd8d9f1dfd040d37811d33/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
      return ['RequestActivity__card', 'sent'];
    }
  }

  return ['RequestActivity__card']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/group-page/components/94d9515756c322ee308f8f0ca6ab8195/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (___arguments.context.pageData['openMessage']) {
    if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
      return ['RequestActivity__card', 'sent'];
    }
  }

  return ['RequestActivity__card']

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/3644e7181decfd1b4a0ba3563c8ba44c/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] != 'open') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')), 'open');
  }

  },  
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] == 'open') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).pop();
  }

  },  
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/group-page/components/90c19d93eb614726a341c1fb5e768591/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-profile', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/9eae8aaea9c2c53768ab2ae436711e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-activities', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/8cadea982ab7c138c629aadb391c73c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('settings', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/607680653092fc2b09867b42d84b520d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bfb8c73aa8c2f3dc6e37c7f9116ae2d5')), 'open');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/fbb42e028304951506e9dcbdfde625d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(', ') + String((await (async function(year, month, day) {
	let now = new Date();
	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

	let dob = new Date(year, month, day);

	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

	let age;

	age = today.getFullYear() - dob.getFullYear();

	if (today < dobnow) {
	  age = age-1;
	} else {
	  age = age
	}

	return age

})((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'authorBirthDate'))).getFullYear()), (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'authorBirthDate'))).getMonth()), (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'authorBirthDate'))).getDate())))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/1c34c06f077fdcf1beceabaaf7018d97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.pageData['currentTab']) == 'chats')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/357a4fb5c6ad0e64b9d76bef28074298/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.pageData['currentTab']) == 'invitations')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/47f23fa5a5c8e31d3696d3728f1a985b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['sentSystemMessages']) {
    return (['Sent (',(___arguments.context.pageData['sentSystemMessages']).length,')'].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/e8bfa435ad95afe650ea843dae874cec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['receivedSystemMessages']) {
    return (['Received (',(___arguments.context.pageData['receivedSystemMessages']).length,')'].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/503cba86ae584c5e50bc98f6d5bb77ed/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['receivedSystemMessages']) {
    return ((___arguments.context.pageData['receivedSystemMessages']).length);
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/a4f514a6b999cda29c6f5c7c98d13788/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')) {
    return ((getObjectProperty(___arguments.context.pageData, 'sentSystemMessages')).length);
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/68110748c904b5c13e3d212865fc3398/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8')['type']) == 'requestPermission') {
    return 'styles/img/icons/lock_gray.svg';
  } else {
    return 'styles/img/icons/logoIcon.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/a2a23eb6c24116b2f938b149b89670ce/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97')['type']) == 'requestPermission') {
    return 'styles/img/icons/lock_gray.svg';
  } else {
    return 'styles/img/icons/logoIcon.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/9caef6f5d10545bd456cc51892ced1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97')['type']) == 'invitation') {
    return (String((___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97')['sender'])['name']) + String(' has invited you to his activity '));
  } else if ((___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97')['type']) == 'activityRequest') {
    return (String((___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97')['sender'])['name']) + String(' has applied to your activity '));
  } else {
    return (String((___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97')['sender'])['name']) + String(' requested permissions to view your photos'));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/7419f70a9f582024be5ad67b3378a45d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8')['type']) == 'invitation') {
    return (['You invited ',((___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8')['receiver'])['name']),' your activity'].join(''));
  } else if ((___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8')['type']) == 'activityRequest') {
    return (['You applied to ',((___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8')['receiver'])['name']),'’s activity'].join(''));
  } else {
    return (['You requested permissions to view ',((___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8')['receiver'])['name']),'\'s photos'].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/3f6f176a773f5a86f8686e43eed81998/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97')['sender'])['photo']) {
    return ((___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97')['sender'])['photo']);
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/f303a567111ef02d43227e742b3f3953/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8')['receiver'])['photo']) {
    return ((___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8')['receiver'])['photo']);
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/10e3c2c8c8ae8c7d5d358e3cb4a7f833/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'receiver')), 'online'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/01c89a6ad71f97ed2ff7bb91b11263a4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'receiver')), 'online'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/b8c7f6fd977547c21cf106878ef9dac8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var receiverPhoto, item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['noMoreMessages'] = false;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', false);
  } else {
    await BackendlessUI.Functions.Custom['fn_30743f6255d6db0f649790555183a8e3'](___arguments.context.pageData);
  }
  ___arguments.context.dataModel['message'] = [(getObjectProperty(___arguments.context.dataModel, 'recentMessage'))];
  ___arguments.context.pageData['openMessage'] = ___arguments.context.dataModel;
  if ((getObjectProperty(___arguments.context.dataModel, 'type')) != 'requestPermission') {
    ___arguments.context.pageData['currentActivity'] = ((await Backendless.Data.of('Activity').find(Backendless.DataQueryBuilder.create().setWhereClause((['chat.objectId=\'',(getObjectProperty(___arguments.context.dataModel, 'objectId')),'\''].join(''))).setProperties(['objectId', 'author.name as authorName', 'author.birthDate as authorBirthDate', 'author.userProfile.media as authorMedia', 'author.objectId as authorObjectId', 'name', 'activityDate', 'author.online as onlineAuthor', 'description', 'financialRole', 'ongoingTiming', 'visibility']).setPageSize(1)))[0]);
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'authorMedia')) {
      receiverPhoto = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'authorMedia')), async (item) => {


       return (getObjectProperty(item, 'isCover'));
      }))[0];
      (getObjectProperty(___arguments.context.pageData, 'currentActivity'))['authorPhoto'] = (getObjectProperty(receiverPhoto, 'file'));
    }
  } else {
    ___arguments.context.pageData['currentActivity'] = null;
  }
  await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](___arguments.context.pageData);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (___arguments.context.pageData['openMessage']) {
      if (((___arguments.context.pageData['openMessage'])['objectId']) == (___arguments.context.dataModel['objectId'])) {
        return ['MessagesActivities__item', 'open'];
      }
    }
  }

  return ['MessagesActivities__item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/group-page/components/b6630085d09adb7f8b08af4e414e1a97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var receiverPhoto, item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['noMoreMessages'] = false;
  if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', false);
  } else {
    await BackendlessUI.Functions.Custom['fn_30743f6255d6db0f649790555183a8e3'](___arguments.context.pageData);
  }
  ___arguments.context.dataModel['message'] = [(getObjectProperty(___arguments.context.dataModel, 'recentMessage'))];
  ___arguments.context.pageData['openMessage'] = ___arguments.context.dataModel;
  if ((getObjectProperty(___arguments.context.dataModel, 'type')) != 'requestPermission') {
    ___arguments.context.pageData['currentActivity'] = ((await Backendless.Data.of('Activity').find(Backendless.DataQueryBuilder.create().setWhereClause((['chat.objectId=\'',(getObjectProperty(___arguments.context.dataModel, 'objectId')),'\''].join(''))).setProperties(['objectId', 'author.name as authorName', 'author.birthDate as authorBirthDate', 'author.userProfile.media as authorMedia', 'author.objectId as authorObjectId', 'name', 'activityDate', 'author.online as onlineAuthor', 'description', 'financialRole', 'ongoingTiming', 'visibility']).setPageSize(1)))[0]);
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'authorMedia')) {
      receiverPhoto = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'authorMedia')), async (item) => {


       return (getObjectProperty(item, 'isCover'));
      }))[0];
      (getObjectProperty(___arguments.context.pageData, 'currentActivity'))['authorPhoto'] = (getObjectProperty(receiverPhoto, 'file'));
    }
  } else {
    ___arguments.context.pageData['currentActivity'] = null;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (___arguments.context.pageData['openMessage']) {
      if (((___arguments.context.pageData['openMessage'])['objectId']) == (___arguments.context.dataModel['objectId'])) {
        return ['MessagesActivities__item', 'open'];
      }
    }
  }

  return ['MessagesActivities__item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/group-page/components/612388e2ccef4c2a23e6fead1ddd02db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver'))) {
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photo')) {
          return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photo'));
        }
      } else {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photo')) {
          return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photo'));
        }
      }
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/3d74f81c23dd303e5ac2e0994ddab7da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/8ac5124f49da89ca63b2083c712272c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return (___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b')['newMessages'])

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/adc40e2ee9cd19992ff9d1a21a5779f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('57d9567f707fa45310b99cff3512d022')['newMessages']) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/834ee899b557cdd8432494d20256efec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['receivedSystemMessages']) {
    return ((___arguments.context.pageData['receivedSystemMessages']).length);
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/955e41f95a3b45e864570a7fc54c7a99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var chat, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.pageData['receivedChats']) {
    chat = (await asyncListFilter((___arguments.context.pageData['receivedChats']), async (item) => {


     return (((___arguments.context.pageData['currentUser'])['objectId']) == (((item['recentMessage'])['receiver'])['objectId']) && ((item['recentMessage'])['isRead']) == false);
    }));
    if (!!chat.length) {
      ___arguments.context.pageData['newMessages'] = true;
    } else {
      ___arguments.context.pageData['newMessages'] = false;
    }
  }

  return (___arguments.context.pageData['newMessages'])

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/32d8e811144bddef7a3286243a856631/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      if (((___arguments.context.pageData['currentUser'])['objectId']) == (((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['recentMessage'])['receiver'])['objectId']) && ((___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94')['recentMessage'])['isRead']) == false) {
    ___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793')['newMessages'] = ((___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793')['newMessages']) + 1);
    console.log(___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793')['newMessages']);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/group-page/components/57d9567f707fa45310b99cff3512d022/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.dataModel['newMessages'] = 0;

  },
  /* handler:onMounted */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cd753f78175390294544bc17bc05c793')).includes('open')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cd753f78175390294544bc17bc05c793')).pop();
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('29a4baa6dcad66e593897e18f1b23076')).pop();
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cd753f78175390294544bc17bc05c793')), 'open');
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('29a4baa6dcad66e593897e18f1b23076')), 'active');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/64e3891b9e772e946bbfe01539084b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_e97140c64a3efafdbfb71077439f3811']();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/7cebd5c389dbd4cf41cb01f96bbc30a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/d232eb43cfcf9e8a9b3d902f80194225/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bfb8c73aa8c2f3dc6e37c7f9116ae2d5')).pop();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/eaf375b73a9358cb05add4e7028fb4cc/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if ((___arguments.context.pageData['currentActivity']) && (___arguments.context.pageData['openMessage'])) {
    if ((___arguments.context.pageData['currentActivity'])['authorPhoto']) {
      return ((___arguments.context.pageData['currentActivity'])['authorPhoto']);
    }
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/f42499eda5915e12ae32f77f2e4519b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var user;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  user = ({  });
  if ((((___arguments.context.pageData['openMessage'])['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
    user = ((___arguments.context.pageData['openMessage'])['receiver']);
  } else {
    user = ((___arguments.context.pageData['openMessage'])['sender']);
  }
  ___arguments.context.pageData['modalContent'] = ({ 'type': 'delete','title': ['Delete chat with ',(user['login']),'?'].join(''),'text': 'Are you sure you would like to delete this chat? All messages will be removed. The other user will still see the chat and will be able to communicate with you. To stop all communication, consider the "Block" option.','button': 'Delete','doneText': 'Done!','doneButton': 'Thanks' });
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/3b41b7a2baccc6c61ebea193187da14b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages']) {
    return (['Messages (',(___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages']).length,')'].join(''));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/4c18d15a5e99d38d46c354a62716c55a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages']) {
    return ((___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages']).length);
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/d1e7e16b3476d7da3a658d53df37c3d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1d6e41f8aae1a55656110e9c7da9667b')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1d6e41f8aae1a55656110e9c7da9667b')).pop();
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchInput'] = '';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fec7f882dd2d3f2d1e2c8ad158cb1708', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d89faea2b93a5846565eb7b1b7871ac', true);
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResults'] = [];
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages'] = [];
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchActivities'] = [];
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchSystemMessages'] = [];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/60df1a7a780f4ec4a186b48a316ebe2a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('9a53a9110001e3b212d5174d225a1ad6')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('9a53a9110001e3b212d5174d225a1ad6')).pop();
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('906f423760f8f3cb1a8f7fabe9a4a6fa')), 'closed');
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('9a53a9110001e3b212d5174d225a1ad6')), 'open');
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('906f423760f8f3cb1a8f7fabe9a4a6fa')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/b55867331c735702367bcf9fea53a1c5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('925ebe06aff5c3f50e1c06032eb9a22c')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('925ebe06aff5c3f50e1c06032eb9a22c')).pop();
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('9c8487d7dbc261af59f84c1c297a929f')), 'closed');
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('925ebe06aff5c3f50e1c06032eb9a22c')), 'open');
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('9c8487d7dbc261af59f84c1c297a929f')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/f6588c3fba03d1a84a789e3df267d5d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4c18d15a5e99d38d46c354a62716c55a')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4c18d15a5e99d38d46c354a62716c55a')).pop();
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('085b0a9f557ed03e391e2354927f65fa')), 'closed');
  } else {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('4c18d15a5e99d38d46c354a62716c55a')), 'open');
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('085b0a9f557ed03e391e2354927f65fa')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/966c50092017b9c3b2be094dc962c8f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1d6e41f8aae1a55656110e9c7da9667b')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1d6e41f8aae1a55656110e9c7da9667b')).pop();
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchInput'] = '';
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fec7f882dd2d3f2d1e2c8ad158cb1708', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7d89faea2b93a5846565eb7b1b7871ac', true);
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResults'] = [];
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchResultsMessages'] = [];
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchActivities'] = [];
    ___arguments.context.getComponentDataStoreByUid('1d6e41f8aae1a55656110e9c7da9667b')['searchSystemMessages'] = [];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/1eb7bab5a136bd39cada56cbf7aa1a01/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'authorObjectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'visibility')) == 3) {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    var user;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'withdraw','title': 'Withdraw the invitation?','text': ['Are you sure you want to withdraw the invitation to this activity for ',(((___arguments.context.pageData['openMessage'])['receiver'])['login']),'?'].join(''),'button': 'Yes','doneText': 'Invitation withdrawn!','doneButton': 'Thanks' });
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/9c9589e7a4af933f98bfcc91a2151232/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty(___arguments.context.pageData, 'currentActivity'))) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'withdraw','title': 'Withdraw the request?','text': ['Are you sure you want to withdraw the request to be +1 for ',(((___arguments.context.pageData['openMessage'])['receiver'])['login']),'?'].join(''),'button': 'Yes','doneText': 'Request withdrawn!','doneButton': 'Thanks' });
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/69b9a7435b6e5a774f967f27f307dc8b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var currentUser, user, error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0659399e0984fc65fe1de38fbd2ed5e4', true);
  ___arguments.context.pageData['group'] = ((await Backendless.Data.of('Group').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(getObjectProperty(___arguments.context.pageData, 'groupId')),'\''].join(''))).setRelationsDepth(2).setPageSize(1)))[0]);
  ___arguments.context.pageData['members'] = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId in (\'',((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'members')).map(item => item['ownerId'])).join('\',\''),'\')'].join(''))).setPageSize(100)));
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures')) {
    ___arguments.context.pageData['imageList'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures'));
  }
  if (!(getObjectProperty(___arguments.context.appData, 'userRoles'))) {
    ___arguments.context.appData['userRoles'] = (await Backendless.UserService.getUserRoles());
  }
  if (!((getObjectProperty(___arguments.context.appData, 'userRoles')).includes('dev'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('out-of-service', undefined);
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await Backendless.UserService.getCurrentUser(false));
    ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
    (getObjectProperty(___arguments.context.appData, 'currentUser'))['searchFilter'] = (await Backendless.Request.get(`${Backendless.appPath}/services/searchFilter/searchFilter`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    (getObjectProperty(___arguments.context.appData, 'currentUser'))['userProfile'] = (await Backendless.Request.get(`${Backendless.appPath}/services/userProfile/userProfile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  } else if ((getObjectProperty(___arguments.context.appData, 'currentUser')) && !(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'searchFilter'))) {
    (getObjectProperty(___arguments.context.appData, 'currentUser'))['searchFilter'] = (await Backendless.Request.get(`${Backendless.appPath}/services/searchFilter/searchFilter`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  ___arguments.context.pageData['pageSize'] = 20;
  console.log(getObjectProperty(___arguments.context.pageData, 'currentUser'));
  currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  try {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')) && (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


     return (getObjectProperty(item, 'isCover'));
    }))) {
      (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


       return ((getObjectProperty(item, 'isCover')) == true);
      }))[0]), 'file'));
    }

  } catch (error) {
    console.log(error);

  }
  if (false) {
    if (!(getObjectProperty(___arguments.context.appData, 'chatList'))) {
      ___arguments.context.appData['chatList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/chatId/chatId`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      ___arguments.context.appData['countMessage'] = (await Backendless.Data.of('Message').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\' and isRead=false'].join('')))));
    }
    ___arguments.context.pageData['chatList'] = (getObjectProperty(___arguments.context.appData, 'chatList'));
    ___arguments.context.pageData['countMessage'] = (getObjectProperty(___arguments.context.appData, 'countMessage'));
    ___arguments.context.pageData['messagesNumber'] = (getObjectProperty(___arguments.context.pageData, 'countMessage'));
  }
  user = (await Backendless.UserService.getCurrentUser(false));
  if (!true) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
  } else if (!(getObjectProperty(___arguments.context.appData, 'login'))) {
    ___arguments.context.appData['login'] = (getObjectProperty(currentUser, 'login'));
    if (getObjectProperty(currentUser, 'photo')) {
      ___arguments.context.appData['photo'] = (getObjectProperty(currentUser, 'photo'));
    }
  }
  if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  if ((getObjectProperty(currentUser, 'profileStatus')) == false) {
    ___arguments.context.appData['profileStatus'] = false;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && !(getObjectProperty(___arguments.context.appData, 'device'))) {
    ___arguments.context.appData['device'] = (await Backendless.Data.of('DeviceRegistration').find(Backendless.DataQueryBuilder.create().setWhereClause((['user.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(100)));
    ___arguments.context.pageData['device'] = (getObjectProperty(___arguments.context.appData, 'device'));
  }
  if (getObjectProperty(___arguments.context.pageData, 'device')) {
    ___arguments.context.pageData['ids'] = ((getObjectProperty(___arguments.context.pageData, 'device')).map(item => item['deviceId']));
  }
  if (true) {
    currentUser = (await Backendless.UserService.getCurrentUser(false));
    if (!(await Backendless.UserService.isValidLogin())) {
      await Backendless.UserService.logout();
      Backendless.setCurrentUserToken(null);
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    }
    if (getObjectProperty(___arguments.context.appData, 'statusList')) {
    } else {
      ___arguments.context.appData['statusList'] = (await Backendless.Data.of('ProfileMaritalStatus').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['ethnicityList'] = (await Backendless.Data.of('ProfileEthnicity').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['bodyTypeList'] = (await Backendless.Data.of('ProfileBodyType').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['orientationList'] = (await Backendless.Data.of('ProfileSexOrientation').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['educationList'] = (await Backendless.Data.of('ProfileEducationLevel').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['politicalList'] = (await Backendless.Data.of('ProfilePoliticalView').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['religionList'] = (await Backendless.Data.of('ProfileReligion').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['hairColorList'] = (await Backendless.Data.of('ProfileHairColor').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['smokeList'] = (await Backendless.Data.of('ProfileSmoke').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['drinkList'] = (await Backendless.Data.of('ProfileDrink').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0659399e0984fc65fe1de38fbd2ed5e4', false);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/group-page/components/efdddf4caeca0a189e04c37687a78d6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('234b2175dd78fb65a874d61666a2f0fe')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('234b2175dd78fb65a874d61666a2f0fe', false);
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb38d4cf241a13843ba17472a5077606')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb38d4cf241a13843ba17472a5077606', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69b9a7435b6e5a774f967f27f307dc8b', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/3f3c1a21a2015662b12119510f954def/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/ba91f952324802d404d8d70cb77f917b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return false;
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/e937903899af201ec38d2a2adc096398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('groups', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/aea919c8e7c3c40e13e84e0a8beb98d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('groups', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/5271f505f2f435b3c51fd2f22f33fd99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/d7fe2313a28319cac025d3c956dcf78b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'group')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/ddf3159b707971be8f264be6a9215538/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async onDynamicItemsAssignment(___arguments) {
    var media;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 2000 || 0));
  if (getObjectProperty(___arguments.context.pageData, 'group')) {
    media = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures'));
  }
  if (media) {
    return media;
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/group-page/components/65415c18b0fca6c5e061237867995b25/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'group')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/6e695a29c0a923fdd02eed655d4c67ce/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'group')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'longDescription'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/b791e4241864055979332aac63a2e173/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'group')) {
    return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'category')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/a5d12953f5343031fb253a59c065a5f6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'group')) {
    return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'category')), 'icon'));
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/660ba6897508db5549c885bf9ea46e73/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'group')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/677e08cf3be6aebbcfe8e665a28d0b3a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'group')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/group-page/components/700b7605359b647953692d7b22939ce4/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures')).length == 1) {
    return ['profile-gallery__item', 'profile-gallery__item-xl'];
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures')).length == 2) {
    return ['profile-gallery__item', 'profile-gallery__item-md'];
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures')).length == 3) {
    return ['profile-gallery__item', 'profile-gallery__item-lg'];
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures')).length == 4) {
    return ['profile-gallery__item', 'profile-gallery__item-sm'];
  }

  return ['profile-gallery__item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/group-page/components/420df169126cdaf8581964413eb7ad21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69b9a7435b6e5a774f967f27f307dc8b')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69b9a7435b6e5a774f967f27f307dc8b', false);
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb38d4cf241a13843ba17472a5077606')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb38d4cf241a13843ba17472a5077606', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('234b2175dd78fb65a874d61666a2f0fe', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/df545cf4f0115583c7ca9701332fd4b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures')).length > 5) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['imageList'] = (await Promise.all((getObjectProperty(___arguments.context.pageData, 'imageList')).map(async item => {  if ((getObjectProperty(item, 'file')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('700b7605359b647953692d7b22939ce4'), 'file'))) {
      item['current'] = true;
    } else {
      item['current'] = false;
    }
  ; return item;})));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8968a8769b41fc3e6ad822d8ff0d0c75', true);
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8968a8769b41fc3e6ad822d8ff0d0c75')));

  },
  /* handler:onClick */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures')) {
    return (['+',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'profilePictures')).length - 5,' more'].join(''));
  }

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/group-page/components/99fb8321d874baaaa3479c770d83658f/bundle.js', [], () => ({
  /* content */
  /* handler:onMapCenterAssignment */
  onMapCenterAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'group')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'locationPiont'))) {
    return ({ 'lat': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'locationPiont')), 'y')),'lng': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'locationPiont')), 'x')) });
  }

  return ({ 'lat': 0,'lng': 0 })

  },
  /* handler:onMapCenterAssignment */
  /* content */
}))

define('./pages/group-page/components/24b91ba82374ffa3dda6a1c80d339e8f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('234b2175dd78fb65a874d61666a2f0fe')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('234b2175dd78fb65a874d61666a2f0fe', false);
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69b9a7435b6e5a774f967f27f307dc8b')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69b9a7435b6e5a774f967f27f307dc8b', false);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('eb38d4cf241a13843ba17472a5077606', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/33e4fbffa6fd54cdd6d9690a98dfff8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'members')) {
    return (getObjectProperty(___arguments.context.pageData, 'members'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/group-page/components/64d2e6c7e0d8989f03a345796d2cac5b/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec5f3cb76deb9f7707286d57303b2ee'), 'photoThumbnail')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec5f3cb76deb9f7707286d57303b2ee'), 'photoThumbnail'));
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/group-page/components/33be696d017839a253d1416a3fe3eb56/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var item, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var item_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'group')), 'organizers'));
  for (var item_index in item_list) {
    item = item_list[item_index];
    if ((getObjectProperty(item, 'ownerId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec5f3cb76deb9f7707286d57303b2ee'), 'objectId'))) {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/group-page/components/e603d06fc8e3e731bf12f74582570c94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/group-page/components/2be70b1b39c7bd5c34fb10d4dd0999dd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/groups/components/916764cf81f7f4dd39add13dbd65fa7a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['location'] = ___arguments.value;
  ___arguments.context.pageData['location'] = ___arguments.value;
  ___arguments.context.pageData['groups'] = (await BackendlessUI.Functions.Custom['fn_498e158c8709b3f96ffb2d42938f05b8'](___arguments.context.pageData));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  onOptionsAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'locationList')) {
    return (getObjectProperty(___arguments.context.pageData, 'locationList'));
  }

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/groups/components/69b9a7435b6e5a774f967f27f307dc8b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
    var currentUser;

  },
  /* handler:onBeforeMount */
  /* handler:onScroll */
  async onScroll(___arguments) {
    var moreUsers, gender, searchInput;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.scrollTop >= 200) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5683be521befcd52d065569654b1f547', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5683be521befcd52d065569654b1f547', false);
  }
  if (___arguments.scrollBottom == 1 && ((getObjectProperty(___arguments.context.pageData, 'users')) ? (getObjectProperty(___arguments.context.pageData, 'users')).length : null) > 0 && !(getObjectProperty(___arguments.context.pageData, 'noMoreUsers'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('018adb099dffd5e852ab50211274a152', true);
    ___arguments.context.pageData['countOffset'] = ((getObjectProperty(___arguments.context.pageData, 'countOffset')) + 1);
    ___arguments.context.pageData['currentUser'] = (await Backendless.Data.of('Users').findById((getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId')), Backendless.DataQueryBuilder.create().setRelationsDepth(2)));
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchInput')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchInput')).length > 0) {
      searchInput = [' and (login like \'%',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchInput')),'%\' or name like \'%',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchInput')),'%\' or userProfile.aboutShort like \'%',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchInput')),'%\')'].join('');
    } else {
      searchInput = '';
    }
    moreUsers = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    if (!!moreUsers.length) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'users')), moreUsers);
    } else {
      ___arguments.context.pageData['users'] = (getObjectProperty(___arguments.context.pageData, 'users'));
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('018adb099dffd5e852ab50211274a152', false);
  }

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/groups/components/f45cfd38a65f190edc6b5ea42557777a/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (!(getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.appData, 'login'))) {
      return (getObjectProperty(___arguments.context.appData, 'login'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
    } else {
      return 'Account';
    }
  } else {
    return 'Account';
  }

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/groups/components/209f76aea5a1596a808900fda74b4dd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async onSourceUrlAssignment(___arguments) {
    var photo;


  photo = '';
  if ((___arguments.context.pageData['currentUser']) && (await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if ((___arguments.context.pageData['currentUser'])['photoThumbnail']) {
      photo = ((___arguments.context.pageData['currentUser'])['photoThumbnail']);
    }
  } else {
    if ((___arguments.context.appData['photo']) && (await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
      photo = (___arguments.context.appData['photo']);
    }
  }

  return photo

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var img;


  img = false;
  if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    img = true;
  }

  return img

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/groups/components/b396680db47c2819f51d8bb87e2a2c45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
    var photo;


  photo = true;
  if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (___arguments.context.pageData['currentUser']) {
      photo = !((___arguments.context.pageData['currentUser'])['photoThumbnail']);
    } else if (___arguments.context.appData['photoThumbnail']) {
      photo = !(___arguments.context.appData['photoThumbnail']);
    } else {
      photo = true;
    }
  }

  return photo

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/groups/components/0448df893e32322927b651e96991a933/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'] = ___arguments.checkedValue;
  ((___arguments.context.pageData['currentUser'])['searchFilter'])['gender'] = ___arguments.checkedValue;
  await Backendless.Data.of('UserSearchFilter').bulkUpdate( (['ownerId=\'',((___arguments.context.pageData['currentUser'])['objectId']),'\''].join('')), ({ 'gender': ___arguments.checkedValue }) );
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((___arguments.context.pageData['currentUser']), ((___arguments.context.pageData['currentUser'])['userProfile']), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (___arguments.context.pageData['pageSize'])));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* handler:onCheckedValueAssignment */
  onCheckedValueAssignment(___arguments) {
      if (!(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'])) {
    return '';
  } else {
    return (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender']);
  }

  },  
  /* handler:onCheckedValueAssignment */
  /* content */
}))

define('./pages/groups/components/c4d360f9584d8828b116ff1ee133ba51/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    var j, searchFilter, error, currentUser, item;

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  onBeforeUnmount(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));

  },
  /* handler:onBeforeUnmount */
  /* handler:onBeforeMount */
  async onBeforeMount(___arguments) {
    var currentUser, item, searchFilter, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if (!currentUser) {
  } else if (!(getObjectProperty(___arguments.context.appData, 'login'))) {
    ___arguments.context.appData['login'] = (getObjectProperty(currentUser, 'login'));
    if (getObjectProperty(currentUser, 'photo')) {
      ___arguments.context.appData['photo'] = (getObjectProperty(currentUser, 'photoThumbnail'));
    }
  }
  if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = currentUser;
    (getObjectProperty(___arguments.context.appData, 'currentUser'))['searchFilter'] = (await Backendless.Request.get(`${Backendless.appPath}/services/searchFilter/searchFilter`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    (getObjectProperty(___arguments.context.appData, 'currentUser'))['userProfile'] = (await Backendless.Request.get(`${Backendless.appPath}/services/userProfile/userProfile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  } else if ((getObjectProperty(___arguments.context.appData, 'currentUser')) && !(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'searchFilter'))) {
    (getObjectProperty(___arguments.context.appData, 'currentUser'))['searchFilter'] = (await Backendless.Request.get(`${Backendless.appPath}/services/searchFilter/searchFilter`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  console.log(getObjectProperty(___arguments.context.pageData, 'currentUser'));
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == false) {
    ___arguments.context.appData['profileStatus'] = false;
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  ___arguments.context.pageData['pageSize'] = 20;
  try {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')) && (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    }))) {
      (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


       return ((getObjectProperty(item, 'isCover')) == true);
      }))[0]), 'file'));
    }

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['groups'] = (await BackendlessUI.Functions.Custom['fn_498e158c8709b3f96ffb2d42938f05b8'](___arguments.context.pageData));
  console.log(getObjectProperty(___arguments.context.pageData, 'groups'));
  ___arguments.context.pageData['groupsAll'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'groups')), -1, async (item) => {


   return (getObjectProperty(item, 'count'));
  }));
  console.log(getObjectProperty(___arguments.context.pageData, 'groupsAll'));
  ___arguments.context.dataModel['groupSizeMin'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'groupsAll')).slice(-1)[0]), 'count'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('84561d5c60947b28591e3898d3bfc142'))['minValue'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'groupsAll')).slice(-1)[0]), 'count'));
  ___arguments.context.dataModel['groupSizeMax'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'groupsAll'))[0]), 'count'));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('84561d5c60947b28591e3898d3bfc142'))['maxValue'] = (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'groupsAll'))[0]), 'count'));
  ___arguments.context.pageData['category'] = (await Backendless.Data.of('Category').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  if (!(getObjectProperty(___arguments.context.appData, 'chatList'))) {
    ___arguments.context.appData['chatList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/chatId/chatId`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    ___arguments.context.appData['countMessage'] = (await Backendless.Data.of('Message').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\' and isRead=false'].join('')))));
  }
  ___arguments.context.pageData['chatList'] = (getObjectProperty(___arguments.context.appData, 'chatList'));
  ___arguments.context.pageData['countMessage'] = (getObjectProperty(___arguments.context.appData, 'countMessage'));
  ___arguments.context.pageData['messagesNumber'] = (getObjectProperty(___arguments.context.pageData, 'countMessage'));
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f64e76d36d2d2cee6b2698b7d2c568db')));
  if (true) {
    if (!(getObjectProperty(___arguments.context.appData, 'userRoles'))) {
      ___arguments.context.appData['userRoles'] = (await Backendless.UserService.getUserRoles());
    }
    if (!((getObjectProperty(___arguments.context.appData, 'userRoles')).includes('dev'))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('out-of-service', undefined);
    }
    if (getObjectProperty(___arguments.context.appData, 'statusList')) {
      return ;
    } else {
      ___arguments.context.appData['statusList'] = (await Backendless.Data.of('ProfileMaritalStatus').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['ethnicityList'] = (await Backendless.Data.of('ProfileEthnicity').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['bodyTypeList'] = (await Backendless.Data.of('ProfileBodyType').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['orientationList'] = (await Backendless.Data.of('ProfileSexOrientation').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['educationList'] = (await Backendless.Data.of('ProfileEducationLevel').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['politicalList'] = (await Backendless.Data.of('ProfilePoliticalView').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['religionList'] = (await Backendless.Data.of('ProfileReligion').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['hairColorList'] = (await Backendless.Data.of('ProfileHairColor').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['smokeList'] = (await Backendless.Data.of('ProfileSmoke').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
      ___arguments.context.appData['drinkList'] = (await Backendless.Data.of('ProfileDrink').find(Backendless.DataQueryBuilder.create().setPageSize(50)));
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && !(getObjectProperty(___arguments.context.appData, 'device'))) {
    ___arguments.context.appData['device'] = (await Backendless.Data.of('DeviceRegistration').find(Backendless.DataQueryBuilder.create().setWhereClause((['user.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join(''))).setSortBy('created desc').setPageSize(100)));
    ___arguments.context.pageData['device'] = (getObjectProperty(___arguments.context.appData, 'device'));
  }
  if (getObjectProperty(___arguments.context.pageData, 'device')) {
    ___arguments.context.pageData['ids'] = ((getObjectProperty(___arguments.context.pageData, 'device')).map(item => item['deviceId']));
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/groups/components/347559d66449cac4a40ff60f93b8a922/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['currentUser']) {
    return (((___arguments.context.pageData['currentUser'])['userProfile'])['location']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/groups/components/6a8f403c019b4a02b177d5034d14607d/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'groups')) {
    return (getObjectProperty(___arguments.context.pageData, 'groups'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/groups/components/eb12e5dc7373502a78063e5e7aa5c957/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://findmyplus.one/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/0025abc14d3781d98c93cff5c9879f2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('group-page', ({ 'groupId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/8378734b92fa3c99354c7421f3ad9f23/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var item, index;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['searchInput'] = (___arguments.value.toLowerCase());
  if (!___arguments.value) {
    console.log('abc');
    ___arguments.context.pageData['search'] = true;
  }
  if (___arguments.value) {
    await new Promise(r => setTimeout(r, 500 || 0));
    if (getObjectProperty(___arguments.context.pageData, 'search')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
      ___arguments.context.pageData['groups'] = (await BackendlessUI.Functions.Custom['fn_498e158c8709b3f96ffb2d42938f05b8'](___arguments.context.pageData));
      delete ___arguments.context.pageData['search'];
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
    }
  } else if (!___arguments.value && !(getObjectProperty(___arguments.context.pageData, 'search'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.pageData['groups'] = (await BackendlessUI.Functions.Custom['fn_498e158c8709b3f96ffb2d42938f05b8'](___arguments.context.pageData));
    delete ___arguments.context.pageData['search'];
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  }

  },
  /* handler:onChange */
  /* handler:onKeyDown */
  onKeyDown(___arguments) {
    
  },
  /* handler:onKeyDown */
  /* content */
}))

define('./pages/groups/components/318563325306ad2e6d432468a69beb08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-profile', null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] != 'open') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')), 'open');
  }

  },  
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] == 'open') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).pop();
  }

  },  
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/groups/components/33fa9bfc9a64afa2cb8db4a6580b59fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/061e6307bb3fb9b624d268225542836e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('interests', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/cd8bf77173e9a0b1fc9e23d99fdfa767/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('group-page', ({ 'groupId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')) }));

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683')['name']) ? (___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683')['name']) : (___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683')['login']))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/groups/components/23e9db8f324d6c9c77a611cf7e162196/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return true;
  } else {
    return false;
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/groups/components/89bba07b78a5b3ba398dcc88d539ea5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/groups/components/80eea16e201a167ad7b116898c7f5e6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['isViewedFiltersTooltip'] = true;
  localStorage.setItem('isViewedFiltersTooltip', JSON.stringify(true));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/686f1e6f2ab7d426809e62a5e57b6e6f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('search-filter', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/5553f044cf82b609f88b4603aaaed488/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5553f044cf82b609f88b4603aaaed488'))['pointer-events'] = 'none';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5553f044cf82b609f88b4603aaaed488')).slice(-1)[0] != 'clicked') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5553f044cf82b609f88b4603aaaed488')), 'clicked');
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), ({ 'ts': ((new Date()).valueOf()),'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')) }));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5553f044cf82b609f88b4603aaaed488')).pop();
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['myLikes'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')) != (getObjectProperty(item, 'objectId')));
    }));
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('5553f044cf82b609f88b4603aaaed488'))['pointer-events'] = 'auto';

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')) {
      if (!!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')));
      })).length) {
        return ['user-activities__favorite-icon', 'clicked'];
      }
    }
  }

  return ['user-activities__favorite-icon', 'white']

  },
  /* handler:onClassListAssignment */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await (async function() {
  	document.querySelector('.user-activities__favorite').addEventListener('click', function(e){
  	    e.preventDefault();
  	});
  })();

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/groups/components/92ac8dee840cbc9e68d70d84a00e3d42/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('group-page', ({ 'groupId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')) }));

  },
  /* handler:onClick */
  /* handler:onSourceUrlAssignment */
  async onSourceUrlAssignment(___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'profilePictures')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'profilePictures')).length > 0) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'profilePictures')), async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    })).length) {
      try {
        return (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'profilePictures')), async (item) => {


         return ((getObjectProperty(item, 'isCover')) == true);
        }))[0]), 'file'));

      } catch (error) {
        console.log(error);
        return 'styles/img/placeholder_photo.png';

      }
    } else {
      return 'styles/img/placeholder_photo.png';
    }
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/groups/components/b3372f6ac9172b9f4ac43c9eaf8cf874/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('create-activity', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/5683be521befcd52d065569654b1f547/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9cba9614d445dce7650ed19b421e5101')));

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  onEnter(___arguments) {
      ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['isViewedFiltersTooltip'] = ((function(){ try { return JSON.parse(localStorage.getItem('isViewedFiltersTooltip')) } catch(e){ return null }})());

  },
  /* handler:onEnter */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'Groups'

  },
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/groups/components/ad13678bc7d7805fa9698b1782d9cc0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['currentUser']) {
    if ((___arguments.context.pageData['currentUser'])['userProfile']) {
      return (((___arguments.context.pageData['currentUser'])['userProfile'])['location']);
    }
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/groups/components/234b2175dd78fb65a874d61666a2f0fe/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['heightList'] = [({ 'value': '152','label': '5′0″ (152 cm)' }), ({ 'value': '155','label': '5′1″ (155 cm)' }), ({ 'value': '157','label': '5′2″ (157 cm)' }), ({ 'value': '160','label': '5′3″ (160 cm)' }), ({ 'value': '163','label': '5′4″ (163 cm)' }), ({ 'value': '165','label': '5′5″ (165 cm)' }), ({ 'value': '168','label': '5′6″ (168 cm)' }), ({ 'value': '170','label': '5′7″ (170 cm)' }), ({ 'value': '173','label': '5′8″ (173 cm)' }), ({ 'value': '176','label': '5′9″ (176 cm)' }), ({ 'value': '178','label': '5′10″ (178 cm)' }), ({ 'value': '180','label': '5′11″ (180 cm)' }), ({ 'value': '183','label': '6′0″ (183 cm)' }), ({ 'value': '185','label': '6′1″ (185 cm)' }), ({ 'value': '188','label': '6′2″ (188 cm)' }), ({ 'value': '191','label': '6′3″ (191 cm)' }), ({ 'value': '193','label': '6′4″ (193 cm)' }), ({ 'value': '195','label': '6′5″ (195 cm)' }), ({ 'value': '198','label': '6′6″ (198 cm)' }), ({ 'value': '201','label': '6′7″ (201 cm)' }), ({ 'value': '203','label': '6′8″ (203 cm)' }), ({ 'value': '206','label': '6′9″ (206 cm)' }), ({ 'value': '208','label': '6′10″ (208 cm)' }), ({ 'value': '211','label': '6′11″ (211 cm)' }), ({ 'value': '213','label': '7′0″ (213 cm)' })];

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/groups/components/79c7b04f811ff50e569589a7c5e5b41d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('messages', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/581569c8be77571fd6b986528ca7db28/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async onOptionsAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'category')) {
    return ([({ 'value': 'All categories','label': 'All categories' })].concat((await Promise.all((getObjectProperty(___arguments.context.pageData, 'category')).map(async item => {; return ({ 'value': (getObjectProperty(item, 'objectId')),'label': (getObjectProperty(item, 'name')) });})))));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async onChange(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  ___arguments.context.pageData['categoryChecked'] = ___arguments.value;
  ___arguments.context.pageData['groups'] = (await BackendlessUI.Functions.Custom['fn_498e158c8709b3f96ffb2d42938f05b8'](___arguments.context.pageData));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/groups/components/d6fff1c825416361de7ca998062e2022/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'groupSizeMin')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'groupSizeMax'))) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/groups/components/76aa53eadedf8a9103cd198dd3899812/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'groups')) && (getObjectProperty(___arguments.context.pageData, 'groups')).length == 0) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/groups/components/84561d5c60947b28591e3898d3bfc142/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  ___arguments.context.pageData['groupSize'] = ___arguments.value;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['groupSizeMin'] = (___arguments.value[0]);
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['groupSizeMax'] = (___arguments.value.slice(-1)[0]);
  await new Promise(r => setTimeout(r, 2000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/groups/components/6833a3bea8b5d9b3eb3ce734405fdbe2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'rangeStatus')) == true) {
    console.log('111111111');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6833a3bea8b5d9b3eb3ce734405fdbe2'))['pointer-events'] = 'none';
    ___arguments.context.pageData['rangeStatus'] = false;
    ___arguments.context.pageData['groups'] = (await BackendlessUI.Functions.Custom['fn_498e158c8709b3f96ffb2d42938f05b8'](___arguments.context.pageData));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
    await new Promise(r => setTimeout(r, 200 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6833a3bea8b5d9b3eb3ce734405fdbe2'))['pointer-events'] = 'auto';
  }

  },
  /* handler:onClick */
  /* handler:onMounted */
  async onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['rangeStatus'] = false;
  await new Promise(r => setTimeout(r, 2000 || 0));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('84561d5c60947b28591e3898d3bfc142')) {
    await (async function(range, data) {
    	range.addEventListener('mouseup', function() {
    	  data.rangeStatus = true
    	});
    })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('84561d5c60947b28591e3898d3bfc142')), 'el')), ___arguments.context.pageData);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/groups/components/267e1ba97cdbe08a07dbd4c74164c7fd/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
    
  },
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/groups/components/3644e7181decfd1b4a0ba3563c8ba44c/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  ['onMouseOver'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] != 'open') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')), 'open');
  }

  },
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] == 'open') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).pop();
  }

  },  
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/groups/components/90c19d93eb614726a341c1fb5e768591/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-profile', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/9eae8aaea9c2c53768ab2ae436711e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-activities', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/8cadea982ab7c138c629aadb391c73c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('settings', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/607680653092fc2b09867b42d84b520d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bfb8c73aa8c2f3dc6e37c7f9116ae2d5')), 'open');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/b0bbd32a4126b78c78f81cd825ea8978/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var message;


  message = true;
  if (!(___arguments.context.pageData['messagesNumber']) || (___arguments.context.pageData['messagesNumber']) == 0) {
    message = false;
  }

  return message

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    var num;


  num = 0;
  if (___arguments.context.pageData['messagesNumber']) {
    num = (___arguments.context.pageData['messagesNumber']);
  }

  return num

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/groups/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('f64e76d36d2d2cee6b2698b7d2c568db')).slice(-1)[0] == 'open') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('f64e76d36d2d2cee6b2698b7d2c568db')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('messages', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/734613cf02b83e317b8d023b100fc7d4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('734613cf02b83e317b8d023b100fc7d4'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('52935a85c38bf4d237a9a84af764629c')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('52935a85c38bf4d237a9a84af764629c')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    await Backendless.Data.of('UserSearchFilter').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'objectId')),'\''].join('')), ({ 'height': null,'heightPrefix': null }) );
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['height'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['heightPrefix'] = null;
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['height'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['heightPrefix'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix'));
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('52935a85c38bf4d237a9a84af764629c')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('52935a85c38bf4d237a9a84af764629c')).pop();
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['heightPrefix'] = 'minHeight';
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['heightPrefix'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix'));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['height'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'heightList'))[0]), 'value')) * 1);
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['height'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height'));
  }
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/groups/components/52935a85c38bf4d237a9a84af764629c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('734613cf02b83e317b8d023b100fc7d4'))['checked']) {
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('734613cf02b83e317b8d023b100fc7d4'))['checked'] = false;
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('734613cf02b83e317b8d023b100fc7d4'))['checked']) {
    return ['filters__container', 'no-prefs-content'];
  }

  return ['filters__container']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/groups/components/64e3891b9e772e946bbfe01539084b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      await BackendlessUI.Functions.Custom['fn_e97140c64a3efafdbfb71077439f3811']();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/7cebd5c389dbd4cf41cb01f96bbc30a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bfb8c73aa8c2f3dc6e37c7f9116ae2d5')).pop();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/d232eb43cfcf9e8a9b3d902f80194225/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bfb8c73aa8c2f3dc6e37c7f9116ae2d5')).pop();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/0848202de2a79f0a4f21996418381491/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
    var activityList, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683')['activity']) && !!(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683')['activity']).length) {
    activityList = (await asyncListFilter((___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683')['activity']), async (item) => {


     return ((item['ongoingTiming']) || (item['activityDate']) >= (new Date()));
    }));
    ___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683')['activity'] = (activityList.slice(0, 2));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/groups/components/c179f417cba33d4d12aabfabeedca814/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/groups/components/e10c498e064201675563d6995c1a3a91/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await (async function(data) {
  	let timerId = null;
  	let searchbox = document.querySelector('.search')

  	searchbox.onkeypress = function() {

  	    clearTimeout(timerId);

  	    timerId = setTimeout(function() {

  	        data.search = true

  	    }, 500);

  	}


  })(___arguments.context.pageData);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/groups/components/c6daef152d19a21a43f98efd2819822d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (!(getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.appData, 'login'))) {
      return (getObjectProperty(___arguments.context.appData, 'login'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
    } else {
      return 'Account';
    }
  } else {
    return 'Account';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/groups/components/013aa38b49553b5f16f436b591fb8eed/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.pageData['genderList'] = [({ 'label': 'Female' }), ({ 'label': 'Male' }), ({ 'label': 'Non-Binary' })];

  },
  /* handler:onMounted */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
      return (___arguments.context.pageData['genderList'])

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/groups/components/e46cd834546236a8bebd060f71073427/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')), (getObjectProperty(___arguments.context.dataModel, 'label')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'label')));
    }));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['gender'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender'));
  await Backendless.Data.of('UserSearchFilter').bulkUpdate( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ 'gender': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')) }) );
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async onCheckedStateAssignment(___arguments) {
    var item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender']) {
    return (!!(await asyncListFilter((___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender']), async (item) => {


     return (item == (___arguments.context.dataModel['label']));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/groups/components/789b4b059b4bd9f1bcf7070d355a2f97/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return false;
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/groups/components/99cda62fde6464e6ca3f0196086c6645/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-group', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/2b6768210b62ae01bc1442066d8ed9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['locationList'] = [({ 'label': 'Radius not selected','value': '16093000' }), ({ 'label': '10 mi','value': '10' }), ({ 'label': '25 mi','value': '25' }), ({ 'label': '50 mi','value': '50' }), ({ 'label': '75 mi','value': '75' }), ({ 'label': '100 mi','value': '100' })];

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/groups/components/e6ef7d041ac13c14d411af83c3f8bd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/groups/components/a66c684ca30d5be547528081425bc833/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/interests/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/interests/components/69b9a7435b6e5a774f967f27f307dc8b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var error, userCover, item, userResponce, updatedUser, user, likedActivities, object, userJson, getLikedBy, likedBy, likedByList, getMyLikes, query, myLikesList, seenBy, getSeenByNew, userSeenBy, seenByList, currentUser, profile;

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  getRTSubscriptions().remove('online');
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  getRTSubscriptions().remove('push');
  ___arguments.context.appData['isOpenFullList'] = (getObjectProperty(___arguments.context.pageData, 'isOpenFullList'));
  ___arguments.context.appData['previousPage'] = 'interests';
  ___arguments.context.appData['backBtnIsClicked'] = false;

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/interests/components/cdf69fa7959d8fa7215cf1e5f96de91b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var getLikedBy, item, likedBy, likedByList, object, updatedUser, user, userJson, userResponce;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  getRTSubscriptions().remove('online');
  getRTSubscriptions().remove('seenByLikesCount');
  getRTSubscriptions().remove('likedByLikesCount');
  getRTSubscriptions().remove('myLikesLikesCount');
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['tab'] = 'likedBy';
  delete ___arguments.context.appData['backBtnIsClicked'];
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('685988157bf97ad2cfa180cc95143de7')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('685988157bf97ad2cfa180cc95143de7', false);
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).slice(-1)[0] != 'interests__navItem--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')), 'interests__navItem--active');
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).pop();
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9e93ec1e55a2b318113ec9241310ace', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c86149a10f5c36f0b3551114936b00f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd78f6c6fe95082e9034ed6fdccf40d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', true);
  if (!(getObjectProperty(___arguments.context.pageData, 'likedBy'))) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy')).length > 0) {
      likedByList = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')));
      }));
      ___arguments.context.pageData['likedByList'] = (likedByList.map(item => item['objectId']));
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy')).length > 21) {
        likedBy = (getObjectProperty(___arguments.context.pageData, 'likedByList')).slice(0, 21);
        ___arguments.context.pageData['likedByList'] = (subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'likedByList')), 21));
      } else {
        likedBy = (getObjectProperty(___arguments.context.pageData, 'likedByList'));
        ___arguments.context.pageData['likedByList'] = [];
      }
      getLikedBy = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfilesForLikes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'profilesIdText': JSON.stringify((likedBy.join('\',\''))),'blockedIdArray': JSON.stringify((JSON.stringify(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) : [])))) }).send());
      getLikedBy = (await asyncListFilter(getLikedBy, async (item) => {


       return ((getObjectProperty(item, 'userProfileObjectId')) && (getObjectProperty(item, 'photo')) && !!(getObjectProperty(item, 'photo')).length);
      }));
      if (getLikedBy) {
        for (var userResponce_index in getLikedBy) {
          userResponce = getLikedBy[userResponce_index];
          var userJson_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy'));
          for (var userJson_index in userJson_list) {
            userJson = userJson_list[userJson_index];
            if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
              userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
            }
          }
        }
        ___arguments.context.pageData['likedBy'] = (await asyncListSort(getLikedBy, -1, async (item) => {


         return (getObjectProperty(item, 'ts'));
        }));
      }

      ;(function(whereClause) {
        const callback = async object => {
            ((getObjectProperty(___arguments.context.pageData, 'likedBy'))[((((getObjectProperty(___arguments.context.pageData, 'likedBy')).map(item => item['objectId'])).indexOf(getObjectProperty(object, 'ownerId')) + 1) - 1)])['likesCount'] = (getObjectProperty(object, 'likesCount'));

        };

        const rtHandlers = Backendless.Data.of('UserProfile').rt();

        const options = [callback];

        if (whereClause) {
           options.unshift(whereClause);
        }

        rtHandlers.addUpdateListener.apply(rtHandlers, options);

        getRTSubscriptions().add('likedByLikesCount', () => rtHandlers.removeUpdateListener(callback));

      })((['ownerId in (\'',((getObjectProperty(___arguments.context.pageData, 'likedBy')).map(item => item['objectId'])).join('\',\''),'\')'].join('')));
        }
    if (!(getObjectProperty(___arguments.context.pageData, 'likedBy'))) {
      ___arguments.context.pageData['likedBy'] = [];
    }
    if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'likedBy'))) {
      (getObjectProperty(___arguments.context.pageData, 'user'))['likedBy'] = [];
    }
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('658e6f5415123338541af193aea4c29e')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/interests/components/c084fa8cbe39b5365f39a1ccd1b1cc28/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var object, updatedUser, user, item, userJson, userResponce, getSeenByNew, userSeenBy, seenByList;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  getRTSubscriptions().remove('online');
  getRTSubscriptions().remove('seenByLikesCount');
  getRTSubscriptions().remove('likedByLikesCount');
  getRTSubscriptions().remove('myLikesLikesCount');
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['tab'] = 'seenBy';
  delete ___arguments.context.appData['backBtnIsClicked'];
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).slice(-1)[0] != 'interests__navItem--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')), 'interests__navItem--active');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('685988157bf97ad2cfa180cc95143de7', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9e93ec1e55a2b318113ec9241310ace', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c86149a10f5c36f0b3551114936b00f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd78f6c6fe95082e9034ed6fdccf40d', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', true);
  if (!(getObjectProperty(___arguments.context.pageData, 'seenByNew'))) {
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy'))) {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile'))['seenBy'] = [];
    }
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy')).length > 0) {
      seenByList = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')));
      }));
      ___arguments.context.pageData['seenByList'] = (seenByList.map(item => item['objectId']));
      if ((getObjectProperty(___arguments.context.pageData, 'seenByList')).length > 21) {
        userSeenBy = (getObjectProperty(___arguments.context.pageData, 'seenByList')).slice(0, 21);
        ___arguments.context.pageData['seenByList'] = (subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'seenByList')), 20));
      } else {
        userSeenBy = (getObjectProperty(___arguments.context.pageData, 'seenByList'));
        ___arguments.context.pageData['seenByList'] = [];
      }
      getSeenByNew = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfilesForLikes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'profilesIdText': JSON.stringify((userSeenBy.join('\',\''))),'blockedIdArray': JSON.stringify((JSON.stringify(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) : [])))) }).send());
      ___arguments.context.pageData['seenByNew'] = (await asyncListFilter(getSeenByNew, async (item) => {


       return ((getObjectProperty(item, 'userProfileObjectId')) && (getObjectProperty(item, 'photo')) && !!(getObjectProperty(item, 'photo')).length);
      }));
      ___arguments.context.pageData['tab'] = 'seenBy';
      await new Promise(r => setTimeout(r, 200 || 0));
      if ((getObjectProperty(___arguments.context.pageData, 'seenByNew')) && !!(getObjectProperty(___arguments.context.pageData, 'seenByNew')).length) {

        ;(function(whereClause) {
          const callback = async object => {
              ((getObjectProperty(___arguments.context.pageData, 'seenByNew'))[((((getObjectProperty(___arguments.context.pageData, 'seenByNew')).map(item => item['objectId'])).indexOf(getObjectProperty(object, 'ownerId')) + 1) - 1)])['likesCount'] = (getObjectProperty(object, 'likesCount'));

          };

          const rtHandlers = Backendless.Data.of('UserProfile').rt();

          const options = [callback];

          if (whereClause) {
             options.unshift(whereClause);
          }

          rtHandlers.addUpdateListener.apply(rtHandlers, options);

          getRTSubscriptions().add('seenByLikesCount', () => rtHandlers.removeUpdateListener(callback));

        })((['ownerId in (\'',((getObjectProperty(___arguments.context.pageData, 'seenByNew')).map(item => item['objectId'])).join('\',\''),'\')'].join('')));
          if (getObjectProperty(___arguments.context.pageData, 'seenByNew')) {
          var userResponce_list = (getObjectProperty(___arguments.context.pageData, 'seenByNew'));
          for (var userResponce_index in userResponce_list) {
            userResponce = userResponce_list[userResponce_index];
            var userJson_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy'));
            for (var userJson_index in userJson_list) {
              userJson = userJson_list[userJson_index];
              if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
              }
            }
          }
          ___arguments.context.pageData['seenBy'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'seenByNew')), -1, async (item) => {


           return (getObjectProperty(item, 'ts'));
          }));
        }
      }
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'seenBy')) && !!(getObjectProperty(___arguments.context.pageData, 'seenBy')).length) {
      if ((getObjectProperty(___arguments.context.pageData, 'seenBy')) && !!(getObjectProperty(___arguments.context.pageData, 'seenBy')).length) {

        ;(function(whereClause) {
          const callback = async object => {
              ((getObjectProperty(___arguments.context.pageData, 'seenBy'))[((((getObjectProperty(___arguments.context.pageData, 'seenBy')).map(item => item['objectId'])).indexOf(getObjectProperty(object, 'ownerId')) + 1) - 1)])['likesCount'] = (getObjectProperty(object, 'likesCount'));

          };

          const rtHandlers = Backendless.Data.of('UserProfile').rt();

          const options = [callback];

          if (whereClause) {
             options.unshift(whereClause);
          }

          rtHandlers.addUpdateListener.apply(rtHandlers, options);

          getRTSubscriptions().add('seenByLikesCount', () => rtHandlers.removeUpdateListener(callback));

        })((['ownerId in (\'',((getObjectProperty(___arguments.context.pageData, 'seenBy')).map(item => item['objectId'])).join('\',\''),'\')'].join('')));
          }
    }
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('658e6f5415123338541af193aea4c29e')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('658e6f5415123338541af193aea4c29e')), 'display'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', false);
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8537fc2a0ad189bdca3ed115e8b7189e')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8537fc2a0ad189bdca3ed115e8b7189e')), 'display'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8537fc2a0ad189bdca3ed115e8b7189e', false);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/interests/components/55ce460eee62bfc349723142ed426591/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedUser, user, likedActivities, object, item, userJson, userResponce, getMyLikes, myLikes, myLikesList, query;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function getMyLikes2() {
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes')).length > 0) {
    myLikesList = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')));
    }));
    query = (myLikesList.map(item => item['objectId']));
    getMyLikes = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfilesForLikes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'profilesIdText': JSON.stringify((query.join('\',\''))),'blockedIdArray': JSON.stringify((JSON.stringify(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) : [])))) }).send());
    ___arguments.context.pageData['myLikes'] = (await asyncListFilter(getMyLikes, async (item) => {


     return ((getObjectProperty(item, 'userProfileObjectId')) && (getObjectProperty(item, 'photo')) && !!(getObjectProperty(item, 'photo')).length);
    }));
    if (getObjectProperty(___arguments.context.pageData, 'myLikes')) {
      var userResponce_list = (getObjectProperty(___arguments.context.pageData, 'myLikes'));
      for (var userResponce_index in userResponce_list) {
        userResponce = userResponce_list[userResponce_index];
        var userJson_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes'));
        for (var userJson_index in userJson_list) {
          userJson = userJson_list[userJson_index];
          if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
            userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
          }
        }
      }
      ___arguments.context.pageData['myLikes'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'myLikes')), -1, async (item) => {


       return (getObjectProperty(item, 'ts'));
      }));
    }

    ;(function(whereClause) {
      const callback = async object => {
          ((getObjectProperty(___arguments.context.pageData, 'myLikes'))[((((getObjectProperty(___arguments.context.pageData, 'myLikes')).map(item => item['objectId'])).indexOf(getObjectProperty(object, 'ownerId')) + 1) - 1)])['likesCount'] = (getObjectProperty(object, 'likesCount'));

      };

      const rtHandlers = Backendless.Data.of('UserProfile').rt();

      const options = [callback];

      if (whereClause) {
         options.unshift(whereClause);
      }

      rtHandlers.addUpdateListener.apply(rtHandlers, options);

      getRTSubscriptions().add('myLikesLikesCount', () => rtHandlers.removeUpdateListener(callback));

    })((['ownerId in (\'',((getObjectProperty(___arguments.context.pageData, 'myLikes')).map(item => item['objectId'])).join('\',\''),'\')'].join('')));
      if (!(getObjectProperty(___arguments.context.pageData, 'myLikes'))) {
      ___arguments.context.pageData['myLikes'] = [];
      if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'myLikes'))) {
        (getObjectProperty(___arguments.context.pageData, 'user'))['myLikes'] = [];
      }
    }
  }
}


  getRTSubscriptions().remove('online');
  getRTSubscriptions().remove('seenByLikesCount');
  getRTSubscriptions().remove('likedByLikesCount');
  getRTSubscriptions().remove('myLikesLikesCount');
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['tab'] = 'favoriteProfiles';
  delete ___arguments.context.appData['backBtnIsClicked'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c86149a10f5c36f0b3551114936b00f', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('685988157bf97ad2cfa180cc95143de7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9e93ec1e55a2b318113ec9241310ace', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', true);
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).slice(-1)[0] != 'interests__navItem--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')), 'interests__navItem--active');
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'isMyLikesLoaded'))) {
    await getMyLikes2();
    ___arguments.context.pageData['isMyLikesLoaded'] = true;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd78f6c6fe95082e9034ed6fdccf40d', true);
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedActivities')) {
      likedActivities = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedActivities')).map(item => item['objectId']));
      if (!(getObjectProperty(___arguments.context.pageData, 'likesActivities'))) {
        ___arguments.context.pageData['likesActivities'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivity/getActivitiesForLikes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'objectIdTextList': JSON.stringify((likedActivities.join('\',\''))),'pageSize': 100,'pageOffset': 0,'blockedIdArray': JSON.stringify((JSON.stringify(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) : [])))) }).send());
        if (!(getObjectProperty(___arguments.context.pageData, 'likesActivities'))) {
          ___arguments.context.pageData['likesActivities'] = [];
        }
        if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'likesActivities'))) {
          (getObjectProperty(___arguments.context.pageData, 'user'))['likesActivities'] = [];
        }
      }
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd78f6c6fe95082e9034ed6fdccf40d', false);
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('658e6f5415123338541af193aea4c29e')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', false);
  }

  },
  /* handler:onClick */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return (['Profiles I ❤️','',''].join(''));
  } else {
    return 'Who I ❤️';
  }

  return 'Who I ❤️'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/62a96fd41ef8650a24f9f999b8123892/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedUser, user, likedActivities;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  getRTSubscriptions().remove('online');
  getRTSubscriptions().remove('seenByLikesCount');
  getRTSubscriptions().remove('likedByLikesCount');
  getRTSubscriptions().remove('myLikesLikesCount');
  delete ___arguments.context.appData['backBtnIsClicked'];
  await new Promise(r => setTimeout(r, 250 || 0));
  ___arguments.context.pageData['tab'] = 'favoriteActivities';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).slice(-1)[0] == 'interests__navItem--active') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).pop();
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).slice(-1)[0] != 'interests__navItem--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')), 'interests__navItem--active');
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('685988157bf97ad2cfa180cc95143de7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9e93ec1e55a2b318113ec9241310ace', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c86149a10f5c36f0b3551114936b00f', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd78f6c6fe95082e9034ed6fdccf40d', true);
  if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedActivities')) {
    likedActivities = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedActivities')).map(item => item['objectId']));
    if (!(getObjectProperty(___arguments.context.pageData, 'likesActivities'))) {
      ___arguments.context.pageData['likesActivities'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivity/getActivitiesForLikes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'objectIdTextList': JSON.stringify((likedActivities.join('\',\''))),'pageSize': 100,'pageOffset': 0,'blockedIdArray': JSON.stringify((JSON.stringify(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) : [])))) }).send());
      if (!(getObjectProperty(___arguments.context.pageData, 'likesActivities'))) {
        ___arguments.context.pageData['likesActivities'] = [];
      }
      if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'likesActivities'))) {
        (getObjectProperty(___arguments.context.pageData, 'user'))['likesActivities'] = [];
      }
    }
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('658e6f5415123338541af193aea4c29e')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return false;
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Activities I ❤️'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/61afe072db5624d1b24c1ae998d9c39d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/interests/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (___arguments.screenWidth > 768) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62a96fd41ef8650a24f9f999b8123892', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62a96fd41ef8650a24f9f999b8123892', false);
  }

  },
  /* handler:onResize */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'messagesNumber')) > 0) {
    return (['(',(getObjectProperty(___arguments.context.appData, 'messagesNumber')),') Likes'].join(''));
  }

  return 'Likes'

  },
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var error, userCover, item, userResponce, updatedUser, user, likedActivities, object, userJson, getLikedBy, likedBy, likedByList, getMyLikes, query, myLikesList, currentUser, profile, seenBy, getSeenByNew, userSeenBy, seenByList;

  },
  /* handler:onEnter */
  /* handler:onScroll */
  async ['onScroll'](___arguments) {
    var error, item, likedByMore, myLikesMore, object, seenByMore, userJson, userResponce, userSeenBy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (___arguments.scrollTop >= 200) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24bf5bfe04cf3b2682972329f4c20ee', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d24bf5bfe04cf3b2682972329f4c20ee', false);
  }
  if (___arguments.scrollBottom <= 20 && !(getObjectProperty(___arguments.context.pageData, 'noMoreSeenBy')) && !(getObjectProperty(___arguments.context.pageData, 'loadMore')) && (getObjectProperty(___arguments.context.pageData, 'tab')) == 'seenBy') {
    ___arguments.context.pageData['loadMore'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'tab')) == 'seenBy') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', true);
      if ((getObjectProperty(___arguments.context.pageData, 'seenByList')).length > 0) {
        if ((getObjectProperty(___arguments.context.pageData, 'seenByList')).length > 21) {
          userSeenBy = (getObjectProperty(___arguments.context.pageData, 'seenByList')).slice(0, 21);
          ___arguments.context.pageData['seenByList'] = (subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'seenByList')), 20));
        } else if ((getObjectProperty(___arguments.context.pageData, 'seenByList')).length <= 21) {
          userSeenBy = (getObjectProperty(___arguments.context.pageData, 'seenByList'));
          ___arguments.context.pageData['seenByList'] = [];
          ___arguments.context.pageData['noMoreSeenBy'] = true;
        } else {
          userSeenBy = (getObjectProperty(___arguments.context.pageData, 'seenByList'));
        }
        seenByMore = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((userSeenBy.join('\',\''))) }).send());
        ___arguments.context.pageData['seenByMore'] = (await asyncListFilter(seenByMore, async (item) => {


         return ((getObjectProperty(item, 'userProfileObjectId')) && (getObjectProperty(item, 'photo')) && !!(getObjectProperty(item, 'photo')).length);
        }));
        ___arguments.context.pageData['seenBy'] = ((getObjectProperty(___arguments.context.pageData, 'seenBy')).concat((getObjectProperty(___arguments.context.pageData, 'seenByMore'))));
        getRTSubscriptions().remove('seenByLikesCount');
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('07f5173df8143396cf131e9a25357f8d', (getObjectProperty(___arguments.context.pageData, 'seenBy')));
        await new Promise(r => setTimeout(r, 1000 || 0));
        try {

          ;(function(whereClause) {
            const callback = async object => {
                ((getObjectProperty(___arguments.context.pageData, 'seenBy'))[((((getObjectProperty(___arguments.context.pageData, 'seenBy')).map(item => item['ownerId'])).indexOf(getObjectProperty(object, 'ownerId')) + 1) - 1)])['likesCount'] = (getObjectProperty(object, 'likesCount'));

            };

            const rtHandlers = Backendless.Data.of('UserProfile').rt();

            const options = [callback];

            if (whereClause) {
               options.unshift(whereClause);
            }

            rtHandlers.addUpdateListener.apply(rtHandlers, options);

            getRTSubscriptions().add('seenByLikesCount', () => rtHandlers.removeUpdateListener(callback));

          })((['ownerId in (\'',((getObjectProperty(___arguments.context.pageData, 'seenBy')).map(item => item['ownerId'])).join('\',\''),'\')'].join('')));

        } catch (error) {
          console.log(error);

        }
        if (getObjectProperty(___arguments.context.pageData, 'seenBy')) {
          var userResponce_list = (getObjectProperty(___arguments.context.pageData, 'seenBy'));
          for (var userResponce_index in userResponce_list) {
            userResponce = userResponce_list[userResponce_index];
            var userJson_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy'));
            for (var userJson_index in userJson_list) {
              userJson = userJson_list[userJson_index];
              if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
              }
            }
          }
          ___arguments.context.pageData['seenBy'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'seenBy')), -1, async (item) => {


           return (getObjectProperty(item, 'ts'));
          }));
        }
        delete ___arguments.context.pageData['loadMore'];
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', false);
  }
  if (___arguments.scrollBottom <= 20 && !(getObjectProperty(___arguments.context.pageData, 'noMoreLikedBy')) && !(getObjectProperty(___arguments.context.pageData, 'loadMoreLikedBy')) && (getObjectProperty(___arguments.context.pageData, 'tab')) == 'likedBy') {
    ___arguments.context.pageData['loadMoreLikedBy'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'tab')) == 'likedBy') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', true);
      if ((getObjectProperty(___arguments.context.pageData, 'likedByList')) && (getObjectProperty(___arguments.context.pageData, 'likedByList')).length > 0) {
        if ((getObjectProperty(___arguments.context.pageData, 'likedByList')).length > 21) {
          userSeenBy = (getObjectProperty(___arguments.context.pageData, 'likedByList')).slice(0, 21);
          ___arguments.context.pageData['likedByList'] = (subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'likedByList')), 20));
        } else if ((getObjectProperty(___arguments.context.pageData, 'likedByList')).length <= 21) {
          userSeenBy = (getObjectProperty(___arguments.context.pageData, 'likedByList'));
          ___arguments.context.pageData['likedByList'] = [];
          ___arguments.context.pageData['noMoreLikedBy'] = true;
        } else {
          userSeenBy = (getObjectProperty(___arguments.context.pageData, 'likedByList'));
        }
        likedByMore = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((userSeenBy.join('\',\''))) }).send());
        ___arguments.context.pageData['likedByMore'] = (await asyncListFilter(likedByMore, async (item) => {


         return ((getObjectProperty(item, 'userProfileObjectId')) && (getObjectProperty(item, 'photo')) && !!(getObjectProperty(item, 'photo')).length);
        }));
        ___arguments.context.pageData['likedBy'] = ((getObjectProperty(___arguments.context.pageData, 'likedBy')).concat((getObjectProperty(___arguments.context.pageData, 'likedByMore'))));
        getRTSubscriptions().remove('likedByLikesCount');
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('27c817237934a69b9a09d224f265dcc3', (getObjectProperty(___arguments.context.pageData, 'likedBy')));
        await new Promise(r => setTimeout(r, 1000 || 0));
        try {

          ;(function(whereClause) {
            const callback = async object => {
                ((getObjectProperty(___arguments.context.pageData, 'likedBy'))[((((getObjectProperty(___arguments.context.pageData, 'likedBy')).map(item => item['ownerId'])).indexOf(getObjectProperty(object, 'ownerId')) + 1) - 1)])['likesCount'] = (getObjectProperty(object, 'likesCount'));

            };

            const rtHandlers = Backendless.Data.of('UserProfile').rt();

            const options = [callback];

            if (whereClause) {
               options.unshift(whereClause);
            }

            rtHandlers.addUpdateListener.apply(rtHandlers, options);

            getRTSubscriptions().add('likedByLikesCount', () => rtHandlers.removeUpdateListener(callback));

          })((['ownerId in (\'',((getObjectProperty(___arguments.context.pageData, 'likedBy')).map(item => item['ownerId'])).join('\',\''),'\')'].join('')));

        } catch (error) {
          console.log(error);

        }
        if (getObjectProperty(___arguments.context.pageData, 'likedBy')) {
          var userResponce_list2 = (getObjectProperty(___arguments.context.pageData, 'likedBy'));
          for (var userResponce_index2 in userResponce_list2) {
            userResponce = userResponce_list2[userResponce_index2];
            var userJson_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy'));
            for (var userJson_index2 in userJson_list2) {
              userJson = userJson_list2[userJson_index2];
              if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
              }
            }
          }
          ___arguments.context.pageData['likedBy'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'likedBy')), -1, async (item) => {


           return (getObjectProperty(item, 'ts'));
          }));
        }
      }
      delete ___arguments.context.pageData['loadMoreLikedBy'];
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', false);
  }
  if (___arguments.scrollBottom <= 20 && !(getObjectProperty(___arguments.context.pageData, 'noMoreFavotiteProfiles')) && !(getObjectProperty(___arguments.context.pageData, 'loadMoreFavotiteProfiles')) && (getObjectProperty(___arguments.context.pageData, 'tab')) == 'favotiteProfiles') {
    ___arguments.context.pageData['loadMoreFavotiteProfiles'] = true;
    if ((getObjectProperty(___arguments.context.pageData, 'tab')) == 'favotiteProfiles') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', true);
      if ((getObjectProperty(___arguments.context.pageData, 'myLikesList')).length > 0) {
        if ((getObjectProperty(___arguments.context.pageData, 'myLikesList')).length > 21) {
          userSeenBy = (getObjectProperty(___arguments.context.pageData, 'myLikesList')).slice(0, 21);
          ___arguments.context.pageData['myLikesList'] = (subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'myLikesList')), 20));
        } else if ((getObjectProperty(___arguments.context.pageData, 'myLikesList')).length <= 21) {
          userSeenBy = (getObjectProperty(___arguments.context.pageData, 'myLikesList'));
          ___arguments.context.pageData['myLikesList'] = [];
          ___arguments.context.pageData['noMoreFavoriteProfiles'] = true;
        } else {
          userSeenBy = (getObjectProperty(___arguments.context.pageData, 'myLikesList'));
        }
        myLikesMore = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfiles`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'condition': JSON.stringify((userSeenBy.join('\',\''))) }).send());
        ___arguments.context.pageData['myLikesMore'] = (await asyncListFilter(myLikesMore, async (item) => {


         return ((getObjectProperty(item, 'userProfileObjectId')) && (getObjectProperty(item, 'photo')) && !!(getObjectProperty(item, 'photo')).length);
        }));
        ___arguments.context.pageData['myLikes'] = ((getObjectProperty(___arguments.context.pageData, 'myLikes')).concat((getObjectProperty(___arguments.context.pageData, 'myLikesMore'))));
        getRTSubscriptions().remove('myLikesLikesCount');
        (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d938b472772a86cfc86eef893c8bfa5', (getObjectProperty(___arguments.context.pageData, 'myLikes')));
        await new Promise(r => setTimeout(r, 1000 || 0));
        try {

          ;(function(whereClause) {
            const callback = async object => {
                ((getObjectProperty(___arguments.context.pageData, 'myLikes'))[((((getObjectProperty(___arguments.context.pageData, 'myLikes')).map(item => item['ownerId'])).indexOf(getObjectProperty(object, 'ownerId')) + 1) - 1)])['likesCount'] = (getObjectProperty(object, 'likesCount'));

            };

            const rtHandlers = Backendless.Data.of('UserProfile').rt();

            const options = [callback];

            if (whereClause) {
               options.unshift(whereClause);
            }

            rtHandlers.addUpdateListener.apply(rtHandlers, options);

            getRTSubscriptions().add('myLikesLikesCount', () => rtHandlers.removeUpdateListener(callback));

          })((['ownerId in (\'',((getObjectProperty(___arguments.context.pageData, 'myLikes')).map(item => item['ownerId'])).join('\',\''),'\')'].join('')));

        } catch (error) {
          console.log(error);

        }
        if (getObjectProperty(___arguments.context.pageData, 'likedBy')) {
          var userResponce_list3 = (getObjectProperty(___arguments.context.pageData, 'myLikes'));
          for (var userResponce_index3 in userResponce_list3) {
            userResponce = userResponce_list3[userResponce_index3];
            var userJson_list3 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes'));
            for (var userJson_index3 in userJson_list3) {
              userJson = userJson_list3[userJson_index3];
              if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
              }
            }
          }
          ___arguments.context.pageData['myLikes'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'myLikes')), -1, async (item) => {


           return (getObjectProperty(item, 'ts'));
          }));
        }
        delete ___arguments.context.pageData['loadMoreFavoriteProfiles'];
      }
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', false);
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('658e6f5415123338541af193aea4c29e')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', false);
  }

  },
  /* handler:onScroll */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  getRTSubscriptions().remove('online');
  getRTSubscriptions().remove('seenByLikesCount');
  getRTSubscriptions().remove('likedByLikesCount');
  getRTSubscriptions().remove('myLikesLikesCount');
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
    if (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus')) {
      ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'user'));
      if (getObjectProperty(___arguments.context.pageData, 'user')) {
        localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'user'))));
      }
      ___arguments.context.appData['isOpenFullList'] = (getObjectProperty(___arguments.context.pageData, 'isOpenFullList'));
    }
  }
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var error, userCover, item, userResponce, updatedUser, user, likedActivities, object, userJson, getLikedBy, likedBy, likedByList, getMyLikes, query, myLikesList, currentUser, profile, seenBy, getSeenByNew, userSeenBy, seenByList;

/**
 * Describe this function...
 */
async function getHeight() {
  ___arguments.context.pageData['height'] = [({ [`value`]: '122',[`label`]: '4′0″ (122 cm)' }), ({ [`value`]: '124',[`label`]: '4′1″ (124 cm)' }), ({ [`value`]: '127',[`label`]: '4′2″ (127 cm)' }), ({ [`value`]: '130',[`label`]: '4′3″ (130 cm)' }), ({ [`value`]: '132',[`label`]: '4′4″ (132 cm)' }), ({ [`value`]: '135',[`label`]: '4′5″ (135 cm)' }), ({ [`value`]: '137',[`label`]: '4′6″ (137 cm)' }), ({ [`value`]: '140',[`label`]: '4′7″ (140 cm)' }), ({ [`value`]: '142',[`label`]: '4′8″ (142 cm)' }), ({ [`value`]: '145',[`label`]: '4′9″ (145 cm)' }), ({ [`value`]: '152',[`label`]: '5′0″ (152 cm)' }), ({ [`value`]: '155',[`label`]: '5′1″ (155 cm)' }), ({ [`value`]: '157',[`label`]: '5′2″ (157 cm)' }), ({ [`value`]: '160',[`label`]: '5′3″ (160 cm)' }), ({ [`value`]: '163',[`label`]: '5′4″ (163 cm)' }), ({ [`value`]: '165',[`label`]: '5′5″ (165 cm)' }), ({ [`value`]: '168',[`label`]: '5′6″ (168 cm)' }), ({ [`value`]: '170',[`label`]: '5′7″ (170 cm)' }), ({ [`value`]: '173',[`label`]: '5′8″ (173 cm)' }), ({ [`value`]: '176',[`label`]: '5′9″ (176 cm)' }), ({ [`value`]: '178',[`label`]: '5′10″ (178 cm)' }), ({ [`value`]: '180',[`label`]: '5′11″ (180 cm)' }), ({ [`value`]: '183',[`label`]: '6′0″ (183 cm)' }), ({ [`value`]: '185',[`label`]: '6′1″ (185 cm)' }), ({ [`value`]: '188',[`label`]: '6′2″ (188 cm)' }), ({ [`value`]: '191',[`label`]: '6′3″ (191 cm)' }), ({ [`value`]: '193',[`label`]: '6′4″ (193 cm)' }), ({ [`value`]: '195',[`label`]: '6′5″ (195 cm)' }), ({ [`value`]: '198',[`label`]: '6′6″ (198 cm)' }), ({ [`value`]: '201',[`label`]: '6′7″ (201 cm)' }), ({ [`value`]: '203',[`label`]: '6′8″ (203 cm)' }), ({ [`value`]: '206',[`label`]: '6′9″ (206 cm)' }), ({ [`value`]: '208',[`label`]: '6′10″ (208 cm)' }), ({ [`value`]: '211',[`label`]: '6′11″ (211 cm)' }), ({ [`value`]: '213',[`label`]: '7′0″ (213 cm)' })];
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

/**
 * Describe this function...
 */
async function getSeenBy() {
  if (!(getObjectProperty(___arguments.context.pageData, 'activeTab'))) {
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy'))) {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile'))['seenBy'] = [];
    }
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy')).length > 0) {
      seenByList = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')));
      }));
      ___arguments.context.pageData['seenByList'] = (seenByList.map(item => item['objectId']));
      if ((getObjectProperty(___arguments.context.pageData, 'seenByList')).length > 21) {
        userSeenBy = (getObjectProperty(___arguments.context.pageData, 'seenByList')).slice(0, 21);
        ___arguments.context.pageData['seenByList'] = (subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'seenByList')), 20));
      } else {
        userSeenBy = (getObjectProperty(___arguments.context.pageData, 'seenByList'));
        ___arguments.context.pageData['seenByList'] = [];
      }
      getSeenByNew = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfilesForLikes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'profilesIdText': JSON.stringify((userSeenBy.join('\',\''))),'blockedIdArray': JSON.stringify((JSON.stringify(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) : [])))) }).send());
      ___arguments.context.pageData['seenByNew'] = (await asyncListFilter(getSeenByNew, async (item) => {


       return ((getObjectProperty(item, 'userProfileObjectId')) && (getObjectProperty(item, 'photo')) && !!(getObjectProperty(item, 'photo')).length);
      }));
      await new Promise(r => setTimeout(r, 200 || 0));
      if ((getObjectProperty(___arguments.context.pageData, 'seenByNew')) && !!(getObjectProperty(___arguments.context.pageData, 'seenByNew')).length) {
        getRTSubscriptions().remove('seenByLikesCount');

        ;(function(whereClause) {
          const callback = async object => {
              ((getObjectProperty(___arguments.context.pageData, 'seenByNew'))[((((getObjectProperty(___arguments.context.pageData, 'seenByNew')).map(item => item['objectId'])).indexOf(getObjectProperty(object, 'ownerId')) + 1) - 1)])['likesCount'] = (getObjectProperty(object, 'likesCount'));

          };

          const rtHandlers = Backendless.Data.of('UserProfile').rt();

          const options = [callback];

          if (whereClause) {
             options.unshift(whereClause);
          }

          rtHandlers.addUpdateListener.apply(rtHandlers, options);

          getRTSubscriptions().add('seenByLikesCount', () => rtHandlers.removeUpdateListener(callback));

        })((['ownerId in (\'',((getObjectProperty(___arguments.context.pageData, 'seenByNew')).map(item => item['objectId'])).join('\',\''),'\')'].join('')));
          if (getObjectProperty(___arguments.context.pageData, 'seenByNew')) {
          var userResponce_list2 = (getObjectProperty(___arguments.context.pageData, 'seenByNew'));
          for (var userResponce_index2 in userResponce_list2) {
            userResponce = userResponce_list2[userResponce_index2];
            var userJson_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'seenBy'));
            for (var userJson_index2 in userJson_list2) {
              userJson = userJson_list2[userJson_index2];
              if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
                userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
              }
            }
          }
          ___arguments.context.pageData['seenBy'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'seenByNew')), -1, async (item) => {


           return (getObjectProperty(item, 'ts'));
          }));
        }
      }
    }
  }
}

/**
 * Describe this function...
 */
async function removeRTListeners() {
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
}


  ___arguments.context.pageData['countOffset'] = 0;
  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
    if (!(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus'))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', ({ [`accountPaused`]: true }));
      return ;
    }
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
    ___arguments.context.appData['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'photoThumbnail'));
    ___arguments.context.appData['profileStatus'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'profileStatus'));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
  ___arguments.context.pageData['tab'] = 'seenBy';
  currentUser = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  ___arguments.context.pageData['user'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  ___arguments.context.pageData['pageSize'] = 20;
  await getSeenBy();
  if (!(getObjectProperty(___arguments.context.pageData, 'seenBy'))) {
    ___arguments.context.pageData['seenBy'] = [];
  }
  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'seenBy'))) {
    (getObjectProperty(___arguments.context.pageData, 'user'))['seenBy'] = [];
  }
  if ((getObjectProperty(___arguments.context.pageData, 'tab')) == 'seenBy') {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')) && ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')) && ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')) && ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')) && ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).slice(-1)[0] != 'interests__navItem--active') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')), 'interests__navItem--active');
    }
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('685988157bf97ad2cfa180cc95143de7')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('685988157bf97ad2cfa180cc95143de7', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9e93ec1e55a2b318113ec9241310ace', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c86149a10f5c36f0b3551114936b00f', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd78f6c6fe95082e9034ed6fdccf40d', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0f987a70aba8015636581e8515faee9', false);
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'tab')) == 'favoriteProfiles') {
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c86149a10f5c36f0b3551114936b00f')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('685988157bf97ad2cfa180cc95143de7', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9e93ec1e55a2b318113ec9241310ace', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c86149a10f5c36f0b3551114936b00f', true);
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0f987a70aba8015636581e8515faee9', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd78f6c6fe95082e9034ed6fdccf40d', false);
        if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8d938b472772a86cfc86eef893c8bfa5')) {
          (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8d938b472772a86cfc86eef893c8bfa5', (getObjectProperty(___arguments.context.pageData, 'myLikes')));
        }
      }
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0f987a70aba8015636581e8515faee9', false);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd78f6c6fe95082e9034ed6fdccf40d', true);
      }
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).slice(-1)[0] != 'interests__navItem--active') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')), 'interests__navItem--active');
    }
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedActivities')) {
        likedActivities = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedActivities')).map(item => item['objectId']));
        if (!(getObjectProperty(___arguments.context.pageData, 'likesActivities'))) {
          ___arguments.context.pageData['likesActivities'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivity/getActivitiesForLikes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'objectIdTextList': JSON.stringify((likedActivities.join('\',\''))),'pageSize': 100,'pageOffset': 0,'blockedIdArray': JSON.stringify((JSON.stringify(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) : [])))) }).send());
          if (!(getObjectProperty(___arguments.context.pageData, 'likesActivities'))) {
            ___arguments.context.pageData['likesActivities'] = [];
          }
          if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'likesActivities'))) {
            (getObjectProperty(___arguments.context.pageData, 'user'))['likesActivities'] = [];
          }
        }
      }
      if ((getObjectProperty(___arguments.context.appData, 'profilesListIsActive')) && ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fe046649ec7ae709c1e88b8caca40cc5'))) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fe046649ec7ae709c1e88b8caca40cc5')), 'interests__navItem--active');
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6b55f836a7230ce579146f14a8f626fd', true);
      }
      if ((getObjectProperty(___arguments.context.appData, 'activitiesListIsActive')) && ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c353fb2dedac1465c93fbf91f18ba75a'))) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c353fb2dedac1465c93fbf91f18ba75a')), 'interests__navItem--active');
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9b95de60639d61afa93fe261c0ec19b', true);
      }
    }
  }
  if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes'))) {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile'))['myLikes'] = [];
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fa46005f6b5a76138f083a95745fda91')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa46005f6b5a76138f083a95745fda91', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'tab')) == 'likedBy') {
    ___arguments.context.pageData['tab'] = 'likedBy';
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).slice(-1)[0] != 'interests__navItem--active') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')), 'interests__navItem--active');
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).pop();
    }
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy')).length > 0) {
      likedByList = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')));
      }));
      ___arguments.context.pageData['likedByList'] = (likedByList.map(item => item['objectId']));
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy')).length > 21) {
        likedBy = (getObjectProperty(___arguments.context.pageData, 'likedByList')).slice(0, 22);
        ___arguments.context.pageData['likedByList'] = (subsequenceFromStartLast((getObjectProperty(___arguments.context.pageData, 'likedByList')), 21));
      } else {
        likedBy = (getObjectProperty(___arguments.context.pageData, 'likedByList'));
        ___arguments.context.pageData['likedByList'] = [];
      }
      getLikedBy = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfiles/getProfilesForLikes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'profilesIdText': JSON.stringify((likedBy.join('\',\''))),'blockedIdArray': JSON.stringify((JSON.stringify(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) : [])))) }).send());
      ___arguments.context.pageData['likedBy'] = (await asyncListFilter(getLikedBy, async (item) => {


       return ((getObjectProperty(item, 'userProfileObjectId')) && (getObjectProperty(item, 'photo')) && !!(getObjectProperty(item, 'photo')).length);
      }));
      if (getObjectProperty(___arguments.context.pageData, 'likedBy')) {
        var userResponce_list = (getObjectProperty(___arguments.context.pageData, 'likedBy'));
        for (var userResponce_index in userResponce_list) {
          userResponce = userResponce_list[userResponce_index];
          var userJson_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedBy'));
          for (var userJson_index in userJson_list) {
            userJson = userJson_list[userJson_index];
            if ((getObjectProperty(userResponce, 'objectId')) == (getObjectProperty(userJson, 'objectId'))) {
              userResponce['ts'] = (getObjectProperty(userJson, 'ts'));
            }
          }
        }
        ___arguments.context.pageData['likedBy'] = (await asyncListSort((getObjectProperty(___arguments.context.pageData, 'likedBy')), -1, async (item) => {


         return (getObjectProperty(item, 'ts'));
        }));
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0f987a70aba8015636581e8515faee9', false);

      ;(function(whereClause) {
        const callback = async object => {
            ((getObjectProperty(___arguments.context.pageData, 'likedBy'))[((((getObjectProperty(___arguments.context.pageData, 'likedBy')).map(item => item['objectId'])).indexOf(getObjectProperty(object, 'ownerId')) + 1) - 1)])['likesCount'] = (getObjectProperty(object, 'likesCount'));

        };

        const rtHandlers = Backendless.Data.of('UserProfile').rt();

        const options = [callback];

        if (whereClause) {
           options.unshift(whereClause);
        }

        rtHandlers.addUpdateListener.apply(rtHandlers, options);

        getRTSubscriptions().add('likedByLikesCount', () => rtHandlers.removeUpdateListener(callback));

      })((['ownerId in (\'',((getObjectProperty(___arguments.context.pageData, 'likedBy')).map(item => item['objectId'])).join('\',\''),'\')'].join('')));
        }
    if (!(getObjectProperty(___arguments.context.pageData, 'likedBy'))) {
      ___arguments.context.pageData['likedBy'] = [];
    }
    if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'likedBy'))) {
      (getObjectProperty(___arguments.context.pageData, 'user'))['likedBy'] = [];
    }
    await (async function(loc) {

    	    try {
    	      history.pushState(null, null, loc);
    	      return;
    	    } catch(e) {}
    	    location.hash = '#' + loc;

    })((((function () { return window.location.href })()).split('&')[0]));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('685988157bf97ad2cfa180cc95143de7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9e93ec1e55a2b318113ec9241310ace', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c86149a10f5c36f0b3551114936b00f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd78f6c6fe95082e9034ed6fdccf40d', false);
  }
  if ((getObjectProperty(___arguments.context.pageData, 'tab')) == 'favoriteActivities' && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    ___arguments.context.pageData['tab'] = 'favoriteActivities';
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c084fa8cbe39b5365f39a1ccd1b1cc28')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cdf69fa7959d8fa7215cf1e5f96de91b')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).slice(-1)[0] == 'interests__navItem--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('55ce460eee62bfc349723142ed426591')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')).slice(-1)[0] != 'interests__navItem--active') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('62a96fd41ef8650a24f9f999b8123892')), 'interests__navItem--active');
    }
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedActivities')) {
      likedActivities = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedActivities')).map(item => item['objectId']));
      if (!(getObjectProperty(___arguments.context.pageData, 'likesActivities'))) {
        ___arguments.context.pageData['likesActivities'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getActivity/getActivities`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'objectId': JSON.stringify((likedActivities.join('\',\''))),'pageSize': 100,'relation': JSON.stringify((['category', 'author', 'author.userProfile.settings'].join(','))),'sort': JSON.stringify('activityDate DESC, ongoingTiming'),'whereClause': JSON.stringify((['visibility!=3 and activityStatus=true ',' and objectId in (\'',likedActivities.join('\',\''),'\') '].join(''))) }).send());
        if (!(getObjectProperty(___arguments.context.pageData, 'likesActivities'))) {
          ___arguments.context.pageData['likesActivities'] = [];
        }
        if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'likesActivities'))) {
          (getObjectProperty(___arguments.context.pageData, 'user'))['likesActivities'] = [];
        }
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b0f987a70aba8015636581e8515faee9', false);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('685988157bf97ad2cfa180cc95143de7', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d9e93ec1e55a2b318113ec9241310ace', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c86149a10f5c36f0b3551114936b00f', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5fd78f6c6fe95082e9034ed6fdccf40d', true);
  }
  await removeRTListeners();
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('658e6f5415123338541af193aea4c29e')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', false);
  }
  await getHeight();
  if (typeof (getObjectProperty(___arguments.context.appData, 'isOpenFullList')) === 'undefined') {
    ___arguments.context.pageData['isOpenFullList'] = false;
    ___arguments.context.appData['isOpenFullList'] = (getObjectProperty(___arguments.context.pageData, 'isOpenFullList'));
  } else {
    ___arguments.context.pageData['isOpenFullList'] = (getObjectProperty(___arguments.context.appData, 'isOpenFullList'));
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_likes_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/interests/components/7f95d526755b33dd326f553f3d7eb51e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenFullList'] = true;

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'isOpenFullList')) {
    return ['fas', 'fa-bars', 'active'];
  }

  return ['fas', 'fa-bars']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/interests/components/3efad19934b3c1dd1f7b677f4e9a8d3a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isOpenFullList'] = false;

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'isOpenFullList')) {
    return ['fas', 'fa-border-all'];
  }

  return ['fas', 'fa-border-all', 'active']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/interests/components/07f5173df8143396cf131e9a25357f8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      return ['cardWrapper']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/interests/components/fe046649ec7ae709c1e88b8caca40cc5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fe046649ec7ae709c1e88b8caca40cc5')).slice(-1)[0] != 'interests__subtab--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fe046649ec7ae709c1e88b8caca40cc5')), 'interests__subtab--active');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6b55f836a7230ce579146f14a8f626fd', true);
    ___arguments.context.appData['profilesListIsActive'] = true;
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fe046649ec7ae709c1e88b8caca40cc5')).slice(-1)[0] == 'interests__subtab--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fe046649ec7ae709c1e88b8caca40cc5')).pop();
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6b55f836a7230ce579146f14a8f626fd', false);
    delete ___arguments.context.appData['profilesListIsActive'];
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/interests/components/c353fb2dedac1465c93fbf91f18ba75a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c353fb2dedac1465c93fbf91f18ba75a')).slice(-1)[0] != 'interests__subtab--active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c353fb2dedac1465c93fbf91f18ba75a')), 'interests__subtab--active');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9b95de60639d61afa93fe261c0ec19b', true);
    ___arguments.context.appData['activitiesListIsActive'] = true;
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c353fb2dedac1465c93fbf91f18ba75a')).slice(-1)[0] == 'interests__subtab--active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c353fb2dedac1465c93fbf91f18ba75a')).pop();
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9b95de60639d61afa93fe261c0ec19b', false);
    ___arguments.context.appData['activitiesListIsActive'] = false;
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('658e6f5415123338541af193aea4c29e')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('658e6f5415123338541af193aea4c29e', false);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/interests/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['','© ',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/0669a398dab33bf127592c99689297ef/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Profiles I ❤️'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/fe6b879dd618870a83131395b85d0718/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return (String('Activities I ❤️'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/685988157bf97ad2cfa180cc95143de7/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  onScroll(___arguments) {
    var item, myLikesList, userLikesList, j, seenByList, newUsers;

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/interests/components/38d5e449d5f861b4ac01d0641cf12aa6/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  onScroll(___arguments) {
    var item, myLikesList, userLikesList, j, seenByList, newUsers;

  },
  /* handler:onScroll */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (!(___arguments.context.pageData['currentUser'])) {
    Object.assign(___arguments.context.pageData, (___arguments.context.appData['pageDataLikes']));
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/interests/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var updatedUser, user, object, item, userJson, userResponce, likedBy;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.pageData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/interests/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'showPopup')) {
    delete ___arguments.context.appData['showPopup'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/interests/components/d24bf5bfe04cf3b2682972329f4c20ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9b8e7334c0dc1c0bb42fac514dc42aeb')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/interests/components/fa46005f6b5a76138f083a95745fda91/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'seenBy'))) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/interests/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/interests/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/6b55f836a7230ce579146f14a8f626fd/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6b55f836a7230ce579146f14a8f626fd', false);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/interests/components/c9b95de60639d61afa93fe261c0ec19b/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9b95de60639d61afa93fe261c0ec19b', false);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/interests/components/b0f987a70aba8015636581e8515faee9/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/interests/components/05c284b74c64ba0da1165d12afa690de/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedUser, user, error, item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('05c284b74c64ba0da1165d12afa690de'))['pointer-events'] = 'none';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('05c284b74c64ba0da1165d12afa690de')).slice(-1)[0] != 'clicked') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('05c284b74c64ba0da1165d12afa690de')), 'clicked');
    await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'userProfileObjectId')),'likesCount': ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'likesCount')) + 1) });
    addItemToList((getObjectProperty(___arguments.context.pageData, 'myLikes')), ___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'));
    ___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717')['likedIcon'] = true;
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes')), ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')),[`ts`]: ((new Date()).valueOf()) }));
    try {
      await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', (String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile')), null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')));
      await (getChannelInstance('likes')).send('', ({ [`message`]: String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile'),[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

    } catch (error) {
      console.log(error);

    }
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')),'parameter': 'likedBy','currentUser': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'userProfileObjectId')) });
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')),'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'objectId')) });
  } else {
    ___arguments.context.pageData['myLikes'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'myLikes')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')));
    }));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile'))['myLikes'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')));
    }));
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('05c284b74c64ba0da1165d12afa690de')).pop();
    ___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717')['likedIcon'] = true;
    await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'userProfileObjectId')),'likesCount': ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'likesCount')) > 0 ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'likesCount')) - 1 : 0) });
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')),'parameter': 'likedBy','currentUser': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'userProfileObjectId')) });
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')),'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'objectId')) });
    try {
      await (getChannelInstance('likes')).send('', ({ [`message`]: undefined,[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

    } catch (error) {
      console.log(error);

    }
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('05c284b74c64ba0da1165d12afa690de'))['pointer-events'] = 'auto';
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'user'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'user'))));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes'))) {
    if (!!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')) == (getObjectProperty(item, 'objectId')));
    })).length) {
      return ['card__favoriteBtn favoriteIcon btnRound btnRound--sm btnRound--dark', 'clicked'];
    }
  }

  return ['card__favoriteBtn favoriteIcon btnRound btnRound--sm btnRound--dark']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/interests/components/6b22372981b8c9ba849f0351dc26e105/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var userName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717')) {
    userName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'name')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'name')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'login'));
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('275fc2ece0ba8c53544f4858417bb326')) {
      await BackendlessUI.Functions.Custom['fn_ad89afb73ebab1c1c7a57aa8e307f1d5'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6b22372981b8c9ba849f0351dc26e105')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('ad05973db39c5aa9f928eaaeae4d01af')), (getObjectProperty(___arguments.context.pageData, 'isOpenFullList')), userName);
    }
    return userName;
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/interests/components/ad05973db39c5aa9f928eaaeae4d01af/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(', ') + String((await (async function(year, month, day) {
	let now = new Date();
	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

	let dob = new Date(year, month, day);

	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

	let age;

	age = today.getFullYear() - dob.getFullYear();

	if (today < dobnow) {
	  age = age-1;
	} else {
	  age = age
	}


	return age

})((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'birthDate'))).getFullYear()), (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'birthDate'))).getMonth()), (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'birthDate'))).getDate())))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/7b5e3f72791980dde547658684d2b9d1/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var photoCoverObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b5a831e558c63a5b383b69ccf57e202f'), 'file')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b5a831e558c63a5b383b69ccf57e202f'), 'file')) : 'styles/media/placeholderPhoto.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/interests/components/8c876f07a89ff88f4e4f3f43898f66b8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ethnicity')), async (item) => {


   return ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'ethnicity')));
  }))[0]) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')),[`ethnicity`]: (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ethnicity')), async (item) => {


     return ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'ethnicity')));
    }))[0]), 'name')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'photo'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/interests/components/5ef49661657e9b7bebc75b7cf6ee43ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId')) }));

  },
  /* handler:onClick */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'photo'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/interests/components/adc55109aa6c03a1fdaa07a549cab5f1/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var img, photoCoverObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('23c8580d58fc9933e5d8fbc10263d36a'), 'file')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('23c8580d58fc9933e5d8fbc10263d36a'), 'file')) : 'styles/media/placeholderPhoto.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/interests/components/eb9d6bbb12f8ac52402acdc7961e9982/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var userName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e')) {
    userName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'name')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'name')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'login'));
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eb9d6bbb12f8ac52402acdc7961e9982')) && ___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e')) {
      await BackendlessUI.Functions.Custom['fn_ad89afb73ebab1c1c7a57aa8e307f1d5'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('eb9d6bbb12f8ac52402acdc7961e9982')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('b7294823e20285467c26d92b26a3019e')), (getObjectProperty(___arguments.context.pageData, 'isOpenFullList')), userName);
    }
    return userName;
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/b7294823e20285467c26d92b26a3019e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(', ') + String((await (async function(year, month, day) {
	let now = new Date();
	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

	let dob = new Date(year, month, day);

	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

	let age;

	age = today.getFullYear() - dob.getFullYear();

	if (today < dobnow) {
	  age = age-1;
	} else {
	  age = age
	}

	return age

})((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'birthDate'))).getFullYear()), (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'birthDate'))).getMonth()), (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'birthDate'))).getDate())))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/4ed85e3d6497c514e215371a6fe426db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedUser, user, error, userObjectId, userProfileObjectId, likesCount, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  if ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4ed85e3d6497c514e215371a6fe426db')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4ed85e3d6497c514e215371a6fe426db'))['pointer-events'] = 'none';
  }
  userProfileObjectId = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'userProfileObjectId'));
  userObjectId = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId'));
  likesCount = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'likesCount'));
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4ed85e3d6497c514e215371a6fe426db')).slice(-1)[0] != 'clicked') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4ed85e3d6497c514e215371a6fe426db')), 'clicked');
    await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': userProfileObjectId,'likesCount': (likesCount + 1) });
    addItemToList((getObjectProperty(___arguments.context.pageData, 'myLikes')), ___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'));
    ___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e')['likedIcon'] = true;
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes')), ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId')),[`ts`]: ((new Date()).valueOf()) }));
    try {
      await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', (String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile')), null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId')));
      await (getChannelInstance('likes')).send('', ({ [`message`]: String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile'),[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

    } catch (error) {
      console.log(error);

    }
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')),'parameter': 'likedBy','currentUser': userProfileObjectId });
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': userObjectId,'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'objectId')) });
  } else {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile'))['myLikes'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId')));
    }));
    ___arguments.context.pageData['myLikes'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'myLikes')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId')) != (getObjectProperty(item, 'objectId')));
    }));
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4ed85e3d6497c514e215371a6fe426db')).pop();
    ___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e')['likedIcon'] = false;
    await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': userProfileObjectId,'likesCount': (likesCount > 0 ? likesCount - 1 : 0) });
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')),'parameter': 'likedBy','currentUser': userProfileObjectId });
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': userObjectId,'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'objectId')) });
    try {
      await (getChannelInstance('likes')).send('', ({ [`message`]: undefined,[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

    } catch (error) {
      console.log(error);

    }
  }
  getRTSubscriptions().remove('online');

  ;(function(whereClause) {
    const callback = async updatedUser => {
        var user_list = (getObjectProperty(___arguments.context.pageData, 'myLikes'));
    for (var user_index in user_list) {
      user = user_list[user_index];
      if (user && updatedUser) {
        if ((getObjectProperty(user, 'objectId')) == (getObjectProperty(updatedUser, 'objectId'))) {
          user['online'] = (getObjectProperty(updatedUser, 'online'));
        }
      }
    }

    };

    const rtHandlers = Backendless.Data.of('Users').rt();

    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add('online', () => rtHandlers.removeUpdateListener(callback));

  })('');
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4ed85e3d6497c514e215371a6fe426db')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('4ed85e3d6497c514e215371a6fe426db'))['pointer-events'] = 'auto';
  }
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'user'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'user'))));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes'))) {
    if (!!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId')) == (getObjectProperty(item, 'objectId')));
    })).length) {
      return ['card__favoriteBtn favoriteIcon btnRound btnRound--sm btnRound--dark', 'clicked'];
    }
  }

  return ['card__favoriteBtn favoriteIcon btnRound btnRound--sm btnRound--dark']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/interests/components/35e1449f27789acc65cdb46925883717/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove((getObjectProperty(___arguments.context.dataModel, 'objectId')));

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/interests/components/14bf5cca767db581060d0a71b86cfc7e/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var j, list, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (getObjectProperty(___arguments.context.pageData, 'myLikes')) {
    list = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'myLikes')), async (item) => {


     return (getObjectProperty(item, 'object'));
    }));
    for (var j_index in list) {
      j = list[j_index];
      if ((getObjectProperty(___arguments.context.dataModel, 'objectId')) == (getObjectProperty(j, 'objectId'))) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4ed85e3d6497c514e215371a6fe426db')), 'clicked');
      }
    }
  } else {
    ___arguments.context.pageData['myLikes'] = [];
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove((getObjectProperty(___arguments.context.dataModel, 'objectId')));

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/interests/components/9a54ec74f6a5714d781f73038bae2908/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedUser, user, error, userObjectId, userProfileObjectId, item, likesCount;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a54ec74f6a5714d781f73038bae2908')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a54ec74f6a5714d781f73038bae2908'))['pointer-events'] = 'none';
  }
  userProfileObjectId = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'userProfileObjectId'));
  userObjectId = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId'));
  likesCount = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'likesCount'));
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9a54ec74f6a5714d781f73038bae2908')).slice(-1)[0] != 'clicked') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9a54ec74f6a5714d781f73038bae2908')), 'clicked');
    await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': userProfileObjectId,'likesCount': (likesCount + 1) });
    addItemToList((getObjectProperty(___arguments.context.pageData, 'myLikes')), ___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'));
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes')), ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')),[`ts`]: ((new Date()).valueOf()) }));
    try {
      await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', (String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile')), null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')));
      await (getChannelInstance('likes')).send('', ({ [`message`]: String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile'),[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

    } catch (error) {
      console.log(error);

    }
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')),'parameter': 'likedBy','currentUser': userProfileObjectId });
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': userObjectId,'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'objectId')) });
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9a54ec74f6a5714d781f73038bae2908')).pop();
    await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': userProfileObjectId,'likesCount': (userProfileObjectId > 0 ? userProfileObjectId - 1 : 0) });
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile'))['myLikes'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'myLikes')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')));
    }));
    ___arguments.context.pageData['myLikes'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'myLikes')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')) != (getObjectProperty(item, 'objectId')));
    }));
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'ownerId')),'parameter': 'likedBy','currentUser': userProfileObjectId });
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': userObjectId,'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'objectId')) });
    try {
      await (getChannelInstance('likes')).send('', ({ [`message`]: undefined,[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

    } catch (error) {
      console.log(error);

    }
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a54ec74f6a5714d781f73038bae2908')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9a54ec74f6a5714d781f73038bae2908'))['pointer-events'] = 'auto';
  }
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'user'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'user'))));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes'))) {
    if (!!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')) == (getObjectProperty(item, 'objectId')));
    })).length) {
      return ['card__favoriteBtn favoriteIcon btnRound btnRound--sm btnRound--dark', 'clicked'];
    }
  }

  return ['card__favoriteBtn favoriteIcon btnRound btnRound--sm btnRound--dark']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/interests/components/06e27cf8c226b8c4d699de726d42bec6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await new Promise(r => setTimeout(r, 1000 || 0));
  var j_list = (getObjectProperty(___arguments.context.pageData, 'myLikes'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.dataModel, 'ownerId')) == (getObjectProperty(j, 'ownerId'))) {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9a54ec74f6a5714d781f73038bae2908')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9a54ec74f6a5714d781f73038bae2908')), 'clicked');
      }
    }
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove((getObjectProperty(___arguments.context.dataModel, 'objectId')));

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/interests/components/15a3e262cace099b4858b80fef4331d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(' ,') + String((await (async function(year, month, day) {
	let now = new Date();
	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

	let dob = new Date(year, month, day);

	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

	let age;

	age = today.getFullYear() - dob.getFullYear();

	if (today < dobnow) {
	  age = age-1;
	} else {
	  age = age
	}

	return age

})((new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'birthDate'))).getFullYear()), (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'birthDate'))).getMonth()), (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'birthDate'))).getDate())))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/8b155f8d384332c91ecddbd22eee53de/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var userName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6')) {
    userName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'name')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'name')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'login'));
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8b155f8d384332c91ecddbd22eee53de')) && ___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6')) {
      await BackendlessUI.Functions.Custom['fn_ad89afb73ebab1c1c7a57aa8e307f1d5'](((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8b155f8d384332c91ecddbd22eee53de')), ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('15a3e262cace099b4858b80fef4331d6')), (getObjectProperty(___arguments.context.pageData, 'isOpenFullList')), userName);
    }
    return userName;
  }

  return ''

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/0a417f559bef7e43563dabade1af4787/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var photoCoverObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('980b1f8fbdb761dc9826ae18441e631f'), 'file')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('980b1f8fbdb761dc9826ae18441e631f'), 'file')) : 'styles/media/placeholder_photo.png')

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/interests/components/9063ac521b9cf3fbf8b12f57ba0d4804/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ethnicity')), async (item) => {


   return ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'ethnicity')));
  }))[0]) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')),[`ethnicity`]: (getObjectProperty(((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'ethnicity')), async (item) => {


     return ((getObjectProperty(item, 'id')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'ethnicity')));
    }))[0]), 'name')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')) }));
  }

  },
  /* handler:onClick */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'photo'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/interests/components/6aadf8218151447e6ba952c96247276d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedUser, user, item, error;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6aadf8218151447e6ba952c96247276d')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6aadf8218151447e6ba952c96247276d'))['pointer-events'] = 'none';
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6aadf8218151447e6ba952c96247276d')).slice(-1)[0] != 'clicked') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6aadf8218151447e6ba952c96247276d')), 'clicked');
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedActivities')), ({ [`ts`]: ((new Date()).valueOf()),[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'objectId')) }));
    try {
      await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),' just liked your activity "',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'name')),'"'].join('')), null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'objectId')));
      await (getChannelInstance('likes')).send('', ({ [`message`]: undefined,[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

    } catch (error) {
      console.log(error);

    }
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'objectId')),'parameter': 'likedActivities','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'objectId')) });
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6aadf8218151447e6ba952c96247276d')).pop();
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile'))['likedActivities'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'likedActivities')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'objectId')) != (getObjectProperty(item, 'objectId')));
    }));
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'objectId')),'parameter': 'likedActivities','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'user')), 'userProfile')), 'objectId')) });
  }
  if ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6aadf8218151447e6ba952c96247276d')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('6aadf8218151447e6ba952c96247276d'))['pointer-events'] = 'auto';
  }
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'user'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'user'))));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'likesActivities')), async (item) => {


   return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'objectId')) == (getObjectProperty(item, 'objectId')));
  })).length) {
    return ['card__favoriteBtn favoriteIcon btnRound btnRound--sm btnRound--dark', 'clicked'];
  }

  return ['card__favoriteBtn favoriteIcon btnRound btnRound--sm btnRound--dark']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/interests/components/b199f396abc49ceaa3aab34e5508e07b/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'media')) {
    var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'media'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (getObjectProperty(j, 'isCover')) {
        return (getObjectProperty(j, 'file'));
      }
    }
  }

  return 'styles/media/placeholderPhoto.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/interests/components/2169d7919171cd3e38bdb82420bbb28b/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'photoThumbnail')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'photoThumbnail')) : null)

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/interests/components/e322660bfdbe99249471759f6ecd6651/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
      return 'Location shared with chosen +1'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/bcfe3c96979cd137fac8f0166f8ae3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'likesCount')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'likesCount')) : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/49f1b20a178778c18f956d37af8cb93a/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var photoCoverObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717') && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('685988157bf97ad2cfa180cc95143de7'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'photo')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'photo')).length) {
      if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('685988157bf97ad2cfa180cc95143de7')), 'display')) {
        photoCoverObj = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'photo')), async (item) => {


         return ((getObjectProperty(item, 'isCover')) == true);
        }))[0];
      }
      if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('685988157bf97ad2cfa180cc95143de7')), 'display')) {
        return (getObjectProperty((photoCoverObj ? photoCoverObj : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'photo'))[0]), 'file'));
      }
    } else {
      return 'styles/media/placeholderPhoto.png';
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/interests/components/a89b469f7383da1ac4a4e619b59aed98/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var img, photoCoverObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e') && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d9e93ec1e55a2b318113ec9241310ace'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'photo')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'photo')).length) {
      if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d9e93ec1e55a2b318113ec9241310ace')), 'display')) {
        photoCoverObj = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'photo')), async (item) => {


         return ((getObjectProperty(item, 'isCover')) == true);
        }))[0];
      }
      if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d9e93ec1e55a2b318113ec9241310ace')), 'display')) {
        img = (getObjectProperty((photoCoverObj ? photoCoverObj : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'photo'))[0]), 'file'));
        return img;
      }
    }
  }

  return 'styles/media/placeholderPhoto.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/interests/components/10833824eaf344b3f3f7913418a28f8f/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var photoCoverObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6') && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c86149a10f5c36f0b3551114936b00f'))) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'photo')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'photo')).length) {
      if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c86149a10f5c36f0b3551114936b00f')), 'display')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6b55f836a7230ce579146f14a8f626fd')), 'display'))) {
        photoCoverObj = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'photo')), async (item) => {


         return ((getObjectProperty(item, 'isCover')) == true);
        }))[0];
      }
      if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3c86149a10f5c36f0b3551114936b00f')), 'display')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6b55f836a7230ce579146f14a8f626fd')), 'display'))) {
        return (getObjectProperty((photoCoverObj ? photoCoverObj : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'photo'))[0]), 'file'));
      }
    }
  }

  return 'styles/media/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/interests/components/95b4f3d2be79aba68b8eb52ed3aa8947/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'likesCount')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'likesCount')) : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/2a7c400e695e606c34528c9bfdac58cb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'likesCount')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'likesCount')) : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/25b2805aa659756c80312fb76175332f/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/interests/components/29f8368e39a4c92f070b109dd81c3b63/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/interests/components/b0727f41027761fd842f66f4d103e54d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a3aeb0943b729c3406c9650f933ff5b9'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/interests/components/e3a89c25acee01720da964b214fd2b9d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('35e1449f27789acc65cdb46925883717'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/interests/components/feaebf57c7d9e8ab5c64ef1d3ba38099/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('14bf5cca767db581060d0a71b86cfc7e'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/interests/components/ce02f1e7e576f3ae51778806f9fde274/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('06e27cf8c226b8c4d699de726d42bec6'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/interests/components/bfbcb3627c3a8fea3b8a5dfa33b9898a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'myLikes')) ? (getObjectProperty(___arguments.context.pageData, 'myLikes')).length : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/b70eb04455b1c10869a2cef9d0212e9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'likesActivities')) ? (getObjectProperty(___arguments.context.pageData, 'likesActivities')).length : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/interests/components/28969456f0b22755ada9258ddfcde20d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'likesActivities'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/interests/components/8102d0fbf54d0e5b8e035afadcdf7e23/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'myLikes'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/interests/components/7351d952d3841acf0b7f07b20ac651a5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/launch/components/ea93768867464198176cccbc5dd46b4d/bundle.js', [], () => ({
  /* content */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('slides');

  },
  /* handler:onVisibilityChange */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('slides');

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/launch/components/33d85a825125deee88fdb26732168804/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['onboarding__slider-item active'];
  }

  return ['onboarding__slider-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/launch/components/19eee636ad8d36031ab2ff7d4d71a16a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newData, oldData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oldData = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d5475b0a598fd7ec5d07431661e408da'));
  if ((getObjectProperty(___arguments.context.dataModel, 'active')) == false) {
    newData = (await BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'](oldData, (getObjectProperty(___arguments.context.dataModel, 'objectId'))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aaed25fc13a63eb92097bd5939f6bd04', newData);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d47df57b11d1b27df885c688728c30e2', newData);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5475b0a598fd7ec5d07431661e408da', newData);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['slider__dots-item active'];
  }

  return ['slider__dots-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/launch/components/8c2584be4c56673c6a8dfe675d837252/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var newData, nextActiveId, oldData, activeId, fetchData, error;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('firstRunComplete')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c2584be4c56673c6a8dfe675d837252', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4a10b07b8a51d35d34c045d91d5b51d', false);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e696f82bb6654778927bf94873775fae')), 'open');
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 992) {
    localStorage.setItem('firstRunComplete', JSON.stringify(true));
    await new Promise(r => setTimeout(r, 1000 || 0));
    if (!((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c2584be4c56673c6a8dfe675d837252'))) {
      stopSetTimeout('slides');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c2584be4c56673c6a8dfe675d837252'))['opacity'] = 1;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c2584be4c56673c6a8dfe675d837252'))['visibility'] = 'visible';
      await new Promise(r => setTimeout(r, 1500 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c2584be4c56673c6a8dfe675d837252'))['opacity'] = 0;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c2584be4c56673c6a8dfe675d837252'))['visibility'] = 'hidden';
      await new Promise(r => setTimeout(r, 800 || 0));
      try {
        if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 992) {
          if (getObjectProperty(___arguments.context.pageData, 'fetchData')) {
            fetchData = (getObjectProperty(___arguments.context.pageData, 'fetchData'));
            activeId = (getObjectProperty((fetchData[0]), 'objectId'));
            newData = (await BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'](fetchData, activeId));
            if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aaed25fc13a63eb92097bd5939f6bd04')) {
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aaed25fc13a63eb92097bd5939f6bd04', newData);
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d47df57b11d1b27df885c688728c30e2', newData);
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5475b0a598fd7ec5d07431661e408da', newData);
              if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aaed25fc13a63eb92097bd5939f6bd04')) {

                ;(function() {
                  const callback = async () => {
                      oldData = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aaed25fc13a63eb92097bd5939f6bd04'));
                  nextActiveId = (await BackendlessUI.Functions.Custom['fn_ff776ab87025e31a9a7f4d5fcf8fe516'](oldData));
                  newData = (await BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'](oldData, nextActiveId));
                  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5475b0a598fd7ec5d07431661e408da', newData);
                  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d47df57b11d1b27df885c688728c30e2', newData);
                  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aaed25fc13a63eb92097bd5939f6bd04', newData);

                  };

                  const timerId = 'slides';
                  const timerDelay = 2000;

                  runSetTimeout(timerId, callback, timerDelay)
                })()
              }
            }
          }
        }

      } catch (error) {
        console.log(error);
        while (!(getObjectProperty(___arguments.context.pageData, 'fetchData'))) {
          await new Promise(r => setTimeout(r, 1000 || 0));
          if (!!(getObjectProperty(___arguments.context.pageData, 'fetchData')).length) {
            fetchData = (getObjectProperty(___arguments.context.pageData, 'fetchData'));
            activeId = (getObjectProperty((fetchData[0]), 'objectId'));
            newData = (await BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'](fetchData, activeId));
            if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aaed25fc13a63eb92097bd5939f6bd04')) {
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aaed25fc13a63eb92097bd5939f6bd04', newData);
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d47df57b11d1b27df885c688728c30e2', newData);
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5475b0a598fd7ec5d07431661e408da', newData);
              if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aaed25fc13a63eb92097bd5939f6bd04')) {

                ;(function() {
                  const callback = async () => {
                      oldData = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aaed25fc13a63eb92097bd5939f6bd04'));
                  nextActiveId = (await BackendlessUI.Functions.Custom['fn_ff776ab87025e31a9a7f4d5fcf8fe516'](oldData));
                  newData = (await BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'](oldData, nextActiveId));
                  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5475b0a598fd7ec5d07431661e408da', newData);
                  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d47df57b11d1b27df885c688728c30e2', newData);
                  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aaed25fc13a63eb92097bd5939f6bd04', newData);

                  };

                  const timerId = 'slides';
                  const timerDelay = 3000;

                  runSetTimeout(timerId, callback, timerDelay)
                })()
              }
            }
          }
        }

      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c2584be4c56673c6a8dfe675d837252', false);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d4a10b07b8a51d35d34c045d91d5b51d'))['display'] = 'flex';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d4a10b07b8a51d35d34c045d91d5b51d'))['opacity'] = 1;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d4a10b07b8a51d35d34c045d91d5b51d'))['visibility'] = 'visible';
    }
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      if (!((function(){ try { return JSON.parse(localStorage.getItem('firstRunComplete')) } catch(e){ return null }})()) && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 992) {
    ___arguments.context.pageData['fetchData'] = (await Backendless.Request.get(`${Backendless.appPath}/services/slides/getSlides`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  }

  },
  /* handler:onBeforeMount */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('slides');

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/launch/components/f269ae6d5e3c79532c99a64929a44bc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4a10b07b8a51d35d34c045d91d5b51d', false);
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e696f82bb6654778927bf94873775fae')), 'open');
  stopSetTimeout('1');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/launch/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('slides');

  },
  /* handler:onLeave */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'FindMy+1'

  },  
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

/**
 * Describe this function...
 */
async function profilesTableData() {
}


  await (async function() {
  	const meta = document.createElement('meta')

  	meta.setAttribute('property', 'og:title')
  	meta.setAttribute('content', 'Check out this new connection platform I found: https://app.findmyplus.one. Post an activity and get matched with a perfect +1')

  	document.querySelector("head").appendChild(meta)

  })();
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_launch_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/launch/components/6fb36dca4a86f3a98327dd3a7f95a36c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('slides');
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/launch/components/d5ffd4f94dff4746bd15eec287a9ba56/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['onboarding__text-subtitle active'];
  }

  return ['onboarding__text-subtitle']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/launch/components/efabfff772c554daa0c1e80bf5e7eb65/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['onboarding__text-description active'];
  }

  return ['onboarding__text-description']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/launch/components/ff8d722900cd0c5e65c2f0b8c435036e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('33d85a825125deee88fdb26732168804'), 'active')) {
    return ['onboarding__text-title active'];
  }

  return ['onboarding__text-title']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/launch/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['','© ',(new Date((new Date())).getFullYear()),'  FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/launch/components/7cba30ec77aa1057a30f84082b67faaa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  try {
    await socialLogin('facebook', null, null, null, 'social-login', null);

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/launch/components/f31b4f0153cbb21ebbcfc8615c654064/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, user, token;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  ___arguments.context.pageData['appleBtnDisabled'] = true;
  try {
    await (async function(data) {
    	if (typeof BackendlessUI && BackendlessUI.DeviceAPI.isMobile()) {

    	  data.isMobile = true
    	}
    })(___arguments.context.pageData);
    if (getObjectProperty(___arguments.context.pageData, 'isMobile')) {
      await socialLogin('apple', null, null, ({ [`clientId`]: 'com.backendless.findmy' }), 'social-login', null);
    } else {
      token = (await (async function() {
      	const AppleID  = await BackendlessUI.requireModule('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js');

      	AppleID.auth.init({
      	  clientId : 'com.backendless.findmy',
      	  scope : 'email',
      	  redirectURI: 'https://app.findmyplus.one/index.html?page=social-login',
      	state : "initial",
      	  usePopup : true
      	})

      	const { authorization} = await AppleID.auth.signIn()

      	return authorization.id_token
      })());
      user = (await Backendless.Request.post(`${Backendless.appPath}/services/AppleAuth/login`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(token)));
      await (async function(user) {
      	Backendless.Users.setCurrentUser(user, true)
      })(user);
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('social-login', undefined);
    }

  } catch (error) {
    ___arguments.context.pageData['appleBtnDisabled'] = false;
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/launch/components/aa7b310ed08fb59d78180db88026c138/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  try {
    await socialLogin('linkedin', null, null, null, 'social-login', null)
  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/launch/components/a2cf35a3d2dc3df348f3c464ba81da9f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  try {
    await socialLogin('twitter', null, null, null, 'social-login', null)
  } catch (error) {
    Backendless.Logging.getLogger('errorLoginTwitter').debug((JSON.stringify(error)));
    console.log(JSON.stringify(error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/launch/components/1bac70e39cddb3b1e7f4a039f32f0449/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var j, error, isServiceAvailable, currentUser, profileTableDataSet, item;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getDeviceSubscriptions() { return getSubscriptionsManager('deviceSubscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function profilesTableData() {
  try {
    if (!((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')) && !(getObjectProperty(___arguments.context.appData, 'statusList'))) {
      ___arguments.context.appData['statusList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileMaritalStatus'));
      ___arguments.context.appData['ethnicityList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileEthnicity'));
      ___arguments.context.appData['bodyTypeList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileBodyType'));
      ___arguments.context.appData['orientationList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileSexOrientation'));
      ___arguments.context.appData['educationList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileEducationLevel'));
      ___arguments.context.appData['politicalList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfilePoliticalView'));
      ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
      ___arguments.context.appData['hairColorList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileHairColor'));
      ___arguments.context.appData['smokeList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileSmoke'));
      ___arguments.context.appData['drinkList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileDrink'));
      ___arguments.context.appData['dietaryList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileDietary'));
      ___arguments.context.appData['profilesData'] = ({ [`statusList`]: (getObjectProperty(___arguments.context.appData, 'statusList')),[`ethnicityList`]: (getObjectProperty(___arguments.context.appData, 'ethnicityList')),[`bodyTypeList`]: (getObjectProperty(___arguments.context.appData, 'bodyTypeList')),[`orientationList`]: (getObjectProperty(___arguments.context.appData, 'orientationList')),[`educationList`]: (getObjectProperty(___arguments.context.appData, 'educationList')),[`politicalList`]: (getObjectProperty(___arguments.context.appData, 'politicalList')),[`religionList`]: (await asyncListSort((getObjectProperty(___arguments.context.appData, 'religionList')), 1, async (item) => {


       return (getObjectProperty(item, 'name'));
      })),[`hairColorList`]: (getObjectProperty(___arguments.context.appData, 'hairColorList')),[`smokeList`]: (getObjectProperty(___arguments.context.appData, 'smokeList')),[`drinkList`]: (getObjectProperty(___arguments.context.appData, 'drinkList')),[`dietaryList`]: (getObjectProperty(___arguments.context.appData, 'dietaryList')) });
      localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
    } else if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')) && !(getObjectProperty(___arguments.context.appData, 'statusList'))) {
      ___arguments.context.appData['profilesData'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'));
      ___arguments.context.appData['statusList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'statusList'));
      ___arguments.context.appData['ethnicityList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'ethnicityList'));
      ___arguments.context.appData['bodyTypeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'bodyTypeList'));
      ___arguments.context.appData['orientationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'orientationList'));
      ___arguments.context.appData['educationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'educationList'));
      ___arguments.context.appData['politicalList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'politicalList'));
      ___arguments.context.appData['religionList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')), 1, async (item) => {


       return (getObjectProperty(item, 'name'));
      }));
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')).length <= 10) {
        ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
        (getObjectProperty(___arguments.context.appData, 'profilesData'))['religionList'] = (getObjectProperty(___arguments.context.appData, 'religionList'));
        localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
      }
      ___arguments.context.appData['hairColorList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'hairColorList'));
      ___arguments.context.appData['smokeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'smokeList'));
      ___arguments.context.appData['drinkList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'drinkList'));
      if (!(getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList'))) {
        ___arguments.context.appData['dietaryList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileDietary'));
        (getObjectProperty(___arguments.context.appData, 'profilesData'))['dietaryList'] = (getObjectProperty(___arguments.context.appData, 'dietaryList'));
        localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
      } else {
        ___arguments.context.appData['dietaryList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList'));
      }
    } else if ((getObjectProperty(___arguments.context.appData, 'religionList')) && (getObjectProperty(___arguments.context.appData, 'religionList')).length <= 10) {
      ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
      (getObjectProperty(___arguments.context.appData, 'profilesData'))['religionList'] = (getObjectProperty(___arguments.context.appData, 'religionList'));
      localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')).length <= 10) {
      ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
      (getObjectProperty(___arguments.context.appData, 'profilesData'))['religionList'] = (getObjectProperty(___arguments.context.appData, 'religionList'));
      localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
    }

  } catch (error) {
    console.log(error);

  }
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1bac70e39cddb3b1e7f4a039f32f0449', true);
    try {
      if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
        getDeviceSubscriptions().remove('onTapPushAction');
        getDeviceSubscriptions().remove('handleInactiveState');
        getDeviceSubscriptions().remove('handleResumeState');
        await ( async function () { return BackendlessUI.DeviceAPI.unregisterDevice() })();
      }

    } catch (error) {
      console.log(error);

    }
    Backendless.setCurrentUserToken(null);
    localStorage.removeItem('messages');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('tooltipInfo');
    localStorage.removeItem('userLocationInfo');
    localStorage.removeItem('country');
    localStorage.removeItem('lastChatInfoUpdate');
    localStorage.removeItem('tempFilters');
    localStorage.removeItem('Backendless');
    var j_list = (Object.keys(___arguments.context.appData));
    for (var j_index in j_list) {
      j = j_list[j_index];
      delete ___arguments.context.appData[j];
    }
  } else if ((await Backendless.UserService.getCurrentUser(false)) != null && (!(await Backendless.UserService.isValidLogin()) || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('Backendless')) && !(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('Backendless')), 'stayLoggedIn')))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1bac70e39cddb3b1e7f4a039f32f0449', true);
    await BackendlessUI.Functions.Custom['fn_e97140c64a3efafdbfb71077439f3811']();
    var j_list2 = (Object.keys(___arguments.context.appData));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      delete ___arguments.context.appData[j];
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e30b7c13cb6d407c46cdd99c0f858329', true);
    ___arguments.context.appData['currentUser'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
    await new Promise(r => setTimeout(r, 800 || 0));
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login')) && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'birthDate')) && !((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')))))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    }
  }
  ;(async () => {
      await BackendlessUI.Functions.Custom['fn_8ee7c112c28a73c6a512f0080e38e44d'](___arguments.context.appData);

  })();

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/launch/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', false, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/launch/components/96fbc2810963c49665885b65a156f891/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 992) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/launch/components/aea56af33881fc8c44788deadd086e7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  ___arguments.context.pageData['googleBtnDisabled'] = true;
  try {
    await socialLogin('googleplus', null, null, null, 'social-login', null);

  } catch (error) {
    ___arguments.context.pageData['googleBtnDisabled'] = false;
    console.log(JSON.stringify(error));

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/launch/components/e696f82bb6654778927bf94873775fae/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/launch/components/6222e5053dbdf6652a052d53e8fdc063/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    ___arguments.context.pageData['isIos'] = (await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('IS_IOS', undefined));
  } else {
    ___arguments.context.pageData['isIos'] = true;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/login/components/224fca35bd76fe12ccbb072cb1c5201b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el')), 'type')) == 'text') {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el'))['type'] = 'password';
    delete ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('224fca35bd76fe12ccbb072cb1c5201b'))['2'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('224fca35bd76fe12ccbb072cb1c5201b'))['2'] = 'fa-eye-slash';
  } else if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el')), 'type')) == 'password') {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el'))['type'] = 'text';
    delete ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('224fca35bd76fe12ccbb072cb1c5201b'))['2'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('224fca35bd76fe12ccbb072cb1c5201b'))['2'] = 'fa-eye';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/0d3cb78845c8ae897e2cbd7862a8948e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var email, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageDataUser'] = '';
  ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = '';
  email = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'email'));
  regExp = (await BackendlessUI.Functions.Custom['fn_33d4b09fd437e3c36dee5ef9d12d4fa1'](email));
  if (!email) {
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = 'Please, enter email address.';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')), 'alert-border');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')).pop();
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var error, currentUser, isLoggedIn, user, password, regExp, email, userRequestActivity;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.keyCode == '13') {
    await (async function(loginBtn) {
    	loginBtn.click();
    })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ea7063f7cc9f73bacc117e26f3ba587')), 'el')));
  }

  },
  /* handler:onKeyDown */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = '15vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a537e357dbe329fbdbd394654cdf0841')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/login/components/2e863203e1897ed6c6a853e89e95d1a5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password'))) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).slice(-1)[0] != 'alert-border') {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = 'Please, enter your password';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'alert-border');
    }
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).pop();
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var error, currentUser, isLoggedIn, user, password, regExp, email, userRequestActivity;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.keyCode == '13') {
    await (async function(loginBtn) {
    	loginBtn.click();
    })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ea7063f7cc9f73bacc117e26f3ba587')), 'el')));
  }

  },
  /* handler:onKeyDown */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = '15vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('a537e357dbe329fbdbd394654cdf0841')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/login/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['','© ',(new Date((new Date())).getFullYear()),'  FindMyPlusOne LLC - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/login/components/c5ebc3f90ddda4b8eac89f0e29bec362/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  ___arguments.context.pageData['disableGoogleBtn'] = true;
  try {
    await socialLogin('googleplus', null, null, null, 'social-login', null);

  } catch (error) {
    console.log(error);

  } finally {
    ___arguments.context.pageData['disableGoogleBtn'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/57da9c9530a6d5fa2d5ab984a267e43e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  ___arguments.context.pageData['disableFbBtn'] = true;
  try {
    await socialLogin('facebook', null, null, null, 'social-login', null);

  } catch (error) {
    console.log(error);

  } finally {
    ___arguments.context.pageData['disableFbBtn'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/ab7b5f2ef37a13a3b9555ae1e128a955/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var user, token, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  ___arguments.context.pageData['disableAppleBtn'] = true;
  try {
    await (async function(data) {
    	if (typeof BackendlessUI && BackendlessUI.DeviceAPI.isMobile()) {

    	  data.isMobile = true
    	}
    })(___arguments.context.pageData);
    if (getObjectProperty(___arguments.context.pageData, 'isMobile')) {
      await socialLogin('apple', null, null, ({ [`clientId`]: 'com.backendless.findmy' }), 'social-login', null);
    } else {
      token = (await (async function() {
      	const AppleID  = await BackendlessUI.requireModule('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js');

      	AppleID.auth.init({
      	  clientId : 'com.backendless.findmy',
      	  scope : 'email',
      	  redirectURI: 'https://app.findmyplus.one/index.html?page=social-login',
      	state : "initial",
      	  usePopup : true
      	})

      	const { authorization} = await AppleID.auth.signIn()

      	return authorization.id_token
      })());
      user = (await Backendless.Request.post(`${Backendless.appPath}/services/AppleAuth/login`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(token)));
      await (async function(user) {
      	Backendless.Users.setCurrentUser(user, true)
      })(user);
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('social-login', undefined);
    }

  } catch (error) {
    console.log(error);

  } finally {
    ___arguments.context.pageData['disableAppleBtn'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', false, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/2fcd63425cca61023ae792b3cfb9227d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')) {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el'))['autocomplete'] = 'off';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/login/components/6222e5053dbdf6652a052d53e8fdc063/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 2000 || 0));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')) {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')), 'el'))['maxLength'] = 60;
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el'))['maxLength'] = 20;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/login/components/8ea7063f7cc9f73bacc117e26f3ba587/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, isUserExist, email, userRequestActivity, currentUser, userData, password, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function isUserProfileReady() {
  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login')) && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'birthDate')) && !((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))))) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile')), 'locationGeoPoint')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile')), 'media')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile')), 'media')).length
}


  email = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'email'));
  password = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password'));
  if (!email) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')).slice(-1)[0] != 'alert-border') {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = 'Please, enter email address.';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')), 'alert-border');
    }
  } else {
    regExp = (await BackendlessUI.Functions.Custom['fn_33d4b09fd437e3c36dee5ef9d12d4fa1'](___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')));
    if ((getObjectProperty(regExp, 'status')) == false) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')).slice(-1)[0] != 'alert-border') {
        ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = 'Please, enter valid email address.';
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')), 'alert-border');
      }
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')).pop();
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = '';
    }
  }
  if (!password) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).slice(-1)[0] != 'alert-border') {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = 'Please, enter your password';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'alert-border');
    }
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).pop();
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = '';
  }
  if ((((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')).includes('alert-border')) || (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).includes('alert-border'))) {
    return ;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('88e7dfae526e227e32b8522f2c347b34', true);
  try {
    currentUser = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'email')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3a6743f3be916b8a656105d65d88c09d')), 'checked'))  ));
    userData = (await Backendless.Request.get(`${Backendless.appPath}/services/getCurrentUserData/getCurrentUserData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    currentUser['searchFilter'] = (getObjectProperty(userData, 'searchFilter'));
    currentUser['userProfile'] = (getObjectProperty(userData, 'userProfile'));
    currentUser = (await BackendlessUI.Functions.Custom['fn_51cfe3ce5dd5feda72d561df87a153ea'](currentUser));
    if (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')) {
      ___arguments.context.appData['userLocationInfo'] = ({ [`locationGeoPoint`]: (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')),[`location`]: (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'location')) });
      localStorage.setItem('userLocationInfo', JSON.stringify((getObjectProperty(___arguments.context.appData, 'userLocationInfo'))));
      if (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'country')) {
        localStorage.setItem('country', JSON.stringify((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'country'))));
      } else {
        await BackendlessUI.Functions.Custom['fn_24498a1473c83209b6d1428325c66861']((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')), (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'objectId')));
        (getObjectProperty(currentUser, 'userProfile'))['country'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country'));
      }
    }
    if ((getObjectProperty(currentUser, 'email')) == 'ari.hamilton@findmyplus.one') {
      ___arguments.context.appData['userLocationInfo'] = ({ [`locationGeoPoint`]: ({ [`type`]: 'Point',[`coordinates`]: [-96.845121, 32.8554833] }),[`location`]: 'Dallas, TX' });
      (getObjectProperty(currentUser, 'userProfile'))['locationGeoPoint'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'userLocationInfo')), 'locationGeoPoint'));
      (getObjectProperty(currentUser, 'userProfile'))['location'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'userLocationInfo')), 'location'));
      localStorage.setItem('userLocationInfo', JSON.stringify((getObjectProperty(___arguments.context.appData, 'userLocationInfo'))));
      localStorage.setItem('country', JSON.stringify('United States'));
    }
    ___arguments.context.appData['currentUser'] = currentUser;
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
    ;(async () => {
        await BackendlessUI.Functions.Custom['fn_36de753f55e8be4c07da77eb5cf7e8b5']((getObjectProperty(currentUser, 'objectId')), ___arguments.context.appData);

    })();
    if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
      await BackendlessUI.Functions.Custom['fn_5443ddc69ad10a1c48cca32797c3739b'](___arguments.context.pageData, ___arguments.context.appData, currentUser);
    }
    if (await isUserProfileReady()) {
      if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('userRequestActivity')) {
        userRequestActivity = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('userRequestActivity'));
        localStorage.removeItem('userRequestActivity');
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: userRequestActivity }));
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
      }
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    }

  } catch (error) {
    console.log(error);
    if ((getObjectProperty(error, 'code')) == 3003) {
      try {
        isUserExist = (await Backendless.Request.get(`${Backendless.appPath}/services/checkUser/checkUser`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'email': JSON.stringify(email) }).send());

      } catch (error) {
        console.log(error);
        ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = 'Oops, something went wrong...';
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('88e7dfae526e227e32b8522f2c347b34', false);
        return ;

      }
      if (isUserExist) {
        ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = 'Wrong password';
      } else {
        ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = 'User not found, please register';
      }
    } else if ((getObjectProperty(error, 'code')) == 3036) {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = 'You entered the wrong password 5 times. For security reasons, your account will be blocked for 5 minutes.';
    } else {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = 'Oops, something went wrong...';
    }
    if ((await Backendless.UserService.getCurrentUser(false)) != null) {
      await BackendlessUI.Functions.Custom['fn_e97140c64a3efafdbfb71077439f3811']();
      delete ___arguments.context.appData['isMobileDevice'];
      delete ___arguments.context.appData['currentUser'];
    }
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'alert-border');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('88e7dfae526e227e32b8522f2c347b34', false);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/login/components/1bac70e39cddb3b1e7f4a039f32f0449/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var j, error;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getDeviceSubscriptions() { return getSubscriptionsManager('deviceSubscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    try {
      if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
        getDeviceSubscriptions().remove('onTapPushAction');
        getDeviceSubscriptions().remove('handleInactiveState');
        getDeviceSubscriptions().remove('handleResumeState');
        await ( async function () { return BackendlessUI.DeviceAPI.unregisterDevice() })();
      }

    } catch (error) {
      console.log(error);

    }
    Backendless.setCurrentUserToken(null);
    localStorage.removeItem('messages');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('tooltipInfo');
    localStorage.removeItem('userLocationInfo');
    localStorage.removeItem('country');
    localStorage.removeItem('lastChatInfoUpdate');
    localStorage.removeItem('tempFilters');
    localStorage.removeItem('Backendless');
    var j_list = (Object.keys(___arguments.context.appData));
    for (var j_index in j_list) {
      j = j_list[j_index];
      delete ___arguments.context.appData[j];
    }
  } else if ((await Backendless.UserService.getCurrentUser(false)) != null && (!(await Backendless.UserService.isValidLogin()) || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('Backendless')) && !(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('Backendless')), 'stayLoggedIn')))) {
    await BackendlessUI.Functions.Custom['fn_e97140c64a3efafdbfb71077439f3811']();
    var j_list2 = (Object.keys(___arguments.context.appData));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      delete ___arguments.context.appData[j];
    }
  } else {
    ___arguments.context.appData['currentUser'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login')) && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'birthDate')) && !((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')))))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    }
  }
  ;(async () => {
      await BackendlessUI.Functions.Custom['fn_8ee7c112c28a73c6a512f0080e38e44d'](___arguments.context.appData);

  })();

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/login/components/75248e442858b6eedd54a2eacd7b3357/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    ___arguments.context.pageData['isIos'] = (await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('IS_IOS', undefined));
  } else {
    ___arguments.context.pageData['isIos'] = true;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/login/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;


  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_login_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/messages/components/baecc013db89a295072fa3537a3ae97b/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791'), 'current')) {
    return ['gallery__slider-image', 'messages-gallery', 'image', 'visible'];
  }

  return ['gallery__slider-image', 'messages-gallery', 'image']

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791'), 'type')) == 'image')

  },
  /* handler:onDisplayAssignment */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791'), 'type')) == 'image') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791'), 'message'));
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/1cbf6c166b68abae4248a1bf6cda9777/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var itemList, nextItem, currentItemIndex, j;


  itemList = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('998fdfebf2b3a7afe31c706a04e836f1'));
  currentItemIndex = 0;
  for (var j_index in itemList) {
    j = itemList[j_index];
    if (j['current']) {
      currentItemIndex = itemList.indexOf(j) + 1;
      j['current'] = false;
    }
  }
  nextItem = itemList[((currentItemIndex + 1) - 1)];
  if (nextItem) {
    nextItem['current'] = true;
  } else {
    (itemList[0])['current'] = true;
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/0285c0180af9eeb9e84dfbf86fa90a81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var itemList, previousItem, currentItemIndex, j;


  itemList = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('998fdfebf2b3a7afe31c706a04e836f1'));
  currentItemIndex = 0;
  for (var j_index in itemList) {
    j = itemList[j_index];
    if (j['current']) {
      currentItemIndex = itemList.indexOf(j) + 1;
      j['current'] = false;
    }
  }
  previousItem = itemList[((currentItemIndex - 1) - 1)];
  if (previousItem) {
    previousItem['current'] = true;
  } else {
    (itemList.slice(-1)[0])['current'] = true;
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/5741032c5bc8e709d218926d5fc6ca07/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentItem, item;

function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'mediaMessages')) {
    currentItem = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'mediaMessages')), async (item) => {


     return ((getObjectProperty(item, 'current')) == true);
    }))[0];
    return ([(getObjectProperty(___arguments.context.pageData, 'mediaMessages')).indexOf(currentItem) + 1,'/',(getObjectProperty(___arguments.context.pageData, 'mediaMessages')).length].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/20caf2e5080a4bdca666ecc304961efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8968a8769b41fc3e6ad822d8ff0d0c75', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/1403f1347411c92ad1ac3f85633ed0b3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name'));
    } else {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/0e1d900704dd8c2c3d319fe85b9e8bef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0e1d900704dd8c2c3d319fe85b9e8bef')).includes('current')) {
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0e1d900704dd8c2c3d319fe85b9e8bef')), 'current');
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')), 'active');
    }
    ___arguments.context.pageData['currentTab'] = 'invitations';
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active')) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).pop();
    }
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('277906747a937508979688e3044a31ce')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('277906747a937508979688e3044a31ce', false);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'invitations') {
    return ['messages__tabsBtn', 'current'];
  }

  return ['messages__tabsBtn']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/6553c1191ba9a6e56e9f5f3cbc7922af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6553c1191ba9a6e56e9f5f3cbc7922af')).includes('current')) {
  } else {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')), 'active');
    }
    ___arguments.context.pageData['currentTab'] = 'chats';
    ___arguments.context.pageData['unreadInvChatsCount'] = 0;
    ___arguments.context.pageData['newMessageCount'] = 0;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active')) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).pop();
    }
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6553c1191ba9a6e56e9f5f3cbc7922af')), 'current');
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('277906747a937508979688e3044a31ce')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('277906747a937508979688e3044a31ce', false);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'chats') {
    return ['messages__tabsBtn', 'current'];
  }

  return ['messages__tabsBtn']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/6702a3f8c207b336ecd19d6d51a6dd76/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'recentMessage')), 'receiver')), 'objectId')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'chatIsRead')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/e96d02d68b080cf24fd310f54ae74813/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'invitedActivities')) {
    return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'invitedActivities')).length);
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activeSpoiler'] = ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'otherAct' ? '' : 'otherAct');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'otherAct' ? ['messages__asideSpoiler', 'open'] : ['messages__asideSpoiler'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/2b2979e1c33b6e361a2e22985a7bf6bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'myActivities')) {
    return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'myActivities')).length);
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activeSpoiler'] = ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'myAct' ? '' : 'myAct');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'myAct' ? ['messages__asideSpoiler', 'open'] : ['messages__asideSpoiler'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/62cc0c5ea2b37ae83d1766c3c24d0d94/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, item, error, interlocutorId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function setInterlocutorCoverPhoto() {
  ___arguments.context.pageData['interlocutorImgUrl'] = null;
  interlocutorId = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'sender')), 'objectId')) : (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'receiver')), 'objectId'));
  ___arguments.context.pageData['interlocutorImgUrl'] = (await Backendless.Request.get(`${Backendless.appPath}/services/userProfileImg/UserProfileImg`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'userId': JSON.stringify(interlocutorId) }).send());
}


  try {
    ;(async () => {
        await setInterlocutorCoverPhoto();

    })();

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['counter'] = '';
  ___arguments.context.pageData['newMessage'] = '';
  if (!(getObjectProperty(___arguments.context.pageData, 'openMessage')) || (getObjectProperty(___arguments.context.pageData, 'openMessage.objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['noMoreMessages'] = false;
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = '100%';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613b611a25aa28f8d6a15151b82ff19a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', false);
    }
    ___arguments.context.dataModel['message'] = (await asyncListSort((getObjectProperty(___arguments.context.dataModel, 'message')), 1, async (item) => {


     return (getObjectProperty(item, 'created'));
    }));
    ___arguments.context.pageData['currentActivity'] = ___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793');
    ___arguments.context.pageData['openMessage'] = ___arguments.context.dataModel;
    (getObjectProperty(___arguments.context.pageData, 'openMessage'))['currentChatType'] = 'byMe';
    ___arguments.context.appData['openMessage'] = (getObjectProperty(___arguments.context.pageData, 'openMessage'));
    if (!(getObjectProperty(___arguments.context.dataModel, 'chatIsRead'))) {
      ___arguments.context.dataModel['chatIsRead'] = true;
      var j_list = (getObjectProperty(___arguments.context.dataModel, 'message'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
          j['isRead'] = true;
        }
      }
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'recentMessage')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        (getObjectProperty(___arguments.context.dataModel, 'recentMessage'))['isRead'] = true;
      }
      ___arguments.context.appData['messagesNumber'] = (await BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369']((getObjectProperty(___arguments.context.pageData, 'messages')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))));
      await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](___arguments.context.pageData);
    }
    localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
    await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))).set((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
    await new Promise(r => setTimeout(r, 300 || 0));
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
    }
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768 && (getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')) ? ['messages__activitiesItem--inner', 'open'] : ['messages__activitiesItem--inner'])

  },
  /* handler:onClassListAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/messages/components/42081544a91ea4ac81e463d9a50b7d8c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    
  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/a09b7b1159dea90c26a414ca31012b66/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    } else {
      return false;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/07234a032eb54ca893edce0bb582b2b5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    return (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'acceptedInvitation' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'acceptedRequest') && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'accepted');
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/90592f5df83b1f3ab9f8231e8051c5a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name'));
      } else {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login'));
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name'));
      } else {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login'));
      }
    }
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var profileId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    profileId = '';
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      profileId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId'));
    } else {
      profileId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': profileId }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/6a54e67ba6c395f96aeca202cd937041/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      return (String('@') + String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')));
    } else {
      return (String('@') + String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login')));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/33530c8fefcce30a39377cafc7f2280c/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if (getObjectProperty(___arguments.context.pageData, 'interlocutorImgUrl')) {
      return (getObjectProperty(___arguments.context.pageData, 'interlocutorImgUrl'));
    } else {
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail')) {
          return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail'));
        } else {
          return 'styles/img/placeholder_photo.png';
        }
      } else {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail')) {
          return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail'));
        } else {
          return 'styles/img/placeholder_photo.png';
        }
      }
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var profileId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    profileId = '';
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      profileId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId'));
    } else {
      profileId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': profileId }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/47e94bfaf83f69abb74b614c803f42f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) {
      return (['Accept ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')),'\'s request?'].join(''));
    } else {
      return (['Accept ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')),'\'s request?'].join(''));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/4eafc1632aefdbcc00cff33e24737eb1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'acceptedInvitation' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'acceptedRequest' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/8b19686a030ea4f4c6642a2277b2fc25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'acceptedInvitation' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'acceptedRequest') && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'accepted') {
      await new Promise(r => setTimeout(r, 300 || 0));
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/9dc7f6325fbe9578e0cf90372163b835/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_f19ee1336b67ca26c4d92a38762420fa'](___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/28ca6fea12d79a96f87476064a748d86/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && ((getObjectProperty(___arguments.context.dataModel, 'type')) == 'image' || (getObjectProperty(___arguments.context.dataModel, 'type')) == 'video')) {
    return ['messages__item', 'media', 'sent'];
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty(___arguments.context.dataModel, 'type')) == 'text') {
    return ['messages__item', 'sent'];
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && ((getObjectProperty(___arguments.context.dataModel, 'type')) == 'image' || (getObjectProperty(___arguments.context.dataModel, 'type')) == 'video')) {
    return ['messages__item', 'media'];
  }

  return ['messages__item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/9f22ff7521482d1a706d50d4c4aa05ec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'requestPermission') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/7906afbf3a91793fc71b83edea43edf6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) {
        return (String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) + String(' requested permissions to view your photos.'));
      } else {
        return (String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')) + String(' requested permissions to view your photos.'));
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) {
        return (['You requested permissions to view ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')),'’s photos'].join(''));
      } else {
        return (['You requested permissions to view ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login')),'’s photos'].join(''));
      }
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/02b7580d726ed03f19c367f48c9e6c89/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      return (['Until you accept or reject the request, ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')),' will not know that you read the message.'].join(''));
    } else {
      return (['You requested permissions to view ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')),' photos'].join(''));
    }
  }

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'received') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/00859164152b0d33d2168ec6ad5e4753/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail'));
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail'));
      }
    }
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/e2bf4d2997ff18c43bb96da68e96d0fe/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) {
        return ([(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')),' invited you to ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'gender')) == 'Female' ? 'her' : 'his',' activity.'].join(''));
      } else {
        return ([(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')),' invited you to ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'gender')) == 'Female' ? 'her' : 'his',' activity.'].join(''));
      }
    } else {
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation') {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) {
          return (['You invited ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')),' to your activity '].join(''));
        } else {
          return (['You invited ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login')),' to your activity '].join(''));
        }
      } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest') {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) {
          return (['You requested to join ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')),'’s activity'].join(''));
        } else {
          return (['You requested to join ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login')),'’s activity'].join(''));
        }
      } else {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) {
          return (['You invited ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')),' to your activity '].join(''));
        } else {
          return (['You invited ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login')),' to your activity '].join(''));
        }
      }
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/b5416f8f64cbdae8349ae85b4ea974f5/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail'));
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail'));
      }
    }
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/161a56ae44884b8a47fdf5890a4d34be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate')) {
      return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate'))));
    } else if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming'));
    } else {
      return 'To be scheduled';
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/e8e420fbbba1693895acf6e419a8e4f4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/d2cabcf4d25c2b2991443bcac0de3346/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'description'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/a628079f4903c3f7cb8a2353908c87ca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')),[`getChat`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/e5434c8ec9ad41f9868672f8c728f465/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/935326e4d434667d09165a29982b94c6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'accepted') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/4b865ee52c736a086b77e98148ed8175/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/f4d21145deeeb3ec57456db1c9576f65/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'rejected') {
      return true;
    } else {
      return false;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'reject','title': 'Reject chat?','text': ['Do you want to delete chat with ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')),' forever?'].join(''),'button': 'Reject','doneText': ['Done! You can always invite ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')),' once again to your activity.'].join(''),'doneButton': 'Thanks' });
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/9ae807e7f72312198c187b88d59d6b6b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/28616305d7db58dd8e0fc35f9f976ffe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'accepted') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/edb83ad88c9f08666989165dd8b85665/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/bc8337d766064b25aae73e46f5d138f5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'reject','title': 'Reject chat?','text': ['Do you want to delete chat with ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')),' forever?'].join(''),'button': 'Reject','doneText': ['Done! You can always invite ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')),' once again to your activity.'].join(''),'doneButton': 'Thanks' });
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/39eb72467532541258257d61de6435dd/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty(___arguments.context.pageData, 'currentActivity'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) && ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'driver' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'passenger')) {
      return 'Covers the expenses';
    } else {
      return 'Share the expenses';
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/aa6c11c95a25f1e23c01881f66e9ffd3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole'));
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/2d6a40f376d4bc234d63a8861aad7289/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  user = ({  });
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
    user = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver'));
  } else {
    user = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender'));
  }
  ___arguments.context.pageData['modalContent'] = ({ 'type': 'block ','title': ['Block ',(getObjectProperty(user, 'name')) ? (getObjectProperty(user, 'name')).split(' ')[0] : (getObjectProperty(user, 'login')),'?'].join(''),'text': String((getObjectProperty(user, 'name')) ? (getObjectProperty(user, 'name')).split(' ')[0] : (getObjectProperty(user, 'login'))) + String(' will not be able to see your activities anymore.'),'button': 'Block','doneText': ['You can find ',(getObjectProperty(user, 'name')) ? (getObjectProperty(user, 'name')).split(' ')[0] : (getObjectProperty(user, 'login')),' in the Block list if you change your mind.'].join(''),'doneButton': 'Got it' });
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/fa3e405694fd59771f1b416ff1047176/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'modalContent')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalContent')), 'title'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/a8f8b43809b53664008fb18d1d0a625c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (object == null || typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'modalContent')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalContent')), 'text'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/27292276b8a4ecdff87d30d618b5bf59/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  onLabelAssignment(___arguments) {
      if (___arguments.context.pageData['modalContent']) {
    return ((___arguments.context.pageData['modalContent'])['button']);
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var openMessageId, receiverId, item, plusOneId, blockedUserId, j;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function updateAppDataSender() {
  if (getObjectProperty(___arguments.context.appData, 'activityList')) {
    delete ___arguments.context.appData['activityList'];
  }
  if (getObjectProperty(___arguments.context.appData, 'users')) {
    delete ___arguments.context.appData['users'];
  }
  if (getObjectProperty(___arguments.context.appData, 'seenBy')) {
    ___arguments.context.appData['seenBy'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'seenBy')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')));
    }));
  }
  if (getObjectProperty(___arguments.context.appData, 'myLikes')) {
    ___arguments.context.appData['myLikes'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'myLikes')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')));
    }));
  }
}

/**
 * Describe this function...
 */
async function updateAppDataReceiver() {
  if (getObjectProperty(___arguments.context.appData, 'activityList')) {
    delete ___arguments.context.appData['activityList'];
  }
  if (getObjectProperty(___arguments.context.appData, 'users')) {
    delete ___arguments.context.appData['users'];
  }
  if (getObjectProperty(___arguments.context.appData, 'seenBy')) {
    ___arguments.context.appData['seenBy'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'seenBy')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')));
    }));
  }
  if (getObjectProperty(___arguments.context.appData, 'myLikes')) {
    ___arguments.context.appData['myLikes'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'myLikes')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')));
    }));
  }
}

/**
 * Describe this function...
 */
async function removeBlockedUserFromUI() {
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
    blockedUserId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
  } else {
    blockedUserId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId'));
  }
  await BackendlessUI.Functions.Custom['fn_341a41468d22574396fc05e34d8ab549'](blockedUserId, (getObjectProperty(___arguments.context.pageData, 'messages')));
  await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('blockUser', blockedUserId, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), null, null);
}

/**
 * Describe this function...
 */
async function removeChatFromUI() {
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'currentChatType')) == 'byMe') {
    var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['chats'] = (await asyncListFilter((getObjectProperty(j, 'chats')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
      }));
    }
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats'))['byMe'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe')), async (item) => {


     return (!!(getObjectProperty(item, 'chats')).length);
    }));
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'currentChatType')) == 'byOthers') {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats'))['byOthers'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byOthers')), async (item) => {


     return ((getObjectProperty((getObjectProperty(item, 'chat')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
    }));
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'currentChatType')) == 'received') {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['received'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) != (getObjectProperty(item, 'objectId')));
    }));
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'currentChatType')) == 'sent') {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['sent'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) != (getObjectProperty(item, 'objectId')));
    }));
  }
}

/**
 * Describe this function...
 */
async function getBlockedUser() {
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36eb0a37d4aabbc739d7b70d25852e56'))['display'] = 'flex';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open', '');
  }
  if (getObjectProperty(___arguments.context.pageData, 'modalContent')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalContent')), 'type')) == 'reject') {
      openMessageId = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId'));
      plusOneId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
      if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'requestPermission' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest') && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['received'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) != openMessageId);
        }));
        ___arguments.context.pageData['currentActivity'] = null;
        ___arguments.context.pageData['openMessage'] = null;
        ___arguments.context.appData['openMessage'] = null;
        ;(async () => {
            await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['objectId=\'',openMessageId,'\''].join('')),'changes': ({ [`status`]: 'rejected',[`statusUpdated`]: (new Date()) }) });
          await Backendless.Request.put(`${Backendless.appPath}/services/updateMessageStatus/updateMessageStatus`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['chatId=\'',openMessageId,'\''].join('')),'changes': ({ [`isRead`]: true }) });
          await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('rejectReceivedRequst', plusOneId, null, openMessageId, null);

        })();
      } else {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['sent'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) != openMessageId);
        }));
        ___arguments.context.pageData['currentActivity'] = null;
        ___arguments.context.pageData['openMessage'] = null;
        ___arguments.context.appData['openMessage'] = null;
        ;(async () => {
            await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['chatId=\'',openMessageId,'\''].join('')),'tableName': 'Message' });
          await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['objectId=\'',openMessageId,'\''].join('')),'tableName': 'Chat' });

        })();
      }
      ___arguments.context.pageData['messagesNumber'] = (getObjectProperty(___arguments.context.pageData, 'countMessage'));
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
        removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open', '');
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = 'auto';
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613b611a25aa28f8d6a15151b82ff19a', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', true);
      }
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalContent')), 'type')) == 'withdraw') {
      openMessageId = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId'));
      receiverId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId'));
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), ' type')) != 'requestPermission' && (getObjectProperty(___arguments.context.appData, 'userActivitiesForInvitation'))) {
        delete ___arguments.context.appData['userActivitiesForInvitation'];
      }
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['sent'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) != openMessageId);
      }));
      ___arguments.context.pageData['currentActivity'] = null;
      ___arguments.context.pageData['openMessage'] = null;
      ___arguments.context.appData['openMessage'] = null;
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).includes('open')) {
        removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open', '');
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = 'auto';
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613b611a25aa28f8d6a15151b82ff19a', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', true);
      }
      ;(async () => {
          await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('withdrawRequest', receiverId, null, openMessageId, null);
        await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['chatId=\'',openMessageId,'\''].join('')),'tableName': 'Message' });
        await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['objectId=\'',openMessageId,'\''].join('')),'tableName': 'Chat' });

      })();
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'modalContent')), 'type')) == 'delete') {
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),'\''].join('')),'changes': ({ [`deletedBySender`]: (new Date()) }) });
      } else {
        await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),'\''].join('')),'changes': ({ [`deletedByReceiver`]: (new Date()) }) });
      }
      await removeChatFromUI();
      ___arguments.context.pageData['currentActivity'] = null;
      ___arguments.context.pageData['openMessage'] = null;
      ___arguments.context.appData['openMessage'] = null;
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).includes('open')) {
        removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open', '');
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = 'auto';
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613b611a25aa28f8d6a15151b82ff19a', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', true);
      }
    } else {
      if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson'))) {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['blockListJson'] = [];
      }
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')));
        addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList')), ({ [`objectId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) }));
        await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': ([String(['(ownerId=\'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')),'\''].join('')) + String([' and receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\')'].join('')),' or ',String(['(ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) + String([' and receiver.objectId=\'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')),'\')'].join(''))].join('')),'changes': ({ [`isBlocked`]: true }) });
        await Backendless.Data.of('UserProfile').save( (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) );
        await updateAppDataSender();
        await Backendless.Data.of('UserProfile').addRelation((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender'))]);
      } else {
        addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')), (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')));
        addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList')), ({ [`objectId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) }));
        await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': ([String(['(ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) + String([' and receiver.objectId=\'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')),'\')'].join('')),' or ',String(['(ownerId=\'',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')),'\''].join('')) + String([' and receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\')'].join(''))].join('')),'changes': ({ [`isBlocked`]: true }) });
        await Backendless.Data.of('UserProfile').save( (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) );
        await updateAppDataReceiver();
        await Backendless.Data.of('UserProfile').addRelation((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver'))]);
      }
      ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
      localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
      await removeBlockedUserFromUI();
      ___arguments.context.pageData['currentActivity'] = null;
      ___arguments.context.pageData['openMessage'] = null;
      ___arguments.context.appData['openMessage'] = null;
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).includes('open')) {
        removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open', '');
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = 'auto';
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613b611a25aa28f8d6a15151b82ff19a', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', true);
      }
    }
  }
  await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))).delete();
  localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36eb0a37d4aabbc739d7b70d25852e56'))['display'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/baac8017300799683fc68d18ebb398a1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  user = ({  });
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
    user = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver'));
  } else {
    user = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender'));
  }
  ___arguments.context.pageData['modalContent'] = ({ 'type': 'reject','title': ['Reject ',(getObjectProperty(user, 'name')) ? (getObjectProperty(user, 'name')).split(' ')[0] : (getObjectProperty(user, 'login')),' from Activity?'].join(''),'text': ['Do you want to reject ',(getObjectProperty(user, 'name')) ? (getObjectProperty(user, 'name')).split(' ')[0] : (getObjectProperty(user, 'login')),' from activity and delete chat forever?'].join(''),'button': 'Reject','doneText': ['Done! You can always invite ',(getObjectProperty(user, 'name')) ? (getObjectProperty(user, 'name')).split(' ')[0] : (getObjectProperty(user, 'login')),' once again to your activity.'].join(''),'doneButton': 'Thanks' });
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    var user;


  if (___arguments.context.pageData['currentActivity']) {
    if (((___arguments.context.pageData['currentActivity'])['authorObjectId']) == ((___arguments.context.pageData['currentUser'])['objectId'])) {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/175ca55ed7c8c6a1f415cb4b9038ce38/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'block','title': ['Block ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')),'?'].join(''),'text': String((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login'))) + String(' will not be able to see your activities anymore.'),'button': 'Block','doneText': ['You can find ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')),' in the Block list if you change your mind.'].join(''),'doneButton': 'Got it' });
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/cb5ca5c49b1354cc7467a7f20972bae8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'reject','title': 'Reject chat?','text': 'If you reject this invitation, it will be permanently deleted','button': 'Reject','doneText': ['Done! You can always invite ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')),' once again to your activity.'].join(''),'doneButton': 'Thanks' });
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/42e8f3bee3ce810f8eb3a6b1972850ed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'reject','title': 'Reject invitation?','text': 'If you reject this invitation, it will be permanently deleted','button': 'Reject','doneText': 'Done!','doneButton': 'Thanks' });
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/64ee9ebc59c655c7788842671414003e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'reject','title': 'Reject request?','text': 'If you reject request we will delete it from the list of requests.','button': 'Reject','doneText': 'Done!','doneButton': 'Thanks' });
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/1373611e32f7eb4be9d5c02af7f8c301/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/14f94cc9bf756a8b2fe6eed65d62644a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, item, name2, notifyText, activityName, user, sendPush, currentChat, newChat;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function sendPushNotification() {
  ;(async () => {
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      user = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
    } else {
      user = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId'));
    }
    await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('replies', notifyText, 'messages', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')), user, null, null, null);

  })();
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function changeUI() {
  if (((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe')).map(item => item['objectId'])).includes((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')))) {
    newChat = (getObjectProperty(___arguments.context.pageData, 'openMessage'));
    delete newChat['currentActivity'];
    delete newChat['currentChatType'];
    currentChat = newChat;
    var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')) == (getObjectProperty(j, 'objectId'))) {
        (getObjectProperty(j, 'chats')).unshift(newChat);
        break;
      }
    }
  } else {
    newChat = ({ [`chats`]: [(getObjectProperty(___arguments.context.pageData, 'openMessage'))],[`name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name')),[`activityDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate')),[`description`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'description')),[`financialRole`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')),[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ownerId')),[`ongoingTiming`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming')) });
    delete ((getObjectProperty(newChat, 'chats'))[0])['currentActivity'];
    delete ((getObjectProperty(newChat, 'chats'))[0])['currentChatType'];
    (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe')).unshift(newChat);
    currentChat = (getObjectProperty(newChat, 'chats'))[0];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['received'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
  }));
  ___arguments.context.pageData['currentTab'] = 'chats';
  ___arguments.context.pageData['activeSpoiler'] = 'myAct';
  ___arguments.context.pageData['selectedAct'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId'));
  ___arguments.context.pageData['openMessage'] = currentChat;
  (getObjectProperty(___arguments.context.pageData, 'openMessage'))['currentChatType'] = 'byMe';
  ___arguments.context.appData['openMessage'] = (getObjectProperty(___arguments.context.pageData, 'openMessage'));
  await new Promise(r => setTimeout(r, 300 || 0));
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
}


  await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),'\''].join('')),'changes': ({ [`status`]: 'accepted',[`type`]: 'acceptedInvitation',[`statusUpdated`]: (new Date()) }) });
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).includes('block')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).splice(((((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')).indexOf('block') + 1) - 1), 1);
  }
  name2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login'));
  activityName = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name')) ? ['"',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name')),'"'].join('') : null;
  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation') {
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'gender')) {
      notifyText = [activityName,' - ',name2,' has accepted your request to join this activity.'].join('');
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest') {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'gender')) == 'Female') {
      notifyText = [name2,' has accepted your request to join her at ',activityName].join('');
    } else if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'gender')) == 'Male') {
      notifyText = [name2,' has accepted your request to join his at ',activityName].join('');
    } else {
      notifyText = [name2,'  has accepted your request to join their at ',activityName].join('');
    }
  } else {
    notifyText = String(name2) + String(' has approved your photo request!');
  }
  (getObjectProperty(___arguments.context.pageData, 'openMessage'))['status'] = 'accepted';
  (getObjectProperty(___arguments.context.pageData, 'openMessage'))['type'] = 'acceptedInvitation';
  await Backendless.Request.put(`${Backendless.appPath}/services/updateMessageStatus/updateMessageStatus`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': ((await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')).map(async item => {; return (['objectId=\'',(getObjectProperty(item, 'objectId')),'\''].join(''));}))).join(' or ')),'changes': ({ [`isRead`]: true }) });
  ___arguments.context.pageData['messagesNumber'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getCount/getCount`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      j['isRead'] = true;
    }
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
  }
  await changeUI();
  await sendPushNotification();
  ;(async () => {
      await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('acceptedActivityRequest', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')), null, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')), null);
    if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
      if ((await Backendless.Request.get(`${Backendless.appPath}/services/isLocationPrivate/isLocationPrivate`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'activityId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId'))) }).send())) {
        await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('unBlockActivityLocation', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')), null, null, null);
      }
    }

  })();
  localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/ae720be69e43105a2519f52890c49713/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/ffcf698ae37f155b683315224795c04a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/f177bcc285f9511d21e445f7118ee249/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/f8a9eda4b2ce71cb7f1f02d288da5203/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, newMessage, currentSenderChatId, receiverId, newMessageInput;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  newMessageInput = (getObjectProperty(___arguments.context.pageData, 'newMessage'));
  if (!newMessageInput || newMessageInput.trim() == '') {
    return ;
  }
  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    receiverId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
    newMessage = ({ [`chatId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),[`message`]: newMessageInput,[`sender`]: ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) }),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),[`receiver`]: ({ [`objectId`]: receiverId }),[`type`]: 'text',[`created`]: ((new Date()).valueOf()),[`isRead`]: false });
    addItemToList((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')), newMessage);
    ___arguments.context.pageData['newMessage'] = '';
    ___arguments.context.pageData['counter'] = '';
    (getObjectProperty(___arguments.context.pageData, 'openMessage'))['recentMessage'] = newMessage;
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
      await new Promise(r => setTimeout(r, 1 || 0));
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
    }
    try {
      await Backendless.Messaging.publish('default', newMessage, new Backendless.PublishOptions({ subtopic: '', headers: ({ [`chatId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),[`receiverId`]: receiverId }) }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
      currentSenderChatId = (await Backendless.Hive('CurrentUserChat').KeyValueStore(receiverId).get());
      if (currentSenderChatId == null || currentSenderChatId != (getObjectProperty(newMessage, 'chatId'))) {
        await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('message', (String('New message from ') + String(getObjectProperty(newMessage, 'senderName'))), 'messages', (getObjectProperty(newMessage, 'chatId')), (getObjectProperty((getObjectProperty(newMessage, 'receiver')), 'objectId')), null, null, null);
      }

    } catch (error) {
      console.log(error);

    }
  }
  localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('message_sent');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/f2eaef554bbdc4fd45cfc7738ddb1c16/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var openMessageId, senderId, receiverId, user, sendPush, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function sendPushNotification() {
  ;(async () => {
      if (receiverId == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      user = senderId;
    } else {
      user = receiverId;
    }
    await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('replies', (String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' has approved your photo request! ')), 'messages', openMessageId, user, null, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), null);

  })();
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function changeUI() {
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['received'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
  }));
}


  if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'chatIsRead'))) {
    ___arguments.context.appData['messagesNumber'] = ((getObjectProperty(___arguments.context.appData, 'messagesNumber')) - 1);
    await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](___arguments.context.pageData);
    (getObjectProperty(___arguments.context.pageData, 'openMessage'))['chatIsRead'] = true;
  }
  (getObjectProperty(___arguments.context.pageData, 'openMessage'))['status'] = 'accepted';
  await Backendless.Data.of('UserProfile').addRelation((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'hasPermission', [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender'))]);
  await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),'\''].join('')),'changes': ({ [`status`]: 'accepted',[`statusUpdated`]: (new Date()) }) });
  await changeUI();
  receiverId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId'));
  senderId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
  openMessageId = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId'));
  await sendPushNotification();
  await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('acceptedRequestPermission', senderId, null, openMessageId, null);
  localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/94bcc5b10957c93ae6ab46fcd6458ba7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var savedCurrentActivity, item, j, chatType, name2, notifyText, activityName, user, sendPush, chat, newChat;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function sendPushNotification() {
  ;(async () => {
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      user = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
    } else {
      user = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId'));
    }
    await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('replies', notifyText, 'messages', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')), user, null, null, null);

  })();
}

/**
 * Describe this function...
 */
async function changeUI() {
  newChat = ({ [`chat`]: (getObjectProperty(___arguments.context.pageData, 'openMessage')),[`name`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name')),[`activityDate`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'activityDate')),[`description`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'description')),[`financialRole`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')),[`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')),[`ownerId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ownerId')),[`ongoingTiming`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ongoingTiming')) });
  delete (getObjectProperty(newChat, 'chat'))['currentActivity'];
  delete (getObjectProperty(newChat, 'chat'))['currentChatType'];
  if (chatType == 'invitation') {
    (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byOthers')).unshift(newChat);
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['received'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
    }));
    ___arguments.context.pageData['currentTab'] = 'chats';
    ___arguments.context.pageData['activeSpoiler'] = ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'otherAct' ? '' : 'otherAct');
    chat = (getObjectProperty(newChat, 'chat'));
    chat['activityId'] = (getObjectProperty(newChat, 'objectId'));
    ___arguments.context.pageData['currentActivity'] = newChat;
    ___arguments.context.pageData['openMessage'] = chat;
    (getObjectProperty(___arguments.context.pageData, 'openMessage'))['currentChatType'] = 'byOthers';
    ___arguments.context.appData['openMessage'] = (getObjectProperty(___arguments.context.pageData, 'openMessage'));
    await new Promise(r => setTimeout(r, 300 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
  }
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'keepLocationPrivate')) {
      delete ___arguments.context.appData['activityList'];
    }
  }
  name2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login'));
  activityName = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name')) ? ['"',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name')),'"'].join('') : null;
  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation') {
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'gender')) {
      notifyText = [activityName,' - ',name2,' has accepted your request to join this activity.'].join('');
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest') {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'gender')) == 'Female') {
      notifyText = [name2,' has accepted your request to join her at ',activityName].join('');
    } else if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'gender')) == 'Male') {
      notifyText = [name2,' has accepted your request to join his at ',activityName].join('');
    } else {
      notifyText = [name2,'  has accepted your request to join their at ',activityName].join('');
    }
  } else {
    notifyText = String(name2) + String(' has approved your photo request!');
  }
  await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),'\''].join('')),'changes': ({ [`status`]: 'accepted',[`type`]: 'acceptedInvitation',[`statusUpdated`]: (new Date()) }) });
  await Backendless.Request.put(`${Backendless.appPath}/services/updateMessageStatus/updateMessageStatus`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['objectId=\'',(getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'))[0]), 'objectId')),'\''].join('')),'changes': ({ [`isRead`]: true }) });
  chatType = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type'));
  (getObjectProperty(___arguments.context.pageData, 'openMessage'))['status'] = 'accepted';
  (getObjectProperty(___arguments.context.pageData, 'openMessage'))['type'] = 'acceptedInvitation';
  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      j['isRead'] = true;
    }
  }
  await changeUI();
  if (getObjectProperty(___arguments.context.appData, 'activityList')) {
    savedCurrentActivity = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'activityList')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')));
    }))[0];
    if (savedCurrentActivity) {
      if (getObjectProperty(savedCurrentActivity, 'keepLocationPrivate')) {
        delete ___arguments.context.appData['activityList'];
      }
    }
  }
  await sendPushNotification();
  ;(async () => {
      await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('acceptedInvitation', (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')), null, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')), null);

  })();
  localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/41171da31a5e0151cbeab5a446f31d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')) {
      if (!!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')).length) {
        return (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'))[0]), 'message'));
      }
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/c6d72883b395de8975cece176529f82c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')) {
      if (!!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')).length) {
        return (await BackendlessUI.Functions.Custom['fn_f19ee1336b67ca26c4d92a38762420fa'](((await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')), 1, async (item) => {


         return (getObjectProperty(item, 'created'));
        }))[0])));
      }
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/49096b92542f1bb284934ebf62a9245b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, chat, item, error, interlocutorId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function setInterlocutorCoverPhoto() {
  ___arguments.context.pageData['interlocutorImgUrl'] = null;
  interlocutorId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'chat')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'chat')), 'sender')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'chat')), 'receiver')), 'objectId'));
  ___arguments.context.pageData['interlocutorImgUrl'] = (await Backendless.Request.get(`${Backendless.appPath}/services/userProfileImg/UserProfileImg`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'userId': JSON.stringify(interlocutorId) }).send());
}


  try {
    ;(async () => {
        await setInterlocutorCoverPhoto();

    })();

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['counter'] = '';
  ___arguments.context.pageData['newMessage'] = '';
  chat = (getObjectProperty(___arguments.context.dataModel, 'chat'));
  chat['message'] = (await asyncListSort((getObjectProperty(chat, 'message')), 1, async (item) => {


   return (getObjectProperty(item, 'created'));
  }));
  chat['activityId'] = (getObjectProperty(___arguments.context.dataModel, 'objectId'));
  if (!(getObjectProperty(___arguments.context.pageData, 'openMessage')) || (getObjectProperty(___arguments.context.pageData, 'openMessage.objectId')) != (getObjectProperty(chat, 'objectId'))) {
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['noMoreMessages'] = false;
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = '100%';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613b611a25aa28f8d6a15151b82ff19a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', false);
    }
    ___arguments.context.pageData['currentActivity'] = ___arguments.context.dataModel;
    ___arguments.context.pageData['openMessage'] = chat;
    (getObjectProperty(___arguments.context.pageData, 'openMessage'))['currentChatType'] = 'byOthers';
    ___arguments.context.appData['openMessage'] = (getObjectProperty(___arguments.context.pageData, 'openMessage'));
    if (!(getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'chat')), 'chatIsRead'))) {
      (getObjectProperty(___arguments.context.dataModel, 'chat'))['chatIsRead'] = true;
      var j_list = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'chat')), 'message'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
          j['isRead'] = true;
        }
      }
      if ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'chat')), 'recentMessage')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'chat')), 'recentMessage'))['isRead'] = true;
      }
      ___arguments.context.appData['messagesNumber'] = (await BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369']((getObjectProperty(___arguments.context.pageData, 'messages')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))));
      await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](___arguments.context.pageData);
    }
    await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))).set((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
    localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
    await new Promise(r => setTimeout(r, 300 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'chat')), 'objectId'))) {
        return ['messages__activitiesItem', 'open'];
      }
    }
  }

  return ['messages__activitiesItem']

  },
  /* handler:onClassListAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var chat, unreadInvChatsCount;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/messages/components/5f3f84bab07cdf1c8c6d7df10918fec8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'recentMessage')), 'type')) == 'text') {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'recentMessage')), 'message'));
  } else {
    return 'Media';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/381a94360597cb1837356c8efb3a303b/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      return ['messages__item', 'sent'];
    }
  }

  return ['messages__item']

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/3df5f22810332d6edd5d25cfc88eb897/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var previousMessage, previousMessageIdx, messageArray;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')) && !!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')).length && ___arguments.context.dataModel) {
    messageArray = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'));
    previousMessageIdx = (messageArray.indexOf(___arguments.context.dataModel) + 1) - 1;
    previousMessage = messageArray[(previousMessageIdx - 1)];
    if (!previousMessage || ((new Date((getObjectProperty(previousMessage, 'created')))).toDateString()) != ((new Date((getObjectProperty(___arguments.context.dataModel, 'created')))).toDateString())) {
      if (((new Date()).toDateString()) == ((new Date((getObjectProperty(___arguments.context.dataModel, 'created')))).toDateString())) {
        return 'Today';
      } else if ((new Date((new Date())).getMonth()) == (new Date((new Date((getObjectProperty(___arguments.context.dataModel, 'created'))))).getMonth()) && (new Date((new Date())).getFullYear()) == (new Date((new Date((getObjectProperty(___arguments.context.dataModel, 'created'))))).getFullYear())) {
        if ((new Date((new Date())).getDate()) - (new Date((new Date((getObjectProperty(___arguments.context.dataModel, 'created'))))).getDate()) == 1) {
          return 'Yesterday';
        } else {
          return ((new Date((getObjectProperty(___arguments.context.dataModel, 'created')))).toDateString());
        }
      } else {
        return ((new Date((getObjectProperty(___arguments.context.dataModel, 'created')))).toDateString());
      }
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/983cd5878ac535b43946e75f4c5a86e3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var previousMessage, previousMessageIdx, messageArray;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && !(getObjectProperty(___arguments.context.pageData, 'openMessage.chatIsRead')) && (getObjectProperty(___arguments.context.dataModel, 'receiver'))) {
    messageArray = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'));
    if (messageArray) {
      previousMessageIdx = (messageArray.indexOf(___arguments.context.dataModel) + 1) - 1;
      previousMessage = messageArray[(previousMessageIdx - 1)];
      if (!previousMessage || (getObjectProperty((getObjectProperty(previousMessage, 'receiver')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) || (getObjectProperty(previousMessage, 'isRead')) != (getObjectProperty(___arguments.context.dataModel, 'isRead'))) {
        if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty(___arguments.context.dataModel, 'isRead')) == false) {
          return true;
        } else {
          return false;
        }
      }
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/cb31993fa61617e16d95cab8496ecde8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var message, item;

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/7979ba2576c4372adabf7e5ad59bc96e/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail'));
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail'));
      }
    }
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/eb55a2c4b313e5198adf93a87d3356f9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')) {
        return ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name'))].join('') : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'name')));
      } else {
        return ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name'))].join('') : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'login')));
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) {
        return ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name'))].join('') : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')));
      } else {
        return ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) ? [(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login')),' - ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name'))].join('') : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login')));
      }
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/bfa8286f3a414eda1dd11ab25654b152/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'openMessage')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/da1b531f95f3628bb38377b28419f33a/bundle.js', [], () => ({
  /* content */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var ids, user, settings, newMessage, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (___arguments.keyCode == 13) {
    ___arguments.context.pageData['new'] = true;
    try {
      if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
        newMessage = ({ 'chatId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),'message': (getObjectProperty(___arguments.context.pageData, 'newMessage')),'sender': ({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) }),'senderName': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),'receiver': ({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'senderObjectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiverObjectId')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'senderObjectId')) }),'type': 'text' });
        addItemToList((getObjectProperty(___arguments.context.pageData, 'openMessage')), newMessage);
        console.log(getObjectProperty(___arguments.context.pageData, 'openMessage'));
        ___arguments.context.pageData['newMessage'] = '';
        await Backendless.Messaging.publish('default', newMessage, new Backendless.PublishOptions({ subtopic: '', headers: ({ 'chatId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) }) }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
        if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
          user = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
          settings = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'senderSettings'));
        } else {
          user = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId'));
          settings = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiverSettings'));
        }
        if (!settings || !(getObjectProperty(settings, 'notifications')) || ((getObjectProperty(settings, 'notifications')).includes('replies')) || ((getObjectProperty(settings, 'notifications')).includes('message'))) {
          ___arguments.context.pageData['device'] = (await Backendless.Data.of('DeviceRegistration').find(Backendless.DataQueryBuilder.create().setWhereClause((['user.objectId=\'',user,'\''].join(''))).setRelationsDepth(1).setSortBy('created desc').setPageSize(100)));
          ids = ((getObjectProperty(___arguments.context.pageData, 'device')).map(item => item['deviceId']));
          if (ids && !!ids.length) {
            await Backendless.Messaging.publish('push', (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), new Backendless.PublishOptions({ 'headers': Object.assign({ 'android-ticker-text': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), 'android-content-title': 'FindMy+1', 'android-content-text': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), 'ios-alert': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))), 'ios-badge': (String('New message from ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) }, ({ 'ios-alert-title': 'FindMy+1' }))  }), new Backendless.DeliveryOptions({ 'pushSinglecast': ids  }));
          }
        }
        if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
        }
      }

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onKeyDown */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768 && (getObjectProperty(___arguments.context.pageData, 'isMobile'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0f65ab42e18eb9727b663f2c7495a9ae'))['margin-bottom'] = '50vh';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('07234a032eb54ca893edce0bb582b2b5'))['margin-bottom'] = '50vh';
    await new Promise(r => setTimeout(r, 100 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0f65ab42e18eb9727b663f2c7495a9ae'))['margin-bottom'] = 'auto';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('07234a032eb54ca893edce0bb582b2b5'))['margin-bottom'] = 'auto';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/messages/components/2c1ec29922918eb39a1afdd394d88511/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceAssignment */
  ['onSourceAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86'), 'type')) == 'video') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86'), 'message'));
  }

  },
  /* handler:onSourceAssignment */
  /* content */
}))

define('./pages/messages/components/b289739c7f29dd4bdbec5601d315b984/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86'), 'type')) == 'image')

  },
  /* handler:onDisplayAssignment */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86'), 'type')) == 'image') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86'), 'message'));
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, mediaList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    mediaList = (await Backendless.Request.get(`${Backendless.appPath}/services/getMessages/getMediaMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'chatId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId'))) }).send());
    ___arguments.context.pageData['mediaMessages'] = (await Promise.all(mediaList.map(async item => {  if ((getObjectProperty(item, 'message')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86'), 'message'))) {
        item['current'] = true;
      } else {
        item['current'] = false;
      }
    ; return item;})));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8968a8769b41fc3e6ad822d8ff0d0c75', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/5f892b1e713cc90fb082fcec98789e68/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86'), 'type')) == 'text')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/736c44feb60b2c27d8717949bb7172b9/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var error, newMessage, currentSenderChatId, receiverId, format, video, moderationResult;

function subsequenceFromStartLast(sequence, at1) {
  var start = at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  video = ['.mov', '.mp4', '.mpeg4', '.wmv', '.flv', '.avi', '.mkv'];
  format = subsequenceFromStartLast(___arguments.uploadedFiles, ((___arguments.uploadedFiles.lastIndexOf('.') + 1) - 1)).trim();
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dfae363cfa6cd20cdeecbf5517e3098f', true);
    moderationResult = (await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(___arguments.uploadedFiles) }).send());
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dfae363cfa6cd20cdeecbf5517e3098f', false);
    if (moderationResult == 'KO') {
      (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('da1259ce1eb992c346a5da8578a99a04', ({ [`showRejectMsg`]: true }));
      ;(async () => {
          await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));

      })();
      return ;
    }

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dfae363cfa6cd20cdeecbf5517e3098f', false);
    ;(async () => {
        await Backendless.Files.remove(encodePath(___arguments.uploadedFiles));

    })();
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));
    return ;

  } finally {
    ___arguments.context.pageData['loadingMediaVisible'] = false;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('736c44feb60b2c27d8717949bb7172b9');

  }
  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    ___arguments.context.pageData['isCurrentMessage'] = true;
    receiverId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
    newMessage = ({ [`chatId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),[`message`]: ___arguments.uploadedFiles,[`sender`]: ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) }),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),[`receiver`]: ({ [`objectId`]: receiverId }),[`type`]: (video.includes(format)) ? 'video' : 'image' });
    ___arguments.context.pageData['newMessage'] = '';
    try {
      newMessage['created'] = ((new Date()).valueOf());
      newMessage['isRead'] = false;
      addItemToList((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')), newMessage);
      (getObjectProperty(___arguments.context.pageData, 'openMessage'))['recentMessage'] = newMessage;
      await Backendless.Messaging.publish('default', newMessage, new Backendless.PublishOptions({ subtopic: '', headers: ({ [`chatId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),[`receiverId`]: receiverId }) }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
      currentSenderChatId = (await Backendless.Hive('CurrentUserChat').KeyValueStore(receiverId).get());
      if (currentSenderChatId == null || currentSenderChatId != (getObjectProperty(newMessage, 'chatId'))) {
        await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('message', (String('New message from ') + String(getObjectProperty(newMessage, 'senderName'))), 'messages', (getObjectProperty(newMessage, 'chatId')), (getObjectProperty((getObjectProperty(newMessage, 'receiver')), 'objectId')), null, null, null);
      }

    } catch (error) {
      console.log(error);

    }
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
    }
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('72a8e8bd3108304126e75675eed7bbc1', false);
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('736c44feb60b2c27d8717949bb7172b9');
  (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
  localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
  await new Promise(r => setTimeout(r, 6000 || 0));
  delete ___arguments.context.pageData['isCurrentMessage'];

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    return (String('/pictures/messages/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
  }

  },
  /* handler:onDirectoryAssignment */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var format, video, name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['loadingMediaVisible'] = true;
  name2 = (getObjectProperty((___arguments.files[0]), 'name'));
  video = ['.mov', '.mp4', '.mpeg4', '.wmv', '.flv', '.avi', '.mkv'];
  format = name2.slice(((name2.lastIndexOf('.') + 1) - 1), name2.length).trim();

  return ((video.includes(format)) ? ___arguments.files : (await (async function(files, width, percent) {
	for (let index = 0; index < files.length; index++) {
	  const file = files[index];

	  const fileName = file.name;

	  const content = await readFileAsDataURL(file);

	  const img = await getNewImage(content);

	  const elem = document.createElement('canvas');

	  const widthImage = !width ? img.width : img.width > width ? width : img.width
	  const scaleFactor = img.width > width ? width && width / img.width : 1
	  const heightImage = width ? img.height * scaleFactor : img.height;

	  elem.width = widthImage;
	  elem.height = heightImage;

	  const ctx = elem.getContext('2d');

	  ctx.drawImage(img, 0, 0, widthImage, heightImage);

	  const blob = await getCanvasBlob(ctx.canvas, percent);

	  const newFile = new File([blob], fileName, {
	    type: 'image/jpeg',
	    lastModified: Date.now()
	  })

	  files[index] = newFile;
	}

	async function readFileAsDataURL(file) {
	  const result = await new Promise((resolve) => {
	    const fileReader = new FileReader();

	    fileReader.onload = (e) => resolve(e.target.result);

	    fileReader.readAsDataURL(file);
	  })

	  return result
	}

	async function getNewImage(content) {
	  const result = await new Promise((resolve) => {
	    const img = new Image()

	    img.src = content

	    img.onload = () => resolve(img)
	  })

	  return result
	}

	async function getCanvasBlob(canvas, percent) {
	  const result = await new Promise((resolve) => {
	    canvas.toBlob((blob) => {
	      resolve(blob)
	    }, 'image/jpeg', percent)
	  })

	  return result
	}

	return files;
})(___arguments.files, 700, 80)))

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  onUploadFail(___arguments) {
      console.log(___arguments.error);

  },
  /* handler:onUploadFail */
  /* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.file, 'name')).toLowerCase())

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/messages/components/561cf7288d470375fb430c08dc515aac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/e0086643c9ea694544ce2fb9e4d3d313/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791'), 'current')) {
    return ['gallery__slider-image', 'messages-gallery', 'visible'];
  }

  return ['gallery__slider-image', 'messages-gallery']

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791'), 'type')) == 'video')

  },
  /* handler:onDisplayAssignment */
  /* handler:onSourceAssignment */
  onSourceAssignment(___arguments) {
      if ((___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791')['type']) == 'video') {
    return (___arguments.context.getComponentDataStoreByUid('0a02c5f2682307b5b2b7a67cf0772791')['message']);
  }

  },  
  /* handler:onSourceAssignment */
  /* handler:onControlsAssignment */
  onControlsAssignment(___arguments) {
      return true

  },  
  /* handler:onControlsAssignment */
  /* content */
}))

define('./pages/messages/components/48efcecab9411159f0946a0e22cc7631/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item, mediaList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  mediaList = (await Backendless.Data.of('Message').find(Backendless.DataQueryBuilder.create().setWhereClause((['chatId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86'), 'chatId')),'\''].join(''))).setHavingClause('type=\'image\' or type=\'video\'').setPageSize(100)));
  ___arguments.context.pageData['mediaMessages'] = (await Promise.all(mediaList.map(async item => {  if ((getObjectProperty(item, 'message')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('28ca6fea12d79a96f87476064a748d86'), 'message'))) {
      item['current'] = true;
    } else {
      item['current'] = false;
    }
  ; return item;})));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8968a8769b41fc3e6ad822d8ff0d0c75', true);
  console.log(getObjectProperty(___arguments.context.pageData, 'mediaMessages'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  async ['onTitleAssignment'](___arguments) {
    var messagesNumber, title;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.pageData, 'messages'))) {
    await new Promise(r => setTimeout(r, 100 || 0));
    messagesNumber = (await BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369']((getObjectProperty(___arguments.context.pageData, 'messages')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))));
    if (messagesNumber > 0) {
      return (['(',messagesNumber,') Messages'].join(''));
    }
  }

  return 'Messages'

  },
  /* handler:onTitleAssignment */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var item, sortList, moreMessages;

  },
  /* handler:onScroll */
  /* handler:onEnter */
  ['onEnter'](___arguments) {
    var error, isMessagesUpdated, lastUpdate, data, temp, App, channels, message, deletedChat, j, chatFound, item, command, filterResult, receiverName, newChatActivity, currentChat, activityName, popupText, receivedChat, senderName, isTargetUser, userForUpdate, updatedChatInfo, chatByMe, lastChatInfoUpdate, currentUser, newUserLikes, areLikesEnabled, activityForUpdate, chatItem, invitationItem;

  },
  /* handler:onEnter */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
    var list;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  getRTSubscriptions().remove('unBlockActivityLocationId');
  getRTSubscriptions().remove('RT_messages_listener');
  getRTSubscriptions().remove('newMessages2');
  getRTSubscriptions().remove('onlineStatus');
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
    if (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus')) {
      ___arguments.context.appData['chats'] = (getObjectProperty(___arguments.context.pageData, 'chats'));
      ___arguments.context.appData['activityMessages'] = (getObjectProperty(___arguments.context.pageData, 'activityMessages'));
    }
  }
  delete ___arguments.context.pageData['currentTab'];
  ___arguments.context.appData['messagesNumber'] = ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.pageData, 'messages')) ? (await BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369']((getObjectProperty(___arguments.context.pageData, 'messages')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')))) : null);
  if (getObjectProperty(___arguments.context.pageData, 'messages')) {
    localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
  }
  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))).delete();
  }
  ___arguments.context.appData['previousPage'] = 'messages';

  },
  /* handler:onLeave */
  /* handler:onResize */
  async ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 350 || 0));
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
    }
  }

  },
  /* handler:onResize */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var error, data, temp, App, notificationPermissionsStatus, channels, isMessagesUpdated, lastUpdate, message, deletedChat, j, chatFound, item, command, filterResult, receiverName, newChatActivity, currentChat, activityName, popupText, receivedChat, senderName, isTargetUser, userForUpdate, updatedChatInfo, chatByMe, lastChatInfoUpdate, currentUser, newUserLikes, areLikesEnabled, activityForUpdate, chatItem, invitationItem;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getDeviceSubscriptions() { return getSubscriptionsManager('deviceSubscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function startNativeListeners() {
  try {
    getDeviceSubscriptions().remove('onTapPushAction');
    await new Promise(r => setTimeout(r, 100 || 0));

    await (async function() {
      const callback = async (data) => {
          console.log('____onTapPushAction');
      temp = (getObjectProperty(data, 'data'));
      try {
        if (getObjectProperty(temp, 'chatId')) {
          console.log('============ Update shat from PushTab start ==========');
          ___arguments.context.pageData['onTapPushAction'] = true;
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36eb0a37d4aabbc739d7b70d25852e56'))['display'] = 'flex';
          if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')) {
            localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'messages')),[`lastUpdate`]: (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'lastUpdate')) + 1000 })));
          }
          ___arguments.context.pageData['messages'] = (await BackendlessUI.Functions.Custom['fn_2171da3dd0357b5cf3e53a779f8ad201']());
          ___arguments.context.pageData['getChat'] = (getObjectProperty(temp, 'chatId'));
          await BackendlessUI.Functions.Custom['fn_570c5ed578a4125bf0d767a52b1a63fc'](___arguments.context.appData, ___arguments.context.pageData);
          if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
            addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
            ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = '100%';
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', false);
            (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', false);
          }
          ___arguments.context.appData['messagesNumber'] = (await BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369']((getObjectProperty(___arguments.context.pageData, 'messages')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))));
          await new Promise(r => setTimeout(r, 500 || 0));
          (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
          ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36eb0a37d4aabbc739d7b70d25852e56'))['display'] = 'none';
          delete ___arguments.context.pageData['onTapPushAction'];
          console.log('============ Update chat from PushTab finisht ==========');
        } else if (getObjectProperty(temp, 'activeTab')) {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(temp, 'activeTab')) }));
        } else {
          (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(temp, 'page')), undefined);
        }

      } catch (error) {
        console.log(error);

      }

      };

      const eventName = 'onTapPushAction'

      if(!getDeviceSubscriptions().has('onTapPushAction')) {
        await BackendlessUI.DeviceAPI.addEventListener(eventName, callback)
      }

      getDeviceSubscriptions().add('onTapPushAction', () => BackendlessUI.DeviceAPI.removeEventListener(eventName, callback));
    })();

  } catch (error) {
    console.log(error);

  }
  try {
    getDeviceSubscriptions().remove('handleInactiveState');
    await new Promise(r => setTimeout(r, 100 || 0));

    await (async function() {
      const callback = async (data) => {
          console.log('_________________HANDLE_INACTIVE_STATE');
      await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))).delete();

      };

      const eventName = 'HANDLE_INACTIVE_STATE'

      if(!getDeviceSubscriptions().has('handleInactiveState')) {
        await BackendlessUI.DeviceAPI.addEventListener(eventName, callback)
      }

      getDeviceSubscriptions().add('handleInactiveState', () => BackendlessUI.DeviceAPI.removeEventListener(eventName, callback));
    })();

  } catch (error) {
    console.log(error);

  }
  try {
    getDeviceSubscriptions().remove('handleResumeState');
    await new Promise(r => setTimeout(r, 100 || 0));

    await (async function() {
      const callback = async (data) => {
          console.log('----------------HANDLE_RESUME_STATE');
      if (getObjectProperty(___arguments.context.appData, 'openMessage')) {
        await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))).set((getObjectProperty((getObjectProperty(___arguments.context.appData, 'openMessage')), 'objectId')));
      }
      if (!(getObjectProperty(___arguments.context.pageData, 'onTapPushAction'))) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36eb0a37d4aabbc739d7b70d25852e56'))['display'] = 'flex';
        if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')) {
          localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'messages')),[`lastUpdate`]: (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'lastUpdate')) + 1000 })));
        }
        ___arguments.context.pageData['messages'] = (await BackendlessUI.Functions.Custom['fn_2171da3dd0357b5cf3e53a779f8ad201']());
        if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
          ___arguments.context.pageData['getChat'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId'));
          await BackendlessUI.Functions.Custom['fn_570c5ed578a4125bf0d767a52b1a63fc'](___arguments.context.appData, ___arguments.context.pageData);
        }
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('36eb0a37d4aabbc739d7b70d25852e56'))['display'] = 'none';
        ___arguments.context.appData['messagesNumber'] = (await BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369']((getObjectProperty(___arguments.context.pageData, 'messages')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))));
      }
      await new Promise(r => setTimeout(r, 350 || 0));
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
      }

      };

      const eventName = 'HANDLE_RESUME_STATE'

      if(!getDeviceSubscriptions().has('handleResumeState')) {
        await BackendlessUI.DeviceAPI.addEventListener(eventName, callback)
      }

      getDeviceSubscriptions().add('handleResumeState', () => BackendlessUI.DeviceAPI.removeEventListener(eventName, callback));
    })();

  } catch (error) {
    console.log(error);

  }
  await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('ON_TAP_EVENT_INITIALIZED', undefined);
}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

/**
 * Describe this function...
 */
async function getUser() {
  if (getObjectProperty(___arguments.context.appData, 'currentUser')) {
    ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  } else if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
    ___arguments.context.pageData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
  }
  if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList'))) {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['blockList'] = [];
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

/**
 * Describe this function...
 */
async function getNewMessage() {
  getRTSubscriptions().remove('newMessages2');

  ;(function(selector) {
    const callback = async message => {
        chatFound = false;
    var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      var item_list = (getObjectProperty(j, 'chats'));
      for (var item_index in item_list) {
        item = item_list[item_index];
        if ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(message, 'message')), 'chatId'))) {
          (getObjectProperty(item, 'message')).push((getObjectProperty(message, 'message')));
          if (!(getObjectProperty(___arguments.context.pageData, 'openMessage')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) != (getObjectProperty(item, 'objectId'))) {
            item['chatIsRead'] = false;
          } else {
            item['chatIsRead'] = true;
            (getObjectProperty(message, 'message'))['isRead'] = true;
            ;(async () => {
                await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](___arguments.context.pageData);

            })();
          }
          item['recentMessage'] = (getObjectProperty(message, 'message'));
          chatFound = true;
          break;
        }
      }
    }
    var j_list2 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byOthers'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      if ((getObjectProperty((getObjectProperty(j, 'chat')), 'objectId')) == (getObjectProperty((getObjectProperty(message, 'message')), 'chatId'))) {
        (getObjectProperty((getObjectProperty(j, 'chat')), 'message')).push((getObjectProperty(message, 'message')));
        if (!(getObjectProperty(___arguments.context.pageData, 'openMessage')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) != (getObjectProperty((getObjectProperty(j, 'chat')), 'objectId'))) {
          (getObjectProperty(j, 'chat'))['chatIsRead'] = false;
        } else {
          (getObjectProperty(j, 'chat'))['chatIsRead'] = true;
          (getObjectProperty(message, 'message'))['isRead'] = true;
          ;(async () => {
              await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](___arguments.context.pageData);

          })();
        }
        (getObjectProperty(j, 'chat'))['recentMessage'] = (getObjectProperty(message, 'message'));
        chatFound = true;
        break;
      }
    }
    if (!chatFound) {
      deletedChat = (await Backendless.Request.get(`${Backendless.appPath}/services/getChats/getChat`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'chatId': JSON.stringify((getObjectProperty((getObjectProperty(message, 'message')), 'chatId'))) }).send());
      if (getObjectProperty(deletedChat, 'chats')) {
        ((getObjectProperty(deletedChat, 'chats'))[0])['message'] = [(getObjectProperty(message, 'message'))];
        ((getObjectProperty(deletedChat, 'chats'))[0])['recentMessage'] = (getObjectProperty(message, 'message'));
        ((getObjectProperty(deletedChat, 'chats'))[0])['chatIsRead'] = (getObjectProperty((getObjectProperty(message, 'message')), 'isRead'));
        var j_list3 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe'));
        for (var j_index3 in j_list3) {
          j = j_list3[j_index3];
          if ((getObjectProperty(j, 'objectId')) == (getObjectProperty(deletedChat, 'objectId'))) {
            (getObjectProperty(j, 'chats')).unshift((getObjectProperty(deletedChat, 'chats'))[0]);
            return ;
          }
        }
        (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe')).unshift(deletedChat);
      } else {
        (getObjectProperty(deletedChat, 'chat'))['message'] = [(getObjectProperty(message, 'message'))];
        (getObjectProperty(deletedChat, 'chat'))['recentMessage'] = (getObjectProperty(message, 'message'));
        (getObjectProperty(deletedChat, 'chat'))['chatIsRead'] = (getObjectProperty((getObjectProperty(message, 'message')), 'isRead'));
        (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byOthers')).unshift(deletedChat);
      }
    }
    ___arguments.context.appData['messagesNumber'] = (await BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369']((getObjectProperty(___arguments.context.pageData, 'messages')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))));
    if (!(getObjectProperty(___arguments.context.pageData, 'openMessage')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) != (getObjectProperty((getObjectProperty(message, 'headers')), 'chatId'))) {
      if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) || !(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')) || !(getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')) || ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')).includes('replies')) || ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')).includes('message'))) {
        if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('BROWSER')) {
          await BackendlessUI.Functions.Custom['fn_a54cd48df219fcf28293b9e3e089975d'](___arguments.context.appData, ___arguments.context.pageData, (getObjectProperty((getObjectProperty(message, 'headers')), 'chatId')), (String('You have a new message from ') + String(getObjectProperty((getObjectProperty(message, 'message')), 'senderName'))));
        }
      }
    }
    (function (component) { component.el.scrollIntoView() })((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) ? ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) : null));
    if (getObjectProperty(___arguments.context.pageData, 'messages')) {
      localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
    }

    };

    const channel = getChannelInstance('default');

    const options = [callback];

    if (selector) {
       options.unshift(selector);
    }

    channel.addMessageListener.apply(channel, options);

    getRTSubscriptions().add('newMessages2', () => channel.removeMessageListener.apply(channel, options));
  })((['receiverId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')));
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function RT_messages_listener() {
  getRTSubscriptions().remove('RT_messages_listener');

  ;(function() {
    const callback = async command => {
        if (Array.isArray((getObjectProperty((getObjectProperty(command, 'data')), 'targetUserId')))) {
      isTargetUser = ((getObjectProperty((getObjectProperty(command, 'data')), 'targetUserId')).includes((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))));
    } else {
      isTargetUser = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'targetUserId'));
    }
    if (isTargetUser) {
      if ((getObjectProperty(command, 'type')) == 'blockUser') {
        await BackendlessUI.Functions.Custom['fn_341a41468d22574396fc05e34d8ab549']((getObjectProperty((getObjectProperty(command, 'data')), 'senderUserId')), (getObjectProperty(___arguments.context.pageData, 'messages')));
        if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
          if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'senderUserId')) || (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'senderUserId'))) {
            ___arguments.context.pageData['currentActivity'] = null;
            ___arguments.context.pageData['openMessage'] = null;
            ___arguments.context.appData['openMessage'] = null;
            if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).includes('open')) {
              ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).pop();
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', true);
            }
          }
        }
        if (getObjectProperty(___arguments.context.appData, 'activityList')) {
          delete ___arguments.context.appData['activityList'];
        }
        if (getObjectProperty(___arguments.context.appData, 'users')) {
          ___arguments.context.appData['users'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'users')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(command, 'data')), 'senderUserId')));
          }));
        }
        if (getObjectProperty(___arguments.context.appData, 'seenBy')) {
          ___arguments.context.appData['seenBy'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'seenBy')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(command, 'data')), 'senderUserId')));
          }));
        }
        if (getObjectProperty(___arguments.context.appData, 'myLikes')) {
          ___arguments.context.appData['myLikes'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'myLikes')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(command, 'data')), 'senderUserId')));
          }));
        }
      }
      if ((getObjectProperty(command, 'type')) == 'unBlockUser') {
        try {
          ___arguments.context.pageData['messages'] = (await Backendless.Request.get(`${Backendless.appPath}/services/messages/getMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());

        } catch (error) {
          try {
            console.log('Retrying to download messages');
            ___arguments.context.pageData['messages'] = (await Backendless.Request.get(`${Backendless.appPath}/services/messages/getMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());

          } catch (error) {
            console.log(error);

          }

        }
        delete ___arguments.context.appData['chats'];
        delete ___arguments.context.appData['activityMessages'];
        delete ___arguments.context.pageData['chats'];
        delete ___arguments.context.pageData['receivedChats'];
        delete ___arguments.context.appData['receivedChats'];
        delete ___arguments.context.pageData['activityMessages'];
        delete ___arguments.context.appData['activityList'];
        delete ___arguments.context.appData['users'];
      }
      if ((getObjectProperty(command, 'type')) == 'receivedInvitation') {
        receivedChat = (await Backendless.Request.get(`${Backendless.appPath}/services/getChats/getReceivedChat`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'chatId': JSON.stringify((getObjectProperty((getObjectProperty(command, 'data')), 'chatId'))) }).send());
        (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received')).unshift(receivedChat);
        if (!(await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
          senderName = (getObjectProperty((getObjectProperty(receivedChat, 'sender')), 'name')) ? (getObjectProperty((getObjectProperty(receivedChat, 'sender')), 'name')) : (getObjectProperty((getObjectProperty(receivedChat, 'sender')), 'login'));
          if ((getObjectProperty(receivedChat, 'type')) == 'requestPermission') {
            popupText = String('You have a new request to photo from ') + String(senderName);
          }
          if ((getObjectProperty(receivedChat, 'type')) == 'invitation') {
            popupText = [senderName,' invites you to be their +1 for "',(getObjectProperty((getObjectProperty(receivedChat, 'currentActivity')), 'name')),'"'].join('');
          }
          if ((getObjectProperty(receivedChat, 'type')) == 'activityRequest') {
            popupText = [senderName,' asks to join your activity "',(getObjectProperty((getObjectProperty(receivedChat, 'currentActivity')), 'name')),'"'].join('');
          }
          await BackendlessUI.Functions.Custom['fn_a54cd48df219fcf28293b9e3e089975d'](___arguments.context.appData, ___arguments.context.pageData, (getObjectProperty((getObjectProperty(command, 'data')), 'chatId')), popupText);
        }
      }
      if ((getObjectProperty(command, 'type')) == 'rejectReceivedRequst') {
        var j_list4 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent'));
        for (var j_index4 in j_list4) {
          j = j_list4[j_index4];
          if ((getObjectProperty(j, 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'chatId'))) {
            j['status'] = 'rejected';
          }
        }
      }
      if ((getObjectProperty(command, 'type')) == 'acceptedInvitation') {
        currentChat = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'chatId')));
        }))[0];
        if (currentChat) {
          activityName = (getObjectProperty((getObjectProperty(currentChat, 'currentActivity')), 'name'));
          currentChat['status'] = 'accepted';
          currentChat['type'] = 'acceptedInvitation';
          currentChat['message'] = [(getObjectProperty(currentChat, 'recentMessage'))];
          if (((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe')).map(item => item['objectId'])).includes((getObjectProperty((getObjectProperty(currentChat, 'currentActivity')), 'objectId')))) {
            var j_list5 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe'));
            for (var j_index5 in j_list5) {
              j = j_list5[j_index5];
              if ((getObjectProperty(j, 'objectId')) == (getObjectProperty((getObjectProperty(currentChat, 'currentActivity')), 'objectId'))) {
                delete currentChat['currentActivity'];
                (getObjectProperty(j, 'chats')).unshift(currentChat);
                break;
              }
            }
          } else {
            newChatActivity = ({ [`chats`]: [currentChat],[`name`]: (getObjectProperty((getObjectProperty(currentChat, 'currentActivity')), 'name')),[`activityDate`]: (getObjectProperty((getObjectProperty(currentChat, 'currentActivity')), 'activityDate')),[`description`]: (getObjectProperty((getObjectProperty(currentChat, 'currentActivity')), 'description')),[`financialRole`]: (getObjectProperty((getObjectProperty(currentChat, 'currentActivity')), 'financialRole')),[`objectId`]: (getObjectProperty((getObjectProperty(currentChat, 'currentActivity')), 'objectId')),[`ownerId`]: (getObjectProperty((getObjectProperty(currentChat, 'currentActivity')), 'ownerId')),[`ongoingTiming`]: (getObjectProperty((getObjectProperty(currentChat, 'currentActivity')), 'ongoingTiming')) });
            delete ((getObjectProperty(newChatActivity, 'chats'))[0])['currentActivity'];
            delete currentChat['currentActivity'];
            (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe')).unshift(newChatActivity);
          }
          (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['sent'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(currentChat, 'objectId')));
          }));
        }
        if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
          if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(currentChat, 'objectId'))) {
            ___arguments.context.pageData['currentTab'] = 'chats';
            ___arguments.context.pageData['activeSpoiler'] = ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'myAct' ? '' : 'myAct');
            ___arguments.context.pageData['selectedAct'] = ((getObjectProperty(___arguments.context.pageData, 'selectedAct')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')) ? '' : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')));
            ___arguments.context.pageData['openMessage'] = currentChat;
            (getObjectProperty(___arguments.context.pageData, 'openMessage'))['currentChatType'] = 'byMe';
            ___arguments.context.appData['openMessage'] = (getObjectProperty(___arguments.context.pageData, 'openMessage'));
            await new Promise(r => setTimeout(r, 300 || 0));
            (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
          }
        }
        if (!(await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
          if (!(getObjectProperty(___arguments.context.pageData, 'openMessage')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) != (getObjectProperty(currentChat, 'objectId'))) {
            await BackendlessUI.Functions.Custom['fn_a54cd48df219fcf28293b9e3e089975d'](___arguments.context.appData, ___arguments.context.pageData, (getObjectProperty(currentChat, 'objectId')), ([activityName,' - ',(getObjectProperty((getObjectProperty(currentChat, 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty(currentChat, 'receiver')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(currentChat, 'receiver')), 'login')),' has accepted your invitation to join this activity.'].join('')));
          }
        }
      }
      if ((getObjectProperty(command, 'type')) == 'acceptedActivityRequest') {
        newChatActivity = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'chatId')));
        }))[0];
        newChatActivity['status'] = 'accepted';
        newChatActivity['type'] = 'acceptedInvitation';
        newChatActivity['message'] = [(getObjectProperty(newChatActivity, 'recentMessage'))];
        if (newChatActivity) {
          currentChat = ({  });
          Object.assign(currentChat, (getObjectProperty(newChatActivity, 'currentActivity')));
          currentChat['chat'] = ({  });
          Object.assign((getObjectProperty(currentChat, 'chat')), newChatActivity);
          delete (getObjectProperty(currentChat, 'chat'))['currentActivity'];
          (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byOthers')).unshift(currentChat);
          (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['sent'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(newChatActivity, 'objectId')));
          }));
          if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
            if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(newChatActivity, 'objectId'))) {
              ___arguments.context.pageData['currentTab'] = 'chats';
              ___arguments.context.pageData['activeSpoiler'] = ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'otherAct' ? '' : 'otherAct');
              ___arguments.context.pageData['openMessage'] = (getObjectProperty(currentChat, 'chat'));
              (getObjectProperty(___arguments.context.pageData, 'openMessage'))['activityId'] = (getObjectProperty(currentChat, 'objectId'));
              (getObjectProperty(___arguments.context.pageData, 'openMessage'))['currentChatType'] = 'byOthers';
              ___arguments.context.appData['openMessage'] = (getObjectProperty(___arguments.context.pageData, 'openMessage'));
              await new Promise(r => setTimeout(r, 300 || 0));
              (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
            }
          }
          if (!(await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
            if (!(getObjectProperty(___arguments.context.pageData, 'openMessage')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) != (getObjectProperty(newChatActivity, 'objectId'))) {
              await BackendlessUI.Functions.Custom['fn_a54cd48df219fcf28293b9e3e089975d'](___arguments.context.appData, ___arguments.context.pageData, (getObjectProperty(newChatActivity, 'objectId')), ([(getObjectProperty((getObjectProperty(newChatActivity, 'currentActivity')), 'name')),' - ',(getObjectProperty((getObjectProperty(newChatActivity, 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty(newChatActivity, 'receiver')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(newChatActivity, 'receiver')), 'login')),' has accepted your request to join this activity.'].join('')));
            }
          }
        }
      }
      if ((getObjectProperty(command, 'type')) == 'acceptedRequestPermission') {
        var j_list6 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent'));
        for (var j_index6 in j_list6) {
          j = j_list6[j_index6];
          if ((getObjectProperty(j, 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'chatId'))) {
            j['status'] = 'accepted';
            receiverName = (getObjectProperty((getObjectProperty(j, 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty(j, 'receiver')), 'name')) : (getObjectProperty((getObjectProperty(j, 'receiver')), 'login'));
            break;
          }
        }
        if (!(await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
          if (!(getObjectProperty(___arguments.context.pageData, 'openMessage')) || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) != (getObjectProperty((getObjectProperty(command, 'data')), 'chatId'))) {
            await BackendlessUI.Functions.Custom['fn_a54cd48df219fcf28293b9e3e089975d'](___arguments.context.appData, ___arguments.context.pageData, (getObjectProperty((getObjectProperty(command, 'data')), 'chatId')), (String(receiverName) + String(' has approved your photo request')));
          }
        }
      }
      if ((getObjectProperty(command, 'type')) == 'withdrawRequest') {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['received'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(command, 'data')), 'chatId')));
        }));
        if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
          if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'chatId'))) {
            ___arguments.context.pageData['openMessage'] = null;
            ___arguments.context.pageData['currentActivity'] = null;
            ___arguments.context.appData['openMessage'] = null;
            if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).includes('open')) {
              ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).pop();
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', true);
            }
          }
        }
      }
      if ((getObjectProperty(command, 'type')) == 'unBlockActivityLocation') {
        if (getObjectProperty(___arguments.context.appData, 'activityList')) {
          delete ___arguments.context.appData['activityList'];
        }
      }
      if ((getObjectProperty(command, 'type')) == 'removeActivityChats') {
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats'))['byOthers'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byOthers')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(command, 'data')), 'activityId')));
        }));
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['received'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received')), async (item) => {
           filterResult = true;
          if ((getObjectProperty(item, 'currentActivity')) != null) {
            if ((getObjectProperty((getObjectProperty(item, 'currentActivity')), 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'activityId'))) {
              filterResult = false;
            }
          }


         return filterResult;
        }));
        (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations'))['sent'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent')), async (item) => {
           filterResult = true;
          if ((getObjectProperty(item, 'currentActivity')) != null) {
            if ((getObjectProperty((getObjectProperty(item, 'currentActivity')), 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'activityId'))) {
              filterResult = false;
            }
          }


         return filterResult;
        }));
        if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty(___arguments.context.pageData, 'currentActivity')) != null) {
          if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'activityId'))) {
            ___arguments.context.pageData['currentActivity'] = null;
            ___arguments.context.pageData['openMessage'] = null;
            ___arguments.context.appData['openMessage'] = null;
            if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).includes('open')) {
              ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).pop();
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', true);
              (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23e9db8f324d6c9c77a611cf7e162196', true);
            }
          }
        }
      }
      if (getObjectProperty(___arguments.context.pageData, 'messages')) {
        localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
      }
    }

    };

    const channel = getChannelInstance('RT_messages');

    channel.addCommandListener(callback);

    getRTSubscriptions().add('RT_messages_listener', () => channel.removeCommandListener(callback));
  })();
}

/**
 * Describe this function...
 */
async function getUpdatedChatInfo() {
  lastChatInfoUpdate = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('lastChatInfoUpdate'));
  updatedChatInfo = (await Backendless.Request.get(`${Backendless.appPath}/services/messages/UpdatedChatInfo`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'lastUpdate': lastChatInfoUpdate }).send());
  localStorage.setItem('lastChatInfoUpdate', JSON.stringify(((new Date()).valueOf())));
  if (!!(getObjectProperty(updatedChatInfo, 'activitiesForUpdate')).length || !!(getObjectProperty(updatedChatInfo, 'usersForUpdate')).length) {
    var j_list7 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe'));
    for (var j_index7 in j_list7) {
      j = j_list7[j_index7];
      await updateActivitiesChatInfo(j);
      if (!!(getObjectProperty(updatedChatInfo, 'usersForUpdate')).length) {
        var chatByMe_list = (getObjectProperty(j, 'chats'));
        for (var chatByMe_index in chatByMe_list) {
          chatByMe = chatByMe_list[chatByMe_index];
          var userForUpdate_list = (getObjectProperty(updatedChatInfo, 'usersForUpdate'));
          for (var userForUpdate_index in userForUpdate_list) {
            userForUpdate = userForUpdate_list[userForUpdate_index];
            if ((getObjectProperty(userForUpdate, 'objectId')) == (getObjectProperty((getObjectProperty(chatByMe, 'receiver')), 'objectId'))) {
              Object.assign((getObjectProperty(chatByMe, 'receiver')), userForUpdate);
            }
            if ((getObjectProperty(userForUpdate, 'objectId')) == (getObjectProperty((getObjectProperty(chatByMe, 'sender')), 'objectId'))) {
              Object.assign((getObjectProperty(chatByMe, 'sender')), userForUpdate);
            }
          }
        }
      }
    }
    var j_list8 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byOthers'));
    for (var j_index8 in j_list8) {
      j = j_list8[j_index8];
      await updateActivitiesChatInfo(j);
      if (!!(getObjectProperty(updatedChatInfo, 'usersForUpdate')).length) {
        var userForUpdate_list2 = (getObjectProperty(updatedChatInfo, 'usersForUpdate'));
        for (var userForUpdate_index2 in userForUpdate_list2) {
          userForUpdate = userForUpdate_list2[userForUpdate_index2];
          if ((getObjectProperty(userForUpdate, 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(j, 'chat')), 'receiver')), 'objectId'))) {
            Object.assign((getObjectProperty((getObjectProperty(j, 'chat')), 'receiver')), userForUpdate);
          }
          if ((getObjectProperty(userForUpdate, 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(j, 'chat')), 'sender')), 'objectId'))) {
            Object.assign((getObjectProperty((getObjectProperty(j, 'chat')), 'sender')), userForUpdate);
          }
        }
      }
    }
    var j_list9 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received'));
    for (var j_index9 in j_list9) {
      j = j_list9[j_index9];
      await updateiIvitationsChatInfo(j);
    }
    var j_list10 = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent'));
    for (var j_index10 in j_list10) {
      j = j_list10[j_index10];
      await updateiIvitationsChatInfo(j);
    }
  }
}

/**
 * Describe this function...
 */
async function RT_likes_listener() {
  if (!(await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL'))) {
    getRTSubscriptions().remove('likes');
    areLikesEnabled = true;
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) {
      areLikesEnabled = !(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')) || (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')) && ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')).includes('likes'));
    }
    if (areLikesEnabled) {

      ;(function() {
        const callback = async command => {
            currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
        if ((getObjectProperty(currentUser, 'objectId')) == (getObjectProperty((getObjectProperty(command, 'data')), 'receiver'))) {
          newUserLikes = (await Backendless.Request.get(`${Backendless.appPath}/services/userProfileLikes/getUserLikes`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'objectId': JSON.stringify((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'objectId'))) }).send());
          ___arguments.context.appData['showPopup'] = true;
          if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty((getObjectProperty(command, 'data')), 'message'))) {
            ___arguments.context.appData['newMessageText'] = (getObjectProperty((getObjectProperty(command, 'data')), 'message'));
            ___arguments.context.appData['newMessageBtn'] = (['View ',(getObjectProperty((getObjectProperty(command, 'data')), 'senderName')),'\'s profile'].join(''));
            ___arguments.context.appData['senderId'] = (getObjectProperty((getObjectProperty(command, 'data')), 'senderId'));
            await new Promise(r => setTimeout(r, 7000 || 0));
            delete ___arguments.context.appData['senderId'];
            delete ___arguments.context.appData['newMessageText'];
            delete ___arguments.context.appData['newMessageBtn'];
            delete ___arguments.context.appData['showPopup'];
          }
          if (currentUser && (getObjectProperty(currentUser, 'userProfile'))) {
            (getObjectProperty(currentUser, 'userProfile'))['likedBy'] = (getObjectProperty(newUserLikes, 'likedBy'));
            (getObjectProperty(currentUser, 'userProfile'))['myLikes'] = (getObjectProperty(newUserLikes, 'myLikes'));
            (getObjectProperty(currentUser, 'userProfile'))['seenBy'] = (getObjectProperty(newUserLikes, 'seenBy'));
            (getObjectProperty(currentUser, 'userProfile'))['likedActivities'] = (getObjectProperty(newUserLikes, 'likedActivities'));
            localStorage.setItem('currentUser', JSON.stringify(currentUser));
          }
        }

        };

        const channel = getChannelInstance('likes');

        channel.addCommandListener(callback);

        getRTSubscriptions().add('likes', () => channel.removeCommandListener(callback));
      })();
    }
  }
}

/**
 * Describe this function...
 */
async function updateActivitiesChatInfo(chatItem) {
  if (!!(getObjectProperty(updatedChatInfo, 'activitiesForUpdate')).length) {
    var activityForUpdate_list = (getObjectProperty(updatedChatInfo, 'activitiesForUpdate'));
    for (var activityForUpdate_index in activityForUpdate_list) {
      activityForUpdate = activityForUpdate_list[activityForUpdate_index];
      if ((getObjectProperty(activityForUpdate, 'objectId')) == (getObjectProperty(chatItem, 'objectId'))) {
        Object.assign(chatItem, activityForUpdate);
      }
    }
  }
}

/**
 * Describe this function...
 */
async function updateiIvitationsChatInfo(invitationItem) {
  if ((getObjectProperty(invitationItem, 'currentActivity')) && !!(getObjectProperty(updatedChatInfo, 'activitiesForUpdate')).length) {
    var activityForUpdate_list2 = (getObjectProperty(updatedChatInfo, 'activitiesForUpdate'));
    for (var activityForUpdate_index2 in activityForUpdate_list2) {
      activityForUpdate = activityForUpdate_list2[activityForUpdate_index2];
      if ((getObjectProperty(activityForUpdate, 'objectId')) == (getObjectProperty((getObjectProperty(invitationItem, 'currentActivity')), 'objectId'))) {
        Object.assign((getObjectProperty(invitationItem, 'currentActivity')), activityForUpdate);
      }
    }
  }
  if (!!(getObjectProperty(updatedChatInfo, 'usersForUpdate')).length) {
    var userForUpdate_list3 = (getObjectProperty(updatedChatInfo, 'usersForUpdate'));
    for (var userForUpdate_index3 in userForUpdate_list3) {
      userForUpdate = userForUpdate_list3[userForUpdate_index3];
      if ((getObjectProperty(userForUpdate, 'objectId')) == (getObjectProperty((getObjectProperty(invitationItem, 'receiver')), 'objectId'))) {
        Object.assign((getObjectProperty(invitationItem, 'receiver')), userForUpdate);
      }
      if ((getObjectProperty(userForUpdate, 'objectId')) == (getObjectProperty((getObjectProperty(invitationItem, 'sender')), 'objectId'))) {
        Object.assign((getObjectProperty(invitationItem, 'sender')), userForUpdate);
      }
    }
  }
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
    if (!(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus'))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', ({ [`accountPaused`]: true }));
      return ;
    }
  }
  getRTSubscriptions().remove('newMessages');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  getRTSubscriptions().remove('likes');
  ___arguments.context.pageData['countOffset'] = 0;
  if (getObjectProperty(___arguments.context.appData, 'chatList')) {
    delete ___arguments.context.appData['chatList'];
  }
  if (getObjectProperty(___arguments.context.appData, 'chats')) {
    delete ___arguments.context.appData['chats'];
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('277906747a937508979688e3044a31ce')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('277906747a937508979688e3044a31ce', true);
  }
  if ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')), 'active');
    }
  }
  await getUser();
  ___arguments.context.pageData['currentTab'] = 'chats';
  if (getObjectProperty(___arguments.context.pageData, 'chatId')) {
    ___arguments.context.pageData['getChat'] = (getObjectProperty(___arguments.context.pageData, 'chatId'));
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')) {
    lastUpdate = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')), 'lastUpdate'));
    if (!lastUpdate) {
      localStorage.removeItem('messages');
    }
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('messages')) {
    ___arguments.context.pageData['messages'] = (await BackendlessUI.Functions.Custom['fn_2171da3dd0357b5cf3e53a779f8ad201']());
  } else {
    try {
      ___arguments.context.pageData['messages'] = (await Backendless.Request.get(`${Backendless.appPath}/services/messages/getMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      if (getObjectProperty(___arguments.context.pageData, 'messages')) {
        localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
      }
      isMessagesUpdated = true;

    } catch (error) {
      try {
        console.log('Retrying to download messages');
        ___arguments.context.pageData['messages'] = (await Backendless.Request.get(`${Backendless.appPath}/services/messages/getMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
        if (getObjectProperty(___arguments.context.pageData, 'messages')) {
          localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
        }
        isMessagesUpdated = true;

      } catch (error) {
        (function (message) { alert(message) })((getObjectProperty(error, 'message')));
        console.log(error);

      }

    }
  }
  ___arguments.context.pageData['isMessagesReady'] = true;
  if ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).includes('active')) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4891c98954161a45dda14a7bff6b0d4f')).pop();
    }
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('277906747a937508979688e3044a31ce')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('277906747a937508979688e3044a31ce', false);
  }
  if (getObjectProperty(___arguments.context.pageData, 'getChat')) {
    await BackendlessUI.Functions.Custom['fn_570c5ed578a4125bf0d767a52b1a63fc'](___arguments.context.appData, ___arguments.context.pageData);
    ___arguments.context.appData['messagesNumber'] = (await BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369']((getObjectProperty(___arguments.context.pageData, 'messages')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))));
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = '100%';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', false);
    }
    await new Promise(r => setTimeout(r, 500 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
  }
  await getNewMessage();
  await RT_messages_listener();
  await RT_likes_listener();
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    await startNativeListeners();
  }
  await (async function() {
  	const url = new URL(document.location);
  	const searchParams = url.searchParams;
  	searchParams.delete("data");
  	window.history.pushState({}, '', url.toString());

  })();
  if (!isMessagesUpdated) {
    ;(async () => {
        try {
        await getUpdatedChatInfo();

      } catch (error) {
        console.log(error);

      }

    })();
  } else {
    localStorage.setItem('lastChatInfoUpdate', JSON.stringify(((new Date()).valueOf())));
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_messages_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/messages/components/79d1884b1acd8d9f1dfd040d37811d33/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      return ['RequestActivity__card', 'center']

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation') {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/94d9515756c322ee308f8f0ca6ab8195/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      return ['RequestActivity__card', 'center']

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/503cba86ae584c5e50bc98f6d5bb77ed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activeSpoiler'] = ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'receivedInv' ? '' : 'receivedInv');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'receivedInv' ? ['messages__asideSpoiler', 'open'] : ['messages__asideSpoiler'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/a4f514a6b999cda29c6f5c7c98d13788/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['activeSpoiler'] = ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'sentInv' ? '' : 'sentInv');

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'sentInv' ? ['messages__asideSpoiler', 'open'] : ['messages__asideSpoiler'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/b8c7f6fd977547c21cf106878ef9dac8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, interlocutorId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function setInterlocutorCoverPhoto() {
  ___arguments.context.pageData['interlocutorImgUrl'] = null;
  interlocutorId = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'sender')), 'objectId')) : (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'receiver')), 'objectId'));
  ___arguments.context.pageData['interlocutorImgUrl'] = (await Backendless.Request.get(`${Backendless.appPath}/services/userProfileImg/UserProfileImg`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'userId': JSON.stringify(interlocutorId) }).send());
}


  try {
    ;(async () => {
        await setInterlocutorCoverPhoto();

    })();

  } catch (error) {
    console.log(error);

  }
  if ((getObjectProperty(___arguments.context.pageData, 'openMessage.objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['noMoreMessages'] = false;
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = '100%';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613b611a25aa28f8d6a15151b82ff19a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', false);
    }
    ___arguments.context.dataModel['message'] = [(getObjectProperty(___arguments.context.dataModel, 'recentMessage'))];
    ___arguments.context.pageData['openMessage'] = ___arguments.context.dataModel;
    (getObjectProperty(___arguments.context.pageData, 'openMessage'))['currentChatType'] = 'sent';
    ___arguments.context.appData['openMessage'] = (getObjectProperty(___arguments.context.pageData, 'openMessage'));
    if ((getObjectProperty(___arguments.context.dataModel, 'type')) != 'requestPermission') {
      ___arguments.context.pageData['currentActivity'] = (getObjectProperty(___arguments.context.dataModel, 'currentActivity'));
    } else {
      ___arguments.context.pageData['currentActivity'] = null;
    }
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c9915ee5b4aff26c256e3062303d2a45')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9915ee5b4aff26c256e3062303d2a45', false);
    }
    await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))).set((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
    localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
      if (___arguments.context.dataModel && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
        return ['messages__activitiesItem', 'open'];
      }
    }
  }

  return ['messages__activitiesItem']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/b6630085d09adb7f8b08af4e414e1a97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, interlocutorId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function setInterlocutorCoverPhoto() {
  ___arguments.context.pageData['interlocutorImgUrl'] = null;
  interlocutorId = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'sender')), 'objectId')) : (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'receiver')), 'objectId'));
  ___arguments.context.pageData['interlocutorImgUrl'] = (await Backendless.Request.get(`${Backendless.appPath}/services/userProfileImg/UserProfileImg`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'userId': JSON.stringify(interlocutorId) }).send());
}


  try {
    ;(async () => {
        await setInterlocutorCoverPhoto();

    })();

  } catch (error) {
    console.log(error);

  }
  if (!(getObjectProperty(___arguments.context.pageData, 'openMessage')) || (getObjectProperty(___arguments.context.pageData, 'openMessage.objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['noMoreMessages'] = false;
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = '100%';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613b611a25aa28f8d6a15151b82ff19a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', false);
    }
    ___arguments.context.dataModel['message'] = [(getObjectProperty(___arguments.context.dataModel, 'recentMessage'))];
    ___arguments.context.pageData['openMessage'] = ___arguments.context.dataModel;
    (getObjectProperty(___arguments.context.pageData, 'openMessage'))['currentChatType'] = 'received';
    ___arguments.context.appData['openMessage'] = (getObjectProperty(___arguments.context.pageData, 'openMessage'));
    if ((getObjectProperty(___arguments.context.dataModel, 'type')) != 'requestPermission') {
      ___arguments.context.pageData['currentActivity'] = (getObjectProperty(___arguments.context.dataModel, 'currentActivity'));
    } else {
      ___arguments.context.pageData['currentActivity'] = null;
    }
    if (!(getObjectProperty(___arguments.context.dataModel, 'chatIsRead'))) {
      ___arguments.context.dataModel['chatIsRead'] = true;
      (getObjectProperty(___arguments.context.dataModel, 'recentMessage'))['isRead'] = true;
      ___arguments.context.appData['messagesNumber'] = (await BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369']((getObjectProperty(___arguments.context.pageData, 'messages')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))));
      ;(async () => {
          await BackendlessUI.Functions.Custom['fn_e6838df71af3b86c75934ac7bf79c8b1'](___arguments.context.pageData);

      })();
    }
    if ((getObjectProperty(___arguments.context.dataModel, 'type')) != 'requestPermission') {
      ___arguments.context.pageData['currentActivity'] = (getObjectProperty(___arguments.context.dataModel, 'currentActivity'));
    }
    await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))).set((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')));
    localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
      if (___arguments.context.dataModel && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
        return ['messages__activitiesItem', 'open'];
      }
    }
  }

  return ['messages__activitiesItem']

  },
  /* handler:onClassListAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var name2, activityName;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/messages/components/612388e2ccef4c2a23e6fead1ddd02db/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/955e41f95a3b45e864570a7fc54c7a99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible, activity, chat;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'myActivities')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'invitedActivities'))) {
    isVisible = false;
    var activity_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'myActivities'));
    for (var activity_index in activity_list) {
      activity = activity_list[activity_index];
      var chat_list = (getObjectProperty(activity, 'chats'));
      for (var chat_index in chat_list) {
        chat = chat_list[chat_index];
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(chat, 'recentMessage')), 'receiver')), 'objectId')) && !(getObjectProperty(chat, 'chatIsRead'))) {
          isVisible = true;
          break;
        }
      }
      if (isVisible) {
        break;
      }
    }
    if (!isVisible) {
      var activity_list2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'invitedActivities'));
      for (var activity_index2 in activity_list2) {
        activity = activity_list2[activity_index2];
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(activity, 'chat')), 'recentMessage')), 'receiver')), 'objectId')) && !(getObjectProperty((getObjectProperty(activity, 'chat')), 'chatIsRead'))) {
          isVisible = true;
          break;
        }
      }
    }
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/57d9567f707fa45310b99cff3512d022/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectedAct'] = ((getObjectProperty(___arguments.context.pageData, 'selectedAct')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')) ? '' : (getObjectProperty(___arguments.context.dataModel, 'objectId')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/eaf375b73a9358cb05add4e7028fb4cc/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty(___arguments.context.pageData, 'openMessage'))) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ownerId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail'));
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail'));
      }
    }
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/f42499eda5915e12ae32f77f2e4519b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  user = ({  });
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
    user = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver'));
  } else {
    user = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender'));
  }
  ___arguments.context.pageData['modalContent'] = ({ 'type': 'delete','title': ['Delete chat with ',(getObjectProperty(user, 'name')) ? (getObjectProperty(user, 'name')).split(' ')[0] : (getObjectProperty(user, 'login')),'?'].join(''),'text': 'Are you sure you would like to delete this chat? All messages will be removed. The other user will still see the chat and will be able to communicate with you. To stop all communication, consider the "Block" option.','button': 'Delete','doneText': 'Done!','doneButton': 'Thanks' });
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/1eb7bab5a136bd39cada56cbf7aa1a01/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivity')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ownerId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'visibility')) == 3) {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'withdraw','title': 'Withdraw the invitation?','text': ['Are you sure you want to withdraw your invitation to ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login')),' for this activity?'].join(''),'button': 'Yes','doneText': 'Invitation withdrawn!','doneButton': 'Thanks' });
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/9c9589e7a4af933f98bfcc91a2151232/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty(___arguments.context.pageData, 'currentActivity'))) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'activityRequest' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation')) {
      return true;
    }
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'invitation' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'authorObjectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'visibility')) == 3) {
        return false;
      } else {
        return true;
      }
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'withdraw','title': 'Withdraw the request?','text': ['Are you sure you want to withdraw the request to be ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login')),'\'s +1?'].join(''),'button': 'Yes','doneText': 'Request withdrawn!','doneButton': 'Thanks' });
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/91990c1a2efd603f75f466483234f91c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, newMessage, currentSenderChatId, receiverId, enteredMessage;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['counter'] = (String(getValueLength(___arguments.value)) + String('/500 symbols'));
  if ((getObjectProperty(___arguments.context.pageData, 'isEnterPress')) && (getObjectProperty(___arguments.context.pageData, 'newMessage'))) {
    enteredMessage = (getObjectProperty(___arguments.context.pageData, 'newMessage'));
    if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
      receiverId = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId'));
      newMessage = ({ [`chatId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),[`message`]: enteredMessage,[`sender`]: ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) }),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),[`receiver`]: ({ [`objectId`]: receiverId }),[`type`]: 'text',[`created`]: ((new Date()).valueOf()),[`isRead`]: false });
      addItemToList((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')), newMessage);
      delete ___arguments.context.pageData['isEnterPress'];
      ___arguments.context.pageData['newMessage'] = '';
      ___arguments.context.pageData['counter'] = '';
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
        await new Promise(r => setTimeout(r, 1 || 0));
        (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
      }
      ___arguments.context.pageData['new'] = true;
      (getObjectProperty(___arguments.context.pageData, 'openMessage'))['recentMessage'] = newMessage;
      try {
        await Backendless.Messaging.publish('default', newMessage, new Backendless.PublishOptions({ subtopic: '', headers: ({ [`chatId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),[`receiverId`]: receiverId }) }), new Backendless.DeliveryOptions({ publishPolicy: 'PUBSUB' }));
        currentSenderChatId = (await Backendless.Hive('CurrentUserChat').KeyValueStore(receiverId).get());
        if (currentSenderChatId == null || currentSenderChatId != (getObjectProperty(newMessage, 'chatId'))) {
          await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('message', (String('New message from ') + String(getObjectProperty(newMessage, 'senderName'))), 'messages', (getObjectProperty(newMessage, 'chatId')), (getObjectProperty((getObjectProperty(newMessage, 'receiver')), 'objectId')), null, null, null);
        }

      } catch (error) {
        console.log(error);

      }
    }
    localStorage.setItem('messages', JSON.stringify(({ [`messages`]: (getObjectProperty(___arguments.context.pageData, 'messages')),[`lastUpdate`]: ((new Date()).valueOf()) })));
    try {
      await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('message_sent');

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 1024) {
    (function (component) { component.focus() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('91990c1a2efd603f75f466483234f91c')));
  }

  },
  /* handler:onBlur */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if ((await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) || (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('VIEWER'))) {
    await new Promise(r => setTimeout(r, 350 || 0));
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
    }
  }

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/messages/components/cfa40434f8581bb7b63111afa7c498e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'type')) == 'requestPermission' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'new') {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['modalContent'] = ({ 'type': 'withdraw','title': 'Withdraw the request?','text': ['Are you sure you want to withdraw the request to  ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'login')),'\'s photo?'].join(''),'button': 'Yes','doneText': 'Request withdrawn!','doneButton': 'Thanks' });
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('30f7c2bc22caf90e95a43ef124e88a2c')), 'block');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/0e2d9979cf7fa8aa583d07eadef86bdc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')) && (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'))[0]), 'message'))) {
    return (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'))[0]), 'message'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/933b21a54739801f187680e8770d30f7/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'rejected') {
      return (String(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')) + String(' is not quite ready to share all their private photos.  Spend a little more time chatting…good things come to those who wait!'));
    }
  }

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/messages/components/d83f788cd12cf59209989d415cf54e93/bundle.js', [], () => ({
  /* content */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'status')) == 'rejected') {
      return (['Message ',(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'name')),' now'].join(''));
    }
  }

  },
  /* handler:onLabelAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  delete ___arguments.context.appData['showPopup'];
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f64e76d36d2d2cee6b2698b7d2c568db')).slice(-1)[0] == 'open') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f64e76d36d2d2cee6b2698b7d2c568db')).pop();
  }
  if (getObjectProperty(___arguments.context.pageData, 'getChat')) {
    await BackendlessUI.Functions.Custom['fn_570c5ed578a4125bf0d767a52b1a63fc'](___arguments.context.appData, ___arguments.context.pageData);
    ___arguments.context.appData['messagesNumber'] = (await BackendlessUI.Functions.Custom['fn_b7bed1b964e9034a97b47d4f7ba72369']((getObjectProperty(___arguments.context.pageData, 'messages')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))));
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['noMoreMessages'] = false;
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = '100%';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613b611a25aa28f8d6a15151b82ff19a', false);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', false);
    }
    delete ___arguments.context.pageData['getChat'];
    await new Promise(r => setTimeout(r, 50 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f931ba3f68b2be24545ef5351acaca87')));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/messages/components/b0fa8d0f8b749fcb518a565aa305b8ee/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'myAct' ? ['MessagesActivities', 'shrink', 'messages__activities'] : ['MessagesActivities', 'shrink', 'closed', 'messages__activities'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/ffbfc9034975dd5bb256f0278a1f4bd8/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'otherAct' ? ['shrink', 'messages__activities'] : ['shrink', 'closed', 'messages__activities'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/cd753f78175390294544bc17bc05c793/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedAct')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')) ? ['messages__activitiesDetails', 'open'] : ['messages__activitiesDetails'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/418e4cc6870bbc3821326a0e62bf61d7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var list;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  (function (event) { event.stopPropagation() })(___arguments.event);
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0816f5b16b0636ee36c33fc1a5a991e7')).includes('open')) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0816f5b16b0636ee36c33fc1a5a991e7')), 'open', '');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0816f5b16b0636ee36c33fc1a5a991e7')).push('open');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/6af428586cab10aa519ddf65f2a4f152/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'chatIsRead')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/a5cd57d2ed138f923958c34252e2b7c6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'driver') {
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'ownerId'))) {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail')) {
          return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail'));
        }
      } else {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail')) {
          return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail'));
        }
      }
      return 'styles/img/icons/pic_profile.svg';
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) == 'passenger' || (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) != 'driver' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) != 'passenger') {
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail')) {
          return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail'));
        } else {
          return 'styles/img/icons/pic_profile.svg';
        }
      } else {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail')) {
          return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail'));
        } else {
          return 'styles/img/icons/pic_profile.svg';
        }
      }
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/657711c9493759d282c9b1e12a993e94/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'openMessage')) && (getObjectProperty(___arguments.context.pageData, 'currentActivity'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) != 'driver' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) != 'passenger') {
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail')) {
          return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail'));
        } else {
          return 'styles/img/icons/pic_profile.svg';
        }
      } else {
        if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail')) {
          return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail'));
        } else {
          return 'styles/img/icons/pic_profile.svg';
        }
      }
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/f1e697cd8cb9738bcd7828a2fc6899c5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'receivedInv')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/8c96a34f8a53df1348130e1b429296c9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'activeSpoiler')) == 'sentInv')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/b3aa0ea4dfed7e8a7ea4cdedcbb718be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentActivity')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) != 'driver' && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole')) != 'passenger') {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'financialRole'));
  }

  return ''

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/13e880f10af60cd3010c5b69da274c5e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fec7f882dd2d3f2d1e2c8ad158cb1708')) && (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fec7f882dd2d3f2d1e2c8ad158cb1708')), 'myActivities')) || !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fec7f882dd2d3f2d1e2c8ad158cb1708')), 'myActivities')).length) && (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fec7f882dd2d3f2d1e2c8ad158cb1708')), 'invitedActivities')) || !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('fec7f882dd2d3f2d1e2c8ad158cb1708')), 'invitedActivities')).length) && (getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'chats' && !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('277906747a937508979688e3044a31ce')), 'display'))) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/7b24dcad6aeb3f3a7388b6d47b863fe6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-report', ({ [`source`]: 'Chat',[`itemId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId')),[`violatorId`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/c5aaaa040a869217fd7441db4f4a98e3/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
    if (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'sender')), 'photoThumbnail')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'sender')), 'photoThumbnail'));
    }
  } else {
    if (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'receiver')), 'photoThumbnail')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'receiver')), 'photoThumbnail'));
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/22ce372babbdf6181cea0b917286f81c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'receiver')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'sender')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'sender')), 'login'))) : ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'receiver')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('62cc0c5ea2b37ae83d1766c3c24d0d94'), 'receiver')), 'login'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/92dec97fb6ca2e232c7bb41a2133e279/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'ownerId')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'receiver')), 'objectId'))) {
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'receiver')), 'photoThumbnail')) {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'receiver')), 'photoThumbnail'));
    }
  } else {
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'sender')), 'photoThumbnail')) {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'sender')), 'photoThumbnail'));
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/fbb42e028304951506e9dcbdfde625d6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var authorBirthDate, authorName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'ownerId')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'receiver')), 'objectId'))) {
    authorBirthDate = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'receiver')), 'birthDate'));
  } else {
    authorBirthDate = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'sender')), 'birthDate'));
  }

  return (String(', ') + String((await (async function(year, month, day) {
	let now = new Date();
	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

	let dob = new Date(year, month, day);

	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

	let age;

	age = today.getFullYear() - dob.getFullYear();

	if (today < dobnow) {
	  age = age-1;
	} else {
	  age = age
	}

	return age

})((new Date(authorBirthDate).getFullYear()), (new Date(authorBirthDate).getMonth()), (new Date(authorBirthDate).getDate())))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/42fd6c71dee2f301dd39137ed0f4519a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var authorLogin, authorName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'ownerId')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'receiver')), 'objectId'))) {
    authorLogin = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'receiver')), 'login'));
    authorName = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'receiver')), 'name'));
  } else {
    authorLogin = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'sender')), 'login'));
    authorName = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'sender')), 'name'));
  }
  if (!authorName || authorName && authorName.trim() == '') {
    return authorLogin;
  }

  return authorName

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/3f6f176a773f5a86f8686e43eed81998/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'receivedSystemMessages')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'receivedSystemMessages')).length) {
    if (___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'sender')), 'photoThumbnail'));
    }
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/c836809b04781bf8f328f6958a8a057f/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      await (async function(data) {
  	const textarea = document.querySelector('.MessagesTextarea')
  	textarea.addEventListener('keypress', function (e) {
  	  if (e.key === 'Enter') {
  	    if (data.newMessage) {
  	      if (data.newMessage.trim()) {
  	        data.isEnterPress = true
  	      } else {
  	        e.preventDefault()
  	      }
  	    } else {
  	      e.preventDefault()
  	    }
  	  }
  	});
  })(___arguments.context.pageData);

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/messages/components/fec7f882dd2d3f2d1e2c8ad158cb1708/bundle.js', [], () => ({
  /* content */
  /* handler:onContainerDataAssignment */
  async ['onContainerDataAssignment'](___arguments) {
    var acivity, activityRemains, byMe, byMeChatsResult, byMeFilterResult, byMeMessages, byMeName, byOthers, byOthersFilterResult, byOthersMessages, byOthersName, chat, data, invitations, invitationsActivityName, invitationsFilterResult, invitationsName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function byMeFilter(byMe) {
  if ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'chats') {
    byMeFilterResult = (await asyncListFilter(byMe, async (acivity) => {
       if (((getObjectProperty(acivity, 'name')).trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1) {
        activityRemains = true;
      } else {
        byMeChatsResult = (await asyncListFilter((getObjectProperty(acivity, 'chats')), async (chat) => {
           byMeName = (getObjectProperty((getObjectProperty(chat, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? ((getObjectProperty((getObjectProperty(chat, 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty(chat, 'receiver')), 'name')) : (getObjectProperty((getObjectProperty(chat, 'receiver')), 'login'))) : ((getObjectProperty((getObjectProperty(chat, 'sender')), 'name')) ? (getObjectProperty((getObjectProperty(chat, 'sender')), 'name')) : (getObjectProperty((getObjectProperty(chat, 'sender')), 'login')));
          byMeMessages = ((getObjectProperty(chat, 'message')).map(item => item['message'])).join(' ');


         return (((byMeMessages.trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1) || ((byMeName.trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1));
        }));
        activityRemains = !!byMeChatsResult.length;
      }


     return activityRemains;
    }));
  } else {
    byMeFilterResult = byMe;
  }
  return byMeFilterResult
}

/**
 * Describe this function...
 */
async function byOthersFilter(byOthers) {
  if ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'chats') {
    byOthersFilterResult = (await asyncListFilter(byOthers, async (acivity) => {
       byOthersName = (getObjectProperty((getObjectProperty((getObjectProperty(acivity, 'chat')), 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? ((getObjectProperty((getObjectProperty((getObjectProperty(acivity, 'chat')), 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(acivity, 'chat')), 'receiver')), 'name')) : (getObjectProperty((getObjectProperty((getObjectProperty(acivity, 'chat')), 'receiver')), 'login'))) : ((getObjectProperty((getObjectProperty((getObjectProperty(acivity, 'chat')), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty((getObjectProperty(acivity, 'chat')), 'sender')), 'name')) : (getObjectProperty((getObjectProperty((getObjectProperty(acivity, 'chat')), 'sender')), 'login')));
      byOthersMessages = ((getObjectProperty((getObjectProperty(acivity, 'chat')), 'message')).map(item => item['message'])).join(' ');


     return ((((getObjectProperty(acivity, 'name')).trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1) || ((byOthersMessages.trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1) || ((byOthersName.trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1));
    }));
  } else {
    byOthersFilterResult = byOthers;
  }
  return byOthersFilterResult
}

/**
 * Describe this function...
 */
async function invitationsFilter(invitations) {
  if ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'invitations') {
    invitationsActivityName = null;
    invitationsFilterResult = (await asyncListFilter(invitations, async (chat) => {
       if ((getObjectProperty(chat, 'currentActivity')) && (getObjectProperty((getObjectProperty(chat, 'currentActivity')), 'name'))) {
        invitationsActivityName = (((getObjectProperty((getObjectProperty(chat, 'currentActivity')), 'name')).trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1);
      }
      invitationsName = (getObjectProperty((getObjectProperty(chat, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? ((getObjectProperty((getObjectProperty(chat, 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty(chat, 'receiver')), 'name')) : (getObjectProperty((getObjectProperty(chat, 'receiver')), 'login'))) : ((getObjectProperty((getObjectProperty(chat, 'sender')), 'name')) ? (getObjectProperty((getObjectProperty(chat, 'sender')), 'name')) : (getObjectProperty((getObjectProperty(chat, 'sender')), 'login')));


     return (invitationsActivityName || ((invitationsName.trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1));
    }));
  } else {
    invitationsFilterResult = invitations;
  }
  return invitationsFilterResult
}


  if (getObjectProperty(___arguments.context.pageData, 'messages')) {
    if ((getObjectProperty(___arguments.context.pageData, 'searchInput')) && (getObjectProperty(___arguments.context.pageData, 'searchInput')).length > 1) {
      data = ({ 'myActivities': await byMeFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe'))),'invitedActivities': await byOthersFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byOthers'))),'receivedSystemMessages': await invitationsFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received'))),'sentSystemMessages': await invitationsFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent'))) });
    } else {
      data = ({ 'myActivities': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byMe')),'invitedActivities': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'chats')), 'byOthers')),'receivedSystemMessages': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'received')),'sentSystemMessages': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'messages')), 'invitations')), 'sent')) });
    }
  }

  return data

  },
  /* handler:onContainerDataAssignment */
  /* content */
}))

define('./pages/messages/components/9caef6f5d10545bd456cc51892ced1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var activityName, name2, title;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97')['authorName'] = ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'sender')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'sender')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'sender')), 'login')));
  name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'authorName'));
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'currentActivity')) {
    activityName = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'currentActivity')), 'name')) ? ['"',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'currentActivity')), 'name')),'"'].join('') : null;
  }
  if (___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'type')) == 'invitation') {
    if (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'sender')), 'gender')) {
      if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'sender')), 'gender')) == 'Female') {
        title = [activityName,' - ',name2,' has invited you to her activity '].join('');
      } else if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'sender')), 'gender')) == 'Male') {
        title = [name2,' has invited you to his activity ',activityName].join('');
      } else {
        title = [name2,' has invited you to they activity ',activityName].join('');
      }
    }
  } else if (___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b6630085d09adb7f8b08af4e414e1a97'), 'type')) == 'activityRequest') {
    title = [activityName,' - ',name2,' would like to join you'].join('');
  } else {
    title = String(name2) + String(' requested permissions to view your photos');
  }

  return title

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/adc40e2ee9cd19992ff9d1a21a5779f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisible = false;
  var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('57d9567f707fa45310b99cff3512d022'), 'chats'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(j, 'recentMessage')), 'receiver')), 'objectId')) && !(getObjectProperty(j, 'chatIsRead'))) {
      isVisible = true;
      break;
    }
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/87c9f56b9d1986c8b4a12a96faec210c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible, chat, activity;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVisible = false;
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'myActivities')) {
    var activity_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'myActivities'));
    for (var activity_index in activity_list) {
      activity = activity_list[activity_index];
      var chat_list = (getObjectProperty(activity, 'chats'));
      for (var chat_index in chat_list) {
        chat = chat_list[chat_index];
        if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(chat, 'recentMessage')), 'receiver')), 'objectId')) && !(getObjectProperty(chat, 'chatIsRead'))) {
          isVisible = true;
          break;
        }
      }
      if (isVisible) {
        break;
      }
    }
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/8ac5124f49da89ca63b2083c712272c3/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isRead;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isRead = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'recentMessage')), 'receiver')), 'objectId')) && !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('49096b92542f1bb284934ebf62a9245b'), 'chat')), 'chatIsRead'));

  return isRead

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/a9d46ad5d16640a98432c75debf4da61/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVissible, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  isVissible = false;
  var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'invitedActivities'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(j, 'chat')), 'recentMessage')), 'receiver')), 'objectId')) && !(getObjectProperty((getObjectProperty(j, 'chat')), 'chatIsRead'))) {
      isVissible = true;
    }
  }

  return isVissible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/6709b5953c23d73d9f224eb9e5d88b12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var visible, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  visible = false;
  if (___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708')) {
    var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'receivedSystemMessages'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (!(getObjectProperty(j, 'chatIsRead'))) {
        visible = true;
        break;
      }
    }
  }

  return visible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/834ee899b557cdd8432494d20256efec/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var isVisible, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'receivedSystemMessages')) {
    isVisible = false;
    var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'receivedSystemMessages'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (!(getObjectProperty(j, 'chatIsRead'))) {
        isVisible = true;
        break;
      }
    }
  }

  return isVisible

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/6b577d392fe11a86b72cd12f2e5f934f/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  async ['onDynamicItemsAssignment'](___arguments) {
    var byMeChats, byMeName, byMeMessages, chat;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'searchInput')) && getValueLength((getObjectProperty(___arguments.context.pageData, 'searchInput'))) > 1) {
    if (((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793'), 'name')).trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1) {
      byMeChats = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793'), 'chats'));
    } else {
      byMeChats = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793'), 'chats')), async (chat) => {
         byMeName = (getObjectProperty((getObjectProperty(chat, 'sender')), 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) ? ((getObjectProperty((getObjectProperty(chat, 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty(chat, 'receiver')), 'name')) : (getObjectProperty((getObjectProperty(chat, 'receiver')), 'login'))) : ((getObjectProperty((getObjectProperty(chat, 'sender')), 'name')) ? (getObjectProperty((getObjectProperty(chat, 'sender')), 'name')) : (getObjectProperty((getObjectProperty(chat, 'sender')), 'login')));
        byMeMessages = ((getObjectProperty(chat, 'message')).map(item => item['message'])).join(' ');


       return (((byMeMessages.trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1) || ((byMeName.trim().toLowerCase()).indexOf((getObjectProperty(___arguments.context.pageData, 'searchInput'))) !== -1));
      }));
    }
  } else {
    byMeChats = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('cd753f78175390294544bc17bc05c793'), 'chats'));
  }

  return byMeChats

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/messages/components/3e919c7dd67a19a9dd62b9f7d293867e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/b3b3cad19761900d30ee220379d76dc5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/083696e161ae23f3cc22f4bef00d7291/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/7419f70a9f582024be5ad67b3378a45d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var activityName, name2, title;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'receiver')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'receiver')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'receiver')), 'login'));
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'currentActivity')) {
      activityName = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'currentActivity')), 'name')) ? ['"',(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'currentActivity')), 'name')),'"'].join('') : '';
    }
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'type')) == 'invitation') {
      title = ['You invited ',name2,' to your activity ',activityName].join('');
    } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'type')) == 'activityRequest') {
      title = ['You requested to join ',name2,'’s activity ',activityName].join('');
    } else {
      title = ['You requested permissions to view ',name2,'\'s photos'].join('');
    }
  }

  return title

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/f303a567111ef02d43227e742b3f3953/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var authorPhoto;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8')) {
    authorPhoto = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'receiver')), 'photoThumbnail')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('b8c7f6fd977547c21cf106878ef9dac8'), 'receiver')), 'photoThumbnail')) : 'styles/img/placeholder_photo.png';
  }

  return authorPhoto

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/f962568c2bb45cae90e7cb7ab749ca12/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/abe8f7d3aca2ad8994fc2db22d82934a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var list;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9903c2f3f164d88e243ab81a181a36de')).includes('filterHeading__searchBl--openMessages')) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9903c2f3f164d88e243ab81a181a36de')), 'filterHeading__searchBl--openMessages', '');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9903c2f3f164d88e243ab81a181a36de')).push('filterHeading__searchBl--openMessages');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/afd356b7bbf6e486140c8afff2670cde/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getValueLength(___arguments.value.trim()) > 1 && (getObjectProperty(___arguments.context.pageData, 'openMessage'))) {
    ___arguments.context.pageData['currentActivity'] = null;
    ___arguments.context.pageData['openMessage'] = null;
    ___arguments.context.pageData['selectedAct'] = null;
  }
  ___arguments.context.pageData['searchInput'] = (___arguments.value.trim().toLowerCase());

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/messages/components/d4c279198f8ceca3827578436306c0be/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'myActivities')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'myActivities')).length ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'myActivities')).length : '0')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/4ba8302d0cd3e9231f063e98b756d8b2/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var num;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'invitedActivities')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'invitedActivities')).length ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'invitedActivities')).length : '0')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/34a554198964a4eedada32989663357f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var num;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'receivedSystemMessages')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'receivedSystemMessages')).length ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'receivedSystemMessages')).length : '0')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/ee3fa6656f1b30d5bf3c1fcdbaa56fff/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var num;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'sentSystemMessages')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'sentSystemMessages')).length ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('fec7f882dd2d3f2d1e2c8ad158cb1708'), 'sentSystemMessages')).length : '0')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/messages/components/bb9b2f6c4b2ae7de5136ddaacd88c7af/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'selectedAct')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('57d9567f707fa45310b99cff3512d022'), 'objectId')) ? ['messages__asideSpoilerArrow', 'messages__asideSpoilerArrow--right', 'messages__asideSpoilerArrow--active'] : ['messages__asideSpoilerArrow', 'messages__asideSpoilerArrow--right'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/messages/components/20f811220e8bde3462192aa28deb4e1e/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'photoThumbnail'));
      }
    } else {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'photoThumbnail'));
      }
    }
  }

  return ''

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/messages/components/caaddd885f87bc1b8a0e7fbf8b3b0861/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  async ['onScroll'](___arguments) {
    var sortList, moreMessages, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')) {
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message')).length >= 10) {
        if (___arguments.scrollTop == 0 && !(getObjectProperty(___arguments.context.pageData, 'noMoreMessages'))) {
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9915ee5b4aff26c256e3062303d2a45', true);
          moreMessages = (await asyncListSort((await Backendless.Request.get(`${Backendless.appPath}/services/messages/getOnScrollMessages`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'chatId': JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'objectId'))),'created': (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'))[0]), 'created')),'pageSize': 10 }).send()), 1, async (item) => {


           return (getObjectProperty(item, 'created'));
          }));
          if (!!moreMessages.length) {
            if (getObjectProperty(___arguments.context.pageData, 'openMessage')) {
              sortList = (moreMessages.concat((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'message'))));
              (getObjectProperty(___arguments.context.pageData, 'openMessage'))['message'] = sortList;
            }
          } else {
            ___arguments.context.pageData['noMoreMessages'] = true;
          }
          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c9915ee5b4aff26c256e3062303d2a45', false);
        }
      }
    }
  }

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/messages/components/fef89752648d896da6aa0b3cfec89e0f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['selectedAct'] = '';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/90fd217a0a94755ba05abb98781a4433/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).includes('open')) {
    ___arguments.context.pageData['currentActivity'] = null;
    ___arguments.context.pageData['openMessage'] = null;
    ___arguments.context.appData['openMessage'] = null;
    while (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')).includes('open')) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('caaddd885f87bc1b8a0e7fbf8b3b0861')), 'open', '');
    }
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('9dc71184ccf28521b01e69cd7beffb74'))['width'] = 0;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18689941caa93ef7868521435ca4d6b2', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4c0a4df38f39912e40a372a4c2d8db9a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('613b611a25aa28f8d6a15151b82ff19a', true);
    await Backendless.Hive('CurrentUserChat').KeyValueStore((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))).delete();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/40e95aa32742b3f44911ac4b6f4a5f7a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'chats')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/f8f449e2d15dd505e867924f159a9e33/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentTab')) == 'invitations')

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/messages/components/b075ad2e6c094b9f7edb816b55fa54d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/fe5ee8a866835f9b50ed6fc41a922a67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/8d0152d94451839b51c49d318dc63383/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/messages/components/f4b9d5ff2b7f0fcffc68c6a5e2961ed9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'sender')), 'objectId')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'openMessage')), 'receiver')), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/modal/components/4656e7b669fd310c5462125d02b29333/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/modal/components/27292276b8a4ecdff87d30d618b5bf59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('personal-data-quiz', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/modal/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) {
      return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'name')) + String('\'s activity'));
    } else {
      return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivityOwner')), 'login')) + String('\'s activity'));
    }
  } else {
    return 'Activity';
  }

  },
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async onEnter(___arguments) {
    var item, object, currentUser;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getRTSubscriptions() { const subs = getGlobalEntitiesMap('subscriptions');subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`RT subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}


  currentUser = (await Backendless.UserService.getCurrentUser(false));
  if (!currentUser) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('launch', null);
  } else if (!(___arguments.context.appData['login'])) {
    ___arguments.context.appData['login'] = (currentUser['login']);
    if (currentUser['photo']) {
      ___arguments.context.appData['photo'] = (currentUser['photo']);
    }
  }
  if ((___arguments.context.appData['profileStatus']) == false) {
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-profile', null);
  }
  ___arguments.context.pageData['currentActivity'] = ((await Backendless.Data.of('Activity').find(Backendless.DataQueryBuilder.create().setWhereClause((['objectId=\'',(___arguments.context.pageData['activityId']),'\''].join(''))).setRelationsDepth(3).setPageSize(1)))[0]);
  ___arguments.context.pageData['users'] = (await Backendless.Data.of('Users').find(Backendless.DataQueryBuilder.create().setWhereClause((String(['objectId=\'',((await Backendless.UserService.getCurrentUser(false))['objectId']),'\''].join('')) + String([' or objectId=\'',((___arguments.context.pageData['currentActivity'])['ownerId']),'\''].join('')))).excludeProperties(['email']).setRelationsDepth(2).setPageSize(2)));
  ___arguments.context.pageData['currentUser'] = ((await asyncListFilter((___arguments.context.pageData['users']), async (item) => {


   return ((item['objectId']) == ((await Backendless.UserService.getCurrentUser(false))['objectId']));
  }))[0]);
  if (((___arguments.context.pageData['currentUser'])['profileStatus']) == false) {
    ___arguments.context.appData['profileStatus'] = false;
    ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-profile', null);
  }
  ___arguments.context.pageData['currentActivityOwner'] = ((await asyncListFilter((___arguments.context.pageData['users']), async (item) => {


   return ((item['objectId']) == ((___arguments.context.pageData['currentActivity'])['ownerId']));
  }))[0]);
  ___arguments.context.pageData['activityList'] = (await Backendless.Data.of('Activity').find(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId=\'',((___arguments.context.pageData['currentActivityOwner'])['objectId']),'\''].join(''))).setHavingClause((['visibility!=3 and (activityDate is null or activityDate >=',((new Date()).valueOf()),')'].join(''))).setRelated('category').setSortBy('activityDate').setPageSize(3)));
  ___arguments.context.pageData['alertMessage'] = (['Describe why ',((___arguments.context.pageData['currentActivityOwner'])['name']),' need to pick you'].join(''));
  if ((___arguments.context.pageData['currentActivity'])['media']) {
    ___arguments.context.pageData['imageList'] = ((___arguments.context.pageData['currentActivity'])['media']);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ddf3159b707971be8f264be6a9215538', true);
  }
  ___arguments.context.pageData['location'] = ((___arguments.context.pageData['currentActivity'])['location']);
  if (!!((___arguments.context.pageData['currentActivity'])['chat']).length) {
    if (!!(await asyncListFilter(((___arguments.context.pageData['currentActivity'])['chat']), async (item) => {


     return (((item['sender'])['objectId']) == ((___arguments.context.pageData['currentUser'])['objectId']));
    })).length) {
      addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('7acf273cdc154e7c1f0ff85b33388e65')), 'disabled');
    }
  }
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3c872f5d052e97d671d3b064b9a502e1', false);

  ;(function() {
    const callback = async object => {
        if ((((___arguments.context.pageData['currentActivityOwner'])['userProfile'])['objectId']) == (object['objectId'])) {
      ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('572adc8c4cdfc6b7ee652b6ffd69ca6f'))['content'] = (object['likesCount']);
      ((___arguments.context.pageData['currentActivityOwner'])['userProfile'])['likesCount'] = (object['likesCount']);
    }

    };

    const rtHandlers = Backendless.Data.of('UserProfile').rt();

    const whereClause = '';
    const options = [callback];

    if (whereClause) {
       options.unshift(whereClause);
    }

    rtHandlers.addUpdateListener.apply(rtHandlers, options);

    getRTSubscriptions().add((((___arguments.context.pageData['currentActivityOwner'])['userProfile'])['objectId']), () => rtHandlers.removeUpdateListener(callback));

  })()
    if (!!(await asyncListFilter((((___arguments.context.pageData['currentUser'])['userProfile'])['myLikes']), async (item) => {


   return ((item['objectId']) == ((___arguments.context.pageData['currentActivityOwner'])['objectId']));
  })).length) {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('dfeb464bec4359fb436190f36259f96a')), 'clicked');
  }
  ___arguments.context.pageData['isInvitation'] = ((await Backendless.Data.of('chat').find(Backendless.DataQueryBuilder.create().setWhereClause((String(['activityId=\'',((___arguments.context.pageData['currentActivity'])['objectId']),'\''].join('')) + String([' and receiver.objectId=\'',((___arguments.context.pageData['currentUser'])['objectId']),'\''].join('')))).setPageSize(1)))[0]);

  },  
  /* handler:onEnter */
  /* content */
}))

define('./pages/out-of-service/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'Outside of our service area'

  },  
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function() {
  	const meta = document.createElement('meta')

  	meta.setAttribute('property', 'og:title')
  	meta.setAttribute('content', 'Check out this new connection platform I found: https://app.findmyplus.one. Post an activity and get matched with a perfect +1')

  	document.querySelector("head").appendChild(meta)

  })();
  if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) && !(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'photo'));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_outofservice_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/out-of-service/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['','© ',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Online Community Company in USA. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/out-of-service/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/out-of-service/components/259d59697c4d7ffdda01e74eee1283e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await ( async function (url, isExternal, params) { const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://twitter.com/intent/tweet', true, ({ 'text': 'Check out this new connection platform I found: https://www.findmyplus.one/. Post an activity and get matched with a perfect +1' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/out-of-service/components/ce46575329e111167b931c79d1975134/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await ( async function (url, isExternal, params) { const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://facebook.com/sharer/sharer.php', true, ({ 'u': 'https://www.findmyplus.one/','quote': 'Check out this new connection platform I found. Post an activity and get matched with a perfect +1' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/out-of-service/components/4991073e9f1a408ee9afcc58e85e67cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.linkedin.com/shareArticle', true, ({ 'url': 'https://findmyplus.one/','title': 'findmyplusone' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/out-of-service/components/57615acf9b55e583cdb108aaba3133ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/out-of-service/components/34640ffe7563d11998bd3bb6d9076f92/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/out-of-service/components/46258ecc13d4938c2b428c36eb6a9374/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('bfb8c73aa8c2f3dc6e37c7f9116ae2d5')), 'open');

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/out-of-service/components/7c93fc68b405de369cdb8e65db019117/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['tellFriendsStr'] = 'Tell your friends about us <b>to get us up</b> and <b>running even faster</b>';

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/out-of-service/components/5543bb8af0da88e2b8774f9ea629eaf4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-activities', ({ 'outOfService': true }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/out-of-service/components/edef64e135394ac41b6b8e8fdd3ae237/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/password-recovery/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'Password recovery'

  },  
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;


  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_passwordrecovery_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/password-recovery/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/password-recovery/components/0d3cb78845c8ae897e2cbd7862a8948e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var email, regExp;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageDataUser'] = '';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('04af6dccd02f14d104473f0d5c3404d8', false);
  ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = '';
  email = (___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['email']);
  regExp = (await BackendlessUI.Functions.Custom['fn_33d4b09fd437e3c36dee5ef9d12d4fa1'](email));
  if (!email) {
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = 'Please, enter email address.';
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')), 'alert-border');
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')).pop();
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async onFocus(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = '50vh';
    ;await ( async function (component){ component.el.scrollIntoView() })(((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  async onBlur(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/password-recovery/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['© ',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/password-recovery/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://findmyplus.one/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/password-recovery/components/8ea7063f7cc9f73bacc117e26f3ba587/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var email, user;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1aab1d0b9eed92a448c21763a4581401', true);
  await Backendless.Request.put(`${Backendless.appPath}/services/passwordRecovery/recoverPassword`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'email'))));
  await new Promise(r => setTimeout(r, 1000 || 0));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1bac70e39cddb3b1e7f4a039f32f0449', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('452cc4e7ebab10572cf35f18dc02c951', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/password-recovery/components/c5ebc3f90ddda4b8eac89f0e29bec362/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var email, user;


  window.location = (await Backendless.UserService.getAuthorizationUrlLink('googleplus', null, null, false, ('activities-search' ? window.location.href.split('?')[0] + '?page=' + 'activities-search' : window.location.href)))
  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/password-recovery/components/57da9c9530a6d5fa2d5ab984a267e43e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      window.location = (await Backendless.UserService.getAuthorizationUrlLink('facebook', null, null, false, ('activities-search' ? window.location.href.split('?')[0] + '?page=' + 'activities-search' : window.location.href)))
  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/password-recovery/components/ab7b5f2ef37a13a3b9555ae1e128a955/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var user, token;


  token = (await (async function() {
  	const AppleID  = await BackendlessUI.requireModule('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js')

  	AppleID.auth.init({
  	  clientId : 'com.backendless.findmy',
  	  scope : 'email',
  	  redirectURI: 'https://app.findmyplus.one/app/?page=social-login',
  	  state : 'gfdghdfgssdf',
  	  //nonce : '[NONCE]',
  	  usePopup : true
  	})

  	const { authorization} = await AppleID.auth.signIn()

  	return authorization.id_token
  })());
  user = (await Backendless.Request.post(`${Backendless.appPath}/services/AppleAuth/login`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(token)));
  await (async function(user) {
  	Backendless.Users.setCurrentUser(user, true)
  })(user);
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/password-recovery/components/6284fae3d6cc16da1af6cc0d8e3bba21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('login', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/f4fd1d5aedec57e435e6199b8f62e533/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['selectHeight'] = ((getObjectProperty(___arguments.context.pageData, 'selectHeight')) * 1);
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8e7ba2ad9bd674993fba6a15a5f7feb4'))['2'] = 'quiz__step--active';
  ___arguments.context.pageData['stepCount'] = '2/9';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6598084651598ceef598a31defd2b5c9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6222e5053dbdf6652a052d53e8fdc063', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33f32d9ebef54b876698895fed12df31', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/79fe8f35d3f58404841caca9f5cd6824/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.pageData['stepCount'] = '1/9';

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/personal-data-quiz/components/14ca8a4b194f83cf5f06fd3a92288dee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('122cee8f42119285088fe064408148ea'))['2'] = 'quiz__step--active';
  ___arguments.context.pageData['stepCount'] = '3/9';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6598084651598ceef598a31defd2b5c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d6eac515ad6801ee30fa26ee4acc0d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/08980b04e2618af3506e42e240ff7342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0b2f24f9001e1718cf5bf1b33329df75'))['2'] = 'quiz__step--active';
  ___arguments.context.pageData['stepCount'] = '4/9';
  ___arguments.context.pageData['children'] = ((getObjectProperty(___arguments.context.pageData, 'children')) * 1);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23741ad16aca770655081927ab240275', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d6eac515ad6801ee30fa26ee4acc0d8', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/d4298dab3979e3decd7869c44f7a89d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c567eeba823d5f01dcba973ea9c27d7b'))['2'] = 'quiz__step--active';
  ___arguments.context.pageData['stepCount'] = '5/9';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa4bf6721a753bfb5203ac29fe4b1186', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23741ad16aca770655081927ab240275', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/9a7f19f725aedd6c33ebccabc4828886/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['ethnicity'] = (___arguments.context.dataModel['objectId']);
  ___arguments.context.pageData['ethnicityId'] = ((___arguments.context.dataModel['id']) * 1);

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.pageData['ethnicity']) == (___arguments.context.dataModel['objectId'])) {
    return ['activity-page__category-item activity-page__category-item-active'];
  }

  return ['activity-page__category-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/28e94501608d16eb2166010e09a1c5cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['maritalStatus'] = (___arguments.context.dataModel['objectId']);
  ___arguments.context.pageData['maritalStatusId'] = (___arguments.context.dataModel['id']);

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.pageData['maritalStatus']) == (___arguments.context.dataModel['objectId'])) {
    return ['activity-page__category-item activity-page__category-item-active'];
  }

  return ['activity-page__category-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/a51aba0471aa872cb7c4dc0b40ffd763/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('96fbc2810963c49665885b65a156f891', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7e6d6011734cbf19e30273aeb1f9ab4b', false);
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449')), 'personal-data__quiz ');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1bac70e39cddb3b1e7f4a039f32f0449', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c98697816d2e1b96e86cec2c14dbacad', true);
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8d168aace99e6f9c71adfc78f96a9193')), 'personal-data__quiz ');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c98697816d2e1b96e86cec2c14dbacad')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/885ab9d8156ccb37488c5f233464d845/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var height;


  height = [({ 'value': '122','label': '4′0″ (122 cm)' }), ({ 'value': '124','label': '4′1″ (124 cm)' }), ({ 'value': '127','label': '4′2″ (127 cm)' }), ({ 'value': '130','label': '4′3″ (130 cm)' }), ({ 'value': '132','label': '4′4″ (132 cm)' }), ({ 'value': '135','label': '4′5″ (135 cm)' }), ({ 'value': '137','label': '4′6″ (137 cm)' }), ({ 'value': '140','label': '4′7″ (140 cm)' }), ({ 'value': '142','label': '4′8″ (142 cm)' }), ({ 'value': '145','label': '4′9″ (145 cm)' }), ({ 'value': '152','label': '5′0″ (152 cm)' }), ({ 'value': '155','label': '5′1″ (155 cm)' }), ({ 'value': '157','label': '5′2″ (157 cm)' }), ({ 'value': '160','label': '5′3″ (160 cm)' }), ({ 'value': '163','label': '5′4″ (163 cm)' }), ({ 'value': '165','label': '5′5″ (165 cm)' }), ({ 'value': '168','label': '5′6″ (168 cm)' }), ({ 'value': '170','label': '5′7″ (170 cm)' }), ({ 'value': '173','label': '5′8″ (173 cm)' }), ({ 'value': '176','label': '5′9″ (176 cm)' }), ({ 'value': '178','label': '5′10″ (178 cm)' }), ({ 'value': '180','label': '5′11″ (180 cm)' }), ({ 'value': '183','label': '6′0″ (183 cm)' }), ({ 'value': '185','label': '6′1″ (185 cm)' }), ({ 'value': '188','label': '6′2″ (188 cm)' }), ({ 'value': '191','label': '6′3″ (191 cm)' }), ({ 'value': '193','label': '6′4″ (193 cm)' }), ({ 'value': '195','label': '6′5″ (195 cm)' }), ({ 'value': '198','label': '6′6″ (198 cm)' }), ({ 'value': '201','label': '6′7″ (201 cm)' }), ({ 'value': '203','label': '6′8″ (203 cm)' }), ({ 'value': '206','label': '6′9″ (206 cm)' }), ({ 'value': '208','label': '6′10″ (208 cm)' }), ({ 'value': '211','label': '6′11″ (211 cm)' }), ({ 'value': '213','label': '7′0″ (213 cm)' })];

  return height

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/444d8e69b706929aa7e4a09ed2924301/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')).slice(-1)[0] != 'quiz__gender-item-active') {
    ___arguments.context.pageData['children'] = '-1';
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')), 'quiz__gender-item-active');
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')).pop();
    }
  } else {
    delete ___arguments.context.pageData['children'];
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/6ab90b1571c517133ae4bc35f4e9f5fb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')).slice(-1)[0] != 'quiz__gender-item-active') {
    ___arguments.context.pageData['children'] = '1';
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')), 'quiz__gender-item-active');
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')).pop();
    }
  } else {
    delete ___arguments.context.pageData['children'];
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/bdca6d4b77b675bcb9ff1b43297c480d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')).slice(-1)[0] != 'quiz__gender-item-active') {
    ___arguments.context.pageData['children'] = '2';
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')), 'quiz__gender-item-active');
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')).pop();
    }
  } else {
    delete ___arguments.context.pageData['children'];
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/e204f16c7de2331234dc1c46e37977fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')).slice(-1)[0] != 'quiz__gender-item-active') {
    ___arguments.context.pageData['children'] = '3';
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')), 'quiz__gender-item-active');
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')).pop();
    }
  } else {
    delete ___arguments.context.pageData['children'];
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/86dc65382b03510169210b6637e6ea75/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')).slice(-1)[0] != 'quiz__gender-item-active') {
    ___arguments.context.pageData['children'] = '';
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')), 'quiz__gender-item-active');
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('444d8e69b706929aa7e4a09ed2924301')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('6ab90b1571c517133ae4bc35f4e9f5fb')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('bdca6d4b77b675bcb9ff1b43297c480d')).pop();
    }
    if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e204f16c7de2331234dc1c46e37977fd')).pop();
    }
  } else {
    delete ___arguments.context.pageData['children'];
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('86dc65382b03510169210b6637e6ea75')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/339cf8cd147458b61ad48a4676eabf5d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['bodyType'] = (___arguments.context.dataModel['objectId']);
  ___arguments.context.pageData['bodyTypeId'] = (___arguments.context.dataModel['id']);

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.pageData['bodyType']) == (___arguments.context.dataModel['objectId'])) {
    return ['activity-page__category-item activity-page__category-item-active'];
  }

  return ['activity-page__category-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/0c67101724dc78a4db797b2c785ed5ef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ___arguments.context.pageData['sexualOrientation'] = (___arguments.context.dataModel['objectId']);
  ___arguments.context.pageData['sexualOrientationId'] = (___arguments.context.dataModel['id']);

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.pageData['sexualOrientation']) == (___arguments.context.dataModel['objectId'])) {
    return ['activity-page__category-item activity-page__category-item-active'];
  }

  return ['activity-page__category-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/a38c3db7dba985669a3300fe5c25af61/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5aeeaf4f73d3f9212d1aa46e25e64d4d'))['2'] = 'quiz__step--active';
  ___arguments.context.pageData['stepCount'] = '6/9';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa4bf6721a753bfb5203ac29fe4b1186', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c74e83c689932cfe4c9966dc9386821', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/b7ec3679f86cce5f1c29daa3f9f76735/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('94dca74b2cf437e8dc5daec93cd7aaa3'))['2'] = 'quiz__step--active';
  ___arguments.context.pageData['stepCount'] = '7/9';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c74e83c689932cfe4c9966dc9386821', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d31b47cac39c7d53808f76b2f94b409', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/2ab92eb1f8236edd34c2beec673d54b7/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    
  },  
  /* handler:onMounted */
  /* handler:onScroll */
  onScroll(___arguments) {
    
  },  
  /* handler:onScroll */
  /* content */
}))

define('./pages/personal-data-quiz/components/fbacfa7a9d74ae34b6ade776df5f7002/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    
  },  
  /* handler:onMounted */
  /* handler:onScroll */
  onScroll(___arguments) {
    
  },  
  /* handler:onScroll */
  /* content */
}))

define('./pages/personal-data-quiz/components/dc7275c9c2b9d6f51433a1ae51d2e32b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8e7c059282ffa11b0e18302d979552a1'))['2'] = 'quiz__step--active';
  ___arguments.context.pageData['stepCount'] = '8/9';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d31b47cac39c7d53808f76b2f94b409', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7efd7f979784f79ba7b4ff8459c525d3', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/88cb170ae9e5e8640ebf36cf0ab59315/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8d393244056475f37b8e0cfca60d5702'))['2'] = 'quiz__step--active';
  ___arguments.context.pageData['stepCount'] = '9/9';
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7efd7f979784f79ba7b4ff8459c525d3', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0756b8cd53a98531575a96570bfb59cf', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/0e38e0ea96c8cd01f53dc5a6b53e8b7c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var personalData, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c98697816d2e1b96e86cec2c14dbacad', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ed6212ed267c1f8a7b325c4a2d4c64ea', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('96fbc2810963c49665885b65a156f891', false);
  currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  personalData = ({ 'height': (getObjectProperty(___arguments.context.pageData, 'selectHeight')),'maritalStatus': (getObjectProperty(___arguments.context.pageData, 'maritalStatusId')),'children': (getObjectProperty(___arguments.context.pageData, 'children')),'ethnicity': (getObjectProperty(___arguments.context.pageData, 'ethnicityId')),'bodyType': (getObjectProperty(___arguments.context.pageData, 'bodyTypeId')),'sexOrientation': (getObjectProperty(___arguments.context.pageData, 'sexualOrientationId')),'educationLevel': (getObjectProperty(___arguments.context.pageData, 'education')),'politicalView': (getObjectProperty(___arguments.context.pageData, 'political')) });
  if (currentUser) {
    await Backendless.Data.of('UserProfile').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'objectId')),'\''].join('')), personalData );
    await Backendless.Data.of('UserProfile').setRelation((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'objectId')), 'myInterests', (getObjectProperty(___arguments.context.pageData, 'interest')));
  } else {
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['height'] = (getObjectProperty(___arguments.context.pageData, 'selectHeight'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['maritalStatus'] = (getObjectProperty(___arguments.context.pageData, 'maritalStatusId'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['children'] = (getObjectProperty(___arguments.context.pageData, 'children'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['ethnicity'] = (getObjectProperty(___arguments.context.pageData, 'ethnicityId'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['bodyType'] = (getObjectProperty(___arguments.context.pageData, 'bodyTypeId'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['sexualOrientation'] = (getObjectProperty(___arguments.context.pageData, 'sexualOrientationId'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['educationLevel'] = (getObjectProperty(___arguments.context.pageData, 'education'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['politicalView'] = (getObjectProperty(___arguments.context.pageData, 'political'));
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/f3a20db8a8d28ca111a1f9bb15586038/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var height;


  await new Promise(r => setTimeout(r, 1000 || 0));
  height = [({ 'value': '122','label': '4′0″ (122 cm)' }), ({ 'value': '124','label': '4′1″ (124 cm)' }), ({ 'value': '127','label': '4′2″ (127 cm)' }), ({ 'value': '130','label': '4′3″ (130 cm)' }), ({ 'value': '132','label': '4′4″ (132 cm)' }), ({ 'value': '135','label': '4′5″ (135 cm)' }), ({ 'value': '137','label': '4′6″ (137 cm)' }), ({ 'value': '140','label': '4′7″ (140 cm)' }), ({ 'value': '142','label': '4′8″ (142 cm)' }), ({ 'value': '145','label': '4′9″ (145 cm)' }), ({ 'value': '152','label': '5′0″ (152 cm)' }), ({ 'value': '155','label': '5′1″ (155 cm)' }), ({ 'value': '157','label': '5′2″ (157 cm)' }), ({ 'value': '160','label': '5′3″ (160 cm)' }), ({ 'value': '163','label': '5′4″ (163 cm)' }), ({ 'value': '165','label': '5′5″ (165 cm)' }), ({ 'value': '168','label': '5′6″ (168 cm)' }), ({ 'value': '170','label': '5′7″ (170 cm)' }), ({ 'value': '173','label': '5′8″ (173 cm)' }), ({ 'value': '176','label': '5′9″ (176 cm)' }), ({ 'value': '178','label': '5′10″ (178 cm)' }), ({ 'value': '180','label': '5′11″ (180 cm)' }), ({ 'value': '183','label': '6′0″ (183 cm)' }), ({ 'value': '185','label': '6′1″ (185 cm)' }), ({ 'value': '188','label': '6′2″ (188 cm)' }), ({ 'value': '191','label': '6′3″ (191 cm)' }), ({ 'value': '193','label': '6′4″ (193 cm)' }), ({ 'value': '195','label': '6′5″ (195 cm)' }), ({ 'value': '198','label': '6′6″ (198 cm)' }), ({ 'value': '201','label': '6′7″ (201 cm)' }), ({ 'value': '203','label': '6′8″ (203 cm)' }), ({ 'value': '206','label': '6′9″ (206 cm)' }), ({ 'value': '208','label': '6′10″ (208 cm)' }), ({ 'value': '211','label': '6′11″ (211 cm)' }), ({ 'value': '213','label': '7′0″ (213 cm)' })];

  },
  /* handler:onMounted */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    
  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/personal-data-quiz/components/10617bec966a797d7a96337d847bb434/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var itemTop;



  return ['quiz__height-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/84f183b7d8a936f6250e5994d319b3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var item;


  if ((___arguments.context.pageData['interest']).includes((___arguments.context.dataModel['objectId']))) {
    return ['activity-page__quality-item', 'activity-page__quality-item-active'];
  }

  return ['activity-page__category-item']

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((___arguments.context.pageData['interest']).includes((___arguments.context.dataModel['objectId']))) {
    ___arguments.context.pageData['interest'] = (await asyncListFilter((___arguments.context.pageData['interest']), async (item) => {


     return (item != (___arguments.context.dataModel['objectId']));
    }));
  } else {
    addItemToList((___arguments.context.pageData['interest']), (___arguments.context.dataModel['objectId']));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/33f32d9ebef54b876698895fed12df31/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0756b8cd53a98531575a96570bfb59cf'))['display']) == true) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7efd7f979784f79ba7b4ff8459c525d3', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0756b8cd53a98531575a96570bfb59cf', false);
    ___arguments.context.pageData['stepCount'] = '8/9';
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8d393244056475f37b8e0cfca60d5702')).pop();
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('7efd7f979784f79ba7b4ff8459c525d3'))['display']) == true) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7efd7f979784f79ba7b4ff8459c525d3', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d31b47cac39c7d53808f76b2f94b409', true);
    ___arguments.context.pageData['stepCount'] = '7/9';
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8e7c059282ffa11b0e18302d979552a1')).pop();
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6d31b47cac39c7d53808f76b2f94b409'))['display']) == true) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c74e83c689932cfe4c9966dc9386821', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6d31b47cac39c7d53808f76b2f94b409', false);
    ___arguments.context.pageData['stepCount'] = '6/9';
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('94dca74b2cf437e8dc5daec93cd7aaa3')).pop();
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('9c74e83c689932cfe4c9966dc9386821'))['display']) == true) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9c74e83c689932cfe4c9966dc9386821', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa4bf6721a753bfb5203ac29fe4b1186', true);
    ___arguments.context.pageData['stepCount'] = '5/9';
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('5aeeaf4f73d3f9212d1aa46e25e64d4d')).pop();
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fa4bf6721a753bfb5203ac29fe4b1186'))['display']) == true) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23741ad16aca770655081927ab240275', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa4bf6721a753bfb5203ac29fe4b1186', false);
    ___arguments.context.pageData['stepCount'] = '4/9';
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('c567eeba823d5f01dcba973ea9c27d7b')).pop();
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('23741ad16aca770655081927ab240275'))['display']) == true) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23741ad16aca770655081927ab240275', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d6eac515ad6801ee30fa26ee4acc0d8', true);
    ___arguments.context.pageData['stepCount'] = '3/9';
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('0b2f24f9001e1718cf5bf1b33329df75')).pop();
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0d6eac515ad6801ee30fa26ee4acc0d8'))['display']) == true) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6598084651598ceef598a31defd2b5c9', true);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d6eac515ad6801ee30fa26ee4acc0d8', false);
    ___arguments.context.pageData['stepCount'] = '2/9';
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('122cee8f42119285088fe064408148ea')).pop();
  }
  if ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('6598084651598ceef598a31defd2b5c9'))['display']) == true) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6598084651598ceef598a31defd2b5c9', false);
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6222e5053dbdf6652a052d53e8fdc063', true);
    ___arguments.context.pageData['stepCount'] = '1/9';
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8e7ba2ad9bd674993fba6a15a5f7feb4')).pop();
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('33f32d9ebef54b876698895fed12df31', false);
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/e6ef7d041ac13c14d411af83c3f8bd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('profiles', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/33fa9bfc9a64afa2cb8db4a6580b59fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/061e6307bb3fb9b624d268225542836e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('interests', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/07ae3011c136f963d8bf3248ffa9eccb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('profiles', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/b3372f6ac9172b9f4ac43c9eaf8cf874/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('create-activity', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) < 992) {
    return false;
  }

  return false

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/5fba0f3a99b6dbffed0c45512474ccb5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) < 992) {
    return false;
  }

  return true

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['© ',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/79c7b04f811ff50e569589a7c5e5b41d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('messages', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/eb12e5dc7373502a78063e5e7aa5c957/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://findmyplus.one/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/1bac70e39cddb3b1e7f4a039f32f0449/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.appData, 'userRoles'))) {
    ___arguments.context.appData['userRoles'] = (await Backendless.UserService.getUserRoles());
  }
  if (!((getObjectProperty(___arguments.context.appData, 'userRoles')).includes('dev'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('out-of-service', undefined);
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = ((function(){ try { return JSON.parse(localStorage.getItem('currentUser')) } catch(e){ return null }})());
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'photo'));
    ___arguments.context.appData['profileStatus'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'profileStatus'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/personal-data-quiz/components/b396680db47c2819f51d8bb87e2a2c45/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (___arguments.context.pageData['currentUser']) {
      return (!((___arguments.context.pageData['currentUser'])['photo']));
    } else if (___arguments.context.appData['photo']) {
      return (!(___arguments.context.appData['photo']));
    } else {
      return true;
    }
  } else {
    return true;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/f45cfd38a65f190edc6b5ea42557777a/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (!(getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.appData, 'login'))) {
      return (getObjectProperty(___arguments.context.appData, 'login'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) {
      return 'Account';
    } else {
      return 'Account';
    }
  } else {
    return 'Account';
  }

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/318563325306ad2e6d432468a69beb08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-profile', null);

  },  
  /* handler:onClick */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] != 'open') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')), 'open');
  }

  },  
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] == 'open') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).pop();
  }

  },  
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/personal-data-quiz/components/3644e7181decfd1b4a0ba3563c8ba44c/bundle.js', [], () => ({
  /* content */
  /* handler:onMouseOver */
  onMouseOver(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] != 'open') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')), 'open');
  }

  },  
  /* handler:onMouseOver */
  /* handler:onMouseOut */
  onMouseOut(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).slice(-1)[0] == 'open') {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('3644e7181decfd1b4a0ba3563c8ba44c')).pop();
  }

  },  
  /* handler:onMouseOut */
  /* content */
}))

define('./pages/personal-data-quiz/components/90c19d93eb614726a341c1fb5e768591/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-profile', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/9eae8aaea9c2c53768ab2ae436711e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-activities', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/8cadea982ab7c138c629aadb391c73c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('settings', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/607680653092fc2b09867b42d84b520d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  localStorage.removeItem('currentUser');
  localStorage.removeItem('tooltipInfo');
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('launch', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/personal-data-quiz/components/a39a09d543fd5b21f604eee16053f976/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var height;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  height = [({ 'value': '122','label': '4′0″ (122 cm)' }), ({ 'value': '124','label': '4′1″ (124 cm)' }), ({ 'value': '127','label': '4′2″ (127 cm)' }), ({ 'value': '130','label': '4′3″ (130 cm)' }), ({ 'value': '132','label': '4′4″ (132 cm)' }), ({ 'value': '135','label': '4′5″ (135 cm)' }), ({ 'value': '137','label': '4′6″ (137 cm)' }), ({ 'value': '140','label': '4′7″ (140 cm)' }), ({ 'value': '142','label': '4′8″ (142 cm)' }), ({ 'value': '145','label': '4′9″ (145 cm)' }), ({ 'value': '152','label': '5′0″ (152 cm)' }), ({ 'value': '155','label': '5′1″ (155 cm)' }), ({ 'value': '157','label': '5′2″ (157 cm)' }), ({ 'value': '160','label': '5′3″ (160 cm)' }), ({ 'value': '163','label': '5′4″ (163 cm)' }), ({ 'value': '165','label': '5′5″ (165 cm)' }), ({ 'value': '168','label': '5′6″ (168 cm)' }), ({ 'value': '170','label': '5′7″ (170 cm)' }), ({ 'value': '173','label': '5′8″ (173 cm)' }), ({ 'value': '176','label': '5′9″ (176 cm)' }), ({ 'value': '178','label': '5′10″ (178 cm)' }), ({ 'value': '180','label': '5′11″ (180 cm)' }), ({ 'value': '183','label': '6′0″ (183 cm)' }), ({ 'value': '185','label': '6′1″ (185 cm)' }), ({ 'value': '188','label': '6′2″ (188 cm)' }), ({ 'value': '191','label': '6′3″ (191 cm)' }), ({ 'value': '193','label': '6′4″ (193 cm)' }), ({ 'value': '195','label': '6′5″ (195 cm)' }), ({ 'value': '198','label': '6′6″ (198 cm)' }), ({ 'value': '201','label': '6′7″ (201 cm)' }), ({ 'value': '203','label': '6′8″ (203 cm)' }), ({ 'value': '206','label': '6′9″ (206 cm)' }), ({ 'value': '208','label': '6′10″ (208 cm)' }), ({ 'value': '211','label': '6′11″ (211 cm)' }), ({ 'value': '213','label': '7′0″ (213 cm)' })];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('a39a09d543fd5b21f604eee16053f976', height);
  ___arguments.context.pageData['selectHeight'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a39a09d543fd5b21f604eee16053f976'))[0]), 'value'));

  },
  /* handler:onMounted */
  /* handler:onScroll */
  onScroll(___arguments) {
    var heightElem, centerOfElem, currentItem, countOfItems, heightBlock;


  heightElem = (___arguments.context.pageData['heightIteminList']);
  centerOfElem = heightElem / 2;
  currentItem = (___arguments.scrollTop - centerOfElem) % heightElem;
  if (currentItem == 0) {
    ___arguments.context.pageData['selectHeight'] = ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('a39a09d543fd5b21f604eee16053f976'))[(((___arguments.scrollTop - centerOfElem) / heightElem + 1) - 1)])['value']);
  }

  },  
  /* handler:onScroll */
  /* content */
}))

define('./pages/personal-data-quiz/components/c76549031cd499192c577e8100a20c63/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['heightIteminList'] = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c76549031cd499192c577e8100a20c63'))));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/personal-data-quiz/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'Personal data quiz'

  },  
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.appData, 'statusList'))) {
    ___arguments.context.appData['profilesData'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'));
    ___arguments.context.appData['statusList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'statusList'));
    ___arguments.context.appData['ethnicityList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'ethnicityList'));
    ___arguments.context.appData['bodyTypeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'bodyTypeList'));
    ___arguments.context.appData['orientationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'orientationList'));
    ___arguments.context.appData['educationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'educationList'));
    ___arguments.context.appData['politicalList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'politicalList'));
    ___arguments.context.appData['religionList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList'));
    ___arguments.context.appData['hairColorList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'hairColorList'));
    ___arguments.context.appData['smokeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'smokeList'));
    ___arguments.context.appData['drinkList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'drinkList'));
  }
  ___arguments.context.pageData['educationList'] = (getObjectProperty(___arguments.context.appData, 'educationList'));
  ___arguments.context.pageData['politicalList'] = (getObjectProperty(___arguments.context.appData, 'politicalList'));
  ___arguments.context.pageData['profileMaritalStatus'] = (getObjectProperty(___arguments.context.appData, 'statusList'));
  ___arguments.context.pageData['profileEthnicity'] = (getObjectProperty(___arguments.context.appData, 'ethnicityList'));
  ___arguments.context.pageData['profileBodyType'] = (getObjectProperty(___arguments.context.appData, 'bodyTypeList'));
  ___arguments.context.pageData['profileSexOrientation'] = (getObjectProperty(___arguments.context.appData, 'orientationList'));
  ___arguments.context.pageData['interestList'] = (await Backendless.Data.of('Interest').find(Backendless.DataQueryBuilder.create().setPageSize(100)));
  ___arguments.context.pageData['interest'] = [];

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/personal-data-quiz/components/8c2a2f5907497a5b3d83901d1513a2c4/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await new Promise(r => setTimeout(r, 1000 || 0));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('8c2a2f5907497a5b3d83901d1513a2c4', (___arguments.context.pageData['educationList']));
  ___arguments.context.pageData['education'] = ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8c2a2f5907497a5b3d83901d1513a2c4'))[0])['id']);

  },  
  /* handler:onMounted */
  /* handler:onScroll */
  async onScroll(___arguments) {
    var heightElem, centerOfElem, currentItem, countOfItems, heightBlock;


  heightElem = (___arguments.context.pageData['heightItemEducation']);
  centerOfElem = heightElem / 2;
  heightBlock = (await ( async function (typeSize, component){ return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('8c2a2f5907497a5b3d83901d1513a2c4'))));
  countOfItems = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8c2a2f5907497a5b3d83901d1513a2c4')).length;
  currentItem = (___arguments.scrollTop - centerOfElem) % heightElem;
  if (currentItem == 0) {
    ___arguments.context.pageData['education'] = ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('8c2a2f5907497a5b3d83901d1513a2c4'))[(((___arguments.scrollTop - centerOfElem) / heightElem + 1) - 1)])['id']);
  }
  console.log(___arguments.context.pageData['education']);

  },  
  /* handler:onScroll */
  /* content */
}))

define('./pages/personal-data-quiz/components/f90378992633f41709d7a95dee3a048c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      ___arguments.context.pageData['heightItemEducation'] = (await ( async function (typeSize, component){ return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('f90378992633f41709d7a95dee3a048c'))));

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/personal-data-quiz/components/3ce5d3c461772574ef682b0499c79c1e/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await new Promise(r => setTimeout(r, 1000 || 0));
  ;(function (componentUid, listItems){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3ce5d3c461772574ef682b0499c79c1e', (___arguments.context.pageData['politicalList']));
  ___arguments.context.pageData['political'] = ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('3ce5d3c461772574ef682b0499c79c1e'))[0])['id']);

  },  
  /* handler:onMounted */
  /* handler:onScroll */
  async onScroll(___arguments) {
    var heightElem, centerOfElem, currentItem, countOfItems, heightBlock;


  heightElem = (___arguments.context.pageData['heightItemPolitical']);
  centerOfElem = heightElem / 2;
  heightBlock = (await ( async function (typeSize, component){ return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('3ce5d3c461772574ef682b0499c79c1e'))));
  countOfItems = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('3ce5d3c461772574ef682b0499c79c1e')).length;
  currentItem = (___arguments.scrollTop - centerOfElem) % heightElem;
  if (currentItem == 0) {
    ___arguments.context.pageData['political'] = ((((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('3ce5d3c461772574ef682b0499c79c1e'))[(((___arguments.scrollTop - centerOfElem) / heightElem + 1) - 1)])['id']);
  }
  console.log(___arguments.context.pageData['political']);

  },  
  /* handler:onScroll */
  /* content */
}))

define('./pages/personal-data-quiz/components/511b398e415e0b6e94d3b2a5981978eb/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      ___arguments.context.pageData['heightItemPolitical'] = (await ( async function (typeSize, component){ return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('511b398e415e0b6e94d3b2a5981978eb'))));

  },  
  /* handler:onMounted */
  /* content */
}))

define('./pages/personal-data-quiz/components/4b5f5e349843351e50af41c8d5c4d275/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (!(___arguments.context.pageData['messagesNumber']) || (___arguments.context.pageData['messagesNumber']) == 0) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['messagesNumber']) {
    return (___arguments.context.pageData['messagesNumber']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/d0593e877d654d44cf78c3d203669d2f/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
      return (___arguments.context.pageData['profileMaritalStatus'])

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/77b2bed9b84db24d55121aac42a38ffc/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
      return (___arguments.context.pageData['profileEthnicity'])

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/9735b1a8a1514dab275989031266226e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
      return (___arguments.context.pageData['profileBodyType'])

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/610348bb51566559357bfc1abdd146ce/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
      return (___arguments.context.pageData['profileSexOrientation'])

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/030954928cff14b427f568c9d7d6dea5/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
      return (___arguments.context.pageData['interestList'])

  },  
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/02d487547966b62541abc0d6e9038664/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (!(getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.appData, 'login'))) {
      return (getObjectProperty(___arguments.context.appData, 'login'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
    } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && !(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) {
      return 'Account';
    } else {
      return 'Account';
    }
  } else {
    return 'Account';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/personal-data-quiz/components/6e8c0ea150c559087b89fc3437166a29/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('groups', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return false;
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/4656e7b669fd310c5462125d02b29333/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/27292276b8a4ecdff87d30d618b5bf59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/7c0b817d980e31a3741e77c373f2619f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['counter'] = (String(getValueLength(___arguments.value)) + String('/500 symbols'));
  if (!___arguments.value.trim().length) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')), 'alert-border');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa53cae1ac9a5bb278d4f9d3b35d89a3', true);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')).slice(-1)[0] == 'alert-border') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')).pop();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa53cae1ac9a5bb278d4f9d3b35d89a3', false);
    }
  }

  },
  /* handler:onChange */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login'));
    return (String('Write your message to ') + String(name2));
  }

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/profile-page/components/c09c346410c1934301c759efb5a960ac/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) {
      return (['Invite ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')),' to be your '].join(''));
    } else {
      return (['Invite ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login')),' to be your '].join(''));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/dbe14ec582a2b1dbe503b87c85bc55da/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['counter'] = '0/500 symbols';

  },
  /* handler:onBeforeMount */
  /* handler:onClick */
  onClick(___arguments) {
    
  },
  /* handler:onClick */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await (async function() {
  	const block = document.querySelector('.request__message')

  	block.addEventListener('click', setClick)

  	function setClick () {
  	    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
  	    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c83c914d666551d4d7a6e81e0bcfdcc6'))['padding-bottom'] = '50vh';
  	    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5a25586377a56141620c14afd337299e')));
  	  }
  	}
  })();

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/profile-page/components/0763d153c58a9f88badfb46b4eeaf004/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item, newChat, gender, name2, isFormValid;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  isFormValid = true;
  if (!(getObjectProperty(___arguments.context.pageData, 'chosenActivity'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ddc3850232635edcd0c4b3c25378440d', true);
    isFormValid = false;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'requestMessage')) || !(getObjectProperty(___arguments.context.pageData, 'requestMessage')).trim().length) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')), 'alert-border');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa53cae1ac9a5bb278d4f9d3b35d89a3', true);
    isFormValid = false;
  }
  if (!isFormValid) {
    return ;
  }
  ___arguments.context.pageData['disableBtn'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7268b11e1d9bf02236710cc46317adc9', true);
  (getObjectProperty(___arguments.context.pageData, 'currentUserActivityList')).splice((((getObjectProperty(___arguments.context.pageData, 'currentUserActivityList')).indexOf(getObjectProperty(___arguments.context.pageData, 'chosenActivity')) + 1) - 1), 1);
  name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login'));
  ___arguments.context.pageData['successStr'] = (['We have successfully notified ',name2,' to be your ',' <img src="styles/img/icons/logoIcon.svg" style=" width: 25 px ;" /> ',' You will be notified once ','they accept your invitation and will be able to chat.'].join(''));
  newChat = (await Backendless.Request.post(`${Backendless.appPath}/services/createChat/createChatFromActivity`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'activityType': 'invitation','activityId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'chosenActivity')), 'objectId')),'plusOneId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')),'message': (getObjectProperty(___arguments.context.pageData, 'requestMessage')) }));
  ___arguments.context.pageData['requestMessage'] = '';
  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'gender')) == 'Female') {
      gender = 'her';
    } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'gender')) == 'Male') {
      gender = 'his';
    } else {
      gender = 'their';
    }
    await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('invites', ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),' invites you to be ',gender,' +1 for "',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'chosenActivity')), 'name')),'"'].join('')), 'messages', newChat, (getObjectProperty(___arguments.context.pageData, 'profileId')), null, null, null);

  } catch (error) {
    console.log(error);

  }
  ;(async () => {
      await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('receivedInvitation', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), newChat, null);

  })();
  if (getObjectProperty(___arguments.context.appData, 'userActivitiesForInvitation')) {
    ___arguments.context.appData['userActivitiesForInvitation'] = (await Promise.all((getObjectProperty(___arguments.context.appData, 'userActivitiesForInvitation')).map(async item => {  if ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'chosenActivity')), 'objectId'))) {
        if (Array.isArray((getObjectProperty(item, 'chat')))) {
          (getObjectProperty(item, 'chat')).push(({ [`receiver`]: (getObjectProperty(___arguments.context.pageData, 'profileId')),[`sender`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) }));
        } else {
          item['chat'] = [({ [`receiver`]: (getObjectProperty(___arguments.context.pageData, 'profileId')),[`sender`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) })];
        }
      }
    ; return item;})));
  }
  delete ___arguments.context.pageData['disableBtn'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7268b11e1d9bf02236710cc46317adc9', false);
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')).pop();
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a6ce736b6a4d989d764c4412413fd541')), 'open');
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('invitation_sent');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/4512d4e953f1972f90db0004a17fc9c2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var isFormValid;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['requestMessage'] = '';
  ___arguments.context.pageData['chosenActivity'] = null;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ddc3850232635edcd0c4b3c25378440d', false);
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')).includes('alert-border')) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7c0b817d980e31a3741e77c373f2619f')), 'alert-border', '');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fa53cae1ac9a5bb278d4f9d3b35d89a3', false);
  }
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/3b52dbaf320f544c6c4880153a0cd98e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a6ce736b6a4d989d764c4412413fd541')).pop();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/dd754a73c42c9caf3b24a14bdebb9752/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c76778b9ae68fb226c639da3d34dbeb3'), 'activityDate')) {
    return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c76778b9ae68fb226c639da3d34dbeb3'), 'activityDate'))));
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c76778b9ae68fb226c639da3d34dbeb3'), 'ongoingTiming')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c76778b9ae68fb226c639da3d34dbeb3'), 'ongoingTiming'));
  }

  return 'To be scheduled '

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/962f54b222a86db1378134dea45a355b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/33347ceae446d7bb8ce633666171da7a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['profile']) {
    return ((new Date((new Date())).getFullYear()) - (new Date(((___arguments.context.pageData['profile'])['birthDate'])).getFullYear()));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/6e6678da0deb22023cf249e819f99ed9/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var height, item;

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.pageData['profile']) {
    if (((___arguments.context.pageData['profile'])['userProfile'])['height']) {
      height = (await asyncListFilter((___arguments.context.pageData['heightList']), async (item) => {


       return ((item['value']) == (((___arguments.context.pageData['profile'])['userProfile'])['height']));
      }))[0];
      if (height) {
        return (String((height['label']).slice(0, (height['label']).indexOf(' ') + 1)) + String(', '));
      }
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/e28f6c43ccd1ae1233098434693ac748/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['profile']) {
    if ((___arguments.context.pageData['profile'])['zodiac']) {
      return ((___arguments.context.pageData['profile'])['zodiac']);
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/bb1f7e5b1fd5265c737351f1627d2b35/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['profile']) {
    return (((___arguments.context.pageData['profile'])['userProfile'])['aboutShort']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/0c62d9b5874c40fced7703cd0a19fb93/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var coverImgObj, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media')).length) {
      coverImgObj = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media')), async (item) => {


       return ((getObjectProperty(item, 'isCover')) == true);
      }))[0];
      if (coverImgObj) {
        return (getObjectProperty(coverImgObj, 'file'));
      } else {
        return (getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media'))[0]), 'file'));
      }
    } else {
      return 'styles/img/placeholder_photo.png';
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/profile-page/components/244848bbdd5f15e96d64008e3a824471/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/aa82dc320913998c74f7dd0279acca8a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['profile']) {
    if ((___arguments.context.pageData['profile'])['name']) {
      return (String('Invite ') + String((___arguments.context.pageData['profile'])['name']));
    } else {
      return (String('Invite ') + String((___arguments.context.pageData['profile'])['login']));
    }
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/3cea117c1c25f5eb2056883a489d5c3e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')).pop();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/2da745ca8bf99428385b90effba145e4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/c9a76b81f522b7fc815a5031722e9b29/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return false;
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/a8f8b43809b53664008fb18d1d0a625c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var name2;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    name2 = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login'));
    return (['You have requested permission to view ',name2,'’s photos. You will be able to view their media when they accept your request.'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name'))) {
    if ((getObjectProperty(___arguments.context.appData, 'messagesNumber')) > 0) {
      return (['(',(getObjectProperty(___arguments.context.appData, 'messagesNumber')),') ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')),'\'s profile'].join(''));
    } else {
      return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) + String('\'s profile'));
    }
  }

  return 'Profile page'

  },
  /* handler:onTitleAssignment */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  getRTSubscriptions().remove((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')));
  ___arguments.context.appData['chatList'] = (getObjectProperty(___arguments.context.pageData, 'chatList'));
  await (async function() {
  	if (swiper) {

  	  if (Array.isArray(swiper)) {
  	    for (const swiperItem of swiper) {
  	      swiperItem.destroy(true, true);
  	    }
  	  } else {
  	    swiper.destroy(true, true)
  	  }

  	}
  })();

  },
  /* handler:onLeave */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var error, item, object, senderIdList, receiverIdList, imageItems, coverImageItem, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

/**
 * Describe this function...
 */
async function startMessagesCountFunction() {
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);
}

/**
 * Describe this function...
 */
async function createHightList() {
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) {
    if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'US' || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'LR' || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'MM') {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″' }), ({ [`value`]: '124',[`label`]: '4′1″' }), ({ [`value`]: '127',[`label`]: '4′2″' }), ({ [`value`]: '130',[`label`]: '4′3″' }), ({ [`value`]: '132',[`label`]: '4′4″' }), ({ [`value`]: '135',[`label`]: '4′5″' }), ({ [`value`]: '137',[`label`]: '4′6″' }), ({ [`value`]: '140',[`label`]: '4′7″' }), ({ [`value`]: '142',[`label`]: '4′8″' }), ({ [`value`]: '145',[`label`]: '4′9″' }), ({ [`value`]: '152',[`label`]: '5′0″' }), ({ [`value`]: '155',[`label`]: '5′1″' }), ({ [`value`]: '157',[`label`]: '5′2″' }), ({ [`value`]: '160',[`label`]: '5′3″' }), ({ [`value`]: '163',[`label`]: '5′4″' }), ({ [`value`]: '165',[`label`]: '5′5″' }), ({ [`value`]: '168',[`label`]: '5′6″' }), ({ [`value`]: '170',[`label`]: '5′7″' }), ({ [`value`]: '173',[`label`]: '5′8″' }), ({ [`value`]: '176',[`label`]: '5′9″' }), ({ [`value`]: '178',[`label`]: '5′10″' }), ({ [`value`]: '180',[`label`]: '5′11″' }), ({ [`value`]: '183',[`label`]: '6′0″' }), ({ [`value`]: '185',[`label`]: '6′1″' }), ({ [`value`]: '188',[`label`]: '6′2″' }), ({ [`value`]: '191',[`label`]: '6′3″' }), ({ [`value`]: '193',[`label`]: '6′4″' }), ({ [`value`]: '195',[`label`]: '6′5″' }), ({ [`value`]: '198',[`label`]: '6′6″' }), ({ [`value`]: '201',[`label`]: '6′7″' }), ({ [`value`]: '203',[`label`]: '6′8″' }), ({ [`value`]: '206',[`label`]: '6′9″' }), ({ [`value`]: '208',[`label`]: '6′10″' }), ({ [`value`]: '211',[`label`]: '6′11″' }), ({ [`value`]: '213',[`label`]: '7′0″' })];
    } else {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '122 cm' }), ({ [`value`]: '124',[`label`]: '124 cm' }), ({ [`value`]: '127',[`label`]: '127 cm' }), ({ [`value`]: '130',[`label`]: '130 cm' }), ({ [`value`]: '132',[`label`]: '132 cm' }), ({ [`value`]: '135',[`label`]: '135 cm' }), ({ [`value`]: '137',[`label`]: '137 cm' }), ({ [`value`]: '140',[`label`]: '140 cm' }), ({ [`value`]: '142',[`label`]: '142 cm' }), ({ [`value`]: '145',[`label`]: '145 cm' }), ({ [`value`]: '152',[`label`]: '152 cm' }), ({ [`value`]: '155',[`label`]: '155 cm' }), ({ [`value`]: '157',[`label`]: '157 cm' }), ({ [`value`]: '160',[`label`]: '160 cm' }), ({ [`value`]: '163',[`label`]: '163 cm' }), ({ [`value`]: '165',[`label`]: '165 cm' }), ({ [`value`]: '168',[`label`]: '168 cm' }), ({ [`value`]: '170',[`label`]: '170 cm' }), ({ [`value`]: '173',[`label`]: '173 cm' }), ({ [`value`]: '176',[`label`]: '176 cm' }), ({ [`value`]: '178',[`label`]: '178 cm' }), ({ [`value`]: '180',[`label`]: '180 cm' }), ({ [`value`]: '183',[`label`]: '183 cm' }), ({ [`value`]: '185',[`label`]: '185 cm' }), ({ [`value`]: '188',[`label`]: '188 cm' }), ({ [`value`]: '191',[`label`]: '191 cm' }), ({ [`value`]: '193',[`label`]: '193 cm' }), ({ [`value`]: '195',[`label`]: '195 cm' }), ({ [`value`]: '198',[`label`]: '198 cm' }), ({ [`value`]: '201',[`label`]: '201 cm' }), ({ [`value`]: '203',[`label`]: '203 cm' }), ({ [`value`]: '206',[`label`]: '206 cm' }), ({ [`value`]: '208',[`label`]: '208 cm' }), ({ [`value`]: '211',[`label`]: '211 cm' }), ({ [`value`]: '213',[`label`]: '213 cm' })];
    }
  } else {
    ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″ (122 cm)' }), ({ [`value`]: '124',[`label`]: '4′1″ (124 cm)' }), ({ [`value`]: '127',[`label`]: '4′2″ (127 cm)' }), ({ [`value`]: '130',[`label`]: '4′3″ (130 cm)' }), ({ [`value`]: '132',[`label`]: '4′4″ (132 cm)' }), ({ [`value`]: '135',[`label`]: '4′5″ (135 cm)' }), ({ [`value`]: '137',[`label`]: '4′6″ (137 cm)' }), ({ [`value`]: '140',[`label`]: '4′7″ (140 cm)' }), ({ [`value`]: '142',[`label`]: '4′8″ (142 cm)' }), ({ [`value`]: '145',[`label`]: '4′9″ (145 cm)' }), ({ [`value`]: '152',[`label`]: '5′0″ (152 cm)' }), ({ [`value`]: '155',[`label`]: '5′1″ (155 cm)' }), ({ [`value`]: '157',[`label`]: '5′2″ (157 cm)' }), ({ [`value`]: '160',[`label`]: '5′3″ (160 cm)' }), ({ [`value`]: '163',[`label`]: '5′4″ (163 cm)' }), ({ [`value`]: '165',[`label`]: '5′5″ (165 cm)' }), ({ [`value`]: '168',[`label`]: '5′6″ (168 cm)' }), ({ [`value`]: '170',[`label`]: '5′7″ (170 cm)' }), ({ [`value`]: '173',[`label`]: '5′8″ (173 cm)' }), ({ [`value`]: '176',[`label`]: '5′9″ (176 cm)' }), ({ [`value`]: '178',[`label`]: '5′10″ (178 cm)' }), ({ [`value`]: '180',[`label`]: '5′11″ (180 cm)' }), ({ [`value`]: '183',[`label`]: '6′0″ (183 cm)' }), ({ [`value`]: '185',[`label`]: '6′1″ (185 cm)' }), ({ [`value`]: '188',[`label`]: '6′2″ (188 cm)' }), ({ [`value`]: '191',[`label`]: '6′3″ (191 cm)' }), ({ [`value`]: '193',[`label`]: '6′4″ (193 cm)' }), ({ [`value`]: '195',[`label`]: '6′5″ (195 cm)' }), ({ [`value`]: '198',[`label`]: '6′6″ (198 cm)' }), ({ [`value`]: '201',[`label`]: '6′7″ (201 cm)' }), ({ [`value`]: '203',[`label`]: '6′8″ (203 cm)' }), ({ [`value`]: '206',[`label`]: '6′9″ (206 cm)' }), ({ [`value`]: '208',[`label`]: '6′10″ (208 cm)' }), ({ [`value`]: '211',[`label`]: '6′11″ (211 cm)' }), ({ [`value`]: '213',[`label`]: '7′0″ (213 cm)' })];
  }
}


  await createHightList();
  if ((await Backendless.UserService.getCurrentUser(false)) != null) {
    if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
      ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    }
    ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
    currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty(currentUser, 'objectId'))))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
      return ;
    }
    if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
      return ;
    }
    if (!(getObjectProperty(___arguments.context.appData, 'name'))) {
      ___arguments.context.appData['name'] = (getObjectProperty(currentUser, 'name'));
    }
    if (!(getObjectProperty(___arguments.context.appData, 'login'))) {
      ___arguments.context.appData['login'] = (getObjectProperty(currentUser, 'login'));
      if (getObjectProperty(currentUser, 'photo')) {
        ___arguments.context.appData['photo'] = (getObjectProperty(currentUser, 'photoThumbnail'));
      }
    }
    if (!(await BackendlessUI.Functions.Custom['fn_c52974435ae439961137e54a2d451282']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('858b09ecdd64688b4aee823f7d43486f', true);
      await startMessagesCountFunction();
      return ;
    }
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5bf1a4af48e5d96ea52a5ec6ae55a14c')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bf1a4af48e5d96ea52a5ec6ae55a14c', true);
    }
    ___arguments.context.pageData['profile'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfile/getProfileData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'profileId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'profileId'))) }).send());
    if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'isBlocked'))) {
      delete ___arguments.context.appData['users'];
      delete ___arguments.context.appData['activityListAll'];
      delete ___arguments.context.appData['searchActivity'];
      delete ___arguments.context.appData['searchProfiles'];
      (function () { window.history.back(); })();
      return ;
    }
    ___arguments.context.pageData['hasPermissionCurrentUser'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'hasPermission'));
    ___arguments.context.pageData['isSentRequest'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'isSentRequest'));
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media')) {
      coverImageItem = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media')), async (item) => {


       return (getObjectProperty(item, 'isCover'));
      }));
      imageItems = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media')), async (item) => {


       return (!(getObjectProperty(item, 'isCover')));
      }));
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile'))['media'] = (coverImageItem.concat(imageItems));
    }
    ___arguments.context.pageData['userActivityList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'activity')), -1, async (item) => {


     return (getObjectProperty(item, 'created'));
    }));
    if (!(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name'))) {
      (getObjectProperty(___arguments.context.pageData, 'profile'))['name'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login'));
    }
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList'))) {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['blockList'] = [];
    }
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5bf1a4af48e5d96ea52a5ec6ae55a14c')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bf1a4af48e5d96ea52a5ec6ae55a14c', false);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('98ce3cf5ba286906dc9761ce7fb44527', true);
    await new Promise(r => setTimeout(r, 50 || 0));
    await (async function() {
    	swiper = new Swiper('.swiper', {

    	  pagination: {
    	    el: '.swiper-pagination',
    	    clickable: true
    	  }

    	});

    })();
    ;(async () => {
        if (!(getObjectProperty(___arguments.context.appData, 'userActivitiesForInvitation'))) {
        ___arguments.context.appData['userActivitiesForInvitation'] = (await Backendless.Request.get(`${Backendless.appPath}/services/myActivitiesForInvites/getMyActivitiesData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      }
      (getObjectProperty(___arguments.context.pageData, 'currentUser'))['activity'] = (getObjectProperty(___arguments.context.appData, 'userActivitiesForInvitation'));
      try {
        ___arguments.context.pageData['currentUserActivityList'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'userActivitiesForInvitation')), async (item) => {
           if (getObjectProperty(item, 'chat')) {
            receiverIdList = ((getObjectProperty(item, 'chat')).map(item => item['receiver']));
            senderIdList = ((getObjectProperty(item, 'chat')).map(item => item['sender']));
          }
          if ((receiverIdList.includes((getObjectProperty(___arguments.context.pageData, 'profileId')))) || (senderIdList.includes((getObjectProperty(___arguments.context.pageData, 'profileId'))))) {
            return false;
          }


         return true;
        }));
        if (!(getObjectProperty(___arguments.context.pageData, 'currentUserActivityList')).length) {
          if ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b55faa4638a448ff757b58b2f3a3c1b')) {
            addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b55faa4638a448ff757b58b2f3a3c1b')), 'profile__inviteBtn--disabled');
          }
        }

      } catch (error) {
        console.log(error);

      }
      getRTSubscriptions().remove((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')));
      try {

        ;(function(whereClause) {
          const callback = async object => {
              if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')) == (getObjectProperty(object, 'objectId'))) {
            ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7021295c6cd5e5dfc4724cb619e874d3'))['content'] = (getObjectProperty(object, 'likesCount'));
            (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile'))['likesCount'] = (getObjectProperty(object, 'likesCount'));
          }

          };

          const rtHandlers = Backendless.Data.of('UserProfile').rt();

          const options = [callback];

          if (whereClause) {
             options.unshift(whereClause);
          }

          rtHandlers.addUpdateListener.apply(rtHandlers, options);

          getRTSubscriptions().add((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')), () => rtHandlers.removeUpdateListener(callback));

        })('');

      } catch (error) {
        console.log(error);

      }
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes'))) {
        if (!!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


         return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')));
        })).length) {
          if ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('377791dc87d61bfbe9b42b62a966278b')) {
            addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('377791dc87d61bfbe9b42b62a966278b')), 'clicked');
          }
        }
      }
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')) != (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId'))) {
        try {
          await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'ownerId')),'parameter': 'seenBy','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')) });
          await (getChannelInstance('likes')).send('', ({ [`message`]: undefined,[`receiver`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

        } catch (error) {
          console.log(error);

        }
      }

    })();
    await startMessagesCountFunction();
    try {
      if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')).length) {
        (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


         return ((getObjectProperty(item, 'isCover')) == true);
        }))[0]), 'file'));
      }

    } catch (error) {
      console.log(error);

    }
  } else {
    ___arguments.context.pageData['profile'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfile/ProfileForGuest`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'id': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'profileId'))) }).send());
    ___arguments.context.pageData['userActivities'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'activity')), -1, async (item) => {


     return (getObjectProperty(item, 'created'));
    }));
    ___arguments.context.pageData['userActivityList'] = ((getObjectProperty(___arguments.context.pageData, 'userActivities')).slice(0, 3));
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5bf1a4af48e5d96ea52a5ec6ae55a14c')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5bf1a4af48e5d96ea52a5ec6ae55a14c', false);
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('98ce3cf5ba286906dc9761ce7fb44527', true);
    await new Promise(r => setTimeout(r, 50 || 0));
    await (async function() {
    	swiper = new Swiper('.swiper', {

    	  pagination: {
    	    el: '.swiper-pagination',
    	    clickable: true
    	  }

    	});

    })();
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_profile_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/profile-page/components/377791dc87d61bfbe9b42b62a966278b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId'))) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('377791dc87d61bfbe9b42b62a966278b')).slice(-1)[0] != 'clicked') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('377791dc87d61bfbe9b42b62a966278b')), 'clicked');
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile'))['likesCount'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'likesCount')) + 1);
      await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')),'likesCount': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'likesCount')) });
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')),[`ts`]: ((new Date()).valueOf()) }));
      if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'settings')) || (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'settings')) && ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'settings')), 'notifications')).includes('likes'))) {
        try {
          await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', (String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile')), null, null, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')));
          await (getChannelInstance('likes')).send('', ({ [`message`]: String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile'),[`receiver`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

        } catch (error) {
          console.log(error);

        }
      }
      await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'ownerId')),'parameter': 'likedBy','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')) });
      await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'ownerId')),'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('377791dc87d61bfbe9b42b62a966278b')).pop();
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile'))['likesCount'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'likesCount')) - 1);
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['myLikes'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


       return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')) != (getObjectProperty(item, 'objectId')));
      }));
      await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'ownerId')),'parameter': 'likedBy','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')) });
      await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'ownerId')),'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
      await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')),'likesCount': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'likesCount')) });
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile'))['myLikes'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')) && (getObjectProperty(___arguments.context.pageData, 'profile')) && !!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')));
  })).length) {
    return ['request__userDetailsIcon', 'clicked'];
  }

  return ['request__userDetailsIcon']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profile-page/components/c643ff3825618a65a04653f2645511ec/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if (___arguments.context.pageData['profile']) {
    return (((___arguments.context.pageData['profile'])['userProfile'])['likesCount']);
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/e28114df2918657a63c175d5c6e7bded/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a242c3ad8e81d5271fb28efd2e671cff')).includes('open')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a242c3ad8e81d5271fb28efd2e671cff')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/3d04711e9a59b5721f94f61c04d6b099/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['modalBtnBlockDisabled'] = true;
  ___arguments.context.pageData['blockErrorMessage'] = '';
  try {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97830fc8f50a1d52065ce7b29ead394a', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e28114df2918657a63c175d5c6e7bded', false);
    ___arguments.context.appData['currentUser'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
    if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
      if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) {
        if (!((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')).includes((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId'))))) {
          addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList')), ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')) }));
          addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')));
          await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': ([String(['sender.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')),'\''].join('')) + String([' and receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')),' or ',String(['sender.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) + String([' and receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')),'\''].join(''))].join('')),'changes': ({ [`isBlocked`]: true }) });
          await Backendless.Data.of('UserProfile').addRelation((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList', [(getObjectProperty(___arguments.context.pageData, 'profile'))]);
          if (getObjectProperty(___arguments.context.appData, 'activityList')) {
            delete ___arguments.context.appData['activityList'];
          }
          if (getObjectProperty(___arguments.context.appData, 'users')) {
            delete ___arguments.context.appData['users'];
          }
          if (getObjectProperty(___arguments.context.appData, 'seenBy')) {
            ___arguments.context.appData['seenBy'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'seenBy')), async (item) => {


             return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')));
            }));
          }
          if (getObjectProperty(___arguments.context.appData, 'myLikes')) {
            ___arguments.context.appData['myLikes'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'myLikes')), async (item) => {


             return ((getObjectProperty(item, 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')));
            }));
          }
          await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('blockUser', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), null, null);
        } else {
        }
      }
    }
    await Backendless.Data.of('UserProfile').bulkUpdate( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ [`blockListJson`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) : [] }) );
    delete ___arguments.context.appData['chats'];
    delete ___arguments.context.appData['activityMessages'];
    delete ___arguments.context.pageData['chats'];
    delete ___arguments.context.pageData['receivedChats'];
    delete ___arguments.context.appData['receivedChats'];
    delete ___arguments.context.pageData['activityMessages'];
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile'))['blockListJson'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson'));
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile'))['blockList'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList'));
    ___arguments.context.appData['chats'] = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);

  } catch (error) {
    ___arguments.context.pageData['blockErrorMessage'] = (getObjectProperty(error, 'message'));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('97830fc8f50a1d52065ce7b29ead394a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e28114df2918657a63c175d5c6e7bded', true);
    ___arguments.context.pageData['modalBtnBlockDisabled'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/bb93cd087992f7ca0ac977dc4144ab29/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
    var j;


  if (!(___arguments.context.getComponentDataStoreByUid('c76778b9ae68fb226c639da3d34dbeb3')['media'])) {
    return 'styles/img/placeholder_photo.png';
  } else {
    var j_list = (___arguments.context.getComponentDataStoreByUid('c76778b9ae68fb226c639da3d34dbeb3')['media']);
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (j['isCover']) {
        return (j['file']);
      }
    }
  }

  },  
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/profile-page/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/profile-page/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/c76778b9ae68fb226c639da3d34dbeb3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['chosenActivity'] = ___arguments.context.dataModel;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ddc3850232635edcd0c4b3c25378440d', false);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'chosenActivity')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'chosenActivity')), 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId'))) {
      return ['request__activityCard', 'chosen'];
    }
  }

  return ['request__activityCard']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profile-page/components/c35d9e1ad5b13f786095a6b651125157/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('3a9b7759d24d263f51e4c12a683ac1cc'))['margin-bottom'] = 'unset';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/3a9b7759d24d263f51e4c12a683ac1cc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    
  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/ab0ca593b5c2bf7f2d6fb872687bc289/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a6ce736b6a4d989d764c4412413fd541')).pop();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/c83c914d666551d4d7a6e81e0bcfdcc6/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async onMounted(___arguments) {
      await (async function() {
  	const newBlock = document.querySelector('.new')

  	newBlock.addEventListener('click', newClick)

  	function newClick() {
  	    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
  	    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c83c914d666551d4d7a6e81e0bcfdcc6'))['padding-bottom'] = '0';
  	  }

  	}
  })();

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/profile-page/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profile-page/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/5b55faa4638a448ff757b58b2f3a3c1b/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId'))) {
      return true;
    }
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) && ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')).includes((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId'))))) {
    if ((getObjectProperty(___arguments.context.pageData, 'currentUserActivityList')) && !(getObjectProperty(___arguments.context.pageData, 'currentUserActivityList')).length) {
      return true;
    }
  }

  return false

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b55faa4638a448ff757b58b2f3a3c1b')).includes('profile__inviteBtn--disabled')) {
    return ;
  } else {
    if (getObjectProperty(___arguments.context.pageData, 'currentUserActivityList')) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('068cd8ab626a7c4fb94f5cb99dafee98')), 'open');
      await new Promise(r => setTimeout(r, 1 || 0));
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768 && ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f19d3a052602b0645fa17be5e95cdb68')))) > 0) {
        ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('98ddc3a16bf45dc14b9c4688932e563f'))['height'] = (String(((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f19d3a052602b0645fa17be5e95cdb68')))) + 80) + String('px'));
      }
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/109b499e0ba42f0a97a25df20c97d3ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('109b499e0ba42f0a97a25df20c97d3ad')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('109b499e0ba42f0a97a25df20c97d3ad'))['pointer-events'] = 'none';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId'))) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('109b499e0ba42f0a97a25df20c97d3ad')).includes('clicked'))) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('109b499e0ba42f0a97a25df20c97d3ad')).push('clicked');
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('377791dc87d61bfbe9b42b62a966278b')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('377791dc87d61bfbe9b42b62a966278b')), 'clicked');
      }
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile'))['likesCount'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'likesCount')) + 1);
      await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')),'likesCount': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'likesCount')) });
      addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')),[`ts`]: ((new Date()).valueOf()) }));
      if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'settings')) || (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'settings')) && ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'settings')), 'notifications')).includes('likes'))) {
        try {
          await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', (String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile')), null, null, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')));
          await (getChannelInstance('likes')).send('', ({ [`message`]: String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile'),[`receiver`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

        } catch (error) {
          console.log(error);

        }
      }
      await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'ownerId')),'parameter': 'likedBy','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')) });
      await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'ownerId')),'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
    } else {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('109b499e0ba42f0a97a25df20c97d3ad')), 'clicked', '');
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('377791dc87d61bfbe9b42b62a966278b')) {
        ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('377791dc87d61bfbe9b42b62a966278b')).pop();
      }
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile'))['likesCount'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'likesCount')) > 0 ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'likesCount')) - 1 : 0);
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['myLikes'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


       return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')) != (getObjectProperty(item, 'objectId')));
      }));
      await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'ownerId')),'parameter': 'likedBy','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')) });
      await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'ownerId')),'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
      await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')),'likesCount': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'likesCount')) });
      try {
        await (getChannelInstance('likes')).send('', ({ [`message`]: undefined,[`receiver`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

      } catch (error) {
        console.log(error);

      }
    }
  }
  if ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('109b499e0ba42f0a97a25df20c97d3ad')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('109b499e0ba42f0a97a25df20c97d3ad'))['pointer-events'] = 'auto';
  }
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile'))['myLikes'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentUser'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var filterLikes, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty(___arguments.context.pageData, 'profile'))) {
    filterLikes = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')));
    }));
    if (filterLikes.length > 0) {
      return ['btnRound', 'btnRound--lg', 'clicked', 'profile__likeBtn'];
    }
  }

  return ['btnRound', 'btnRound--lg', 'profile__likeBtn']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profile-page/components/3435e29900152a1e9a8c8a7d148c6613/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['back'] = true;
  ___arguments.context.appData['backBtnIsClicked'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'back')) && !(getObjectProperty(___arguments.context.appData, 'previousPage'))) {
    (function () { window.history.back(); })();
  } else if ((getObjectProperty(___arguments.context.pageData, 'back')) && (getObjectProperty(___arguments.context.appData, 'previousPage'))) {
    if ((getObjectProperty(___arguments.context.appData, 'previousPage')) == 'activities-search' || (getObjectProperty(___arguments.context.appData, 'previousPage')) == 'profiles') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), ({ [`notUpdate`]: true }));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), undefined);
    }
    delete ___arguments.context.appData['previousPage'];
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentUser'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/46ed2091b74d874f7dce95c389662c4a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name'));
    } else {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/b9e5d8220d4fa8d654d594e6a40298d7/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile'))) {
    return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/profile-page/components/c2a5a681b1c41fad808d16ca4aac4c0e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newChat;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
  } else {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');
    if (!(getObjectProperty(___arguments.context.pageData, 'isSentRequest'))) {
      newChat = (await Backendless.Request.post(`${Backendless.appPath}/services/createChat/createChatRequestPermission`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')))));
      ___arguments.context.pageData['isSentRequest'] = true;
      await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('message', (String('New request from ') + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')))), 'messages', newChat, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')), null, null, null);
      await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('receivedInvitation', (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), newChat, null);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/378f0629da9f2e522442d4b58737b177/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dbdbe135d7a9cc7d1ce7d88214e79159'), 'isPrivate')) && !(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'hasPermission')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/534b6d8355f225944f97595b2de18138/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    return (String(',&nbsp;') + String((await (async function(year, month, day) {
    	let now = new Date();
    	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    	let dob = new Date(year, month, day);

    	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

    	let age;

    	age = today.getFullYear() - dob.getFullYear();

    	if (today < dobnow) {
    	  age = age-1;
    	} else {
    	  age = age
    	}

    	return age

    })((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'birthDate'))).getFullYear()), (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'birthDate'))).getMonth()), (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'birthDate'))).getDate())))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/06af550377f4ea7bbef4a44c0a611f6a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var height, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    height = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'heightList')), async (item) => {


     return ((getObjectProperty(item, 'value')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'height')));
    }))[0];
    if (height) {
      return (getObjectProperty(height, 'label'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/e70dfc23fb05cfdf9e413905811e413a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'zodiac'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/1457184543babc61314b9cb45d37fe95/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'height')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/4c577309c9ff7f0d039fa672d80faad7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    return false;
  }
  if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'objectId')) == (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId'))) {
      return false;
    }
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['blockErrorMessage'] = '';
  ___arguments.context.pageData['modalBtnBlockLabel'] = 'Block';
  ___arguments.context.pageData['modalBlockContent'] = (String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login'))) + String(' will not be able to see your profile and activities anymore.'));
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a242c3ad8e81d5271fb28efd2e671cff')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/d1b79c4920df68ac936326416cee2653/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    return (String('Block ') + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login'))));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/3e8be3685ed94fb49103246dadf1e61d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-report', ({ [`source`]: 'UserProfile',[`itemId`]: (getObjectProperty(___arguments.context.pageData, 'profile.userProfile.objectId')),[`violatorId`]: (getObjectProperty(___arguments.context.pageData, 'profileId')) }));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'currentUser')) || (getObjectProperty(___arguments.context.pageData, 'outOfService'))) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/e46ca79895a435c962246deadd859ca5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var link, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  link = String('https://app.findmyplus.one/index.html?page=profile-page&profileId=') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId'));
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    await ( async function (link, message, resourceName) { return BackendlessUI.DeviceAPI.shareSheetRequest({ link, message, resourceName }) })(link, 'Check out the profile in the in the "FindMyPlusOne" app', ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login'))));
  } else {
    ___arguments.context.pageData['modalShareOpen'] = true;
    ___arguments.context.pageData['shareLink'] = link;
    ___arguments.context.pageData['shareProfile'] = true;
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('share_profile');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var link;



  return ((await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) || (await (async function() {
	if (navigator.share) {
	  return true
	} else {
	  return false
	}
})()))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/4ad59d763617564b0a5b1a271eebbd0c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) {
      return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) + String('’s Activities'));
    } else {
      return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login')) + String('’s Activities'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'userActivityList')) && !!(getObjectProperty(___arguments.context.pageData, 'userActivityList')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/181b098fb2b3b54d0452eda8e6ee8796/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('181b098fb2b3b54d0452eda8e6ee8796'))['pointer-events'] = 'none';
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('12262fdc0e142b01926e15570c4e5248')).includes('clicked')) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('12262fdc0e142b01926e15570c4e5248')), 'clicked', '');
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['likedActivities'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd4e0772722d80ef68dde23e502e937a'), 'objectId')) != (getObjectProperty(item, 'objectId')));
    }));
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd4e0772722d80ef68dde23e502e937a'), 'objectId')),'parameter': 'likedActivities','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('12262fdc0e142b01926e15570c4e5248')).push('clicked');
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities'))) {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['likedActivities'] = [];
    }
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')), ({ [`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd4e0772722d80ef68dde23e502e937a'), 'objectId')),[`ts`]: ((new Date()).valueOf()) }));
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'settings')) || (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'settings')) && ((getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'settings')), 'notifications')).includes('likes'))) {
      try {
        await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', ([(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),' just liked your activity "',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd4e0772722d80ef68dde23e502e937a'), 'name')),'"'].join('')), null, null, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')));
        await (getChannelInstance('likes')).send('', ({ [`message`]: [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),' just liked your activity "',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd4e0772722d80ef68dde23e502e937a'), 'name')),'"'].join(''),[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd4e0772722d80ef68dde23e502e937a'), 'ownerId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

      } catch (error) {
        console.log(error);

      }
    }
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd4e0772722d80ef68dde23e502e937a'), 'objectId')),'parameter': 'likedActivities','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
  }
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('181b098fb2b3b54d0452eda8e6ee8796'))['pointer-events'] = 'auto';
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile'))['likedActivities'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    return false;
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId'))) {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities'))) {
    if (!!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'likedActivities')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd4e0772722d80ef68dde23e502e937a'), 'objectId')));
    })).length) {
      return ['card__favoriteBtn favoriteIcon btnRound btnRound--sm btnRound--dark', 'clicked'];
    }
  }

  return ['card__favoriteBtn favoriteIcon btnRound btnRound--sm btnRound--dark']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profile-page/components/dc51365c965ea0cae68ae9926c3444f3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('dd4e0772722d80ef68dde23e502e937a'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profile-page/components/1bd88104df19d1026097133dffc4d8e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['back'] = true;
  ___arguments.context.appData['backBtnIsClicked'] = true;
  if ((getObjectProperty(___arguments.context.pageData, 'back')) && !(getObjectProperty(___arguments.context.appData, 'previousPage'))) {
    (function () { window.history.back(); })();
  } else if ((getObjectProperty(___arguments.context.pageData, 'back')) && (getObjectProperty(___arguments.context.appData, 'previousPage'))) {
    if ((getObjectProperty(___arguments.context.appData, 'previousPage')) == 'activities-search' || (getObjectProperty(___arguments.context.appData, 'previousPage')) == 'profiles') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), ({ [`notUpdate`]: true }));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })((getObjectProperty(___arguments.context.appData, 'previousPage')), undefined);
    }
    delete ___arguments.context.appData['previousPage'];
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'currentUser'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/6e63dbc4da0360ac3952fd83ba1d91c8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) {
      return (String('About ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')));
    } else {
      return (String('About ') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login')));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/b935e2b875623538dea77c1a157d6a06/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'profile')) ? ['styles/media/zodiac/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'zodiac')).toLowerCase(),'.svg'].join('') : null)

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/profile-page/components/eefd75d30c984baf093ba40fe248012a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    return (String((await (async function(year, month, day) {
    	let now = new Date();
    	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

    	let dob = new Date(year, month, day);

    	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

    	let age;

    	age = today.getFullYear() - dob.getFullYear();

    	if (today < dobnow) {
    	  age = age-1;
    	} else {
    	  age = age
    	}

    	return age

    })((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'birthDate'))).getFullYear()), (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'birthDate'))).getMonth()), (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'birthDate'))).getDate())))) + String(' Years Old'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/11b7e0dc4029fdf6cfb2b1a494c833af/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var photo;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media')).length) {
    return (getObjectProperty(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media'))[0]), 'file'));
  }

  return 'styles/img/placeholder_photo.png'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/profile-page/components/c1a583673e82e99d688b1c1eb8c26573/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profile-page/components/0f335af7560a86c6605a8ef66ab2103a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile'))) {
    return ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'aboutDetailed')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'aboutDetailed')) : (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'aboutShort')));
  }

  return ''

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profile-page/components/3ea9f0b7eb54fb4bfd7a2e8ae1c9a75e/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return './styles/media/icons/Calendar.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/profile-page/components/f0fef5e742eacc1c1d644c211315a0be/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
      return './styles/media/icons/Ruler.svg'

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/profiles/components/916764cf81f7f4dd39add13dbd65fa7a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function saveFilterData() {
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  if (getObjectProperty(___arguments.context.appData, 'currentUser')) {
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
  }
  ___arguments.context.pageData['searchFilter'] = ({  });
  Object.assign((getObjectProperty(___arguments.context.pageData, 'searchFilter')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')));
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['objectId'];
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['created'];
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['updated'];
  await Backendless.Data.of('UserSearchFilter').bulkUpdate( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), (getObjectProperty(___arguments.context.pageData, 'searchFilter')) );
  if (getObjectProperty(___arguments.context.appData, 'activityList')) {
    delete ___arguments.context.appData['activityList'];
  }
}


  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['height'] = (___arguments.value * 1);
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix'))) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefHeightCheckbox'] = false;
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var strToArr, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'heightList')) {
    return (getObjectProperty(___arguments.context.pageData, 'heightList'));
  }

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/profiles/components/69b9a7435b6e5a774f967f27f307dc8b/bundle.js', [], () => ({
  /* content */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var moreUsers, searchInput;

  },
  /* handler:onScroll */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 200 || 0));
  if ((getObjectProperty(___arguments.context.appData, 'scrollTop')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69b9a7435b6e5a774f967f27f307dc8b')) && (getObjectProperty(___arguments.context.pageData, 'notUpdate'))) {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('69b9a7435b6e5a774f967f27f307dc8b')), 'el'))['scrollTop'] = (getObjectProperty(___arguments.context.appData, 'scrollTop'));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/profiles/components/5979df7d1ea76def79124244409e64d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42749a53cdcc499bbbcd9ee636cb00c6')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42749a53cdcc499bbbcd9ee636cb00c6'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('42749a53cdcc499bbbcd9ee636cb00c6'))['checked']) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/78c320323da7ed26c9b8f5f4aa2e5761/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de15c0463e130f4396ad7c8196bc8739')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de15c0463e130f4396ad7c8196bc8739'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('de15c0463e130f4396ad7c8196bc8739'))['checked']) {
    return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/70f2547404293aab0e6c72e76781a2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('513e6a016f41bde56455dc2358a2332e'))['checked']) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },  
  /* handler:onClassListAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('513e6a016f41bde56455dc2358a2332e')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('513e6a016f41bde56455dc2358a2332e'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/454b2d213f9de7b9e88940a982e58aff/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('742803ed0e6aa5f9c78e811827d9c46d')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('742803ed0e6aa5f9c78e811827d9c46d'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('742803ed0e6aa5f9c78e811827d9c46d'))['checked']) {
    return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/f14a23fbebc8d1bd3e02f02e6cc20b23/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fb4347842036052b5d05eff4e8c4876e')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fb4347842036052b5d05eff4e8c4876e'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('fb4347842036052b5d05eff4e8c4876e'))['checked']) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/3322eed45a44439b5e0818f8b3d7fec5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('df97b96264af20de58cae1cc95ea9de8')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('df97b96264af20de58cae1cc95ea9de8'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('df97b96264af20de58cae1cc95ea9de8'))['checked']) {
    return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'activity-page__quality-list']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/54aa67d779df4b443aee7eeab00bc6d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['childrenList'] = [({ 'name': 'None','icon': '/images/speaker-low-volume.svg','value': -1 }), ({ 'name': '1','icon': '/images/performing-arts.svg','value': 1 }), ({ 'name': '2','icon': '/images/light-bulb.svg','value': 2 }), ({ 'name': 'More than 2','icon': '/images/person-standing.svg','value': 3 })];

  },
  /* handler:onBeforeMount */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked']) {
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = false;
    ((function (componentUid){ return ___arguments.context.getComponentStyleByUid(componentUid) })('54aa67d779df4b443aee7eeab00bc6d3'))['opacity'] = 1;
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked']) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-padding', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'no-padding']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/95c2e8cf2a39b1f3ec3b278902dd3273/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b5686909fc32d7055a59aaef72e057')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b5686909fc32d7055a59aaef72e057')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatus'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatusJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['maritalStatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['maritalStatusJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatusJson'));
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b5686909fc32d7055a59aaef72e057')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b5686909fc32d7055a59aaef72e057')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/65b5686909fc32d7055a59aaef72e057/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked']) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-padding', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'no-padding']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/0f28f89e2a6536cfb0eebe16d0559bda/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54aa67d779df4b443aee7eeab00bc6d3')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54aa67d779df4b443aee7eeab00bc6d3')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['children'] = null;
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['children'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'children'));
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54aa67d779df4b443aee7eeab00bc6d3')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54aa67d779df4b443aee7eeab00bc6d3')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'children'))) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/01815e1e73fa255454e22ba1a802afcb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('719557ecdc25ddc33fb93fbd57862026')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('719557ecdc25ddc33fb93fbd57862026')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicity'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicityJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ethnicity'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ethnicityJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicityJson'));
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('719557ecdc25ddc33fb93fbd57862026')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('719557ecdc25ddc33fb93fbd57862026')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/719557ecdc25ddc33fb93fbd57862026/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked']) {
    ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked'] = false;
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked']) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-padding', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper', 'no-padding']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/a8db42ffbba6fb0120a63c65e89baedd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatus'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatusJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a8db42ffbba6fb0120a63c65e89baedd')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a8db42ffbba6fb0120a63c65e89baedd')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatusJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a8db42ffbba6fb0120a63c65e89baedd')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatus'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatusJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatusJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['maritalStatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatus'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['maritalStatusJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'maritalStatusJson'));
  ___arguments.context.pageData['changes'] = true;
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var item;


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatus']) {
    if (!!(await (async () => {
      async function callback (item) {


        return ((item['objectId']) == (___arguments.context.dataModel['objectId']));
      }

      const list = await Promise.all((___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['maritalStatus']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/291b763c95f5d6bbafa48f05487f8bed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('291b763c95f5d6bbafa48f05487f8bed')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('291b763c95f5d6bbafa48f05487f8bed')), 'activity-page__quality-item-active');
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['children'] = (getObjectProperty(___arguments.context.dataModel, 'value'));
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('291b763c95f5d6bbafa48f05487f8bed')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['children'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = true;
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['children'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'children'));
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['children']) {
    if ((___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['children']) == (___arguments.context.dataModel['value'])) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/54064f0e3191651d6a12169de924785a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicity'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicityJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54064f0e3191651d6a12169de924785a')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54064f0e3191651d6a12169de924785a')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicityJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54064f0e3191651d6a12169de924785a')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicity'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicityJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicityJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ethnicity'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicity'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ethnicityJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'ethnicityJson'));
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var item;


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicity']) {
    if (!!(await (async () => {
      async function callback (item) {


        return ((item['objectId']) == (___arguments.context.dataModel['objectId']));
      }

      const list = await Promise.all((___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['ethnicity']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/5c17afcc57bb0b1abd42323dae8683e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religion'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religionJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religionJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religion'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religionJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religionJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42749a53cdcc499bbbcd9ee636cb00c6'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religion'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religionJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religionJson'));
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')).length) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/8e75f309995d41a7d5dd49872bdf2a58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['education'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['educationJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'educationJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['education'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['educationJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'educationJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('513e6a016f41bde56455dc2358a2332e'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['education'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['educationJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'educationJson'));
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education'))) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/e332d82dbc4c5d099d3919faf62be734/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['political'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['politicalJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'politicalJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['political'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['politicalJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'politicalJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fb4347842036052b5d05eff4e8c4876e'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['political'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['politicalJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'politicalJson'));
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political'))) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/982656bea75328da811cc844403d3e19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientation'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientationJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('982656bea75328da811cc844403d3e19')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('982656bea75328da811cc844403d3e19')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientationJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('982656bea75328da811cc844403d3e19')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientation'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientationJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientationJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de15c0463e130f4396ad7c8196bc8739'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['sexOrientation'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['sexOrientation'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation'));
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var item;


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientation']) {
    if (!!(await (async () => {
      async function callback (item) {


        return ((item['objectId']) == (___arguments.context.dataModel['objectId']));
      }

      const list = await Promise.all((___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientation']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/ca6ecb0f5df69667b0b79f9fe86d845f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyType'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyTypeJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ca6ecb0f5df69667b0b79f9fe86d845f')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ca6ecb0f5df69667b0b79f9fe86d845f')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyTypeJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ca6ecb0f5df69667b0b79f9fe86d845f')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyType'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyTypeJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('742803ed0e6aa5f9c78e811827d9c46d'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['bodyType'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['bodyTypeJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyTypeJson'));
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var item;


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyType']) {
    if (!!(await (async () => {
      async function callback (item) {


        return ((item['objectId']) == (___arguments.context.dataModel['objectId']));
      }

      const list = await Promise.all((___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyType']).map(async source => ({
        source,
        value: await callback(source),
      })));

      const resultList = list.filter(item => item.value)

      return resultList.map(item => item.source)
    })()).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/34a95071417e8828fbb385946e9c01d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColor'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColorJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34a95071417e8828fbb385946e9c01d3')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34a95071417e8828fbb385946e9c01d3')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColorJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34a95071417e8828fbb385946e9c01d3')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColor'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColorJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColorJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('df97b96264af20de58cae1cc95ea9de8'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColorJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColorJson'));
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/020b49a8ac82256cbc7b4f8d8d678804/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function saveFilterData() {
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  if (getObjectProperty(___arguments.context.appData, 'currentUser')) {
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
  }
  ___arguments.context.pageData['searchFilter'] = ({  });
  Object.assign((getObjectProperty(___arguments.context.pageData, 'searchFilter')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')));
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['objectId'];
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['created'];
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['updated'];
  await Backendless.Data.of('UserSearchFilter').bulkUpdate( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), (getObjectProperty(___arguments.context.pageData, 'searchFilter')) );
  if (getObjectProperty(___arguments.context.appData, 'activityList')) {
    delete ___arguments.context.appData['activityList'];
  }
}


  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['heightPrefix'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix'))) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefHeightCheckbox'] = false;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/profiles/components/8378734b92fa3c99354c7421f3ad9f23/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var users;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.pageData['searchInput'] = (___arguments.value.toLowerCase());
  stopSetTimeout('searchData');

  ;(function() {
    const callback = async () => {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.pageData['noMoreUsers'] = false;
    ___arguments.context.pageData['countOffset'] = 0;
    users = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['users'] = [null];
    ___arguments.context.pageData['users'] = users;
    if ((getObjectProperty(___arguments.context.pageData, 'users')) && !!(getObjectProperty(___arguments.context.pageData, 'users')).length) {
      await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

    };

    const timerId = 'searchData';
    const timerDelay = 500;

    runSetTimeout(timerId, callback, timerDelay)
  })()
  ___arguments.context.appData['searchProfiles'] = (getObjectProperty(___arguments.context.pageData, 'searchInput'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/profiles/components/5683be521befcd52d065569654b1f547/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9cba9614d445dce7650ed19b421e5101')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'messagesNumber')) > 0) {
    return (['(',(getObjectProperty(___arguments.context.appData, 'messagesNumber')),') Profiles'].join(''));
  }

  return 'Profiles'

  },
  /* handler:onTitleAssignment */
  /* handler:onLeave */
  async ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['scrollTopProfiles'] = (await (async function() {
  	  const returnValue = scrollTopProfiles;
  	  delete scrollTopProfiles;
  	  return returnValue;
  })());
  ___arguments.context.appData['previousPage'] = 'profiles';
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
    if (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus')) {
      ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
      if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
        localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
      }
      ___arguments.context.appData['users'] = (getObjectProperty(___arguments.context.pageData, 'users'));
    }
  }
  ___arguments.context.appData['countOffset'] = (getObjectProperty(___arguments.context.pageData, 'countOffset'));
  await (async function() {
  	if (swiper) {

  	  if (Array.isArray(swiper)) {
  	    for (const swiperItem of swiper) {
  	      swiperItem.destroy(true, true);
  	    }
  	  } else {
  	    swiper.destroy(true, true)
  	  }

  	}
  })();
  await (async function() {
  	delete window.scrollTopProfiles ;
  	delete window.onScrollProfiles ;
  })();

  },
  /* handler:onLeave */
  /* handler:onScroll */
  async ['onScroll'](___arguments) {
    var moreUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(value) {
  	scrollTopProfiles = value;
  })(___arguments.scrollTop);
  if (___arguments.scrollTop >= 200) {
    if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5683be521befcd52d065569654b1f547')) || !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5683be521befcd52d065569654b1f547')), 'display'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5683be521befcd52d065569654b1f547', true);
    }
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5683be521befcd52d065569654b1f547')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5683be521befcd52d065569654b1f547')), 'display'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('5683be521befcd52d065569654b1f547', false);
    }
  }
  if (!(await (async function() {
  	return onScrollProfiles
  })())) {
    if (___arguments.scrollBottom <= 30 && ((getObjectProperty(___arguments.context.pageData, 'users')) ? (getObjectProperty(___arguments.context.pageData, 'users')).length : null) > 0 && !(getObjectProperty(___arguments.context.pageData, 'noMoreUsers'))) {
      await (async function() {
      	OnScrollProfiles = true;
      })();
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('018adb099dffd5e852ab50211274a152', true);
      ___arguments.context.pageData['countOffset'] = ((getObjectProperty(___arguments.context.pageData, 'countOffset')) + 1);
      moreUsers = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
      if (!!moreUsers.length) {
        ___arguments.context.pageData['users'] = ((getObjectProperty(___arguments.context.pageData, 'users')).concat(moreUsers));
        await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();
      } else {
        ___arguments.context.pageData['noMoreUsers'] = true;
      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('018adb099dffd5e852ab50211274a152', false);
      await (async function() {
      	OnScrollProfiles = null;
      })();
    }
  }

  },
  /* handler:onScroll */
  /* handler:onBeforeEnter */
  async ['onBeforeEnter'](___arguments) {
    var error, isNewActivity, isNewUser, j, usersIdList, item, tempFiltersRadius, countriesThatUseMiles;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

/**
 * Describe this function...
 */
async function setDataToRadiusSelect() {
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) {
    countriesThatUseMiles = ['united states', 'usa', 'us', 'myanmar', 'myanmar (burma)', 'burma', 'mm', 'liberia', 'lr'];
    if (countriesThatUseMiles.includes((((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')).toLowerCase()))) {
      ___arguments.context.pageData['distanseUnit'] = [({ [`value`]: 'All',[`label`]: 'Radius not selected' }), ({ [`value`]: '16093',[`label`]: '10 mi' }), ({ [`value`]: '40234',[`label`]: '25 mi' }), ({ [`value`]: '80467',[`label`]: '50 mi' }), ({ [`value`]: '120701',[`label`]: '75 mi' }), ({ [`value`]: '160934',[`label`]: '100 mi' })];
    } else {
      ___arguments.context.pageData['distanseUnit'] = [({ [`value`]: 'All',[`label`]: 'Radius not selected' }), ({ [`value`]: '16000',[`label`]: '16 km' }), ({ [`value`]: '40000',[`label`]: '40 km' }), ({ [`value`]: '80000',[`label`]: '80 km' }), ({ [`value`]: '120000',[`label`]: '120 km' }), ({ [`value`]: '160000',[`label`]: '160 km' })];
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'radius')) && (getObjectProperty(___arguments.context.pageData, 'radius')) != 'All') {
    if (((getObjectProperty(___arguments.context.pageData, 'distanseUnit')).map(item => item['value'])).includes((getObjectProperty(___arguments.context.pageData, 'radius')))) {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('b1b9058f3bce25a586de3fd51f9d1888', (getObjectProperty(___arguments.context.pageData, 'radius')));
    }
  }
}

/**
 * Describe this function...
 */
async function profilesTableData() {
}

/**
 * Describe this function...
 */
async function setHeightList() {
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) {
    if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'US' || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'LR' || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'MM') {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″' }), ({ [`value`]: '124',[`label`]: '4′1″' }), ({ [`value`]: '127',[`label`]: '4′2″' }), ({ [`value`]: '130',[`label`]: '4′3″' }), ({ [`value`]: '132',[`label`]: '4′4″' }), ({ [`value`]: '135',[`label`]: '4′5″' }), ({ [`value`]: '137',[`label`]: '4′6″' }), ({ [`value`]: '140',[`label`]: '4′7″' }), ({ [`value`]: '142',[`label`]: '4′8″' }), ({ [`value`]: '145',[`label`]: '4′9″' }), ({ [`value`]: '152',[`label`]: '5′0″' }), ({ [`value`]: '155',[`label`]: '5′1″' }), ({ [`value`]: '157',[`label`]: '5′2″' }), ({ [`value`]: '160',[`label`]: '5′3″' }), ({ [`value`]: '163',[`label`]: '5′4″' }), ({ [`value`]: '165',[`label`]: '5′5″' }), ({ [`value`]: '168',[`label`]: '5′6″' }), ({ [`value`]: '170',[`label`]: '5′7″' }), ({ [`value`]: '173',[`label`]: '5′8″' }), ({ [`value`]: '176',[`label`]: '5′9″' }), ({ [`value`]: '178',[`label`]: '5′10″' }), ({ [`value`]: '180',[`label`]: '5′11″' }), ({ [`value`]: '183',[`label`]: '6′0″' }), ({ [`value`]: '185',[`label`]: '6′1″' }), ({ [`value`]: '188',[`label`]: '6′2″' }), ({ [`value`]: '191',[`label`]: '6′3″' }), ({ [`value`]: '193',[`label`]: '6′4″' }), ({ [`value`]: '195',[`label`]: '6′5″' }), ({ [`value`]: '198',[`label`]: '6′6″' }), ({ [`value`]: '201',[`label`]: '6′7″' }), ({ [`value`]: '203',[`label`]: '6′8″' }), ({ [`value`]: '206',[`label`]: '6′9″' }), ({ [`value`]: '208',[`label`]: '6′10″' }), ({ [`value`]: '211',[`label`]: '6′11″' }), ({ [`value`]: '213',[`label`]: '7′0″' })];
    } else {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '122 cm' }), ({ [`value`]: '124',[`label`]: '124 cm' }), ({ [`value`]: '127',[`label`]: '127 cm' }), ({ [`value`]: '130',[`label`]: '130 cm' }), ({ [`value`]: '132',[`label`]: '132 cm' }), ({ [`value`]: '135',[`label`]: '135 cm' }), ({ [`value`]: '137',[`label`]: '137 cm' }), ({ [`value`]: '140',[`label`]: '140 cm' }), ({ [`value`]: '142',[`label`]: '142 cm' }), ({ [`value`]: '145',[`label`]: '145 cm' }), ({ [`value`]: '152',[`label`]: '152 cm' }), ({ [`value`]: '155',[`label`]: '155 cm' }), ({ [`value`]: '157',[`label`]: '157 cm' }), ({ [`value`]: '160',[`label`]: '160 cm' }), ({ [`value`]: '163',[`label`]: '163 cm' }), ({ [`value`]: '165',[`label`]: '165 cm' }), ({ [`value`]: '168',[`label`]: '168 cm' }), ({ [`value`]: '170',[`label`]: '170 cm' }), ({ [`value`]: '173',[`label`]: '173 cm' }), ({ [`value`]: '176',[`label`]: '176 cm' }), ({ [`value`]: '178',[`label`]: '178 cm' }), ({ [`value`]: '180',[`label`]: '180 cm' }), ({ [`value`]: '183',[`label`]: '183 cm' }), ({ [`value`]: '185',[`label`]: '185 cm' }), ({ [`value`]: '188',[`label`]: '188 cm' }), ({ [`value`]: '191',[`label`]: '191 cm' }), ({ [`value`]: '193',[`label`]: '193 cm' }), ({ [`value`]: '195',[`label`]: '195 cm' }), ({ [`value`]: '198',[`label`]: '198 cm' }), ({ [`value`]: '201',[`label`]: '201 cm' }), ({ [`value`]: '203',[`label`]: '203 cm' }), ({ [`value`]: '206',[`label`]: '206 cm' }), ({ [`value`]: '208',[`label`]: '208 cm' }), ({ [`value`]: '211',[`label`]: '211 cm' }), ({ [`value`]: '213',[`label`]: '213 cm' })];
    }
  } else {
    ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″ (122 cm)' }), ({ [`value`]: '124',[`label`]: '4′1″ (124 cm)' }), ({ [`value`]: '127',[`label`]: '4′2″ (127 cm)' }), ({ [`value`]: '130',[`label`]: '4′3″ (130 cm)' }), ({ [`value`]: '132',[`label`]: '4′4″ (132 cm)' }), ({ [`value`]: '135',[`label`]: '4′5″ (135 cm)' }), ({ [`value`]: '137',[`label`]: '4′6″ (137 cm)' }), ({ [`value`]: '140',[`label`]: '4′7″ (140 cm)' }), ({ [`value`]: '142',[`label`]: '4′8″ (142 cm)' }), ({ [`value`]: '145',[`label`]: '4′9″ (145 cm)' }), ({ [`value`]: '152',[`label`]: '5′0″ (152 cm)' }), ({ [`value`]: '155',[`label`]: '5′1″ (155 cm)' }), ({ [`value`]: '157',[`label`]: '5′2″ (157 cm)' }), ({ [`value`]: '160',[`label`]: '5′3″ (160 cm)' }), ({ [`value`]: '163',[`label`]: '5′4″ (163 cm)' }), ({ [`value`]: '165',[`label`]: '5′5″ (165 cm)' }), ({ [`value`]: '168',[`label`]: '5′6″ (168 cm)' }), ({ [`value`]: '170',[`label`]: '5′7″ (170 cm)' }), ({ [`value`]: '173',[`label`]: '5′8″ (173 cm)' }), ({ [`value`]: '176',[`label`]: '5′9″ (176 cm)' }), ({ [`value`]: '178',[`label`]: '5′10″ (178 cm)' }), ({ [`value`]: '180',[`label`]: '5′11″ (180 cm)' }), ({ [`value`]: '183',[`label`]: '6′0″ (183 cm)' }), ({ [`value`]: '185',[`label`]: '6′1″ (185 cm)' }), ({ [`value`]: '188',[`label`]: '6′2″ (188 cm)' }), ({ [`value`]: '191',[`label`]: '6′3″ (191 cm)' }), ({ [`value`]: '193',[`label`]: '6′4″ (193 cm)' }), ({ [`value`]: '195',[`label`]: '6′5″ (195 cm)' }), ({ [`value`]: '198',[`label`]: '6′6″ (198 cm)' }), ({ [`value`]: '201',[`label`]: '6′7″ (201 cm)' }), ({ [`value`]: '203',[`label`]: '6′8″ (203 cm)' }), ({ [`value`]: '206',[`label`]: '6′9″ (206 cm)' }), ({ [`value`]: '208',[`label`]: '6′10″ (208 cm)' }), ({ [`value`]: '211',[`label`]: '6′11″ (211 cm)' }), ({ [`value`]: '213',[`label`]: '7′0″ (213 cm)' })];
  }
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) {
    if (!(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus'))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', ({ [`accountPaused`]: true }));
      return ;
    }
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
    ___arguments.context.appData['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'photoThumbnail'));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
  await (async function() {
  	scrollTopProfiles = 0;
  	onScrollProfiles = null;
  })();
  await setHeightList();
  if (getObjectProperty(___arguments.context.appData, 'needUpdateUsersRtBlock')) {
    delete ___arguments.context.appData['needUpdateUsersRtBlock'];
    delete ___arguments.context.appData['users'];
  }
  if (getObjectProperty(___arguments.context.appData, 'users')) {
    if ((getObjectProperty(___arguments.context.appData, 'users')).length > 100 && !(getObjectProperty(___arguments.context.pageData, 'notUpdate'))) {
      ___arguments.context.appData['users'] = ((getObjectProperty(___arguments.context.appData, 'users')).slice(0, 100));
    }
    ___arguments.context.pageData['users'] = (getObjectProperty(___arguments.context.appData, 'users'));
    await (async function() {
    	swiper = new Swiper('.swiper', {

    	  pagination: {
    	    el: '.swiper-pagination',
    	    clickable: true
    	  }

    	});

    })();
  }
  if ((getObjectProperty(___arguments.context.appData, 'scrollTopProfiles')) && (await (async function() {
  	const pageEl = document.getElementById('page');
  	if (pageEl) {
  	  return pageEl;
  	} else {
  	  return null;
  	}
  })()) && (getObjectProperty(___arguments.context.pageData, 'notUpdate'))) {
    await (async function(scrollTop) {
    	const pageEl = document.getElementById('page');
    	if (pageEl) {
    	  pageEl.scroll({
    	    top: scrollTop,
    	    left: 0,
    	    behavior: "smooth",
    	  });
    	}
    })((getObjectProperty(___arguments.context.appData, 'scrollTopProfiles')));
  }
  if (!(getObjectProperty(___arguments.context.appData, 'users')) && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11091feacdf7b6761bf4b58f079fe4f1'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  }
  ___arguments.context.pageData['pageSize'] = 100;
  if (getObjectProperty(___arguments.context.pageData, 'notUpdate')) {
    if (typeof (getObjectProperty(___arguments.context.appData, 'countOffset')) === 'number' && !isNaN((getObjectProperty(___arguments.context.appData, 'countOffset')))) {
      ___arguments.context.pageData['countOffset'] = (getObjectProperty(___arguments.context.appData, 'countOffset'));
    }
  } else {
    ___arguments.context.pageData['countOffset'] = 0;
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')) && (((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')).indexOf('mi') !== -1) || ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')).indexOf('km') !== -1))) {
      tempFiltersRadius = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
      tempFiltersRadius['radius'] = null;
      localStorage.setItem('tempFilters', JSON.stringify(tempFiltersRadius));
    }
    if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')) && (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')) != 'All') {
      ___arguments.context.pageData['radius'] = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius'));
    }
  }
  ;(async () => {
      if (!(getObjectProperty(___arguments.context.pageData, 'users'))) {
      ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
      await (async function() {
      	swiper = new Swiper('.swiper', {
      	  pagination: {
      	    el: '.swiper-pagination',
      	    clickable: true
      	  }
      	});


      })();
      ___arguments.context.pageData['allProfiles'] = false;
    }
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('11091feacdf7b6761bf4b58f079fe4f1')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
    }

  })();
  if (!(getObjectProperty(___arguments.context.appData, 'statusList'))) {
    ___arguments.context.appData['profilesData'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'));
    ___arguments.context.appData['statusList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'statusList'));
    ___arguments.context.appData['ethnicityList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'ethnicityList'));
    ___arguments.context.appData['bodyTypeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'bodyTypeList'));
    ___arguments.context.appData['orientationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'orientationList'));
    ___arguments.context.appData['educationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'educationList'));
    ___arguments.context.appData['politicalList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'politicalList'));
    ___arguments.context.appData['religionList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')), 1, async (item) => {


     return (getObjectProperty(item, 'name'));
    }));
    ___arguments.context.appData['hairColorList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'hairColorList'));
    ___arguments.context.appData['smokeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'smokeList'));
    ___arguments.context.appData['drinkList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'drinkList'));
    ___arguments.context.appData['dietaryList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList')), 1, async (item) => {


     return (getObjectProperty(item, 'id'));
    }));
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f3bb039ced4875e3b557d80781bce5ef')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')) {
      Object.assign(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')));
      delete ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['created'];
      delete ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['updated'];
      delete ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['objectId'];
      if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) && !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))) {
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['age'] = [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')), 100];
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['ageMax'] = 100;
        if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) == 18) {
          ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefAgeCheckbox'] = true;
        }
      } else if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))) {
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['age'] = [18, (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))];
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['ageMin'] = 18;
        if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax')) == 100) {
          ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefAgeCheckbox'] = true;
        }
      } else if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))) {
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['age'] = [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))];
        if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) == 18 && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax')) == 100) {
          ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefAgeCheckbox'] = true;
        }
      } else if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) && !(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))) {
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['age'] = [18, 100];
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefAgeCheckbox'] = true;
      }
      if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'gender'))) {
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['gender'] = [];
      }
      if (!(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'gender')).length) {
        ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefGenderCheckbox'] = true;
      }
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefHeightCheckbox'] = ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'height')) ? false : true);
      ___arguments.context.pageData['checked'] = true;
    }
  }
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);
  ;(async () => {
      if ((getObjectProperty(___arguments.context.appData, 'users')) && !(getObjectProperty(___arguments.context.pageData, 'allProfiles')) && !(getObjectProperty(___arguments.context.pageData, 'notUpdate'))) {
      ___arguments.context.pageData['usersNew'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
      if ((getObjectProperty(___arguments.context.pageData, 'usersNew')) && !!(getObjectProperty(___arguments.context.pageData, 'usersNew')).length) {
        isNewUser = false;
        usersIdList = ((getObjectProperty(___arguments.context.pageData, 'users')).map(item => item['objectId']));
        var j_list = (getObjectProperty(___arguments.context.pageData, 'usersNew'));
        for (var j_index in j_list) {
          j = j_list[j_index];
          if (!(usersIdList.includes((getObjectProperty(j, 'objectId'))))) {
            isNewUser = true;
            break;
          }
        }
        if (isNewActivity) {
          ___arguments.context.pageData['btnNewProfileVisible'] = true;
          ___arguments.context.pageData['noMoreUsers'] = true;
        } else {
          ___arguments.context.pageData['users'] = (getObjectProperty(___arguments.context.pageData, 'usersNew'));
          await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();
          ___arguments.context.appData['users'] = (getObjectProperty(___arguments.context.pageData, 'usersNew'));
        }
      } else {
        ___arguments.context.pageData['users'] = [];
        ___arguments.context.appData['users'] = [];
      }
    }

  })();
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1b9058f3bce25a586de3fd51f9d1888')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b1b9058f3bce25a586de3fd51f9d1888')), 'display'))) {
    await setDataToRadiusSelect();
  }
  if (getObjectProperty(___arguments.context.pageData, 'notUpdate')) {
    await (async function() {
    	const url = new URL(document.location);
    	const searchParams = url.searchParams;
    	searchParams.delete("data");
    	window.history.pushState({}, '', url.toString());

    })();
  }
  ___arguments.context.pageData['end'] = true;
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_profiles_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onBeforeEnter */
  /* content */
}))

define('./pages/profiles/components/42749a53cdcc499bbbcd9ee636cb00c6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('42749a53cdcc499bbbcd9ee636cb00c6'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5979df7d1ea76def79124244409e64d4')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5979df7d1ea76def79124244409e64d4')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religion'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['religionJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religion'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religionJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religionJson'));
    ___arguments.context.pageData['countOffset'] = 0;
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5979df7d1ea76def79124244409e64d4')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5979df7d1ea76def79124244409e64d4')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'religion')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/de15c0463e130f4396ad7c8196bc8739/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('de15c0463e130f4396ad7c8196bc8739'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('78c320323da7ed26c9b8f5f4aa2e5761')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('78c320323da7ed26c9b8f5f4aa2e5761')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientation'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['sexOrientationJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['sexOrientation'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['sexOrientationJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientationJson'));
    ___arguments.context.pageData['countOffset'] = 0;
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('78c320323da7ed26c9b8f5f4aa2e5761')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('78c320323da7ed26c9b8f5f4aa2e5761')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'sexOrientation')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/513e6a016f41bde56455dc2358a2332e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('513e6a016f41bde56455dc2358a2332e'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('70f2547404293aab0e6c72e76781a2cd')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('70f2547404293aab0e6c72e76781a2cd')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['education'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['educationJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['education'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['educationJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'educationJson'));
    ___arguments.context.pageData['countOffset'] = 0;
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('70f2547404293aab0e6c72e76781a2cd')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('70f2547404293aab0e6c72e76781a2cd')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'education')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/742803ed0e6aa5f9c78e811827d9c46d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('742803ed0e6aa5f9c78e811827d9c46d'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('454b2d213f9de7b9e88940a982e58aff')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('454b2d213f9de7b9e88940a982e58aff')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyType'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['bodyTypeJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['bodyType'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['bodyTypeJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType'));
    ___arguments.context.pageData['countOffset'] = 0;
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('454b2d213f9de7b9e88940a982e58aff')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('454b2d213f9de7b9e88940a982e58aff')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'bodyType')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/fb4347842036052b5d05eff4e8c4876e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fb4347842036052b5d05eff4e8c4876e'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f14a23fbebc8d1bd3e02f02e6cc20b23')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f14a23fbebc8d1bd3e02f02e6cc20b23')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['political'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['politicalJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['political'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['politicalJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'politicalJson'));
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f14a23fbebc8d1bd3e02f02e6cc20b23')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f14a23fbebc8d1bd3e02f02e6cc20b23')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'political')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/df97b96264af20de58cae1cc95ea9de8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('df97b96264af20de58cae1cc95ea9de8'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3322eed45a44439b5e0818f8b3d7fec5')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3322eed45a44439b5e0818f8b3d7fec5')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColor'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColorJson'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['hairColorJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColorJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColorJson'));
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3322eed45a44439b5e0818f8b3d7fec5')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('3322eed45a44439b5e0818f8b3d7fec5')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'hairColor')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/def40283aa391c8ad36df9d9a2b7ed82/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid) })('eba33a2a33c227ac3a76f81b537b2d74'))['checked']) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },  
  /* handler:onClassListAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eba33a2a33c227ac3a76f81b537b2d74')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eba33a2a33c227ac3a76f81b537b2d74'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/4f0185b5faacc151c527aa0b5779573d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b8ad7afb1294a479ca8c9d7b8566f26')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b8ad7afb1294a479ca8c9d7b8566f26'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b8ad7afb1294a479ca8c9d7b8566f26')), 'checked')) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/eba33a2a33c227ac3a76f81b537b2d74/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eba33a2a33c227ac3a76f81b537b2d74'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('def40283aa391c8ad36df9d9a2b7ed82')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('def40283aa391c8ad36df9d9a2b7ed82')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smoke'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smokeJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smoke'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smokeJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smokeJson'));
    ___arguments.context.pageData['countOffset'] = 0;
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('def40283aa391c8ad36df9d9a2b7ed82')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('def40283aa391c8ad36df9d9a2b7ed82')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/5b8ad7afb1294a479ca8c9d7b8566f26/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b8ad7afb1294a479ca8c9d7b8566f26'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4f0185b5faacc151c527aa0b5779573d')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4f0185b5faacc151c527aa0b5779573d')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drink'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drinkJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drink'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drinkJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drinkJson'));
    ___arguments.context.pageData['countOffset'] = 0;
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4f0185b5faacc151c527aa0b5779573d')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4f0185b5faacc151c527aa0b5779573d')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/c687162656cb67b53aee32d363fe458b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smoke'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smokeJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smokeJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smoke'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['smokeJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smokeJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('eba33a2a33c227ac3a76f81b537b2d74'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smoke'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smokeJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smokeJson'));
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke'))) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'smoke')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/5e421929669fd1bfd7086bccce9dc288/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drink'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drinkJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drinkJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drink'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['drinkJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drinkJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b8ad7afb1294a479ca8c9d7b8566f26'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drink'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drinkJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drinkJson'));
  ___arguments.context.pageData['countOffset'] = 0;
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink'))) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'drink')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/76aa53eadedf8a9103cd198dd3899812/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'users')) && (getObjectProperty(___arguments.context.pageData, 'users')).length == 0) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profiles/components/84561d5c60947b28591e3898d3bfc142/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value[0] == 18 && ___arguments.value.slice(-1)[0] == 100) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefAgeCheckbox'] = true;
  } else {
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'noPrefAgeCheckbox')) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefAgeCheckbox'] = false;
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/profiles/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/profiles/components/734613cf02b83e317b8d023b100fc7d4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function saveFilterData() {
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  if (getObjectProperty(___arguments.context.appData, 'currentUser')) {
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
  }
  ___arguments.context.pageData['searchFilter'] = ({  });
  Object.assign((getObjectProperty(___arguments.context.pageData, 'searchFilter')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')));
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['objectId'];
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['created'];
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['updated'];
  await Backendless.Data.of('UserSearchFilter').bulkUpdate( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), (getObjectProperty(___arguments.context.pageData, 'searchFilter')) );
  if (getObjectProperty(___arguments.context.appData, 'activityList')) {
    delete ___arguments.context.appData['activityList'];
  }
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['height'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['heightPrefix'] = null;
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['heightPrefix'] = 'minHeight';
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['height'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'heightList'))[0]), 'value')) * 1);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/profiles/components/013aa38b49553b5f16f436b591fb8eed/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['genderList'] = [({ [`label`]: 'Male' }), ({ [`label`]: 'Female' }), ({ [`label`]: 'Non-Binary' })];

  },
  /* handler:onMounted */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
      return (___arguments.context.pageData['genderList'])

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'noPrefGenderCheckbox')) ? ({ [`opacity`]: 0.3 }) : ({ [`opacity`]: 1 }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/profiles/components/e46cd834546236a8bebd060f71073427/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function saveFilterData() {
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  if (getObjectProperty(___arguments.context.appData, 'currentUser')) {
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
  }
  ___arguments.context.pageData['searchFilter'] = ({  });
  Object.assign((getObjectProperty(___arguments.context.pageData, 'searchFilter')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')));
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['objectId'];
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['created'];
  delete (getObjectProperty(___arguments.context.pageData, 'searchFilter'))['updated'];
  await Backendless.Data.of('UserSearchFilter').bulkUpdate( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), (getObjectProperty(___arguments.context.pageData, 'searchFilter')) );
  if (getObjectProperty(___arguments.context.appData, 'activityList')) {
    delete ___arguments.context.appData['activityList'];
  }
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'] = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')).map(async item => {; return item;})));
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')), (getObjectProperty(___arguments.context.dataModel, 'label')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'label')));
    }));
  }
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefGenderCheckbox'] = (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')).length ? true : false);
  if (getObjectProperty(___arguments.context.pageData, 'usersNew')) {
    delete ___arguments.context.pageData['usersNew'];
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')) ? ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender')).includes((getObjectProperty(___arguments.context.dataModel, 'label')))) : false)

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/c862fd64e386a15880a1d708f2a82247/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'usersNew')) {
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.appData['countOffset'] = (getObjectProperty(___arguments.context.pageData, 'countOffset'));
    ___arguments.context.pageData['noMoreUsers'] = false;
    ___arguments.context.pageData['users'] = (getObjectProperty(___arguments.context.pageData, 'usersNew'));
    await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();
    delete ___arguments.context.pageData['usersNew'];
  }
  ___arguments.context.pageData['btnNewProfileVisible'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/1e09855dddcdb7e2f3fcf7d2935ae354/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('092a07be3f1db42d245eb4bc0ca4449a')), 'checked')) {
    return ['filters__container', 'activity-page__text-wrapper', 'no-prefs-content'];
  }

  return ['filters__container', 'activity-page__text-wrapper']

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('092a07be3f1db42d245eb4bc0ca4449a')), 'checked')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('092a07be3f1db42d245eb4bc0ca4449a'))['checked'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/092a07be3f1db42d245eb4bc0ca4449a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('092a07be3f1db42d245eb4bc0ca4449a'))['checked'] = ___arguments.value;
  if (___arguments.value) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e09855dddcdb7e2f3fcf7d2935ae354')).slice(-1)[0] != 'no-prefs-content') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e09855dddcdb7e2f3fcf7d2935ae354')), 'no-prefs-content');
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreference'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreferenceJson'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreference'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreferenceJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson'));
    delete ___arguments.context.pageData['noMoreUsers'];
    ___arguments.context.pageData['countOffset'] = 0;
    ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
    ___arguments.context.pageData['changes'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e09855dddcdb7e2f3fcf7d2935ae354')).slice(-1)[0] == 'no-prefs-content') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1e09855dddcdb7e2f3fcf7d2935ae354')).pop();
    }
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/6c52503c21a491c8c3e708aadfa6499a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreference'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreferenceJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreference'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['dietaryPreferenceJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson')).length == 0) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('092a07be3f1db42d245eb4bc0ca4449a'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreference'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreferenceJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreferenceJson'));
  delete ___arguments.context.pageData['noMoreUsers'];
  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['changes'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'checked')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference'))) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'dietaryPreference')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/profiles/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profiles/components/b1b9058f3bce25a586de3fd51f9d1888/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var tempFilter;


  if (___arguments.value == 'All') {
    ___arguments.context.pageData['radius'] = null;
  } else {
    ___arguments.context.pageData['radius'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'distanseUnit'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/profiles/components/6a8f403c019b4a02b177d5034d14607d/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'users'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/profiles/components/ec7e28ef344b0e35963da83fd73261e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('23e9db8f324d6c9c77a611cf7e162196')).includes('aside__open'))) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('23e9db8f324d6c9c77a611cf7e162196')).push('aside__open');
    try {
      await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('profiles_filter_opened');

    } catch (error) {
      console.log(error);

    }
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      return ['searchPrefButton', 'filterHeading__btn']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/33d2eab75f46a5d8f5ea38ddf24744ee/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'searchProfiles')) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8378734b92fa3c99354c7421f3ad9f23'))['value'] = (getObjectProperty(___arguments.context.appData, 'searchProfiles'));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/profiles/components/f6452b3d76d70bf2856b5668208e8b13/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getChannelInstance(channelName) { const channelsMap = getGlobalEntitiesMap('channels');if(!channelsMap[channelName] || !channelsMap[channelName].connection) { channelsMap[channelName] = Backendless.Messaging.subscribe(channelName); }return channelsMap[channelName];}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f6452b3d76d70bf2856b5668208e8b13'))['pointer-events'] = 'none';
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'likedIcon')) {
    ___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7')['likedIcon'] = false;
    await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'userProfileId')),'likesCount': ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'likesCount')) > 0 ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'likesCount')) - 1 : 0) });
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['myLikes'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), async (item) => {


     return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'objectId')) != (getObjectProperty(item, 'objectId')));
    }));
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'parameter': 'likedBy','currentUser': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'userProfileId')) });
    await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'objectId')),'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
    try {
      await (getChannelInstance('likes')).send('', ({ [`message`]: undefined,[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

    } catch (error) {
      console.log(error);

    }
  } else {
    ___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7')['likedIcon'] = true;
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes'))) {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['myLikes'] = [];
    }
    await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'userProfileId')),'likesCount': ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'likesCount')) + 1) });
    addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')), ({ [`ts`]: ((new Date()).valueOf()),[`objectId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'objectId')) }));
    try {
      await BackendlessUI.Functions.Custom['fn_8102bf6f3d2ae8538ba8eb4128ef3e87']('likes', (String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile')), null, null, (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'objectId')));
      await (getChannelInstance('likes')).send('', ({ [`message`]: String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))) + String(' just liked your profile'),[`receiver`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'objectId')),[`senderId`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),[`senderName`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) }));

    } catch (error) {
      console.log(error);

    }
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'parameter': 'likedBy','currentUser': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'userProfileId')) });
    await Backendless.Request.post(`${Backendless.appPath}/services/json/generateJson`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'objectId')),'parameter': 'myLikes','currentUser': (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId')) });
  }
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('f6452b3d76d70bf2856b5668208e8b13'))['pointer-events'] = 'auto';

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'likedIcon')) ? ['favoriteIcon', 'btnRound', 'btnRound--sm', 'btnRound--dark', 'clicked'] : ['favoriteIcon', 'btnRound', 'btnRound--sm', 'btnRound--dark'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/profiles/components/6905a1bacf55ab09c4cefc6e982b6e74/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['countOffset'];
  delete ___arguments.context.appData['activitiesSearch'];
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/ded7cba229366d43ddb1528b25ac97d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/4a8a7a695ecdfd52cfdb2ffdee17a63e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'name')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'name')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'login')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profiles/components/50f399b7ea462976cd5844a290b466a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    var height;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'heightList')) {
    height = (await (async function(list, condition) {
    	return list.find(item => +item.value === condition)
    })((getObjectProperty(___arguments.context.pageData, 'heightList')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'height'))));
    if (height) {
      return (getObjectProperty(height, 'label'));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profiles/components/fc99fe81b464257f411b44269e211f8c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'height'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profiles/components/e23f3251761788065d1efa5a400aef23/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (['styles/media/zodiacWhite/',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('69747fbbb441f6f449a1a8b22e0da5c7'), 'zodiac')).toLowerCase(),'.svg'].join(''))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/profiles/components/e4530f6605376f68d3233cde2bae055c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('23e9db8f324d6c9c77a611cf7e162196')), 'aside__open', '');
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['age'] = [(getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax'))];
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMin')) == 18 && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51')), 'ageMax')) == 100) {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefAgeCheckbox'] = true;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefAgeCheckbox'] = false;
  }
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['gender'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'gender')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'gender')) : []);
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'gender')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'gender')).length) {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefGenderCheckbox'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefGenderCheckbox'] = true;
  }
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['heightPrefix'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'heightPrefix'));
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['height'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'height'));
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'heightPrefix')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'height'))) {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefHeightCheckbox'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['noPrefHeightCheckbox'] = true;
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('b1b9058f3bce25a586de3fd51f9d1888', (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/57dc4d86a803dec53b6d9cd6745c910f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age')) ? [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age'))[0],'-',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age')).slice(-1)[0]].join('') : '')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/profiles/components/cc08e552cb8d6a6b3f747139b49c50e2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var tempFilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getFilteredData() {
  ___arguments.context.pageData['noMoreUsers'] = false;
  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.appData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['users'] = (getObjectProperty(___arguments.context.appData, 'users'));
}

/**
 * Describe this function...
 */
async function saveFilterData() {
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
  if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'objectId')) {
    await Backendless.Data.of('UserSearchFilter').save( (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')) );
  }
  if (getObjectProperty(___arguments.context.appData, 'activityList')) {
    delete ___arguments.context.appData['activityList'];
  }
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ageMin'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age'))[0]);
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ageMax'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age')).slice(-1)[0]);
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['ageMin'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age'))[0]);
  ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba51'))['ageMax'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'age')).slice(-1)[0]);
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['gender'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'gender'));
  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix'))) {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['heightPrefix'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'heightPrefix'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['height'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'height'));
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    tempFilter = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
    tempFilter['radius'] = (getObjectProperty(___arguments.context.pageData, 'radius'));
    localStorage.setItem('tempFilters', JSON.stringify(tempFilter));
  } else {
    localStorage.setItem('tempFilters', JSON.stringify(({ [`category`]: null,[`radius`]: (getObjectProperty(___arguments.context.pageData, 'radius')),[`date`]: null,[`dateStart`]: null,[`dateEnd`]: null })));
  }
  await (async function(closeBtn) {
  	closeBtn.click();
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4530f6605376f68d3233cde2bae055c')), 'el')));
  if (getObjectProperty(___arguments.context.pageData, 'usersNew')) {
    delete ___arguments.context.pageData['usersNew'];
  }
  await getFilteredData();
  await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  await saveFilterData();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/531830f33b9f771854e9f09f56878d88/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['age'] = [18, 100];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/profiles/components/7ecd93fc0593a2533522969f096a25ae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['radius'] = null;
  (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('b1b9058f3bce25a586de3fd51f9d1888', (getObjectProperty(___arguments.context.pageData, 'radius')));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['age'] = [18, 100];
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefAgeCheckbox'] = true;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'] = [];
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefGenderCheckbox'] = true;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['height'] = null;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['heightPrefix'] = null;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['noPrefHeightCheckbox'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/267e1ba97cdbe08a07dbd4c74164c7fd/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'noPrefAgeCheckbox')) ? ({ [`opacity`]: 0.3 }) : ({ [`opacity`]: 1 }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/profiles/components/859254b6bd4699a5fc27429b60ac05b9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await (async function(closeBtn) {
  	closeBtn.click();
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e4530f6605376f68d3233cde2bae055c')), 'el')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/profiles/components/f76483b80d9ab7bce98651ba42f90f89/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51')['gender'] = [];
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/profiles/components/52935a85c38bf4d237a9a84af764629c/bundle.js', [], () => ({
  /* content */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba51'), 'noPrefHeightCheckbox')) ? ({ [`opacity`]: 0.4 }) : ({ [`opacity`]: 1 }))

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./pages/profiles/components/59efe36fa6e5a0b36e4d9a932cbf6b38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/profiles/components/f2198c532ffc88f9f858f9724649bbfd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var users;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['searchInput'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', true);
  ___arguments.context.pageData['noMoreUsers'] = false;
  ___arguments.context.pageData['countOffset'] = 0;
  users = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), (getObjectProperty(___arguments.context.pageData, 'pageSize')), ___arguments.context.pageData));
  ___arguments.context.pageData['users'] = [null];
  ___arguments.context.pageData['users'] = users;
  if ((getObjectProperty(___arguments.context.pageData, 'users')) && !!(getObjectProperty(___arguments.context.pageData, 'users')).length) {
    await BackendlessUI.Functions.Custom['fn_6d640b539fc5e0f7d9c267729e9a3a04']();
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('11091feacdf7b6761bf4b58f079fe4f1', false);
  ___arguments.context.appData['searchProfiles'] = (getObjectProperty(___arguments.context.pageData, 'searchInput'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/prompt-screen/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'Welcome to FindMy+1'

  },  
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async onEnter(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.appData, 'userRoles'))) {
    ___arguments.context.appData['userRoles'] = (await Backendless.UserService.getUserRoles());
  }
  if (!((getObjectProperty(___arguments.context.appData, 'userRoles')).includes('dev'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('out-of-service', undefined);
  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/prompt-screen/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/prompt-screen/components/a51aba0471aa872cb7c4dc0b40ffd763/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('create-activity', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/prompt-screen/components/9c5bd6b5593f5705ba15c5ac0087e29f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/prompt-screen/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['© ','',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/prompt-screen/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://findmyplus.one/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/prompt-screen/components/a1f162d38df51e3b11a1abfa525d1862/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('create-activity', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/prompt-screen/components/27756d424f520dc6214354324fc5904f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('launch', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/fdef6b747d1db807d5c7ecaf74d49c01/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['userName'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22efe27c9ee434406d821e7939d7493'), 'userName'));
  if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22efe27c9ee434406d821e7939d7493'), 'userName'))) > 25) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fdef6b747d1db807d5c7ecaf74d49c01')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fdef6b747d1db807d5c7ecaf74d49c01')), 'alert-border');
    }
    ___arguments.context.getComponentDataStoreByUid('a22efe27c9ee434406d821e7939d7493')['alertMessage'] = 'Maximum 25 characters';
  } else if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22efe27c9ee434406d821e7939d7493'), 'userName')).trim()) < 2) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fdef6b747d1db807d5c7ecaf74d49c01')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fdef6b747d1db807d5c7ecaf74d49c01')), 'alert-border');
    }
    ___arguments.context.getComponentDataStoreByUid('a22efe27c9ee434406d821e7939d7493')['alertMessage'] = 'Minimum 2 characters';
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fdef6b747d1db807d5c7ecaf74d49c01')).includes('alert-border')) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fdef6b747d1db807d5c7ecaf74d49c01')), 'alert-border', '');
    }
    ___arguments.context.getComponentDataStoreByUid('a22efe27c9ee434406d821e7939d7493')['alertMessage'] = '';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/quiz/components/f4fd1d5aedec57e435e6199b8f62e533/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22efe27c9ee434406d821e7939d7493'), 'userName')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22efe27c9ee434406d821e7939d7493'), 'userName')).trim().length <= 1 || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22efe27c9ee434406d821e7939d7493'), 'userName')).length > 25) {
    return true;
  }

  return false

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var login, userName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  userName = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('a22efe27c9ee434406d821e7939d7493'), 'userName'));
  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['name'] = userName;
  ___arguments.context.pageData['userName'] = userName;
  ___arguments.context.pageData['inputSuccess'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8e7ba2ad9bd674993fba6a15a5f7feb4'))['2'] = 'quiz__step--active';
  ___arguments.context.pageData['stepCount'] = '2/5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6598084651598ceef598a31defd2b5c9', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6222e5053dbdf6652a052d53e8fdc063', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3210d2603c5f2ccf1147cccaf218779', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/79fe8f35d3f58404841caca9f5cd6824/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
      ___arguments.context.pageData['stepCount'] = '1/5';

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/14ca8a4b194f83cf5f06fd3a92288dee/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var genderPronounsStatus, genderSatus;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  genderSatus = true;
  genderPronounsStatus = true;
  if (!(getObjectProperty(___arguments.context.pageData, 'genderValue'))) {
    genderSatus = false;
    ___arguments.context.pageData['alertTextGender'] = 'Please make a selection';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3baf8c695df4fc19376674bb31dda355', true);
  }
  if (getObjectProperty(___arguments.context.pageData, 'preferredGenderPronounsChecked')) {
    if (!(getObjectProperty(___arguments.context.pageData, 'preferredGenderPronouns')) || !(getObjectProperty(___arguments.context.pageData, 'preferredGenderPronouns')).trim().length) {
      genderPronounsStatus = false;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('93de58e42ba5a5dbf45e0b389476563a', true);
    } else {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['preferredGenderPronouns'] = (getObjectProperty(___arguments.context.pageData, 'preferredGenderPronouns'));
    }
  }
  if (!genderSatus || !genderPronounsStatus) {
    return ;
  }
  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['gender'] = (getObjectProperty(___arguments.context.pageData, 'genderValue'));
  ___arguments.context.pageData['genderSuccess'] = true;
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('122cee8f42119285088fe064408148ea'))['2'] = 'quiz__step--active';
  ___arguments.context.pageData['stepCount'] = '3/5';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3210d2603c5f2ccf1147cccaf218779', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6598084651598ceef598a31defd2b5c9', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d6eac515ad6801ee30fa26ee4acc0d8', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/c6eeecbeb49290d2664e5ab3f4285ecb/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  onOptionsAssignment(___arguments) {
    var list, i, date;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  list = [];
  if ((getObjectProperty(___arguments.context.pageData, 'month')) == '1' && !(getObjectProperty(___arguments.context.pageData, 'year'))) {
    for (i = 1; i <= 28; i++) {
      addItemToList(list, ({ 'value': i,'label': i }));
    }
    return list;
  } else if ((getObjectProperty(___arguments.context.pageData, 'month')) == '3' || (getObjectProperty(___arguments.context.pageData, 'month')) == '5' || (getObjectProperty(___arguments.context.pageData, 'month')) == '8' || (getObjectProperty(___arguments.context.pageData, 'month')) == '10') {
    for (i = 1; i <= 30; i++) {
      addItemToList(list, ({ 'value': i,'label': i }));
    }
    return list;
  } else if (!(getObjectProperty(___arguments.context.pageData, 'month')) || !(getObjectProperty(___arguments.context.pageData, 'year'))) {
    for (i = 1; i <= 31; i++) {
      addItemToList(list, ({ 'value': i,'label': i }));
    }
    return list;
  } else {
    date = (new Date());
    date.setFullYear((getObjectProperty(___arguments.context.pageData, 'year')));
    date.setDate(1);
    date.setMonth((((getObjectProperty(___arguments.context.pageData, 'month')) - 0) + 1));
    date.setDate(0);
    var i_end = (new Date(date).getDate());
    var i_inc = 1;
    if (1 > i_end) {
      i_inc = -i_inc;
    }
    for (i = 1; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
      addItemToList(list, ({ 'value': i,'label': i }));
    }
    return list;
  }

  return list

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['alertText'] = '';

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/quiz/components/9862d3efde161fe6aa3b68263569a7a9/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  onOptionsAssignment(___arguments) {
    var months;


  months = [({ 'value': '0','label': 'January' }), ({ 'value': '1','label': 'February' }), ({ 'value': '2','label': 'March' }), ({ 'value': '3','label': 'April' }), ({ 'value': '4','label': 'May' }), ({ 'value': '5','label': 'June' }), ({ 'value': '6','label': 'July' }), ({ 'value': '7','label': 'August' }), ({ 'value': '8','label': 'September' }), ({ 'value': '9','label': 'October' }), ({ 'value': '10','label': 'November' }), ({ 'value': '11','label': 'December' })];

  return months

  },  
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      ___arguments.context.pageData['alertText'] = '';

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/quiz/components/33be5d2d178406d2b942043c35beef93/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var list, i, birthDateTo, birthDayFrom;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  list = [];
  birthDayFrom = (new Date((new Date())).getFullYear()) - 90;
  birthDateTo = (new Date((new Date())).getFullYear()) - 18;
  var i_inc = 1;
  if (birthDateTo > birthDayFrom) {
    i_inc = -i_inc;
  }
  for (i = birthDateTo; i_inc >= 0 ? i <= birthDayFrom : i >= birthDayFrom; i += i_inc) {
    addItemToList(list, ({ 'option': i,'value': i }));
  }

  return list

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['alertText'] = '';

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/quiz/components/08980b04e2618af3506e42e240ff7342/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, date, shortMonths, message;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getDateFromTimepickers() {
  ___arguments.context.pageData['day'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('e2cf0bacdde84af41b91e1063c3e665d'))[((await (async function() {
  	const item = document.querySelector('.itemDayId');
  	const daysContainer = document.querySelector('.pickerDayId');

  	const itemHeight = item.offsetHeight;
  	const currentScroll = daysContainer.scrollTop;
  	const selectedItem = Math.round( (currentScroll - itemHeight/2) /itemHeight);

  	return selectedItem+1;
  })()) - 1)]), 'value'));
  ___arguments.context.pageData['month'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('77235ed502f76dfe48cbab3120119f48'))[((await (async function() {
  	const item = document.querySelector('.itemMonthId');
  	const monthsContainer = document.querySelector('.pickerMonthId');

  	const itemHeight = item.offsetHeight;
  	const currentScroll = monthsContainer.scrollTop;
  	const selectedItem = Math.round( (currentScroll - itemHeight/2) /itemHeight);

  	return selectedItem+1;
  })()) - 1)]), 'value'));
  ___arguments.context.pageData['year'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('34a8b58383a49f7d8cb1db518468a19d'))[((await (async function() {
  	const item = document.querySelector('.itemYearId');
  	const yearsContainer = document.querySelector('.pickerYearId');

  	const itemHeight = item.offsetHeight;
  	const currentScroll = yearsContainer.scrollTop;
  	const selectedItem = Math.round( (currentScroll - itemHeight/2) /itemHeight);

  	return selectedItem+1;
  })()) - 1)]), 'value'));
}

/**
 * Describe this function...
 */
async function showMessage(message) {
  ___arguments.context.pageData['alertText'] = message;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('add18221dadb1702b2e6bc96afcb9201', true);
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992) {
    await getDateFromTimepickers();
    if (!(getObjectProperty(___arguments.context.pageData, 'day')) || !(getObjectProperty(___arguments.context.pageData, 'month')) || !(getObjectProperty(___arguments.context.pageData, 'year'))) {
      await showMessage('Please select a date');
      return false;
    }
    shortMonths = [3, 5, 8, 10];
    if (shortMonths.includes((Number((getObjectProperty(___arguments.context.pageData, 'month')))))) {
      if ((getObjectProperty(___arguments.context.pageData, 'day')) > 30) {
        await showMessage('Invalid date selected');
        return false;
      }
    }
    if ((Number((getObjectProperty(___arguments.context.pageData, 'month')))) == 1) {
      if ((getObjectProperty(___arguments.context.pageData, 'day')) > 28) {
        await showMessage('Invalid date selected');
        return false;
      }
    }
  }
  date = (new Date());
  date.setDate((getObjectProperty(___arguments.context.pageData, 'day')));
  date.setMonth((getObjectProperty(___arguments.context.pageData, 'month')));
  date.setFullYear((getObjectProperty(___arguments.context.pageData, 'year')));
  date.setHours(12);
  date.setMinutes(0);
  if ((getObjectProperty(___arguments.context.pageData, 'day')) && (getObjectProperty(___arguments.context.pageData, 'month')) && (getObjectProperty(___arguments.context.pageData, 'year'))) {
    if ((Number((getObjectProperty(___arguments.context.pageData, 'year')))) == (new Date((new Date())).getFullYear()) - 18) {
      if ((Number((getObjectProperty(___arguments.context.pageData, 'month')))) > (new Date((new Date())).getMonth())) {
        await showMessage('Uh-oh! You must be at least 18 to join.');
        return ;
      }
      if ((Number((getObjectProperty(___arguments.context.pageData, 'month')))) == (new Date((new Date())).getMonth())) {
        if ((getObjectProperty(___arguments.context.pageData, 'day')) > (new Date((new Date())).getDate())) {
          await showMessage('Uh-oh! You must be at least 18 to join.');
          return ;
        }
      }
    }
    if ((Number((getObjectProperty(___arguments.context.pageData, 'year')))) == (new Date((new Date())).getFullYear()) - 90) {
      if ((new Date((new Date())).getMonth()) > (Number((getObjectProperty(___arguments.context.pageData, 'month'))))) {
        await showMessage('Age must be between 18 and 90 years old');
        return ;
      }
      if ((Number((getObjectProperty(___arguments.context.pageData, 'month')))) == (new Date((new Date())).getMonth())) {
        if ((new Date((new Date())).getDate()) > (getObjectProperty(___arguments.context.pageData, 'day'))) {
          await showMessage('Age must be between 18 and 90 years old');
          return ;
        }
      }
    }
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['birthDate'] = (date.valueOf());
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0b2f24f9001e1718cf5bf1b33329df75'))['2'] = 'quiz__step--active';
    ___arguments.context.pageData['stepCount'] = '4/5';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c72c0f755ffcddb57121028d67ddd0ba', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d6eac515ad6801ee30fa26ee4acc0d8', false);
    if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
      try {
        await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('REQUEST_CAMERA_PERMISSIONS', undefined);

      } catch (error) {
        console.log(error);

      }
    }
  } else {
    await showMessage('Please select a date');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/d4298dab3979e3decd7869c44f7a89d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  try {
    if ((getObjectProperty(___arguments.context.pageData, 'list')).length > 0) {
      ___arguments.context.pageData['activityAlertText'] = '';
      (getObjectProperty(___arguments.context.pageData, 'currentUser'))['searchedInterests'] = (getObjectProperty(___arguments.context.pageData, 'list'));
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c567eeba823d5f01dcba973ea9c27d7b'))['2'] = 'quiz__step--active';
      ___arguments.context.pageData['stepCount'] = '5/5';
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c72c0f755ffcddb57121028d67ddd0ba', true);
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('23741ad16aca770655081927ab240275', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9738d7cc416a9207dd6fb8912aaaa8be', true);
      ___arguments.context.pageData['activityAlertText'] = 'Please select at least one quality';
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/77b2bed9b84db24d55121aac42a38ffc/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('77b2bed9b84db24d55121aac42a38ffc', (getObjectProperty(___arguments.context.pageData, 'interestList')));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/9a7f19f725aedd6c33ebccabc4828886/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9a7f19f725aedd6c33ebccabc4828886')).slice(-1)[0] != 'quiz__activities-item-active') {
    ___arguments.context.pageData['activityAlertText'] = '';
    addItemToList((getObjectProperty(___arguments.context.pageData, 'list')), (getObjectProperty(___arguments.context.dataModel, 'objectId')));
  } else {
    ___arguments.context.pageData['list'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'list')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'list')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'list')), async (item) => {


     return (item == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['quiz__activities-item', 'quiz__activities-item-active'];
    }
  }

  return ['quiz__activities-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/quiz/components/8404e3335c9506b39e7e5356a88239d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('4d349e0bcf39ca3c746386083d34ed4f', ({ [`showRejectMsg`]: false }));
  if (!(getObjectProperty(___arguments.context.pageData, 'isSetPhoto'))) {
    ___arguments.context.pageData['activityPhotoAlertText'] = 'Please upload a photo';
  } else {
    ___arguments.context.pageData['activityPhotoAlertText'] = '';
    if (!(getObjectProperty(___arguments.context.pageData, 'smallPhoto'))) {
      ___arguments.context.pageData['smallPhoto'] = [];
      (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = (getObjectProperty((await (async function(width, percent, path, content) {

      	  const img = await getNewImage(content)

      	  const elem = document.createElement('canvas')

      	  const widthImage = !width ? img.width : width
      	  const scaleFactor = width && width / img.width
      	  const heightImage = width ? img.height * scaleFactor : img.height

      	  elem.width = widthImage
      	  elem.height = heightImage

      	  const ctx = elem.getContext('2d')

      	  ctx.drawImage(img, 0, 0, widthImage, heightImage)

      	  const blob = await getCanvasBlob(ctx.canvas, percent)

      	  const newFile = new File([blob], 'photo.jpeg', {
      	    type: 'image/jpeg',
      	    lastModified: Date.now()
      	  })
      	  // const {fileUrl} = await Backendless.Files.upload(newFile, path, true)

      	async function getNewImage(content) {
      	  const result = await new Promise((resolve) => {
      	    const img = new Image()

      	    img.crossOrigin = "Anonymous"
      	    img.src = content
      	    img.onload = () => resolve(img)
      	  })

      	  return result

      	}

      	async function getCanvasBlob(canvas, percent) {
      	  const result = await new Promise((resolve) => {
      	    canvas.toBlob((blob) => {
      	      resolve(blob)
      	    }, 'image/jpeg', percent)
      	  })

      	  return result
      	}

      	return await Backendless.Files.upload(newFile, path, true)


      })(50, 1, (String('/pictures/thumbnails/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'))), (getObjectProperty(___arguments.context.pageData, 'photoSrc')))), 'fileURL'));
    } else {
      (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = ((getObjectProperty(___arguments.context.pageData, 'smallPhoto'))[0]);
    }
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['media'] = [({ [`file`]: (getObjectProperty((await (async function(width, percent, path, content) {

    	  const img = await getNewImage(content)

    	  const elem = document.createElement('canvas')

    	  const widthImage = !width ? img.width : width
    	  const scaleFactor = width && width / img.width
    	  const heightImage = width ? img.height * scaleFactor : img.height

    	  elem.width = widthImage
    	  elem.height = heightImage

    	  const ctx = elem.getContext('2d')

    	  ctx.drawImage(img, 0, 0, widthImage, heightImage)

    	  const blob = await getCanvasBlob(ctx.canvas, percent)

    	  const newFile = new File([blob], 'photo.jpeg', {
    	    type: 'image/jpeg',
    	    lastModified: Date.now()
    	  })
    	  // const {fileUrl} = await Backendless.Files.upload(newFile, path, true)

    	async function getNewImage(content) {
    	  const result = await new Promise((resolve) => {
    	    const img = new Image()

    	    img.crossOrigin = "Anonymous"
    	    img.src = content
    	    img.onload = () => resolve(img)
    	  })

    	  return result

    	}

    	async function getCanvasBlob(canvas, percent) {
    	  const result = await new Promise((resolve) => {
    	    canvas.toBlob((blob) => {
    	      resolve(blob)
    	    }, 'image/jpeg', percent)
    	  })

    	  return result
    	}

    	return await Backendless.Files.upload(newFile, path, true)


    })(700, 1, (String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'))), (getObjectProperty(___arguments.context.pageData, 'photoSrc')))), 'fileURL')),[`type`]: 'image',[`isCover`]: true,[`isPrivate`]: false })];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c567eeba823d5f01dcba973ea9c27d7b'))['2'] = 'quiz__step--active';
    ___arguments.context.pageData['stepCount'] = '5/5';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c72c0f755ffcddb57121028d67ddd0ba', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c36b02c1794da7cce67079ab0efedcb', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/9125d4257ae7c32c22b2ea0d3fbcfbc1/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var months;


  await new Promise(r => setTimeout(r, 1000 || 0));
  months = [({ [`value`]: '0',[`label`]: 'January' }), ({ [`value`]: '1',[`label`]: 'February' }), ({ [`value`]: '2',[`label`]: 'March' }), ({ [`value`]: '3',[`label`]: 'April' }), ({ [`value`]: '4',[`label`]: 'May' }), ({ [`value`]: '5',[`label`]: 'June' }), ({ [`value`]: '6',[`label`]: 'July' }), ({ [`value`]: '7',[`label`]: 'August' }), ({ [`value`]: '8',[`label`]: 'September' }), ({ [`value`]: '9',[`label`]: 'October' }), ({ [`value`]: '10',[`label`]: 'November' }), ({ [`value`]: '11',[`label`]: 'December' })];

  },
  /* handler:onMounted */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var list, i, date;

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/quiz/components/28e94501608d16eb2166010e09a1c5cf/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28e94501608d16eb2166010e09a1c5cf')).slice(-1)[0] != 'quiz__gender-item-active') {
    ___arguments.context.pageData['genderValue'] = 'Male';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28e94501608d16eb2166010e09a1c5cf')), 'quiz__gender-item-active');
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d2c13e277addfbc81e32321d9a27861')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d2c13e277addfbc81e32321d9a27861')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4786c427e05f065bab66e73fc868567a')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4786c427e05f065bab66e73fc868567a')).pop();
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3baf8c695df4fc19376674bb31dda355', false);
  } else {
    delete ___arguments.context.pageData['genderValue'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28e94501608d16eb2166010e09a1c5cf')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/4d2c13e277addfbc81e32321d9a27861/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d2c13e277addfbc81e32321d9a27861')).slice(-1)[0] != 'quiz__gender-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d2c13e277addfbc81e32321d9a27861')), 'quiz__gender-item-active');
    ___arguments.context.pageData['genderValue'] = 'Female';
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28e94501608d16eb2166010e09a1c5cf')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28e94501608d16eb2166010e09a1c5cf')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4786c427e05f065bab66e73fc868567a')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4786c427e05f065bab66e73fc868567a')).pop();
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3baf8c695df4fc19376674bb31dda355', false);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d2c13e277addfbc81e32321d9a27861')).pop();
    delete ___arguments.context.pageData['genderValue'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/4786c427e05f065bab66e73fc868567a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4786c427e05f065bab66e73fc868567a')).slice(-1)[0] != 'quiz__gender-item-active') {
    ___arguments.context.pageData['genderValue'] = 'Non-Binary';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4786c427e05f065bab66e73fc868567a')), 'quiz__gender-item-active');
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28e94501608d16eb2166010e09a1c5cf')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28e94501608d16eb2166010e09a1c5cf')).pop();
    }
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d2c13e277addfbc81e32321d9a27861')).slice(-1)[0] == 'quiz__gender-item-active') {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d2c13e277addfbc81e32321d9a27861')).pop();
    }
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('3baf8c695df4fc19376674bb31dda355', false);
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4786c427e05f065bab66e73fc868567a')).pop();
    delete ___arguments.context.pageData['genderValue'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/c3210d2603c5f2ccf1147cccaf218779/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8c36b02c1794da7cce67079ab0efedcb')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c36b02c1794da7cce67079ab0efedcb', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c72c0f755ffcddb57121028d67ddd0ba', true);
    ___arguments.context.pageData['stepCount'] = '4/5';
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c567eeba823d5f01dcba973ea9c27d7b')).pop();
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c72c0f755ffcddb57121028d67ddd0ba')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d6eac515ad6801ee30fa26ee4acc0d8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c72c0f755ffcddb57121028d67ddd0ba', false);
    ___arguments.context.pageData['stepCount'] = '3/5';
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0b2f24f9001e1718cf5bf1b33329df75')).pop();
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d6eac515ad6801ee30fa26ee4acc0d8')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d6eac515ad6801ee30fa26ee4acc0d8', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6598084651598ceef598a31defd2b5c9', true);
    ___arguments.context.pageData['stepCount'] = '2/5';
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('122cee8f42119285088fe064408148ea')).pop();
  }
  if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6598084651598ceef598a31defd2b5c9')), 'display')) == true) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3210d2603c5f2ccf1147cccaf218779', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6598084651598ceef598a31defd2b5c9', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6222e5053dbdf6652a052d53e8fdc063', true);
    ___arguments.context.pageData['stepCount'] = '1/5';
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8e7ba2ad9bd674993fba6a15a5f7feb4')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/e696f82bb6654778927bf94873775fae/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var login, currentUser, userPhoto, item, userRoles, error;

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/56caf60c9f766826aa1c20fcf73c4462/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'genderValue')) == 'Male') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('28e94501608d16eb2166010e09a1c5cf')), 'quiz__gender-item-active');
  } else if ((getObjectProperty(___arguments.context.pageData, 'genderValue')) == 'Female') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d2c13e277addfbc81e32321d9a27861')), 'quiz__gender-item-active');
  } else if ((getObjectProperty(___arguments.context.pageData, 'genderValue')) == 'Non-Binary') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4786c427e05f065bab66e73fc868567a')), 'quiz__gender-item-active');
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/d5ad67a2720e29d90072dd9b80ad627e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      return ['quiz__height-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/quiz/components/cc6a30890fdd4b3786e3b2dd19f5edd8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992) {
    return false;
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/quiz/components/395bd4ff90726705b00394341e39c0dc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/quiz/components/1aab490bd717e529bb7babde788e5d24/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var list, i;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await new Promise(r => setTimeout(r, 1000 || 0));
  list = [];
  for (i = 1; i <= 31; i++) {
    addItemToList(list, ({ [`value`]: i,[`label`]: i }));
  }

  },
  /* handler:onMounted */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    
  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/quiz/components/5f5b2d2557344afcc5b52cb39d98abaa/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var list, i;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await new Promise(r => setTimeout(r, 1000 || 0));
  list = [];
  var i_end = (new Date((new Date())).getFullYear());
  var i_inc = 1;
  if (1950 > i_end) {
    i_inc = -i_inc;
  }
  for (i = 1950; i_inc >= 0 ? i <= i_end : i >= i_end; i += i_inc) {
    addItemToList(list, ({ [`option`]: i,[`value`]: i }));
  }

  },
  /* handler:onMounted */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var list, i, date;

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/quiz/components/08c50846df69300ec7eb67ad547a32fe/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      return ['quiz__height-item']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/quiz/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['© ',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/quiz/components/a22efe27c9ee434406d821e7939d7493/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 2500 || 0));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fdef6b747d1db807d5c7ecaf74d49c01')) {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fdef6b747d1db807d5c7ecaf74d49c01')), 'el'))['maxLength'] = 25;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'Welcome to FindMy+1'

  },  
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error, currentUser, userPhoto, item, login;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c3210d2603c5f2ccf1147cccaf218779', false);
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  login = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')).replace((new RegExp('[^\\w\\s]', 'g')), ''));
  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['login'] = login;
  currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  ;(async () => {
      await Backendless.UserService.update( new Backendless.User(({ [`objectId`]: (getObjectProperty(currentUser, 'objectId')),[`login`]: login })) );

  })();
  if ((getObjectProperty(currentUser, 'birthDate')) && (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'locationGeoPoint')) && (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'media')) && !!(getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'media')).length) {
    localStorage.removeItem((String('q_') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'))));
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
    return ;
  } else {
    localStorage.setItem((String('q_') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'))), JSON.stringify(true));
  }
  ___arguments.context.pageData['userNameMedia'] = login;
  if ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('a22efe27c9ee434406d821e7939d7493')) {
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('a22efe27c9ee434406d821e7939d7493'))['userName'] = (getObjectProperty(currentUser, 'name'));
  }
  ___arguments.context.pageData['userProfile'] = (JSON.parse((JSON.stringify((getObjectProperty(currentUser, 'userProfile'))))));
  ___arguments.context.pageData['userProfileId'] = (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'objectId'));
  if (getObjectProperty(currentUser, 'name')) {
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fdef6b747d1db807d5c7ecaf74d49c01')) {
      (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fdef6b747d1db807d5c7ecaf74d49c01')), 'el'))['value'] = (getObjectProperty(currentUser, 'name'));
    }
    ___arguments.context.pageData['userName'] = (getObjectProperty(currentUser, 'name'));
  }
  if (getObjectProperty(currentUser, 'gender')) {
    ___arguments.context.pageData['genderValue'] = (getObjectProperty(currentUser, 'gender'));
  }
  if (getObjectProperty(currentUser, 'birthDate')) {
    ___arguments.context.pageData['day'] = (new Date((getObjectProperty(currentUser, 'birthDate'))).getUTCDate());
    ___arguments.context.pageData['month'] = (String((new Date((getObjectProperty(currentUser, 'birthDate'))).getMonth() + 1) - 1));
    ___arguments.context.pageData['year'] = (new Date((getObjectProperty(currentUser, 'birthDate'))).getUTCFullYear());
  }
  if (currentUser && (getObjectProperty(currentUser, 'userProfile'))) {
    if ((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'media')) && !!(getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'media')).length) {
      userPhoto = (await asyncListFilter((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'media')), async (item) => {


       return (getObjectProperty(item, 'isCover'));
      }))[0];
      if (userPhoto) {
        ___arguments.context.pageData['photoSrc'] = (getObjectProperty(userPhoto, 'file'));
      }
    }
  }
  ___arguments.context.pageData['photoNextBtnDisable'] = true;
  ___arguments.context.pageData['preferredGenderPronouns'] = (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'preferredGenderPronouns'));
  if (getObjectProperty(___arguments.context.pageData, 'preferredGenderPronouns')) {
    ___arguments.context.pageData['preferredGenderPronounsChecked'] = true;
  } else {
    ___arguments.context.pageData['preferredGenderInputDisabled'] = true;
  }
  ___arguments.context.pageData['list'] = [];
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_quiz_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/quiz/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/3265ed4a46c43c5f1117702864a858c3/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var list;


  list = [({ 'gender': 'Female' }), ({ 'gender': 'Male' }), ({ 'gender': 'Non-Binary' })];
  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('3265ed4a46c43c5f1117702864a858c3', list);
  await new Promise(r => setTimeout(r, 1000 || 0));
  ___arguments.context.pageData['genderSelectItem'] = 'Female';

  },
  /* handler:onMounted */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var heightElem, centerOfElem, currentItem, countOfItems, heightBlock;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  heightElem = (getObjectProperty(___arguments.context.pageData, 'itemHeight'));
  centerOfElem = heightElem / 2;
  heightBlock = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('3265ed4a46c43c5f1117702864a858c3'))));
  countOfItems = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('3265ed4a46c43c5f1117702864a858c3')).length;
  currentItem = (___arguments.scrollTop - centerOfElem) % heightElem;
  if (currentItem == 0) {
    ___arguments.context.pageData['genderSelectItem'] = (getObjectProperty((((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('3265ed4a46c43c5f1117702864a858c3'))[(((___arguments.scrollTop - centerOfElem) / heightElem + 1) - 1)]), 'gender'));
  }

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/quiz/components/9e48a55ac65df012dcacde776d235ef8/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['itemHeight'] = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9e48a55ac65df012dcacde776d235ef8'))));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/77235ed502f76dfe48cbab3120119f48/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var months;


  months = [({ [`value`]: null,[`label`]: '---' }), ({ [`value`]: '0',[`label`]: 'January' }), ({ [`value`]: '1',[`label`]: 'February' }), ({ [`value`]: '2',[`label`]: 'March' }), ({ [`value`]: '3',[`label`]: 'April' }), ({ [`value`]: '4',[`label`]: 'May' }), ({ [`value`]: '5',[`label`]: 'June' }), ({ [`value`]: '6',[`label`]: 'July' }), ({ [`value`]: '7',[`label`]: 'August' }), ({ [`value`]: '8',[`label`]: 'September' }), ({ [`value`]: '9',[`label`]: 'October' }), ({ [`value`]: '10',[`label`]: 'November' }), ({ [`value`]: '11',[`label`]: 'December' })];
  await new Promise(r => setTimeout(r, 1000 || 0));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('77235ed502f76dfe48cbab3120119f48')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('77235ed502f76dfe48cbab3120119f48', months);
  }

  },
  /* handler:onMounted */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var currentItem, heightElem, centerOfElem, scrollTop, countOfItems, heightBlock;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('add18221dadb1702b2e6bc96afcb9201', false);

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/quiz/components/37a4eb2efa7fac5536b66361d6422875/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/e2cf0bacdde84af41b91e1063c3e665d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var list, i;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await new Promise(r => setTimeout(r, 1000 || 0));
  list = [];
  addItemToList(list, ({ [`value`]: null,[`label`]: '---' }));
  for (i = 1; i <= 31; i++) {
    addItemToList(list, ({ [`value`]: i,[`label`]: i }));
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e2cf0bacdde84af41b91e1063c3e665d')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('e2cf0bacdde84af41b91e1063c3e665d', list);
  }

  },
  /* handler:onMounted */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var currentItem, heightElem, centerOfElem, scrollTop, countOfItems, heightBlock;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('add18221dadb1702b2e6bc96afcb9201', false);

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/quiz/components/54361dda6ef811894638bc586d0851fd/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/34a8b58383a49f7d8cb1db518468a19d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var list, i, birthDayFrom, birthDateTo;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await new Promise(r => setTimeout(r, 1000 || 0));
  list = [];
  addItemToList(list, ({ [`option`]: '---',[`value`]: null }));
  birthDayFrom = (new Date((new Date())).getFullYear()) - 90;
  birthDateTo = (new Date((new Date())).getFullYear()) - 18;
  var i_inc = 1;
  if (birthDateTo > birthDayFrom) {
    i_inc = -i_inc;
  }
  for (i = birthDateTo; i_inc >= 0 ? i <= birthDayFrom : i >= birthDayFrom; i += i_inc) {
    addItemToList(list, ({ [`option`]: i,[`value`]: i }));
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('34a8b58383a49f7d8cb1db518468a19d')) {
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('34a8b58383a49f7d8cb1db518468a19d', list);
  }

  },
  /* handler:onMounted */
  /* handler:onScroll */
  ['onScroll'](___arguments) {
    var direction, heightElem, currentItem, centerOfElem, scrollTop, countOfItems, heightBlock;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('add18221dadb1702b2e6bc96afcb9201', false);

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/quiz/components/ed1912168a8d54f9f844f7d96749ab24/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
      ___arguments.context.pageData['itemHeightYear'] = ((function (typeSize, component) { return component && component.el ? component.el[`${typeSize}`] : null })('clientHeight', ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed1912168a8d54f9f844f7d96749ab24'))));

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/8c152d9deb5a5b85cd2d8e25a9116552/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      if (___arguments.value) {
    ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94fbee58fc283ce6fe583be2f9cfb7d3', false);
  }
  ___arguments.context.pageData['feedback'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'feedback')) {
    return (getObjectProperty(___arguments.context.pageData, 'feedback'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/quiz/components/7384b46934b10807ccb117e858f54f92/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var userRequestActivity, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  if (getObjectProperty(___arguments.context.pageData, 'feedback')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('78b8fa747dffd1bba7aaf00ea225a956', true);
    var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(j, 'file')).split('/')[0] == 'https:') {
        j['file'] = (String('/') + String(subsequenceFromEndLast((getObjectProperty(j, 'file')).split('/'), 2).join('/')));
      }
    }
    await Backendless.Data.of('Users').save( (getObjectProperty(___arguments.context.pageData, 'currentUser')) );
    await Backendless.Data.of('UserProfile').save( (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) );
    await Backendless.Data.of('Feedback').save( ({ [`name`]: (getObjectProperty(___arguments.context.pageData, 'feedback')) }) );
    ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    if (!(getObjectProperty(___arguments.context.appData, 'userRoles'))) {
      ___arguments.context.appData['userRoles'] = (await Backendless.UserService.getUserRoles());
    }
    localStorage.removeItem((String('q_') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'))));
    if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('userRequestActivity')) {
      userRequestActivity = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('userRequestActivity'));
      localStorage.removeItem('userRequestActivity');
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: userRequestActivity }));
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity-presentation', undefined);
    }
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('94fbee58fc283ce6fe583be2f9cfb7d3', true);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/7b7e64fbb1b1675b47e84fb5d9495e93/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('c72c0f755ffcddb57121028d67ddd0ba', false);
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f158a78d005289933dc6444728022c82', true);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/97229aa4f91eed09ddfec52f6f39baae/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bfd263e6c8478242d46b1ea990a96b72', false);
  ___arguments.context.pageData['activityPhotoAlertText'] = '';
  await (async function(tag, pageData, path) {
  	loadCss('https://cdnjs.cloudflare.com/ajax/libs/cropper/2.3.4/cropper.min.css')

  	await BackendlessUI.requireModule('https://cdnjs.cloudflare.com/ajax/libs/cropperjs/0.8.1/cropper.min.js')
  	const block = document.createElement('div')

  	block.innerHTML = `
  	<div style="width:100%">
  	<!-- add autoplay muted playsinline for iOS -->
  	<video id="cam" autoplay muted playsinline>Not available</video>
  	<canvas id="canvas" style="display:none"></canvas>
  	<!-- <img id="photo" alt="The screen capture will appear in this box.">  -->
  	</div>
  	<div class="panel" style="display: flex; align-items: baseline; position: relative">
  	<button id="snapBtn" class="MuiButtonBase-root MuiButton-root bl-button MuiButton-contained bl-button--contained quiz__btn" style="color: white!important; text-transform: none;">Snap</button>
  	<button id="cancel" class="MuiButtonBase-root MuiButton-root bl-button MuiButton-contained bl-button--contained quiz__btn-cancel">Cancel</button>
  	<span id="moderationMsg" class="quiz__moderation-upload-camera" style="display: none">Moderating...</span>
  	</div>
  	`

  	tag.append(block)

  	let mediaStream = null
  	const constraints = {
  	  audio: false,
  	  video: {
  	    width: {
  	      ideal: 320
  	    },
  	    height: {
  	      ideal: 320
  	    },
  	    facingMode: "environment"
  	  }
  	}

  	async function getMediaStream(constraints) {
  	  try {
  	    mediaStream = await navigator.mediaDevices.getUserMedia(constraints)
  	    let video = document.getElementById('cam')
  	    video.srcObject = mediaStream
  	    video.onloadedmetadata = (event) => {
  	      video.play()
  	    }
  	  } catch (err) {
  	    console.error(err.message)
  	  }
  	}

  	async function switchCamera(cameraMode) {
  	  try {
  	    // stop the current video stream
  	    if (mediaStream != null && mediaStream.active) {
  	      const tracks = mediaStream.getVideoTracks()
  	      tracks.forEach(track => {
  	        track.stop()
  	      })
  	    }

  	    // set the video source to null
  	    document.getElementById('cam').srcObject = null

  	    // get new media stream
  	    await getMediaStream(constraints)
  	  } catch (err) {
  	    console.error(err.message)
  	    alert(err.message)
  	  }
  	}

  	async function takePicture() {
  	  let canvas = document.getElementById('canvas')
  	  let video = document.getElementById('cam')
  	  let photo = document.getElementById('photo')
  	  let context = canvas.getContext('2d')

  	  const height = video.videoHeight
  	  const width = video.videoWidth

  	  if (width && height) {
  	    canvas.width = width
  	    canvas.height = height

  	    context.drawImage(video, 0, 0, width, height)

  	    const data = canvas.toDataURL('image/png')
  	    b64 = data.split(',')[1]

  	    const byteCharacters = atob(b64);
  	    const byteNumbers = new Array(byteCharacters.length);
  	    for (let i = 0; i < byteCharacters.length; i++) {
  	      byteNumbers[i] = byteCharacters.charCodeAt(i);
  	    }
  	    const byteArray = new Uint8Array(byteNumbers);
  	    const blob = new Blob([byteArray], {
  	      type: 'image/jpeg'
  	    });


  	    const newFile = new File([blob], 'photo.jpeg', {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })
  	    const url = await Backendless.Files.upload(newFile, path, true)

  	    // ******************** moderate logic ***********************

  	    const moderationMessage = document.querySelector('#moderationMsg')
  	    moderationMessage.style.display = 'block'

  	    try {

  	      const moderationResult = await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set({'user-token': Backendless.getCurrentUserToken() }).query({ 'url': url.fileURL }).send();
  	      moderationMessage.style.display = 'none'

  	      if (moderationResult === 'KO') {
  	        (function (componentUid, dataModel) {
  	          ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel)
  	        })('4d349e0bcf39ca3c746386083d34ed4f', ({
  	            'showRejectMsg': true
  	          }));
  	        const deletedFile = await Backendless.Files.remove(url.fileURL)
  	        return
  	      }

  	    } catch (error) {

  	      if(url) {
  	        await Backendless.Files.remove(url.fileURL)
  	      }
  	      moderationMessage.style.display = 'none'
  	      alert(error.message)
  	      return
  	    }


  	    pageData.photoSrc = data


  	    block.innerHTML = `

  	    `

  	    tag.append(block)
  	    mediaStream.getTracks().forEach(function(track) {
  	      track.stop();
  	    });

  	  } else {
  	    clearphoto()
  	  }

  	  makeCropp ()
  	}

  	function clearPhoto() {

  	  let canvas = document.getElementById('canvas')
  	  let photo = document.getElementById('photo')
  	  let context = canvas.getContext('2d')

  	  context.fillStyle = "#AAA"
  	  context.fillRect(0, 0, canvas.width, canvas.height)

  	  const data = canvas.toDataURL('image/png')
  	  data.photoSrc = data
  	  imgSrc = data

  	}

  	document.getElementById('snapBtn').onclick = (event) => {
  	  takePicture()
  	}

  	cancel.addEventListener('click', (e) => {
  	  e.preventDefault()

  	  block.innerHTML = `

  	  `

  	  document.querySelector('.modal').classList.remove('open')

  	  try {
  	    if(mediaStream) {
  	     mediaStream.getTracks().forEach(function(track) {
  	    track.stop();
  	  });
  	    }

  	  } catch(error) {
  	    console.log(error)
  	  }



  	})

  	switchCamera()
  	clearPhoto()


  	function loadCss(url) {
  	  const link = document.createElement("link")

  	  link.type = "text/css"
  	  link.rel = "stylesheet"
  	  link.href = url

  	  document.querySelector("head").appendChild(link)
  	}

  	function makeCropp () {
  	  event.preventDefault()

  	  document.querySelector('.modal').classList.add('open')

  	  const block1 = document.createElement('div')

  	  block1.classList.add('cropper-photo')
  	  block1.innerHTML = `
  	  <div class="page">
  	  <div class="box-2">
  	  <h2 style="margin: 0 auto">Crop photo</h2>
  	  <div class="result"></div>
  	  </div>
  	  <div class="box-2 img-result hide">
  	  <img class="cropped" src="" alt="">
  	  </div>
  	  <div class="box">
  	  <button class="btn MuiButtonBase-root MuiButton-root bl-button MuiButton-contained bl-button--contained quiz__btn save hide" style="color: #fff; border: none;">Save</button>
  	  <a href="" class="btn download hide">Download</a>
  	  </div>
  	  </div>
  	  `
  	  document.querySelector('.modal__container').append(block1)


  	  let result = document.querySelector('.result'),
  	  img_result = document.querySelector('.img-result'),
  	  save = document.querySelector('.save'),
  	  cancel = document.querySelector('.cancel'),
  	  cropped = document.querySelector('.cropped'),
  	  dwn = document.querySelector('.download'),
  	  upload = document.querySelector('#file-input'),
  	  cropper = ''

  	  const width = 700

  	  const img = document.createElement('img')

  	  img.id = 'image'
  	  img.src = pageData.photoSrc
  	  delete oldImg
  	  result.innerHTML = ''

  	  result.appendChild(img)

  	  save.classList.remove('hide')

  	  cropper = new Cropper(img)


  	  save.addEventListener('click', (e) => {
  	    e.preventDefault()

  	    const imgSrc = cropper.getCroppedCanvas({
  	      width
  	    }).toDataURL("image/png")

  	    cropped.classList.remove('hide')

  	    cropped.src = imgSrc

  	    pageData.photoSrc = imgSrc
  	    b64 = imgSrc.split(',')[1]

  	    const byteCharacters = atob(b64);
  	    const byteNumbers = new Array(byteCharacters.length);
  	    for (let i = 0; i < byteCharacters.length; i++) {
  	      byteNumbers[i] = byteCharacters.charCodeAt(i);
  	    }
  	    const byteArray = new Uint8Array(byteNumbers);
  	    const blob = new Blob([byteArray], {
  	      type: 'image/jpeg'
  	    });


  	    const newFile = new File([blob], 'photo.jpeg', {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })
  	    const url = Backendless.Files.upload(newFile, path, true)

  	    pageData.isSetPhoto = true
  	    pageData.photoNextBtnDisable = false

  	    document.querySelector('.modal').classList.remove('open')

  	  })
  	}
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b8bf6a88d87eece56cf90f64655a2c4b')), 'el')), ___arguments.context.pageData, (String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'))));

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/quiz/components/9e44dee2cbfa7a1362f2c53a3e2176a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a7f3d024fa0a1d215265df0382a60ba1')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/81156c027d13aea4239c189216b90522/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  onSourceUrlAssignment(___arguments) {
      if (___arguments.context.pageData['photoSrc']) {
    return (___arguments.context.pageData['photoSrc']);
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/quiz/components/2dc938797a64ad6a517babc6a973df1a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/quiz/components/4e6fde76657a0ffdc4bae1034c922d09/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  onMounted(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && !(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'preferredGenderPronouns'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e78d12964c4891538af8ea0e2b1aae24'))['opacity'] = '.4';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/2b4cb09498e196df694fd5a2b564a12e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e78d12964c4891538af8ea0e2b1aae24'))['opacity'] = '1';
    ___arguments.context.pageData['preferredGenderInputDisabled'] = false;
  } else {
    ___arguments.context.pageData['preferredGenderInputDisabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('e78d12964c4891538af8ea0e2b1aae24'))['opacity'] = '.5';
    ___arguments.context.pageData['preferredGenderPronouns'] = '';
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93de58e42ba5a5dbf45e0b389476563a')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93de58e42ba5a5dbf45e0b389476563a')), 'display'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('93de58e42ba5a5dbf45e0b389476563a', false);
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/quiz/components/e78d12964c4891538af8ea0e2b1aae24/bundle.js', [], () => ({
  /* content */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 350 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfdcacd4a1d7144d8fcb3818b7e3eb32'))['margin-bottom'] = '50vh';
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientHeight')) >= 400) {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('56caf60c9f766826aa1c20fcf73c4462')));
    } else {
      (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e78d12964c4891538af8ea0e2b1aae24')));
    }
  }

  },
  /* handler:onFocus */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!___arguments.value.trim().length) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('93de58e42ba5a5dbf45e0b389476563a', true);
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93de58e42ba5a5dbf45e0b389476563a')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('93de58e42ba5a5dbf45e0b389476563a')), 'display'))) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('93de58e42ba5a5dbf45e0b389476563a', false);
    }
  }

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
      await new Promise(r => setTimeout(r, 50 || 0));
  if ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfdcacd4a1d7144d8fcb3818b7e3eb32')) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfdcacd4a1d7144d8fcb3818b7e3eb32'))['margin-bottom'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/quiz/components/aa7884a3e6bafe9fcff7158bf858a1b2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  await (async function() {
  	const btn = document.querySelector('.drop-image-area label')
  	btn.click()
  })();
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e7869db6755eb25fe0f601e635137ba1')).push('open');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1ded05fddba75d15692638a52ebf7474')), 'hidden', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/4ca146c6d806c5a13556e2cfabe6088b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  await (async function() {
  	const btns = document.querySelectorAll('.header-toolbar button')
  	if (btns[0]) {
  	  btns[0].click()
  	}


  })();
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e7869db6755eb25fe0f601e635137ba1')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1ded05fddba75d15692638a52ebf7474')).push('hidden');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/de4c1dc113080dcb85b3f3c580ffde64/bundle.js', [], () => ({
  /* content */
  /* handler:onSave */
  async ['onSave'](___arguments) {
    var fileUrlSmall, moderationResult, error;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await (async function() {
  	const btns = document.querySelectorAll('.header-toolbar button')
  	if (btns[0]) {
  	  btns[0].click()
  	}


  })();
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e7869db6755eb25fe0f601e635137ba1')), 'open', '');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1ded05fddba75d15692638a52ebf7474')), 'hidden');
  ___arguments.context.pageData['smallPhoto'] = [];
  fileUrlSmall = (await (async function(files, width, percent, path) {
  	const file = files
  	let fileURL=''

  	const content = await readFileAsDataURL(file)

  	const img = await getNewImage(content)

  	const elem = document.createElement('canvas')

  	const widthImage = !width ? img.width: width
  	const scaleFactor = width && width / img.width
  	const heightImage = width ? img.height * scaleFactor: img.height

  	elem.width = widthImage
  	elem.height = heightImage

  	const ctx = elem.getContext('2d')

  	ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	const blob = await getCanvasBlob(ctx.canvas, percent)

  	const newFile = new File([blob], 'photo.png', {
  	  type: 'image/png',
  	  lastModified: Date.now()
  	})

  	try {
  	  fileURL = await Backendless.Files.upload(newFile, path, overwrite = true)
  	} catch (error) {
  	  alert(error.message)
  	  return false
  	}

  	async function readFileAsDataURL(file) {
  	  const result = await new Promise((resolve) => {
  	    const fileReader = new FileReader()
  	    fileReader.onload = (e) => resolve(e.target.result)
  	    fileReader.readAsDataURL(file)
  	  })
  	  return result
  	}

  	async function getNewImage(content) {
  	  const result = await new Promise((resolve) => {
  	    const img = new Image()
  	    img.src = content
  	    img.onload = () => resolve(img)
  	  })

  	  return result
  	}

  	async function getCanvasBlob(canvas, percent) {
  	  const result = await new Promise((resolve) => {
  	    canvas.toBlob((blob) => {
  	      resolve(blob)
  	    }, 'image/png', percent)
  	  })

  	  return result
  	}

  	return fileURL.fileURL
  })(___arguments['fileContent'], 50, 100, (String('/pictures/thumbnails/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia')))));
  if (!fileUrlSmall) {
    return ;
  }
  if (getObjectProperty(___arguments.context.pageData, 'retakeMobile')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('165d4c1fdb842e07281cb6a84b2a968a', true);
  } else if (getObjectProperty(___arguments.context.pageData, 'retakeDesktop')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d868398695e424f7d4d33d63ab4c63e', true);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7779f33e2df705668b52be97e93c4624', true);
  }
  try {
    moderationResult = (await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileUrlSmall) }).send());

  } catch (error) {
    if (getObjectProperty(___arguments.context.pageData, 'retakeMobile')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('165d4c1fdb842e07281cb6a84b2a968a', false);
    } else if (getObjectProperty(___arguments.context.pageData, 'retakeDesktop')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d868398695e424f7d4d33d63ab4c63e', false);
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7779f33e2df705668b52be97e93c4624', false);
    }
    ;(async () => {
        await Backendless.Files.remove(encodePath(fileUrlSmall));

    })();
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));
    return ;

  }
  if (moderationResult == 'KO') {
    if (getObjectProperty(___arguments.context.pageData, 'retakeMobile')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('165d4c1fdb842e07281cb6a84b2a968a', false);
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('851803f8cbadee0dfe536b4cdd8d6721'))['showRejectMsg'] = true;
    } else if (getObjectProperty(___arguments.context.pageData, 'retakeDesktop')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d868398695e424f7d4d33d63ab4c63e', false);
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('ac9b4cfaed5721991c65f108b105ffe9'))['showRejectMsg'] = true;
    } else {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7779f33e2df705668b52be97e93c4624', false);
      ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('4d349e0bcf39ca3c746386083d34ed4f'))['showRejectMsg'] = true;
    }
    if (fileUrlSmall) {
      ;(async () => {
          await Backendless.Files.remove(encodePath(fileUrlSmall));

      })();
    }
    return ;
  }
  (getObjectProperty(___arguments.context.pageData, 'smallPhoto')).push(fileUrlSmall);
  ___arguments.context.pageData['photoSrc'] = (await (async function(file) {
  	const content = await readFileAsDataURL(file)

  	async function readFileAsDataURL(file) {
  	  const result = await new Promise((resolve) => {
  	    const fileReader = new FileReader()
  	    fileReader.onload = (e) => resolve(e.target.result)
  	    fileReader.readAsDataURL(file)
  	  })
  	  return result
  	}

  	return content
  })(___arguments['fileContent']));
  ___arguments.context.pageData['activityPhotoAlertText'] = '';
  if (getObjectProperty(___arguments.context.pageData, 'retakeMobile')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('165d4c1fdb842e07281cb6a84b2a968a', false);
  } else if (getObjectProperty(___arguments.context.pageData, 'retakeDesktop')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d868398695e424f7d4d33d63ab4c63e', false);
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7779f33e2df705668b52be97e93c4624', false);
  }
  ___arguments.context.pageData['isSetPhoto'] = true;
  ___arguments.context.pageData['photoNextBtnDisable'] = false;
  ___arguments.context.pageData['retakeMobile'] = false;

  },
  /* handler:onSave */
  /* content */
}))

define('./pages/quiz/components/4ebb092fabc76492404ba7d1e2e4617e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['counterQualities'] = (String(___arguments.value.length) + String('/150 symbols'));

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 350 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c36b02c1794da7cce67079ab0efedcb'))['margin-bottom'] = '50vh';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2274fbcb466f6ecd43f76e9653ffc725')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 50 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c36b02c1794da7cce67079ab0efedcb'))['margin-bottom'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/quiz/components/92f4635ec3d39bf545eba4b2a2b8b096/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['interestsCounter'] = (String(___arguments.value.length) + String('/150 symbols'));

  },
  /* handler:onChange */
  /* handler:onBlur */
  async ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 50 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c36b02c1794da7cce67079ab0efedcb'))['margin-bottom'] = '0';
  }

  },
  /* handler:onBlur */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 350 || 0));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c36b02c1794da7cce67079ab0efedcb'))['margin-bottom'] = '50vh';
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2f91258cf3219dbc9dad187131ce3e68')));
  }

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/quiz/components/1eb6995f1673bf648527efb28e4aaf2e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var errorText, error, response, request;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function getDescriptions() {
  request = ['The description is for a user profile for a social networking site that connects users based on mutually shared interests. The tone of the text must be friendly and inviting. Make it sound so other users would be interested in meeting the person. The description must be in the JSON format that consists of two properties: "long"  and "short". The content generated for the "long" property must be at least 290 characters and no more than 320 characters. The content generated for the "short" property must be 100 characters long. ',' \n ','Age: ',(await (async function(year, month, day) {
  	let now = new Date(); 
  	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); 
  	
  	let dob = new Date(year, month, day);
  	
  	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate()); 
  	
  	let age; 
  	
  	age = today.getFullYear() - dob.getFullYear();
  	
  	if (today < dobnow) {
  	  age = age-1;
  	} else {
  	  age = age
  	}
  	
  	return age
  })((getObjectProperty(___arguments.context.pageData, 'year')), (getObjectProperty(___arguments.context.pageData, 'month')), (getObjectProperty(___arguments.context.pageData, 'day')))),' Do not mention the age number directly, but allude to it',' \n ','Gender: ',(getObjectProperty(___arguments.context.pageData, 'genderValue')),' \n ','Interests and hobbies: ',(getObjectProperty(___arguments.context.pageData, 'interests')),' \n ','Description: ',(getObjectProperty(___arguments.context.pageData, 'qualities'))].join('');
  return JSON.parse((await Backendless.Request.get(`${Backendless.appPath}/services/chatGPT/getDescriptions`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'Message': JSON.stringify(request) }).send()))
}


  ___arguments.context.pageData['previewProfileBtnDisabled'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d845b7d2f996bdf718eb37bda213da6', true);
  try {
    response = await getDescriptions();
    if ((getObjectProperty(response, 'long')).length > 500 || (getObjectProperty(response, 'long')).length < 230) {
      response = await getDescriptions();
    }
    if ((getObjectProperty(response, 'long')).length > 500) {
      response['long'] = (String((getObjectProperty(response, 'long')).slice(0, 495)) + String('...'));
    }
    ___arguments.context.pageData['briefDescription'] = (getObjectProperty(response, 'short'));
    ___arguments.context.pageData['fullDescription'] = (getObjectProperty(response, 'long'));

  } catch (error) {
    console.log(error);
    errorText = '';
    ___arguments.context.pageData['briefDescription'] = errorText;
    ___arguments.context.pageData['fullDescription'] = errorText;

  }
  ___arguments.context.pageData['previewProfileBtnDisabled'] = false;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d845b7d2f996bdf718eb37bda213da6', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c36b02c1794da7cce67079ab0efedcb', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b355be55125c224bc817e9cfdb9859a', true);

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'previewProfileBtnDisabled')) {
    return true;
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'interests')) || !(getObjectProperty(___arguments.context.pageData, 'qualities'))) {
    return true;
  } else {
    if (!(getObjectProperty(___arguments.context.pageData, 'interests')).trim().length || !(getObjectProperty(___arguments.context.pageData, 'qualities')).trim().length) {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/quiz/components/bfe3689990c425025cb97d686e6323f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var fullDescription, briefDescription, userName;


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0af25ed6cdf74489284ada593a70214', false);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7b472c84f07689d90f9a20a503b1685e'))['display'] = 'none';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f72241bc6634b67442c46ee9e77bb7ea', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4276261c9dc4581ddc8529bbefde19c7', true);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0e554b9dd99b3fae7e9f06774b955072'))['display'] = 'flex';

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(((getObjectProperty(___arguments.context.pageData, 'userName')) ? (getObjectProperty(___arguments.context.pageData, 'userName')).trim().length >= 2 : false) && ((getObjectProperty(___arguments.context.pageData, 'briefDescription')) ? (getObjectProperty(___arguments.context.pageData, 'briefDescription')).trim().length >= 15 : false)))

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/quiz/components/a7892e44b7ea79f79ad10a7b7b5c3e77/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(' ') + String((await (async function(year, month, day) {
	let now = new Date(); 
	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate()); 
	
	let dob = new Date(year, month, day);
	
	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate()); 
	
	let age; 
	
	age = today.getFullYear() - dob.getFullYear();
	
	if (today < dobnow) {
	  age = age-1;
	} else {
	  age = age
	}
	
	return age
})((getObjectProperty(___arguments.context.pageData, 'year')), (getObjectProperty(___arguments.context.pageData, 'month')), (getObjectProperty(___arguments.context.pageData, 'day'))))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/quiz/components/8fd5bed8fb6e4e713c1fea91d2fad03f/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'preferredGenderPronouns'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/quiz/components/97faf72bbe1347e8599ee6ce89bec961/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['preferredGenderPronouns'] = (___arguments.value.trim());

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfe3689990c425025cb97d686e6323f1'))['marginBottom'] = '25vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('75fcd9bacbfcd5e31b9469f59693d1c5')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfe3689990c425025cb97d686e6323f1'))['marginBottom'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/quiz/components/32ac26a6bacd66e3f1a541d8e1a7b3a3/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(month, day) {
	const monthNumber = Number(month);
	let result = '';

	if ( (monthNumber == 2 && day >= 21) ||  (monthNumber == 3 && day <= 21) ) {
	  result = 'Aries';
	}

	if ( (monthNumber == 3 && day >= 20) ||  (monthNumber == 4 && day <= 20) ) {
	  result = 'Taurus';
	}

	if ( (monthNumber == 4 && day >= 21) ||  (monthNumber == 5 && day <= 20) ) {
	  result = 'Gemini';
	}

	if ( (monthNumber == 5 && day >= 21) ||  (monthNumber == 6 && day <= 22) ) {
	  result = 'Cancer';
	}

	if ( (monthNumber == 6 && day >= 23) ||  (monthNumber == 7 && day <= 22) ) {
	  result = 'Leo';
	}

	if ( (monthNumber == 7 && day >= 23) ||  (monthNumber == 8 && day <= 22) ) {
	  result = 'Virgo';
	}

	if ( (monthNumber == 8 && day >= 23) ||  (monthNumber == 9 && day <= 22) ) {
	  result = 'Libra';
	}

	if ( (monthNumber == 9 && day >= 23) ||  (monthNumber == 10 && day <= 21) ) {
	  result = 'Scorpio';
	}

	if ( (monthNumber == 10 && day >= 22) ||  (monthNumber == 11 && day <= 21) ) {
	  result = 'Sagittarius';
	}

	if ( (monthNumber == 11 && day >= 22) ||  (monthNumber == 0 && day <= 19) ) {
	  result = 'Capricorn';
	}

	if ( (monthNumber == 0 && day >= 20) ||  (monthNumber == 1 && day <= 18) ) {
	  result = 'Aquarius';
	}

	if ( (monthNumber == 1 && day >= 19) ||  (monthNumber == 2 && day <= 20) ) {
	  result = 'Pisces';
	}


	return result
})((getObjectProperty(___arguments.context.pageData, 'month')), (getObjectProperty(___arguments.context.pageData, 'day'))))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/quiz/components/e594798d72ffa8f73cc94e45acf8e82f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['gender'] = ___arguments.checkedValue;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/quiz/components/040ca3d1b0e6a092268f67837c6f4b02/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'photoSrc')) {
    return (getObjectProperty(___arguments.context.pageData, 'photoSrc'));
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/quiz/components/7579d6399cb5d572e7e8bb565721667f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02d86b16a92f32a3f6f94e6a719c60b3', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/a248da59c061002708ac691e6ae724c5/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'photoSrc')) {
    return (getObjectProperty(___arguments.context.pageData, 'photoSrc'));
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/quiz/components/db935f8e26478e6e7327ee1e6f719434/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['retakeMobile'] = true;
  await (async function() {
  	const btn = document.querySelector('.drop-image-area label')
  	btn.click()
  })();
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e7869db6755eb25fe0f601e635137ba1')).push('open');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1ded05fddba75d15692638a52ebf7474')), 'hidden', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/53035a1c60a388aa58738c45230f718f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('02d86b16a92f32a3f6f94e6a719c60b3', false);
  delete ___arguments.context.pageData['smallPhoto'];
  await (async function(tag, pageData, path) {
  	loadCss('https://cdnjs.cloudflare.com/ajax/libs/cropper/2.3.4/cropper.min.css')

  	await BackendlessUI.requireModule('https://cdnjs.cloudflare.com/ajax/libs/cropperjs/0.8.1/cropper.min.js')
  	const block = document.createElement('div')

  	block.innerHTML = `
  	<div style="width:100%">
  	<!-- add autoplay muted playsinline for iOS -->
  	<video id="cam" autoplay muted playsinline>Not available</video>
  	<canvas id="canvas" style="display:none"></canvas>
  	<!-- <img id="photo" alt="The screen capture will appear in this box.">  -->
  	</div>
  	<div class="panel" style="display: flex; align-items: baseline; position: relative">
  	<button id="snapBtn" class="MuiButtonBase-root MuiButton-root bl-button MuiButton-contained bl-button--contained quiz__btn" style="color: white!important; text-transform: none;">Snap</button>
  	<button id="cancel" class="MuiButtonBase-root MuiButton-root bl-button MuiButton-contained bl-button--contained quiz__btn-cancel">Cancel</button>
  	<span id="moderationMsg" class="quiz__moderation-upload-camera" style="display: none">Moderating...</span>
  	</div>
  	`

  	tag.append(block)

  	let mediaStream = null
  	const constraints = {
  	  audio: false,
  	  video: {
  	    width: {
  	      ideal: 320
  	    },
  	    height: {
  	      ideal: 320
  	    },
  	    facingMode: "environment"
  	  }
  	}

  	async function getMediaStream(constraints) {
  	  try {
  	    mediaStream = await navigator.mediaDevices.getUserMedia(constraints)
  	    let video = document.getElementById('cam')
  	    video.srcObject = mediaStream
  	    video.onloadedmetadata = (event) => {
  	      video.play()
  	    }
  	  } catch (err) {
  	    console.error(err.message)
  	  }
  	}

  	async function switchCamera(cameraMode) {
  	  try {
  	    // stop the current video stream
  	    if (mediaStream != null && mediaStream.active) {
  	      const tracks = mediaStream.getVideoTracks()
  	      tracks.forEach(track => {
  	        track.stop()
  	      })
  	    }

  	    // set the video source to null
  	    document.getElementById('cam').srcObject = null

  	    // get new media stream
  	    await getMediaStream(constraints)
  	  } catch (err) {
  	    console.error(err.message)
  	    alert(err.message)
  	  }
  	}

  	async function takePicture() {
  	  let canvas = document.getElementById('canvas')
  	  let video = document.getElementById('cam')
  	  let photo = document.getElementById('photo')
  	  let context = canvas.getContext('2d')

  	  const height = video.videoHeight
  	  const width = video.videoWidth

  	  if (width && height) {
  	    canvas.width = width
  	    canvas.height = height

  	    context.drawImage(video, 0, 0, width, height)

  	    const data = canvas.toDataURL('image/png')
  	    b64 = data.split(',')[1]

  	    const byteCharacters = atob(b64);
  	    const byteNumbers = new Array(byteCharacters.length);
  	    for (let i = 0; i < byteCharacters.length; i++) {
  	      byteNumbers[i] = byteCharacters.charCodeAt(i);
  	    }
  	    const byteArray = new Uint8Array(byteNumbers);
  	    const blob = new Blob([byteArray], {
  	      type: 'image/jpeg'
  	    });


  	    const newFile = new File([blob], 'photo.jpeg', {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })
  	    const url = await Backendless.Files.upload(newFile, path, true)

  	    // ******************** moderate logic ***********************

  	    const moderationMessage = document.querySelector('#moderationMsg')
  	    moderationMessage.style.display = 'block'

  	    try {

  	      const moderationResult = await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).query({
  	        'url': url.fileURL
  	      }).send();
  	      moderationMessage.style.display = 'none'

  	      if (moderationResult === 'KO') {
  	        (function (componentUid, dataModel) {
  	          ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel)
  	        })('586fdfc9990e96e3b59e82175bf7fa3b', ({
  	            'showRejectMsg': true
  	          }));
  	        const deletedFile = await Backendless.Files.remove(url.fileURL)
  	        return
  	      }

  	    } catch (error) {

  	      if(url) {
  	        await Backendless.Files.remove(url.fileURL)
  	      }
  	      moderationMessage.style.display = 'none'
  	      alert(error.message)
  	      return
  	    }


  	    pageData.photoSrc = data


  	    block.innerHTML = `

  	    `

  	    tag.append(block)
  	    mediaStream.getTracks().forEach(function(track) {
  	      track.stop();
  	    });

  	  } else {
  	    clearphoto()
  	  }

  	  makeCropp ()
  	}

  	function clearPhoto() {

  	  let canvas = document.getElementById('canvas')
  	  let photo = document.getElementById('photo')
  	  let context = canvas.getContext('2d')

  	  context.fillStyle = "#AAA"
  	  context.fillRect(0, 0, canvas.width, canvas.height)

  	  const data = canvas.toDataURL('image/png')
  	  data.photoSrc = data
  	  imgSrc = data

  	}

  	document.getElementById('snapBtn').onclick = (event) => {
  	  takePicture()
  	}

  	cancel.addEventListener('click', (e) => {
  	  e.preventDefault()

  	  block.innerHTML = `

  	  `

  	  document.querySelector('.modal').classList.remove('open')

  	  try {
  	    if(mediaStream) {
  	     mediaStream.getTracks().forEach(function(track) {
  	    track.stop();
  	  });
  	    }

  	  } catch(error) {
  	    console.log(error)
  	  }

  	})

  	switchCamera()
  	clearPhoto()


  	function loadCss(url) {
  	  const link = document.createElement("link")

  	  link.type = "text/css"
  	  link.rel = "stylesheet"
  	  link.href = url

  	  document.querySelector("head").appendChild(link)
  	}

  	function makeCropp () {
  	  event.preventDefault()

  	  document.querySelector('.modal').classList.add('open')

  	  const block1 = document.createElement('div')

  	  block1.classList.add('cropper-photo')
  	  block1.innerHTML = `
  	  <div class="page">
  	  <div class="box-2">
  	  <h2 style="margin: 0 auto">Crop photo</h2>
  	  <div class="result"></div>
  	  </div>
  	  <div class="box-2 img-result hide">
  	  <img class="cropped" src="" alt="">
  	  </div>
  	  <div class="box">
  	  <button class="btn MuiButtonBase-root MuiButton-root bl-button MuiButton-contained bl-button--contained quiz__btn save hide" style="color: #fff; border: none;">Save</button>
  	  <a href="" class="btn download hide">Download</a>
  	  </div>
  	  </div>
  	  `
  	  document.querySelector('.modal__container').append(block1)


  	  let result = document.querySelector('.result'),
  	  img_result = document.querySelector('.img-result'),
  	  save = document.querySelector('.save'),
  	  cancel = document.querySelector('.cancel'),
  	  cropped = document.querySelector('.cropped'),
  	  dwn = document.querySelector('.download'),
  	  upload = document.querySelector('#file-input'),
  	  cropper = ''

  	  const width = 700

  	  const img = document.createElement('img')

  	  img.id = 'image'
  	  img.src = pageData.photoSrc
  	  delete oldImg
  	  result.innerHTML = ''

  	  result.appendChild(img)

  	  save.classList.remove('hide')

  	  cropper = new Cropper(img)


  	  save.addEventListener('click', (e) => {
  	    e.preventDefault()

  	    const imgSrc = cropper.getCroppedCanvas({
  	      width
  	    }).toDataURL("image/png")

  	    cropped.classList.remove('hide')

  	    cropped.src = imgSrc

  	    pageData.photoSrc = imgSrc
  	    b64 = imgSrc.split(',')[1]

  	    const byteCharacters = atob(b64);
  	    const byteNumbers = new Array(byteCharacters.length);
  	    for (let i = 0; i < byteCharacters.length; i++) {
  	      byteNumbers[i] = byteCharacters.charCodeAt(i);
  	    }
  	    const byteArray = new Uint8Array(byteNumbers);
  	    const blob = new Blob([byteArray], {
  	      type: 'image/jpeg'
  	    });


  	    const newFile = new File([blob], 'photo.jpeg', {
  	      type: 'image/jpeg',
  	      lastModified: Date.now()
  	    })
  	    const url = Backendless.Files.upload(newFile, path, true)

  	    pageData.isSetPhoto = true
  	    pageData.photoNextBtnDisable = false

  	    document.querySelector('.modal').classList.remove('open')

  	  })
  	}
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('7d22e9c7f221a58e315bcb0a8f1fe973')), 'el')), ___arguments.context.pageData, (String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'))));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/b0fee963e5964c64aa7e65c9df2ed6af/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['retakeDesktop'] = true;
  await (async function() {
  	const btn = document.querySelector('.drop-image-area label')
  	btn.click()
  })();
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e7869db6755eb25fe0f601e635137ba1')).push('open');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1ded05fddba75d15692638a52ebf7474')), 'hidden', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/318f47efe41c6a16873ddf31a277c63e/bundle.js', [], () => ({
  /* content */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    var fullDescription, briefDescription, userName;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(((getObjectProperty(___arguments.context.pageData, 'userName')) ? (getObjectProperty(___arguments.context.pageData, 'userName')).trim().length >= 2 : false) && ((getObjectProperty(___arguments.context.pageData, 'briefDescription')) ? (getObjectProperty(___arguments.context.pageData, 'briefDescription')).trim().length >= 15 : false)))

  },
  /* handler:onDisabledStateAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var j, userLocation;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function saveData() {
  var j_list = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(j, 'file')).split('/')[0] == 'https:') {
      j['file'] = (String('/') + String(subsequenceFromEndLast((getObjectProperty(j, 'file')).split('/'), 2).join('/')));
    }
  }
  ;(async () => {
      await Backendless.Data.of('Users').save( (getObjectProperty(___arguments.context.pageData, 'currentUser')) );
    await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), ((function () { return window.location.href })()));

  })();
  ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name'));
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('userLocationInfo')) {
    localStorage.removeItem((String('q_') + String(getObjectProperty((await Backendless.UserService.getCurrentUser(false)), 'objectId'))));
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4b355be55125c224bc817e9cfdb9859a', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('80c6fc3994c5445c0cdbbee9b15cb11d', true);
  } else {
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('7e0904fd756f8ee9720caae3a1bbeffd', ({ [`title`]: 'Location needed',[`message`]: 'For the application to work correctly, it needs access to geolocation. To be able to continue working, please enable geolocation on your device and allow the application to access it.',[`buttonLabel`]: 'Got It!',[`open`]: true }));
  }
}

/**
 * Describe this function...
 */
async function getLocation() {
  userLocation = (await BackendlessUI.Functions.Custom['fn_47bed951feaa47e346a419d69147a6a6']());
  if (userLocation && (getObjectProperty(userLocation, 'locationGeoPoint'))) {
    ___arguments.context.appData['userLocationInfo'] = ({ [`locationGeoPoint`]: (getObjectProperty(userLocation, 'locationGeoPoint')),[`location`]: (getObjectProperty(userLocation, 'location')) });
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['locationGeoPoint'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'userLocationInfo')), 'locationGeoPoint'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['location'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'userLocationInfo')), 'location'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['country'] = (getObjectProperty(userLocation, 'country'));
    localStorage.setItem('userLocationInfo', JSON.stringify((getObjectProperty(___arguments.context.appData, 'userLocationInfo'))));
    localStorage.setItem('country', JSON.stringify((getObjectProperty(userLocation, 'country'))));
    ___arguments.context.pageData['isUserLocationSet'] = true;
  }
}


  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['name'] = (getObjectProperty(___arguments.context.pageData, 'userName'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['aboutShort'] = (getObjectProperty(___arguments.context.pageData, 'briefDescription'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['aboutDetailed'] = (getObjectProperty(___arguments.context.pageData, 'fullDescription'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['interestsForAI'] = (getObjectProperty(___arguments.context.pageData, 'interests'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['qualitiesForAI'] = (getObjectProperty(___arguments.context.pageData, 'qualities'));
  if (!(getObjectProperty(___arguments.context.pageData, 'smallPhoto'))) {
    ___arguments.context.pageData['smallPhoto'] = [];
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = (getObjectProperty((await (async function(width, percent, path, content) {

    	  const img = await getNewImage(content)

    	  const elem = document.createElement('canvas')

    	  const widthImage = !width ? img.width : width
    	  const scaleFactor = width && width / img.width
    	  const heightImage = width ? img.height * scaleFactor : img.height

    	  elem.width = widthImage
    	  elem.height = heightImage

    	  const ctx = elem.getContext('2d')

    	  ctx.drawImage(img, 0, 0, widthImage, heightImage)

    	  const blob = await getCanvasBlob(ctx.canvas, percent)

    	  const newFile = new File([blob], 'photo.jpeg', {
    	    type: 'image/jpeg',
    	    lastModified: Date.now()
    	  })
    	  // const {fileUrl} = await Backendless.Files.upload(newFile, path, true)

    	async function getNewImage(content) {
    	  const result = await new Promise((resolve) => {
    	    const img = new Image()

    	    img.crossOrigin = "Anonymous"
    	    img.src = content
    	    img.onload = () => resolve(img)
    	  })

    	  return result

    	}

    	async function getCanvasBlob(canvas, percent) {
    	  const result = await new Promise((resolve) => {
    	    canvas.toBlob((blob) => {
    	      resolve(blob)
    	    }, 'image/jpeg', percent)
    	  })

    	  return result
    	}

    	return await Backendless.Files.upload(newFile, path, true)


    })(50, 1, (String('/pictures/thumbnails/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'))), (getObjectProperty(___arguments.context.pageData, 'photoSrc')))), 'fileURL'));
  } else {
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = ((getObjectProperty(___arguments.context.pageData, 'smallPhoto'))[0]);
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['media'] = [({ [`file`]: (getObjectProperty((await (async function(width, percent, path, content) {
  	let widthImage = 0
  	let heightImage = 0

  	const img = await getNewImage(content)

  	const elem = document.createElement('canvas')

  	// const widthImage = !width ? img.width : width
  	// const scaleFactor = width && width / img.width
  	// const heightImage = width ? img.height * scaleFactor : img.height

  	if (!width || img.width < width) {
  	  widthImage = img.width
  	  heightImage = img.height
  	} else {
  	  widthImage = width
  	  const scaleFactor = width / img.width
  	  heightImage = img.height * scaleFactor
  	}

  	elem.width = widthImage
  	elem.height = heightImage

  	const ctx = elem.getContext('2d')

  	ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	const blob = await getCanvasBlob(ctx.canvas, percent)

  	const newFile = new File([blob], 'photo.jpeg', {
  	  type: 'image/jpeg',
  	  lastModified: Date.now()
  	})

  	async function getNewImage(content) {
  	  const result = await new Promise((resolve) => {
  	    const img = new Image()

  	    img.crossOrigin = "Anonymous"
  	    img.src = content
  	    img.onload = () => resolve(img)
  	  })

  	  return result

  	}

  	async function getCanvasBlob(canvas, percent) {
  	  const result = await new Promise((resolve) => {
  	    canvas.toBlob((blob) => {
  	      resolve(blob)
  	    }, 'image/jpeg', percent)
  	  })

  	  return result
  	}

  	return await Backendless.Files.upload(newFile, path, true)
  })(1000, 0.8, (String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'))), (getObjectProperty(___arguments.context.pageData, 'photoSrc')))), 'fileURL')),[`type`]: 'image',[`isCover`]: true,[`isPrivate`]: false })];
  if (!((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('userLocationInfo')) || !(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'locationGeoPoint'))) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22084583fe7686c2b38bf328661cfd69', true);
    await getLocation();
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('22084583fe7686c2b38bf328661cfd69', false);
  }
  await saveData();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/79e3fa950f9a67717494e8ddcde54402/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('0e554b9dd99b3fae7e9f06774b955072'))['display'] = 'none';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('4276261c9dc4581ddc8529bbefde19c7', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f72241bc6634b67442c46ee9e77bb7ea', false);
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('7b472c84f07689d90f9a20a503b1685e'))['display'] = 'flex';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('f0af25ed6cdf74489284ada593a70214', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/c35b86cb78df350b962838a52027fe6c/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c351d12674131dd8facde0f0cab94cd')) {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c351d12674131dd8facde0f0cab94cd')), 'el'))['maxLength'] = 25;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/quiz/components/1c351d12674131dd8facde0f0cab94cd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'userName')).length > 25) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1c351d12674131dd8facde0f0cab94cd')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1c351d12674131dd8facde0f0cab94cd')), 'alert-border');
    }
    ___arguments.context.pageData['nameErrorMessage'] = 'Maximum 25 characters';
  } else if ((getObjectProperty(___arguments.context.pageData, 'userName')).trim().length < 2) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1c351d12674131dd8facde0f0cab94cd')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1c351d12674131dd8facde0f0cab94cd')), 'alert-border');
    }
    ___arguments.context.pageData['nameErrorMessage'] = 'Minimum 2 characters';
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1c351d12674131dd8facde0f0cab94cd')).includes('alert-border')) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('1c351d12674131dd8facde0f0cab94cd')), 'alert-border', '');
    }
    ___arguments.context.pageData['nameErrorMessage'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfe3689990c425025cb97d686e6323f1'))['marginBottom'] = '25vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('1c351d12674131dd8facde0f0cab94cd')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfe3689990c425025cb97d686e6323f1'))['marginBottom'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/quiz/components/6a6d1755c3f9527d0b7b5f9ca764bc04/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if ((getObjectProperty(___arguments.context.pageData, 'briefDescription')).trim().length < 15) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6a6d1755c3f9527d0b7b5f9ca764bc04')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6a6d1755c3f9527d0b7b5f9ca764bc04')), 'alert-border');
    }
    ___arguments.context.pageData['descriptionErrorMessage'] = 'Minimum 15 characters';
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6a6d1755c3f9527d0b7b5f9ca764bc04')).includes('alert-border')) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6a6d1755c3f9527d0b7b5f9ca764bc04')), 'alert-border', '');
    }
    ___arguments.context.pageData['descriptionErrorMessage'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfe3689990c425025cb97d686e6323f1'))['marginBottom'] = '25vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f1de2d7944f7bfba6b7123af9ecd3a5a')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfe3689990c425025cb97d686e6323f1'))['marginBottom'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/quiz/components/13e83001835c4f2526095cf979062253/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'gender'))

  },
  /* handler:onCheckedValueAssignment */
  /* content */
}))

define('./pages/quiz/components/cc3c0b943de7204c00fc893c4b5b54ef/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'gender'))

  },
  /* handler:onCheckedValueAssignment */
  /* content */
}))

define('./pages/quiz/components/ee935667d74517b7b02fd253e363e3ea/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'gender'))

  },
  /* handler:onCheckedValueAssignment */
  /* content */
}))

define('./pages/quiz/components/db5e38ee7616b134b8464f122924cad4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var userRequestActivity;


  ___arguments.context.pageData['disabledSetupDoneBtn'] = true;
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('userRequestActivity')) {
    userRequestActivity = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('userRequestActivity'));
    localStorage.removeItem('userRequestActivity');
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: userRequestActivity }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/quiz/components/f8b30103b25e3feadf42263d1ff222b9/bundle.js', [], () => ({
  /* content */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfe3689990c425025cb97d686e6323f1'))['marginBottom'] = '25vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('79af8821170873c4abbf8c7b5ddebbb8')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('bfe3689990c425025cb97d686e6323f1'))['marginBottom'] = '0';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/registration/components/ea93768867464198176cccbc5dd46b4d/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    var newData, nextActiveId, oldData, activeId, fetchData;

  },
  /* handler:onMounted */
  /* handler:onVisibilityChange */
  ['onVisibilityChange'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('slides');

  },
  /* handler:onVisibilityChange */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('slides');

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/registration/components/33d85a825125deee88fdb26732168804/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['onboarding__slider-item active'];
  }

  return ['onboarding__slider-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/registration/components/19eee636ad8d36031ab2ff7d4d71a16a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newData, oldData;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  oldData = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('d5475b0a598fd7ec5d07431661e408da'));
  if ((getObjectProperty(___arguments.context.dataModel, 'active')) == false) {
    newData = (await BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'](oldData, (getObjectProperty(___arguments.context.dataModel, 'objectId'))));
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aaed25fc13a63eb92097bd5939f6bd04', newData);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d47df57b11d1b27df885c688728c30e2', newData);
    (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5475b0a598fd7ec5d07431661e408da', newData);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['slider__dots-item active'];
  }

  return ['slider__dots-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/registration/components/8c2584be4c56673c6a8dfe675d837252/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var newData, nextActiveId, oldData, activeId, fetchData, error;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setIntervals'); const timer = setInterval(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if ((function(){ try { return JSON.parse(localStorage.getItem('firstRunComplete')) } catch(e){ return null }})()) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c2584be4c56673c6a8dfe675d837252', false);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4a10b07b8a51d35d34c045d91d5b51d', false);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e696f82bb6654778927bf94873775fae')), 'open');
  } else if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 992) {
    localStorage.setItem('firstRunComplete', JSON.stringify(true));
    await new Promise(r => setTimeout(r, 1000 || 0));
    if (!((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c2584be4c56673c6a8dfe675d837252'))) {
      stopSetTimeout('slides');
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c2584be4c56673c6a8dfe675d837252'))['opacity'] = 1;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c2584be4c56673c6a8dfe675d837252'))['visibility'] = 'visible';
      await new Promise(r => setTimeout(r, 1500 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c2584be4c56673c6a8dfe675d837252'))['opacity'] = 0;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('8c2584be4c56673c6a8dfe675d837252'))['visibility'] = 'hidden';
      await new Promise(r => setTimeout(r, 800 || 0));
      try {
        if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 992) {
          if (getObjectProperty(___arguments.context.pageData, 'fetchData')) {
            fetchData = (getObjectProperty(___arguments.context.pageData, 'fetchData'));
            activeId = (getObjectProperty((fetchData[0]), 'objectId'));
            newData = (await BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'](fetchData, activeId));
            if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aaed25fc13a63eb92097bd5939f6bd04')) {
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aaed25fc13a63eb92097bd5939f6bd04', newData);
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d47df57b11d1b27df885c688728c30e2', newData);
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5475b0a598fd7ec5d07431661e408da', newData);
              if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aaed25fc13a63eb92097bd5939f6bd04')) {

                ;(function() {
                  const callback = async () => {
                      oldData = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aaed25fc13a63eb92097bd5939f6bd04'));
                  nextActiveId = (await BackendlessUI.Functions.Custom['fn_ff776ab87025e31a9a7f4d5fcf8fe516'](oldData));
                  newData = (await BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'](oldData, nextActiveId));
                  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5475b0a598fd7ec5d07431661e408da', newData);
                  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d47df57b11d1b27df885c688728c30e2', newData);
                  (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aaed25fc13a63eb92097bd5939f6bd04', newData);

                  };

                  const timerId = 'slides';
                  const timerDelay = 2000;

                  runSetTimeout(timerId, callback, timerDelay)
                })()
              }
            }
          }
        }

      } catch (error) {
        console.log(error);
        await new Promise(r => setTimeout(r, 1000 || 0));
        fetchData = (getObjectProperty(___arguments.context.pageData, 'fetchData'));
        console.log(getObjectProperty(___arguments.context.pageData, 'fetchData'));
        activeId = (getObjectProperty((fetchData[0]), 'objectId'));
        newData = (await BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'](fetchData, activeId));
        if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('aaed25fc13a63eb92097bd5939f6bd04')) {
          (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aaed25fc13a63eb92097bd5939f6bd04', newData);
          (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d47df57b11d1b27df885c688728c30e2', newData);
          (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5475b0a598fd7ec5d07431661e408da', newData);
          if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aaed25fc13a63eb92097bd5939f6bd04')) {

            ;(function() {
              const callback = async () => {
                  oldData = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('aaed25fc13a63eb92097bd5939f6bd04'));
              nextActiveId = (await BackendlessUI.Functions.Custom['fn_ff776ab87025e31a9a7f4d5fcf8fe516'](oldData));
              newData = (await BackendlessUI.Functions.Custom['fn_03e9e4e2797693e9f375c3dfa7d7abc8'](oldData, nextActiveId));
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d5475b0a598fd7ec5d07431661e408da', newData);
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('d47df57b11d1b27df885c688728c30e2', newData);
              (function (componentUid, listItems) { ___arguments.context.getComponentByUid(componentUid).dynamicListItems = listItems })('aaed25fc13a63eb92097bd5939f6bd04', newData);

              };

              const timerId = 'slides';
              const timerDelay = 3000;

              runSetTimeout(timerId, callback, timerDelay)
            })()
          }
        }

      }
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8c2584be4c56673c6a8dfe675d837252', false);
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d4a10b07b8a51d35d34c045d91d5b51d'))['display'] = 'flex';
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d4a10b07b8a51d35d34c045d91d5b51d'))['opacity'] = 1;
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('d4a10b07b8a51d35d34c045d91d5b51d'))['visibility'] = 'visible';
    }
  }

  },
  /* handler:onMounted */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
      if (!((function(){ try { return JSON.parse(localStorage.getItem('firstRunComplete')) } catch(e){ return null }})()) && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) < 992) {
    ___arguments.context.pageData['fetchData'] = (await Backendless.Data.of('Slides').find(Backendless.DataQueryBuilder.create().setSortBy('order').setPageSize(10)));
  }

  },
  /* handler:onBeforeMount */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('slides');

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/registration/components/f269ae6d5e3c79532c99a64929a44bc8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d4a10b07b8a51d35d34c045d91d5b51d', false);
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e696f82bb6654778927bf94873775fae')), 'open');
  stopSetTimeout('1');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registration/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('slides');

  },
  /* handler:onLeave */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'FindMy+1'

  },  
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
      await (async function() {
  	const meta = document.createElement('meta')

  	meta.setAttribute('property', 'og:title')
  	meta.setAttribute('content', 'Check out this new connection platform I found: https://app.findmyplus.one. Post an activity and get matched with a perfect +1')

  	document.querySelector("head").appendChild(meta)

  })();

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/registration/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registration/components/d5ffd4f94dff4746bd15eec287a9ba56/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['onboarding__text-subtitle active'];
  }

  return ['onboarding__text-subtitle']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/registration/components/efabfff772c554daa0c1e80bf5e7eb65/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.dataModel, 'active')) {
    return ['onboarding__text-description active'];
  }

  return ['onboarding__text-description']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/registration/components/ff8d722900cd0c5e65c2f0b8c435036e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('33d85a825125deee88fdb26732168804'), 'active')) {
    return ['onboarding__text-title active'];
  }

  return ['onboarding__text-title']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/registration/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['','© ',(new Date((new Date())).getFullYear()),'  FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/registration/components/1bac70e39cddb3b1e7f4a039f32f0449/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
    var usersServiceArray, countryIP, item, distance, geo;

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/registration/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (url, isExternal, params){ const queryString = BackendlessUI.QueryString.stringify(params); const targetUrl = `${url}${queryString ? '?' + queryString : ''}`; isExternal ? window.open(targetUrl, '_blank') : window.location = targetUrl; })('https://findmyplus.one/', true, null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/registration/components/27292276b8a4ecdff87d30d618b5bf59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    console.log(getObjectProperty(___arguments.context.pageData, 'userLocation'));
    await Backendless.Data.of('UserProfile').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'userProfile')), 'objectId')),'\''].join('')), ({ 'locationGeoPoint': ({ 'type': 'Point','coordinates': [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'userLocation')), 'longitude')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'userLocation')), 'latitude'))] }),'location': [(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'userLocation')), 'city')),', ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'userLocation')), 'country'))].join('') }) );
    await Backendless.Data.of('UserProfile').setRelation((getObjectProperty(___arguments.context.pageData, 'userProfile')), 'lastUsedServiceArea', (getObjectProperty(___arguments.context.pageData, 'newServiceArea')));
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).pop();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registration/components/49d71348e969ea056086e0ec3227b15e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).pop();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/registration/components/96fbc2810963c49665885b65a156f891/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) >= 992) {
    return true;
  } else {
    return false;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/registration/components/437fb07b266df948dff8442c017730aa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('home', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/916764cf81f7f4dd39add13dbd65fa7a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['height'] = (___arguments.value * 1);
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['height'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'height'));

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var height;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  height = (getObjectProperty(___arguments.context.pageData, 'heightList'));

  return height

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/search-filter/components/46531bbeeeff89bf3d7e716ea77caca9/bundle.js', [], () => ({
  /* content */
  /* handler:onDirectoryAssignment */
  ['onDirectoryAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return (String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia')));
  }

  return '/pictures/'

  },
  /* handler:onDirectoryAssignment */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var newThumb, content2, path, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  var j_list = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'media'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['isCover'] = false;
  }
  await (async function(oldImg, pageData, path) {
  	// loadCss('https://cdnjs.cloudflare.com/ajax/libs/cropper/2.3.4/cropper.min.css')

  	// await BackendlessUI.requireModule('https://cdnjs.cloudflare.com/ajax/libs/cropperjs/0.8.1/cropper.min.js')
  	await BackendlessUI.requireModule('https://backendlessappcontent.com/0669397B-EF4D-2FD1-FFDD-52D6B2154300/0961E282-EB32-4919-9847-6FDC35D51EF4/files/images/cropper.js')

  	 fileName = oldImg.split('/')

  	 document.querySelector('.modal-photo').classList.add('open')

  	  const block = document.createElement('div')

  	block.classList.add('cropper-photo')
  	block.innerHTML = `
  	  <div class="page">
  	  <h2 style="margin: 0 auto">Crop photo</h2>
  	  	<div class="box-2">
  	  		<div class="result"></div>
  	  	</div>
  	  	<div class="box-2 img-result hide">
  	  		<img class="cropped" src="" alt="">
  	  	</div>
  	  	<div class="box">
  	  		<button class="btn MuiButtonBase-root MuiButton-root bl-button MuiButton-contained bl-button--contained quiz__btn save hide" style="color: #fff; border: none;">Save</button>
  	  		<a href="" class="btn download hide">Download</a>
  	  	</div>
  	  </div>
  	`
  	  document.querySelector('.modal__container-photo').append(block)


  	let result = document.querySelector('.result'),
  	  img_result = document.querySelector('.img-result'),
  	  save = document.querySelector('.save'),
  	  cropped = document.querySelector('.cropped'),
  	  dwn = document.querySelector('.download'),
  	  upload = document.querySelector('#file-input'),
  	  cropper = ''

  	const width = 700

  	const img = document.createElement('img')

  					img.id = 'image'
  					img.src = oldImg
  					result.innerHTML = ''

  	        result.appendChild(img)

  					save.classList.remove('hide')

  					cropper = new Cropper(img)

  	 save.addEventListener('click', async (e) => {
  	  e.preventDefault()

  	  const imgSrc = cropper.getCroppedCanvas({ width }).toDataURL("image/png")

  	  cropped.classList.remove('hide')

  	  cropped.src = imgSrc

  	  pageData.photo = imgSrc
  	  b64 = imgSrc.split(',')[1]

  	  const byteCharacters = atob(b64);
  	  const byteNumbers = new Array(byteCharacters.length);
  	  for (let i = 0; i < byteCharacters.length; i++) {
  	    byteNumbers[i] = byteCharacters.charCodeAt(i);
  	  }
  	  const byteArray = new Uint8Array(byteNumbers);
  	  const blob = new Blob([byteArray], {type: 'image/jpeg'});


  	  const newFile = new File([blob], fileName[fileName.length-1], {
  	    type: 'image/jpeg',
  	    lastModified: Date.now()
  	  })
  	  const { fileURL } = await Backendless.Files.upload(newFile, path, true)

  	  pageData.currentUser.photoThumbnail = pageData.photo


  	  // pageData.currentUser.media = pageData.currentUser.userProfile.media

  	  pageData.currentUser.userProfile.media.forEach(item => item.isCover = false)

  	  let newItem = {file: fileURL, isCover: true, isPrivate: false, type: 'image'}


  	  pageData.currentUser.userProfile.media.push(newItem)
  	  pageData.save = true

  	  document.querySelector('.modal-photo').classList.remove('open')

  	  pageData.save = false
  	  newItem = ''

  	})


  	// function loadCss(url) {
  	//     const link = document.createElement("link")

  	//     link.type = "text/css"
  	//     link.rel = "stylesheet"
  	//     link.href = url

  	//     document.querySelector("head").appendChild(link)
  	// }

  })(___arguments.uploadedFiles, ___arguments.context.pageData, (String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'))));
  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = ___arguments.uploadedFiles;
  ___arguments.context.pageData['avatar'] = ___arguments.uploadedFiles;
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('46531bbeeeff89bf3d7e716ea77caca9');
  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = (getObjectProperty(___arguments.context.pageData, 'avatar'));
  if (((function () { return window.location.href })()) == 'file://' || ((function () { return window.location.href })()) == '' || ((function () { return window.location.href })()) != 'https://app.findmyplus.one/?page=user-profile' || ((function () { return window.location.href })()) != 'https://app.findmyplus.one/?page=user-profile&data=%7B%7D') {
    path = ['/pictures/thumbnails/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('');
    content2 = String('https://app.findmyplus.one/api/files/') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')).split('/'), 2).join('/'));
  } else {
    path = String('/pictures/thumbnails/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
    content2 = String('/api/files/') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')).split('/'), 2).join('/'));
  }
  ___arguments.context.pageData['newThumbnail'] = (await (async function(width, percent, path, content) {

  	  const img = await getNewImage(content);

  	  const elem = document.createElement('canvas');

  	  const widthImage = !width ? img.width : width;
  	  const scaleFactor = width && width / img.width;
  	  const heightImage = width ? img.height * scaleFactor : img.height;

  	  elem.width = widthImage;
  	  elem.height = heightImage;

  	  const ctx = elem.getContext('2d');

  	  ctx.drawImage(img, 0, 0, widthImage, heightImage);

  	 const blob = await getCanvasBlob(ctx.canvas, percent);

  	  const newFile = new File([blob], 'photo'+ Date.now()+ '.jpeg', {
  	    type: 'image/jpeg',
  	    lastModified: Date.now()
  	  });


  	  // const {fileUrl} = await Backendless.Files.upload(newFile, path, true)


  	async function getNewImage(content) {
  	  const result = await new Promise((resolve) => {
  	    const img = new Image();

  	    img.crossOrigin = "Anonymous";
  	    img.src = content;
  	    img.onload = () => resolve(img);
  	  })

  	  return result;

  	};

  	async function getCanvasBlob(canvas, percent) {
  	  const result = await new Promise((resolve) => {
  	    canvas.toBlob((blob) => {
  	      resolve(blob)
  	    }, 'image/jpeg', percent)
  	  });

  	  return result;
  	};

  	return await Backendless.Files.upload(newFile, path, true);


  })(50, 1, path, content2));
  newThumb = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newThumbnail')), 'fileURL'));
  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = newThumb;
  ___arguments.context.appData['photo'] = newThumb;

  },
  /* handler:onUploadSuccess */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
    var file;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  file = ___arguments.files[0];
  ___arguments.context.pageData['smallPhoto'] = [];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85bab2bb114506dd428633a6e4df977e', true);
  await (async function(files, width, percent, path, thumbnailPhoto) {
  	// for (let index = 0; index < files.length; index++) {
  	const file = files

  	const fileName = file.name
  	let fileURL=''
  	let moderationResult=''

  	const content = await readFileAsDataURL(file)

  	const img = await getNewImage(content)

  	const elem = document.createElement('canvas')

  	const widthImage = !width ? img.width: width
  	const scaleFactor = width && width / img.width
  	const heightImage = width ? img.height * scaleFactor: img.height

  	elem.width = widthImage
  	elem.height = heightImage

  	const ctx = elem.getContext('2d')

  	ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	const blob = await getCanvasBlob(ctx.canvas, percent)

  	const newFile = new File([blob], 'photo.jpeg', {
  	  type: 'image/jpeg',
  	  lastModified: Date.now()
  	})

  	try {
  	  fileURL = await Backendless.Files.upload(newFile, path, overwrite = true)
  	  moderationResult = await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).query({
  	    'url': fileURL.fileURL}).send()

  	} catch (error) {
  	  if(fileURL) {
  	    await Backendless.Files.remove(fileURL.fileURL)
  	  }
  	  alert(error.message)
  	  throw new UserException('Content is prohibited');
  	  return
  	}

  	if (moderationResult === 'KO') {
  	  Backendless.Files.remove(fileURL.fileURL)
  	  throw new UserException('Content is prohibited')
  	  return
  	}

  	thumbnailPhoto.push(fileURL.fileURL)

  	//newFile
  	// files[index] = newFile
  	// }

  	async function readFileAsDataURL(file) {
  	  const result = await new Promise((resolve) => {
  	    const fileReader = new FileReader()

  	    fileReader.onload = (e) => resolve(e.target.result)


  	    fileReader.readAsDataURL(file)
  	  })

  	  return result
  	}

  	async function getNewImage(content) {
  	  const result = await new Promise((resolve) => {
  	    const img = new Image()

  	    img.src = content

  	    img.onload = () => resolve(img)
  	  })

  	  return result
  	}

  	async function getCanvasBlob(canvas, percent) {
  	  const result = await new Promise((resolve) => {
  	    canvas.toBlob((blob) => {
  	      resolve(blob)
  	    }, 'image/jpeg', percent)
  	  })

  	  return result
  	}

  	return thumbnailPhoto;
  })(file, 50, 100, (String('/pictures/thumbnails/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'))), (getObjectProperty(___arguments.context.pageData, 'smallPhoto')));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85bab2bb114506dd428633a6e4df977e', false);

  return (await (async function(files, width, percent) {
	for (let index = 0; index < files.length; index++) {
	  const file = files[index]

	  const fileName = file.name

	  const content = await readFileAsDataURL(file)

	  const img = await getNewImage(content)

	  const elem = document.createElement('canvas')

	  const widthImage = !width ? img.width : width
	  const scaleFactor = width && width / img.width
	  const heightImage = width ? img.height * scaleFactor : img.height

	  elem.width = widthImage
	  elem.height = heightImage

	  const ctx = elem.getContext('2d')

	  ctx.drawImage(img, 0, 0, widthImage, heightImage)

	  const blob = await getCanvasBlob(ctx.canvas, percent)

	  const newFile = new File([blob], fileName, {
	    type: 'image/jpeg',
	    lastModified: Date.now()
	  })

	  files[index] = newFile
	}

	async function readFileAsDataURL(file) {
	  const result = await new Promise((resolve) => {
	    const fileReader = new FileReader()

	    fileReader.onload = (e) => resolve(e.target.result)

	    fileReader.readAsDataURL(file)
	  })

	  return result
	}

	async function getNewImage(content) {
	  const result = await new Promise((resolve) => {
	    const img = new Image()

	    img.src = content

	    img.onload = () => resolve(img)
	  })

	  return result
	}

	async function getCanvasBlob(canvas, percent) {
	  const result = await new Promise((resolve) => {
	    canvas.toBlob((blob) => {
	      resolve(blob)
	    }, 'image/jpeg', percent)
	  })

	  return result
	}

	return files;
})(___arguments.files, 1000, 100))

  },
  /* handler:onBeforeUpload */
  /* handler:onUploadFail */
  ['onUploadFail'](___arguments) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('85bab2bb114506dd428633a6e4df977e', false);
  (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('b1a9a3a2a57c4a1bcb5b4e7e2f5b77fe', ({ 'showRejectMsg': true }));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('46531bbeeeff89bf3d7e716ea77caca9');

  },
  /* handler:onUploadFail */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'profileStatus')) {
    if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
      return false;
    } else {
      return true;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == false) {
      return false;
    } else {
      return true;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onFileNameAssignment */
  ['onFileNameAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ([((new Date()).valueOf()),'_',(getObjectProperty(___arguments.file, 'name')).toLowerCase()].join(''))

  },
  /* handler:onFileNameAssignment */
  /* content */
}))

define('./pages/search-filter/components/210f78999af9cd780d78138a39e97725/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('210f78999af9cd780d78138a39e97725')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')).length > 0) {
      if ((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


       return ((getObjectProperty(item, 'isCover')) == true);
      })) && (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


       return ((getObjectProperty(item, 'isCover')) == true);
      }))[0]) {
        return (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


         return ((getObjectProperty(item, 'isCover')) == true);
        }))[0]), 'file'));
      }
    } else {
      if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
        return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
      }
    }
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/search-filter/components/cd639dc90bf9cefc61f6848b410db64d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/search-filter/components/73881eb52cd3154e2fba501c285d8dde/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
      if (___arguments.context.pageData['currentUser']) {
    return ((___arguments.context.pageData['currentUser'])['email']);
  }

  },  
  /* handler:onTextAssignment */
  /* handler:onTargetPathAssignment */
  onTargetPathAssignment(___arguments) {
      if (___arguments.context.pageData['currentUser']) {
    return (String('mailto:') + String((___arguments.context.pageData['currentUser'])['email']));
  }

  },  
  /* handler:onTargetPathAssignment */
  /* content */
}))

define('./pages/search-filter/components/c4d360f9584d8828b116ff1ee133ba53/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var tempFiltersRadius, tempFilters, genderList, j, userCover, item, currentUser, radius, countriesThatUseMiles;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

/**
 * Describe this function...
 */
async function setDataToRadiusSelect() {
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) {
    countriesThatUseMiles = ['united states', 'usa', 'us', 'myanmar', 'myanmar (burma)', 'burma', 'mm', 'liberia', 'lr'];
    if (countriesThatUseMiles.includes((((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')).toLowerCase()))) {
      ___arguments.context.pageData['distanseUnit'] = [({ [`value`]: 'All',[`label`]: 'Radius not selected' }), ({ [`value`]: '16093',[`label`]: '10 mi' }), ({ [`value`]: '40234',[`label`]: '25 mi' }), ({ [`value`]: '80467',[`label`]: '50 mi' }), ({ [`value`]: '120701',[`label`]: '75 mi' }), ({ [`value`]: '160934',[`label`]: '100 mi' })];
    } else {
      ___arguments.context.pageData['distanseUnit'] = [({ [`value`]: 'All',[`label`]: 'Radius not selected' }), ({ [`value`]: '16000',[`label`]: '16 km' }), ({ [`value`]: '40000',[`label`]: '40 km' }), ({ [`value`]: '80000',[`label`]: '80 km' }), ({ [`value`]: '120000',[`label`]: '120 km' }), ({ [`value`]: '160000',[`label`]: '160 km' })];
    }
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    radius = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius'));
  }
  if (radius && radius != 'All') {
    if (((getObjectProperty(___arguments.context.pageData, 'distanseUnit')).map(item => item['value'])).includes(radius)) {
      (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('74a5c9bccf873f5a6a8e62ebf91c1efe', radius);
    }
  }
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
    ___arguments.context.appData['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'photo'));
    ___arguments.context.appData['profileStatus'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'profileStatus'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
  currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  ___arguments.context.pageData['userNameMedia'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).replace((new RegExp('[^\\w\\s]', 'g')), ''));
  ;(async () => {
      userCover = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    }))[0];
    if (userCover) {
      (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty(userCover, 'file'));
    }

  })();
  ;(async () => {
      if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')) {
      Object.assign(___arguments.context.dataModel, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')));
      ___arguments.context.pageData['financialCheckboxChecked'] = ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'financialRole')) == null);
      delete ___arguments.context.dataModel['created'];
      delete ___arguments.context.dataModel['updated'];
      delete ___arguments.context.dataModel['objectId'];
      if (!(getObjectProperty(___arguments.context.dataModel, 'gender'))) {
        ___arguments.context.dataModel['gender'] = [];
      }
      if ((getObjectProperty(___arguments.context.dataModel, 'ageMin')) && !(getObjectProperty(___arguments.context.dataModel, 'ageMax'))) {
        ___arguments.context.dataModel['age'] = [(getObjectProperty(___arguments.context.dataModel, 'ageMin')), 100];
        ___arguments.context.dataModel['ageMax'] = 100;
      } else if (!(getObjectProperty(___arguments.context.dataModel, 'ageMin')) && (getObjectProperty(___arguments.context.dataModel, 'ageMax'))) {
        ___arguments.context.dataModel['age'] = [18, (getObjectProperty(___arguments.context.dataModel, 'ageMax'))];
        ___arguments.context.dataModel['ageMin'] = 18;
      } else if ((getObjectProperty(___arguments.context.dataModel, 'ageMin')) && (getObjectProperty(___arguments.context.dataModel, 'ageMax'))) {
        ___arguments.context.dataModel['age'] = [(getObjectProperty(___arguments.context.dataModel, 'ageMin')), (getObjectProperty(___arguments.context.dataModel, 'ageMax'))];
      } else if (!(getObjectProperty(___arguments.context.dataModel, 'ageMin')) && !(getObjectProperty(___arguments.context.dataModel, 'ageMax'))) {
        ___arguments.context.dataModel['age'] = [18, 100];
      }
    } else {
      ___arguments.context.dataModel['gender'] = [];
      ___arguments.context.dataModel['maritalStatus'] = [];
      ___arguments.context.dataModel['ethnicity'] = [];
      ___arguments.context.dataModel['religion'] = [];
      ___arguments.context.dataModel['sexOrientation'] = [];
      ___arguments.context.dataModel['education'] = [];
      ___arguments.context.dataModel['bodyType'] = [];
      ___arguments.context.dataModel['political'] = [];
      ___arguments.context.dataModel['hairColor'] = [];
      ___arguments.context.dataModel['smoke'] = [];
      ___arguments.context.dataModel['drink'] = [];
      ___arguments.context.dataModel['dietaryPreference'] = [];
    }
    genderList = [({ [`label`]: 'Female',[`isChecked`]: false }), ({ [`label`]: 'Male',[`isChecked`]: false }), ({ [`label`]: 'Non-Binary',[`isChecked`]: false })];
    if (!!(getObjectProperty(___arguments.context.dataModel, 'gender')).length) {
      for (var j_index in genderList) {
        j = genderList[j_index];
        if ((getObjectProperty(___arguments.context.dataModel, 'gender')).includes((getObjectProperty(j, 'label')))) {
          j['isChecked'] = true;
        }
      }
    }
    ___arguments.context.dataModel['genderList'] = genderList;

  })();
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    if (getObjectProperty(___arguments.context.appData, 'activitiesSearch')) {
      if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'category')) && getValueLength((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'category'))) >= 36) {
        if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'category')) != 'All categories') {
          if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d147c7544bfafd78ac1ab1e3c27cb597')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d147c7544bfafd78ac1ab1e3c27cb597')), 'display'))) {
            (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('d147c7544bfafd78ac1ab1e3c27cb597', (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'category')));
          }
        }
      } else {
        tempFilters = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
        tempFilters['category'] = null;
        localStorage.setItem('tempFilters', JSON.stringify(tempFilters));
      }
    }
    if (getObjectProperty(___arguments.context.appData, 'activitiesSearch')) {
      if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'date')) && (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'date')) == 'This weekend') {
        ___arguments.context.pageData['selectedDate'] = 'This weekend';
        if ((new Date((new Date())).getDay()) == 1) {
          ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + ((86400 * 5) * 1000))).valueOf());
          ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 6) * 1000))).valueOf());
        } else if ((new Date((new Date())).getDay()) == 2) {
          ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + ((86400 * 4) * 1000))).valueOf());
          ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 5) * 1000))).valueOf());
        } else if ((new Date((new Date())).getDay()) == 3) {
          ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + ((86400 * 3) * 1000))).valueOf());
          ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 4) * 1000))).valueOf());
        } else if ((new Date((new Date())).getDay()) == 4) {
          ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + ((86400 * 2) * 1000))).valueOf());
          ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 3) * 1000))).valueOf());
        } else if ((new Date((new Date())).getDay()) == 5) {
          ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + ((86400 * 1) * 1000))).valueOf());
          ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 2) * 1000))).valueOf());
        } else if ((new Date((new Date())).getDay()) == 6) {
          ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + (0 * 1000))).valueOf());
          ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 1) * 1000))).valueOf());
        } else if ((new Date((new Date())).getDay()) == 7) {
          ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + (0 * 1000))).valueOf());
          ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + (0 * 1000))).valueOf());
        }
      } else if (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'date')) {
        ___arguments.context.pageData['dateStart'] = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'dateStart'));
        ___arguments.context.pageData['dateEnd'] = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'dateEnd'));
        ___arguments.context.pageData['selectedDate'] = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'date'));
      }
    }
    if ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')) && (((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')).indexOf('mi') !== -1) || ((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')).indexOf('km') !== -1))) {
      tempFiltersRadius = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
      tempFiltersRadius['radius'] = null;
      localStorage.setItem('tempFilters', JSON.stringify(tempFiltersRadius));
    }
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74a5c9bccf873f5a6a8e62ebf91c1efe')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74a5c9bccf873f5a6a8e62ebf91c1efe')), 'display'))) {
    await setDataToRadiusSelect();
  }
  ;(async () => {
      await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);

  })();
  ___arguments.context.pageData['pageLoaded'] = true;

  },
  /* handler:onBeforeMount */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var item, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function profilesTableData() {
  try {
    if (!((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')) && !(getObjectProperty(___arguments.context.appData, 'statusList'))) {
      ___arguments.context.appData['statusList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileMaritalStatus'));
      ___arguments.context.appData['ethnicityList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileEthnicity'));
      ___arguments.context.appData['bodyTypeList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileBodyType'));
      ___arguments.context.appData['orientationList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileSexOrientation'));
      ___arguments.context.appData['educationList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileEducationLevel'));
      ___arguments.context.appData['politicalList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfilePoliticalView'));
      ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
      ___arguments.context.appData['hairColorList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileHairColor'));
      ___arguments.context.appData['smokeList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileSmoke'));
      ___arguments.context.appData['drinkList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileDrink'));
      ___arguments.context.appData['dietaryList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileDietary'));
      ___arguments.context.appData['profilesData'] = ({ [`statusList`]: (getObjectProperty(___arguments.context.appData, 'statusList')),[`ethnicityList`]: (getObjectProperty(___arguments.context.appData, 'ethnicityList')),[`bodyTypeList`]: (getObjectProperty(___arguments.context.appData, 'bodyTypeList')),[`orientationList`]: (getObjectProperty(___arguments.context.appData, 'orientationList')),[`educationList`]: (getObjectProperty(___arguments.context.appData, 'educationList')),[`politicalList`]: (getObjectProperty(___arguments.context.appData, 'politicalList')),[`religionList`]: (await asyncListSort((getObjectProperty(___arguments.context.appData, 'religionList')), 1, async (item) => {


       return (getObjectProperty(item, 'name'));
      })),[`hairColorList`]: (getObjectProperty(___arguments.context.appData, 'hairColorList')),[`smokeList`]: (getObjectProperty(___arguments.context.appData, 'smokeList')),[`drinkList`]: (getObjectProperty(___arguments.context.appData, 'drinkList')),[`dietaryList`]: (getObjectProperty(___arguments.context.appData, 'dietaryList')) });
      localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
    } else if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')) && !(getObjectProperty(___arguments.context.appData, 'statusList'))) {
      ___arguments.context.appData['profilesData'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'));
      ___arguments.context.appData['statusList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'statusList'));
      ___arguments.context.appData['ethnicityList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'ethnicityList'));
      ___arguments.context.appData['bodyTypeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'bodyTypeList'));
      ___arguments.context.appData['orientationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'orientationList'));
      ___arguments.context.appData['educationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'educationList'));
      ___arguments.context.appData['politicalList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'politicalList'));
      ___arguments.context.appData['religionList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')), 1, async (item) => {


       return (getObjectProperty(item, 'name'));
      }));
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')).length <= 10) {
        ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
        (getObjectProperty(___arguments.context.appData, 'profilesData'))['religionList'] = (await asyncListSort((getObjectProperty(___arguments.context.appData, 'religionList')), 1, async (item) => {


         return (getObjectProperty(item, 'name'));
        }));
        localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
      }
      ___arguments.context.appData['hairColorList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'hairColorList'));
      ___arguments.context.appData['smokeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'smokeList'));
      ___arguments.context.appData['drinkList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'drinkList'));
      if (!(getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList'))) {
        ___arguments.context.appData['dietaryList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileDietary'));
        (getObjectProperty(___arguments.context.appData, 'profilesData'))['dietaryList'] = (getObjectProperty(___arguments.context.appData, 'dietaryList'));
        localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
      } else {
        ___arguments.context.appData['dietaryList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList'));
      }
    } else if ((getObjectProperty(___arguments.context.appData, 'religionList')) && (getObjectProperty(___arguments.context.appData, 'religionList')).length <= 10) {
      ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
      (getObjectProperty(___arguments.context.appData, 'profilesData'))['religionList'] = (getObjectProperty(___arguments.context.appData, 'religionList'));
      localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')).length <= 10) {
      ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
      (getObjectProperty(___arguments.context.appData, 'profilesData'))['religionList'] = (getObjectProperty(___arguments.context.appData, 'religionList'));
      localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
    }

  } catch (error) {
    console.log(error);

  }
}


  ;(async () => {
      if ((getObjectProperty(___arguments.context.appData, 'category')) && (getObjectProperty(___arguments.context.appData, 'activitiesSearch'))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d147c7544bfafd78ac1ab1e3c27cb597'))['value'] = (getObjectProperty(___arguments.context.appData, 'category'));
    }
    if ((getObjectProperty(___arguments.context.appData, 'activitiesSearch')) && (getObjectProperty(___arguments.context.appData, 'radius'))) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74a5c9bccf873f5a6a8e62ebf91c1efe'))['value'] = ((getObjectProperty(___arguments.context.appData, 'radius')) / 1609);
    } else {
      if (getObjectProperty(___arguments.context.appData, 'profilesRadius')) {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74a5c9bccf873f5a6a8e62ebf91c1efe'))['value'] = ((getObjectProperty(___arguments.context.appData, 'profilesRadius')) / 1609);
      }
    }
    if (!(getObjectProperty(___arguments.context.appData, 'statusList'))) {
      ___arguments.context.appData['profilesData'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'));
      ___arguments.context.appData['genderList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'genderList'));
      ___arguments.context.appData['statusList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'statusList'));
      ___arguments.context.appData['ethnicityList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'ethnicityList'));
      ___arguments.context.appData['bodyTypeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'bodyTypeList'));
      ___arguments.context.appData['orientationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'orientationList'));
      ___arguments.context.appData['educationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'educationList'));
      ___arguments.context.appData['politicalList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'politicalList'));
      ___arguments.context.appData['religionList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')), 1, async (item) => {


       return (getObjectProperty(item, 'name'));
      }));
      ___arguments.context.appData['hairColorList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'hairColorList'));
      ___arguments.context.appData['smokeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'smokeList'));
      ___arguments.context.appData['drinkList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'drinkList'));
      ___arguments.context.appData['dietaryList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList')), 1, async (item) => {


       return (getObjectProperty(item, 'id'));
      }));
    }
    await profilesTableData();

  })();

  },
  /* handler:onMounted */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isMainBlVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/5979df7d1ea76def79124244409e64d4/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/70f2547404293aab0e6c72e76781a2cd/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/f14a23fbebc8d1bd3e02f02e6cc20b23/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/54aa67d779df4b443aee7eeab00bc6d3/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      ___arguments.context.pageData['childrenList'] = [({ 'name': 'None','icon': '/images/speaker-low-volume.svg','value': -1 }), ({ 'name': '1','icon': '/images/performing-arts.svg','value': 1 }), ({ 'name': '2','icon': '/images/light-bulb.svg','value': 2 }), ({ 'name': 'More than 2','icon': '/images/person-standing.svg','value': 3 })];

  },
  /* handler:onBeforeMount */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'children')) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/64319b78c8e541859e34049a09c9393c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['height'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['heightPrefix'] = null;
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['height'] = ((getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'heightList'))[0]), 'value')) * 1);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['heightPrefix'] = 'minHeight';
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['heightPrefix'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'heightPrefix'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['height'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'height'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'height')) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/95c2e8cf2a39b1f3ec3b278902dd3273/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['maritalStatus'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['maritalStatusJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['maritalStatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['maritalStatusJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatusJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/65b5686909fc32d7055a59aaef72e057/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/0f28f89e2a6536cfb0eebe16d0559bda/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['children'] = null;
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['children'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'children'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'children')) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/01815e1e73fa255454e22ba1a802afcb/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ethnicity'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ethnicityJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ethnicity'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ethnicityJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicityJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/719557ecdc25ddc33fb93fbd57862026/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/9f2e76054637e1482e7f381dded7ebbd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['sexOrientation'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['sexOrientationJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['sexOrientation'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['sexOrientationJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientationJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/13356ad66f6c310958f5d5a4f6a5650d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/10362e039ae4c17f59e51513eeb650ec/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['education'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['educationJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['education'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['educationJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'educationJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/494c656b36747ff229e23696e147450c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['bodyType'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['bodyTypeJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['bodyType'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['bodyTypeJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyTypeJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/cfca34fb190c1fc1a33a77c2a80b8b53/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/965968e628f4867bdb1f39dbe7d31e36/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['political'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['politicalJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['political'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['politicalJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'politicalJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/6e58aea7af5ab5a76c7b4da47f5376b5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['hairColor'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['hairColorJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColorJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColorJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/4f3ddc1e8a7a893bf911c8eb0978b7c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/501d09be2a459665775f10ec82d24c52/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['religion'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['religionJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religionJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religionJson'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religion'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/a8db42ffbba6fb0120a63c65e89baedd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['maritalStatus'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['maritalStatusJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a8db42ffbba6fb0120a63c65e89baedd')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a8db42ffbba6fb0120a63c65e89baedd')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatusJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('a8db42ffbba6fb0120a63c65e89baedd')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['maritalStatus'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['maritalStatusJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatusJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['maritalStatus'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['maritalStatusJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatusJson'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'maritalStatus')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/291b763c95f5d6bbafa48f05487f8bed/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('291b763c95f5d6bbafa48f05487f8bed')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('291b763c95f5d6bbafa48f05487f8bed')), 'activity-page__quality-item-active');
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['children'] = (getObjectProperty(___arguments.context.dataModel, 'value'));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('291b763c95f5d6bbafa48f05487f8bed')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['children'] = null;
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['children'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'children'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'children')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'children')) == (getObjectProperty(___arguments.context.dataModel, 'value'))) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/54064f0e3191651d6a12169de924785a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ethnicity'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ethnicityJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54064f0e3191651d6a12169de924785a')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54064f0e3191651d6a12169de924785a')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicityJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('54064f0e3191651d6a12169de924785a')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ethnicity'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ethnicityJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicityJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ethnicity'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ethnicityJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicityJson'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ethnicity')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/5c17afcc57bb0b1abd42323dae8683e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['religion'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['religionJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religionJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['religion'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['religionJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religionJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religion'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['religionJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religionJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion')) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'religion')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/8e75f309995d41a7d5dd49872bdf2a58/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['education'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['educationJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'educationJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['education'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['educationJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'educationJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['education'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['educationJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'educationJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education')) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'education')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/e332d82dbc4c5d099d3919faf62be734/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['political'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['politicalJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'politicalJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['political'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['politicalJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'politicalJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['political'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['politicalJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'politicalJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political')) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'political')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/982656bea75328da811cc844403d3e19/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['sexOrientation'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['sexOrientationJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('982656bea75328da811cc844403d3e19')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('982656bea75328da811cc844403d3e19')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientationJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('982656bea75328da811cc844403d3e19')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['sexOrientation'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['sexOrientationJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientationJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['sexOrientation'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['sexOrientationJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientationJson'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'sexOrientation')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/ca6ecb0f5df69667b0b79f9fe86d845f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['bodyType'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['bodyTypeJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ca6ecb0f5df69667b0b79f9fe86d845f')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ca6ecb0f5df69667b0b79f9fe86d845f')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyTypeJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ca6ecb0f5df69667b0b79f9fe86d845f')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['bodyType'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['bodyTypeJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyTypeJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['bodyType'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['bodyTypeJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyTypeJson'));

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'bodyType')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/34a95071417e8828fbb385946e9c01d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor')) {
    if (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['hairColor'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['hairColorJson'] = [];
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34a95071417e8828fbb385946e9c01d3')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34a95071417e8828fbb385946e9c01d3')), 'activity-page__quality-item-active');
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColorJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34a95071417e8828fbb385946e9c01d3')).pop();
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['hairColor'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['hairColorJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColorJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColor'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColor'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['hairColorJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'hairColorJson'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/fc3a803dbceb524742ec629dfd5c048b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/cb0ff1a34b59b3ddd58310b281de9268/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-activities', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/23e9db8f324d6c9c77a611cf7e162196/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/6bccd771bec8f6f7a57bd8d34877f249/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6bccd771bec8f6f7a57bd8d34877f249')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('248fc77262aceb93bd34bd1aef813394', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6bccd771bec8f6f7a57bd8d34877f249')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6bccd771bec8f6f7a57bd8d34877f249')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('248fc77262aceb93bd34bd1aef813394', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/4a76a78ff1cab06128a741829c72394c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4a76a78ff1cab06128a741829c72394c')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7fa498dc1d183bd781cfbd825567742', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4a76a78ff1cab06128a741829c72394c')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4a76a78ff1cab06128a741829c72394c')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('d7fa498dc1d183bd781cfbd825567742', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/008218291a02136ed0fb86cc3a4851e9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('008218291a02136ed0fb86cc3a4851e9')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7edc250d1d03242d19b90c7a22e3ba9c', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('008218291a02136ed0fb86cc3a4851e9')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('008218291a02136ed0fb86cc3a4851e9')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('7edc250d1d03242d19b90c7a22e3ba9c', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/c1a6235eeacc10d237ec7055584e2c4e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c1a6235eeacc10d237ec7055584e2c4e')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62e4dd329421f5bd354575be5f1d567c', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c1a6235eeacc10d237ec7055584e2c4e')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c1a6235eeacc10d237ec7055584e2c4e')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('62e4dd329421f5bd354575be5f1d567c', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/5f172bef7ec46667a252bc3cf4340895/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5f172bef7ec46667a252bc3cf4340895')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ba225e6ee828b0d008582fc779cd05a', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5f172bef7ec46667a252bc3cf4340895')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5f172bef7ec46667a252bc3cf4340895')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0ba225e6ee828b0d008582fc779cd05a', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/e1f54fdf0b493eae01ee8dc306dce17a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e1f54fdf0b493eae01ee8dc306dce17a')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde6ddd40b7d94ef8c36a297b9113e09', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e1f54fdf0b493eae01ee8dc306dce17a')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e1f54fdf0b493eae01ee8dc306dce17a')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('dde6ddd40b7d94ef8c36a297b9113e09', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/288cbcc2e04d3a7c10dd0da3515ea1e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('288cbcc2e04d3a7c10dd0da3515ea1e3')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ea9f993b612fd40470393f2583a6b154', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('288cbcc2e04d3a7c10dd0da3515ea1e3')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('288cbcc2e04d3a7c10dd0da3515ea1e3')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ea9f993b612fd40470393f2583a6b154', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/06270879f4e131fa03734f289f1f2c7d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06270879f4e131fa03734f289f1f2c7d')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e111eb93edc561959ff7550ef0bbb2e2', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06270879f4e131fa03734f289f1f2c7d')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06270879f4e131fa03734f289f1f2c7d')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e111eb93edc561959ff7550ef0bbb2e2', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/796edaeb723bc14a80fec747dcee30bd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('796edaeb723bc14a80fec747dcee30bd')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee8c1466d44b2cd745c74b16d41ef49a', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('796edaeb723bc14a80fec747dcee30bd')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('796edaeb723bc14a80fec747dcee30bd')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('ee8c1466d44b2cd745c74b16d41ef49a', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/83f94aa273c9ecd56047c515f3e853c7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var updatedSearchFilter, newGenderList, item, tempFilters;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12f294e9db4cab1821f6c86a8df22f01', true);
  ___arguments.context.appData['filtersProfilesAdded'] = true;
  ___arguments.context.appData['filtersActivitiesAdded'] = true;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('83f94aa273c9ecd56047c515f3e853c7')) && (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83f94aa273c9ecd56047c515f3e853c7')).includes('notFocused'))) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83f94aa273c9ecd56047c515f3e853c7')), 'notFocused', '');
  }
  tempFilters = ({ [`category`]: (getObjectProperty(___arguments.context.pageData, 'checkedCategory')) ? (!!(getObjectProperty(___arguments.context.pageData, 'checkedCategory')).length ? (getObjectProperty(((getObjectProperty(___arguments.context.pageData, 'checkedCategory'))[0]), 'name')) : '') : (!(getObjectProperty(___arguments.context.pageData, 'resetCategory')) && ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) && (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'category')) ? (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'category')) : ''),[`radius`]: (getObjectProperty(___arguments.context.pageData, 'selectedRadius')) ? (getObjectProperty(___arguments.context.pageData, 'selectedRadius')) : (!(getObjectProperty(___arguments.context.pageData, 'resetRadius')) && ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) && (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')) ? (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'radius')) : ''),[`date`]: (getObjectProperty(___arguments.context.pageData, 'selectedDate')) ? (getObjectProperty(___arguments.context.pageData, 'selectedDate')) : (!(getObjectProperty(___arguments.context.pageData, 'resetDates')) && ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) && (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'date')) ? (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'date')) : '') });
  localStorage.setItem('tempFilters', JSON.stringify(tempFilters));
  newGenderList = (await Promise.all((await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ff65ce66562490a29b9769da52e33cdb')), async (item) => {


   return (getObjectProperty(item, 'isChecked'));
  })).map(async item => {; return (getObjectProperty(item, 'label'));})));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['gender'] = newGenderList;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['gender'] = newGenderList;
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['financialRole'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'financialRole'));
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')) {
    updatedSearchFilter = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'objectId'));
    await Backendless.Data.of('UserSearchFilter').bulkUpdate( (['objectId=\'',updatedSearchFilter,'\''].join('')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53') );
  }
  ___arguments.context.appData['users'] = (await BackendlessUI.Functions.Custom['fn_f918007d700c69eceb3445db5ba65eec']((getObjectProperty(___arguments.context.pageData, 'currentUser')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 10, ___arguments.context.pageData));
  delete ___arguments.context.appData['activityList'];
  if (getObjectProperty(___arguments.context.pageData, 'resetFilters')) {
    delete ___arguments.context.appData['filtersActivitiesAdded'];
    delete ___arguments.context.appData['filtersProfilesAdded'];
    delete ___arguments.context.pageData['resetFilters'];
  }
  ___arguments.context.pageData['isModalSavedChangesOpen'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('12f294e9db4cab1821f6c86a8df22f01', false);
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('83f94aa273c9ecd56047c515f3e853c7')) && !(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83f94aa273c9ecd56047c515f3e853c7')).includes('notFocused'))) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('83f94aa273c9ecd56047c515f3e853c7')), 'notFocused');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['© ','',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/search-filter/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'messagesNumber')) && (getObjectProperty(___arguments.context.pageData, 'messagesNumber')) > 0) {
    return (['(',(getObjectProperty(___arguments.context.pageData, 'messagesNumber')),') Search filters'].join(''));
  }

  return 'Search filters'

  },
  /* handler:onTitleAssignment */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    var error, item, j, userProfile;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ___arguments.context.appData['previousPage'] = 'user-profile';
  }

  },
  /* handler:onLeave */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;


  ___arguments.context.pageData['isMainVisible'] = true;
  ___arguments.context.pageData['isMainBlVisible'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    ___arguments.context.pageData['isHeaderVisible'] = true;
    ___arguments.context.pageData['isFilterHeadingVisible'] = true;
    ___arguments.context.pageData['isAsideUserProfileVisible'] = true;
  } else {
    ___arguments.context.pageData['isHeaderVisible'] = false;
    ___arguments.context.pageData['isFilterHeadingVisible'] = false;
    ___arguments.context.pageData['isAsideUserProfileVisible'] = false;
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_searchFilterpage_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/search-filter/components/837ba13198bd952a4e81471e756ce2ab/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('07b36232d73163cb4be5b5bf1dd2b9cb')), 'open');

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/a55e1b3b390fc107c0a2b647d3dc7af7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('personal-data-quiz', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/b69eeb7cd1534988c021ecfe2cef5d96/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return false

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/9d7e39b25d5c261aa3ae54a3131859a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/66fa7bce7e9f8ad159fe391eee8ad415/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/ed311c31d8e92cf248e651fac6faf261/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['smoke'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['smokeJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smoke'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smokeJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smokeJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/ee258e9d4605139e522aa47ea05f45e2/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['drink'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['drinkJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drink'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drinkJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drinkJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/36399701d8c769cbcbd4c883d81f0c84/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  async onCheckedStateAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke')) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['smoke'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['smokeJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smokeJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['smoke'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['smokeJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smokeJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smoke'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smoke'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['smokeJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'smokeJson'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/50b412b31705a544f542b1fb001716d8/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  async onCheckedStateAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['drink'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['drinkJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drinkJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['drink'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['drinkJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drinkJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink')).length == 0) {
      (getObjectProperty(___arguments.context.pageData, 'drinkNoPref'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drink'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drink'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['drinkJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'drinkJson'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/e101a3ae4d24f979acfc001b9c6858ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var list;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f6ef273cecae4adb6e7d34838d269e2f')).includes('open'))) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f6ef273cecae4adb6e7d34838d269e2f')), 'open');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/e3a3ff8a687fd8b77088a1872b7a7aba/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if ((___arguments.context.pageData['currentUser']) && ((___arguments.context.pageData['currentUser'])['profileStatus']) == true) {
    return ['header-light__icon', 'pause'];
  } else {
    return ['header-light__icon', 'play'];
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/92862fd95b067d05ea02b42c8b73c555/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  onTextAssignment(___arguments) {
      if ((___arguments.context.pageData['currentUser']) && ((___arguments.context.pageData['currentUser'])['profileStatus']) == true) {
    return 'Pause my account';
  } else {
    return 'Reactivate my account';
  }

  },
  /* handler:onTextAssignment */
  /* content */
}))

define('./pages/search-filter/components/90c9569a56463d081da777b3b7e8f4e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8b376bc7df972302610e704c47bb8a4f')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/c58ef296cbb58bdcdf83964303311c56/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/a4e9fcb2181afabb5b33d47de1266747/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMin'] = (___arguments.value[0]);
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMax'] = (___arguments.value.slice(-1)[0]);
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ageMin'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMin'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ageMax'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMax'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['age'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'age'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/search-filter/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/b1c6599f2b6154c3d2eca523bdfd2b79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      await Backendless.UserService.logout();
  localStorage.removeItem('currentUser');
  localStorage.removeItem('tooltipInfo');
  ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('launch', null);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/4438de4c90c6f85a5b9b1f74f99b0059/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8b376bc7df972302610e704c47bb8a4f')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/7fd65e1e8601a96de7434adda04425db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('8b376bc7df972302610e704c47bb8a4f')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/6ea9ea64e62b2b815935c828785936d8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['inputGoogleEmail'];
  delete ___arguments.context.pageData['isGoogleplusUser'];
  delete ___arguments.context.pageData['password'];
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8b376bc7df972302610e704c47bb8a4f')).pop();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fcea7be993f52212f693a2518c4c2e3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efe9b75dfc2d1f7890f1d37e989ee482', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/18ac3d0f5661984a16099a4d955ad163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['inputGoogleEmail'];
  delete ___arguments.context.pageData['isGoogleplusUser'];
  delete ___arguments.context.pageData['password'];
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8b376bc7df972302610e704c47bb8a4f')).pop();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fcea7be993f52212f693a2518c4c2e3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efe9b75dfc2d1f7890f1d37e989ee482', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/48bab036739a37e18c751c7b822da44f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0ff60be6dd39ee8ca7d41edb36ef31c3'))['disabled'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0ff60be6dd39ee8ca7d41edb36ef31c3'))['disabled'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/70a6b355e8e6afc4bec978cbb34753b8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = true;
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03f20519e805f91f505f7d011d0181f6')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03f20519e805f91f505f7d011d0181f6', false);
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isGoogleplusUser')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/0ff60be6dd39ee8ca7d41edb36ef31c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'oAuthIdentities')) {
    if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'oAuthIdentities')).map(item => item['providerCode'])).includes('googleplus')) {
      ___arguments.context.pageData['isGoogleplusUser'] = true;
    }
  }
  ___arguments.context.pageData['enterMessage'] = ((getObjectProperty(___arguments.context.pageData, 'isGoogleplusUser')) ? 'Enter your google email' : 'Enter your password');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fcea7be993f52212f693a2518c4c2e3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efe9b75dfc2d1f7890f1d37e989ee482', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/de9f49df1556f3abc07eb147fd3974da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70a6b355e8e6afc4bec978cbb34753b8')), 'el')), 'type')) == 'text') {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70a6b355e8e6afc4bec978cbb34753b8')), 'el'))['type'] = 'password';
    delete ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('de9f49df1556f3abc07eb147fd3974da'))['2'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('de9f49df1556f3abc07eb147fd3974da'))['2'] = 'fa-eye';
  } else if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70a6b355e8e6afc4bec978cbb34753b8')), 'el')), 'type')) == 'password') {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70a6b355e8e6afc4bec978cbb34753b8')), 'el'))['type'] = 'text';
    delete ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('de9f49df1556f3abc07eb147fd3974da'))['2'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('de9f49df1556f3abc07eb147fd3974da'))['2'] = 'fa-eye-slash';
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isGoogleplusUser')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/c8979c7d4133aaf3e6c37afc6783dc3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, usersForUpdateChat, j, chats, shortUserId;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updateChatsOnMessagePage() {
  if (getObjectProperty(___arguments.context.appData, 'chats')) {
    chats = (getObjectProperty(___arguments.context.appData, 'chats'));
  } else {
    chats = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  }
  usersForUpdateChat = [];
  for (var j_index in chats) {
    j = chats[j_index];
    if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId'))))) {
        usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')));
      }
    }
    if ((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId'))))) {
        usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')));
      }
    }
  }
  await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('blockUser', usersForUpdateChat, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), null, null);
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function deleteUser() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('e79447b50b3b6f4e6c26ae6ae36f52ea', true);
  await updateChatsOnMessagePage();
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Media...';
  try {
    await Backendless.Files.removeDirectory(encodePath((['/pictures/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),'/'].join(''))));

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User folders...';
  try {
    await Backendless.Files.removeDirectory(encodePath((['/pictures/activities/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),'/'].join(''))));

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Activities...';
  await Backendless.Data.of('Activity').bulkDelete( (['author.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the ActivityPreferences...';
  await Backendless.Data.of('ActivityPreferences').bulkDelete( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Messagess...';
  await Backendless.Data.of('Message').bulkDelete( (['sender.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\'',' or receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Chats...';
  await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChatNoClause`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User profile...';
  await Backendless.Data.of('UserProfile').bulkDelete( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User search filter...';
  await Backendless.Data.of('UserSearchFilter').bulkDelete( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    await ( async function () { return BackendlessUI.DeviceAPI.unregisterDevice() })();
  }
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User record...';
  shortUserId = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')).split('-').slice(-1)[0];
  localStorage.removeItem((String(shortUserId) + String('_viewCounter')));
  localStorage.removeItem((String(shortUserId) + String('_viewEnabled')));
  localStorage.removeItem(shortUserId);
  await Backendless.Data.of(Backendless.User).remove({ objectId: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) });
  localStorage.removeItem('feedback');
  localStorage.removeItem('isShowModal');
  localStorage.removeItem('tooltipInfo');
  localStorage.removeItem('userLocationInfo');
  localStorage.removeItem('country');
  localStorage.removeItem('Backendless');
  localStorage.removeItem('currentUser');
  localStorage.removeItem('messages');
  localStorage.removeItem('lastChatInfoUpdate');
  localStorage.removeItem('tempFilters');
  await Backendless.UserService.logout();
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8b376bc7df972302610e704c47bb8a4f')).pop();
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8d168aace99e6f9c71adfc78f96a9193', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('69b9a7435b6e5a774f967f27f307dc8b', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('082f42395767fbba8e3cecc377115a28', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('79342911d5abe35ec88217a8aadb23da', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b6fef79531bc586ecf89cc0f52d241f8', true);
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ea9ea64e62b2b815935c828785936d8', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18ac3d0f5661984a16099a4d955ad163', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = true;
  try {
    if (getObjectProperty(___arguments.context.pageData, 'isGoogleplusUser')) {
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'email')) == (getObjectProperty(___arguments.context.pageData, 'inputGoogleEmail'))) {
        await deleteUser();
      } else {
        ___arguments.context.pageData['errorDeleteMessage'] = 'Wrong email';
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ea9ea64e62b2b815935c828785936d8', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18ac3d0f5661984a16099a4d955ad163', true);
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = false;
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03f20519e805f91f505f7d011d0181f6', true);
      }
    } else if ((await Backendless.UserService.login( (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'email')), (getObjectProperty(___arguments.context.pageData, 'password')), true  ))) {
      await deleteUser();
    }

  } catch (error) {
    ___arguments.context.pageData['errorDeleteMessage'] = 'Wrong password';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6ea9ea64e62b2b815935c828785936d8', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18ac3d0f5661984a16099a4d955ad163', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03f20519e805f91f505f7d011d0181f6', true);
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/41dc6a12a0f54b2af2e51495a356898e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('41dc6a12a0f54b2af2e51495a356898e')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('852df24c949d367de9076f859db50284', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('41dc6a12a0f54b2af2e51495a356898e')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('41dc6a12a0f54b2af2e51495a356898e')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('852df24c949d367de9076f859db50284', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/f023e6544be2607ee94a2781d227d11a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f023e6544be2607ee94a2781d227d11a')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc15a3128f137c34b3bc0375b0f73779', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f023e6544be2607ee94a2781d227d11a')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f023e6544be2607ee94a2781d227d11a')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('fc15a3128f137c34b3bc0375b0f73779', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/aef7de2daaa478aad83adf8b552ba84a/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.pageData['currentUser']) && ((___arguments.context.pageData['currentUser'])['profileStatus']) == true) {
    return 'Pause my account';
  } else {
    return 'Reactivate my account';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/search-filter/components/c5ecd202dce43da975e2073a242b3439/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.dataModel['isChecked'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/9f65760a0a6e490bdca6e2d43c35413a/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/search-filter/components/d147c7544bfafd78ac1ab1e3c27cb597/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'categoryList')) {
    return ([({ [`value`]: 'All categories',[`label`]: 'All categories' })].concat((await Promise.all((getObjectProperty(___arguments.context.pageData, 'categoryList')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'name')) });})))));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var item, tempFilter;


  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    tempFilter = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
    tempFilter['category'] = ___arguments.value;
    localStorage.setItem('tempFilters', JSON.stringify(tempFilter));
  } else {
    localStorage.setItem('tempFilters', JSON.stringify(({ [`category`]: ___arguments.value,[`radius`]: null,[`date`]: null,[`dateStart`]: null,[`dateEnd`]: null })));
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/74a5c9bccf873f5a6a8e62ebf91c1efe/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var selectedRadiusItem, item, radius, tempFilter;


  radius = ___arguments.value == 'All' ? null : ___arguments.value;
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    tempFilter = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
    tempFilter['radius'] = radius;
    localStorage.setItem('tempFilters', JSON.stringify(tempFilter));
  } else {
    localStorage.setItem('tempFilters', JSON.stringify(({ [`category`]: null,[`radius`]: radius,[`date`]: null,[`dateStart`]: null,[`dateEnd`]: null })));
  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'distanseUnit'))

  },
  /* handler:onOptionsAssignment */
  /* content */
}))

define('./pages/search-filter/components/5858a3ec9e6a140472f60fb48146a545/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b0366c8f677676cf51642ac5624df45')).includes('open'))) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b0366c8f677676cf51642ac5624df45')), 'open');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('264ba11b3fab960b21361c4c050fe728'))['display'] = 'block';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/fe44659a973757d32e0a8e2e1129f6f8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) && (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'date')) && !(getObjectProperty(___arguments.context.pageData, 'selectedDate'))) {
    return (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')), 'date'));
  } else if (getObjectProperty(___arguments.context.pageData, 'selectedDate')) {
    return (getObjectProperty(___arguments.context.pageData, 'selectedDate'));
  } else {
    return 'Activity Date';
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/search-filter/components/ff6bbb2dfba80467e2efea25281908c9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var tempFilter;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['selectedDate'] = 'All dates';
  ___arguments.context.pageData['dateStart'] = null;
  ___arguments.context.pageData['dateEnd'] = null;
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    tempFilter = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
    tempFilter['dateStart'] = null;
    tempFilter['dateEnd'] = null;
    tempFilter['date'] = null;
    localStorage.setItem('tempFilters', JSON.stringify(tempFilter));
  } else {
    localStorage.setItem('tempFilters', JSON.stringify(({ [`category`]: null,[`radius`]: null,[`date`]: null,[`dateStart`]: null,[`dateEnd`]: null })));
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b0366c8f677676cf51642ac5624df45')), 'open', '');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('396c5c8d35ad07ff8262779760b237f5')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('264ba11b3fab960b21361c4c050fe728'))['display'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/81b6d5b9d189a2e9dc58258a676a484d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var tempFilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['selectedDate'] = 'This weekend';
  if ((new Date((new Date())).getDay()) == 1) {
    ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + ((86400 * 5) * 1000))).valueOf());
    ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 6) * 1000))).valueOf());
  } else if ((new Date((new Date())).getDay()) == 2) {
    ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + ((86400 * 4) * 1000))).valueOf());
    ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 5) * 1000))).valueOf());
  } else if ((new Date((new Date())).getDay()) == 3) {
    ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + ((86400 * 3) * 1000))).valueOf());
    ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 4) * 1000))).valueOf());
  } else if ((new Date((new Date())).getDay()) == 4) {
    ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + ((86400 * 2) * 1000))).valueOf());
    ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 3) * 1000))).valueOf());
  } else if ((new Date((new Date())).getDay()) == 5) {
    ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + ((86400 * 1) * 1000))).valueOf());
    ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 2) * 1000))).valueOf());
  } else if ((new Date((new Date())).getDay()) == 6) {
    ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + (0 * 1000))).valueOf());
    ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + ((86400 * 1) * 1000))).valueOf());
  } else if ((new Date((new Date())).getDay()) == 7) {
    ___arguments.context.pageData['dateStart'] = ((new Date((new Date()).getTime() + (0 * 1000))).valueOf());
    ___arguments.context.pageData['dateEnd'] = ((new Date((new Date()).getTime() + (0 * 1000))).valueOf());
  }
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
    tempFilter = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
    tempFilter['dateStart'] = (getObjectProperty(___arguments.context.pageData, 'dateStart'));
    tempFilter['dateEnd'] = (getObjectProperty(___arguments.context.pageData, 'dateEnd'));
    tempFilter['date'] = (getObjectProperty(___arguments.context.pageData, 'selectedDate'));
    localStorage.setItem('tempFilters', JSON.stringify(tempFilter));
  } else {
    localStorage.setItem('tempFilters', JSON.stringify(({ [`category`]: null,[`radius`]: null,[`date`]: (getObjectProperty(___arguments.context.pageData, 'selectedDate')),[`dateStart`]: (getObjectProperty(___arguments.context.pageData, 'dateStart')),[`dateEnd`]: (getObjectProperty(___arguments.context.pageData, 'dateEnd')) })));
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b0366c8f677676cf51642ac5624df45')), 'open', '');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('396c5c8d35ad07ff8262779760b237f5')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('264ba11b3fab960b21361c4c050fe728'))['display'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/396c5c8d35ad07ff8262779760b237f5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'dateStart')) && !(getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = ([(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getFullYear())].join(''));
  } else if (!(getObjectProperty(___arguments.context.pageData, 'dateStart')) && (getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = ([(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getFullYear())].join(''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'dateStart')) && (getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = ([[(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getFullYear())].join(''),' - ',[(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getFullYear())].join('')].join(''));
  } else if (!(getObjectProperty(___arguments.context.pageData, 'dateStart')) && !(getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = 'Date range';
  }
  ___arguments.context.appData['dateStart'] = (getObjectProperty(___arguments.context.pageData, 'dateStart'));
  ___arguments.context.appData['dateEnd'] = (getObjectProperty(___arguments.context.pageData, 'dateEnd'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/38d7d11c2c976c1ab6bc6d2c83968971/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dateStart'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var tempFilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['dateStart'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.pageData, 'dateStart')) && !(getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = ([(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getFullYear())].join(''));
  } else if (!(getObjectProperty(___arguments.context.pageData, 'dateStart')) && (getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = ([(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getFullYear())].join(''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'dateStart')) && (getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = ([[(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getFullYear())].join(''),'-',[(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getFullYear())].join('')].join(''));
  } else if (!(getObjectProperty(___arguments.context.pageData, 'dateStart')) && !(getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = 'Date range';
  }
  if ((getObjectProperty(___arguments.context.pageData, 'dateStart')) && (getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
      tempFilter = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
      tempFilter['dateStart'] = (getObjectProperty(___arguments.context.pageData, 'dateStart'));
      tempFilter['dateEnd'] = (getObjectProperty(___arguments.context.pageData, 'dateEnd'));
      tempFilter['date'] = (getObjectProperty(___arguments.context.pageData, 'selectedDate'));
      localStorage.setItem('tempFilters', JSON.stringify(tempFilter));
    } else {
      localStorage.setItem('tempFilters', JSON.stringify(({ [`category`]: null,[`radius`]: null,[`date`]: (getObjectProperty(___arguments.context.pageData, 'selectedDate')),[`dateStart`]: (getObjectProperty(___arguments.context.pageData, 'dateStart')),[`dateEnd`]: (getObjectProperty(___arguments.context.pageData, 'dateEnd')) })));
    }
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b0366c8f677676cf51642ac5624df45')), 'open', '');
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('396c5c8d35ad07ff8262779760b237f5')), 'open', '');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('264ba11b3fab960b21361c4c050fe728'))['display'] = 'none';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/ad2c1d8b7436ed7dc04a8dc9e5452567/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  onValueAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'dateEnd'))

  },
  /* handler:onValueAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var tempFilter;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['dateEnd'] = ___arguments.value;
  if ((getObjectProperty(___arguments.context.pageData, 'dateStart')) && !(getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = ([(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getFullYear())].join(''));
  } else if (!(getObjectProperty(___arguments.context.pageData, 'dateStart')) && (getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = ([(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getFullYear())].join(''));
  } else if ((getObjectProperty(___arguments.context.pageData, 'dateStart')) && (getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = ([[(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateStart'))).getFullYear())].join(''),'-',[(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getMonth()) + 1,'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getDate()),'/',(new Date((getObjectProperty(___arguments.context.pageData, 'dateEnd'))).getFullYear())].join('')].join(''));
    if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters')) {
      tempFilter = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('tempFilters'));
      tempFilter['dateStart'] = (getObjectProperty(___arguments.context.pageData, 'dateStart'));
      tempFilter['dateEnd'] = (getObjectProperty(___arguments.context.pageData, 'dateEnd'));
      tempFilter['date'] = (getObjectProperty(___arguments.context.pageData, 'selectedDate'));
      localStorage.setItem('tempFilters', JSON.stringify(tempFilter));
    } else {
      localStorage.setItem('tempFilters', JSON.stringify(({ [`category`]: null,[`radius`]: null,[`date`]: (getObjectProperty(___arguments.context.pageData, 'selectedDate')),[`dateStart`]: (getObjectProperty(___arguments.context.pageData, 'dateStart')),[`dateEnd`]: (getObjectProperty(___arguments.context.pageData, 'dateEnd')) })));
    }
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b0366c8f677676cf51642ac5624df45')), 'open', '');
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('396c5c8d35ad07ff8262779760b237f5')), 'open', '');
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('264ba11b3fab960b21361c4c050fe728'))['display'] = 'none';
  } else if (!(getObjectProperty(___arguments.context.pageData, 'dateStart')) && !(getObjectProperty(___arguments.context.pageData, 'dateEnd'))) {
    ___arguments.context.pageData['selectedDate'] = 'Date range';
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/f6fbe98979a71a8b2b816c2eba3ed8b1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('396c5c8d35ad07ff8262779760b237f5')).includes('open'))) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('396c5c8d35ad07ff8262779760b237f5')), 'open');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/2b6768210b62ae01bc1442066d8ed9bb/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  ['onBeforeMount'](___arguments) {
      if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) {
    if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'US' || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'LR' || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country')) == 'MM') {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″' }), ({ [`value`]: '124',[`label`]: '4′1″' }), ({ [`value`]: '127',[`label`]: '4′2″' }), ({ [`value`]: '130',[`label`]: '4′3″' }), ({ [`value`]: '132',[`label`]: '4′4″' }), ({ [`value`]: '135',[`label`]: '4′5″' }), ({ [`value`]: '137',[`label`]: '4′6″' }), ({ [`value`]: '140',[`label`]: '4′7″' }), ({ [`value`]: '142',[`label`]: '4′8″' }), ({ [`value`]: '145',[`label`]: '4′9″' }), ({ [`value`]: '152',[`label`]: '5′0″' }), ({ [`value`]: '155',[`label`]: '5′1″' }), ({ [`value`]: '157',[`label`]: '5′2″' }), ({ [`value`]: '160',[`label`]: '5′3″' }), ({ [`value`]: '163',[`label`]: '5′4″' }), ({ [`value`]: '165',[`label`]: '5′5″' }), ({ [`value`]: '168',[`label`]: '5′6″' }), ({ [`value`]: '170',[`label`]: '5′7″' }), ({ [`value`]: '173',[`label`]: '5′8″' }), ({ [`value`]: '176',[`label`]: '5′9″' }), ({ [`value`]: '178',[`label`]: '5′10″' }), ({ [`value`]: '180',[`label`]: '5′11″' }), ({ [`value`]: '183',[`label`]: '6′0″' }), ({ [`value`]: '185',[`label`]: '6′1″' }), ({ [`value`]: '188',[`label`]: '6′2″' }), ({ [`value`]: '191',[`label`]: '6′3″' }), ({ [`value`]: '193',[`label`]: '6′4″' }), ({ [`value`]: '195',[`label`]: '6′5″' }), ({ [`value`]: '198',[`label`]: '6′6″' }), ({ [`value`]: '201',[`label`]: '6′7″' }), ({ [`value`]: '203',[`label`]: '6′8″' }), ({ [`value`]: '206',[`label`]: '6′9″' }), ({ [`value`]: '208',[`label`]: '6′10″' }), ({ [`value`]: '211',[`label`]: '6′11″' }), ({ [`value`]: '213',[`label`]: '7′0″' })];
    } else {
      ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '122 cm' }), ({ [`value`]: '124',[`label`]: '124 cm' }), ({ [`value`]: '127',[`label`]: '127 cm' }), ({ [`value`]: '130',[`label`]: '130 cm' }), ({ [`value`]: '132',[`label`]: '132 cm' }), ({ [`value`]: '135',[`label`]: '135 cm' }), ({ [`value`]: '137',[`label`]: '137 cm' }), ({ [`value`]: '140',[`label`]: '140 cm' }), ({ [`value`]: '142',[`label`]: '142 cm' }), ({ [`value`]: '145',[`label`]: '145 cm' }), ({ [`value`]: '152',[`label`]: '152 cm' }), ({ [`value`]: '155',[`label`]: '155 cm' }), ({ [`value`]: '157',[`label`]: '157 cm' }), ({ [`value`]: '160',[`label`]: '160 cm' }), ({ [`value`]: '163',[`label`]: '163 cm' }), ({ [`value`]: '165',[`label`]: '165 cm' }), ({ [`value`]: '168',[`label`]: '168 cm' }), ({ [`value`]: '170',[`label`]: '170 cm' }), ({ [`value`]: '173',[`label`]: '173 cm' }), ({ [`value`]: '176',[`label`]: '176 cm' }), ({ [`value`]: '178',[`label`]: '178 cm' }), ({ [`value`]: '180',[`label`]: '180 cm' }), ({ [`value`]: '183',[`label`]: '183 cm' }), ({ [`value`]: '185',[`label`]: '185 cm' }), ({ [`value`]: '188',[`label`]: '188 cm' }), ({ [`value`]: '191',[`label`]: '191 cm' }), ({ [`value`]: '193',[`label`]: '193 cm' }), ({ [`value`]: '195',[`label`]: '195 cm' }), ({ [`value`]: '198',[`label`]: '198 cm' }), ({ [`value`]: '201',[`label`]: '201 cm' }), ({ [`value`]: '203',[`label`]: '203 cm' }), ({ [`value`]: '206',[`label`]: '206 cm' }), ({ [`value`]: '208',[`label`]: '208 cm' }), ({ [`value`]: '211',[`label`]: '211 cm' }), ({ [`value`]: '213',[`label`]: '213 cm' })];
    }
  } else {
    ___arguments.context.pageData['heightList'] = [({ [`value`]: '122',[`label`]: '4′0″ (122 cm)' }), ({ [`value`]: '124',[`label`]: '4′1″ (124 cm)' }), ({ [`value`]: '127',[`label`]: '4′2″ (127 cm)' }), ({ [`value`]: '130',[`label`]: '4′3″ (130 cm)' }), ({ [`value`]: '132',[`label`]: '4′4″ (132 cm)' }), ({ [`value`]: '135',[`label`]: '4′5″ (135 cm)' }), ({ [`value`]: '137',[`label`]: '4′6″ (137 cm)' }), ({ [`value`]: '140',[`label`]: '4′7″ (140 cm)' }), ({ [`value`]: '142',[`label`]: '4′8″ (142 cm)' }), ({ [`value`]: '145',[`label`]: '4′9″ (145 cm)' }), ({ [`value`]: '152',[`label`]: '5′0″ (152 cm)' }), ({ [`value`]: '155',[`label`]: '5′1″ (155 cm)' }), ({ [`value`]: '157',[`label`]: '5′2″ (157 cm)' }), ({ [`value`]: '160',[`label`]: '5′3″ (160 cm)' }), ({ [`value`]: '163',[`label`]: '5′4″ (163 cm)' }), ({ [`value`]: '165',[`label`]: '5′5″ (165 cm)' }), ({ [`value`]: '168',[`label`]: '5′6″ (168 cm)' }), ({ [`value`]: '170',[`label`]: '5′7″ (170 cm)' }), ({ [`value`]: '173',[`label`]: '5′8″ (173 cm)' }), ({ [`value`]: '176',[`label`]: '5′9″ (176 cm)' }), ({ [`value`]: '178',[`label`]: '5′10″ (178 cm)' }), ({ [`value`]: '180',[`label`]: '5′11″ (180 cm)' }), ({ [`value`]: '183',[`label`]: '6′0″ (183 cm)' }), ({ [`value`]: '185',[`label`]: '6′1″ (185 cm)' }), ({ [`value`]: '188',[`label`]: '6′2″ (188 cm)' }), ({ [`value`]: '191',[`label`]: '6′3″ (191 cm)' }), ({ [`value`]: '193',[`label`]: '6′4″ (193 cm)' }), ({ [`value`]: '195',[`label`]: '6′5″ (195 cm)' }), ({ [`value`]: '198',[`label`]: '6′6″ (198 cm)' }), ({ [`value`]: '201',[`label`]: '6′7″ (201 cm)' }), ({ [`value`]: '203',[`label`]: '6′8″ (203 cm)' }), ({ [`value`]: '206',[`label`]: '6′9″ (206 cm)' }), ({ [`value`]: '208',[`label`]: '6′10″ (208 cm)' }), ({ [`value`]: '211',[`label`]: '6′11″ (211 cm)' }), ({ [`value`]: '213',[`label`]: '7′0″ (213 cm)' })];
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/search-filter/components/30b6f4b80a75e98ba3c7b46c28c2280f/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')).length) {
    return ['filters__container'];
  }

  return ['filters__container', 'no-prefs-content']

  },
  /* handler:onClassListAssignment */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'dietaryList'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/search-filter/components/b6fae6f59c1c4462c7b3e7dbb43cae1c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['dietaryPreference'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['dietaryPreferenceJson'] = [];
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreference'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreferenceJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreferenceJson'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')).length) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/765bcd6d93e7ff4aef8c984deef6a8bc/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')) {
    return (!!(await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')) || !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')).length) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['dietaryPreference'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['dietaryPreferenceJson'] = [];
  }
  if (___arguments.value) {
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreferenceJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['dietaryPreference'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['dietaryPreferenceJson'] = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreferenceJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference')).length == 0) {
      (getObjectProperty(___arguments.context.pageData, 'dietaryPreferenceNoPref'))['checked'] = true;
    }
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreference'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreference'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['dietaryPreferenceJson'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'dietaryPreferenceJson'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/b378c38e65b2a715a996c2f9e1f560a4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var usersForUpdateChat, j, chats;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus'))) {
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['profileStatus'] = false;
    ___arguments.context.appData['profileStatus'] = false;
    await Backendless.Data.of('Users').save( (getObjectProperty(___arguments.context.pageData, 'currentUser')) );
    (getObjectProperty(___arguments.context.appData, 'currentUser'))['profileStatus'] = (getObjectProperty(___arguments.context.appData, 'profileStatus'));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
    ;(async () => {
        if (getObjectProperty(___arguments.context.appData, 'chats')) {
        chats = (getObjectProperty(___arguments.context.appData, 'chats'));
      } else {
        chats = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      }
      usersForUpdateChat = [];
      for (var j_index in chats) {
        j = chats[j_index];
        if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
          if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId'))))) {
            usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')));
          }
        }
        if ((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
          if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId'))))) {
            usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')));
          }
        }
      }
      await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('blockUser', usersForUpdateChat, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), null);

    })();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/5cd6861740f2f5bb985e6167ce2ea3c8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f6ef273cecae4adb6e7d34838d269e2f')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/e7e40c9aa94e9a997647d691b2326801/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f6ef273cecae4adb6e7d34838d269e2f')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/search-filter/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/search-filter/components/f082dfcc895c2bd4e77aee032e6168dc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    try {
      await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('REQUEST_CAMERA_PERMISSIONS', undefined);
      await (async function() {
      	const btn = document.querySelector('.aside__upload-photo')

      	btn.click()
      })();
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f082dfcc895c2bd4e77aee032e6168dc')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f082dfcc895c2bd4e77aee032e6168dc')), 'hidden');
      }

    } catch (error) {
      console.log(error);
      await (async function() {
      	const btn = document.querySelector('.aside__upload-photo')

      	btn.click()
      })();
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('f082dfcc895c2bd4e77aee032e6168dc')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f082dfcc895c2bd4e77aee032e6168dc')), 'hidden');
      }

    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/2ebb6d6da4c3d7eda4a6dfe5e0dd6a29/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = true;
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03f20519e805f91f505f7d011d0181f6')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03f20519e805f91f505f7d011d0181f6', false);
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isGoogleplusUser'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/f02164bcc7f7fc0f4ce7a9aacb23e1e5/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    
  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/search-filter/components/332a8f3f7459ab2313ec1885e4d9af07/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var options, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  options = [({ [`value`]: 'profilePreferences',[`label`]: 'Choose your activity' })];
  if (getObjectProperty(___arguments.context.pageData, 'currentUserActivities')) {
    options = (options.concat((await Promise.all((getObjectProperty(___arguments.context.pageData, 'currentUserActivities')).map(async item => {; return ({ [`value`]: (getObjectProperty(item, 'objectId')),[`label`]: (getObjectProperty(item, 'name')) });})))));
  }

  return options

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var preferenses, searchFilter, item, itemList, checkedItem;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.pageData['chooseActivity'] = true;
  if ('profilePreferences' == ___arguments.value) {
    preferenses = (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'searchFilter'));
    preferenses['ageFrom'] = (getObjectProperty(preferenses, 'ageMin'));
    preferenses['ageTo'] = (getObjectProperty(preferenses, 'ageMax'));
  } else {
    ___arguments.context.pageData['checkedCategory'] = ___arguments.value;
    ___arguments.context.pageData['checkedActivity'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'currentUserActivities')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == ___arguments.value);
    }))[0]);
    preferenses = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'checkedActivity')), 'preferences'));
  }
  searchFilter = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'));
  if (preferenses) {
    console.log(preferenses);
    if (getObjectProperty(preferenses, 'ageFrom')) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMin'] = (getObjectProperty(preferenses, 'ageFrom'));
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMin'] = null;
    }
    if (getObjectProperty(preferenses, 'ageTo')) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMax'] = (getObjectProperty(preferenses, 'ageTo'));
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMax'] = null;
    }
    if (getObjectProperty(preferenses, 'gender')) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['gender'] = (getObjectProperty(preferenses, 'gender'));
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['gender'] = [];
    }
    checkedItem = (await Promise.all((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'genderList')).map(async item => {  if ((getObjectProperty(item, 'label')) == (await Promise.all((getObjectProperty(preferenses, 'gender')).map(async itemList => {; return itemList;})))) {
        item['isChecked'] = true;
      } else {
        item['isChecked'] = false;
      }
    ; return ;})));
    if ((getObjectProperty(preferenses, 'bodyType')) && (getObjectProperty(preferenses, 'bodyType')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['bodyType'] = (getObjectProperty(preferenses, 'bodyType'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('494c656b36747ff229e23696e147450c'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['bodyType'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('494c656b36747ff229e23696e147450c'))['checked'] = true;
    }
    if (getObjectProperty(preferenses, 'children')) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['children'] = (getObjectProperty(preferenses, 'children'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['children'] = null;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = true;
    }
    if ((getObjectProperty(preferenses, 'education')) && (getObjectProperty(preferenses, 'education')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['education'] = (getObjectProperty(preferenses, 'education'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10362e039ae4c17f59e51513eeb650ec'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['education'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10362e039ae4c17f59e51513eeb650ec'))['checked'] = true;
    }
    if ((getObjectProperty(preferenses, 'ethnicity')) && (getObjectProperty(preferenses, 'ethnicity')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ethnicity'] = (getObjectProperty(preferenses, 'ethnicity'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ethnicity'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked'] = true;
    }
    if ((getObjectProperty(preferenses, 'hairColor')) && (getObjectProperty(preferenses, 'hairColor')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['hairColor'] = (getObjectProperty(preferenses, 'hairColor'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6e58aea7af5ab5a76c7b4da47f5376b5'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['hairColor'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6e58aea7af5ab5a76c7b4da47f5376b5'))['checked'] = true;
    }
    if ((getObjectProperty(preferenses, 'height')) && (getObjectProperty(preferenses, 'height')) > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['height'] = (String(getObjectProperty(preferenses, 'height')));
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['heightPrefix'] = 'minHeight';
    } else if ((getObjectProperty(preferenses, 'height')) && (getObjectProperty(preferenses, 'height')) < 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['height'] = ((getObjectProperty(preferenses, 'height')) * -1);
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['heightPrefix'] = 'maxHeight';
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['height'] = null;
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['heightPrefix'] = null;
    }
    if ((getObjectProperty(preferenses, 'maritalStatus')) && (getObjectProperty(preferenses, 'maritalStatus')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['maritalStatus'] = (getObjectProperty(preferenses, 'maritalStatus'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['maritalStatus'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked'] = true;
    }
    if ((getObjectProperty(preferenses, 'politicalViews')) && (getObjectProperty(preferenses, 'politicalViews')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['political'] = (getObjectProperty(preferenses, 'politicalViews'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('965968e628f4867bdb1f39dbe7d31e36'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['political'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('965968e628f4867bdb1f39dbe7d31e36'))['checked'] = true;
    }
    if ((getObjectProperty(preferenses, 'religion')) && (getObjectProperty(preferenses, 'religion')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['religion'] = (getObjectProperty(preferenses, 'religion'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('501d09be2a459665775f10ec82d24c52'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['religion'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('501d09be2a459665775f10ec82d24c52'))['checked'] = true;
    }
    if ((getObjectProperty(preferenses, 'sexualIdentity')) && (getObjectProperty(preferenses, 'sexualIdentity')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['sexOrientation'] = (getObjectProperty(preferenses, 'sexualIdentity'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f2e76054637e1482e7f381dded7ebbd'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['sexOrientation'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f2e76054637e1482e7f381dded7ebbd'))['checked'] = true;
    }
    if ((getObjectProperty(preferenses, 'smoke')) && (getObjectProperty(preferenses, 'smoke')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['smoke'] = (getObjectProperty(preferenses, 'smoke'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed311c31d8e92cf248e651fac6faf261'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['smoke'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed311c31d8e92cf248e651fac6faf261'))['checked'] = true;
    }
    if ((getObjectProperty(preferenses, 'drink')) && (getObjectProperty(preferenses, 'drink')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['drink'] = (getObjectProperty(preferenses, 'drink'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee258e9d4605139e522aa47ea05f45e2'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['drink'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee258e9d4605139e522aa47ea05f45e2'))['checked'] = true;
    }
    if ((getObjectProperty(preferenses, 'dietaryPreference')) && (getObjectProperty(preferenses, 'dietaryPreference')).length > 0) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['dietaryPreference'] = (getObjectProperty(preferenses, 'dietaryPreference'));
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b6fae6f59c1c4462c7b3e7dbb43cae1c'))['checked'] = false;
    } else {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['dietaryPreference'] = [];
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b6fae6f59c1c4462c7b3e7dbb43cae1c'))['checked'] = true;
    }
    searchFilter = preferenses;
  } else if (!preferenses) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMin'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMax'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['gender'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['bodyType'] = [];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['gender'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('494c656b36747ff229e23696e147450c'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['children'] = null;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0f28f89e2a6536cfb0eebe16d0559bda'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['education'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('10362e039ae4c17f59e51513eeb650ec'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ethnicity'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('01815e1e73fa255454e22ba1a802afcb'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['hairColor'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6e58aea7af5ab5a76c7b4da47f5376b5'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['height'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['heightPrefix'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['maritalStatus'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('95c2e8cf2a39b1f3ec3b278902dd3273'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['political'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('965968e628f4867bdb1f39dbe7d31e36'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['religion'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('501d09be2a459665775f10ec82d24c52'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['sexOrientation'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('9f2e76054637e1482e7f381dded7ebbd'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['smoke'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ed311c31d8e92cf248e651fac6faf261'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['drink'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('ee258e9d4605139e522aa47ea05f45e2'))['checked'] = true;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['dietaryPreference'] = [];
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('b6fae6f59c1c4462c7b3e7dbb43cae1c'))['checked'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/020b49a8ac82256cbc7b4f8d8d678804/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['heightPrefix'] = ___arguments.value;
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['heightPrefix'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/264ba11b3fab960b21361c4c050fe728/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('7b0366c8f677676cf51642ac5624df45')), 'open', '');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('396c5c8d35ad07ff8262779760b237f5')), 'open', '');
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('264ba11b3fab960b21361c4c050fe728'))['display'] = 'none';

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/5a8e8e236a6ccfa5e34b715e387d0b15/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a8e8e236a6ccfa5e34b715e387d0b15')).includes('close')) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d77d48257075d514c779ca9a2fe829d', true);
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a8e8e236a6ccfa5e34b715e387d0b15')).pop();
    } else {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5a8e8e236a6ccfa5e34b715e387d0b15')), 'close');
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0d77d48257075d514c779ca9a2fe829d', false);
    }
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/92fa5e0381ae8cb7fb2d43ec88dd5584/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['financialRole'] = null;
    ___arguments.context.pageData['financialCheckboxChecked'] = ___arguments.value;
  } else {
    ___arguments.context.pageData['financialCheckboxChecked'] = ___arguments.value;
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'financialCheckboxChecked'))

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/47355511bb28f8785b3910bab9693f25/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/96e4a5632d666565174dd7c203038993/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.pageData['financialCheckboxChecked'] = false;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/3949534f12258cc17f9d9f65991cfc52/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'activitiesSearch'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/3c775084cdb7f195f51638949d487dcd/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'activitiesSearch'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/f85ccda571e51096719fa5698a955c8c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    var list;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'age'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMin')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMin')) : '18')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/search-filter/components/129f89d98a8ec674536948a183a5f20a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'age'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMax')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMax')) : '100')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/search-filter/components/da03f0f5d5c9069740e5c6b655b1e906/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/caf5a1a6fc273583ca294ac15c0af3ac/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalPauseAccOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/1d11e308eefa785b596e1231461e442c/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalShareOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/b105052d661b55f1c75b6cdf1b2481d1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalDeleteAccOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/e501702d2698f1af674460c2f298b9b6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isAsideUserProfileVisible'] = true;
  ___arguments.context.pageData['isFilterHeadingVisible'] = true;
  ___arguments.context.pageData['isMainBlVisible'] = false;
  ___arguments.context.pageData['isHeaderVisible'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/256ba10697b47d25f35d2e2ab98c4d2f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item, genderList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74a5c9bccf873f5a6a8e62ebf91c1efe')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('74a5c9bccf873f5a6a8e62ebf91c1efe')), 'display'))) {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('74a5c9bccf873f5a6a8e62ebf91c1efe', null);
  }
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d147c7544bfafd78ac1ab1e3c27cb597')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('d147c7544bfafd78ac1ab1e3c27cb597')), 'display'))) {
    (function (componentUid, value) { ___arguments.context.getComponentByUid(componentUid).value = value })('d147c7544bfafd78ac1ab1e3c27cb597', null);
  }
  localStorage.setItem('tempFilters', JSON.stringify(({ [`category`]: null,[`radius`]: null,[`date`]: null,[`dateStart`]: null,[`dateEnd`]: null })));
  ___arguments.context.pageData['resetFilters'] = true;
  ___arguments.context.pageData['selectedDate'] = null;
  ___arguments.context.pageData['dateStart'] = null;
  ___arguments.context.pageData['dateEnd'] = null;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMin'] = null;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMax'] = null;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['age'] = [18, 100];
  genderList = (await Promise.all(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ff65ce66562490a29b9769da52e33cdb')).map(async item => {  item['isChecked'] = false;
  ; return item;})));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['genderList'] = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('ff65ce66562490a29b9769da52e33cdb'));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['height'] = null;
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['heightPrefix'] = null;
  if (getObjectProperty(___arguments.context.appData, 'activitiesSearch')) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['financialRole'] = null;
    ___arguments.context.pageData['financialCheckboxChecked'] = true;
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ageMin'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMin'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ageMax'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMax'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['age'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'age'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['height'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'height'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['heightPrefix'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'heightPrefix'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/c1ef6f3e0819e0c15945c6c745f30825/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  ['onCheckedStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMax')) || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMin'))) {
    return false;
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMin'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMax'] = null;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['age'] = [18, 100];
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMin'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'age'))[0]);
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['ageMax'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'age')).slice(-1)[0]);
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ageMin'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMin'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['ageMax'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'ageMax'));
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['age'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'age'));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/search-filter/components/76d8743c5afb18f91f187951d31bb7b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['genderList'] = [({ [`label`]: 'Female',[`isChecked`]: false }), ({ [`label`]: 'Male',[`isChecked`]: false }), ({ [`label`]: 'Non-Binary',[`isChecked`]: false })];
  } else {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['genderList'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter')), 'genderList'));
  }
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'searchFilter'))['genderList'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'genderList'));

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var result, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'genderList')) {
    result = (await asyncListFind((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'genderList')), async (item) => {


     return ((getObjectProperty(item, 'isChecked')) == true);
    }));
    if (result) {
      return false;
    }
  }

  return true

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/search-filter/components/43d8aa77c841c37cc0df4379aa3be964/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isMissYouVisible')) && (getObjectProperty(___arguments.context.pageData, 'isAsideUserProfileVisible')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/search-filter/components/c1a9eaae43d762b36aac043387f10df5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/search-filter/components/40cf4f7c27410c93f1011aee94589086/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', ({ [`isFromAccountPage`]: true }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/c4d360f9584d8828b116ff1ee133ba53/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var userCover, item, currentUser, j, itemMedia;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
    ___arguments.context.appData['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'photoThumbnail'));
    ___arguments.context.appData['profileStatus'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'profileStatus'));
  }
  if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
  if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')).length) {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['blockList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/blockedUsers/getBlockedUsersData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'blockList': JSON.stringify(((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')).join('\',\''))) }).send());
  } else {
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['blockList'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['blockListJson'] = [];
  }
  currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  if (currentUser == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
  } else {
    if (!(getObjectProperty(___arguments.context.appData, 'login'))) {
      ___arguments.context.appData['login'] = (getObjectProperty(currentUser, 'login'));
      if (getObjectProperty(currentUser, 'photo')) {
        ___arguments.context.appData['photo'] = (getObjectProperty(currentUser, 'photoThumbnail'));
      }
    }
    if (!(getObjectProperty(___arguments.context.appData, 'name'))) {
      ___arguments.context.appData['name'] = (getObjectProperty(currentUser, 'name'));
    }
    userCover = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    }))[0];
    if (userCover) {
      (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty(userCover, 'file'));
    }
    ___arguments.context.pageData['userNameMedia'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).replace((new RegExp('[^\\w\\s]', 'g')), ''));
    if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')) && (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')) && (getObjectProperty((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')), 'notifications')).length == 4 || !(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings')))) {
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8')) {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = true;
      }
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d')) {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d'))['checked'] = true;
      }
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708')) {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708'))['checked'] = true;
      }
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6')) {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6'))['checked'] = true;
      }
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd')) {
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd'))['checked'] = true;
      }
    }
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings'))) {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['settings'] = ({ [`notifications`]: ['likes', 'replies', 'message', 'invites'] });
    }
    Object.assign(___arguments.context.dataModel, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')));
    delete ___arguments.context.dataModel['objectId'];
    delete ___arguments.context.dataModel['created'];
    delete ___arguments.context.dataModel['updated'];
    if (getObjectProperty(___arguments.context.dataModel, 'settings')) {
      if (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'visibility')) {
        ___arguments.context.dataModel['visibility'] = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'visibility'));
        if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'visibility')) == 1) {
          ___arguments.context.dataModel['selectedVisibility'] = 'Everyone';
        } else if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'visibility')) == 2) {
          ___arguments.context.dataModel['selectedVisibility'] = 'Members only';
        } else if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'visibility')) == 3) {
          ___arguments.context.dataModel['selectedVisibility'] = 'Invation only';
        }
      }
      if (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'notifications')) {
        ___arguments.context.dataModel['notifications'] = (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'notifications'));
        if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'notifications')).includes('likes')) {
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d'))['checked'] = true;
        }
        if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'notifications')).includes('replies')) {
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708'))['checked'] = true;
        }
        if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'notifications')).includes('message')) {
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6'))['checked'] = true;
        }
        if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'notifications')).includes('invites')) {
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd'))['checked'] = true;
        }
        if ((getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'settings')), 'notifications')).length == 4) {
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d'))['checked'] = true;
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708'))['checked'] = true;
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6'))['checked'] = true;
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd'))['checked'] = true;
          ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = true;
        }
      }
    } else {
      ___arguments.context.dataModel['visibility'] = 1;
    }
  }
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isMainBlVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/settings/components/67e4ff4ce96344dbe3615264c29963f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var channels, notification;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('saveSettingsData');

  ;(function() {
    const callback = async () => {
        notification = [];
    if (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8')), 'checked')) {
      addItemToList(notification, 'likes');
      addItemToList(notification, 'replies');
      addItemToList(notification, 'message');
      addItemToList(notification, 'invites');
    } else {
      if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d')), 'checked')) == true) {
        addItemToList(notification, 'likes');
      }
      if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708')), 'checked')) == true) {
        addItemToList(notification, 'replies');
      }
      if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6')), 'checked')) == true) {
        addItemToList(notification, 'message');
      }
      if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd')), 'checked')) == true) {
        addItemToList(notification, 'invites');
      }
    }
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings'))['notifications'] = notification;
    (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings'))['notifications'] = notification;
    await Backendless.Data.of('UserProfile').bulkUpdate( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53') );
    ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    channels = (await BackendlessUI.Functions.Custom['fn_60df16e39c865d63641b3eb11343e25f']((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
      ;(async () => {
          if (!channels.length) {
          await ( async function () { return BackendlessUI.DeviceAPI.unregisterDevice() })();
        } else {
          await ( async function () { return BackendlessUI.DeviceAPI.unregisterDevice() })();
          await ( async function (channels) { return BackendlessUI.DeviceAPI.registerDevice(channels) })(channels);
        }

      })();
    }

    };

    const timerId = 'saveSettingsData';
    const timerDelay = 1500;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/4656e7b669fd310c5462125d02b29333/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/27292276b8a4ecdff87d30d618b5bf59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'messagesNumber')) > 0) {
    return (['(',(getObjectProperty(___arguments.context.appData, 'messagesNumber')),') Settings'].join(''));
  }

  return 'Settings'

  },
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;


  ___arguments.context.pageData['isMainBlVisible'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    ___arguments.context.pageData['isHeaderVisible'] = true;
    ___arguments.context.pageData['isFilterHeadingVisible'] = true;
    ___arguments.context.pageData['isAsideUserProfileVisible'] = true;
  } else {
    ___arguments.context.pageData['isHeaderVisible'] = false;
    ___arguments.context.pageData['isFilterHeadingVisible'] = false;
    ___arguments.context.pageData['isAsideUserProfileVisible'] = false;
  }
  ___arguments.context.pageData['isCheckedFeedback'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('feedback'));
  ___arguments.context.pageData['pageLoaded'] = true;
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_settings_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    var error, item, j, userProfile;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  ___arguments.context.appData['previousPage'] = 'settings';
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ___arguments.context.appData['previousPage'] = 'user-profile';
  }

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/settings/components/6106c6b9cecd84b38b3c6c03f78e692d/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708')), 'checked')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6')), 'checked')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd')), 'checked')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = true;
    }
    if (!((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('likes'))) {
      addItemToList((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')), 'likes');
    }
  } else {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8')), 'checked')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = false;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('likes')) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings'))['notifications'] = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')), async (item) => {


       return (item != 'likes');
      }));
    }
  }
  await (async function(btnSave) {
  	btnSave.click();
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('67e4ff4ce96344dbe3615264c29963f9')), 'el')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/settings/components/fe5fb7f1fddbb38bec096ccfc4d4c4f8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.value) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d'))['checked'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708'))['checked'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6'))['checked'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd'))['checked'] = true;
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings'))) {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['settings'] = ({  });
    }
    (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings'))['notifications'] = ['likes', 'replies', 'message', 'invites'];
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings'))['notifications'] = ['likes', 'replies', 'message', 'invites'];
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d'))['checked'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708'))['checked'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6'))['checked'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd'))['checked'] = false;
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings'))) {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['settings'] = ({  });
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['settings'] = ({  });
    }
    (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings'))['notifications'] = [];
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings'))['notifications'] = [];
  }
  await (async function(btnSave) {
  	btnSave.click();
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('67e4ff4ce96344dbe3615264c29963f9')), 'el')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/settings/components/e147c1ab28ca6932024d6957c34602ba/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications'))) {
    if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'settings'))) {
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['settings'] = ({ [`notifications`]: ['likes', 'replies', 'message', 'invites'] });
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['notifications'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications'));
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('likes')) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d'))['checked'] = true;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('replies')) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708'))['checked'] = true;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('message')) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6'))['checked'] = true;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('invites')) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd'))['checked'] = true;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).length == 4) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d'))['checked'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708'))['checked'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6'))['checked'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd'))['checked'] = true;
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = true;
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/settings/components/c5e4dbd42eb6ffe9c0784ed60ac18d45/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['openSettings'] = false;
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('85fefb48c7bc4bf326cd0b6d6118c983')).includes('open')) {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('85fefb48c7bc4bf326cd0b6d6118c983')), 'open', '');
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c5e4dbd42eb6ffe9c0784ed60ac18d45')), 'open', '');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('85fefb48c7bc4bf326cd0b6d6118c983')).push('open');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c5e4dbd42eb6ffe9c0784ed60ac18d45')).push('open');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/69b9a7435b6e5a774f967f27f307dc8b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.appData, 'statusList'))) {
    ___arguments.context.appData['profilesData'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'));
    ___arguments.context.appData['statusList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'statusList'));
    ___arguments.context.appData['ethnicityList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'ethnicityList'));
    ___arguments.context.appData['bodyTypeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'bodyTypeList'));
    ___arguments.context.appData['orientationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'orientationList'));
    ___arguments.context.appData['educationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'educationList'));
    ___arguments.context.appData['politicalList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'politicalList'));
    ___arguments.context.appData['religionList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList'));
    ___arguments.context.appData['hairColorList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'hairColorList'));
    ___arguments.context.appData['smokeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'smokeList'));
    ___arguments.context.appData['drinkList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'drinkList'));
    ___arguments.context.appData['dietaryList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList')), 1, async (item) => {


     return (getObjectProperty(item, 'id'));
    }));
  }

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isMissYouVisible')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/settings/components/64122fbc7d883aa97c6552136ee38708/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d')), 'checked')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6')), 'checked')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd')), 'checked')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = true;
    }
    if (!((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('replies'))) {
      addItemToList((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')), 'replies');
    }
  } else {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8')), 'checked')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = false;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('replies')) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings'))['notifications'] = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')), async (item) => {


       return (item != 'replies');
      }));
    }
  }
  await (async function(btnSave) {
  	btnSave.click();
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('67e4ff4ce96344dbe3615264c29963f9')), 'el')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/settings/components/e11c27b9727da01a27844883978eaac6/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708')), 'checked')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d')), 'checked')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6615eb44579196b33d7bd4a32d68b9fd')), 'checked')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = true;
    }
    if (!((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('message'))) {
      addItemToList((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')), 'message');
    }
  } else {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8')), 'checked')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = false;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('message')) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings'))['notifications'] = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')), async (item) => {


       return (item != 'message');
      }));
    }
  }
  await (async function(btnSave) {
  	btnSave.click();
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('67e4ff4ce96344dbe3615264c29963f9')), 'el')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/settings/components/6615eb44579196b33d7bd4a32d68b9fd/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value) {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6106c6b9cecd84b38b3c6c03f78e692d')), 'checked')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('64122fbc7d883aa97c6552136ee38708')), 'checked')) == true && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('e11c27b9727da01a27844883978eaac6')), 'checked')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = true;
    }
    if (!((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('invites'))) {
      addItemToList((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')), 'invites');
    }
  } else {
    if ((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8')), 'checked')) == true) {
      ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fe5fb7f1fddbb38bec096ccfc4d4c4f8'))['checked'] = false;
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')).includes('invites')) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings'))['notifications'] = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'settings')), 'notifications')), async (item) => {


       return (item != 'invites');
      }));
    }
  }
  await (async function(btnSave) {
  	btnSave.click();
  })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('67e4ff4ce96344dbe3615264c29963f9')), 'el')));

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/settings/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/settings/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/settings/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/settings/components/cfbed1de0389b8ffc0ca081210c7a3da/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/settings/components/346b1cc2fd8cd4cc9d2e547d4ed82e17/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isAsideUserProfileVisible'] = true;
  ___arguments.context.pageData['isHeaderVisible'] = true;
  ___arguments.context.pageData['isFilterHeadingVisible'] = true;
  ___arguments.context.pageData['isMainBlVisible'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/4bc71fd84b982a523de3f4f3d9255316/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, unBlockUserId, blockListJson, blockList, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6a8f403c019b4a02b177d5034d14607d')).push('delete');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('31dc1f45c43658f75e85933712a848f7', true);
  try {
    ___arguments.context.appData['currentUser'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
    await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': ([String(['(ownerId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'objectId')),'\''].join('')) + String([' and receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\')'].join('')),' or ',String(['(ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) + String([' and receiver.objectId=\'',(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'objectId')),'\')'].join(''))].join('')),'changes': ({ [`isBlocked`]: false,[`statusUpdated`]: (new Date()) }) });
    blockList = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'blockList')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'objectId')));
    }));
    blockListJson = (await asyncListFilter((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'blockListJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'objectId')));
    }));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['blockListJson'] = blockListJson;
    await Backendless.Data.of('UserProfile').bulkUpdate( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ [`blockListJson`]: blockListJson }) );
    await Backendless.Data.of('UserProfile').deleteRelation((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList', [(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'objectId'))]);
    unBlockUserId = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'objectId'));
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile'))['blockListJson'] = blockListJson;
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile'))['blockList'] = blockList;
    delete ___arguments.context.appData['chats'];
    delete ___arguments.context.appData['activityMessages'];
    delete ___arguments.context.pageData['chats'];
    delete ___arguments.context.pageData['receivedChats'];
    delete ___arguments.context.appData['receivedChats'];
    delete ___arguments.context.pageData['activityMessages'];
    delete ___arguments.context.appData['activityList'];
    delete ___arguments.context.appData['users'];
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['blockList'] = blockList;
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['blockListJson'] = blockListJson;
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
    if (!((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('6a8f403c019b4a02b177d5034d14607d')).length) {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b397af83cb7cabc4870a770a32195f22', true);
    }
    await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('unBlockUser', unBlockUserId, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), null, null);

  } catch (error) {
    (function (message) { alert(message) })('Something went wrong. Please try again.');
    console.log(error);

  } finally {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('31dc1f45c43658f75e85933712a848f7', false);
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6a8f403c019b4a02b177d5034d14607d')), 'delete', '');

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/310d73899e49d35bd7ff8c9f27c703b1/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((new Date((new Date())).getFullYear()) - (new Date((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'birthDate'))).getFullYear()))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/settings/components/d1bb0a2a9bbdc46a0e6b35a89e4c722d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'name')) + String(',&nbsp;'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/settings/components/0d210a996c1caeec4c040294393ad443/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'media')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'media')).length > 0) {
      return (getObjectProperty(((getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'media'))[0]), 'file'));
    } else {
      return 'styles/img/placeholder_photo.png';
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ [`profileId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('8096310d968937fb45d64a9a934a98c9'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/258d56f79cb468c924b5abf1e80a25f8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/8a9b9cf1ffbab1c3be07d7ebb3dec32a/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isHeaderVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/settings/components/99332bdc1eb50faffb9ad35213a3fba1/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isFilterHeadingVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/settings/components/806353a7ccc5b8638a3b0f220f2a6f62/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isMissYouVisible')) && (getObjectProperty(___arguments.context.pageData, 'isAsideUserProfileVisible')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/settings/components/b397af83cb7cabc4870a770a32195f22/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'blockList')) && !(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'blockList')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/settings/components/de01e2a7770de2b4b16b45e3319d3fe8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isHeaderVisible'] = false;
  ___arguments.context.pageData['isFilterHeadingVisible'] = false;
  ___arguments.context.pageData['isAsideUserProfileVisible'] = false;
  ___arguments.context.pageData['isMainBlVisible'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/settings/components/3a198cc8769c862ed26e1cef23c41e55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', ({ [`isFromAccountPage`]: true }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signup/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('1');
  ___arguments.context.pageData['info'] = ({ [`title`]: 'title' });
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_signup_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'Sign up'

  },  
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/signup/components/224fca35bd76fe12ccbb072cb1c5201b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el')), 'type')) == 'text') {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el'))['type'] = 'password';
    delete ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('224fca35bd76fe12ccbb072cb1c5201b'))['2'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('224fca35bd76fe12ccbb072cb1c5201b'))['2'] = 'fa-eye-slash';
  } else if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el')), 'type')) == 'password') {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el'))['type'] = 'text';
    delete ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('224fca35bd76fe12ccbb072cb1c5201b'))['2'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('224fca35bd76fe12ccbb072cb1c5201b'))['2'] = 'fa-eye';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signup/components/726a8b32406fee26b4a28a8634ade9d9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'el')), 'type')) == 'password') {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'el'))['type'] = 'text';
    delete ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('726a8b32406fee26b4a28a8634ade9d9'))['2'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('726a8b32406fee26b4a28a8634ade9d9'))['2'] = 'fa-eye';
  } else if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'el')), 'type')) == 'text') {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'el'))['type'] = 'password';
    delete ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('726a8b32406fee26b4a28a8634ade9d9'))['2'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('726a8b32406fee26b4a28a8634ade9d9'))['2'] = 'fa-eye-slash';
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signup/components/8ea7063f7cc9f73bacc117e26f3ba587/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, currentUser, userData, country, userLocation, email, isDataValid, repeatPassword, password, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

/**
 * Describe this function...
 */
async function isFormValid() {
  isDataValid = true;
  email = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'email'));
  password = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')).trim() : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password'));
  repeatPassword = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password2')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password2')).trim() : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password2'));
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'alertMessageDataUser')) {
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageDataUser'] = '';
  }
  if (!email) {
    isDataValid = false;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')).slice(-1)[0] != 'alert-border') {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = 'Please, enter email address.';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')), 'alert-border');
    }
  } else {
    regExp = (await BackendlessUI.Functions.Custom['fn_33d4b09fd437e3c36dee5ef9d12d4fa1'](___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')));
    if ((getObjectProperty(regExp, 'status')) == false) {
      isDataValid = false;
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')).slice(-1)[0] != 'alert-border') {
        ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = 'Please, enter valid email address.';
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')), 'alert-border');
      }
    }
  }
  if (!password) {
    isDataValid = false;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).slice(-1)[0] != 'alert-border') {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = 'Please, enter your password';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'alert-border');
    }
  } else {
    if (!((new RegExp('(?=.*\\d)(?=.*[a-z])[^\\s]{6,20}', 'g')).test(password))) {
      isDataValid = false;
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4b111109af61cf97987665b45302ae28')).slice(-1)[0] != 'alert-block') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4b111109af61cf97987665b45302ae28')), 'alert-block');
      }
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).slice(-1)[0] != 'alert-border') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'alert-border');
      }
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')).slice(-1)[0] != 'alert-border') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'alert-border');
      }
      await new Promise(r => setTimeout(r, 2000 || 0));
      ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4b111109af61cf97987665b45302ae28')).pop();
    }
  }
  if (!repeatPassword) {
    isDataValid = false;
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')).slice(-1)[0] != 'alert-border') {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePasswordRepeat'] = 'Please, enter your password';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'alert-border');
    }
  } else {
    if (password != repeatPassword) {
      isDataValid = false;
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).slice(-1)[0] != 'alert-border' || ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')).slice(-1)[0] != 'alert-border') {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'alert-border');
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'alert-border');
        ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePasswordRepeat'] = 'Password mismatch';
      }
    }
  }
  return isDataValid
}


  try {
    if (await isFormValid()) {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['disableSignupBtn'] = true;
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b489ddb6aa93e3ae12945d7458326c3', true);
      if (email == 'ari.hamilton@findmyplus.one') {
        ___arguments.context.appData['userLocationInfo'] = ({ [`locationGeoPoint`]: ({ [`type`]: 'Point',[`coordinates`]: [-96.845121, 32.8554833] }),[`location`]: 'Dallas, TX' });
        localStorage.setItem('userLocationInfo', JSON.stringify((getObjectProperty(___arguments.context.appData, 'userLocationInfo'))));
        localStorage.setItem('country', JSON.stringify('United States'));
      } else {
        userLocation = (await BackendlessUI.Functions.Custom['fn_47bed951feaa47e346a419d69147a6a6']());
        if (userLocation && (getObjectProperty(userLocation, 'locationGeoPoint'))) {
          ___arguments.context.appData['userLocationInfo'] = ({ [`locationGeoPoint`]: (getObjectProperty(userLocation, 'locationGeoPoint')),[`location`]: (getObjectProperty(userLocation, 'location')) });
          country = (getObjectProperty(userLocation, 'country'));
          localStorage.setItem('userLocationInfo', JSON.stringify((getObjectProperty(___arguments.context.appData, 'userLocationInfo'))));
          localStorage.setItem('country', JSON.stringify(country));
        } else {
          ___arguments.context.appData['userLocationInfo'] = ({ [`locationGeoPoint`]: null,[`location`]: null });
          country = null;
        }
      }
      await Backendless.Request.post(`${Backendless.appPath}/services/registration/userRegistration`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'email': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'email')),'password': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')) });
      currentUser = (await Backendless.UserService.login( (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'email')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')), (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('fa2883b9deeb0c37944fa1faaff75928')), 'checked'))  ));
      userData = (await Backendless.Request.post(`${Backendless.appPath}/services/createUserData/createUserData`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'location': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'userLocationInfo')), 'location')),'country': country,'locationGeoPoint': (getObjectProperty((getObjectProperty(___arguments.context.appData, 'userLocationInfo')), 'locationGeoPoint')) }));
      ___arguments.context.appData['currentUser'] = currentUser;
      (getObjectProperty(___arguments.context.appData, 'currentUser'))['searchFilter'] = (getObjectProperty(userData, 'searchFilter'));
      (getObjectProperty(___arguments.context.appData, 'currentUser'))['userProfile'] = (getObjectProperty(userData, 'userProfile'));
      localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
      try {
        if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
          await BackendlessUI.Functions.Custom['fn_5443ddc69ad10a1c48cca32797c3739b'](___arguments.context.pageData, ___arguments.context.appData, currentUser);
        }

      } catch (error) {
        console.log(error);

      }
      ;(async () => {
          await BackendlessUI.Functions.Custom['fn_36de753f55e8be4c07da77eb5cf7e8b5']((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')), ___arguments.context.appData);

      })();
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    }

  } catch (error) {
    console.log(error);
    if ((getObjectProperty(error, 'code')) == 3033) {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageDataUser'] = 'This email already exists';
    } else {
      if (currentUser && (getObjectProperty(currentUser, 'objectId'))) {
        try {
          await Backendless.Request.put(`${Backendless.appPath}/services/createUserData/rollbackUserCreation`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();

        } catch (error) {
          console.log(error);

        }
        delete ___arguments.context.appData['currentUser'];
        delete ___arguments.context.appData['isMobileDevice'];
        await BackendlessUI.Functions.Custom['fn_e97140c64a3efafdbfb71077439f3811']();
      }
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageDataUser'] = 'Something went wrong. Please try again.';
    }
    localStorage.removeItem('userLocationInfo');
    localStorage.removeItem('country');
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0b489ddb6aa93e3ae12945d7458326c3', false);
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['disableSignupBtn'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signup/components/0d3cb78845c8ae897e2cbd7862a8948e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var email, regExp;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageDataUser'] = '';
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('04af6dccd02f14d104473f0d5c3404d8', false);
  ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = '';
  email = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'email'));
  regExp = (await BackendlessUI.Functions.Custom['fn_33d4b09fd437e3c36dee5ef9d12d4fa1'](email));
  if (!email) {
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = 'Please, enter email address.';
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')), 'alert-border');
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')).pop();
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageEmail'] = '';
  }

  },
  /* handler:onChange */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var message, isExistEmail, error, currentUser, country, userLocation, isLoggedIn, passwordStatus, repeatPassword, password, regExp, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.keyCode == '13' && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ea7063f7cc9f73bacc117e26f3ba587'))) {
    await (async function(btnElement) {
    	btnElement.click();
    })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ea7063f7cc9f73bacc117e26f3ba587')), 'el')));
  }

  },
  /* handler:onKeyDown */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = '15vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dfb625ee3d989b0569d993cd0ba63615')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/signup/components/2e863203e1897ed6c6a853e89e95d1a5/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageDataUser'] = '';
  if (!___arguments.value || !___arguments.value.trim().length) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).slice(-1)[0] != 'alert-border') {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'alert-border');
    }
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = 'Please, enter your password';
  } else {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'alert-border', '');
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = '';
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')).includes('alert-border')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password2')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password2')).trim().length && ((new RegExp('(?=.*\\d)(?=.*[a-z])[^\\s]{6,20}', 'g')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password2'))))) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'alert-border', '');
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePasswordRepeat'] = '';
    }
  }

  },
  /* handler:onChange */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
    var password;


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onBlur */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var message, isExistEmail, error, currentUser, country, userLocation, isLoggedIn, passwordStatus, repeatPassword, password, regExp, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.keyCode == '13' && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ea7063f7cc9f73bacc117e26f3ba587'))) {
    await (async function(btnElement) {
    	btnElement.click();
    })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ea7063f7cc9f73bacc117e26f3ba587')), 'el')));
  }

  },
  /* handler:onKeyDown */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = '15vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dfb625ee3d989b0569d993cd0ba63615')));
  }

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/signup/components/4d3444065f37d4973089f6d2fe9e2b4b/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessageDataUser'] = '';
  if (!___arguments.value || !___arguments.value.trim().length) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')).slice(-1)[0] != 'alert-border') {
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePasswordRepeat'] = 'Please, enter your password';
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'alert-border');
    }
  } else {
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'alert-border', '');
    ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePasswordRepeat'] = '';
  }
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')).includes('alert-border')) {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')) && !!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')).trim().length && ((new RegExp('(?=.*\\d)(?=.*[a-z])[^\\s]{6,20}', 'g')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password'))))) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'alert-border', '');
      ___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063')['alertMessagePassword'] = '';
    }
  }

  },
  /* handler:onChange */
  /* handler:onKeyDown */
  async ['onKeyDown'](___arguments) {
    var message, isExistEmail, error, currentUser, country, userLocation, isLoggedIn, passwordStatus, repeatPassword, password, regExp, email;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.keyCode == '13' && ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ea7063f7cc9f73bacc117e26f3ba587'))) {
    await (async function(btnElement) {
    	btnElement.click();
    })((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('8ea7063f7cc9f73bacc117e26f3ba587')), 'el')));
  }

  },
  /* handler:onKeyDown */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = '15vh';
    await new Promise(r => setTimeout(r, 350 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('dfb625ee3d989b0569d993cd0ba63615')));
  }

  },
  /* handler:onFocus */
  /* handler:onBlur */
  ['onBlur'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1bac70e39cddb3b1e7f4a039f32f0449'))['margin-bottom'] = 'unset';
  }

  },
  /* handler:onBlur */
  /* content */
}))

define('./pages/signup/components/c5ebc3f90ddda4b8eac89f0e29bec362/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, user, token;

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  ___arguments.context.pageData['disableGoogleBtn'] = true;
  try {
    await socialLogin('googleplus', null, null, null, 'social-login', null);

  } catch (error) {
    console.log(error);

  } finally {
    ___arguments.context.pageData['disableGoogleBtn'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signup/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['© ','',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/signup/components/57da9c9530a6d5fa2d5ab984a267e43e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  ___arguments.context.pageData['disableFbBtn'] = true;
  try {
    await socialLogin('facebook', null, null, null, 'activities-search', null);

  } catch (error) {
    console.log(error);

  } finally {
    ___arguments.context.pageData['disableFbBtn'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signup/components/ab7b5f2ef37a13a3b9555ae1e128a955/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var user, token, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function socialLogin(providerCode, fieldsMappings, scope, options, redirectToPage, callbackUrlDomain) {
  if (typeof BackendlessUI !== 'undefined' && await BackendlessUI.DeviceAPI.isRunningEnv('NATIVE_SHELL')) {
    const user = await BackendlessUI.DeviceAPI.socialLogin(providerCode, fieldsMappings, scope, options, callbackUrlDomain)

    Backendless.UserService.setCurrentUser(user, true)

    if (redirectToPage) {
      BackendlessUI.Navigator.goToPage(redirectToPage)
    }
  } else {
    const redirectAfterLoginUrl = redirectToPage
      ? window.location.href.split('?')[0] + `?page=${ redirectToPage }`
      : window.location.href

    window.location = await Backendless.UserService.getAuthorizationUrlLink(providerCode, fieldsMappings, scope, false, redirectAfterLoginUrl, callbackUrlDomain)
  }}


  ___arguments.context.pageData['disableAppleBtn'] = true;
  try {
    await (async function(data) {
    	if (typeof BackendlessUI && BackendlessUI.DeviceAPI.isMobile()) {

    	  data.isMobile = true
    	}
    })(___arguments.context.pageData);
    if (getObjectProperty(___arguments.context.pageData, 'isMobile')) {
      await socialLogin('apple', null, null, ({ [`clientId`]: 'com.backendless.findmy' }), 'social-login', null);
    } else {
      token = (await (async function() {
      	const AppleID  = await BackendlessUI.requireModule('https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js');

      	AppleID.auth.init({
      	  clientId : 'com.backendless.findmy',
      	  scope : 'email',
      	  redirectURI: 'https://app.findmyplus.one/index.html?page=social-login',
      	state : "initial",
      	  usePopup : true
      	})

      	const { authorization} = await AppleID.auth.signIn()

      	return authorization.id_token
      })());
      user = (await Backendless.Request.post(`${Backendless.appPath}/services/AppleAuth/login`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify(token)));
      await (async function(user) {
      	Backendless.Users.setCurrentUser(user, true)
      })(user);
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('social-login', undefined);
    }

  } catch (error) {
    console.log(error);

  } finally {
    ___arguments.context.pageData['disableAppleBtn'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signup/components/c98697816d2e1b96e86cec2c14dbacad/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var j, error;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getDeviceSubscriptions() { return getSubscriptionsManager('deviceSubscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    try {
      if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
        getDeviceSubscriptions().remove('onTapPushAction');
        getDeviceSubscriptions().remove('handleInactiveState');
        getDeviceSubscriptions().remove('handleResumeState');
        await ( async function () { return BackendlessUI.DeviceAPI.unregisterDevice() })();
      }

    } catch (error) {
      console.log(error);

    }
    Backendless.setCurrentUserToken(null);
    localStorage.removeItem('messages');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('tooltipInfo');
    localStorage.removeItem('userLocationInfo');
    localStorage.removeItem('country');
    localStorage.removeItem('lastChatInfoUpdate');
    localStorage.removeItem('tempFilters');
    localStorage.removeItem('Backendless');
    var j_list = (Object.keys(___arguments.context.appData));
    for (var j_index in j_list) {
      j = j_list[j_index];
      delete ___arguments.context.appData[j];
    }
  } else if ((await Backendless.UserService.getCurrentUser(false)) != null && (!(await Backendless.UserService.isValidLogin()) || ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('Backendless')) && !(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('Backendless')), 'stayLoggedIn')))) {
    await BackendlessUI.Functions.Custom['fn_e97140c64a3efafdbfb71077439f3811']();
    var j_list2 = (Object.keys(___arguments.context.appData));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      delete ___arguments.context.appData[j];
    }
  } else {
    ___arguments.context.appData['currentUser'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login')) && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'birthDate')) && !((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId')))))) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    }
  }
  ;(async () => {
      await BackendlessUI.Functions.Custom['fn_8ee7c112c28a73c6a512f0080e38e44d'](___arguments.context.appData);

  })();

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/signup/components/28c237bac525d87832b7bd8d7785bf26/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
      if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', false, undefined);
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', true, undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/signup/components/82340dfb8593f7c9b86c9f99f5b49675/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('ebd800d935388f7ecd61c4d51469a25a')).slice(-1)[0] != 'active') {
    return ['fas fa-circle'];
  } else {
    return ['fas fa-check'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/signup/components/ac15a16200d548ef0aed6795a6c139b4/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('4098e8921aee88f85ad7c9abc669235e')).slice(-1)[0] != 'active') {
    return ['fas fa-circle'];
  } else {
    return ['fas fa-check'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/signup/components/7cf9968e17677b7475fa33613c694891/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('007264ae662bc4181b4e8c8ad6386355')).slice(-1)[0] != 'active') {
    return ['fas fa-circle'];
  } else {
    return ['fas fa-check'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/signup/components/ebd800d935388f7ecd61c4d51469a25a/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')).length >= 6 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')).length <= 20) {
    return ['settings__password-requirements-item', 'active'];
  } else {
    return ['settings__password-requirements-item'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/signup/components/4098e8921aee88f85ad7c9abc669235e/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')) && ((new RegExp('[0-9]', '')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password'))))) {
    return ['settings__password-requirements-item', 'active'];
  } else {
    return ['settings__password-requirements-item'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/signup/components/007264ae662bc4181b4e8c8ad6386355/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password')) && ((new RegExp('[a-z]', '')).test((getObjectProperty(___arguments.context.getComponentDataStoreByUid('6222e5053dbdf6652a052d53e8fdc063'), 'password'))))) {
    return ['settings__password-requirements-item', 'active'];
  } else {
    return ['settings__password-requirements-item'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/signup/components/dfb625ee3d989b0569d993cd0ba63615/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 2000 || 0));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')) {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0d3cb78845c8ae897e2cbd7862a8948e')), 'el'))['maxLength'] = 60;
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')) {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('2e863203e1897ed6c6a853e89e95d1a5')), 'el'))['maxLength'] = 20;
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')) {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4d3444065f37d4973089f6d2fe9e2b4b')), 'el'))['maxLength'] = 20;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/signup/components/75248e442858b6eedd54a2eacd7b3357/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
      if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    ___arguments.context.pageData['isIos'] = (await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('IS_IOS', undefined));
  } else {
    ___arguments.context.pageData['isIos'] = true;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/social-login/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onLeave */
  onLeave(___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setIntervals'); if (timerId && timers[timerId]) {    clearInterval(timers[timerId]);    delete timers[timerId]; }}


  stopSetTimeout('1');

  },  
  /* handler:onLeave */
  /* handler:onTitleAssignment */
  onTitleAssignment(___arguments) {
      return 'FindMy+1'

  },  
  /* handler:onTitleAssignment */
  /* content */
}))

define('./pages/social-login/components/1bac70e39cddb3b1e7f4a039f32f0449/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    var error, userRequestActivity, currentUser, isServiceAvailable, userData, userLocation, profilesCount, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function isUserProfileReady() {
  return (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login')) && (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'birthDate')) && !((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'objectId'))))) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile')), 'locationGeoPoint')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile')), 'media')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile')), 'media')).length
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  try {
    currentUser = (await Backendless.UserService.getCurrentUser(false));
    if (getObjectProperty(currentUser, 'login')) {
      userData = (await Backendless.Request.get(`${Backendless.appPath}/services/getCurrentUserData/getCurrentUserData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      ___arguments.context.appData['name'] = (getObjectProperty(currentUser, 'name'));
      ___arguments.context.appData['login'] = (getObjectProperty(currentUser, 'login'));
      ___arguments.context.appData['photo'] = (getObjectProperty(currentUser, 'photoThumbnail'));
    } else {
      profilesCount = (await Backendless.Data.of('UserProfile').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['ownerId=\'',(getObjectProperty(currentUser, 'objectId')),'\''].join('')))));
      if (profilesCount > 0) {
        userData = (await Backendless.Request.get(`${Backendless.appPath}/services/getCurrentUserData/getCurrentUserData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      } else {
        userLocation = (await BackendlessUI.Functions.Custom['fn_47bed951feaa47e346a419d69147a6a6']());
        if (userLocation && (getObjectProperty(userLocation, 'locationGeoPoint'))) {
          userData = (await Backendless.Request.post(`${Backendless.appPath}/services/createUserData/createUserData`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'location': (getObjectProperty(userLocation, 'location')),'country': (getObjectProperty(userLocation, 'country')),'locationGeoPoint': (getObjectProperty(userLocation, 'locationGeoPoint')) }));
        } else {
          userData = (await Backendless.Request.post(`${Backendless.appPath}/services/createUserData/createUserData`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'location': null,'country': null,'locationGeoPoint': null }));
        }
      }
    }
    if (getObjectProperty((getObjectProperty(userData, 'userProfile')), 'locationGeoPoint')) {
      ___arguments.context.appData['userLocationInfo'] = ({ [`locationGeoPoint`]: (getObjectProperty((getObjectProperty(userData, 'userProfile')), 'locationGeoPoint')),[`location`]: (getObjectProperty((getObjectProperty(userData, 'userProfile')), 'location')) });
      localStorage.setItem('userLocationInfo', JSON.stringify((getObjectProperty(___arguments.context.appData, 'userLocationInfo'))));
      if (getObjectProperty((getObjectProperty(userData, 'userProfile')), 'country')) {
        localStorage.setItem('country', JSON.stringify((getObjectProperty((getObjectProperty(userData, 'userProfile')), 'country'))));
      } else {
        await BackendlessUI.Functions.Custom['fn_24498a1473c83209b6d1428325c66861']((getObjectProperty((getObjectProperty(userData, 'userProfile')), 'locationGeoPoint')), (getObjectProperty((getObjectProperty(userData, 'userProfile')), 'objectId')));
        (getObjectProperty(userData, 'userProfile'))['country'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('country'));
      }
    }
    currentUser['userProfile'] = (getObjectProperty(userData, 'userProfile'));
    currentUser['searchFilter'] = (getObjectProperty(userData, 'searchFilter'));
    await BackendlessUI.Functions.Custom['fn_8ee7c112c28a73c6a512f0080e38e44d'](___arguments.context.appData);
    currentUser = (await BackendlessUI.Functions.Custom['fn_51cfe3ce5dd5feda72d561df87a153ea'](currentUser));
    if ((getObjectProperty(currentUser, 'email')) == 'ari.hamilton@findmyplus.one') {
      ___arguments.context.appData['userLocationInfo'] = ({ [`locationGeoPoint`]: ({ [`type`]: 'Point',[`coordinates`]: [-96.845121, 32.8554833] }),[`location`]: 'Dallas, TX' });
      (getObjectProperty(currentUser, 'userProfile'))['locationGeoPoint'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'userLocationInfo')), 'locationGeoPoint'));
      (getObjectProperty(currentUser, 'userProfile'))['location'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'userLocationInfo')), 'location'));
      (getObjectProperty(currentUser, 'userProfile'))['country'] = 'United States';
      localStorage.setItem('userLocationInfo', JSON.stringify((getObjectProperty(___arguments.context.appData, 'userLocationInfo'))));
      localStorage.setItem('country', JSON.stringify('United States'));
    }
    ___arguments.context.appData['currentUser'] = currentUser;
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
    ;(async () => {
        await BackendlessUI.Functions.Custom['fn_36de753f55e8be4c07da77eb5cf7e8b5']((getObjectProperty(currentUser, 'objectId')), ___arguments.context.appData);

    })();
    try {
      if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
        await BackendlessUI.Functions.Custom['fn_5443ddc69ad10a1c48cca32797c3739b'](___arguments.context.pageData, ___arguments.context.appData, currentUser);
      }

    } catch (error) {
      console.log(error);

    }
    if (await isUserProfileReady()) {
      if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('userRequestActivity')) {
        userRequestActivity = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('userRequestActivity'));
        localStorage.removeItem('userRequestActivity');
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: userRequestActivity }));
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
      }
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    }

  } catch (error) {
    console.log(error);
    await Backendless.UserService.logout();
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);

  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/testPage/components/2ea2924d6585bd8541525258afbc320d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var testObject;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/testPage/components/57d1db7dbde65bf97c382af2d2ad4565/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
      return (await BackendlessUI.Functions.Custom['fn_24392cc9c418884d6e77cf1f6c7ebbce']('/pictures/FEF645594A994272B50E8530E92AC468/1729797456652.png'))

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/07f5173df8143396cf131e9a25357f8d/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activitiesListCurrent')) {
    return (getObjectProperty(___arguments.context.pageData, 'activitiesListCurrent'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onScroll */
  async ['onScroll'](___arguments) {
    var item, newActivities;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.scrollBottom == 0 && !(getObjectProperty(___arguments.context.pageData, 'noMoreActivities'))) {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06a2e6e96b56e4f5de8c616a5a5f20d6')).slice(-1)[0] != 'open') {
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b16237a7bd6b741255c67bfebc722a84', true);
      ___arguments.context.pageData['countOffset'] = ((getObjectProperty(___arguments.context.pageData, 'countOffset')) + 1);
      newActivities = (await Backendless.Request.get(`${Backendless.appPath}/services/myActivities/getMyActivities`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'pageSize': (getObjectProperty(___arguments.context.pageData, 'pageSize')),'pageOffset': ((getObjectProperty(___arguments.context.pageData, 'countOffset')) * (getObjectProperty(___arguments.context.pageData, 'pageSize'))) }).send());
      if (!!newActivities.length) {
        addItemToList((getObjectProperty(___arguments.context.pageData, 'activityList')), newActivities);
      } else {
        ___arguments.context.pageData['noMoreActivities'] = true;
      }
      ___arguments.context.pageData['activitiesListCurrent'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


       return ((getObjectProperty(item, 'activityStatus')) == true && ((getObjectProperty(item, 'activityDate')) > (new Date()) || (getObjectProperty(item, 'activityDate')) == null));
      }));
      ___arguments.context.pageData['activitiesPaused'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


       return ((getObjectProperty(item, 'activityStatus')) == false);
      }));
      ___arguments.context.pageData['activitiesPast'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


       return ((getObjectProperty(item, 'activityStatus')) == true && (getObjectProperty(item, 'activityDate')) < (new Date()) && (getObjectProperty(item, 'activityDate')) != null);
      }));
      (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b16237a7bd6b741255c67bfebc722a84', false);
      await (async function() {
      	swiper = new Swiper('.swiper', {

      	  pagination: {
      	    el: '.swiper-pagination',
      	    clickable: true
      	  }

      	});
      })();
    }
  }

  },
  /* handler:onScroll */
  /* content */
}))

define('./pages/user-activities/components/92ac8dee840cbc9e68d70d84a00e3d42/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'media')) {
    var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'media'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (getObjectProperty(j, 'isCover')) {
        return (getObjectProperty(j, 'file'));
      }
    }
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/275fc2ece0ba8c53544f4858417bb326/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')));
  }

  },
  /* handler:onContentAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/7914dcf8655b523e145d18cce3053eed/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (await (async function(year, month, day) {
	let now = new Date();
	let today = new Date(now.getFullYear(), now.getMonth(), now.getDate());

	let dob = new Date(year, month, day);

	let dobnow = new Date(today.getFullYear(), dob.getMonth(), dob.getDate());

	let age;

	age = today.getFullYear() - dob.getFullYear();

	if (today < dobnow) {
	  age = age-1;
	} else {
	  age = age
	}

	return age

})((new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'birthDate'))).getFullYear()), (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'birthDate'))).getMonth()), (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'birthDate'))).getDate())))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/bfabf0f3cd6dbdd7e6e52607aa4df944/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'activityDate')) {
    return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'activityDate'))));
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'ongoingTiming')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'ongoingTiming'));
  }

  return 'To be scheduled'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/cd8bf77173e9a0b1fc9e23d99fdfa767/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/c4d360f9584d8828b116ff1ee133ba53/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
    ___arguments.context.appData['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'photo'));
    ___arguments.context.appData['profileStatus'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'profileStatus'));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')).length) {
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    }))[0]), 'file'));
  } else {
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
  }
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == false) {
    ___arguments.context.appData['profileStatus'] = false;
  }
  ___arguments.context.pageData['userNameMedia'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).replace((new RegExp('[^\\w\\s]', 'g')), ''));
  ;(async () => {
      ___arguments.context.pageData['pageSize'] = 20;
    ___arguments.context.pageData['activityList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/myActivities/getMyActivitiesData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'pageSize': (getObjectProperty(___arguments.context.pageData, 'pageSize')) }).send());
    ___arguments.context.pageData['activitiesListCurrent'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


     return ((getObjectProperty(item, 'activityStatus')) == true && ((getObjectProperty(item, 'activityDate')) > (new Date()) || (getObjectProperty(item, 'activityDate')) == null));
    }));
    ___arguments.context.pageData['activitiesPaused'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


     return ((getObjectProperty(item, 'activityStatus')) == false);
    }));
    ___arguments.context.pageData['activitiesPast'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


     return ((getObjectProperty(item, 'activityStatus')) == true && (getObjectProperty(item, 'activityDate')) < (new Date()) && (getObjectProperty(item, 'activityDate')) != null);
    }));
    if (getObjectProperty(___arguments.context.appData, 'scrollPositionMyActivities')) {
      await (async function(scrollPosition) {
      	const page = document.getElementById('page');
      	if (page){
      	  page.scrollTop = scrollPosition;
      	}

      })((getObjectProperty(___arguments.context.appData, 'scrollPositionMyActivities')));
    }

  })();
  ___arguments.context.pageData['pageLoaded'] = true;
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);
  await (async function() {
  	swiper = new Swiper('.swiper', {

  	  pagination: {
  	    el: '.swiper-pagination',
  	    clickable: true
  	  }

  	});
  })();

  },
  /* handler:onBeforeMount */
  /* handler:onBeforeUnmount */
  async ['onBeforeUnmount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
  ___arguments.context.appData['previousPage'] = 'user-activities';
  await (async function() {
  	if (swiper) {

  	  if (Array.isArray(swiper)) {
  	    for (const swiperItem of swiper) {
  	      swiperItem.destroy(true, true);
  	    }
  	  } else {
  	    swiper.destroy(true, true)
  	  }

  	}
  })();

  },
  /* handler:onBeforeUnmount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isMainBlVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-activities/components/5553f044cf82b609f88b4603aaaed488/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var item;

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    var item;



  return ['user-activities__favorite-icon']

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/user-activities/components/dfa10baffe6da20dc6a7851c3eeae838/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  async onClassListAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return ['user-activities__icon', 'user-activities__profile-icon'];
  } else {
    return ['header-light__userphoto'];
  }

  },  
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/user-activities/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['','© ',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'messagesNumber')) > 0) {
    return (['(',(getObjectProperty(___arguments.context.appData, 'messagesNumber')),') My activities'].join(''));
  }

  return 'My activities'

  },
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;


  ___arguments.context.pageData['countOffset'] = 0;
  ___arguments.context.pageData['isMainVisible'] = true;
  ___arguments.context.pageData['isMainBlVisible'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    ___arguments.context.pageData['isHeaderVisible'] = true;
    ___arguments.context.pageData['isFilterHeadingVisible'] = true;
    ___arguments.context.pageData['isAsideUserProfileVisible'] = true;
  } else {
    ___arguments.context.pageData['isHeaderVisible'] = false;
    ___arguments.context.pageData['isFilterHeadingVisible'] = false;
    ___arguments.context.pageData['isAsideUserProfileVisible'] = false;
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_userActivities_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* handler:onScroll */
  async ['onScroll'](___arguments) {
    var item, newActivities;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.pageData, 'isMainBlVisible')) {
    stopSetTimeout('saveScrollPositionTimer');

    ;(function() {
      const callback = async () => {
          ___arguments.context.appData['scrollPositionMyActivities'] = (Math.round(___arguments.scrollTop));

      };

      const timerId = 'saveScrollPositionTimer';
      const timerDelay = 300;

      runSetTimeout(timerId, callback, timerDelay)
    })()
    ___arguments.context.pageData['scroll'] = true;
    await new Promise(r => setTimeout(r, 1000 || 0));
    if (___arguments.scrollBottom <= 1 && (getObjectProperty(___arguments.context.pageData, 'scroll')) && !(getObjectProperty(___arguments.context.pageData, 'noMoreActivities'))) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06a2e6e96b56e4f5de8c616a5a5f20d6')).slice(-1)[0] != 'open') {
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b16237a7bd6b741255c67bfebc722a84', true);
        ___arguments.context.pageData['countOffset'] = ((getObjectProperty(___arguments.context.pageData, 'countOffset')) + 1);
        newActivities = (await Backendless.Request.get(`${Backendless.appPath}/services/myActivities/getMyActivitiesData`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'pageSize': (getObjectProperty(___arguments.context.pageData, 'pageSize')),'pageOffset': ((getObjectProperty(___arguments.context.pageData, 'countOffset')) * (getObjectProperty(___arguments.context.pageData, 'pageSize'))) }).send());
        if (!!newActivities.length) {
          addItemToList((getObjectProperty(___arguments.context.pageData, 'activityList')), newActivities);
        } else {
          ___arguments.context.pageData['noMoreActivities'] = true;
        }
        ___arguments.context.pageData['activitiesListCurrent'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


         return ((getObjectProperty(item, 'activityStatus')) == true && ((getObjectProperty(item, 'activityDate')) > (new Date()) || (getObjectProperty(item, 'activityDate')) == null));
        }));
        ___arguments.context.pageData['activitiesPaused'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


         return ((getObjectProperty(item, 'activityStatus')) == false);
        }));
        ___arguments.context.pageData['activitiesPast'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


         return ((getObjectProperty(item, 'activityStatus')) == true && (getObjectProperty(item, 'activityDate')) < (new Date()) && (getObjectProperty(item, 'activityDate')) != null);
        }));
        delete ___arguments.context.pageData['scroll'];
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('b16237a7bd6b741255c67bfebc722a84', false);
      }
    }
  }

  },
  /* handler:onScroll */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    var error, item, j, userProfile;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ___arguments.context.appData['previousPage'] = 'user-profile';
  }

  },
  /* handler:onLeave */
  /* content */
}))

define('./pages/user-activities/components/0287a518a15a6181b07a2c3d0ddebeef/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683')['activityStatus'] = false;
  await Backendless.Data.of('Activity').save( ___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683') );
  ___arguments.context.pageData['activitiesListCurrent'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


   return ((getObjectProperty(item, 'activityStatus')) == true && ((getObjectProperty(item, 'activityDate')) > (new Date()) || (getObjectProperty(item, 'activityDate')) == null));
  }));
  ___arguments.context.pageData['activitiesPaused'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


   return ((getObjectProperty(item, 'activityStatus')) == false);
  }));
  ___arguments.context.pageData['activitiesPast'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


   return ((getObjectProperty(item, 'activityStatus')) == true && (getObjectProperty(item, 'activityDate')) < (new Date()) && (getObjectProperty(item, 'activityDate')) != null);
  }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/46f349673c1b89795e22411e83e8fa9f/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activitiesPaused')) {
    return (getObjectProperty(___arguments.context.pageData, 'activitiesPaused'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-activities/components/d979ddba2a5312e9a7f5f01121a335ef/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'media')) {
    var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'media'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (getObjectProperty(j, 'isCover')) {
        return (getObjectProperty(j, 'file'));
      }
    }
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/41248543a5b323093ab2d91ee27c0dfc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/b0fa86576ade3cc66b5d1922bcced619/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'categoryName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/cd955865d238a51c7e83037531860707/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  ___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219')['activityStatus'] = true;
  await Backendless.Data.of('Activity').save( ___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219') );
  ___arguments.context.pageData['activitiesListCurrent'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


   return ((getObjectProperty(item, 'activityStatus')) == true && ((getObjectProperty(item, 'activityDate')) > (new Date()) || (getObjectProperty(item, 'activityDate')) == null));
  }));
  ___arguments.context.pageData['activitiesPaused'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


   return ((getObjectProperty(item, 'activityStatus')) == false);
  }));
  ___arguments.context.pageData['activitiesPast'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


   return ((getObjectProperty(item, 'activityStatus')) == true && (getObjectProperty(item, 'activityDate')) < (new Date()) && (getObjectProperty(item, 'activityDate')) != null);
  }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/14593f216caeb10fd8a886de268cab5a/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activitiesPast')) {
    return (getObjectProperty(___arguments.context.pageData, 'activitiesPast'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-activities/components/b6cdb839a2140b01d46671dca697a08b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b6cdb839a2140b01d46671dca697a08b')).slice(-1)[0] == 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07f5173df8143396cf131e9a25357f8d', false);
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b6cdb839a2140b01d46671dca697a08b')).pop();
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('07f5173df8143396cf131e9a25357f8d', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b6cdb839a2140b01d46671dca697a08b')), 'open');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/77bc69dd7d484919e471124fd6babc54/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('77bc69dd7d484919e471124fd6babc54')).slice(-1)[0] == 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46f349673c1b89795e22411e83e8fa9f', false);
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('77bc69dd7d484919e471124fd6babc54')).pop();
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('46f349673c1b89795e22411e83e8fa9f', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('77bc69dd7d484919e471124fd6babc54')), 'open');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/9deaf5fa5493ffaa368c29bd4a763ecb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9deaf5fa5493ffaa368c29bd4a763ecb')).slice(-1)[0] == 'open') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14593f216caeb10fd8a886de268cab5a', false);
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9deaf5fa5493ffaa368c29bd4a763ecb')).pop();
  } else {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('14593f216caeb10fd8a886de268cab5a', true);
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9deaf5fa5493ffaa368c29bd4a763ecb')), 'open');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/37b24f5ea3661f7d0e15d66803e86eaf/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'media')) {
    var j_list = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'media'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (getObjectProperty(j, 'isCover')) {
        return (getObjectProperty(j, 'file'));
      }
    }
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/c86901799eaedfec8e75301aa48cd29e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/6d4cfe2f0e27e48e242c2be49e5e40a5/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return ['user-activities__icon', 'user-activities__profile-icon'];
  } else {
    return ['header-light__userphoto'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/user-activities/components/815cb2814cff0e3d6bc447d1bc37543d/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return ['user-activities__icon', 'user-activities__profile-icon'];
  } else {
    return ['header-light__userphoto'];
  }

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/user-activities/components/07b5e981823ce2f7c7d27dc35bc44257/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/fbf2fe0bd191c763ee83946a915ec2cc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/b14acb79a283b5eda25a8b1e7c3a1ee7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.pageData['currentUser'])['birthDate']) {
    return ((new Date((new Date())).getFullYear()) - (new Date(((___arguments.context.pageData['currentUser'])['birthDate'])).getFullYear()));
  }

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/d08ff23b19153fb8543d3403ec939671/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'birthDate')) {
    return ((new Date((new Date())).getFullYear()) - (new Date((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'birthDate'))).getFullYear()));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/ab8c832986510f35ac8c615ff2840f81/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'activityDate')) {
    return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'activityDate'))));
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'ongoingTiming')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'ongoingTiming'));
  }

  return 'To be scheduled'

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/de9eee721ebca918ed4aed7a7b1ecf47/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'activityDate')) {
    return (await BackendlessUI.Functions.Custom['fn_77f5988a8ef8a2995bf9591883927c65']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'activityDate'))));
  } else {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'ongoingTiming'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/02092138e8ec50b7d9f18a045d8c02d1/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('70c5f87cf441851fad16aa857a8308df'), 'categoryIcon')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('70c5f87cf441851fad16aa857a8308df'), 'categoryIcon'));
  } else {
    return '/ui-builder/containers/app/styles/img/icons/dinner.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/f01787120e8f73fc5fe85c7a2f0f1ec3/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'categoryIcon')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'categoryIcon'));
  } else {
    return '/ui-builder/containers/app/styles/img/icons/dinner.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/d37b6ab5e78120e4dcf86ec43412fcb7/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'categoryIcon')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'categoryIcon'));
  } else {
    return '/ui-builder/containers/app/styles/img/icons/dinner.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/ac29598d9a87fbdd367e6b9d4c58fcb8/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'categoryName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/3c7cea79394d0b15c2dd4dd22391eb8e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('edit-activity', ({ 'activityId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/51116dbf1e9eb325af4a36e9e6199ba5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'disableConfirmActivityBtn')) {
    return ;
  }
  delete ___arguments.context.pageData['selectedActivity'];
  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06a2e6e96b56e4f5de8c616a5a5f20d6')).slice(-1)[0] == 'open') {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06a2e6e96b56e4f5de8c616a5a5f20d6')).pop();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/2a92555bbaa68076d2333916b595a91b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['selectedActivity'] = ___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06a2e6e96b56e4f5de8c616a5a5f20d6')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/b903fa71b28190b9a1496a55a05931f2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['selectedActivity'] = ___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06a2e6e96b56e4f5de8c616a5a5f20d6')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/341b66571e9fe5ddbd8a74073b1d0b11/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['selectedActivity'] = ___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06a2e6e96b56e4f5de8c616a5a5f20d6')), 'open');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/821b27c1506c03aa256f987c11c359e8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['selectedActivity'];
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06a2e6e96b56e4f5de8c616a5a5f20d6')).pop();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/e22c8bef4eb481de1d7f97668c1dfb21/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, mediaItem, item, usersForUpdateChat, j, chats;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function updateChatsOnMessagePage() {
  if (getObjectProperty(___arguments.context.appData, 'chats')) {
    chats = (getObjectProperty(___arguments.context.appData, 'chats'));
  } else {
    chats = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  }
  chats = (await asyncListFilter(chats, async (item) => {


   return ((getObjectProperty(item, 'activityId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedActivity')), 'objectId')));
  }));
  usersForUpdateChat = [];
  if (!!chats.length) {
    for (var j_index in chats) {
      j = chats[j_index];
      if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId'))))) {
          usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')));
        }
      }
      if ((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
        if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId'))))) {
          usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')));
        }
      }
      await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('removeActivityChats', usersForUpdateChat, null, null, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedActivity')), 'objectId')));
    }
  }
}


  try {
    ___arguments.context.pageData['disableConfirmActivityBtn'] = true;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37bfd0daa8525ff32565f47752ee46f8', true);
    ___arguments.context.pageData['activityList'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


     return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedActivity')), 'objectId')) != (getObjectProperty(item, 'objectId')));
    }));
    ___arguments.context.pageData['activitiesListCurrent'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


     return ((getObjectProperty(item, 'activityStatus')) == true && ((getObjectProperty(item, 'activityDate')) > (new Date()) || (getObjectProperty(item, 'activityDate')) == null));
    }));
    ___arguments.context.pageData['activitiesPaused'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


     return ((getObjectProperty(item, 'activityStatus')) == false);
    }));
    ___arguments.context.pageData['activitiesPast'] = (await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'activityList')), async (item) => {


     return ((getObjectProperty(item, 'activityStatus')) == true && (getObjectProperty(item, 'activityDate')) < (new Date()) && (getObjectProperty(item, 'activityDate')) != null);
    }));
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedActivity')), 'preferences')) {
      await Backendless.Data.of('ActivityPreferences').remove( (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedActivity')), 'preferences')), 'objectId')) );
    }
    await updateChatsOnMessagePage();
    await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['activityId = \'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedActivity')), 'objectId')),'\''].join('')),'tableName': 'Chat' });
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedActivity')), 'chat')) {
      await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['chatId in (\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedActivity')), 'chat')).join('\',\''),'\')'].join('')),'tableName': 'Message' });
    }
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('06a2e6e96b56e4f5de8c616a5a5f20d6')).pop();
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedActivity')), 'media')) {
      var mediaItem_list = (await Promise.all((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'selectedActivity')), 'media')).map(async item => {; return (getObjectProperty(item, 'file'));})));
      for (var mediaItem_index in mediaItem_list) {
        mediaItem = mediaItem_list[mediaItem_index];
        try {
          ;(async () => {
              await Backendless.Files.remove(encodePath(mediaItem));

          })();

        } catch (error) {
          console.log(error);

        }
      }
    }
    await Backendless.Data.of('Activity').remove( (getObjectProperty(___arguments.context.pageData, 'selectedActivity')) );
    delete ___arguments.context.pageData['selectedActivity'];

  } catch (error) {
    console.log(error);

  } finally {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('37bfd0daa8525ff32565f47752ee46f8', false);
    ___arguments.context.pageData['disableConfirmActivityBtn'] = false;

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/d7caa253929b9c12f77135fb96fa5171/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('edit-activity', ({ 'activityId': (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/7f3624edfa24a7d55795589125df53a6/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('edit-activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'objectId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/7ce37ac87d1657967ff8f052026fa5f7/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'activitiesListCurrent')) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-activities/components/446c97f58b8390a3d145ca59957e9018/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole')) == 'driver' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole')) == 'passenger')) {
    return 'Covers the expenses';
  }

  return 'Share the expenses: '

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/6361cab92397ffeb9b6c8243f25aa531/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole')) == 'driver' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole')) == 'passenger')) {
    return 'Covers the expenses';
  }

  return 'Share the expenses: '

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/1f2f272371fef1b26ebf52acebc7cbfb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole')) && ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole')) == 'driver' || (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole')) == 'passenger')) {
    return 'Covers the expenses';
  }

  return 'Share the expenses: '

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/2dc944d8d87d50ac0aeca60647fec3fa/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole')) != 'driver' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole')) != 'passenger') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/d2c894b9e10dcb1b12ffc5d436d1de6b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole')) != 'driver' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole')) != 'passenger') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/fd2dea2a9766b2b850694f931aa5d224/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole')) && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole')) != 'driver' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole')) != 'passenger') {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/4b586641640cdd7d93543bd11f454de6/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole')) == 'driver') {
    return 'styles/img/icons/pic_profile.svg';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole')) == 'passenger' && (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
    } else {
      return 'styles/img/icons/pic_profile.svg';
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'))) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
    } else {
      return 'styles/img/icons/pic_profile.svg';
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/e74549591394c331d62f8f07b5bd2595/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole')) != 'driver' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'financialRole')) != 'passenger') {
    return 'styles/img/icons/pic_profile.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/a542937aae62635ff74442543e339d6e/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole')) == 'driver') {
    return 'styles/img/icons/pic_profile.svg';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole')) == 'passenger' && (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
    } else {
      return 'styles/img/icons/pic_profile.svg';
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'))) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
    } else {
      return 'styles/img/icons/pic_profile.svg';
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/e86d817fecbfb5e30c87d28f1f8ee184/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole')) == 'driver') {
    return 'styles/img/icons/pic_profile.svg';
  } else if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole')) == 'passenger' && (getObjectProperty(___arguments.context.pageData, 'currentUser'))) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
    } else {
      return 'styles/img/icons/pic_profile.svg';
    }
  } else {
    if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'))) {
      return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
    } else {
      return 'styles/img/icons/pic_profile.svg';
    }
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/30b6d63cda33344660f4e43db376bfd3/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole')) != 'driver' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'financialRole')) != 'passenger') {
    return 'styles/img/icons/pic_profile.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/d8bdcd88eb91d6240c2d17e4773b0519/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole')) != 'driver' && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'financialRole')) != 'passenger') {
    return 'styles/img/icons/pic_profile.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/user-activities/components/5eb52dd44126d7fb060e6c6a658d8d76/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'activityTitle')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'activityTitle')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('44052603e929851ad9234dfd84e81683'), 'description')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/b108767fa8d6ccb62416491c057262ad/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'activityTitle')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'activityTitle')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('4be27b999883681561a5b98b225b5219'), 'description')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/36454bb86fe987e6b5223cc364cd9cfc/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'activityTitle')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'activityTitle')) : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('69015f15d5b80e1cd22fa84ee62ddfb8'), 'description')))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/c74df778b571c96cb98d8c55afe97a38/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-activities/components/b6c2bb4d94fda823c8cf82cebc8e7fde/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('70c5f87cf441851fad16aa857a8308df'), 'categoryName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/d70fca84fb9b7f19e53507291739bf8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('70c5f87cf441851fad16aa857a8308df'), 'objectId')) }));

  },
  /* handler:onClick */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('70c5f87cf441851fad16aa857a8308df'), 'media'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-activities/components/62031d1e9c9f6a0d16f82ae6debe669c/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var item, list, photoUrl;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')) {
    photoUrl = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


     return (getObjectProperty(item, 'isCover'));
    }))[0];
    if (photoUrl) {
      return (getObjectProperty(photoUrl, 'file'));
    }
  }
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/67ab12a48143176ab50701e93ed2b777/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab2c135f83950b181cb2c2de682b0633'), 'categoryName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/67b1343e9e476c654015f73beef8c3aa/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab2c135f83950b181cb2c2de682b0633'), 'categoryIcon')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab2c135f83950b181cb2c2de682b0633'), 'categoryIcon'));
  } else {
    return '/ui-builder/containers/app/styles/img/icons/dinner.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/073b9f724c3c4aa33c48d8c19a6aa71b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab2c135f83950b181cb2c2de682b0633'), 'objectId')) }));

  },
  /* handler:onClick */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('ab2c135f83950b181cb2c2de682b0633'), 'media'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-activities/components/0dc2608681012231b99918ca5a74a7ab/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/31288271d60dde0fcc54beae5b23fc1d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'outOfService')) {
    return false;
  }
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if (getObjectProperty(___arguments.context.pageData, 'isAsideUserProfileVisible')) {
      return true;
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-activities/components/b264dfb1e1f66886f30e315a10ff70a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isAsideUserProfileVisible'] = true;
  ___arguments.context.pageData['isFilterHeadingVisible'] = true;
  ___arguments.context.pageData['isMainBlVisible'] = false;
  ___arguments.context.pageData['isHeaderVisible'] = true;

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-activities/components/b9bab0df575b963b3019459c264d59ee/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalPauseAccOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-activities/components/5e37bd8ab8f34136ecc47b0fcce3fabe/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalShareOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-activities/components/5f1b6ee37bdca1a3fe6c72c1a2eaba02/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalDeleteAccOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-activities/components/847f4382064c32f807457ee6475e44c7/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('175febfe5da14514d0924ad78b59726d'), 'categoryIcon')) {
    return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('175febfe5da14514d0924ad78b59726d'), 'categoryIcon'));
  } else {
    return '/ui-builder/containers/app/styles/img/icons/dinner.svg';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/af0e5d1df6e76f5549b6b456699c08ee/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('175febfe5da14514d0924ad78b59726d'), 'categoryName'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-activities/components/905c77ccc26b3621b29c2fe9c9138528/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
  } else {
    return 'styles/img/placeholder_photo.png';
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./pages/user-activities/components/bc9b9d16f60911d87b0fd1a40caedc46/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activity', ({ [`activityId`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('175febfe5da14514d0924ad78b59726d'), 'objectId')) }));

  },
  /* handler:onClick */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('175febfe5da14514d0924ad78b59726d'), 'media'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-activities/components/51b1b67aa8d14c85921e704cb2ba431f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isMissYouVisible')) && (getObjectProperty(___arguments.context.pageData, 'isAsideUserProfileVisible')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-activities/components/fdcee92ffab4f922602fecdbb76af5d2/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'profileStatus')) {
    if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
      return false;
    } else {
      return true;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == false) {
      return false;
    } else {
      return true;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-activities/components/1dfaf4b14d021c68cdea9aaeed244131/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', ({ [`isFromAccountPage`]: true }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-activities/components/bed76bd1e19cdfcfd52721b8cbb71ae9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isFilterHeadingVisible'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-media/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/4656e7b669fd310c5462125d02b29333/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var list;


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).pop();
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/27292276b8a4ecdff87d30d618b5bf59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/69b9a7435b6e5a774f967f27f307dc8b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var item, error, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!(getObjectProperty(___arguments.context.appData, 'userRoles'))) {
    ___arguments.context.appData['userRoles'] = (await Backendless.UserService.getUserRoles());
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  if (currentUser == null) {
  } else if (!(getObjectProperty(___arguments.context.appData, 'login'))) {
    ___arguments.context.appData['login'] = (getObjectProperty(currentUser, 'login'));
    if (getObjectProperty(currentUser, 'photo')) {
      ___arguments.context.appData['photo'] = (getObjectProperty(currentUser, 'photoThumbnail'));
    }
  }
  if (!(getObjectProperty(___arguments.context.appData, 'name'))) {
    ___arguments.context.appData['name'] = (getObjectProperty(currentUser, 'name'));
  }
  ___arguments.context.pageData['users'] = (await Backendless.Request.get(`${Backendless.appPath}/services/getCurrentUser/getUser`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'objectId': JSON.stringify((getObjectProperty(___arguments.context.pageData, 'profileId'))),'properties': JSON.stringify((['name', 'login', 'photoThumbnail', 'objectId', 'gender'].join(','))),'page': JSON.stringify('userMedia') }).send());
  try {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')) && !!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')).length) {
      (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


       return ((getObjectProperty(item, 'isCover')) == true);
      }))[0]), 'file'));
    }

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['profile'] = ((await asyncListFilter((getObjectProperty(___arguments.context.pageData, 'users')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.pageData, 'profileId')));
  }))[0]);
  ___arguments.context.pageData['hasPermissionCurrentUser'] = (!!(await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'hasPermission')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')));
  })).length);
  ___arguments.context.pageData['isSentRequest'] = ((await Backendless.Data.of('Chat').getObjectCount(Backendless.DataQueryBuilder.create().setWhereClause((['(sender.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\' and ','receiver.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'profileId')),'\' ) and type=\'requestPermission\''].join(''))))) > 0 ? true : false);
  if (getObjectProperty(___arguments.context.pageData, 'hasPermissionCurrentUser')) {
    ___arguments.context.pageData['imageList'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media'));
  } else {
    ___arguments.context.pageData['imageList'] = (await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media')), async (item) => {


     return (!(getObjectProperty(item, 'isPrivate')));
    }));
  }
  ___arguments.context.pageData['chatList'] = (getObjectProperty(___arguments.context.appData, 'chatList'));
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/user-media/components/e937903899af201ec38d2a2adc096398/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('user-profile', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/d7fe2313a28319cac025d3c956dcf78b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login')));
  }

  },
  /* handler:onContentAssignment */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-media/components/5271f505f2f435b3c51fd2f22f33fd99/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.pageData, 'profileId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/bd58a6cac48b54c1db1a89724acc2788/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')) {
      return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'userProfile')), 'media'));
    }
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-media/components/c2a4676115810df623bedfa895c99c69/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'hasPermissionCurrentUser')) {
    return ['profile-gallery__photo image', 'gallery__photo'];
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('23a98d0b424e1c843b2d398b1814364e'), 'isPrivate')) {
    return ['profile-gallery__photo image', 'gallery__photo', 'private'];
  }

  return ['profile-gallery__photo image', 'gallery__photo']

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;


  ___arguments.context.pageData['imageList'] = (await Promise.all((___arguments.context.pageData['imageList']).map(async item => {  if ((item['file']) == (___arguments.context.getComponentDataStoreByUid('23a98d0b424e1c843b2d398b1814364e')['file'])) {
      item['current'] = true;
    } else {
      item['current'] = false;
    }
  ; return item;})));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8968a8769b41fc3e6ad822d8ff0d0c75', true);

  },  
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('23a98d0b424e1c843b2d398b1814364e')['type']) == 'image')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-media/components/baecc013db89a295072fa3537a3ae97b/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (___arguments.context.dataModel['current']) {
    return ['gallery__slider-image', 'image', 'visible'];
  }

  return ['gallery__slider-image', 'image']

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['type']) == 'image')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-media/components/1cbf6c166b68abae4248a1bf6cda9777/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var itemList, nextItem, currentItemIndex, j;


  itemList = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('998fdfebf2b3a7afe31c706a04e836f1'));
  currentItemIndex = 0;
  for (var j_index in itemList) {
    j = itemList[j_index];
    if (j['current']) {
      currentItemIndex = itemList.indexOf(j) + 1;
      j['current'] = false;
    }
  }
  nextItem = itemList[((currentItemIndex + 1) - 1)];
  if (nextItem) {
    nextItem['current'] = true;
  } else {
    (itemList[0])['current'] = true;
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/0285c0180af9eeb9e84dfbf86fa90a81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var itemList, previousItem, currentItemIndex, j;


  itemList = ((function (componentUid){ return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('998fdfebf2b3a7afe31c706a04e836f1'));
  currentItemIndex = 0;
  for (var j_index in itemList) {
    j = itemList[j_index];
    if (j['current']) {
      currentItemIndex = itemList.indexOf(j) + 1;
      j['current'] = false;
    }
  }
  previousItem = itemList[((currentItemIndex - 1) - 1)];
  if (previousItem) {
    previousItem['current'] = true;
  } else {
    (itemList.slice(-1)[0])['current'] = true;
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/5741032c5bc8e709d218926d5fc6ca07/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  async onContentAssignment(___arguments) {
    var currentItem, item, list;


  currentItem = (await (async () => {
    async function callback (item) {


      return ((item['current']) == true);
    }

    const list = await Promise.all((___arguments.context.pageData['imageList']).map(async source => ({
      source,
      value: await callback(source),
    })));

    const resultList = list.filter(item => item.value)

    return resultList.map(item => item.source)
  })())[0];

  return ([(___arguments.context.pageData['imageList']).indexOf(currentItem) + 1,'/',(___arguments.context.pageData['imageList']).length].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-media/components/20caf2e5080a4bdca666ecc304961efc/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8968a8769b41fc3e6ad822d8ff0d0c75', false);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/63c914b500852997b016a8ceff06d122/bundle.js', [], () => ({
  /* content */
  /* handler:onTextAssignment */
  ['onTextAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login')));
  }

  },
  /* handler:onTextAssignment */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (){ window.history.back(); })();

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/8c4d31016a76a2e435920c99c6da77b4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.pageData, 'profileId')) }));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/6465e80a2358bd62c423aaba884644d4/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  async onDisplayAssignment(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-media/components/07991db49195026ce48658524e129ddd/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      if ((await ( async function (typeSize){ return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return false;
  } else {
    return true;
  }

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/4d0a2cef2e0e0fe42208621e1cf7801e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newChat, notifyText, ids, newRequest;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')), 'open');
  if (!(getObjectProperty(___arguments.context.pageData, 'isSentRequest'))) {
    newChat = (await Backendless.Request.post(`${Backendless.appPath}/services/createChat/createChatRequestPermission`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send(JSON.stringify((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')))));
    ___arguments.context.pageData['isSentRequest'] = true;
    await Backendless.Messaging.pushWithTemplate('message', ({ 'message': String('New request from ') + String((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')).split(' ')[0] : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))),'userId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'objectId')),'app_in_foreground': true,'page': 'messages','id': newChat }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/a8f8b43809b53664008fb18d1d0a625c/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'profile')) {
    return (['You have requested permission to view ',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'login')),'’s photos. You will be able to view their media when they accept your request.'].join(''));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-media/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['© ','',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-media/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  async ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 2000 || 0));
  if ((getObjectProperty(___arguments.context.pageData, 'profile')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name'))) {
    if ((getObjectProperty(___arguments.context.pageData, 'messagesNumber')) && (getObjectProperty(___arguments.context.pageData, 'messagesNumber')) > 0) {
      return (['(',(getObjectProperty(___arguments.context.pageData, 'messagesNumber')),') My activities',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')),'\'s media'].join(''));
    } else {
      return (String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'profile')), 'name')) + String('\'s media'));
    }
  }

  return 'User\'s media'

  },
  /* handler:onTitleAssignment */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}


  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');

  },
  /* handler:onLeave */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;


  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_userMedia_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/user-media/components/bab9d8954fbb1ae3c00b109b45e38f0c/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'hasPermissionCurrentUser')) {
    return ['profile-gallery__photo image', 'gallery__photo'];
  } else if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('23a98d0b424e1c843b2d398b1814364e'), 'isPrivate')) {
    return ['profile-gallery__photo image', 'gallery__photo', 'private'];
  }

  return ['profile-gallery__photo image', 'gallery__photo']

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('23a98d0b424e1c843b2d398b1814364e')['type']) == 'video')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-media/components/86ea2b0f6d97308d02137f1e3fb5b732/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;


  ___arguments.context.pageData['imageList'] = (await Promise.all((___arguments.context.pageData['imageList']).map(async item => {  if ((item['file']) == (___arguments.context.getComponentDataStoreByUid('23a98d0b424e1c843b2d398b1814364e')['file'])) {
      item['current'] = true;
    } else {
      item['current'] = false;
    }
  ; return item;})));
  ;(function (componentUid, visible){ (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('8968a8769b41fc3e6ad822d8ff0d0c75', true);

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || !result.hasOwnProperty(propsNamesList[i])) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('23a98d0b424e1c843b2d398b1814364e'), 'isPrivate')) {
    return ['profile-gallery__videoIcon', 'private'];
  }

  return ['profile-gallery__videoIcon']

  },
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.getComponentDataStoreByUid('23a98d0b424e1c843b2d398b1814364e')['type']) == 'video')

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-media/components/7b279a442ad4bb3f3bb49f3b5b638b8d/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  onClassListAssignment(___arguments) {
      if (___arguments.context.dataModel['current']) {
    return ['gallery__slider-image', 'visible'];
  }

  return ['gallery__slider-image']

  },  
  /* handler:onClassListAssignment */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      return ((___arguments.context.dataModel['type']) == 'video')

  },  
  /* handler:onDisplayAssignment */
  /* handler:onControlsAssignment */
  onControlsAssignment(___arguments) {
      return true

  },  
  /* handler:onControlsAssignment */
  /* content */
}))

define('./pages/user-media/components/103e3f49f20d26d7bfeb402da01e3b92/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  onDisplayAssignment(___arguments) {
      if (___arguments.context.pageData['hasPermissionCurrentUser']) {
    return false;
  } else if (___arguments.context.getComponentDataStoreByUid('23a98d0b424e1c843b2d398b1814364e')['isPrivate']) {
    return true;
  }

  },  
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-media/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-media/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/user-media/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/user-media/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-media/components/a33269d760b7931bd9cee88667c37ac2/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/cdcf362d8bf5943d91d715b650cb12e5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
      ;await ( async function (pageName, pageData){ BackendlessUI.goToPage(pageName, pageData) })('activities-search', null);

  },  
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/1d61c9a7286f9baf3e5194abd727caf9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async onClick(___arguments) {
    var item;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1d61c9a7286f9baf3e5194abd727caf9')).slice(-1)[0] != 'activity-page__quality-item-active') {
    addItemToList(((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1d61c9a7286f9baf3e5194abd727caf9')), 'activity-page__quality-item-active');
    addItemToList(((___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['searchedInterests']), ___arguments.context.dataModel);
  } else {
    ((function (componentUid){ return ___arguments.context.getComponentClassesByUid(componentUid) })('1d61c9a7286f9baf3e5194abd727caf9')).pop();
    (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['searchedInterests'] = (await asyncListFilter(((___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['searchedInterests']), async (item) => {


     return ((item['objectId']) != (___arguments.context.dataModel['objectId']));
    }));
  }

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    if (!!(await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'searchedInterests')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    })).length) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/user-profile/components/a0a4ac7cfa3115af9b7ffac3f949a63e/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['gender'] = ___arguments.checkedValue;
  stopSetTimeout('saveUserGender');

  ;(function() {
    const callback = async () => {
        await Backendless.Data.of('Users').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ [`gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'gender')) }) );
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['gender'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'gender'));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    try {
      await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('profile_edited');

    } catch (error) {
      console.log(error);

    }

    };

    const timerId = 'saveUserGender';
    const timerDelay = 750;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/user-profile/components/916764cf81f7f4dd39add13dbd65fa7a/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['height'] = (___arguments.value * 1);
  await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), ((function () { return window.location.href })()));
  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['height'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'height'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('profile_edited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  ['onOptionsAssignment'](___arguments) {
    var height;


  height = [({ 'value': '122','label': '4′0″ (122 cm)' }), ({ 'value': '124','label': '4′1″ (124 cm)' }), ({ 'value': '127','label': '4′2″ (127 cm)' }), ({ 'value': '130','label': '4′3″ (130 cm)' }), ({ 'value': '132','label': '4′4″ (132 cm)' }), ({ 'value': '135','label': '4′5″ (135 cm)' }), ({ 'value': '137','label': '4′6″ (137 cm)' }), ({ 'value': '140','label': '4′7″ (140 cm)' }), ({ 'value': '142','label': '4′8″ (142 cm)' }), ({ 'value': '145','label': '4′9″ (145 cm)' }), ({ 'value': '152','label': '5′0″ (152 cm)' }), ({ 'value': '155','label': '5′1″ (155 cm)' }), ({ 'value': '157','label': '5′2″ (157 cm)' }), ({ 'value': '160','label': '5′3″ (160 cm)' }), ({ 'value': '163','label': '5′4″ (163 cm)' }), ({ 'value': '165','label': '5′5″ (165 cm)' }), ({ 'value': '168','label': '5′6″ (168 cm)' }), ({ 'value': '170','label': '5′7″ (170 cm)' }), ({ 'value': '173','label': '5′8″ (173 cm)' }), ({ 'value': '176','label': '5′9″ (176 cm)' }), ({ 'value': '178','label': '5′10″ (178 cm)' }), ({ 'value': '180','label': '5′11″ (180 cm)' }), ({ 'value': '183','label': '6′0″ (183 cm)' }), ({ 'value': '185','label': '6′1″ (185 cm)' }), ({ 'value': '188','label': '6′2″ (188 cm)' }), ({ 'value': '191','label': '6′3″ (191 cm)' }), ({ 'value': '193','label': '6′4″ (193 cm)' }), ({ 'value': '195','label': '6′5″ (195 cm)' }), ({ 'value': '198','label': '6′6″ (198 cm)' }), ({ 'value': '201','label': '6′7″ (201 cm)' }), ({ 'value': '203','label': '6′8″ (203 cm)' }), ({ 'value': '206','label': '6′9″ (206 cm)' }), ({ 'value': '208','label': '6′10″ (208 cm)' }), ({ 'value': '211','label': '6′11″ (211 cm)' }), ({ 'value': '213','label': '7′0″ (213 cm)' })];

  return height

  },
  /* handler:onOptionsAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'height'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/bbf8a5244799fbdbc716b9c9c8955a33/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.appData, 'interestList'))

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-profile/components/868ca14116b7664ae49e7a7508b6d056/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
      return (___arguments.context.pageData['interestList'])

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-profile/components/8de1d2230862d2733bc8862c20f6f193/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
    var item;

  },  
  /* handler:onClick */
  /* handler:onClassListAssignment */
  async ['onClassListAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (!!(await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'myInterests')), async (item) => {


   return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
  })).length) {
    return ['activity-page__quality-item', 'activity-page__quality-item-active'];
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/user-profile/components/b3e614a80d460e6d53dff501d99a944c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b3e614a80d460e6d53dff501d99a944c')).includes('open')) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e147c1ab28ca6932024d6957c34602ba')), 'hide');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b3e614a80d460e6d53dff501d99a944c')).pop();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e147c1ab28ca6932024d6957c34602ba')).pop();
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('b3e614a80d460e6d53dff501d99a944c')), 'open');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/87b9d398699cda462d3ceeeda9d1d8a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('87b9d398699cda462d3ceeeda9d1d8a5')).includes('open')) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34d9f58fc91f4ba3ade4cbe4a7152b15')), 'hide');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('87b9d398699cda462d3ceeeda9d1d8a5')).pop();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('34d9f58fc91f4ba3ade4cbe4a7152b15')).pop();
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('87b9d398699cda462d3ceeeda9d1d8a5')), 'open');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/cb55276c83c373e4354d01dba47998d3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cb55276c83c373e4354d01dba47998d3')).includes('open')) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('040cb2e4a1a28edf4d440cae0252a477')), 'hide');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cb55276c83c373e4354d01dba47998d3')).pop();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('040cb2e4a1a28edf4d440cae0252a477')).pop();
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('cb55276c83c373e4354d01dba47998d3')), 'open');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/d49dcce198d1e1460d86cb16cb2ebb22/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var path;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d49dcce198d1e1460d86cb16cb2ebb22')).includes('open')) {
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('96ab2505fcf869727852706bb86bb7e7')), 'hide');
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d49dcce198d1e1460d86cb16cb2ebb22')).pop();
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('96ab2505fcf869727852706bb86bb7e7')).pop();
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('d49dcce198d1e1460d86cb16cb2ebb22')), 'open');
  }
  if (!(getObjectProperty(___arguments.context.pageData, 'dragAndDropInit'))) {
    path = String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'));
    await (async function(path, mediaList, data) {
    	async function resizeImage(files, width, percent) {
    	  for (let index = 0; index < files.length; index++) {
    	    const file = files[index];
    	
    	    if (file.type.includes('image')) {
    	      const fileName = file.name
    	      const content = await readFileAsDataURL(file)
    	    
    	      const img = await getNewImage(content)
    	    
    	      const elem = document.createElement('canvas')
    	    
    	      const widthImage = !width ? img.width : width
    	      const scaleFactor = width && width / img.width
    	      const heightImage = width ? img.height * scaleFactor : img.height
    	      
    	      elem.width = widthImage
    	      elem.height = heightImage
    	    
    	      const ctx = elem.getContext('2d')
    	    
    	      ctx.drawImage(img, 0, 0, widthImage, heightImage)
    	    
    	      const blob = await getCanvasBlob(ctx.canvas, percent)
    	    
    	      const newFile = new File([blob], fileName, {
    	        type: 'image/jpeg',
    	        lastModified: Date.now()
    	      })
    	    
    	      files[index] = newFile
    	    
    	    
    	    async function readFileAsDataURL(file) {
    	      const result = await new Promise((resolve) => {
    	        const fileReader = new FileReader()
    	    
    	        fileReader.onload = (e) => resolve(e.target.result)
    	    
    	        fileReader.readAsDataURL(file)
    	      })
    	    
    	      return result
    	    }
    	    
    	    async function getNewImage(content) {
    	      const result = await new Promise((resolve) => {
    	        const img = new Image()
    	    
    	        img.src = content
    	    
    	        img.onload = () => resolve(img)
    	      })
    	    
    	      return result
    	    }
    	    
    	    async function getCanvasBlob(canvas, percent) {
    	      const result = await new Promise((resolve) => {
    	        canvas.toBlob((blob) => {
    	          resolve(blob)
    	        }, 'image/jpeg', percent)
    	      })
    	    
    	      return result
    	    }
    	  } 
    	  }
    	  uploadFile(files);
    	}
    	
    	const dropArea = document.querySelector('.upload__btn');
    	
    	  dropArea.addEventListener("dragover", (event) => {
    	    event.preventDefault();
    	    dropArea.classList.add('active');
    	  });
    	  
    	  dropArea.addEventListener("dragleave", () => {
    	    dropArea.classList.remove('active');
    	  });
    	  
    	  
    	  function uploadFile(files) {
    	    files.forEach((file) => {
    	      if (file.type.includes('image')) {
    	        Backendless.Files.upload(file, path, overwrite = true)
    	       .then(async function(fileURL) {
    	          let media = {
    	            file: fileURL.fileURL,
    	            type: 'image',
    	            isPrivate: false
    	          };
    	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', true);
    	          let moderationResult =  await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileURL.fileURL) }).send();
    	         if (moderationResult == 'OK') {
    	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', false);
    	            mediaList.push(media);
    	         } else {
    	           Backendless.Files.remove(fileURL.fileURL);
    	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', false);
    	           (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('f51aa52ccaef96dd73c868889425adfc', ({ 'showRejectMsg': true }));
    	         }
    	        })
    	       .catch( function( error ) {
    	         console.log(error)
    	        })
    	      } else if (file.type.includes('video')) {
    	        Backendless.Files.upload(file, path, overwrite = true)
    	       .then(function(fileURL) {
    	         let media = {
    	            file: fileURL.fileURL,
    	            type: 'video',
    	            isPrivate: false
    	          }
    	          mediaList.push(media);
    	          // data.media.push(mediaImg);
    	        })
    	       .catch( function( error ) {
    	         console.log(error)
    	        })
    	      }
    	    });
    	    
    	    // return mediaList;
    	    return data.media
    	  }
    	  
    	 
    	  dragAndDropFunc = function (event) {
    	    event.preventDefault();
    	    let files = event.dataTransfer.files;
    	    resizeImage([...files], 700, 80)
    	    dropArea.classList.remove('active');
    	  }
    	  
    	  dropArea.addEventListener("drop", dragAndDropFunc);
    	  

    })(path, (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')), ___arguments.context.pageData);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/e147c1ab28ca6932024d6957c34602ba/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6f156a461b118ffc7715fde545aa8564'))['maxDate'] = (new Date(([(new Date((new Date())).getMonth()) + 1,'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear()) - 18].join(''))));
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6f156a461b118ffc7715fde545aa8564'))['minDate'] = (new Date(([(new Date((new Date())).getMonth()) + 1,'/',(new Date((new Date())).getDate()),'/',(new Date((new Date())).getFullYear()) - 150].join(''))));
  (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('08a4fca887d723b91cc10043ce77d7b4')), 'el'))['maxLength'] = 25;
  if (((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e8a755b42451b274345b1215a9c2096')) && (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e8a755b42451b274345b1215a9c2096')), 'el'))) {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('4e8a755b42451b274345b1215a9c2096')), 'el'))['maxLength'] = 120;
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/user-profile/components/6f156a461b118ffc7715fde545aa8564/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['birthDate'] = ___arguments.value;

  },
  /* handler:onChange */
  /* handler:onReadOnlyStateAssignment */
  ['onReadOnlyStateAssignment'](___arguments) {
      return true

  },
  /* handler:onReadOnlyStateAssignment */
  /* content */
}))

define('./pages/user-profile/components/fccd6465526e32f622722e6463298119/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'statusList')) {
    return (await Promise.all((getObjectProperty(___arguments.context.appData, 'statusList')).map(async item => {; return ({ 'label': (getObjectProperty(item, 'name')),'value': (getObjectProperty(item, 'id')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['maritalStatus'] = (___arguments.value * 1);

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'maritalStatus'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/e509b52108cc743602bb99da619cb49b/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'ethnicityList')) {
    return (await Promise.all((getObjectProperty(___arguments.context.appData, 'ethnicityList')).map(async item => {; return ({ 'label': (getObjectProperty(item, 'name')),'value': (getObjectProperty(item, 'id')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['ethnicity'] = (___arguments.value * 1);

  },  
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'ethnicity'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/1ce78263d572fa68a24e34ddac4d64fd/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'bodyTypeList')) {
    return (await Promise.all((getObjectProperty(___arguments.context.appData, 'bodyTypeList')).map(async item => {; return ({ 'label': (getObjectProperty(item, 'name')),'value': (getObjectProperty(item, 'id')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['bodyType'] = (___arguments.value * 1);

  },
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'bodyType'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/9e7d1fe2d7344144ddfd3d918ba58662/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'orientationList')) {
    return (await Promise.all((getObjectProperty(___arguments.context.appData, 'orientationList')).map(async item => {; return ({ 'label': (getObjectProperty(item, 'name')),'value': (getObjectProperty(item, 'id')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['sexOrientation'] = (___arguments.value * 1);

  },  
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'sexOrientation'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/258f112f751145b21d365bcaee3dc96f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
      (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['children'] = undefined;

  },  
  /* handler:onChange */
  /* handler:onCheckedValueAssignment */
  ['onCheckedValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'children'));
  }

  },
  /* handler:onCheckedValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/b099536a783874bbbb0ccc9b0d5f2627/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'educationList')) {
    return (await Promise.all((getObjectProperty(___arguments.context.appData, 'educationList')).map(async item => {; return ({ 'label': (getObjectProperty(item, 'name')),'value': (getObjectProperty(item, 'id')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['educationLevel'] = (___arguments.value * 1);

  },  
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'educationLevel'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/f1faa0849b97ab66b344fc31225370d6/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'politicalList')) {
    return (await Promise.all((getObjectProperty(___arguments.context.appData, 'politicalList')).map(async item => {; return ({ 'label': (getObjectProperty(item, 'name')),'value': (getObjectProperty(item, 'id')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['politicalView'] = (___arguments.value * 1);

  },  
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'politicalView'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/b139a8ba689305b43d0f3df917432332/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.appData, 'religionList')) {
    return (await Promise.all((await asyncListSort((getObjectProperty(___arguments.context.appData, 'religionList')), 1, async (item) => {


     return (getObjectProperty(item, 'name'));
    })).map(async item => {; return ({ 'label': (getObjectProperty(item, 'name')),'value': (getObjectProperty(item, 'id')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['religion'] = (___arguments.value * 1);

  },  
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'religion'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/69b9a7435b6e5a774f967f27f307dc8b/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeUnmount */
  ['onBeforeUnmount'](___arguments) {
      ___arguments.context.appData['pageDataAccount'] = ___arguments.context.pageData;

  },
  /* handler:onBeforeUnmount */
  /* content */
}))

define('./pages/user-profile/components/04ebf6abafcf4fe87097b24a6349841a/bundle.js', [], () => ({
  /* content */
  /* handler:onUploadSuccess */
  async ['onUploadSuccess'](___arguments) {
    var error, j, item, userProfile, format, video, deleteFiles, moderateResult;

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

/**
 * Describe this function...
 */
async function drugAndDrop() {
  await (async function(path, mediaList) {
  	async function resizeImage(files, width, percent) {
  	  let widthImage = 0
  	  let heightImage = 0

  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index];

  	    if (file.type.includes('image')) {
  	      const fileName = file.name
  	      const content = await readFileAsDataURL(file)

  	      const img = await getNewImage(content)

  	      const elem = document.createElement('canvas')

  	      if (!width || img.width < width) {
  	        widthImage = img.width
  	        heightImage = img.height
  	      } else {
  	        widthImage = width
  	        const scaleFactor = width / img.width
  	        heightImage = img.height * scaleFactor
  	      }

  	      elem.width = widthImage
  	      elem.height = heightImage

  	      const ctx = elem.getContext('2d')

  	      ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	      const blob = await getCanvasBlob(ctx.canvas, percent)

  	      const newFile = new File([blob], fileName, {
  	        type: 'image/jpeg',
  	        lastModified: Date.now()
  	      })

  	      files[index] = newFile


  	      async function readFileAsDataURL(file) {
  	        const result = await new Promise((resolve) => {
  	          const fileReader = new FileReader()

  	          fileReader.onload = (e) => resolve(e.target.result)

  	          fileReader.readAsDataURL(file)
  	        })

  	        return result
  	      }

  	      async function getNewImage(content) {
  	        const result = await new Promise((resolve) => {
  	          const img = new Image()

  	          img.src = content

  	          img.onload = () => resolve(img)
  	        })

  	        return result
  	      }

  	      async function getCanvasBlob(canvas, percent) {
  	        const result = await new Promise((resolve) => {
  	          canvas.toBlob((blob) => {
  	            resolve(blob)
  	          }, 'image/jpeg', percent)
  	        })

  	        return result
  	      }
  	    }
  	  }
  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.upload__btn');
  	dropArea.removeEventListener('drop', dragAndDropFunc);

  	dropArea.addEventListener("dragover", (event) => {
  	  event.preventDefault();
  	  dropArea.classList.add('active');
  	});

  	dropArea.addEventListener("dragleave", () => {
  	  dropArea.classList.remove('active');
  	});


  	function uploadFile(files) {
  	  files.forEach((file) => {
  	    if (file.type.includes('image')) {
  	      Backendless.Files.upload(file, path, overwrite = true)
  	      .then(async function(fileURL) {
  	        let media = {
  	          file: fileURL.fileURL,
  	          type: 'image',
  	          isPrivate: false
  	        };
  	        (function (componentUid, visible) {
  	          (function(component) {
  	            component.display = !!(typeof visible === 'boolean' ? visible: !component.display)
  	          })(___arguments.context.getComponentByUid(componentUid))
  	        })('0e03a68310cbad155bf9b23c41ef1324', true);
  	        let moderationResult = await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h) {
  	          if (!h['user-token']) {
  	            delete h['user-token']} return h
  	        })({
  	          ... {},
  	          ... {
  	            'user-token': Backendless.getCurrentUserToken()
  	          }})).query({
  	          'url': JSON.stringify(fileURL.fileURL)
  	        }).send();
  	        if (moderationResult == 'OK') {
  	          (function (componentUid, visible) {
  	            (function(component) {
  	              component.display = !!(typeof visible === 'boolean' ? visible: !component.display)
  	            })(___arguments.context.getComponentByUid(componentUid))
  	          })('0e03a68310cbad155bf9b23c41ef1324', false);
  	          mediaList.push(media);
  	        } else {
  	          Backendless.Files.remove(fileURL.fileURL);
  	          (function (componentUid, visible) {
  	            (function(component) {
  	              component.display = !!(typeof visible === 'boolean' ? visible: !component.display)
  	            })(___arguments.context.getComponentByUid(componentUid))
  	          })('0e03a68310cbad155bf9b23c41ef1324', false);
  	          (function (componentUid, dataModel) {
  	            ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel)
  	          })('f51aa52ccaef96dd73c868889425adfc', ({
  	              'showRejectMsg': true
  	            }));
  	        };
  	      })
  	      .catch(function(error) {
  	        console.log(error)
  	      })
  	    } else if (file.type.includes('video')) {
  	      Backendless.Files.upload(file, path, overwrite = true)
  	      .then(function(fileURL) {
  	        let media = {
  	          file: fileURL.fileURL,
  	          type: 'video',
  	          isPrivate: false
  	        };
  	        mediaList.push(media);
  	      })
  	      .catch(function(error) {
  	        console.log(error)
  	      })
  	    }
  	  })
  	  return mediaList;
  	}

  	dragAndDropFunc = function(event) {

  	  event.preventDefault();
  	  let files = event.dataTransfer.files;
  	  resizeImage([...files],
  	    1000,
  	    0.8)
  	  dropArea.classList.remove('active');
  	}

  	dropArea.addEventListener("drop", dragAndDropFunc);
  })((String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'))), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')));
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', true);
  video = ['.mov', '.mp4', '.mpeg4', '.wmv', '.flv', '.avi', '.mkv'];
  try {
    var j_list = ___arguments.uploadedFiles;
    for (var j_index in j_list) {
      j = j_list[j_index];
      if (video.includes((j.slice(((j.lastIndexOf('.') + 1) - 1), j.length).trim()))) {
      } else {
        moderateResult = (await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(j) }).send());
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', false);
        if (moderateResult == 'KO') {
          (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('f51aa52ccaef96dd73c868889425adfc', ({ [`showRejectMsg`]: true }));
          deleteFiles = true;
          break;
        }
      }
    }
    if (deleteFiles) {
      ;(async () => {
          var j_list2 = ___arguments.uploadedFiles;
        for (var j_index2 in j_list2) {
          j = j_list2[j_index2];
          await Backendless.Files.remove(encodePath(j));
        }

      })();
      (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04ebf6abafcf4fe87097b24a6349841a');
      await drugAndDrop();
      return ;
    }

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04ebf6abafcf4fe87097b24a6349841a');
    return ;

  }
  addItemToList((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')), (await Promise.all(___arguments.uploadedFiles.map(async item => {  format = item.slice(((item.lastIndexOf('.') + 1) - 1), item.length).trim();
  ; return ({ [`file`]: item,[`isPrivate`]: false,[`type`]: (video.includes(format)) ? 'video' : 'image',[`isCover`]: false });}))));
  (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04ebf6abafcf4fe87097b24a6349841a');
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'login')) {
    await drugAndDrop();
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')).length >= 10) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['media'] = ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')).slice(0, 10));
    }
  }
  try {
    userProfile = (getObjectProperty(___arguments.context.pageData, 'userProfileId'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['media'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')), -1, async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    }));
    var j_list3 = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media'));
    for (var j_index3 in j_list3) {
      j = j_list3[j_index3];
      if ((getObjectProperty(j, 'file')).split('/')[0] == 'https:') {
        j['file'] = (String('/') + String(subsequenceFromEndLast((getObjectProperty(j, 'file')).split('/'), 2).join('/')));
      }
    }
    await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), ((function () { return window.location.href })()));
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04ebf6abafcf4fe87097b24a6349841a');
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['media'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media'));
    ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));

  } catch (error) {
    console.log(error);

  }
  try {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')).length > 1) {
      await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('extra_photo_added');
    }

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onUploadSuccess */
  /* handler:onDirectoryAssignment */
  onDirectoryAssignment(___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string') {
    throw new Error('"property name" in "Get object property" block must be "string"')
  }

  if (object.hasOwnProperty(propPath)) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object[propsNamesList[0]]

  for (let i = 1; i < propsNamesList.length; i++) {
    result = result[propsNamesList[i]]
  }

  return result
}



  return (String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia')))

  },
  /* handler:onDirectoryAssignment */
  /* handler:onFileNameAssignment */
  onFileNameAssignment(___arguments) {
      return ([((new Date()).valueOf()),'_',(___arguments.file['name']).toLowerCase()].join(''))

  },
  /* handler:onFileNameAssignment */
  /* handler:onBeforeUpload */
  async ['onBeforeUpload'](___arguments) {
      return (await (async function(files, width, percent) {
	let widthImage = 0
	let heightImage = 0

	for (let index = 0; index < files.length; index++) {
	  const file = files[index]
	  if (file.type.includes('video')) {
	    return files;
	  }
	  const fileName = file.name

	  const content = await readFileAsDataURL(file)

	  const img = await getNewImage(content)

	  const elem = document.createElement('canvas')

	  if (!width || img.width < width) {
	    widthImage = img.width
	    heightImage = img.height
	  } else {
	    widthImage = width
	    const scaleFactor = width / img.width
	    heightImage = img.height * scaleFactor
	  }

	  elem.width = widthImage
	  elem.height = heightImage

	  const ctx = elem.getContext('2d')

	  ctx.drawImage(img, 0, 0, widthImage, heightImage)

	  const blob = await getCanvasBlob(ctx.canvas, percent)

	  const newFile = new File([blob], fileName, {
	    type: 'image/jpeg',
	    lastModified: Date.now()
	  })

	  files[index] = newFile
	}

	async function readFileAsDataURL(file) {
	  const result = await new Promise((resolve) => {
	    const fileReader = new FileReader()

	    fileReader.onload = (e) => resolve(e.target.result)

	    fileReader.readAsDataURL(file)
	  })

	  return result
	}

	async function getNewImage(content) {
	  const result = await new Promise((resolve) => {
	    const img = new Image()

	    img.src = content

	    img.onload = () => resolve(img)
	  })

	  return result
	}

	async function getCanvasBlob(canvas, percent) {
	  const result = await new Promise((resolve) => {
	    canvas.toBlob((blob) => {
	      resolve(blob)
	    }, 'image/jpeg', percent)
	  })

	  return result
	}

	return files;
})(___arguments.files, 1000, 0.8))

  },
  /* handler:onBeforeUpload */
  /* handler:onButtonLabelAssignment */
  ['onButtonLabelAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    return 'Upload media';
  }

  return 'Drag and Drop or click to upload'

  },
  /* handler:onButtonLabelAssignment */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')).length >= 10) {
      return true;
    } else {
      return false;
    }
  }

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/user-profile/components/3abfce2929ff97f1e464d966dc698b56/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var currentUser;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  ___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07')['isPrivate'] = ___arguments.value;
  stopSetTimeout('savePrivatePhoto');

  ;(function() {
    const callback = async () => {
        if (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'objectId')) {
      await Backendless.Data.of('UserProfile').save( ({ [`objectId`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'objectId')),[`media`]: (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')) }) );
      currentUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
      if (getObjectProperty(currentUser, 'userProfile')) {
        (getObjectProperty(currentUser, 'userProfile'))['media'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media'));
        localStorage.setItem('currentUser', JSON.stringify(currentUser));
      }
    }

    };

    const timerId = 'savePrivatePhoto';
    const timerDelay = 1000;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 1000 || 0));
  if (___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07'), 'isCover')) == true) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/c4d360f9584d8828b116ff1ee133ba53/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    var error, item, path, mediaList, dateTo, dateFrom, currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

/**
 * Describe this function...
 */
async function profilesTableData() {
  try {
    if (!((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')) && !(getObjectProperty(___arguments.context.appData, 'statusList'))) {
      ___arguments.context.appData['statusList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileMaritalStatus'));
      ___arguments.context.appData['ethnicityList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileEthnicity'));
      ___arguments.context.appData['bodyTypeList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileBodyType'));
      ___arguments.context.appData['orientationList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileSexOrientation'));
      ___arguments.context.appData['educationList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileEducationLevel'));
      ___arguments.context.appData['politicalList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfilePoliticalView'));
      ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
      ___arguments.context.appData['hairColorList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileHairColor'));
      ___arguments.context.appData['smokeList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileSmoke'));
      ___arguments.context.appData['drinkList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileDrink'));
      ___arguments.context.appData['dietaryList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileDietary'));
      ___arguments.context.appData['profilesData'] = ({ [`statusList`]: (getObjectProperty(___arguments.context.appData, 'statusList')),[`ethnicityList`]: (getObjectProperty(___arguments.context.appData, 'ethnicityList')),[`bodyTypeList`]: (getObjectProperty(___arguments.context.appData, 'bodyTypeList')),[`orientationList`]: (getObjectProperty(___arguments.context.appData, 'orientationList')),[`educationList`]: (getObjectProperty(___arguments.context.appData, 'educationList')),[`politicalList`]: (getObjectProperty(___arguments.context.appData, 'politicalList')),[`religionList`]: (await asyncListSort((getObjectProperty(___arguments.context.appData, 'religionList')), 1, async (item) => {


       return (getObjectProperty(item, 'name'));
      })),[`hairColorList`]: (getObjectProperty(___arguments.context.appData, 'hairColorList')),[`smokeList`]: (getObjectProperty(___arguments.context.appData, 'smokeList')),[`drinkList`]: (getObjectProperty(___arguments.context.appData, 'drinkList')),[`dietaryList`]: (getObjectProperty(___arguments.context.appData, 'dietaryList')) });
      localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
    } else if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData')) && !(getObjectProperty(___arguments.context.appData, 'statusList'))) {
      ___arguments.context.appData['profilesData'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'));
      ___arguments.context.appData['statusList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'statusList'));
      ___arguments.context.appData['ethnicityList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'ethnicityList'));
      ___arguments.context.appData['bodyTypeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'bodyTypeList'));
      ___arguments.context.appData['orientationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'orientationList'));
      ___arguments.context.appData['educationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'educationList'));
      ___arguments.context.appData['politicalList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'politicalList'));
      ___arguments.context.appData['religionList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')), 1, async (item) => {


       return (getObjectProperty(item, 'name'));
      }));
      if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')).length <= 10) {
        ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
        (getObjectProperty(___arguments.context.appData, 'profilesData'))['religionList'] = (await asyncListSort((getObjectProperty(___arguments.context.appData, 'religionList')), 1, async (item) => {


         return (getObjectProperty(item, 'name'));
        }));
        localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
      }
      ___arguments.context.appData['hairColorList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'hairColorList'));
      ___arguments.context.appData['smokeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'smokeList'));
      ___arguments.context.appData['drinkList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'drinkList'));
      if (!(getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList'))) {
        ___arguments.context.appData['dietaryList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileDietary'));
        (getObjectProperty(___arguments.context.appData, 'profilesData'))['dietaryList'] = (getObjectProperty(___arguments.context.appData, 'dietaryList'));
        localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
      } else {
        ___arguments.context.appData['dietaryList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList'));
      }
    } else if ((getObjectProperty(___arguments.context.appData, 'religionList')) && (getObjectProperty(___arguments.context.appData, 'religionList')).length <= 10) {
      ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
      (getObjectProperty(___arguments.context.appData, 'profilesData'))['religionList'] = (await asyncListSort((getObjectProperty(___arguments.context.appData, 'religionList')), 1, async (item) => {


       return (getObjectProperty(item, 'name'));
      }));
      localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
    }
    if ((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')).length <= 10) {
      ___arguments.context.appData['religionList'] = (await BackendlessUI.Functions.Custom['fn_7933881c975cf68554fd4556990234b5']('ProfileReligion'));
      (getObjectProperty(___arguments.context.appData, 'profilesData'))['religionList'] = (await asyncListSort((getObjectProperty(___arguments.context.appData, 'religionList')), 1, async (item) => {


       return (getObjectProperty(item, 'name'));
      }));
      localStorage.setItem('profilesData', JSON.stringify((getObjectProperty(___arguments.context.appData, 'profilesData'))));
    }

  } catch (error) {
    console.log(error);

  }
}

/**
 * Describe this function...
 */
async function statusList() {
  if (!(getObjectProperty(___arguments.context.appData, 'statusList'))) {
    ___arguments.context.appData['profilesData'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('profilesData'));
    ___arguments.context.appData['statusList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'statusList'));
    ___arguments.context.appData['ethnicityList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'ethnicityList'));
    ___arguments.context.appData['bodyTypeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'bodyTypeList'));
    ___arguments.context.appData['orientationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'orientationList'));
    ___arguments.context.appData['educationList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'educationList'));
    ___arguments.context.appData['politicalList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'politicalList'));
    ___arguments.context.appData['religionList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'religionList')), 1, async (item) => {


     return (getObjectProperty(item, 'name'));
    }));
    ___arguments.context.appData['hairColorList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'hairColorList'));
    ___arguments.context.appData['smokeList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'smokeList'));
    ___arguments.context.appData['drinkList'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'drinkList'));
    ___arguments.context.appData['dietaryList'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.appData, 'profilesData')), 'dietaryList')), 1, async (item) => {


     return (getObjectProperty(item, 'id'));
    }));
  }
}


  if ((await Backendless.UserService.getCurrentUser(false)) == null) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  await statusList();
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
    ___arguments.context.appData['login'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'login'));
    ___arguments.context.appData['name'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'name'));
    ___arguments.context.appData['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'photoThumbnail'));
    ___arguments.context.appData['profileStatus'] = (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'profileStatus'));
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  if ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})((String('q_') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('quiz', undefined);
    return ;
  }
  currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  if (!(getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile')), 'dietaryPreferenceJson'))) {
    (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile'))['dietaryPreferenceJson'] = [];
  }
  ___arguments.context.pageData['userProfile'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'));
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) {
    ___arguments.context.dataModel['name'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name'));
  } else if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')) != ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')).replace((new RegExp('[^\\w\\s]', 'g')), ''))) {
    ___arguments.context.dataModel['name'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
  }
  ___arguments.context.dataModel['login'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
  ___arguments.context.dataModel['email'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'email'));
  ___arguments.context.dataModel['birthDate'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'birthDate'));
  dateFrom = (new Date());
  dateFrom.setFullYear(((new Date((new Date())).getFullYear()) - 90));
  ___arguments.context.dataModel['birthDateFrom'] = dateFrom;
  dateTo = (new Date());
  dateTo.setFullYear(((new Date((new Date())).getFullYear()) - 18));
  ___arguments.context.dataModel['birthDateTo'] = dateTo;
  ___arguments.context.dataModel['gender'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'gender'));
  ___arguments.context.dataModel['height'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'height'));
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) != null) {
    ___arguments.context.pageData['userProfileId'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'objectId'));
    ___arguments.context.dataModel['aboutDetailed'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'aboutDetailed'));
    ___arguments.context.dataModel['aboutShort'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'aboutShort'));
    ___arguments.context.dataModel['preferredGenderPronouns'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'preferredGenderPronouns'));
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'preferredGenderPronouns')) {
      ___arguments.context.dataModel['isCustomGenderPronouns'] = true;
      ___arguments.context.dataModel['isGenderCustomDisabled'] = false;
    } else {
      ___arguments.context.dataModel['isCustomGenderPronouns'] = false;
      ___arguments.context.dataModel['isGenderCustomDisabled'] = true;
    }
    ___arguments.context.dataModel['newUserProfile'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'));
  } else {
  }
  ___arguments.context.pageData['userNameMedia'] = ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).replace((new RegExp('[^\\w\\s]', 'g')), ''));
  path = String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'));
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('04ebf6abafcf4fe87097b24a6349841a')) {
    await (async function(path, mediaList, data) {
    	async function resizeImage(files, width, percent) {
    	  for (let index = 0; index < files.length; index++) {
    	    const file = files[index];
    	
    	    if (file.type.includes('image')) {
    	      const fileName = file.name
    	      const content = await readFileAsDataURL(file)
    	    
    	      const img = await getNewImage(content)
    	    
    	      const elem = document.createElement('canvas')
    	    
    	      const widthImage = !width ? img.width : width
    	      const scaleFactor = width && width / img.width
    	      const heightImage = width ? img.height * scaleFactor : img.height
    	      
    	      elem.width = widthImage
    	      elem.height = heightImage
    	    
    	      const ctx = elem.getContext('2d')
    	    
    	      ctx.drawImage(img, 0, 0, widthImage, heightImage)
    	    
    	      const blob = await getCanvasBlob(ctx.canvas, percent)
    	    
    	      const newFile = new File([blob], fileName, {
    	        type: 'image/jpeg',
    	        lastModified: Date.now()
    	      })
    	    
    	      files[index] = newFile
    	    
    	    
    	    async function readFileAsDataURL(file) {
    	      const result = await new Promise((resolve) => {
    	        const fileReader = new FileReader()
    	    
    	        fileReader.onload = (e) => resolve(e.target.result)
    	    
    	        fileReader.readAsDataURL(file)
    	      })
    	    
    	      return result
    	    }
    	    
    	    async function getNewImage(content) {
    	      const result = await new Promise((resolve) => {
    	        const img = new Image()
    	    
    	        img.src = content
    	    
    	        img.onload = () => resolve(img)
    	      })
    	    
    	      return result
    	    }
    	    
    	    async function getCanvasBlob(canvas, percent) {
    	      const result = await new Promise((resolve) => {
    	        canvas.toBlob((blob) => {
    	          resolve(blob)
    	        }, 'image/jpeg', percent)
    	      })
    	    
    	      return result
    	    }
    	  } 
    	  }
    	  uploadFile(files);
    	}
    	
    	const dropArea = document.querySelector('.upload__btn');
    	  
    	  dropArea.addEventListener("dragover", (event) => {
    	    event.preventDefault();
    	    dropArea.classList.add('active');
    	  });
    	  
    	  dropArea.addEventListener("dragleave", () => {
    	    dropArea.classList.remove('active');
    	  });
    	  
    	  
    	  function uploadFile(files) {
    	    files.forEach((file) => {
    	      if (file.type.includes('image')) {
    	        Backendless.Files.upload(file, path, overwrite = true)
    	       .then(async function(fileURL) {
    	          let media = {
    	            file: fileURL.fileURL,
    	            type: 'image',
    	            isPrivate: false
    	          };
    	          (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', true);
    	          let moderationResult =  await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileURL.fileURL) }).send();
    	         if (moderationResult == 'OK') {
    	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', false);
    	            mediaList.push(media);
    	         } else {
    	           Backendless.Files.remove(fileURL.fileURL);
    	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', false);
    	           (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('f51aa52ccaef96dd73c868889425adfc', ({ 'showRejectMsg': true }));
    	         }
    	        })
    	       .catch( function( error ) {
    	         console.log(error)
    	        })
    	      } else if (file.type.includes('video')) {
    	        Backendless.Files.upload(file, path, overwrite = true)
    	       .then(function(fileURL) {
    	         let media = {
    	            file: fileURL.fileURL,
    	            type: 'video',
    	            isPrivate: false
    	          }
    	          mediaList.push(media);
    	          // data.media.push(mediaImg);
    	        })
    	       .catch( function( error ) {
    	         console.log(error)
    	        })
    	      }
    	    });
    	    
    	    // return mediaList;
    	    return data.media
    	  }
    	  
    	 
    	  dragAndDropFunc = function (event) {
    	    event.preventDefault();
    	    let files = event.dataTransfer.files;
    	    resizeImage([...files], 700, 80)
    	    dropArea.classList.remove('active');
    	  }
    	  
    	  dropArea.addEventListener("drop", dragAndDropFunc);
    	  

    })(path, (getObjectProperty((getObjectProperty(___arguments.context.dataModel, 'newUserProfile')), 'media')), ___arguments.context.pageData);
    ___arguments.context.pageData['dragAndDropInit'] = true;
  }
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  await new Promise(r => setTimeout(r, 500 || 0));
  await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);
  try {
    if ((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')).length > 0) {
      (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty(((await asyncListFilter((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')), async (item) => {


       return ((getObjectProperty(item, 'isCover')) == true);
      }))[0]), 'file'));
    } else {
    }

  } catch (error) {
    console.log(error);

  }
  ___arguments.context.pageData['pageLoaded'] = true;

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'isMainBlVisible')) && !(getObjectProperty(___arguments.context.pageData, 'accountPaused')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/73ff53b8469ea262363bb127e1f8c9b3/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function saveData() {
  stopSetTimeout('saveAboutShort');

  ;(function() {
    const callback = async () => {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['aboutShort'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'aboutShort'));
    await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), ((function () { return window.location.href })()));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['aboutShort'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'aboutShort'));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    try {
      await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('profile_edited');

    } catch (error) {
      console.log(error);

    }

    };

    const timerId = 'saveAboutShort';
    const timerDelay = 750;

    runSetTimeout(timerId, callback, timerDelay)
  })()
}


  if (getValueLength(___arguments.value.trim()) < 15) {
    stopSetTimeout('saveAboutShort');
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('73ff53b8469ea262363bb127e1f8c9b3')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('73ff53b8469ea262363bb127e1f8c9b3')), 'alert-border');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['errorMmessageHeadline'] = 'Minimum 15 characters';
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('73ff53b8469ea262363bb127e1f8c9b3')).includes('alert-border')) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('73ff53b8469ea262363bb127e1f8c9b3')), 'alert-border', '');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['errorMmessageHeadline'] = '';
    await saveData();
  }

  },
  /* handler:onChange */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 300 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('87b9d398699cda462d3ceeeda9d1d8a5')));
  }

  },
  /* handler:onFocus */
  /* content */
}))

define('./pages/user-profile/components/550e8ecdfeb40e56aa1aaebb7d949092/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')) ? (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')) : [])

  },
  /* handler:onDynamicItemsAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')).length >= 10) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['media'] = ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')).slice(0, 10));
    }
  }
  ___arguments.context.pageData['check'] = true;

  },
  /* handler:onMounted */
  /* handler:onMouseOut */
  ['onMouseOut'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')).length >= 10) {
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['media'] = ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')).slice(0, 10));
    }
  }

  },
  /* handler:onMouseOut */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')) && !!(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')).length)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/396cda244eae4e6b560c0098547d0fc7/bundle.js', [], () => ({
  /* content */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'hairColorList')) {
    return (await Promise.all((getObjectProperty(___arguments.context.appData, 'hairColorList')).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'name')),[`value`]: (getObjectProperty(item, 'id')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onChange */
  onChange(___arguments) {
      (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['hairColor'] = (___arguments.value * 1);

  },  
  /* handler:onChange */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'hairColor'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/67e4ff4ce96344dbe3615264c29963f9/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, name2, j, userProfile, item, newThumb, content2, path;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

function sortBy(list, order) {
  return list.sort(function(elementA, elementB) {
     const a = elementA.value
     const b = elementB.value
     let result = 0

     if (a > b) result = 1
     if (a < b) result = -1

     return result * order
   })
}

async function asyncListSort(sourceList, order, callback) {
 const list = await Promise.all(sourceList.map(async source => ({
   source,
   value: await callback(source),
 })));

 sortBy(list, order);

 return list.map(item => item.source)
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await new Promise(r => setTimeout(r, 100 || 0));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['savingData'] = true;
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cf1c17c14ad4ee5be59806b9e55a535', true);
  if (getObjectProperty(___arguments.context.pageData, 'newCover')) {
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = (getObjectProperty(___arguments.context.pageData, 'avatar'));
    if (((function () { return window.location.href })()) == 'file://' || ((function () { return window.location.href })()) == '' || ((function () { return window.location.href })()) != 'https://app.findmyplus.one/?page=user-profile' || ((function () { return window.location.href })()) != 'https://app.findmyplus.one/?page=user-profile&data=%7B%7D') {
      path = ['/pictures/thumbnails/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('');
      content2 = String('https://app.findmyplus.one/api/files/') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')).split('/'), 2).join('/'));
    } else {
      path = String('/pictures/thumbnails/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
      content2 = String('/api/files/') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')).split('/'), 2).join('/'));
    }
    ___arguments.context.pageData['newThumbnail'] = (await (async function(width, percent, path, content) {

    	  const img = await getNewImage(content);

    	  const elem = document.createElement('canvas');

    	  const widthImage = !width ? img.width : width;
    	  const scaleFactor = width && width / img.width;
    	  const heightImage = width ? img.height * scaleFactor : img.height;

    	  elem.width = widthImage;
    	  elem.height = heightImage;

    	  const ctx = elem.getContext('2d');

    	  ctx.drawImage(img, 0, 0, widthImage, heightImage);

    	 const blob = await getCanvasBlob(ctx.canvas, percent);

    	  const newFile = new File([blob], 'photo'+ Date.now()+ '.jpeg', {
    	    type: 'image/jpeg',
    	    lastModified: Date.now()
    	  });


    	  // const {fileUrl} = await Backendless.Files.upload(newFile, path, true)


    	async function getNewImage(content) {
    	  const result = await new Promise((resolve) => {
    	    const img = new Image();

    	    img.crossOrigin = "Anonymous";
    	    img.src = content;
    	    img.onload = () => resolve(img);
    	  })

    	  return result;

    	};

    	async function getCanvasBlob(canvas, percent) {
    	  const result = await new Promise((resolve) => {
    	    canvas.toBlob((blob) => {
    	      resolve(blob)
    	    }, 'image/jpeg', percent)
    	  });

    	  return result;
    	};

    	return await Backendless.Files.upload(newFile, path, true);


    })(50, 1, path, content2));
    newThumb = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newThumbnail')), 'fileURL'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = newThumb;
    ___arguments.context.appData['photo'] = newThumb;
    delete ___arguments.context.pageData['newCover'];
  }
  try {
    userProfile = (getObjectProperty(___arguments.context.pageData, 'userProfileId'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['media'] = (await asyncListSort((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')), -1, async (item) => {


     return ((getObjectProperty(item, 'isCover')) == true);
    }));
    var j_list = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      if ((getObjectProperty(j, 'file')).split('/')[0] == 'https:') {
        j['file'] = (String('/') + String(subsequenceFromEndLast((getObjectProperty(j, 'file')).split('/'), 2).join('/')));
      }
    }
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['aboutDetailed'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'aboutDetailed'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['aboutShort'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'aboutShort'));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['preferredGenderPronouns'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'preferredGenderPronouns')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'preferredGenderPronouns')).trim() : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'preferredGenderPronouns')));
    await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), ((function () { return window.location.href })()));
    if ((getObjectProperty(___arguments.context.pageData, 'toDelete')) && !!(getObjectProperty(___arguments.context.pageData, 'toDelete')).length) {
      var j_list2 = (getObjectProperty(___arguments.context.pageData, 'toDelete'));
      for (var j_index2 in j_list2) {
        j = j_list2[j_index2];
        ;(async () => {
            await Backendless.Files.remove(encodePath(j));

        })();
      }
      ___arguments.context.pageData['toDelete'] = [];
    }
    if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'name')) {
      name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'name')).trim();
    }
    await Backendless.Data.of('Users').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ [`name`]: name2,[`birthDate`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'birthDate')),[`gender`]: (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'gender')),[`photoThumbnail`]: (getObjectProperty(___arguments.context.pageData, 'newThumbnail')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newThumbnail')), 'fileURL')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) }) );
    ___arguments.context.appData['name'] = name2;
    try {
      if (getObjectProperty(___arguments.context.pageData, 'newThumbnail')) {
        ;(async () => {
            await Backendless.Files.remove(encodePath((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'photoThumbnail'))));

        })();
      }

    } catch (error) {
      console.log(error);

    }
    ___arguments.context.pageData['isModalSavedChangesOpen'] = true;
    (function (componentUid) { ___arguments.context.getComponentByUid(componentUid).reset() })('04ebf6abafcf4fe87097b24a6349841a');
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['name'] = name2;
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['birthDate'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'birthDate'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['gender'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'gender'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['height'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'height'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['userProfile'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['media'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['objectId'] = (getObjectProperty(___arguments.context.pageData, 'userProfileId'));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['center'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'locationGeoPoint'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = ((getObjectProperty(___arguments.context.pageData, 'newThumbnail')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newThumbnail')), 'fileURL')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')));
    ___arguments.context.appData['photo'] = ((getObjectProperty(___arguments.context.pageData, 'newThumbnail')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newThumbnail')), 'fileURL')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')));
    ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    delete ___arguments.context.appData['activityListAll'];
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    delete ___arguments.context.pageData['newThumbnail'];

  } catch (error) {
    console.log(error);

  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('6cf1c17c14ad4ee5be59806b9e55a535', false);
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['savingData'] = false;

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'nameChanged')) {
    if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'name')).trim()) < 2 || getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'name'))) > 25) {
      return true;
    }
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'aboutShortChanged')) {
    if (getValueLength((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'aboutShort')).trim()) < 15) {
      return true;
    }
  }
  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'savingData')) {
    return true;
  }

  return false

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/user-profile/components/dfa3b5cd8d5f10463b3606a74e84d663/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      return (['© ','',(new Date((new Date())).getFullYear()),' FindMyPlusOne - Made in USA, enjoyed world-wide. All Rights Reserved'].join(''))

  },  
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-profile/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onTitleAssignment */
  ['onTitleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'messagesNumber')) {
    return (['(',(getObjectProperty(___arguments.context.appData, 'messagesNumber')),') My account'].join(''));
  }

  return 'My account'

  },
  /* handler:onTitleAssignment */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ___arguments.context.pageData['isMainVisible'] = true;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    ___arguments.context.pageData['isMainBlVisible'] = true;
    ___arguments.context.pageData['isHeaderVisible'] = true;
    ___arguments.context.pageData['isFilterHeadingVisible'] = true;
    ___arguments.context.pageData['isAsideUserProfileVisible'] = true;
  } else {
    if (getObjectProperty(___arguments.context.pageData, 'isFromAccountPage')) {
      ___arguments.context.pageData['isHeaderVisible'] = false;
      ___arguments.context.pageData['isFilterHeadingVisible'] = false;
      ___arguments.context.pageData['isAsideUserProfileVisible'] = false;
      ___arguments.context.pageData['isMainBlVisible'] = true;
    } else {
      ___arguments.context.pageData['isHeaderVisible'] = true;
      ___arguments.context.pageData['isFilterHeadingVisible'] = true;
      ___arguments.context.pageData['isAsideUserProfileVisible'] = true;
      ___arguments.context.pageData['isMainBlVisible'] = false;
    }
  }
  await (async function() {
  	const url = new URL(document.location);
  	const searchParams = url.searchParams;
  	searchParams.delete("data");
  	window.history.pushState({}, '', url.toString());

  })();
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_userProfile_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* handler:onLeave */
  ['onLeave'](___arguments) {
    function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function getSubscriptionsManager(mapName) { const subs = getGlobalEntitiesMap(mapName);subs.map = subs.map || {};subs.has = subs.has || (subId => !!subs.map[subId]);subs.remove = subs.remove || (subId => { if (subs.map[subId]) { subs.map[subId](); delete subs.map[subId];} });subs.add = subs.add || ((subId, callback) => {    if (subs.map[subId]) { throw new Error(`Subscription with ID: "${subId}" already exists.`) }    subs.map[subId] = callback; });return subs;}

function getRTSubscriptions() { return getSubscriptionsManager('subscriptions');}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  getRTSubscriptions().remove('push');
  getRTSubscriptions().remove('likes');
  getRTSubscriptions().remove('messages');
  getRTSubscriptions().remove('chats');
  getRTSubscriptions().remove('chatsAccepted');
  getRTSubscriptions().remove('delete');
  getRTSubscriptions().remove('blockListAdd');
  getRTSubscriptions().remove('blockListDelete');
  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
  }
  ___arguments.context.appData['previousPage'] = 'user-profile';

  },
  /* handler:onLeave */
  /* handler:onResize */
  ['onResize'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) >= 768) {
    ___arguments.context.pageData['isMainBlVisible'] = true;
  }

  },
  /* handler:onResize */
  /* content */
}))

define('./pages/user-profile/components/c5cb3638ef34b114ef6b30e7cbc338ee/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  onBeforeMount(___arguments) {
      ___arguments.context.pageData['childrenList'] = [({ 'name': 'None','icon': '/images/speaker-low-volume.svg','value': -1 }), ({ 'name': '1','icon': '/images/performing-arts.svg','value': 1 }), ({ 'name': '2','icon': '/images/light-bulb.svg','value': 2 }), ({ 'name': 'More than 2','icon': '/images/person-standing.svg','value': 3 })];

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./pages/user-profile/components/5358302ba5557af8cf5f078c62735f1e/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  onDynamicItemsAssignment(___arguments) {
      if (___arguments.context.pageData['childrenList']) {
    return (___arguments.context.pageData['childrenList']);
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-profile/components/6a3cc7cb8e510573a024144a9eb8bfb6/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'children'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'children')) == (getObjectProperty(___arguments.context.dataModel, 'value'))) {
      return ['activity-page__quality-item', 'activity-page__quality-item-active'];
    }
  }

  return ['activity-page__quality-item']

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['children'] = (getObjectProperty(___arguments.context.dataModel, 'value'));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/2cbbe501b26acd7e846ee4069fd86d07/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'type')) == 'image')

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  await new Promise(r => setTimeout(r, 2000 || 0));
  if ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')) && (getObjectProperty(___arguments.context.pageData, 'check'))) {
    await (async function(data, list) {
    	if (data.check) {
    	  const draggables = document.querySelectorAll('.draggable')
    	  const containers = document.querySelectorAll('.userProfile__dropBl')

    	  draggables.forEach(draggable => {
    	    draggable.addEventListener('dragstart', () => {

    	      draggable.classList.add('dragging')
    	    })

    	    draggable.addEventListener('dragend', () => {
    	      draggable.classList.remove('dragging')
    	      const images = [...document.querySelectorAll('.draggable .userProfile__dropItemImg ')]

    	      const listNew = [...document.querySelectorAll('.draggable')]

    	      const media = images.map((image) => list.filter(item => item.file === image.src)[0])

    	      data.currentUser.media = media

    	    })

    	    draggable.addEventListener('touchstart', () => {
    	      setTimeout(function() {draggable.classList.add('dragging')}, 500)

    	    })

    	    draggable.addEventListener('touchend', () => {
    	      draggable.classList.remove('dragging')
    	      const images = [...document.querySelectorAll('.draggable .userProfile__dropItemImg ')]

    	      const media = images.map((image) => list.filter(item => item.file === image.src)[0])

    	     data.currentUser.media = media

    	    })
    	  })

    	  containers.forEach(container => {
    	    container.addEventListener('dragover', e => {
    	      e.preventDefault()
    	      const afterElement = getDragAfterElement(container, e.clientY)
    	      const draggable = document.querySelector('.dragging')
    	      if (draggable) {
    	        if (afterElement == null) {
    	          container.appendChild(draggable)
    	        } else {
    	          container.insertBefore(draggable, afterElement)
    	        }
    	      }
    	    })

    	    container.addEventListener('touchmove', event => {
    	      event.preventDefault()
    	      const afterElement = getDragAfterElementMobile(container, event.targetTouches[0].clientY)
    	      const draggable = document.querySelector('.dragging')
    	      if (draggable) {
    	        if (afterElement == null) {
    	          container.appendChild(draggable)
    	        } else {
    	          container.insertBefore(draggable, afterElement)
    	        }
    	      }
    	    })
    	  })

    	  function getDragAfterElement(container, y) {
    	    const draggableElements = [...container.querySelectorAll('.draggable:not(.dragging)')]

    	    return draggableElements.reduce((closest, child) => {
    	      const box = child.getBoundingClientRect()
    	      const offset = y - box.top - box.height / 1.25
    	    if (offset < 0 && offset > closest.offset) {
    	        return { offset: offset, element: child }
    	      } else {
    	        return closest
    	      }
    	    }, { offset: Number.NEGATIVE_INFINITY }).element
    	  }
    	}

    	  function getDragAfterElementMobile(container, y) {
    	    const draggableElements = [...container.querySelectorAll('.draggable:not(.dragging)')]

    	    return draggableElements.reduce((closest, child) => {
    	      const box = child.getBoundingClientRect()
    	      const offset = y - box.top - box.height / 1.5
    	    if (offset < 0 && offset > closest.offset) {
    	        return { offset: offset, element: child }
    	      } else {
    	        return closest
    	      }
    	    }, { offset: Number.NEGATIVE_INFINITY }).element
    	  }


    	data.check = false

    })(___arguments.context.pageData, ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('550e8ecdfeb40e56aa1aaebb7d949092')));
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/user-profile/components/2352c9b48ff9de0daf1ac8f69b5e42e9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.dataModel, 'type')) == 'video')

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  async ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'preloadCheck'))) {
    await new Promise(r => setTimeout(r, 1000 || 0));
    await (async function(data) {
    	let video = document.querySelectorAll('video')
    	// console.log(video)

    	video.forEach(item => {
    	  item.setAttribute('preload', 'metadata')
    	  item.setAttribute('buffered', 'true')
    	  // console.log(item)
    	})

    	data.preloadCheck = true
    })(___arguments.context.pageData);
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/user-profile/components/bfc220d618bd6f7467b3966fef18c736/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      ___arguments.context.getComponentDataStoreByUid('2352c9b48ff9de0daf1ac8f69b5e42e9')['isPrivate'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/user-profile/components/25f40974b8c1c742fda9b19a754cc144/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['smoke'] = (___arguments.value * 1);

  },
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'smokeList')) {
    return (await Promise.all((getObjectProperty(___arguments.context.appData, 'smokeList')).map(async item => {; return ({ 'label': (getObjectProperty(item, 'name')),'value': (getObjectProperty(item, 'id')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'smoke'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/2088bdcd38db42c6a028531e0f377258/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  onChange(___arguments) {
    var item;


  (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['newUserProfile'])['drink'] = (___arguments.value * 1);

  },  
  /* handler:onChange */
  /* handler:onOptionsAssignment */
  async ['onOptionsAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'drinkList')) {
    return (await Promise.all((getObjectProperty(___arguments.context.appData, 'drinkList')).map(async item => {; return ({ [`label`]: (getObjectProperty(item, 'name')),[`value`]: (getObjectProperty(item, 'id')) });})));
  }

  },
  /* handler:onOptionsAssignment */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    return (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'drink'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./pages/user-profile/components/1d7729ad621fc11f70a2a878e09cf224/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!((getObjectProperty(___arguments.context.pageData, 'accountPaused')) && !(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus'))))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/27e7c2be67cb3c0f171cf36fb8331c52/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var userObjectId, usersForUpdateChat, j, chats;


  ___arguments.context.pageData['modalPauseAccOpen'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/4e8a755b42451b274345b1215a9c2096/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['location'] = ___arguments.value;
  if (___arguments.value) {
    if (getObjectProperty(___arguments.context.pageData, 'deleteLocation')) {
      delete ___arguments.context.pageData['deleteLocation'];
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/user-profile/components/19d672357669e51ec8681a5683c56726/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['showPopup'];

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/6d8470ee42943bb635d2bbce7a7e2eb8/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.appData['showPopup'];
  if (getObjectProperty(___arguments.context.appData, 'getChat')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', ({ 'getChat': (getObjectProperty(___arguments.context.appData, 'getChat')) }));
  } else if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profile-page', ({ 'profileId': (getObjectProperty(___arguments.context.appData, 'senderId')) }));
  } else {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageBtn')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageBtn'));
  }

  return 'Read messages'

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./pages/user-profile/components/c89cf62d8178474edea919bd744e2869/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-profile/components/2bdfbf1c9ff3eccab8d5e0e6811c8503/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  console.log(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'));
  if (___arguments.value) {
    addItemToList((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'searchedInterests')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'searchedInterestsJson')), (getObjectProperty(___arguments.context.dataModel, 'objectId')));
  } else {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['searchedInterests'] = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'searchedInterests')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['searchedInterestsJson'] = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'searchedInterestsJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'searchedInterests')) {
      return (!!(await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'searchedInterests')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
      })).length);
    }
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/user-profile/components/bcae106f91aabae4b09e5989e6051b0b/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    
  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-profile/components/9dc41f0602c623dcda99ae03e22f488c/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async onChange(___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value) {
    addItemToList((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'myInterests')), ___arguments.context.dataModel);
    addItemToList((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'myInterestsJson')), (getObjectProperty(___arguments.context.dataModel, 'objectId')));
  } else {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['myInterests'] = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'myInterests')), async (item) => {


     return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['myInterestsJson'] = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'myInterestsJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'objectId')));
    }));
  }

  },
  /* handler:onChange */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) {
    if (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'myInterests')) {
      return (!!(await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'myInterests')), async (item) => {


       return ((getObjectProperty(item, 'objectId')) == (getObjectProperty(___arguments.context.dataModel, 'objectId')));
      })).length);
    }
  }

  },
  /* handler:onCheckedStateAssignment */
  /* content */
}))

define('./pages/user-profile/components/46491deb31bd63b154eaa5645e63bc7a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, mediaListWithoutCover, mediaListCover, item, newThumb, content2, path, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07'), 'isPrivate'))) {
    var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('550e8ecdfeb40e56aa1aaebb7d949092'));
    for (var j_index in j_list) {
      j = j_list[j_index];
      j['isCover'] = false;
    }
    ___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07')['isCover'] = true;
    ___arguments.context.pageData['newCover'] = true;
    ___arguments.context.appData['photo'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07'), 'file'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07'), 'file'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07'), 'file'));
    ___arguments.context.pageData['avatar'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07'), 'file'));
  }
  if (getObjectProperty(___arguments.context.pageData, 'newCover')) {
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = (getObjectProperty(___arguments.context.pageData, 'avatar'));
    if (((function () { return window.location.href })()) == 'file://' || ((function () { return window.location.href })()) == '' || ((function () { return window.location.href })()) != 'https://app.findmyplus.one/?page=user-profile' || ((function () { return window.location.href })()) != 'https://app.findmyplus.one/?page=user-profile&data=%7B%7D') {
      path = ['/pictures/thumbnails/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('');
      content2 = String('https://app.findmyplus.one/api/files/') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')).split('/'), 2).join('/'));
    } else {
      path = String('/pictures/thumbnails/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
      content2 = String('/api/files/') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')).split('/'), 2).join('/'));
    }
    ___arguments.context.pageData['newThumbnail'] = (await (async function(width, percent, path, content) {

    	  const img = await getNewImage(content);

    	  const elem = document.createElement('canvas');

    	  const widthImage = !width ? img.width : width;
    	  const scaleFactor = width && width / img.width;
    	  const heightImage = width ? img.height * scaleFactor : img.height;

    	  elem.width = widthImage;
    	  elem.height = heightImage;

    	  const ctx = elem.getContext('2d');

    	  ctx.drawImage(img, 0, 0, widthImage, heightImage);

    	 const blob = await getCanvasBlob(ctx.canvas, percent);

    	  const newFile = new File([blob], 'photo'+ Date.now()+ '.jpeg', {
    	    type: 'image/jpeg',
    	    lastModified: Date.now()
    	  });


    	  // const {fileUrl} = await Backendless.Files.upload(newFile, path, true)


    	async function getNewImage(content) {
    	  const result = await new Promise((resolve) => {
    	    const img = new Image();

    	    img.crossOrigin = "Anonymous";
    	    img.src = content;
    	    img.onload = () => resolve(img);
    	  })

    	  return result;

    	};

    	async function getCanvasBlob(canvas, percent) {
    	  const result = await new Promise((resolve) => {
    	    canvas.toBlob((blob) => {
    	      resolve(blob)
    	    }, 'image/jpeg', percent)
    	  });

    	  return result;
    	};

    	return await Backendless.Files.upload(newFile, path, true);


    })(50, 1, path, content2));
    newThumb = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newThumbnail')), 'fileURL'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = newThumb;
    ___arguments.context.appData['photo'] = newThumb;
    delete ___arguments.context.pageData['newCover'];
    mediaListWithoutCover = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')), async (item) => {


     return (!(getObjectProperty(item, 'isCover')));
    }));
    mediaListCover = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')), async (item) => {


     return (getObjectProperty(item, 'isCover'));
    }));
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['media'] = (mediaListCover.concat(mediaListWithoutCover));
    await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), ((function () { return window.location.href })()));
    await Backendless.Data.of('Users').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ [`photoThumbnail`]: (getObjectProperty(___arguments.context.pageData, 'newThumbnail')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newThumbnail')), 'fileURL')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) }) );
    try {
      if (getObjectProperty(___arguments.context.pageData, 'newThumbnail')) {
        ;(async () => {
            await Backendless.Files.remove(encodePath((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'photoThumbnail'))));

        })();
      }

    } catch (error) {
      console.log(error);

    }
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = ((getObjectProperty(___arguments.context.pageData, 'newThumbnail')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newThumbnail')), 'fileURL')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')));
    ___arguments.context.appData['photo'] = ((getObjectProperty(___arguments.context.pageData, 'newThumbnail')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newThumbnail')), 'fileURL')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    delete ___arguments.context.pageData['newThumbnail'];
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/298db46fc0a14ed46c4f649729d51013/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceAssignment */
  async ['onSourceAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (!(getObjectProperty(___arguments.context.pageData, 'preloadCheck'))) {
    await (async function(data) {
    	let video = document.querySelectorAll('video')

    	video.forEach(item => {
    	  item.setAttribute('preload', 'metadata')
    	  item.setAttribute('buffered', 'true')
    	  // console.log(item)
    	})

    	data.preloadCheck = true
    })(___arguments.context.pageData);
  }

  return (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2352c9b48ff9de0daf1ac8f69b5e42e9'), 'file'))

  },
  /* handler:onSourceAssignment */
  /* content */
}))

define('./pages/user-profile/components/0466a67383220c7d4dd8a10e3e263665/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, preferredGenderPronouns;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}


  if (___arguments.value) {
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['isGenderCustomDisabled'] = false;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c10783145c5374c9aa211cd1079c07c9'))['opacity'] = '1';
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['preferredGenderPronouns'] = ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'preferredGenderPronouns')) ? (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'preferredGenderPronouns')).trim() : (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'preferredGenderPronouns')));
  } else {
    stopSetTimeout('saveGenderPronouns');
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['isGenderCustomDisabled'] = true;
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c10783145c5374c9aa211cd1079c07c9'))['opacity'] = '.5';
    preferredGenderPronouns = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'preferredGenderPronouns'));
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['preferredGenderPronouns'] = '';
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['preferredGenderPronouns'] = '';
    if (preferredGenderPronouns && !!preferredGenderPronouns.trim().length) {
      console.log('save gender pronoun checkbox');
      await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), ((function () { return window.location.href })()));
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['preferredGenderPronouns'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'preferredGenderPronouns'));
      localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
      try {
        await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('profile_edited');

      } catch (error) {
        console.log(error);

      }
    }
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/user-profile/components/5bd93e85421a2f89d3cd25f4231b9ff9/bundle.js', [], () => ({
  /* content */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) && !(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'preferredGenderPronouns'))) {
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('c10783145c5374c9aa211cd1079c07c9'))['opacity'] = '.4';
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./pages/user-profile/components/6d048dd54d3155be12eebd696e94d91c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    try {
      await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('REQUEST_CAMERA_PERMISSIONS', undefined);
      await (async function() {
      	const btn = document.querySelector('.upload__btn')

      	btn.click()
      })();
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6d048dd54d3155be12eebd696e94d91c')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6d048dd54d3155be12eebd696e94d91c')), 'hidden');
      }

    } catch (error) {
      console.log(error);
      await (async function() {
      	const btn = document.querySelector('.upload__btn')

      	btn.click()
      })();
      if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6d048dd54d3155be12eebd696e94d91c')) {
        addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6d048dd54d3155be12eebd696e94d91c')), 'hidden');
      }

    }
  } else {
    await (async function() {
    	const btn = document.querySelector('.upload__btn')

    	btn.click()
    })();
    if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('6d048dd54d3155be12eebd696e94d91c')) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('6d048dd54d3155be12eebd696e94d91c')), 'hidden');
    }
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 992) {
    return true;
  }

  return false

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/ca7c264f527a93b59b231d812b12b724/bundle.js', [], () => ({
  /* content */
  /* handler:onDynamicItemsAssignment */
  ['onDynamicItemsAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'dietaryList')) {
    return (getObjectProperty(___arguments.context.appData, 'dietaryList'));
  }

  },
  /* handler:onDynamicItemsAssignment */
  /* content */
}))

define('./pages/user-profile/components/2d72496211fae3daad17e4d404d546a9/bundle.js', [], () => ({
  /* content */
  /* handler:onCheckedStateAssignment */
  async ['onCheckedStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  await new Promise(r => setTimeout(r, 100 || 0));
  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'dietaryPreferenceJson'))) {
    return (!!(await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'dietaryPreferenceJson')), async (item) => {


     return (item == (getObjectProperty(___arguments.context.dataModel, 'id')));
    })).length);
  }

  },
  /* handler:onCheckedStateAssignment */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.value) {
    addItemToList((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'dietaryPreferenceJson')), (getObjectProperty(___arguments.context.dataModel, 'id')));
  } else {
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['dietaryPreferenceJson'] = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'dietaryPreferenceJson')), async (item) => {


     return (item != (getObjectProperty(___arguments.context.dataModel, 'id')));
    }));
  }
  console.log(getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'dietaryPreferenceJson'));

  },
  /* handler:onChange */
  /* handler:onDisabledStateAssignment */
  async ['onDisabledStateAssignment'](___arguments) {
    var item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if (___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')) && (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'dietaryPreferenceJson'))) {
    return ((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'dietaryPreferenceJson')).length >= 3 && !(await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'dietaryPreferenceJson')), async (item) => {


     return (item == (getObjectProperty(___arguments.context.dataModel, 'id')));
    })).length);
  }

  return false

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/user-profile/components/8deaa95ffdf4e83fcc4189235ee4c7bc/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'accountPaused')) && !(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/f64e76d36d2d2cee6b2698b7d2c568db/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'showPopup')) && (getObjectProperty(___arguments.context.appData, 'newMessageText'))) {
    return ['modalNewMessage', 'open'];
  }

  return ['modalNewMessage']

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./pages/user-profile/components/bfa88cf9b43d945fcca68edcf3045ae4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'newMessageText')) {
    return (getObjectProperty(___arguments.context.appData, 'newMessageText'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./pages/user-profile/components/08a4fca887d723b91cc10043ce77d7b4/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error, name2;

function getValueLength(value) {
 if (typeof value === 'number') {
   value = `${ value }`
 }

 return value.length
}

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}

/**
 * Describe this function...
 */
async function saveData() {
  stopSetTimeout('saveUserName');

  ;(function() {
    const callback = async () => {
        if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'name')) {
      name2 = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'name')).trim();
    }
    await Backendless.Data.of('Users').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ [`name`]: name2 }) );
    ___arguments.context.appData['name'] = name2;
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['name'] = name2;
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['nameLogin'] = name2;
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    try {
      await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('profile_edited');

    } catch (error) {
      console.log(error);

    }

    };

    const timerId = 'saveUserName';
    const timerDelay = 750;

    runSetTimeout(timerId, callback, timerDelay)
  })()
}


  if (getValueLength(___arguments.value) > 25) {
    stopSetTimeout('saveUserName');
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('08a4fca887d723b91cc10043ce77d7b4')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('08a4fca887d723b91cc10043ce77d7b4')), 'alert-border');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['errorMmessageName'] = 'Maximum 25 characters';
  } else if (getValueLength(___arguments.value.trim()) < 2) {
    stopSetTimeout('saveUserName');
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('08a4fca887d723b91cc10043ce77d7b4')).includes('alert-border'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('08a4fca887d723b91cc10043ce77d7b4')), 'alert-border');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['errorMmessageName'] = 'Minimum 2 characters';
  } else {
    if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('08a4fca887d723b91cc10043ce77d7b4')).includes('alert-border')) {
      removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('08a4fca887d723b91cc10043ce77d7b4')), 'alert-border', '');
    }
    ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['errorMmessageName'] = '';
    await saveData();
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/user-profile/components/c10783145c5374c9aa211cd1079c07c9/bundle.js', [], () => ({
  /* content */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 300 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0466a67383220c7d4dd8a10e3e263665')));
  }

  },
  /* handler:onFocus */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  if (!!___arguments.value.trim().length || !___arguments.value.length) {
    stopSetTimeout('saveGenderPronouns');

    ;(function() {
      const callback = async () => {
          console.log('save gender pronoun');
      (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['preferredGenderPronouns'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'preferredGenderPronouns'));
      await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), ((function () { return window.location.href })()));
      (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['preferredGenderPronouns'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'preferredGenderPronouns'));
      localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
      try {
        await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('profile_edited');

      } catch (error) {
        console.log(error);

      }

      };

      const timerId = 'saveGenderPronouns';
      const timerDelay = 500;

      runSetTimeout(timerId, callback, timerDelay)
    })()
  } else {
    stopSetTimeout('saveGenderPronouns');
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/user-profile/components/dc659585a5ffb1e7267abffe71a31f7e/bundle.js', [], () => ({
  /* content */
  /* handler:onFocus */
  async ['onFocus'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    await new Promise(r => setTimeout(r, 300 || 0));
    (function (component) { component.el.scrollIntoView() })(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('73ff53b8469ea262363bb127e1f8c9b3')));
  }

  },
  /* handler:onFocus */
  /* handler:onChange */
  async ['onChange'](___arguments) {
    var error;

function defineGlobalScope() { const root = (typeof window !== 'undefined' ? window : global);root.codelessScope = root.codelessScope || {};return root.codelessScope;}

function getGlobalEntitiesMap(mapName) { const globalScope = defineGlobalScope();return globalScope[mapName] = globalScope[mapName] || {};}

function stopSetTimeout(timerId) {  const timers = getGlobalEntitiesMap('setTimeouts'); if (timerId && timers[timerId]) {    clearTimeout(timers[timerId]);    delete timers[timerId]; }}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function runSetTimeout(timerId, callback, delay) {  const timers = getGlobalEntitiesMap('setTimeouts'); const timer = setTimeout(callback, delay); if (timerId) {  stopSetTimeout(timerId);  timers[timerId] = timer }}


  stopSetTimeout('saveAboutLong');

  ;(function() {
    const callback = async () => {
        (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['aboutDetailed'] = (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'aboutDetailed'));
    await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), ((function () { return window.location.href })()));
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['aboutDetailed'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'aboutDetailed'));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    try {
      await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('profile_edited');

    } catch (error) {
      console.log(error);

    }

    };

    const timerId = 'saveAboutLong';
    const timerDelay = 750;

    runSetTimeout(timerId, callback, timerDelay)
  })()

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/user-profile/components/903655233b142426e2e9d54bd9e1e796/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalLogoutOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/43b3290d018ba716e2f9311dc6d2e348/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalShareOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/3f58581540d5425e248d8405435b1eec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.appData['countOffset'];
  delete ___arguments.context.appData['activitiesSearch'];
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isMissYouVisible')) && (getObjectProperty(___arguments.context.pageData, 'isAsideUserProfileVisible')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/1e08c73446711152b9a25f1c19b73768/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['accountPaused'] = false;
  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    ___arguments.context.pageData['isAsideUserProfileVisible'] = false;
    ___arguments.context.pageData['isFilterHeadingVisible'] = false;
    ___arguments.context.pageData['isMainBlVisible'] = true;
    ___arguments.context.pageData['isHeaderVisible'] = false;
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/2236598ee07cca763515332a6a0da4ec/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings', undefined);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'profileStatus')) {
    if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
      return false;
    } else {
      return true;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == false) {
      return false;
    } else {
      return true;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/f98e1d161f2222c94eeaa8b9f7f40c2d/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    return false;
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['isAsideUserProfileVisible'] = true;
  ___arguments.context.pageData['isFilterHeadingVisible'] = true;
  ___arguments.context.pageData['isMainBlVisible'] = false;
  ___arguments.context.pageData['isHeaderVisible'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/34aab0bd6f5132620eba91739c21680a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var newThumb, error, content2, path, item, j, filteredList;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

async function asyncListFind(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  return list.find(item => item.value)?.source || null
}

function subsequenceFromEndLast(sequence, at1) {
  var start = sequence.length - 1 - at1;
  var end = sequence.length - 1 + 1;
  return sequence.slice(start, end);
}


  ___arguments.context.pageData['toDelete'] = [];
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'media')).length > 0) {
    filteredList = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')), async (item) => {


     return ((getObjectProperty(item, 'file')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07'), 'file')));
    }));
    if (getObjectProperty(___arguments.context.pageData, 'toDelete')) {
      addItemToList((getObjectProperty(___arguments.context.pageData, 'toDelete')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07'), 'file')));
    }
    (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['media'] = filteredList;
    if (!(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'userNameMedia'))) {
      if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')).includes('.')) {
        ___arguments.context.pageData['userNameMedia'] = ((await asyncListFilter(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')).split('')), async (item) => {


         return (item != '.');
        })).join(''));
      } else {
        ___arguments.context.pageData['userNameMedia'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
      }
    }
    await (async function(path, mediaList) {
    	async function resizeImage(files, width, percent) {
    	  for (let index = 0; index < files.length; index++) {
    	    const file = files[index];
    	    if (file.type.includes('image')) {
    	      const fileName = file.name
    	      const content = await readFileAsDataURL(file)

    	      const img = await getNewImage(content)

    	      const elem = document.createElement('canvas')

    	      const widthImage = !width ? img.width : width
    	      const scaleFactor = width && width / img.width
    	      const heightImage = width ? img.height * scaleFactor : img.height

    	      elem.width = widthImage
    	      elem.height = heightImage

    	      const ctx = elem.getContext('2d')

    	      ctx.drawImage(img, 0, 0, widthImage, heightImage)

    	      const blob = await getCanvasBlob(ctx.canvas, percent)

    	      const newFile = new File([blob], fileName, {
    	        type: 'image/jpeg',
    	        lastModified: Date.now()
    	      })

    	      files[index] = newFile
    	    }

    	    async function readFileAsDataURL(file) {
    	      const result = await new Promise((resolve) => {
    	        const fileReader = new FileReader()

    	        fileReader.onload = (e) => resolve(e.target.result)

    	        fileReader.readAsDataURL(file)
    	      })

    	      return result
    	    }

    	    async function getNewImage(content) {
    	      const result = await new Promise((resolve) => {
    	        const img = new Image()

    	        img.src = content

    	        img.onload = () => resolve(img)
    	      })

    	      return result
    	    }

    	    async function getCanvasBlob(canvas, percent) {
    	      const result = await new Promise((resolve) => {
    	        canvas.toBlob((blob) => {
    	          resolve(blob)
    	        }, 'image/jpeg', percent)
    	      })

    	      return result
    	    }
    	  }
    	  uploadFile(files);
    	}

    	const dropArea = document.querySelector('.upload__btn');
    	dropArea.removeEventListener('drop', dragAndDropFunc);

    	  dropArea.addEventListener("dragover", (event) => {
    	    event.preventDefault();
    	    dropArea.classList.add('active');
    	  });

    	  dropArea.addEventListener("dragleave", () => {
    	    dropArea.classList.remove('active');
    	  });


    	  function uploadFile(files) {
    	    files.forEach((file) => {
    	      if (file.type.includes('image')) {
    	        Backendless.Files.upload(file, path, overwrite = true)
    	       .then(async function(fileURL) {
    	          let media = {
    	            file: fileURL.fileURL,
    	            type: 'image',
    	            isPrivate: false
    	          };
    	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', true);
    	          let moderationResult =  await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileURL.fileURL) }).send();
    	         if (moderationResult == 'OK') {
    	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', false);
    	            mediaList.push(media);
    	         } else {
    	           await Backendless.Files.remove(fileURL.fileURL);
    	           (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('0e03a68310cbad155bf9b23c41ef1324', false);
    	           (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('f51aa52ccaef96dd73c868889425adfc', ({ 'showRejectMsg': true }));
    	         };
    	        })
    	       .catch( function( error ) {
    	         console.log(error)
    	        })
    	      } else if (file.type.includes('video')) {
    	        Backendless.Files.upload(file, path, overwrite = true)
    	       .then(function(fileURL) {
    	         let media = {
    	            file: fileURL.fileURL,
    	            type: 'video',
    	            isPrivate: false
    	          }
    	          mediaList.push(media);
    	        })
    	       .catch( function( error ) {
    	         console.log(error)
    	        })
    	      }
    	    })
    	    return mediaList;
    	  }

    	  dragAndDropFunc = function(event) {
    	    event.preventDefault();
    	    let files = event.dataTransfer.files;
    	    resizeImage([...files], 700, 80)
    	    dropArea.classList.remove('active');
    	  }

    	  dropArea.addEventListener("drop", dragAndDropFunc);


    })((String('/pictures/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'userNameMedia'))), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')));
    if (!(await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')), async (item) => {


     return (getObjectProperty(item, 'isCover'));
    })).length) {
      var j_list = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media'));
      for (var j_index in j_list) {
        j = j_list[j_index];
        if (!(getObjectProperty(j, 'isPrivate'))) {
          j['isCover'] = true;
          break;
        }
      }
    }
  }
  if ((getObjectProperty(___arguments.context.pageData, 'toDelete')) && !!(getObjectProperty(___arguments.context.pageData, 'toDelete')).length) {
    var j_list2 = (getObjectProperty(___arguments.context.pageData, 'toDelete'));
    for (var j_index2 in j_list2) {
      j = j_list2[j_index2];
      ;(async () => {
          await Backendless.Files.remove(encodePath(j));

      })();
    }
    ___arguments.context.pageData['toDelete'] = [];
    (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['media'] = (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = (getObjectProperty((await asyncListFind((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')), async (item) => {


     return (getObjectProperty(item, 'isCover'));
    })), 'file'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
    ___arguments.context.pageData['avatar'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail'));
    if (((function () { return window.location.href })()) == 'file://' || ((function () { return window.location.href })()) == '' || ((function () { return window.location.href })()) != 'https://app.findmyplus.one/?page=user-profile' || ((function () { return window.location.href })()) != 'https://app.findmyplus.one/?page=user-profile&data=%7B%7D') {
      path = ['/pictures/thumbnails/',(getObjectProperty(___arguments.context.pageData, 'userNameMedia')),'/'].join('');
      content2 = String('https://app.findmyplus.one/api/files/') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')).split('/'), 2).join('/'));
    } else {
      path = String('/pictures/thumbnails/') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'));
      content2 = String('/api/files/') + String(subsequenceFromEndLast((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')).split('/'), 2).join('/'));
    }
    ___arguments.context.pageData['newThumbnail'] = (await (async function(width, percent, path, content) {

    	  const img = await getNewImage(content);

    	  const elem = document.createElement('canvas');

    	  const widthImage = !width ? img.width : width;
    	  const scaleFactor = width && width / img.width;
    	  const heightImage = width ? img.height * scaleFactor : img.height;

    	  elem.width = widthImage;
    	  elem.height = heightImage;

    	  const ctx = elem.getContext('2d');

    	  ctx.drawImage(img, 0, 0, widthImage, heightImage);

    	 const blob = await getCanvasBlob(ctx.canvas, percent);

    	  const newFile = new File([blob], 'photo'+ Date.now()+ '.jpeg', {
    	    type: 'image/jpeg',
    	    lastModified: Date.now()
    	  });


    	  // const {fileUrl} = await Backendless.Files.upload(newFile, path, true)


    	async function getNewImage(content) {
    	  const result = await new Promise((resolve) => {
    	    const img = new Image();

    	    img.crossOrigin = "Anonymous";
    	    img.src = content;
    	    img.onload = () => resolve(img);
    	  })

    	  return result;

    	};

    	async function getCanvasBlob(canvas, percent) {
    	  const result = await new Promise((resolve) => {
    	    canvas.toBlob((blob) => {
    	      resolve(blob)
    	    }, 'image/jpeg', percent)
    	  });

    	  return result;
    	};

    	return await Backendless.Files.upload(newFile, path, true);


    })(50, 1, path, content2));
    newThumb = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'newThumbnail')), 'fileURL'));
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = newThumb;
    ___arguments.context.appData['photo'] = newThumb;
    await BackendlessUI.Functions.Custom['fn_a981d7d7f97db90c49ec67e3b7d11474']((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), ((function () { return window.location.href })()));
    await Backendless.Data.of('Users').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ [`photoThumbnail`]: (getObjectProperty(___arguments.context.pageData, 'newThumbnail')) ? newThumb : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')) }) );
    try {
      if (getObjectProperty(___arguments.context.pageData, 'newThumbnail')) {
        ;(async () => {
            await Backendless.Files.remove(encodePath((getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'photoThumbnail'))));

        })();
      }

    } catch (error) {
      console.log(error);

    }
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = ((getObjectProperty(___arguments.context.pageData, 'newThumbnail')) ? newThumb : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')));
    ___arguments.context.appData['photo'] = ((getObjectProperty(___arguments.context.pageData, 'newThumbnail')) ? newThumb : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photoThumbnail')));
    localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
    delete ___arguments.context.pageData['newThumbnail'];
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('profile_edited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  async ['onDisplayAssignment'](___arguments) {
    var notPrivatePhotosLeft, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  notPrivatePhotosLeft = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('550e8ecdfeb40e56aa1aaebb7d949092')).length - (await asyncListFilter(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('550e8ecdfeb40e56aa1aaebb7d949092')), async (item) => {


   return (getObjectProperty(item, 'isPrivate'));
  })).length;
  if (___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07')) {
    if (notPrivatePhotosLeft == 1 && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07'), 'isCover'))) {
      return false;
    } else {
      return true;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/3691cc6fe8087389e30246f950eb9dc6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07') && (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2cbbe501b26acd7e846ee4069fd86d07'), 'isCover')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/f691c7231866a83c00eca1290b38f3f1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var filteredList, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  filteredList = (await asyncListFilter((getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')), async (item) => {


   return ((getObjectProperty(item, 'file')) != (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2352c9b48ff9de0daf1ac8f69b5e42e9'), 'file')));
  }));
  addItemToList((getObjectProperty(___arguments.context.pageData, 'toDelete')), (getObjectProperty(___arguments.context.getComponentDataStoreByUid('2352c9b48ff9de0daf1ac8f69b5e42e9'), 'file')));
  (getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile'))['media'] = filteredList;
  await (async function(path, mediaList) {
  	async function resizeImage(files, width, percent) {
  	  for (let index = 0; index < files.length; index++) {
  	    const file = files[index];
  	    if (file.type.includes('image')) {
  	      const fileName = file.name
  	      const content = await readFileAsDataURL(file)

  	      const img = await getNewImage(content)

  	      const elem = document.createElement('canvas')

  	      const widthImage = !width ? img.width : width
  	      const scaleFactor = width && width / img.width
  	      const heightImage = width ? img.height * scaleFactor : img.height

  	      elem.width = widthImage
  	      elem.height = heightImage

  	      const ctx = elem.getContext('2d')

  	      ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	      const blob = await getCanvasBlob(ctx.canvas, percent)

  	      const newFile = new File([blob], fileName, {
  	        type: 'image/jpeg',
  	        lastModified: Date.now()
  	      })

  	      files[index] = newFile
  	    }

  	    async function readFileAsDataURL(file) {
  	      const result = await new Promise((resolve) => {
  	        const fileReader = new FileReader()

  	        fileReader.onload = (e) => resolve(e.target.result)

  	        fileReader.readAsDataURL(file)
  	      })

  	      return result
  	    }

  	    async function getNewImage(content) {
  	      const result = await new Promise((resolve) => {
  	        const img = new Image()

  	        img.src = content

  	        img.onload = () => resolve(img)
  	      })

  	      return result
  	    }

  	    async function getCanvasBlob(canvas, percent) {
  	      const result = await new Promise((resolve) => {
  	        canvas.toBlob((blob) => {
  	          resolve(blob)
  	        }, 'image/jpeg', percent)
  	      })

  	      return result
  	    }
  	  }
  	  uploadFile(files);
  	}

  	const dropArea = document.querySelector('.content__upload-button');

  	  dropArea.addEventListener("dragover", (event) => {
  	    event.preventDefault();
  	    dropArea.classList.add('active');
  	  });

  	  dropArea.addEventListener("dragleave", () => {
  	    dropArea.classList.remove('active');
  	  });


  	  function uploadFile(files) {
  	    files.forEach((file) => {
  	      if (file.type.includes('image')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	       .then(function(fileURL) {
  	          let media = {
  	            file: fileURL.fileURL,
  	            type: 'image',
  	            isPrivate: false
  	          }
  	          mediaList.push(media);
  	        })
  	       .catch( function( error ) {
  	         console.log(error)
  	        })
  	      } else if (file.type.includes('video')) {
  	        Backendless.Files.upload(file, path, overwrite = true)
  	       .then(function(fileURL) {
  	         let media = {
  	            file: fileURL.fileURL,
  	            type: 'video',
  	            isPrivate: false
  	          }
  	          mediaList.push(media);
  	        })
  	       .catch( function( error ) {
  	         console.log(error)
  	        })
  	      }
  	    })
  	    return mediaList;
  	  }


  	  dropArea.addEventListener("drop", (event) => {
  	    event.preventDefault();
  	    let files = event.dataTransfer.files;
  	    resizeImage([...files], 700, 80)
  	    dropArea.classList.remove('active');
  	  });


  })((String('/pictures/') + String(getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'login'))), (getObjectProperty((getObjectProperty(___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53'), 'newUserProfile')), 'media')));

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/c89c25fd043a7b3bafd9d32f6004ebde/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
    if ((getObjectProperty(___arguments.context.pageData, 'accountPaused')) && !(getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus'))) {
      return false;
    } else {
      if (getObjectProperty(___arguments.context.pageData, 'isAsideUserProfileVisible')) {
        return true;
      }
    }
  } else {
    return true;
  }

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/bcc2b581871a6b79de66688af1fedeb9/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalPauseAccOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/8342cffc34d610bdcfebda544d1fd7e8/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'modalDeleteAccOpen'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./pages/user-profile/components/765faeba7df5135deb798d79bac44caa/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    var currentUser;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  currentUser = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['name'] = (getObjectProperty(currentUser, 'name'));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['aboutDetailed'] = (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'aboutDetailed'));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['aboutShort'] = (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'aboutShort'));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['gender'] = (getObjectProperty(currentUser, 'gender'));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['preferredGenderPronouns'] = (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'preferredGenderPronouns'));
  ___arguments.context.getComponentDataStoreByUid('c4d360f9584d8828b116ff1ee133ba53')['height'] = null;

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-profile/components/56445eba75e6e43fcfe4cb47c0968d72/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  ___arguments.context.pageData['accountPaused'] = false;
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c4d360f9584d8828b116ff1ee133ba53')), 'open', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-report/components/page/bundle.js', [], () => ({
  /* content */
  /* handler:onEnter */
  async ['onEnter'](___arguments) {
    var error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1d3b58f6d2c8b12b2c5a7319467743b8'))['display'] = 'flex';
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    ___arguments.context.appData['currentUser'] = (await BackendlessUI.Functions.Custom['fn_c3e522be76839721882205a107595563'](((function () { return window.location.href })())));
  }
  if (!(getObjectProperty(___arguments.context.appData, 'currentUser'))) {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);
    return ;
  }
  ___arguments.context.pageData['currentUser'] = (getObjectProperty(___arguments.context.appData, 'currentUser'));
  ___arguments.context.pageData['btnReport'] = 'Report';
  ___arguments.context.pageData['btnBlock'] = 'Report and block forever';
  try {
    ___arguments.context.pageData['violationTypes'] = (await Backendless.Data.of('violationType').find(Backendless.DataQueryBuilder.create().setSortBy('violationType').setPageSize(100)));
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('1d3b58f6d2c8b12b2c5a7319467743b8'))['display'] = 'none';

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }
  try {
    ;(async () => {
        if (!(getObjectProperty(___arguments.context.appData, 'chats'))) {
        ___arguments.context.appData['chats'] = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
      }
      if (!(getObjectProperty(___arguments.context.appData, 'chatList'))) {
        ___arguments.context.appData['chatList'] = (await Backendless.Request.get(`${Backendless.appPath}/services/chatId/chatId`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
        await BackendlessUI.Functions.Custom['fn_25e577c7a55ec13aac55c1b782dc57ca'](___arguments.context.appData);
      }
      await BackendlessUI.Functions.Custom['fn_6bf75c3392372ebb595566f4a75ca2b3'](___arguments.context.pageData, null, ___arguments.context.appData);

    })();

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));

  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('page_userReport_visited');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onEnter */
  /* content */
}))

define('./pages/user-report/components/b36db7933828619875e9cced4425b472/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
    var j;


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9adda9f1890ee60a58c3f2744d552e8b'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    j['checkedValue'] = false;
  }
  ___arguments.context.dataModel['checkedValue'] = ___arguments.value;

  },
  /* handler:onChange */
  /* content */
}))

define('./pages/user-report/components/decfcfc2e7834cacb07400c24ea96a96/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, violationType, j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  ___arguments.context.pageData['btnReport'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('09421aef0e189208d4ec16c59c13cd57'))['display'] = 'flex';
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9adda9f1890ee60a58c3f2744d552e8b'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'checkedValue')) {
      violationType = (getObjectProperty(j, 'checkedValue'));
    }
  }
  try {
    await Backendless.Request.post(`${Backendless.appPath}/services/userReport/createUserReport`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'source': ((getObjectProperty(___arguments.context.pageData, 'source')) == 'Chat' ? 'sourceChat' : 'sourceProfile'),'violatorId': (getObjectProperty(___arguments.context.pageData, 'violatorId')),'violationType': violationType,'itemId': (getObjectProperty(___arguments.context.pageData, 'itemId')) });
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('5b6e52683c8955849131d812155fe25e', ({ 'onlyReport': true,'source': (getObjectProperty(___arguments.context.pageData, 'source')) }));
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b6e52683c8955849131d812155fe25e')), 'open');

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));
    ___arguments.context.pageData['btnReport'] = 'Report';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('09421aef0e189208d4ec16c59c13cd57'))['display'] = 'none';

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9adda9f1890ee60a58c3f2744d552e8b'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(___arguments.context.pageData, 'btnReport')) && (getObjectProperty(j, 'checkedValue'))) {
      return false;
    }
  }
  return true;

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/user-report/components/2fd6820d9ff8ad6c42010d15b7a5d163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, violationType, j, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}

/**
 * Describe this function...
 */
async function block_user() {
  ___arguments.context.appData['currentUser'] = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))) {
    if (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) {
      if (!((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')).includes((getObjectProperty(___arguments.context.pageData, 'violatorId'))))) {
        addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList')), ({ [`objectId`]: (getObjectProperty(___arguments.context.pageData, 'violatorId')) }));
        addItemToList((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')), (getObjectProperty(___arguments.context.pageData, 'violatorId')));
        await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': ([String(['sender.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'violatorId')),'\''].join('')) + String([' and receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')),' or ',String(['sender.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) + String([' and receiver.objectId=\'',(getObjectProperty(___arguments.context.pageData, 'violatorId')),'\''].join(''))].join('')),'changes': ({ [`isBlocked`]: true }) });
        await Backendless.Data.of('UserProfile').addRelation((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList', [(getObjectProperty(___arguments.context.pageData, 'violatorId'))]);
        if (getObjectProperty(___arguments.context.appData, 'activityList')) {
          delete ___arguments.context.appData['activityList'];
        }
        if (getObjectProperty(___arguments.context.appData, 'users')) {
          delete ___arguments.context.appData['users'];
        }
        if (getObjectProperty(___arguments.context.appData, 'seenBy')) {
          ___arguments.context.appData['seenBy'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'seenBy')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'violatorId')));
          }));
        }
        if (getObjectProperty(___arguments.context.appData, 'myLikes')) {
          ___arguments.context.appData['myLikes'] = (await asyncListFilter((getObjectProperty(___arguments.context.appData, 'myLikes')), async (item) => {


           return ((getObjectProperty(item, 'objectId')) != (getObjectProperty(___arguments.context.pageData, 'violatorId')));
          }));
        }
      }
    }
  }
  await Backendless.Data.of('UserProfile').bulkUpdate( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ [`blockListJson`]: (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) ? (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson')) : [] }) );
  delete ___arguments.context.appData['chats'];
  delete ___arguments.context.appData['activityMessages'];
  delete ___arguments.context.pageData['chats'];
  delete ___arguments.context.pageData['receivedChats'];
  delete ___arguments.context.appData['receivedChats'];
  delete ___arguments.context.pageData['activityMessages'];
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile'))['blockListJson'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockListJson'));
  (getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile'))['blockList'] = (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'blockList'));
  ___arguments.context.appData['chats'] = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
  ;(async () => {
      await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('blockUser', (getObjectProperty(___arguments.context.pageData, 'violatorId')), (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), null, null);

  })();
}


  ___arguments.context.pageData['btnBlock'] = '';
  ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('18ecab0593f93229b50af3fb766269da'))['display'] = 'flex';
  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9adda9f1890ee60a58c3f2744d552e8b'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if (getObjectProperty(j, 'checkedValue')) {
      violationType = (getObjectProperty(j, 'checkedValue'));
    }
  }
  try {
    await Backendless.Request.post(`${Backendless.appPath}/services/userReport/createUserReport`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'source': ((getObjectProperty(___arguments.context.pageData, 'source')) == 'Chat' ? 'sourceChat' : 'sourceProfile'),'violatorId': (getObjectProperty(___arguments.context.pageData, 'violatorId')),'violationType': violationType,'itemId': (getObjectProperty(___arguments.context.pageData, 'itemId')) });
    await block_user();
    (function (componentUid, dataModel) { ___arguments.context.setComponentDataStoreByUid(componentUid, dataModel) })('5b6e52683c8955849131d812155fe25e', ({ [`onlyReport`]: false,[`source`]: (getObjectProperty(___arguments.context.pageData, 'source')) }));
    addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b6e52683c8955849131d812155fe25e')), 'open');

  } catch (error) {
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));
    ___arguments.context.pageData['btnBlock'] = 'Report and block forever';
    ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('18ecab0593f93229b50af3fb766269da'))['display'] = 'none';

  }

  },
  /* handler:onClick */
  /* handler:onDisabledStateAssignment */
  ['onDisabledStateAssignment'](___arguments) {
    var j;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  var j_list = ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid).dynamicListItems })('9adda9f1890ee60a58c3f2744d552e8b'));
  for (var j_index in j_list) {
    j = j_list[j_index];
    if ((getObjectProperty(j, 'checkedValue')) && (getObjectProperty(___arguments.context.pageData, 'btnBlock'))) {
      return false;
    }
  }
  return true;

  },
  /* handler:onDisabledStateAssignment */
  /* content */
}))

define('./pages/user-report/components/6e0804547f3660b740affa82de8a4a97/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if (getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b6e52683c8955849131d812155fe25e'), 'onlyReport')) {
    (function () { window.history.back(); })();
  } else {
    if ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b6e52683c8955849131d812155fe25e'), 'source')) == 'Chat') {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
    } else {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);
    }
  }
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b6e52683c8955849131d812155fe25e')), 'open', '');

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-report/components/5b6e52683c8955849131d812155fe25e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}


  if ((getObjectProperty(___arguments.event, 'target')) == (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('5b6e52683c8955849131d812155fe25e')), 'el'))) {
    if (getObjectProperty(___arguments.context.dataModel, 'onlyReport')) {
      (function () { window.history.back(); })();
    } else {
      if ((getObjectProperty(___arguments.context.dataModel, 'source')) == 'Chat') {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
      } else {
        (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);
      }
    }
    removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('5b6e52683c8955849131d812155fe25e')), 'open', '');
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-report/components/035218ff08daadeffdb575b52f7888ac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function () { window.history.back(); })();

  },
  /* handler:onClick */
  /* content */
}))

define('./pages/user-report/components/118f0bebeb5d7de4bc42db2d85d919a5/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.getComponentDataStoreByUid('5b6e52683c8955849131d812155fe25e'), 'onlyReport')) ? 'Your message has been successfully sent to the administrator' : 'Your message has been successfully sent to the administrator. You will no longer see information about this user')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_f359bb293da281ea103ee55626bea1f3/logic/b1c6599f2b6154c3d2eca523bdfd2b79/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  onClick(___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/be72489dae64af08aa1a2afce50ddfeb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

/**
 * Describe this function...
 */
async function openCropper() {
  await (async function() {
  	const btn = document.querySelector('.drop-image-area label')
  	btn.click()
  })();
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b283615ec8eb7384f764353ec48a16')).push('open');
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f1fc054ccb0533b7d85a17adcb2e2e54')), 'hidden', '');
}


  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    try {
      await ( async function (name, data) { return BackendlessUI.DeviceAPI.sendRequest(name, data) })('REQUEST_CAMERA_PERMISSIONS', undefined);
      await openCropper();

    } catch (error) {
      console.log(error);
      await openCropper();

    }
  } else {
    await openCropper();
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/210f78999af9cd780d78138a39e97725/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  async ['onSourceUrlAssignment'](___arguments) {
    var fileUrl, currentUser, coverImg, item;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

async function asyncListFilter(sourceList, callback) {
  const list = await Promise.all(sourceList.map(async source => ({
    source,
    value: await callback(source),
  })));

  const resultList = list.filter(item => item.value)

  return resultList.map(item => item.source)
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photo'))) {
    fileUrl = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photo'));
  } else {
    currentUser = ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'));
    if (currentUser && (getObjectProperty(currentUser, 'userProfile'))) {
      if (getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'media')) {
        coverImg = (await asyncListFilter((getObjectProperty((getObjectProperty(currentUser, 'userProfile')), 'media')), async (item) => {


         return (getObjectProperty(item, 'isCover'));
        }))[0];
        if (coverImg) {
          fileUrl = (getObjectProperty(coverImg, 'file'));
        }
      }
    }
    if (!fileUrl) {
      fileUrl = (getObjectProperty(currentUser, 'photoThumbnail'));
    }
  }

  return fileUrl

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/cd639dc90bf9cefc61f6848b410db64d/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'name')) || (getObjectProperty(___arguments.context.appData, 'login'))) {
    return ((getObjectProperty(___arguments.context.appData, 'name')) ? (getObjectProperty(___arguments.context.appData, 'name')) : (getObjectProperty(___arguments.context.appData, 'login')));
  } else {
    if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
      return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')));
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/69843731ff9de1eaeecebf632496a3f6/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'pageLoaded')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/aee4d403a9cd61afc1cd526705320622/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'pageLoaded'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/fc3a803dbceb524742ec629dfd5c048b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['accountPaused'] = false;
  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'user-profile') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', ({ [`isFromAccountPage`]: true }));
  } else {
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      ___arguments.context.pageData['isHeaderVisible'] = false;
      ___arguments.context.pageData['isFilterHeadingVisible'] = false;
      ___arguments.context.pageData['isAsideUserProfileVisible'] = false;
      ___arguments.context.pageData['isMainBlVisible'] = true;
    }
  }
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'user-profile' && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fc3a803dbceb524742ec629dfd5c048b')).includes('current'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('fc3a803dbceb524742ec629dfd5c048b')), 'current');
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/e043db13a5d7b4fcc333e5bb3771c52e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'search-filter') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('search-filter', undefined);
  } else {
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      ___arguments.context.pageData['isHeaderVisible'] = false;
      ___arguments.context.pageData['isFilterHeadingVisible'] = false;
      ___arguments.context.pageData['isAsideUserProfileVisible'] = false;
      ___arguments.context.pageData['isMainBlVisible'] = true;
    }
  }
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'profileStatus')) {
    if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
      return false;
    } else {
      return true;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == false) {
      return false;
    } else {
      return true;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'search-filter' && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e043db13a5d7b4fcc333e5bb3771c52e')).includes('current'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e043db13a5d7b4fcc333e5bb3771c52e')), 'current');
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/9109766263c5d498a44c8c35d323a8d5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'user-activities') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-activities', undefined);
  } else {
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      ___arguments.context.pageData['isHeaderVisible'] = false;
      ___arguments.context.pageData['isFilterHeadingVisible'] = false;
      ___arguments.context.pageData['isAsideUserProfileVisible'] = false;
      ___arguments.context.pageData['isMainBlVisible'] = true;
    }
  }
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'user-activities' && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9109766263c5d498a44c8c35d323a8d5')).includes('current'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('9109766263c5d498a44c8c35d323a8d5')), 'current');
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/c58ef296cbb58bdcdf83964303311c56/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'profileStatus')) {
    if ((getObjectProperty(___arguments.context.appData, 'profileStatus')) == false) {
      return false;
    } else {
      return true;
    }
  } else if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus'))) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == false) {
      return false;
    } else {
      return true;
    }
  }

  },
  /* handler:onDisplayAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'settings') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings', undefined);
  } else {
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) <= 768) {
      ___arguments.context.pageData['isHeaderVisible'] = false;
      ___arguments.context.pageData['isFilterHeadingVisible'] = false;
      ___arguments.context.pageData['isAsideUserProfileVisible'] = false;
      ___arguments.context.pageData['isMainBlVisible'] = true;
    }
  }
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* handler:onMounted */
  ['onMounted'](___arguments) {
    function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'settings' && ((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
    if (!(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c58ef296cbb58bdcdf83964303311c56')).includes('current'))) {
      addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('c58ef296cbb58bdcdf83964303311c56')), 'current');
    }
  }

  },
  /* handler:onMounted */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/e8d7bcd23bc83b2303f45f067ed418a7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var link, error;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  link = String('https://app.findmyplus.one/index.html?page=profile-page&profileId=') + String(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'));
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    await ( async function (link, message, resourceName) { return BackendlessUI.DeviceAPI.shareSheetRequest({ link, message, resourceName }) })(link, 'Check out the profile in the in the "FindMyPlusOne" app', ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login'))));
  } else {
    ___arguments.context.pageData['modalShareOpen'] = true;
    ___arguments.context.pageData['shareLink'] = link;
    ___arguments.context.pageData['shareProfile'] = true;
  }
  try {
    await BackendlessUI.Functions.Custom['fn_90729fb61be96ffcf74a9622259d0dc4']('share_profile');

  } catch (error) {
    console.log(error);

  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return true

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/fda1d9842eb38205631f9de918e8efb1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['modalLogoutOpen'] = true;
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/0a5f5a857427c3b4b9ffe08bf9dfc4e1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['modalLogoutOpen'] = true;
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/e101a3ae4d24f979acfc001b9c6858ad/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['modalPauseAccOpen'] = true;
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/dadb54e20d112189ede1587da91b6355/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  onContentAssignment(___arguments) {
      if ((___arguments.context.pageData['currentUser']) && ((___arguments.context.pageData['currentUser'])['profileStatus']) == true) {
    return 'Pause my account';
  } else {
    return 'Reactivate my account';
  }

  },
  /* handler:onContentAssignment */
  /* handler:onStyleAssignment */
  ['onStyleAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == false) {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dadb54e20d112189ede1587da91b6355'))['color'] = '#737373';
    } else {
      ((function (componentUid) { return ___arguments.context.getComponentStyleByUid(componentUid) })('dadb54e20d112189ede1587da91b6355'))['color'] = '#ffa347';
    }
  }

  },
  /* handler:onStyleAssignment */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/90c9569a56463d081da777b3b7e8f4e3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['modalDeleteAccOpen'] = true;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/98fefa918f5534c27d5452a100e2ab75/bundle.js', [], () => ({
  /* content */
  /* handler:onSave */
  async ['onSave'](___arguments) {
    var fileUrlSmall, fileURL, fileName, moderationResult, error;

function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}


  await (async function() {
  	const btns = document.querySelectorAll('.header-toolbar button')
  	if (btns[0]) {
  	  btns[0].click()
  	}


  })();
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b283615ec8eb7384f764353ec48a16')), 'open', '');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f1fc054ccb0533b7d85a17adcb2e2e54')), 'hidden');
  ___arguments.context.pageData['smallPhoto'] = [];
  fileUrlSmall = (await (async function(files, width, percent, path) {
  	const file = files
  	let fileURL=''

  	const content = await readFileAsDataURL(file)

  	const img = await getNewImage(content)

  	const elem = document.createElement('canvas')

  	const widthImage = !width ? img.width: width
  	const scaleFactor = width && width / img.width
  	const heightImage = width ? img.height * scaleFactor: img.height

  	elem.width = widthImage
  	elem.height = heightImage

  	const ctx = elem.getContext('2d')

  	ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	const blob = await getCanvasBlob(ctx.canvas, percent)

  	const newFile = new File([blob], 'photo.png', {
  	  type: 'image/png',
  	  lastModified: Date.now()
  	})

  	try {
  	  fileURL = await Backendless.Files.upload(newFile, path, overwrite = true)
  	} catch (error) {
  	  alert(error.message)
  	  return false
  	}

  	async function readFileAsDataURL(file) {
  	  const result = await new Promise((resolve) => {
  	    const fileReader = new FileReader()
  	    fileReader.onload = (e) => resolve(e.target.result)
  	    fileReader.readAsDataURL(file)
  	  })
  	  return result
  	}

  	async function getNewImage(content) {
  	  const result = await new Promise((resolve) => {
  	    const img = new Image()
  	    img.src = content
  	    img.onload = () => resolve(img)
  	  })

  	  return result
  	}

  	async function getCanvasBlob(canvas, percent) {
  	  const result = await new Promise((resolve) => {
  	    canvas.toBlob((blob) => {
  	      resolve(blob)
  	    }, 'image/png', percent)
  	  })

  	  return result
  	}

  	return fileURL.fileURL
  })(___arguments['fileContent'], 50, 100, (String('/pictures/thumbnails/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia')))));
  if (!fileUrlSmall) {
    return ;
  }
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35a968680c168a25e41bf44392de526d', true);
  try {
    moderationResult = (await Backendless.Request.get(`${Backendless.appPath}/services/moderationImg/check`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'url': JSON.stringify(fileUrlSmall) }).send());

  } catch (error) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35a968680c168a25e41bf44392de526d', false);
    (function (message) { alert(message) })((getObjectProperty(error, 'message')));
    await Backendless.Files.remove(encodePath(fileUrlSmall));
    return ;

  }
  if (moderationResult == 'KO') {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35a968680c168a25e41bf44392de526d', false);
    ((function (componentUid) { return ___arguments.context.getComponentDataStoreByUid(componentUid) })('50cd81d4955ece4f900aa05672a3638d'))['showRejectMsg'] = true;
    if (fileUrlSmall) {
      await Backendless.Files.remove(encodePath(fileUrlSmall));
    }
    return ;
  }
  (getObjectProperty(___arguments.context.pageData, 'smallPhoto')).push(fileUrlSmall);
  fileName = String((new Date()).valueOf()) + String('.png');
  fileURL = (await (async function(files, width, percent, path, fileName, pageData) {
  	const file = files
  	let fileURL = ''
  	let widthImage = 0
  	let heightImage = 0

  	const content = await readFileAsDataURL(file)
  	pageData.photo = content

  	const img = await getNewImage(content)

  	const elem = document.createElement('canvas')

  	if (!width || img.width < width) {
  	  widthImage = img.width
  	  heightImage = img.height
  	} else {
  	  widthImage = width
  	  const scaleFactor = width / img.width
  	  heightImage = img.height * scaleFactor
  	}

  	elem.width = widthImage
  	elem.height = heightImage

  	const ctx = elem.getContext('2d')

  	ctx.drawImage(img, 0, 0, widthImage, heightImage)

  	const blob = await getCanvasBlob(ctx.canvas, percent)

  	const newFile = new File([blob], fileName, {
  	  type: 'image/png',
  	  lastModified: Date.now()
  	})

  	try {
  	  fileURL = await Backendless.Files.upload(newFile, path, overwrite = true)

  	  let newItem = {
  	    file: fileURL.fileURL,
  	    isCover: true,
  	    isPrivate: false,
  	    type: 'image'
  	  }
  	  pageData.currentUser.media = pageData.currentUser.userProfile.media
  	  pageData.currentUser.media.forEach(item => item.isCover = false)
  	  pageData.currentUser.media.unshift(newItem)
  	  newItem = ''

  	} catch (error) {
  	  alert(error.message)
  	  return false
  	}

  	async function readFileAsDataURL(file) {
  	  const result = await new Promise((resolve) => {
  	    const fileReader = new FileReader()
  	    fileReader.onload = (e) => resolve(e.target.result)
  	    fileReader.readAsDataURL(file)
  	  })
  	  return result
  	}

  	async function getNewImage(content) {
  	  const result = await new Promise((resolve) => {
  	    const img = new Image()
  	    img.src = content
  	    img.onload = () => resolve(img)
  	  })

  	  return result
  	}

  	async function getCanvasBlob(canvas, percent) {
  	  const result = await new Promise((resolve) => {
  	    canvas.toBlob((blob) => {
  	      resolve(blob)
  	    }, 'image/png', percent)
  	  })

  	  return result
  	}

  	return fileURL.fileURL
  })(___arguments['fileContent'], 1000, 0.8, (String('/pictures/') + String(getObjectProperty(___arguments.context.pageData, 'userNameMedia'))), fileName, ___arguments.context.pageData));
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('35a968680c168a25e41bf44392de526d', false);
  ___arguments.context.appData['photo'] = (getObjectProperty(___arguments.context.pageData, 'photo'));
  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photo'] = fileURL;
  (getObjectProperty(___arguments.context.pageData, 'currentUser'))['photoThumbnail'] = fileUrlSmall;
  (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile'))['media'] = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'media'));
  ___arguments.context.appData['currentUser'] = (getObjectProperty(___arguments.context.pageData, 'currentUser'));
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.pageData, 'currentUser'))));
  ___arguments.context.pageData['avatar'] = fileURL;
  ___arguments.context.pageData['newCover'] = true;
  ;(async () => {
      await Backendless.Data.of('Users').bulkUpdate( (['objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ [`photoThumbnail`]: fileUrlSmall }) );
    await Backendless.Data.of('UserProfile').bulkUpdate( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')), ({ [`media`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'media')) }) );

  })();

  },
  /* handler:onSave */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/9b366d8749110aad183e0ee5f66cc98b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function removeItemInList(l, i, c) {   const index = c ? l.findIndex(el => el[c] === i[c]) : l.indexOf(i);  if (index >= 0) { l.splice(index, 1); }  return l;}

function addItemToList(l, v) { Array.prototype.push.apply(l, Array.isArray(v) ? v : [v]);return l;}


  await (async function() {
  	const btns = document.querySelectorAll('.header-toolbar button')
  	if (btns[0]) {
  	  btns[0].click()
  	}


  })();
  removeItemInList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('65b283615ec8eb7384f764353ec48a16')), 'open', '');
  addItemToList(((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('f1fc054ccb0533b7d85a17adcb2e2e54')), 'hidden');

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/42285944ce3f244fcdeff4a740384533/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == true)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_a0c601bed55878cd67d1b7b3517fc5fc/logic/48a69ed20d239d575d4528c5b84c9018/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) == false)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_1c064d22cd755508f68659c41cfd73e9/logic/c2179a1b32bdc8dc0d02ba0ac6a29b92/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.rootComponentData['showRejectMsg'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_2ec519fee98a5ca7e7d51b8c7d91f9f6/logic/2c41e7a64e0206b9481dc8f227926d9e/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus'))) {
    text = 'Pause account';
  } else {
    text = 'Reactivate account';
  }

  return (String(text) + String('?'))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_2ec519fee98a5ca7e7d51b8c7d91f9f6/logic/3d3f84c65ad9dfc961916e2e43e12cca/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['modalPauseAccOpen'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_2ec519fee98a5ca7e7d51b8c7d91f9f6/logic/18547d8aa1929df878f789552e146b9b/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    var text;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus'))) {
    text = 'pause';
  } else {
    text = 'reactivate';
  }

  return (['Do you want to ',text,' your FindMy +1 account?'].join(''))

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_2ec519fee98a5ca7e7d51b8c7d91f9f6/logic/f27ebf9d055d1cb14138c006b40ae808/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['modalPauseAccOpen'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_2ec519fee98a5ca7e7d51b8c7d91f9f6/logic/219f263658858765000469148774780c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var userObjectId, usersForUpdateChat, userProfileStatus, j, chats;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  delete ___arguments.context.pageData['modalPauseAccOpen'];
  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus')) {
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['profileStatus'] = false;
    ___arguments.context.appData['profileStatus'] = false;
  } else {
    ___arguments.context.pageData['accountPaused'] = false;
    (getObjectProperty(___arguments.context.pageData, 'currentUser'))['profileStatus'] = true;
    ___arguments.context.appData['profileStatus'] = true;
  }
  userProfileStatus = (getObjectProperty(___arguments.context.appData, 'profileStatus'));
  userObjectId = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'));
  (getObjectProperty(___arguments.context.appData, 'currentUser'))['profileStatus'] = userProfileStatus;
  localStorage.setItem('currentUser', JSON.stringify((getObjectProperty(___arguments.context.appData, 'currentUser'))));
  if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'settings' || ((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'search-filter') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  chats = (getObjectProperty(___arguments.context.appData, 'chats'));
  await Backendless.Data.of('Users').save( ({ [`objectId`]: userObjectId,[`profileStatus`]: userProfileStatus }) );
  if (!chats) {
    chats = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  }
  usersForUpdateChat = [];
  for (var j_index in chats) {
    j = chats[j_index];
    if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) != userObjectId) {
      if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId'))))) {
        usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')));
      }
    }
    if ((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')) != userObjectId) {
      if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId'))))) {
        usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')));
      }
    }
  }
  if (userProfileStatus) {
    await Backendless.Request.put(`${Backendless.appPath}/services/updateChatfromMessage/updateChat`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'whereClause': (['receiver.objectId=\'',userObjectId,'\' or sender.objectId=\'',userObjectId,'\''].join('')),'changes': ({ [`statusUpdated`]: (new Date()) }) });
    await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('unBlockUser', usersForUpdateChat, userObjectId, null, null);
  } else {
    await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('blockUser', usersForUpdateChat, userObjectId, null, null);
  }

  },
  /* handler:onClick */
  /* handler:onLabelAssignment */
  ['onLabelAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.pageData, 'currentUser')) && (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'profileStatus'))) {
    return 'Pause account';
  } else {
    return 'Reactivate account';
  }

  },
  /* handler:onLabelAssignment */
  /* content */
}))

define('./components/reusable/r_c9f74b692e23103f729d2a88bc324efc/logic/afca4ac8851cfaefbb8305c6b9d9e9d1/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['modalDeleteAccOpen'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_c9f74b692e23103f729d2a88bc324efc/logic/48bab036739a37e18c751c7b822da44f/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0ff60be6dd39ee8ca7d41edb36ef31c3'))['disabled'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('0ff60be6dd39ee8ca7d41edb36ef31c3'))['disabled'] = true;
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_c9f74b692e23103f729d2a88bc324efc/logic/7fd65e1e8601a96de7434adda04425db/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['modalDeleteAccOpen'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_c9f74b692e23103f729d2a88bc324efc/logic/0ff60be6dd39ee8ca7d41edb36ef31c3/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'oAuthIdentities')) {
    if (((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'oAuthIdentities')).map(item => item['providerCode'])).includes('googleplus')) {
      ___arguments.context.pageData['isGoogleplusUser'] = true;
    }
  }
  ___arguments.context.pageData['enterMessage'] = ((getObjectProperty(___arguments.context.pageData, 'isGoogleplusUser')) ? 'Enter your google email' : 'Enter your password');
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fcea7be993f52212f693a2518c4c2e3', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efe9b75dfc2d1f7890f1d37e989ee482', true);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_c9f74b692e23103f729d2a88bc324efc/logic/bd2ee0b624c3ab151b3c034bdacc1dbe/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['modalDeleteAccOpen'];
  delete ___arguments.context.pageData['password'];
  delete ___arguments.context.pageData['inputGoogleEmail'];
  delete ___arguments.context.pageData['isGoogleplusUser'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fcea7be993f52212f693a2518c4c2e3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efe9b75dfc2d1f7890f1d37e989ee482', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_c9f74b692e23103f729d2a88bc324efc/logic/70a6b355e8e6afc4bec978cbb34753b8/bundle.js', [], () => ({
  /* content */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = true;
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03f20519e805f91f505f7d011d0181f6')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03f20519e805f91f505f7d011d0181f6', false);
  }

  },
  /* handler:onChange */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isGoogleplusUser')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_c9f74b692e23103f729d2a88bc324efc/logic/041cecdfa5c39f5e8cb8b4fb900ac9df/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.pageData, 'isGoogleplusUser'))

  },
  /* handler:onDisplayAssignment */
  /* handler:onChange */
  ['onChange'](___arguments) {
      if (___arguments.value) {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = false;
  } else {
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = true;
  }
  if ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('03f20519e805f91f505f7d011d0181f6')) {
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03f20519e805f91f505f7d011d0181f6', false);
  }

  },
  /* handler:onChange */
  /* content */
}))

define('./components/reusable/r_c9f74b692e23103f729d2a88bc324efc/logic/de9f49df1556f3abc07eb147fd3974da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70a6b355e8e6afc4bec978cbb34753b8')), 'el')), 'type')) == 'text') {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70a6b355e8e6afc4bec978cbb34753b8')), 'el'))['type'] = 'password';
    delete ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('de9f49df1556f3abc07eb147fd3974da'))['2'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('de9f49df1556f3abc07eb147fd3974da'))['2'] = 'fa-eye';
  } else if ((getObjectProperty((getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70a6b355e8e6afc4bec978cbb34753b8')), 'el')), 'type')) == 'password') {
    (getObjectProperty(((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('70a6b355e8e6afc4bec978cbb34753b8')), 'el'))['type'] = 'text';
    delete ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('de9f49df1556f3abc07eb147fd3974da'))['2'];
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('de9f49df1556f3abc07eb147fd3974da'))['2'] = 'fa-eye-slash';
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (!(getObjectProperty(___arguments.context.pageData, 'isGoogleplusUser')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_c9f74b692e23103f729d2a88bc324efc/logic/18ac3d0f5661984a16099a4d955ad163/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['modalDeleteAccOpen'];
  delete ___arguments.context.pageData['password'];
  delete ___arguments.context.pageData['inputGoogleEmail'];
  delete ___arguments.context.pageData['isGoogleplusUser'];
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('1fcea7be993f52212f693a2518c4c2e3', true);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('efe9b75dfc2d1f7890f1d37e989ee482', false);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_c9f74b692e23103f729d2a88bc324efc/logic/c8979c7d4133aaf3e6c37afc6783dc3f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error, usersForUpdateChat, j, chats, shortUserId, userObjectId, likesCount, getProfile, item, mapLikedUsers;

function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}

/**
 * Describe this function...
 */
async function updateChatsOnMessagePage() {
  if (getObjectProperty(___arguments.context.appData, 'chats')) {
    chats = (getObjectProperty(___arguments.context.appData, 'chats'));
  } else {
    chats = (await Backendless.Request.get(`${Backendless.appPath}/services/chats/Chats`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send());
  }
  usersForUpdateChat = [];
  for (var j_index in chats) {
    j = chats[j_index];
    if ((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId'))))) {
        usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'receiver')), 'objectId')));
      }
    }
    if ((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')) != (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId'))) {
      if (!(usersForUpdateChat.includes((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId'))))) {
        usersForUpdateChat.push((getObjectProperty((getObjectProperty(j, 'sender')), 'objectId')));
      }
    }
  }
  await BackendlessUI.Functions.Custom['fn_3b374911e58e10b950860fc357bf0904']('blockUser', usersForUpdateChat, (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')), null, null);
}

function encodePath(path) {
  if(path.startsWith("http://") || path.startsWith("https://")) {
    return path
  }

  let decodedPath
  try {
    decodedPath = decodeURI(path)
  } finally {
    return (decodedPath || path).split("/").map(encodeURIComponent).join("/")
  }
}

/**
 * Describe this function...
 */
async function deleteUser() {
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('9d396d337f0688f6ec0ab2a5308cb39c', true);
  await updateChatsOnMessagePage();
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Media...';
  ;(async () => {
      try {
      await Backendless.Files.removeDirectory(encodePath((['/pictures/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),'/'].join(''))));

    } catch (error) {
      console.log(error);

    }

  })();
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User folders...';
  ;(async () => {
      try {
      await Backendless.Files.removeDirectory(encodePath((['/pictures/activities/',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')),'/'].join(''))));

    } catch (error) {
      console.log(error);

    }

  })();
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Activities...';
  await Backendless.Data.of('Activity').bulkDelete( (['author.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the ActivityPreferences...';
  await Backendless.Data.of('ActivityPreferences').bulkDelete( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Messagess...';
  await Backendless.Data.of('Message').bulkDelete( (['sender.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\'',' or receiver.objectId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the Chats...';
  await Backendless.Request.delete(`${Backendless.appPath}/services/deleteChat/deleteChatNoClause`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send();
  if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')) && (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes'))) {
    mapLikedUsers = (await Promise.all((getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'myLikes')).map(async item => {  try {
        getProfile = (await Backendless.Request.get(`${Backendless.appPath}/services/getProfile/getProfile`).set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).query({ 'id': JSON.stringify((getObjectProperty(item, 'objectId'))) }).send());
        if (getProfile && (getObjectProperty(getProfile, 'userProfile'))) {
          userObjectId = (getObjectProperty((getObjectProperty(getProfile, 'userProfile')), 'objectId'));
          likesCount = (getObjectProperty((getObjectProperty(getProfile, 'userProfile')), 'likesCount'));
          await Backendless.Request.put(`${Backendless.appPath}/services/setLikesCount/setLikesCount`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'userProfileId': userObjectId,'likesCount': (likesCount > 0 ? likesCount - 1 : 0) });
          await Backendless.Request.post(`${Backendless.appPath}/services/removeLike/removeLike`).set('Content-Type', 'application/json').set((function(h){if(!h['user-token']){delete h['user-token']} return h})({...{}, ...{ 'user-token': Backendless.getCurrentUserToken() }})).send({ 'objectId': (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'parameter': 'likedBy','currentUser': userObjectId });
        }

      } catch (error) {
        console.log(error);

      }
    ; return ;})));
  }
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User profile...';
  await Backendless.Data.of('UserProfile').bulkDelete( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User search filter...';
  await Backendless.Data.of('UserSearchFilter').bulkDelete( (['ownerId=\'',(getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')),'\''].join('')) );
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User folders...';
  if (await ( async function (kind) { return BackendlessUI.DeviceAPI.isRunningEnv(kind) })('NATIVE_SHELL')) {
    await ( async function () { return BackendlessUI.DeviceAPI.unregisterDevice() })();
  }
  ___arguments.context.pageData['deleteInfo'] = 'Removing the User record...';
  shortUserId = (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')).split('-').slice(-1)[0];
  localStorage.removeItem((String(shortUserId) + String('_viewCounter')));
  localStorage.removeItem((String(shortUserId) + String('_viewEnabled')));
  localStorage.removeItem(shortUserId);
  await Backendless.Data.of(Backendless.User).remove({ objectId: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'objectId')) });
  localStorage.removeItem('feedback');
  localStorage.removeItem('isShowModal');
  localStorage.removeItem('tooltipInfo');
  localStorage.removeItem('userLocationInfo');
  localStorage.removeItem('country');
  localStorage.removeItem('Backendless');
  localStorage.removeItem('currentUser');
  localStorage.removeItem('messages');
  localStorage.removeItem('lastChatInfoUpdate');
  localStorage.removeItem('tempFilters');
  await Backendless.UserService.logout();
  ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('8b376bc7df972302610e704c47bb8a4f')).pop();
  delete ___arguments.context.pageData['isHeaderVisible'];
  delete ___arguments.context.pageData['isFilterHeadingVisible'];
  delete ___arguments.context.pageData['isMainVisible'];
  ___arguments.context.pageData['isMissYouVisible'] = true;
}


  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd2ee0b624c3ab151b3c034bdacc1dbe', false);
  (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18ac3d0f5661984a16099a4d955ad163', false);
  ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = true;
  try {
    if (getObjectProperty(___arguments.context.pageData, 'isGoogleplusUser')) {
      if ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'email')) == (getObjectProperty(___arguments.context.pageData, 'inputGoogleEmail'))) {
        await deleteUser();
      } else {
        ___arguments.context.pageData['errorDeleteMessage'] = 'Wrong email';
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd2ee0b624c3ab151b3c034bdacc1dbe', true);
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18ac3d0f5661984a16099a4d955ad163', true);
        ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = false;
        (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03f20519e805f91f505f7d011d0181f6', true);
      }
    } else if ((await Backendless.UserService.login( (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'email')), (getObjectProperty(___arguments.context.pageData, 'password')), true  ))) {
      await deleteUser();
    }

  } catch (error) {
    ___arguments.context.pageData['errorDeleteMessage'] = 'Wrong password';
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('bd2ee0b624c3ab151b3c034bdacc1dbe', true);
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('18ac3d0f5661984a16099a4d955ad163', true);
    ((function (componentUid) { return ___arguments.context.getComponentByUid(componentUid) })('c8979c7d4133aaf3e6c37afc6783dc3f'))['disabled'] = false;
    (function (componentUid, visible) { (function(component){ component.display = !!(typeof visible === 'boolean' ? visible : !component.display ) })(___arguments.context.getComponentByUid(componentUid)) })('03f20519e805f91f505f7d011d0181f6', true);
    console.log(error);

  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_bcb8a17d9b31076bb3d6fbd55adad01b/logic/959917414d6a1689b84953f71b891b5b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).includes('open')) {
    ((function (componentUid) { return ___arguments.context.getComponentClassesByUid(componentUid) })('e109fa67187e00c150e996ea5407884c')).pop();
    ___arguments.context.pageData['disableSaveBtn'] = false;
  }
  delete ___arguments.context.pageData['isModalSavedChangesOpen'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_bcb8a17d9b31076bb3d6fbd55adad01b/logic/27292276b8a4ecdff87d30d618b5bf59/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['isModalSavedChangesOpen'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_bcb8a17d9b31076bb3d6fbd55adad01b/logic/74fe986ed9bd5d1459413a51137abdb7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      delete ___arguments.context.pageData['isModalSavedChangesOpen'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_df21e45a5b4cca74faeb78c4f06fd9e5/logic/e33fa44fab3cbc27e349354563e11e67/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.rootComponentData['open'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_df21e45a5b4cca74faeb78c4f06fd9e5/logic/4c0ae35a6ebf83e4c497fa370a2c1cac/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.rootComponentData['open'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_df21e45a5b4cca74faeb78c4f06fd9e5/logic/c0fca6b9d2e6727f8db46f4eb642a318/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (getObjectProperty(___arguments.context.rootComponentData, 'open'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_4de3d9f8cad7d5587f627f7ea7bf8604/logic/e792ff71fb1678a5a3fa1557088e01ea/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', ({ [`previousPage`]: 'activities-search' }));

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cd15688b609c1396e213eab029e9043/logic/8fe5ab6d46b38fabe055e8057f36b92e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['modalShareOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cd15688b609c1396e213eab029e9043/logic/8ae4a869cc0406eb96c27a0ca4629e81/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'shareLink')) {
    await (async function(url) {
    	navigator.clipboard.writeText(url)
    })((getObjectProperty(___arguments.context.pageData, 'shareLink')));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cd15688b609c1396e213eab029e9043/logic/131b3042c3a5f953e9926fcba685ab73/bundle.js', [], () => ({
  /* content */
  /* handler:onValueAssignment */
  ['onValueAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'shareLink')) {
    return (getObjectProperty(___arguments.context.pageData, 'shareLink'));
  }

  },
  /* handler:onValueAssignment */
  /* content */
}))

define('./components/reusable/r_0cd15688b609c1396e213eab029e9043/logic/92c39c3ba03395c61211c9a45c94aa5f/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'shareProfile')) {
    if (getObjectProperty(___arguments.context.pageData, 'profileLink')) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.facebook.com/sharer/sharer.php', true, ({ [`s`]: 100,[`p[title]`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')),[`p[url]`]: (getObjectProperty(___arguments.context.pageData, 'profileLink')),[`p[summary]`]: '',[`p[images][0]`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'photo')) }));
    }
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.facebook.com/sharer/sharer.php', true, ({ [`s`]: 100,[`p[title]`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'name')),[`p[url]`]: ((function () { return window.location.href })()),[`p[summary]`]: (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'description')),[`p[images][0]`]: (getObjectProperty(((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentActivity')), 'media'))[0]), 'file')) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cd15688b609c1396e213eab029e9043/logic/3673306abeb79f7de93ada4596312912/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://www.instagram.com/', true, undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cd15688b609c1396e213eab029e9043/logic/27bbbd4972369bc5e3811a31b09e106b/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'shareProfile')) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://twitter.com/intent/tweet', true, ({ [`text`]: (getObjectProperty(___arguments.context.pageData, 'profileLink')) }));
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://twitter.com/intent/tweet', true, ({ [`text`]: ((function () { return window.location.href })()) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cd15688b609c1396e213eab029e9043/logic/d299fe92bc6dbaf77aaa034a7f25cbbb/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.pageData, 'shareProfile')) {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://wa.me/?text=', true, ({ [`text`]: (getObjectProperty(___arguments.context.pageData, 'profileLink')) }));
  } else {
    (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://wa.me/?text=', true, ({ [`text`]: ((function () { return window.location.href })()) }));
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_0cd15688b609c1396e213eab029e9043/logic/4aa462966f62a275acd6f995534adb45/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'shareProfile')) ? 'Share Profile' : 'Share Activity')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_0cd15688b609c1396e213eab029e9043/logic/de4eab9e27253466323b7f586f6fb6c4/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.pageData, 'shareProfile')) ? 'Profile link' : 'Activity link')

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_78731097ecd84723505e6534f5292b87/logic/ee9b1c62401b31e89a2e97dc62729f55/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['modalLogoutOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_78731097ecd84723505e6534f5292b87/logic/7cebd5c389dbd4cf41cb01f96bbc30a5/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['modalLogoutOpen'] = false;

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_78731097ecd84723505e6534f5292b87/logic/64e3891b9e772e946bbfe01539084b9c/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  async ['onClick'](___arguments) {
    var error;


  await BackendlessUI.Functions.Custom['fn_e97140c64a3efafdbfb71077439f3811']();
  (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('launch', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/e6ef7d041ac13c14d411af83c3f8bd8a/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'profiles') {
    if (['profile-page', 'activity', 'search-filter'].includes(((function () { return BackendlessUI.Navigator.getCurrentPageName() })()))) {
      delete ___arguments.context.appData['activitiesSearch'];
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('profiles', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      return (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'profiles' || ((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'profile-page' ? ['header__item', 'header__item--active'] : ['header__item'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/061e6307bb3fb9b624d268225542836e/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'interests') {
    if (['profile-page', 'activity', 'search-filter'].includes(((function () { return BackendlessUI.Navigator.getCurrentPageName() })()))) {
      delete ___arguments.context.appData['activitiesSearch'];
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('interests', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      return (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'interests' ? ['header__item', 'header__item--active'] : ['header__item'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/79c7b04f811ff50e569589a7c5e5b41d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'messages') {
    if (['profile-page', 'activity', 'search-filter'].includes(((function () { return BackendlessUI.Navigator.getCurrentPageName() })()))) {
      delete ___arguments.context.appData['activitiesSearch'];
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('messages', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      return (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'messages' ? ['header__item', 'header__item--active'] : ['header__item'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/9404f564d5d77adcac4eb30d46a2cacb/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'messagesNumber')) {
    return (getObjectProperty(___arguments.context.appData, 'messagesNumber'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/c2da2316959b1a8c462943fa77d4b7e7/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'user-profile') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
    delete ___arguments.context.appData['activitiesCountOffset'];
  }

  },
  /* handler:onClick */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      return (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'user-profile' || ((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'settings' ? ['header__item header__item--mobile', 'header__item--active'] : ['header__item header__item--mobile'])

  },
  /* handler:onClassListAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/318563325306ad2e6d432468a69beb08/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'user-profile') {
    if (['profile-page', 'activity', 'search-filter'].includes(((function () { return BackendlessUI.Navigator.getCurrentPageName() })()))) {
      delete ___arguments.context.appData['activitiesSearch'];
    }
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/209f76aea5a1596a808900fda74b4dd8/bundle.js', [], () => ({
  /* content */
  /* handler:onSourceUrlAssignment */
  ['onSourceUrlAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'photo')) {
    return (getObjectProperty(___arguments.context.appData, 'photo'));
  } else if (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) && (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'photoThumbnail'))) {
    return (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'photoThumbnail'));
  }

  },
  /* handler:onSourceUrlAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/3a49ade16213354510815bafe2fd70e6/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((getObjectProperty(___arguments.context.appData, 'name')) || (getObjectProperty(___arguments.context.appData, 'login'))) {
    return ((getObjectProperty(___arguments.context.appData, 'name')) ? (getObjectProperty(___arguments.context.appData, 'name')) : (getObjectProperty(___arguments.context.appData, 'login')));
  } else {
    if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
      return ((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) ? (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'name')) : (getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'login')));
    } else {
      return 'Account';
    }
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/90c19d93eb614726a341c1fb5e768591/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'user-profile') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-profile', undefined);
  }
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/9eae8aaea9c2c53768ab2ae436711e03/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'user-activities') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('user-activities', undefined);
  }
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/8cadea982ab7c138c629aadb391c73c4/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'settings') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('settings', undefined);
  }
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return (((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')) && (getObjectProperty(((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser')), 'profileStatus')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/607680653092fc2b09867b42d84b520d/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      ___arguments.context.pageData['modalLogoutOpen'] = true;
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/33fa9bfc9a64afa2cb8db4a6580b59fd/bundle.js', [], () => ({
  /* content */
  /* handler:onClassListAssignment */
  ['onClassListAssignment'](___arguments) {
      return (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'activities-search' || ((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) == 'activity' ? ['header__item', 'header__item--active'] : ['header__item'])

  },
  /* handler:onClassListAssignment */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'activities-search') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('activities-search', undefined);
  }

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/8d168aace99e6f9c71adfc78f96a9193/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (['profile-page', 'activity', 'user-media', 'create-activity', 'edit-activity'].includes(((function () { return BackendlessUI.Navigator.getCurrentPageName() })()))) {
    if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768) {
      if (getObjectProperty(___arguments.context.pageData, 'outOfService')) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  return true

  },
  /* handler:onDisplayAssignment */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (((function (typeSize) { return document.documentElement[`${typeSize}`] })('clientWidth')) > 768 && !(getObjectProperty(___arguments.context.appData, 'userRoles'))) {
    ___arguments.context.appData['userRoles'] = (await Backendless.UserService.getUserRoles());
  }

  },
  /* handler:onBeforeMount */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/9a656fd803fac756cc961bde8951d668/bundle.js', [], () => ({
  /* content */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
      return ((function(key){ try { return JSON.parse(localStorage.getItem(key)) } catch(e){ return null }})('currentUser'))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/ee22692e181d71063dee8d226ffb4514/bundle.js', [], () => ({
  /* content */
  /* handler:onBeforeMount */
  async ['onBeforeMount'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if ((await Backendless.UserService.getCurrentUser(false)) != null && (typeof (getObjectProperty(___arguments.context.appData, 'messagesNumber')) === 'undefined')) {
    ;(async () => {
        await BackendlessUI.Functions.Custom['fn_25e577c7a55ec13aac55c1b782dc57ca'](___arguments.context.appData);

    })();
  }

  },
  /* handler:onBeforeMount */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'messagesNumber')) > 0)

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/381a02fdda320934f64f3f01167364da/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('create-activity', undefined);

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/b903c19a0336a69931287c1bbd8cf463/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      (function (url, isExternal, params) { BackendlessUI.Navigator.openWebPage(url, isExternal, params); })('https://findmyplus.one/', true, undefined);
  delete ___arguments.context.appData['activitiesCountOffset'];

  },
  /* handler:onClick */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/3fc887677bb459fd878939e858aaa5f7/bundle.js', [], () => ({
  /* content */
  /* handler:onContentAssignment */
  ['onContentAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}


  if (getObjectProperty(___arguments.context.appData, 'currentUser')) {
    return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.appData, 'currentUser')), 'userProfile')), 'location'));
  } else if (getObjectProperty(___arguments.context.pageData, 'currentUser')) {
    return (getObjectProperty((getObjectProperty((getObjectProperty(___arguments.context.pageData, 'currentUser')), 'userProfile')), 'location'));
  }

  },
  /* handler:onContentAssignment */
  /* content */
}))

define('./components/reusable/r_ea9ffbf36af4f41ee3ea9c91d2f7d7d7/logic/eb0de606a72d99e476bffd25d72b1e01/bundle.js', [], () => ({
  /* content */
  /* handler:onClick */
  ['onClick'](___arguments) {
      if (((function () { return BackendlessUI.Navigator.getCurrentPageName() })()) != 'admin-dashboard') {
    (function (pageName, pageData) { BackendlessUI.Navigator.goToPage(pageName, pageData) })('admin-dashboard', undefined);
  }
  (function (event) { event.stopPropagation() })(___arguments.event);

  },
  /* handler:onClick */
  /* handler:onDisplayAssignment */
  ['onDisplayAssignment'](___arguments) {
    function getObjectProperty(object, propPath) {
  if (typeof propPath !== 'string' || object[propPath] !== undefined) {
    return object[propPath]
  }

  const propsNamesList = propPath.split('.')

  let result = object

  for (let i = 0; i < propsNamesList.length; i++) {
    if (!result || result[propsNamesList[i]] === undefined) {
      return
    }

    result = result[propsNamesList[i]]
  }

  return result
}



  return ((getObjectProperty(___arguments.context.appData, 'userRoles')) && ((getObjectProperty(___arguments.context.appData, 'userRoles')).includes('admin')))

  },
  /* handler:onDisplayAssignment */
  /* content */
}))

